import { isEmptyObject } from '@phx-husky/object-utils';
import { isNonBlank, isBlank } from '@phx-husky/string-utils';
import axios from 'axios';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { isAfter, isBefore } from 'date-fns';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest();
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$7(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread();
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var commonjsGlobal$2 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var runtime = {exports: {}};

(function (module) {
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
})(runtime);

var regenerator = runtime.exports;

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$4()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _createForOfIteratorHelper$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var stringToByteArray$1 = function stringToByteArray$1(str) {
  // TODO(user): Use native implementations if/when available
  var out = [];
  var p = 0;

  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);

    if (c < 128) {
      out[p++] = c;
    } else if (c < 2048) {
      out[p++] = c >> 6 | 192;
      out[p++] = c & 63 | 128;
    } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
      // Surrogate Pair
      c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
      out[p++] = c >> 18 | 240;
      out[p++] = c >> 12 & 63 | 128;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    } else {
      out[p++] = c >> 12 | 224;
      out[p++] = c >> 6 & 63 | 128;
      out[p++] = c & 63 | 128;
    }
  }

  return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */


var byteArrayToString = function byteArrayToString(bytes) {
  // TODO(user): Use native implementations if/when available
  var out = [];
  var pos = 0,
      c = 0;

  while (pos < bytes.length) {
    var c1 = bytes[pos++];

    if (c1 < 128) {
      out[c++] = String.fromCharCode(c1);
    } else if (c1 > 191 && c1 < 224) {
      var c2 = bytes[pos++];
      out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
    } else if (c1 > 239 && c1 < 365) {
      // Surrogate Pair
      var _c = bytes[pos++];
      var c3 = bytes[pos++];
      var c4 = bytes[pos++];
      var u = ((c1 & 7) << 18 | (_c & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
      out[c++] = String.fromCharCode(0xd800 + (u >> 10));
      out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
    } else {
      var _c2 = bytes[pos++];
      var _c3 = bytes[pos++];
      out[c++] = String.fromCharCode((c1 & 15) << 12 | (_c2 & 63) << 6 | _c3 & 63);
    }
  }

  return out.join('');
}; // We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()


var base64 = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,

  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,

  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,

  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,

  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',

  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + '+/=';
  },

  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + '-_.';
  },

  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob === 'function',

  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray: function encodeByteArray(input, webSafe) {
    if (!Array.isArray(input)) {
      throw Error('encodeByteArray takes an array as a parameter');
    }

    this.init_();
    var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
    var output = [];

    for (var i = 0; i < input.length; i += 3) {
      var byte1 = input[i];
      var haveByte2 = i + 1 < input.length;
      var byte2 = haveByte2 ? input[i + 1] : 0;
      var haveByte3 = i + 2 < input.length;
      var byte3 = haveByte3 ? input[i + 2] : 0;
      var outByte1 = byte1 >> 2;
      var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
      var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
      var outByte4 = byte3 & 0x3f;

      if (!haveByte3) {
        outByte4 = 64;

        if (!haveByte2) {
          outByte3 = 64;
        }
      }

      output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
    }

    return output.join('');
  },

  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString: function encodeString(input, webSafe) {
    // Shortcut for Mozilla browsers that implement
    // a native base64 encoder in the form of "btoa/atob"
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return btoa(input);
    }

    return this.encodeByteArray(stringToByteArray$1(input), webSafe);
  },

  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString: function decodeString(input, webSafe) {
    // Shortcut for Mozilla browsers that implement
    // a native base64 encoder in the form of "btoa/atob"
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return atob(input);
    }

    return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
  },

  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray: function decodeStringToByteArray(input, webSafe) {
    this.init_();
    var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
    var output = [];

    for (var i = 0; i < input.length;) {
      var byte1 = charToByteMap[input.charAt(i++)];
      var haveByte2 = i < input.length;
      var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
      ++i;
      var haveByte3 = i < input.length;
      var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      var haveByte4 = i < input.length;
      var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
      ++i;

      if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
        throw new DecodeBase64StringError();
      }

      var outByte1 = byte1 << 2 | byte2 >> 4;
      output.push(outByte1);

      if (byte3 !== 64) {
        var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
        output.push(outByte2);

        if (byte4 !== 64) {
          var outByte3 = byte3 << 6 & 0xc0 | byte4;
          output.push(outByte3);
        }
      }
    }

    return output;
  },

  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_: function init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {};
      this.charToByteMap_ = {};
      this.byteToCharMapWebSafe_ = {};
      this.charToByteMapWebSafe_ = {}; // We want quick mappings back and forth, so we precompute two maps.

      for (var i = 0; i < this.ENCODED_VALS.length; i++) {
        this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
        this.charToByteMap_[this.byteToCharMap_[i]] = i;
        this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
        this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i; // Be forgiving when decoding and correctly decode both encodings.

        if (i >= this.ENCODED_VALS_BASE.length) {
          this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
          this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
        }
      }
    }
  }
};
/**
 * An error encountered while decoding base64 string.
 */

var DecodeBase64StringError = /*#__PURE__*/function (_Error) {
  _inherits(DecodeBase64StringError, _Error);

  var _super = _createSuper$3(DecodeBase64StringError);

  function DecodeBase64StringError() {
    var _this;

    _classCallCheck(this, DecodeBase64StringError);

    _this = _super.apply(this, arguments);
    _this.name = 'DecodeBase64StringError';
    return _this;
  }

  return _createClass(DecodeBase64StringError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * URL-safe base64 encoding
 */


var base64Encode = function base64Encode(str) {
  var utf8Bytes = stringToByteArray$1(str);
  return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */


var base64urlEncodeWithoutPadding = function base64urlEncodeWithoutPadding(str) {
  // Use base64url encoding and remove padding in the end (dot characters).
  return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */


var base64Decode = function base64Decode(str) {
  try {
    return base64.decodeString(str, true);
  } catch (e) {
    console.error('base64Decode failed: ', e);
  }

  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */


function getGlobal() {
  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var getDefaultsFromGlobal = function getDefaultsFromGlobal() {
  return getGlobal().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */


var getDefaultsFromEnvVariable = function getDefaultsFromEnvVariable() {
  if (typeof process === 'undefined' || typeof process.env === 'undefined') {
    return;
  }

  var defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;

  if (defaultsJsonString) {
    return JSON.parse(defaultsJsonString);
  }
};

var getDefaultsFromCookie = function getDefaultsFromCookie() {
  if (typeof document === 'undefined') {
    return;
  }

  var match;

  try {
    match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch (e) {
    // Some environments such as Angular Universal SSR have a
    // `document` object but error on accessing `document.cookie`.
    return;
  }

  var decoded = match && base64Decode(match[1]);
  return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */


var getDefaults = function getDefaults() {
  try {
    return getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
  } catch (e) {
    /**
     * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
     * to any environment case we have not accounted for. Log to
     * info instead of swallowing so we can find these unknown cases
     * and add paths for them if needed.
     */
    console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
    return;
  }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */


var getDefaultEmulatorHost = function getDefaultEmulatorHost(productName) {
  var _a, _b;

  return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */


var getDefaultAppConfig = function getDefaultAppConfig() {
  var _a;

  return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */


var getExperimentalSetting = function getExperimentalSetting(name) {
  var _a;

  return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Deferred = /*#__PURE__*/function () {
  function Deferred() {
    var _this2 = this;

    _classCallCheck(this, Deferred);

    this.reject = function () {};

    this.resolve = function () {};

    this.promise = new Promise(function (resolve, reject) {
      _this2.resolve = resolve;
      _this2.reject = reject;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */


  _createClass(Deferred, [{
    key: "wrapCallback",
    value: function wrapCallback(callback) {
      var _this3 = this;

      return function (error, value) {
        if (error) {
          _this3.reject(error);
        } else {
          _this3.resolve(value);
        }

        if (typeof callback === 'function') {
          // Attaching noop handler just in case developer wasn't expecting
          // promises
          _this3.promise["catch"](function () {}); // Some of our callbacks don't expect a value and our own tests
          // assert that the parameter length is 1


          if (callback.length === 1) {
            callback(error);
          } else {
            callback(error, value);
          }
        }
      };
    }
  }]);

  return Deferred;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */


function getUA() {
  if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
    return navigator['userAgent'];
  } else {
    return '';
  }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */


function isMobileCordova() {
  return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/


function isNode() {
  var _a;

  var forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;

  if (forceEnvironment === 'node') {
    return true;
  } else if (forceEnvironment === 'browser') {
    return false;
  }

  try {
    return Object.prototype.toString.call(global.process) === '[object process]';
  } catch (e) {
    return false;
  }
}

function isBrowserExtension() {
  var runtime = (typeof chrome === "undefined" ? "undefined" : _typeof(chrome)) === 'object' ? chrome.runtime : (typeof browser === "undefined" ? "undefined" : _typeof(browser)) === 'object' ? browser.runtime : undefined;
  return _typeof(runtime) === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */


function isReactNative() {
  return (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Internet Explorer. */


function isIE() {
  var ua = getUA();
  return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Returns true if we are running in Safari. */


function isSafari() {
  return !isNode() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */


function isIndexedDBAvailable() {
  try {
    return (typeof indexedDB === "undefined" ? "undefined" : _typeof(indexedDB)) === 'object';
  } catch (e) {
    return false;
  }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */


function validateIndexedDBOpenable() {
  return new Promise(function (resolve, reject) {
    try {
      var preExist = true;
      var DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
      var request = self.indexedDB.open(DB_CHECK_NAME);

      request.onsuccess = function () {
        request.result.close(); // delete database only when it doesn't pre-exist

        if (!preExist) {
          self.indexedDB.deleteDatabase(DB_CHECK_NAME);
        }

        resolve(true);
      };

      request.onupgradeneeded = function () {
        preExist = false;
      };

      request.onerror = function () {
        var _a;

        reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
      };
    } catch (error) {
      reject(error);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */


var ERROR_NAME = 'FirebaseError'; // Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types

var FirebaseError = /*#__PURE__*/function (_Error2) {
  _inherits(FirebaseError, _Error2);

  var _super2 = _createSuper$3(FirebaseError);

  function FirebaseError(
  /** The error code for this error. */
  code, message,
  /** Custom data for this error. */
  customData) {
    var _this4;

    _classCallCheck(this, FirebaseError);

    _this4 = _super2.call(this, message);
    _this4.code = code;
    _this4.customData = customData;
    /** The custom name for all FirebaseErrors. */

    _this4.name = ERROR_NAME; // Fix For ES5
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work

    Object.setPrototypeOf(_assertThisInitialized(_this4), FirebaseError.prototype); // Maintains proper stack trace for where our error was thrown.
    // Only available on V8.

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this4), ErrorFactory.prototype.create);
    }

    return _this4;
  }

  return _createClass(FirebaseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ErrorFactory = /*#__PURE__*/function () {
  function ErrorFactory(service, serviceName, errors) {
    _classCallCheck(this, ErrorFactory);

    this.service = service;
    this.serviceName = serviceName;
    this.errors = errors;
  }

  _createClass(ErrorFactory, [{
    key: "create",
    value: function create(code) {
      var customData = (arguments.length <= 1 ? undefined : arguments[1]) || {};
      var fullCode = "".concat(this.service, "/").concat(code);
      var template = this.errors[code];
      var message = template ? replaceTemplate(template, customData) : 'Error'; // Service Name: Error message (service/code).

      var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
      var error = new FirebaseError(fullCode, fullMessage, customData);
      return error;
    }
  }]);

  return ErrorFactory;
}();

function replaceTemplate(template, data) {
  return template.replace(PATTERN, function (_, key) {
    var value = data[key];
    return value != null ? String(value) : "<".concat(key, "?>");
  });
}

var PATTERN = /\{\$([^}]+)}/g;

function isEmpty$1(obj) {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }

  return true;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */


function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);

  for (var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++) {
    var k = _aKeys[_i];

    if (!bKeys.includes(k)) {
      return false;
    }

    var aProp = a[k];
    var bProp = b[k];

    if (isObject$6(aProp) && isObject$6(bProp)) {
      if (!deepEqual(aProp, bProp)) {
        return false;
      }
    } else if (aProp !== bProp) {
      return false;
    }
  }

  for (var _i2 = 0, _bKeys = bKeys; _i2 < _bKeys.length; _i2++) {
    var _k = _bKeys[_i2];

    if (!aKeys.includes(_k)) {
      return false;
    }
  }

  return true;
}

function isObject$6(thing) {
  return thing !== null && _typeof(thing) === 'object';
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */


function querystring(querystringParams) {
  var params = [];

  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (Array.isArray(value)) {
      value.forEach(function (arrayVal) {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
      });
    } else {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  };

  for (var _i3 = 0, _Object$entries = Object.entries(querystringParams); _i3 < _Object$entries.length; _i3++) {
    _loop();
  }

  return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */


function querystringDecode(querystring) {
  var obj = {};
  var tokens = querystring.replace(/^\?/, '').split('&');
  tokens.forEach(function (token) {
    if (token) {
      var _token$split = token.split('='),
          _token$split2 = _slicedToArray(_token$split, 2),
          key = _token$split2[0],
          value = _token$split2[1];

      obj[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  });
  return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */


function extractQuerystring(url) {
  var queryStart = url.indexOf('?');

  if (!queryStart) {
    return '';
  }

  var fragmentStart = url.indexOf('#', queryStart);
  return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */


function createSubscribe(executor, onNoObservers) {
  var proxy = new ObserverProxy(executor, onNoObservers);
  return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */


var ObserverProxy = /*#__PURE__*/function () {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  function ObserverProxy(executor, onNoObservers) {
    var _this5 = this;

    _classCallCheck(this, ObserverProxy);

    this.observers = [];
    this.unsubscribes = [];
    this.observerCount = 0; // Micro-task scheduling by calling task.then().

    this.task = Promise.resolve();
    this.finalized = false;
    this.onNoObservers = onNoObservers; // Call the executor asynchronously so subscribers that are called
    // synchronously after the creation of the subscribe function
    // can still receive the very first value generated in the executor.

    this.task.then(function () {
      executor(_this5);
    })["catch"](function (e) {
      _this5.error(e);
    });
  }

  _createClass(ObserverProxy, [{
    key: "next",
    value: function next(value) {
      this.forEachObserver(function (observer) {
        observer.next(value);
      });
    }
  }, {
    key: "error",
    value: function error(_error) {
      this.forEachObserver(function (observer) {
        observer.error(_error);
      });
      this.close(_error);
    }
  }, {
    key: "complete",
    value: function complete() {
      this.forEachObserver(function (observer) {
        observer.complete();
      });
      this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */

  }, {
    key: "subscribe",
    value: function subscribe(nextOrObserver, error, complete) {
      var _this6 = this;

      var observer;

      if (nextOrObserver === undefined && error === undefined && complete === undefined) {
        throw new Error('Missing Observer.');
      } // Assemble an Observer object when passed as callback functions.


      if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
        observer = nextOrObserver;
      } else {
        observer = {
          next: nextOrObserver,
          error: error,
          complete: complete
        };
      }

      if (observer.next === undefined) {
        observer.next = noop;
      }

      if (observer.error === undefined) {
        observer.error = noop;
      }

      if (observer.complete === undefined) {
        observer.complete = noop;
      }

      var unsub = this.unsubscribeOne.bind(this, this.observers.length); // Attempt to subscribe to a terminated Observable - we
      // just respond to the Observer with the final error or complete
      // event.

      if (this.finalized) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
          try {
            if (_this6.finalError) {
              observer.error(_this6.finalError);
            } else {
              observer.complete();
            }
          } catch (e) {// nothing
          }

          return;
        });
      }

      this.observers.push(observer);
      return unsub;
    } // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.

  }, {
    key: "unsubscribeOne",
    value: function unsubscribeOne(i) {
      if (this.observers === undefined || this.observers[i] === undefined) {
        return;
      }

      delete this.observers[i];
      this.observerCount -= 1;

      if (this.observerCount === 0 && this.onNoObservers !== undefined) {
        this.onNoObservers(this);
      }
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(fn) {
      if (this.finalized) {
        // Already closed by previous event....just eat the additional values.
        return;
      } // Since sendOne calls asynchronously - there is no chance that
      // this.observers will become undefined.


      for (var i = 0; i < this.observers.length; i++) {
        this.sendOne(i, fn);
      }
    } // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.

  }, {
    key: "sendOne",
    value: function sendOne(i, fn) {
      var _this7 = this;

      // Execute the callback asynchronously
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.task.then(function () {
        if (_this7.observers !== undefined && _this7.observers[i] !== undefined) {
          try {
            fn(_this7.observers[i]);
          } catch (e) {
            // Ignore exceptions raised in Observers or missing methods of an
            // Observer.
            // Log error to console. b/31404806
            if (typeof console !== 'undefined' && console.error) {
              console.error(e);
            }
          }
        }
      });
    }
  }, {
    key: "close",
    value: function close(err) {
      var _this8 = this;

      if (this.finalized) {
        return;
      }

      this.finalized = true;

      if (err !== undefined) {
        this.finalError = err;
      } // Proxy is no longer needed - garbage collect references
      // eslint-disable-next-line @typescript-eslint/no-floating-promises


      this.task.then(function () {
        _this8.observers = undefined;
        _this8.onNoObservers = undefined;
      });
    }
  }]);

  return ObserverProxy;
}();
/**
 * Return true if the object passed in implements any of the named methods.
 */


function implementsAnyMethods(obj, methods) {
  if (_typeof(obj) !== 'object' || obj === null) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper$6(methods),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var method = _step.value;

      if (method in obj && typeof obj[method] === 'function') {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}

function noop() {// do nothing
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */


var uuidv4 = function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The amount of milliseconds to exponentially increase.
 */


var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */

var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */

var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.

/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */

var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */

function calculateBackoffMillis(backoffCount) {
  var intervalMillis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INTERVAL_MILLIS;
  var backoffFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BACKOFF_FACTOR;
  // Calculates an exponentially increasing value.
  // Deviation: calculates value from count and a constant interval, so we only need to save value
  // and count to restore state.
  var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount); // A random "fuzz" to avoid waves of retries.
  // Deviation: randomFactor is required.

  var randomWait = Math.round( // A fraction of the backoff value to add/subtract.
  // Deviation: changes multiplication order to improve readability.
  RANDOM_FACTOR * currBaseValue * ( // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
  // if we add or subtract.
  Math.random() - 0.5) * 2); // Limits backoff to max to avoid effectively permanent backoff.

  return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getModularInstance(service) {
  if (service && service._delegate) {
    return service._delegate;
  } else {
    return service;
  }
}

function _createForOfIteratorHelper$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */

var Component = /*#__PURE__*/function () {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  function Component(name, instanceFactory, type) {
    _classCallCheck(this, Component);

    this.name = name;
    this.instanceFactory = instanceFactory;
    this.type = type;
    this.multipleInstances = false;
    /**
     * Properties to be added to the service namespace
     */

    this.serviceProps = {};
    this.instantiationMode = "LAZY"
    /* InstantiationMode.LAZY */
    ;
    this.onInstanceCreated = null;
  }

  _createClass(Component, [{
    key: "setInstantiationMode",
    value: function setInstantiationMode(mode) {
      this.instantiationMode = mode;
      return this;
    }
  }, {
    key: "setMultipleInstances",
    value: function setMultipleInstances(multipleInstances) {
      this.multipleInstances = multipleInstances;
      return this;
    }
  }, {
    key: "setServiceProps",
    value: function setServiceProps(props) {
      this.serviceProps = props;
      return this;
    }
  }, {
    key: "setInstanceCreatedCallback",
    value: function setInstanceCreatedCallback(callback) {
      this.onInstanceCreated = callback;
      return this;
    }
  }]);

  return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ENTRY_NAME$1 = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */

var Provider = /*#__PURE__*/function () {
  function Provider(name, container) {
    _classCallCheck(this, Provider);

    this.name = name;
    this.container = container;
    this.component = null;
    this.instances = new Map();
    this.instancesDeferred = new Map();
    this.instancesOptions = new Map();
    this.onInitCallbacks = new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */


  _createClass(Provider, [{
    key: "get",
    value: function get(identifier) {
      // if multipleInstances is not supported, use the default name
      var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);

      if (!this.instancesDeferred.has(normalizedIdentifier)) {
        var deferred = new Deferred();
        this.instancesDeferred.set(normalizedIdentifier, deferred);

        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
          // initialize the service if it can be auto-initialized
          try {
            var instance = this.getOrInitializeService({
              instanceIdentifier: normalizedIdentifier
            });

            if (instance) {
              deferred.resolve(instance);
            }
          } catch (e) {// when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
          }
        }
      }

      return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
  }, {
    key: "getImmediate",
    value: function getImmediate(options) {
      var _a; // if multipleInstances is not supported, use the default name


      var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
      var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;

      if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
        try {
          return this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier
          });
        } catch (e) {
          if (optional) {
            return null;
          } else {
            throw e;
          }
        }
      } else {
        // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
        if (optional) {
          return null;
        } else {
          throw Error("Service ".concat(this.name, " is not available"));
        }
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "setComponent",
    value: function setComponent(component) {
      if (component.name !== this.name) {
        throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
      }

      if (this.component) {
        throw Error("Component for ".concat(this.name, " has already been provided"));
      }

      this.component = component; // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)

      if (!this.shouldAutoInitialize()) {
        return;
      } // if the service is eager, initialize the default instance


      if (isComponentEager(component)) {
        try {
          this.getOrInitializeService({
            instanceIdentifier: DEFAULT_ENTRY_NAME$1
          });
        } catch (e) {// when the instance factory for an eager Component throws an exception during the eager
          // initialization, it should not cause a fatal error.
          // TODO: Investigate if we need to make it configurable, because some component may want to cause
          // a fatal error in this case?
        }
      } // Create service instances for the pending promises and resolve them
      // NOTE: if this.multipleInstances is false, only the default instance will be created
      // and all promises with resolve with it regardless of the identifier.


      var _iterator = _createForOfIteratorHelper$5(this.instancesDeferred.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              instanceIdentifier = _step$value[0],
              instanceDeferred = _step$value[1];

          var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);

          try {
            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
            var instance = this.getOrInitializeService({
              instanceIdentifier: normalizedIdentifier
            });
            instanceDeferred.resolve(instance);
          } catch (e) {// when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "clearInstance",
    value: function clearInstance() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      this.instancesDeferred["delete"](identifier);
      this.instancesOptions["delete"](identifier);
      this.instances["delete"](identifier);
    } // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var services;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                services = Array.from(this.instances.values());
                _context.next = 3;
                return Promise.all([].concat(_toConsumableArray(services.filter(function (service) {
                  return 'INTERNAL' in service;
                }) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(function (service) {
                  return service.INTERNAL["delete"]();
                })), _toConsumableArray(services.filter(function (service) {
                  return '_delete' in service;
                }) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(function (service) {
                  return service._delete();
                }))));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "isComponentSet",
    value: function isComponentSet() {
      return this.component != null;
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      return this.instances.has(identifier);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;
      return this.instancesOptions.get(identifier) || {};
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$options = opts.options,
          options = _opts$options === void 0 ? {} : _opts$options;
      var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);

      if (this.isInitialized(normalizedIdentifier)) {
        throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
      }

      if (!this.isComponentSet()) {
        throw Error("Component ".concat(this.name, " has not been registered yet"));
      }

      var instance = this.getOrInitializeService({
        instanceIdentifier: normalizedIdentifier,
        options: options
      }); // resolve any pending promise waiting for the service instance

      var _iterator2 = _createForOfIteratorHelper$5(this.instancesDeferred.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              instanceIdentifier = _step2$value[0],
              instanceDeferred = _step2$value[1];

          var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);

          if (normalizedIdentifier === normalizedDeferredIdentifier) {
            instanceDeferred.resolve(instance);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */

  }, {
    key: "onInit",
    value: function onInit(callback, identifier) {
      var _a;

      var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
      var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
      existingCallbacks.add(callback);
      this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
      var existingInstance = this.instances.get(normalizedIdentifier);

      if (existingInstance) {
        callback(existingInstance, normalizedIdentifier);
      }

      return function () {
        existingCallbacks["delete"](callback);
      };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */

  }, {
    key: "invokeOnInitCallbacks",
    value: function invokeOnInitCallbacks(instance, identifier) {
      var callbacks = this.onInitCallbacks.get(identifier);

      if (!callbacks) {
        return;
      }

      var _iterator3 = _createForOfIteratorHelper$5(callbacks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var callback = _step3.value;

          try {
            callback(instance, identifier);
          } catch (_a) {// ignore errors in the onInit callback
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "getOrInitializeService",
    value: function getOrInitializeService(_ref) {
      var instanceIdentifier = _ref.instanceIdentifier,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options;
      var instance = this.instances.get(instanceIdentifier);

      if (!instance && this.component) {
        instance = this.component.instanceFactory(this.container, {
          instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
          options: options
        });
        this.instances.set(instanceIdentifier, instance);
        this.instancesOptions.set(instanceIdentifier, options);
        /**
         * Invoke onInit listeners.
         * Note this.component.onInstanceCreated is different, which is used by the component creator,
         * while onInit listeners are registered by consumers of the provider.
         */

        this.invokeOnInitCallbacks(instance, instanceIdentifier);
        /**
         * Order is important
         * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
         * makes `isInitialized()` return true.
         */

        if (this.component.onInstanceCreated) {
          try {
            this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
          } catch (_a) {// ignore errors in the onInstanceCreatedCallback
          }
        }
      }

      return instance || null;
    }
  }, {
    key: "normalizeInstanceIdentifier",
    value: function normalizeInstanceIdentifier() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME$1;

      if (this.component) {
        return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME$1;
      } else {
        return identifier; // assume multiple instances are supported before the component is provided.
      }
    }
  }, {
    key: "shouldAutoInitialize",
    value: function shouldAutoInitialize() {
      return !!this.component && this.component.instantiationMode !== "EXPLICIT"
      /* InstantiationMode.EXPLICIT */
      ;
    }
  }]);

  return Provider;
}(); // undefined should be passed to the service factory for the default instance


function normalizeIdentifierForFactory(identifier) {
  return identifier === DEFAULT_ENTRY_NAME$1 ? undefined : identifier;
}

function isComponentEager(component) {
  return component.instantiationMode === "EAGER"
  /* InstantiationMode.EAGER */
  ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */


var ComponentContainer = /*#__PURE__*/function () {
  function ComponentContainer(name) {
    _classCallCheck(this, ComponentContainer);

    this.name = name;
    this.providers = new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */


  _createClass(ComponentContainer, [{
    key: "addComponent",
    value: function addComponent(component) {
      var provider = this.getProvider(component.name);

      if (provider.isComponentSet()) {
        throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
      }

      provider.setComponent(component);
    }
  }, {
    key: "addOrOverwriteComponent",
    value: function addOrOverwriteComponent(component) {
      var provider = this.getProvider(component.name);

      if (provider.isComponentSet()) {
        // delete the existing provider from the container, so we can register the new component
        this.providers["delete"](component.name);
      }

      this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */

  }, {
    key: "getProvider",
    value: function getProvider(name) {
      if (this.providers.has(name)) {
        return this.providers.get(name);
      } // create a Provider for a service that hasn't registered with Firebase


      var provider = new Provider(name, this);
      this.providers.set(name, provider);
      return provider;
    }
  }, {
    key: "getProviders",
    value: function getProviders() {
      return Array.from(this.providers.values());
    }
  }]);

  return ComponentContainer;
}();

var _ConsoleMethod;
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */

var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
  LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
  LogLevel[LogLevel["INFO"] = 2] = "INFO";
  LogLevel[LogLevel["WARN"] = 3] = "WARN";
  LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
  LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));

var levelStringToEnum = {
  'debug': LogLevel.DEBUG,
  'verbose': LogLevel.VERBOSE,
  'info': LogLevel.INFO,
  'warn': LogLevel.WARN,
  'error': LogLevel.ERROR,
  'silent': LogLevel.SILENT
};
/**
 * The default log level
 */

var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */

var ConsoleMethod = (_ConsoleMethod = {}, _defineProperty$1(_ConsoleMethod, LogLevel.DEBUG, 'log'), _defineProperty$1(_ConsoleMethod, LogLevel.VERBOSE, 'log'), _defineProperty$1(_ConsoleMethod, LogLevel.INFO, 'info'), _defineProperty$1(_ConsoleMethod, LogLevel.WARN, 'warn'), _defineProperty$1(_ConsoleMethod, LogLevel.ERROR, 'error'), _ConsoleMethod);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */

var defaultLogHandler = function defaultLogHandler(instance, logType) {
  if (logType < instance.logLevel) {
    return;
  }

  var now = new Date().toISOString();
  var method = ConsoleMethod[logType];

  if (method) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    (_console = console)[method].apply(_console, ["[".concat(now, "]  ").concat(instance.name, ":")].concat(args));
  } else {
    throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
  }
};

var Logger$1 = /*#__PURE__*/function () {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  function Logger(name) {
    _classCallCheck(this, Logger);

    this.name = name;
    /**
     * The log level of the given Logger instance.
     */

    this._logLevel = defaultLogLevel;
    /**
     * The main (internal) log handler for the Logger instance.
     * Can be set to a new function in internal package code but not by user.
     */

    this._logHandler = defaultLogHandler;
    /**
     * The optional, additional, user-defined log handler for the Logger instance.
     */

    this._userLogHandler = null;
  }

  _createClass(Logger, [{
    key: "logLevel",
    get: function get() {
      return this._logLevel;
    },
    set: function set(val) {
      if (!(val in LogLevel)) {
        throw new TypeError("Invalid value \"".concat(val, "\" assigned to `logLevel`"));
      }

      this._logLevel = val;
    } // Workaround for setter/getter having to be the same type.

  }, {
    key: "setLogLevel",
    value: function setLogLevel(val) {
      this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
  }, {
    key: "logHandler",
    get: function get() {
      return this._logHandler;
    },
    set: function set(val) {
      if (typeof val !== 'function') {
        throw new TypeError('Value assigned to `logHandler` must be a function');
      }

      this._logHandler = val;
    }
  }, {
    key: "userLogHandler",
    get: function get() {
      return this._userLogHandler;
    },
    set: function set(val) {
      this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */

  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.DEBUG].concat(args));

      this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));

      this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.INFO].concat(args));

      this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.WARN].concat(args));

      this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.ERROR].concat(args));

      this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    }
  }]);

  return Logger;
}();

var instanceOfAny = function instanceOfAny(object, constructors) {
  return constructors.some(function (c) {
    return object instanceof c;
  });
};

var idbProxyableTypes;
var cursorAdvanceMethods; // This is a function to prevent it throwing up in node environments.

function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
} // This is a function to prevent it throwing up in node environments.


function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype["continue"], IDBCursor.prototype.continuePrimaryKey]);
}

var cursorRequestMap = new WeakMap();
var transactionDoneMap = new WeakMap();
var transactionStoreNamesMap = new WeakMap();
var transformCache = new WeakMap();
var reverseTransformCache = new WeakMap();

function promisifyRequest(request) {
  var promise = new Promise(function (resolve, reject) {
    var unlisten = function unlisten() {
      request.removeEventListener('success', success);
      request.removeEventListener('error', error);
    };

    var success = function success() {
      resolve(wrap(request.result));
      unlisten();
    };

    var error = function error() {
      reject(request.error);
      unlisten();
    };

    request.addEventListener('success', success);
    request.addEventListener('error', error);
  });
  promise.then(function (value) {
    // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
    // (see wrapFunction).
    if (value instanceof IDBCursor) {
      cursorRequestMap.set(value, request);
    } // Catching to avoid "Uncaught Promise exceptions"

  })["catch"](function () {}); // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
  // is because we create many promises from a single IDBRequest.

  reverseTransformCache.set(promise, request);
  return promise;
}

function cacheDonePromiseForTransaction(tx) {
  // Early bail if we've already created a done promise for this transaction.
  if (transactionDoneMap.has(tx)) return;
  var done = new Promise(function (resolve, reject) {
    var unlisten = function unlisten() {
      tx.removeEventListener('complete', complete);
      tx.removeEventListener('error', error);
      tx.removeEventListener('abort', error);
    };

    var complete = function complete() {
      resolve();
      unlisten();
    };

    var error = function error() {
      reject(tx.error || new DOMException('AbortError', 'AbortError'));
      unlisten();
    };

    tx.addEventListener('complete', complete);
    tx.addEventListener('error', error);
    tx.addEventListener('abort', error);
  }); // Cache it for later retrieval.

  transactionDoneMap.set(tx, done);
}

var idbProxyTraps = {
  get: function get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      // Special handling for transaction.done.
      if (prop === 'done') return transactionDoneMap.get(target); // Polyfill for objectStoreNames because of Edge.

      if (prop === 'objectStoreNames') {
        return target.objectStoreNames || transactionStoreNamesMap.get(target);
      } // Make tx.store return the only store in the transaction, or undefined if there are many.


      if (prop === 'store') {
        return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    } // Else transform whatever we get back.


    return wrap(target[prop]);
  },
  set: function set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has: function has(target, prop) {
    if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
      return true;
    }

    return prop in target;
  }
};

function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}

function wrapFunction(func) {
  // Due to expected object equality (which is enforced by the caching in `wrap`), we
  // only create one new func per func.
  // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
  if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) {
    return function (storeNames) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var tx = func.call.apply(func, [unwrap(this), storeNames].concat(args));
      transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
      return wrap(tx);
    };
  } // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
  // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
  // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
  // with real promises, so each advance methods returns a new promise for the cursor object, or
  // undefined if the end of the cursor has been reached.


  if (getCursorAdvanceMethods().includes(func)) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
      // the original object.
      func.apply(unwrap(this), args);
      return wrap(cursorRequestMap.get(this));
    };
  }

  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
    // the original object.
    return wrap(func.apply(unwrap(this), args));
  };
}

function transformCachableValue(value) {
  if (typeof value === 'function') return wrapFunction(value); // This doesn't return, it just creates a 'done' promise for the transaction,
  // which is later returned for transaction.done (see idbObjectHandler).

  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps); // Return the same value back if we're not going to transform it.

  return value;
}

function wrap(value) {
  // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
  // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
  if (value instanceof IDBRequest) return promisifyRequest(value); // If we've already transformed this value before, reuse the transformed value.
  // This is faster, but it also provides object equality.

  if (transformCache.has(value)) return transformCache.get(value);
  var newValue = transformCachableValue(value); // Not all types are transformed.
  // These may be primitive types, so they can't be WeakMap keys.

  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }

  return newValue;
}

var unwrap = function unwrap(value) {
  return reverseTransformCache.get(value);
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */

function openDB(name, version) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      blocked = _ref.blocked,
      upgrade = _ref.upgrade,
      blocking = _ref.blocking,
      terminated = _ref.terminated;

  var request = indexedDB.open(name, version);
  var openPromise = wrap(request);

  if (upgrade) {
    request.addEventListener('upgradeneeded', function (event) {
      upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
    });
  }

  if (blocked) {
    request.addEventListener('blocked', function (event) {
      return blocked( // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
      event.oldVersion, event.newVersion, event);
    });
  }

  openPromise.then(function (db) {
    if (terminated) db.addEventListener('close', function () {
      return terminated();
    });

    if (blocking) {
      db.addEventListener('versionchange', function (event) {
        return blocking(event.oldVersion, event.newVersion, event);
      });
    }
  })["catch"](function () {});
  return openPromise;
}

var readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
var writeMethods = ['put', 'add', 'delete', 'clear'];
var cachedMethods = new Map();

function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
    return;
  }

  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  var targetFuncName = prop.replace(/FromIndex$/, '');
  var useIndex = prop !== targetFuncName;
  var isWrite = writeMethods.includes(targetFuncName);

  if ( // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
  !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }

  var method = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(storeName) {
      var _target;

      var tx,
          target,
          _len,
          args,
          _key,
          _args = arguments;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
              tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
              target = tx.store;

              for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args[_key];
              }

              if (useIndex) target = target.index(args.shift()); // Must reject if op rejects.
              // If it's a write operation, must reject if tx.done rejects.
              // Must reject with op rejection first.
              // Must resolve with op value.
              // Must handle both promises (no unhandled rejections)

              _context.next = 6;
              return Promise.all([(_target = target)[targetFuncName].apply(_target, args), isWrite && tx.done]);

            case 6:
              return _context.abrupt("return", _context.sent[0]);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function method(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  cachedMethods.set(prop, method);
  return method;
}

replaceTraps(function (oldTraps) {
  return _objectSpread(_objectSpread({}, oldTraps), {}, {
    get: function get(target, prop, receiver) {
      return getMethod(target, prop) || oldTraps.get(target, prop, receiver);
    },
    has: function has(target, prop) {
      return !!getMethod(target, prop) || oldTraps.has(target, prop);
    }
  });
});

var _PLATFORM_LOG_STRING, _ERRORS$1;

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var PlatformLoggerServiceImpl = /*#__PURE__*/function () {
  function PlatformLoggerServiceImpl(container) {
    _classCallCheck(this, PlatformLoggerServiceImpl);

    this.container = container;
  } // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.


  _createClass(PlatformLoggerServiceImpl, [{
    key: "getPlatformInfoString",
    value: function getPlatformInfoString() {
      var providers = this.container.getProviders(); // Loop through providers and get library/version pairs from any that are
      // version components.

      return providers.map(function (provider) {
        if (isVersionServiceProvider(provider)) {
          var service = provider.getImmediate();
          return "".concat(service.library, "/").concat(service.version);
        } else {
          return null;
        }
      }).filter(function (logString) {
        return logString;
      }).join(' ');
    }
  }]);

  return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */


function isVersionServiceProvider(provider) {
  var component = provider.getComponent();
  return (component === null || component === void 0 ? void 0 : component.type) === "VERSION"
  /* ComponentType.VERSION */
  ;
}

var name$p = "@firebase/app";
var version$1$1 = "0.10.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var logger$1 = new Logger$1('@firebase/app');
var name$o = "@firebase/app-compat";
var name$n = "@firebase/analytics-compat";
var name$m = "@firebase/analytics";
var name$l = "@firebase/app-check-compat";
var name$k = "@firebase/app-check";
var name$j = "@firebase/auth";
var name$i = "@firebase/auth-compat";
var name$h = "@firebase/database";
var name$g = "@firebase/database-compat";
var name$f = "@firebase/functions";
var name$e = "@firebase/functions-compat";
var name$d = "@firebase/installations";
var name$c = "@firebase/installations-compat";
var name$b = "@firebase/messaging";
var name$a = "@firebase/messaging-compat";
var name$9 = "@firebase/performance";
var name$8 = "@firebase/performance-compat";
var name$7 = "@firebase/remote-config";
var name$6 = "@firebase/remote-config-compat";
var name$5 = "@firebase/storage";
var name$4 = "@firebase/storage-compat";
var name$3 = "@firebase/firestore";
var name$2$1 = "@firebase/vertexai-preview";
var name$1$1 = "@firebase/firestore-compat";
var name$q = "firebase";
var version$3 = "10.12.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The default app name
 *
 * @internal
 */

var DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_PLATFORM_LOG_STRING = {}, _defineProperty$1(_PLATFORM_LOG_STRING, name$p, 'fire-core'), _defineProperty$1(_PLATFORM_LOG_STRING, name$o, 'fire-core-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$m, 'fire-analytics'), _defineProperty$1(_PLATFORM_LOG_STRING, name$n, 'fire-analytics-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$k, 'fire-app-check'), _defineProperty$1(_PLATFORM_LOG_STRING, name$l, 'fire-app-check-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$j, 'fire-auth'), _defineProperty$1(_PLATFORM_LOG_STRING, name$i, 'fire-auth-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$h, 'fire-rtdb'), _defineProperty$1(_PLATFORM_LOG_STRING, name$g, 'fire-rtdb-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$f, 'fire-fn'), _defineProperty$1(_PLATFORM_LOG_STRING, name$e, 'fire-fn-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$d, 'fire-iid'), _defineProperty$1(_PLATFORM_LOG_STRING, name$c, 'fire-iid-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$b, 'fire-fcm'), _defineProperty$1(_PLATFORM_LOG_STRING, name$a, 'fire-fcm-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$9, 'fire-perf'), _defineProperty$1(_PLATFORM_LOG_STRING, name$8, 'fire-perf-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$7, 'fire-rc'), _defineProperty$1(_PLATFORM_LOG_STRING, name$6, 'fire-rc-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$5, 'fire-gcs'), _defineProperty$1(_PLATFORM_LOG_STRING, name$4, 'fire-gcs-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$3, 'fire-fst'), _defineProperty$1(_PLATFORM_LOG_STRING, name$1$1, 'fire-fst-compat'), _defineProperty$1(_PLATFORM_LOG_STRING, name$2$1, 'fire-vertex'), _defineProperty$1(_PLATFORM_LOG_STRING, 'fire-js', 'fire-js'), _defineProperty$1(_PLATFORM_LOG_STRING, name$q, 'fire-js-all'), _PLATFORM_LOG_STRING);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @internal
 */

var _apps = new Map();
/**
 * @internal
 */


var _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


var _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */


function _addComponent(app, component) {
  try {
    app.container.addComponent(component);
  } catch (e) {
    logger$1.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
  }
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */


function _registerComponent(component) {
  var componentName = component.name;

  if (_components.has(componentName)) {
    logger$1.debug("There were multiple attempts to register component ".concat(componentName, "."));
    return false;
  }

  _components.set(componentName, component); // add the component to existing app instances


  var _iterator = _createForOfIteratorHelper$4(_apps.values()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var app = _step.value;

      _addComponent(app, component);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper$4(_serverApps.values()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var serverApp = _step2.value;

      _addComponent(serverApp, component);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */


function _getProvider(app, name) {
  var heartbeatController = app.container.getProvider('heartbeat').getImmediate({
    optional: true
  });

  if (heartbeatController) {
    void heartbeatController.triggerHeartbeat();
  }

  return app.container.getProvider(name);
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */


function _isFirebaseServerApp(obj) {
  return obj.settings !== undefined;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERRORS$1 = (_ERRORS$1 = {}, _defineProperty$1(_ERRORS$1, "no-app"
/* AppError.NO_APP */
, "No Firebase App '{$appName}' has been created - " + 'call initializeApp() first'), _defineProperty$1(_ERRORS$1, "bad-app-name"
/* AppError.BAD_APP_NAME */
, "Illegal App name: '{$appName}'"), _defineProperty$1(_ERRORS$1, "duplicate-app"
/* AppError.DUPLICATE_APP */
, "Firebase App named '{$appName}' already exists with different options or config"), _defineProperty$1(_ERRORS$1, "app-deleted"
/* AppError.APP_DELETED */
, "Firebase App named '{$appName}' already deleted"), _defineProperty$1(_ERRORS$1, "server-app-deleted"
/* AppError.SERVER_APP_DELETED */
, 'Firebase Server App has been deleted'), _defineProperty$1(_ERRORS$1, "no-options"
/* AppError.NO_OPTIONS */
, 'Need to provide options, when not being deployed to hosting via source.'), _defineProperty$1(_ERRORS$1, "invalid-app-argument"
/* AppError.INVALID_APP_ARGUMENT */
, 'firebase.{$appName}() takes either no argument or a ' + 'Firebase App instance.'), _defineProperty$1(_ERRORS$1, "invalid-log-argument"
/* AppError.INVALID_LOG_ARGUMENT */
, 'First argument to `onLog` must be null or a function.'), _defineProperty$1(_ERRORS$1, "idb-open"
/* AppError.IDB_OPEN */
, 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS$1, "idb-get"
/* AppError.IDB_GET */
, 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS$1, "idb-set"
/* AppError.IDB_WRITE */
, 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS$1, "idb-delete"
/* AppError.IDB_DELETE */
, 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS$1, "finalization-registry-not-supported"
/* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */
, 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.'), _defineProperty$1(_ERRORS$1, "invalid-server-app-environment"
/* AppError.INVALID_SERVER_APP_ENVIRONMENT */
, 'FirebaseServerApp is not for use in browser environments.'), _ERRORS$1);
var ERROR_FACTORY$1 = new ErrorFactory('app', 'Firebase', ERRORS$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FirebaseAppImpl = /*#__PURE__*/function () {
  function FirebaseAppImpl(options, config, container) {
    var _this = this;

    _classCallCheck(this, FirebaseAppImpl);

    this._isDeleted = false;
    this._options = Object.assign({}, options);
    this._config = Object.assign({}, config);
    this._name = config.name;
    this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
    this._container = container;
    this.container.addComponent(new Component('app', function () {
      return _this;
    }, "PUBLIC"
    /* ComponentType.PUBLIC */
    ));
  }

  _createClass(FirebaseAppImpl, [{
    key: "automaticDataCollectionEnabled",
    get: function get() {
      this.checkDestroyed();
      return this._automaticDataCollectionEnabled;
    },
    set: function set(val) {
      this.checkDestroyed();
      this._automaticDataCollectionEnabled = val;
    }
  }, {
    key: "name",
    get: function get() {
      this.checkDestroyed();
      return this._name;
    }
  }, {
    key: "options",
    get: function get() {
      this.checkDestroyed();
      return this._options;
    }
  }, {
    key: "config",
    get: function get() {
      this.checkDestroyed();
      return this._config;
    }
  }, {
    key: "container",
    get: function get() {
      return this._container;
    }
  }, {
    key: "isDeleted",
    get: function get() {
      return this._isDeleted;
    },
    set: function set(val) {
      this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */

  }, {
    key: "checkDestroyed",
    value: function checkDestroyed() {
      if (this.isDeleted) {
        throw ERROR_FACTORY$1.create("app-deleted"
        /* AppError.APP_DELETED */
        , {
          appName: this._name
        });
      }
    }
  }]);

  return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The current SDK version.
 *
 * @public
 */


var SDK_VERSION = version$3;

function initializeApp(_options) {
  var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = _options;

  if (_typeof(rawConfig) !== 'object') {
    var _name = rawConfig;
    rawConfig = {
      name: _name
    };
  }

  var config = Object.assign({
    name: DEFAULT_ENTRY_NAME,
    automaticDataCollectionEnabled: false
  }, rawConfig);
  var name = config.name;

  if (typeof name !== 'string' || !name) {
    throw ERROR_FACTORY$1.create("bad-app-name"
    /* AppError.BAD_APP_NAME */
    , {
      appName: String(name)
    });
  }

  options || (options = getDefaultAppConfig());

  if (!options) {
    throw ERROR_FACTORY$1.create("no-options"
    /* AppError.NO_OPTIONS */
    );
  }

  var existingApp = _apps.get(name);

  if (existingApp) {
    // return the existing app if options and config deep equal the ones in the existing app.
    if (deepEqual(options, existingApp.options) && deepEqual(config, existingApp.config)) {
      return existingApp;
    } else {
      throw ERROR_FACTORY$1.create("duplicate-app"
      /* AppError.DUPLICATE_APP */
      , {
        appName: name
      });
    }
  }

  var container = new ComponentContainer(name);

  var _iterator3 = _createForOfIteratorHelper$4(_components.values()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var component = _step3.value;
      container.addComponent(component);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var newApp = new FirebaseAppImpl(options, config, container);

  _apps.set(name, newApp);

  return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */


function getApp() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

  var app = _apps.get(name);

  if (!app && name === DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
    return initializeApp();
  }

  if (!app) {
    throw ERROR_FACTORY$1.create("no-app"
    /* AppError.NO_APP */
    , {
      appName: name
    });
  }

  return app;
}

function registerVersion(libraryKeyOrName, version, variant) {
  var _a; // TODO: We can use this check to whitelist strings when/if we set up
  // a good whitelist system.


  var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;

  if (variant) {
    library += "-".concat(variant);
  }

  var libraryMismatch = library.match(/\s|\//);
  var versionMismatch = version.match(/\s|\//);

  if (libraryMismatch || versionMismatch) {
    var warning = ["Unable to register library \"".concat(library, "\" with version \"").concat(version, "\":")];

    if (libraryMismatch) {
      warning.push("library name \"".concat(library, "\" contains illegal characters (whitespace or \"/\")"));
    }

    if (libraryMismatch && versionMismatch) {
      warning.push('and');
    }

    if (versionMismatch) {
      warning.push("version name \"".concat(version, "\" contains illegal characters (whitespace or \"/\")"));
    }

    logger$1.warn(warning.join(' '));
    return;
  }

  _registerComponent(new Component("".concat(library, "-version"), function () {
    return {
      library: library,
      version: version
    };
  }, "VERSION"
  /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME$2 = 'firebase-heartbeat-database';
var DB_VERSION$2 = 1;
var STORE_NAME$1 = 'firebase-heartbeat-store';
var dbPromise$1 = null;

function getDbPromise() {
  if (!dbPromise$1) {
    dbPromise$1 = openDB(DB_NAME$2, DB_VERSION$2, {
      upgrade: function upgrade(db, oldVersion) {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch (oldVersion) {
          case 0:
            try {
              db.createObjectStore(STORE_NAME$1);
            } catch (e) {
              // Safari/iOS browsers throw occasional exceptions on
              // db.createObjectStore() that may be a bug. Avoid blocking
              // the rest of the app functionality.
              console.warn(e);
            }

        }
      }
    })["catch"](function (e) {
      throw ERROR_FACTORY$1.create("idb-open"
      /* AppError.IDB_OPEN */
      , {
        originalErrorMessage: e.message
      });
    });
  }

  return dbPromise$1;
}

function readHeartbeatsFromIndexedDB(_x2) {
  return _readHeartbeatsFromIndexedDB.apply(this, arguments);
}

function _readHeartbeatsFromIndexedDB() {
  _readHeartbeatsFromIndexedDB = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(app) {
    var db, tx, result, idbGetError;
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return getDbPromise();

          case 3:
            db = _context8.sent;
            tx = db.transaction(STORE_NAME$1);
            _context8.next = 7;
            return tx.objectStore(STORE_NAME$1).get(computeKey$1(app));

          case 7:
            result = _context8.sent;
            _context8.next = 10;
            return tx.done;

          case 10:
            return _context8.abrupt("return", result);

          case 13:
            _context8.prev = 13;
            _context8.t0 = _context8["catch"](0);

            if (_context8.t0 instanceof FirebaseError) {
              logger$1.warn(_context8.t0.message);
            } else {
              idbGetError = ERROR_FACTORY$1.create("idb-get"
              /* AppError.IDB_GET */
              , {
                originalErrorMessage: _context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message
              });
              logger$1.warn(idbGetError.message);
            }

          case 16:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 13]]);
  }));
  return _readHeartbeatsFromIndexedDB.apply(this, arguments);
}

function writeHeartbeatsToIndexedDB(_x3, _x4) {
  return _writeHeartbeatsToIndexedDB.apply(this, arguments);
}

function _writeHeartbeatsToIndexedDB() {
  _writeHeartbeatsToIndexedDB = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(app, heartbeatObject) {
    var db, tx, objectStore, idbGetError;
    return regenerator.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return getDbPromise();

          case 3:
            db = _context9.sent;
            tx = db.transaction(STORE_NAME$1, 'readwrite');
            objectStore = tx.objectStore(STORE_NAME$1);
            _context9.next = 8;
            return objectStore.put(heartbeatObject, computeKey$1(app));

          case 8:
            _context9.next = 10;
            return tx.done;

          case 10:
            _context9.next = 15;
            break;

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](0);

            if (_context9.t0 instanceof FirebaseError) {
              logger$1.warn(_context9.t0.message);
            } else {
              idbGetError = ERROR_FACTORY$1.create("idb-set"
              /* AppError.IDB_WRITE */
              , {
                originalErrorMessage: _context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message
              });
              logger$1.warn(idbGetError.message);
            }

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 12]]);
  }));
  return _writeHeartbeatsToIndexedDB.apply(this, arguments);
}

function computeKey$1(app) {
  return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var MAX_HEADER_BYTES = 1024; // 30 days

var STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;

var HeartbeatServiceImpl = /*#__PURE__*/function () {
  function HeartbeatServiceImpl(container) {
    var _this3 = this;

    _classCallCheck(this, HeartbeatServiceImpl);

    this.container = container;
    /**
     * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
     * the header string.
     * Stores one record per date. This will be consolidated into the standard
     * format of one record per user agent string before being sent as a header.
     * Populated from indexedDB when the controller is instantiated and should
     * be kept in sync with indexedDB.
     * Leave public for easier testing.
     */

    this._heartbeatsCache = null;
    var app = this.container.getProvider('app').getImmediate();
    this._storage = new HeartbeatStorageImpl(app);
    this._heartbeatsCachePromise = this._storage.read().then(function (result) {
      _this3._heartbeatsCache = result;
      return result;
    });
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */


  _createClass(HeartbeatServiceImpl, [{
    key: "triggerHeartbeat",
    value: function () {
      var _triggerHeartbeat = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _a, _b, platformLogger, agent, date;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                platformLogger = this.container.getProvider('platform-logger').getImmediate(); // This is the "Firebase user agent" string from the platform logger
                // service, not the browser user agent.

                agent = platformLogger.getPlatformInfoString();
                date = getUTCDateString();

                if (!(((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this._heartbeatsCachePromise;

              case 6:
                this._heartbeatsCache = _context.sent;

                if (!(((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                if (!(this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some(function (singleDateHeartbeat) {
                  return singleDateHeartbeat.date === date;
                }))) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return");

              case 13:
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                  date: date,
                  agent: agent
                });

              case 14:
                // Remove entries older than 30 days.
                this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(function (singleDateHeartbeat) {
                  var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                  var now = Date.now();
                  return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                });
                return _context.abrupt("return", this._storage.overwrite(this._heartbeatsCache));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function triggerHeartbeat() {
        return _triggerHeartbeat.apply(this, arguments);
      }

      return triggerHeartbeat;
    }()
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */

  }, {
    key: "getHeartbeatsHeader",
    value: function () {
      var _getHeartbeatsHeader = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _a, date, _extractHeartbeatsFor, heartbeatsToSend, unsentEntries, headerString;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._heartbeatsCache === null)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this._heartbeatsCachePromise;

              case 3:
                if (!(((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", '');

              case 5:
                date = getUTCDateString(); // Extract as many heartbeats from the cache as will fit under the size limit.

                _extractHeartbeatsFor = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsFor.heartbeatsToSend, unsentEntries = _extractHeartbeatsFor.unsentEntries;
                headerString = base64urlEncodeWithoutPadding(JSON.stringify({
                  version: 2,
                  heartbeats: heartbeatsToSend
                })); // Store last sent date to prevent another being logged/sent for the same day.

                this._heartbeatsCache.lastSentHeartbeatDate = date;

                if (!(unsentEntries.length > 0)) {
                  _context2.next = 15;
                  break;
                }

                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries; // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.

                _context2.next = 13;
                return this._storage.overwrite(this._heartbeatsCache);

              case 13:
                _context2.next = 17;
                break;

              case 15:
                this._heartbeatsCache.heartbeats = []; // Do not wait for this, to reduce latency.

                void this._storage.overwrite(this._heartbeatsCache);

              case 17:
                return _context2.abrupt("return", headerString);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHeartbeatsHeader() {
        return _getHeartbeatsHeader.apply(this, arguments);
      }

      return getHeartbeatsHeader;
    }()
  }]);

  return HeartbeatServiceImpl;
}();

function getUTCDateString() {
  var today = new Date(); // Returns date format 'YYYY-MM-DD'

  return today.toISOString().substring(0, 10);
}

function extractHeartbeatsForHeader(heartbeatsCache) {
  var maxSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_HEADER_BYTES;
  // Heartbeats grouped by user agent in the standard format to be sent in
  // the header.
  var heartbeatsToSend = []; // Single date format heartbeats that are not sent.

  var unsentEntries = heartbeatsCache.slice();

  var _iterator5 = _createForOfIteratorHelper$4(heartbeatsCache),
      _step5;

  try {
    var _loop = function _loop() {
      var singleDateHeartbeat = _step5.value;
      // Look for an existing entry with the same user agent.
      var heartbeatEntry = heartbeatsToSend.find(function (hb) {
        return hb.agent === singleDateHeartbeat.agent;
      });

      if (!heartbeatEntry) {
        // If no entry for this user agent exists, create one.
        heartbeatsToSend.push({
          agent: singleDateHeartbeat.agent,
          dates: [singleDateHeartbeat.date]
        });

        if (countBytes(heartbeatsToSend) > maxSize) {
          // If the header would exceed max size, remove the added heartbeat
          // entry and stop adding to the header.
          heartbeatsToSend.pop();
          return "break";
        }
      } else {
        heartbeatEntry.dates.push(singleDateHeartbeat.date); // If the header would exceed max size, remove the added date
        // and stop adding to the header.

        if (countBytes(heartbeatsToSend) > maxSize) {
          heartbeatEntry.dates.pop();
          return "break";
        }
      } // Pop unsent entry from queue. (Skipped if adding the entry exceeded
      // quota and the loop breaks early.)


      unsentEntries = unsentEntries.slice(1);
    };

    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _ret = _loop();

      if (_ret === "break") break;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return {
    heartbeatsToSend: heartbeatsToSend,
    unsentEntries: unsentEntries
  };
}

var HeartbeatStorageImpl = /*#__PURE__*/function () {
  function HeartbeatStorageImpl(app) {
    _classCallCheck(this, HeartbeatStorageImpl);

    this.app = app;
    this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }

  _createClass(HeartbeatStorageImpl, [{
    key: "runIndexedDBEnvironmentCheck",
    value: function () {
      var _runIndexedDBEnvironmentCheck = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (isIndexedDBAvailable()) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", false);

              case 4:
                return _context3.abrupt("return", validateIndexedDBOpenable().then(function () {
                  return true;
                })["catch"](function () {
                  return false;
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function runIndexedDBEnvironmentCheck() {
        return _runIndexedDBEnvironmentCheck.apply(this, arguments);
      }

      return runIndexedDBEnvironmentCheck;
    }()
    /**
     * Read all heartbeats.
     */

  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var canUseIndexedDB, idbHeartbeatObject;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context4.sent;

                if (canUseIndexedDB) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", {
                  heartbeats: []
                });

              case 7:
                _context4.next = 9;
                return readHeartbeatsFromIndexedDB(this.app);

              case 9:
                idbHeartbeatObject = _context4.sent;

                if (!(idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats)) {
                  _context4.next = 14;
                  break;
                }

                return _context4.abrupt("return", idbHeartbeatObject);

              case 14:
                return _context4.abrupt("return", {
                  heartbeats: []
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }() // overwrite the storage with the provided heartbeats

  }, {
    key: "overwrite",
    value: function () {
      var _overwrite = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(heartbeatsObject) {
        var _a, canUseIndexedDB, existingHeartbeatsObject;

        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context5.sent;

                if (canUseIndexedDB) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return");

              case 7:
                _context5.next = 9;
                return this.read();

              case 9:
                existingHeartbeatsObject = _context5.sent;
                return _context5.abrupt("return", writeHeartbeatsToIndexedDB(this.app, {
                  lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                  heartbeats: heartbeatsObject.heartbeats
                }));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function overwrite(_x5) {
        return _overwrite.apply(this, arguments);
      }

      return overwrite;
    }() // add heartbeats

  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(heartbeatsObject) {
        var _a, canUseIndexedDB, existingHeartbeatsObject;

        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                canUseIndexedDB = _context6.sent;

                if (canUseIndexedDB) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return this.read();

              case 9:
                existingHeartbeatsObject = _context6.sent;
                return _context6.abrupt("return", writeHeartbeatsToIndexedDB(this.app, {
                  lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                  heartbeats: [].concat(_toConsumableArray(existingHeartbeatsObject.heartbeats), _toConsumableArray(heartbeatsObject.heartbeats))
                }));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function add(_x6) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
  }]);

  return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */


function countBytes(heartbeatsCache) {
  // base64 has a restricted set of characters, all of which should be 1 byte.
  return base64urlEncodeWithoutPadding( // heartbeatsCache wrapper properties
  JSON.stringify({
    version: 2,
    heartbeats: heartbeatsCache
  })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function registerCoreComponents(variant) {
  _registerComponent(new Component('platform-logger', function (container) {
    return new PlatformLoggerServiceImpl(container);
  }, "PRIVATE"
  /* ComponentType.PRIVATE */
  ));

  _registerComponent(new Component('heartbeat', function (container) {
    return new HeartbeatServiceImpl(container);
  }, "PRIVATE"
  /* ComponentType.PRIVATE */
  )); // Register `app` package.


  registerVersion(name$p, version$1$1, variant); // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation

  registerVersion(name$p, version$1$1, 'esm2017'); // Register platform SDK identifier (no version).

  registerVersion('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */


registerCoreComponents('');

var _SERVER_ERROR_MAP;

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Enumeration of supported providers.
 *
 * @public
 */

var ProviderId = {
  /** Facebook provider ID */
  FACEBOOK: 'facebook.com',

  /** GitHub provider ID */
  GITHUB: 'github.com',

  /** Google provider ID */
  GOOGLE: 'google.com',

  /** Password provider */
  PASSWORD: 'password',

  /** Phone provider */
  PHONE: 'phone',

  /** Twitter provider ID */
  TWITTER: 'twitter.com'
};

function _prodErrorMap() {
  // We will include this one message in the prod error map since by the very
  // nature of this error, developers will never be able to see the message
  // using the debugErrorMap (which is installed during auth initialization).
  return _defineProperty$1({}, "dependent-sdk-initialized-before-auth"
  /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
  , 'Another Firebase SDK was initialized and is trying to use Auth before Auth is ' + 'initialized. Please be sure to call `initializeAuth` or `getAuth` before ' + 'starting any other Firebase SDK.');
}
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */

var prodErrorMap = _prodErrorMap;

var _DEFAULT_AUTH_ERROR_FACTORY = new ErrorFactory('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */


var AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
  ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
  ARGUMENT_ERROR: 'auth/argument-error',
  APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
  APP_NOT_INSTALLED: 'auth/app-not-installed',
  CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
  CODE_EXPIRED: 'auth/code-expired',
  CORDOVA_NOT_READY: 'auth/cordova-not-ready',
  CORS_UNSUPPORTED: 'auth/cors-unsupported',
  CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
  CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
  DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
  DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
  EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
  EMAIL_EXISTS: 'auth/email-already-in-use',
  EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
  EXPIRED_OOB_CODE: 'auth/expired-action-code',
  EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
  INTERNAL_ERROR: 'auth/internal-error',
  INVALID_API_KEY: 'auth/invalid-api-key',
  INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
  INVALID_APP_ID: 'auth/invalid-app-id',
  INVALID_AUTH: 'auth/invalid-user-token',
  INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
  INVALID_CERT_HASH: 'auth/invalid-cert-hash',
  INVALID_CODE: 'auth/invalid-verification-code',
  INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
  INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
  INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
  INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
  INVALID_EMAIL: 'auth/invalid-email',
  INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
  INVALID_IDP_RESPONSE: 'auth/invalid-credential',
  INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
  INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
  INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
  INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
  INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
  INVALID_OOB_CODE: 'auth/invalid-action-code',
  INVALID_ORIGIN: 'auth/unauthorized-domain',
  INVALID_PASSWORD: 'auth/wrong-password',
  INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
  INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
  INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
  INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
  INVALID_SENDER: 'auth/invalid-sender',
  INVALID_SESSION_INFO: 'auth/invalid-verification-id',
  INVALID_TENANT_ID: 'auth/invalid-tenant-id',
  MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
  MFA_REQUIRED: 'auth/multi-factor-auth-required',
  MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
  MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
  MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
  MISSING_CODE: 'auth/missing-verification-code',
  MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
  MISSING_IFRAME_START: 'auth/missing-iframe-start',
  MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
  MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
  MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
  MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
  MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
  MISSING_SESSION_INFO: 'auth/missing-verification-id',
  MODULE_DESTROYED: 'auth/app-deleted',
  NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
  NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
  NULL_USER: 'auth/null-user',
  NO_AUTH_EVENT: 'auth/no-auth-event',
  NO_SUCH_PROVIDER: 'auth/no-such-provider',
  OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
  OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
  POPUP_BLOCKED: 'auth/popup-blocked',
  POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
  PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
  QUOTA_EXCEEDED: 'auth/quota-exceeded',
  REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
  REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
  REJECTED_CREDENTIAL: 'auth/rejected-credential',
  SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
  SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
  TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
  TIMEOUT: 'auth/timeout',
  TOKEN_EXPIRED: 'auth/user-token-expired',
  TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
  UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
  UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
  UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
  UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
  UNVERIFIED_EMAIL: 'auth/unverified-email',
  USER_CANCELLED: 'auth/user-cancelled',
  USER_DELETED: 'auth/user-not-found',
  USER_DISABLED: 'auth/user-disabled',
  USER_MISMATCH: 'auth/user-mismatch',
  USER_SIGNED_OUT: 'auth/user-signed-out',
  WEAK_PASSWORD: 'auth/weak-password',
  WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
  ALREADY_INITIALIZED: 'auth/already-initialized',
  RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
  MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
  INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
  INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
  MISSING_CLIENT_TYPE: 'auth/missing-client-type',
  MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
  INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
  INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var logClient = new Logger$1('@firebase/auth');

function _logWarn(msg) {
  if (logClient.logLevel <= LogLevel.WARN) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    logClient.warn.apply(logClient, ["Auth (".concat(SDK_VERSION, "): ").concat(msg)].concat(args));
  }
}

function _logError(msg) {
  if (logClient.logLevel <= LogLevel.ERROR) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key3 = 1; _key3 < _len2; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    logClient.error.apply(logClient, ["Auth (".concat(SDK_VERSION, "): ").concat(msg)].concat(args));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _fail(authOrCode) {
  for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++) {
    rest[_key4 - 1] = arguments[_key4];
  }

  throw createErrorInternal.apply(void 0, [authOrCode].concat(rest));
}

function _createError(authOrCode) {
  for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
    rest[_key5 - 1] = arguments[_key5];
  }

  return createErrorInternal.apply(void 0, [authOrCode].concat(rest));
}

function _errorWithCustomMessage(auth, code, message) {
  var errorMap = Object.assign(Object.assign({}, prodErrorMap()), _defineProperty$1({}, code, message));
  var factory = new ErrorFactory('auth', 'Firebase', errorMap);
  return factory.create(code, {
    appName: auth.name
  });
}

function _serverAppCurrentUserOperationNotSupportedError(auth) {
  return _errorWithCustomMessage(auth, "operation-not-supported-in-this-environment"
  /* AuthErrorCode.OPERATION_NOT_SUPPORTED */
  , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}

function _assertInstanceOf(auth, object, instance) {
  var constructorInstance = instance;

  if (!(object instanceof constructorInstance)) {
    if (constructorInstance.name !== object.constructor.name) {
      _fail(auth, "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
      );
    }

    throw _errorWithCustomMessage(auth, "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
    , "Type of ".concat(object.constructor.name, " does not match expected instance.") + "Did you pass a reference from a different Auth SDK?");
  }
}

function createErrorInternal(authOrCode) {
  for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key6 = 1; _key6 < _len5; _key6++) {
    rest[_key6 - 1] = arguments[_key6];
  }

  if (typeof authOrCode !== 'string') {
    var _authOrCode$_errorFac;

    var code = rest[0];

    var fullParams = _toConsumableArray(rest.slice(1));

    if (fullParams[0]) {
      fullParams[0].appName = authOrCode.name;
    }

    return (_authOrCode$_errorFac = authOrCode._errorFactory).create.apply(_authOrCode$_errorFac, [code].concat(_toConsumableArray(fullParams)));
  }

  return _DEFAULT_AUTH_ERROR_FACTORY.create.apply(_DEFAULT_AUTH_ERROR_FACTORY, [authOrCode].concat(rest));
}

function _assert(assertion, authOrCode) {
  if (!assertion) {
    for (var _len6 = arguments.length, rest = new Array(_len6 > 2 ? _len6 - 2 : 0), _key7 = 2; _key7 < _len6; _key7++) {
      rest[_key7 - 2] = arguments[_key7];
    }

    throw createErrorInternal.apply(void 0, [authOrCode].concat(rest));
  }
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */


function debugFail(failure) {
  // Log the failure in addition to throw an exception, just in case the
  // exception is swallowed.
  var message = "INTERNAL ASSERTION FAILED: " + failure;

  _logError(message); // NOTE: We don't use FirebaseError here because these are internal failures
  // that cannot be handled by the user. (Also it would create a circular
  // dependency between the error and assert modules which doesn't work.)


  throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */


function debugAssert(assertion, message) {
  if (!assertion) {
    debugFail(message);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getCurrentUrl() {
  var _a;

  return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}

function _isHttpOrHttps() {
  return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}

function _getCurrentScheme() {
  var _a;

  return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Determine whether the browser is working online
 */


function _isOnline() {
  if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && ( // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  _isHttpOrHttps() || isBrowserExtension() || 'connection' in navigator)) {
    return navigator.onLine;
  } // If we can't determine the state, assume it is online.


  return true;
}

function _getUserLanguage() {
  if (typeof navigator === 'undefined') {
    return null;
  }

  var navigatorLanguage = navigator;
  return (// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */


var Delay = /*#__PURE__*/function () {
  function Delay(shortDelay, longDelay) {
    _classCallCheck(this, Delay);

    this.shortDelay = shortDelay;
    this.longDelay = longDelay; // Internal error when improperly initialized.

    debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
    this.isMobile = isMobileCordova() || isReactNative();
  }

  _createClass(Delay, [{
    key: "get",
    value: function get() {
      if (!_isOnline()) {
        // Pick the shorter timeout.
        return Math.min(5000
        /* DelayMin.OFFLINE */
        , this.shortDelay);
      } // If running in a mobile environment, return the long delay, otherwise
      // return the short delay.
      // This could be improved in the future to dynamically change based on other
      // variables instead of just reading the current environment.


      return this.isMobile ? this.longDelay : this.shortDelay;
    }
  }]);

  return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _emulatorUrl(config, path) {
  debugAssert(config.emulator, 'Emulator should always be set here');
  var url = config.emulator.url;

  if (!path) {
    return url;
  }

  return "".concat(url).concat(path.startsWith('/') ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var FetchProvider = /*#__PURE__*/function () {
  function FetchProvider() {
    _classCallCheck(this, FetchProvider);
  }

  _createClass(FetchProvider, null, [{
    key: "initialize",
    value: function initialize(fetchImpl, headersImpl, responseImpl) {
      this.fetchImpl = fetchImpl;

      if (headersImpl) {
        this.headersImpl = headersImpl;
      }

      if (responseImpl) {
        this.responseImpl = responseImpl;
      }
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      if (this.fetchImpl) {
        return this.fetchImpl;
      }

      if (typeof self !== 'undefined' && 'fetch' in self) {
        return self.fetch;
      }

      if (typeof globalThis !== 'undefined' && globalThis.fetch) {
        return globalThis.fetch;
      }

      if (typeof fetch !== 'undefined') {
        return fetch;
      }

      debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    })
  }, {
    key: "headers",
    value: function headers() {
      if (this.headersImpl) {
        return this.headersImpl;
      }

      if (typeof self !== 'undefined' && 'Headers' in self) {
        return self.Headers;
      }

      if (typeof globalThis !== 'undefined' && globalThis.Headers) {
        return globalThis.Headers;
      }

      if (typeof Headers !== 'undefined') {
        return Headers;
      }

      debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
  }, {
    key: "response",
    value: function response() {
      if (this.responseImpl) {
        return this.responseImpl;
      }

      if (typeof self !== 'undefined' && 'Response' in self) {
        return self.Response;
      }

      if (typeof globalThis !== 'undefined' && globalThis.Response) {
        return globalThis.Response;
      }

      if (typeof Response !== 'undefined') {
        return Response;
      }

      debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
  }]);

  return FetchProvider;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Map from errors returned by the server to errors to developer visible errors
 */


var SERVER_ERROR_MAP = (_SERVER_ERROR_MAP = {}, _defineProperty$1(_SERVER_ERROR_MAP, "CREDENTIAL_MISMATCH"
/* ServerError.CREDENTIAL_MISMATCH */
, "custom-token-mismatch"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_CUSTOM_TOKEN"
/* ServerError.MISSING_CUSTOM_TOKEN */
, "internal-error"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_IDENTIFIER"
/* ServerError.INVALID_IDENTIFIER */
, "invalid-email"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_CONTINUE_URI"
/* ServerError.MISSING_CONTINUE_URI */
, "internal-error"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_PASSWORD"
/* ServerError.INVALID_PASSWORD */
, "wrong-password"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_PASSWORD"
/* ServerError.MISSING_PASSWORD */
, "missing-password"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_LOGIN_CREDENTIALS"
/* ServerError.INVALID_LOGIN_CREDENTIALS */
, "invalid-credential"), _defineProperty$1(_SERVER_ERROR_MAP, "EMAIL_EXISTS"
/* ServerError.EMAIL_EXISTS */
, "email-already-in-use"), _defineProperty$1(_SERVER_ERROR_MAP, "PASSWORD_LOGIN_DISABLED"
/* ServerError.PASSWORD_LOGIN_DISABLED */
, "operation-not-allowed"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_IDP_RESPONSE"
/* ServerError.INVALID_IDP_RESPONSE */
, "invalid-credential"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_PENDING_TOKEN"
/* ServerError.INVALID_PENDING_TOKEN */
, "invalid-credential"), _defineProperty$1(_SERVER_ERROR_MAP, "FEDERATED_USER_ID_ALREADY_LINKED"
/* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */
, "credential-already-in-use"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_REQ_TYPE"
/* ServerError.MISSING_REQ_TYPE */
, "internal-error"), _defineProperty$1(_SERVER_ERROR_MAP, "EMAIL_NOT_FOUND"
/* ServerError.EMAIL_NOT_FOUND */
, "user-not-found"), _defineProperty$1(_SERVER_ERROR_MAP, "RESET_PASSWORD_EXCEED_LIMIT"
/* ServerError.RESET_PASSWORD_EXCEED_LIMIT */
, "too-many-requests"), _defineProperty$1(_SERVER_ERROR_MAP, "EXPIRED_OOB_CODE"
/* ServerError.EXPIRED_OOB_CODE */
, "expired-action-code"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_OOB_CODE"
/* ServerError.INVALID_OOB_CODE */
, "invalid-action-code"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_OOB_CODE"
/* ServerError.MISSING_OOB_CODE */
, "internal-error"), _defineProperty$1(_SERVER_ERROR_MAP, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN"
/* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */
, "requires-recent-login"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_ID_TOKEN"
/* ServerError.INVALID_ID_TOKEN */
, "invalid-user-token"), _defineProperty$1(_SERVER_ERROR_MAP, "TOKEN_EXPIRED"
/* ServerError.TOKEN_EXPIRED */
, "user-token-expired"), _defineProperty$1(_SERVER_ERROR_MAP, "USER_NOT_FOUND"
/* ServerError.USER_NOT_FOUND */
, "user-token-expired"), _defineProperty$1(_SERVER_ERROR_MAP, "TOO_MANY_ATTEMPTS_TRY_LATER"
/* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */
, "too-many-requests"), _defineProperty$1(_SERVER_ERROR_MAP, "PASSWORD_DOES_NOT_MEET_REQUIREMENTS"
/* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */
, "password-does-not-meet-requirements"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_CODE"
/* ServerError.INVALID_CODE */
, "invalid-verification-code"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_SESSION_INFO"
/* ServerError.INVALID_SESSION_INFO */
, "invalid-verification-id"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_TEMPORARY_PROOF"
/* ServerError.INVALID_TEMPORARY_PROOF */
, "invalid-credential"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_SESSION_INFO"
/* ServerError.MISSING_SESSION_INFO */
, "missing-verification-id"), _defineProperty$1(_SERVER_ERROR_MAP, "SESSION_EXPIRED"
/* ServerError.SESSION_EXPIRED */
, "code-expired"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_ANDROID_PACKAGE_NAME"
/* ServerError.MISSING_ANDROID_PACKAGE_NAME */
, "missing-android-pkg-name"), _defineProperty$1(_SERVER_ERROR_MAP, "UNAUTHORIZED_DOMAIN"
/* ServerError.UNAUTHORIZED_DOMAIN */
, "unauthorized-continue-uri"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_OAUTH_CLIENT_ID"
/* ServerError.INVALID_OAUTH_CLIENT_ID */
, "invalid-oauth-client-id"), _defineProperty$1(_SERVER_ERROR_MAP, "ADMIN_ONLY_OPERATION"
/* ServerError.ADMIN_ONLY_OPERATION */
, "admin-restricted-operation"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_MFA_PENDING_CREDENTIAL"
/* ServerError.INVALID_MFA_PENDING_CREDENTIAL */
, "invalid-multi-factor-session"), _defineProperty$1(_SERVER_ERROR_MAP, "MFA_ENROLLMENT_NOT_FOUND"
/* ServerError.MFA_ENROLLMENT_NOT_FOUND */
, "multi-factor-info-not-found"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_MFA_ENROLLMENT_ID"
/* ServerError.MISSING_MFA_ENROLLMENT_ID */
, "missing-multi-factor-info"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_MFA_PENDING_CREDENTIAL"
/* ServerError.MISSING_MFA_PENDING_CREDENTIAL */
, "missing-multi-factor-session"), _defineProperty$1(_SERVER_ERROR_MAP, "SECOND_FACTOR_EXISTS"
/* ServerError.SECOND_FACTOR_EXISTS */
, "second-factor-already-in-use"), _defineProperty$1(_SERVER_ERROR_MAP, "SECOND_FACTOR_LIMIT_EXCEEDED"
/* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */
, "maximum-second-factor-count-exceeded"), _defineProperty$1(_SERVER_ERROR_MAP, "BLOCKING_FUNCTION_ERROR_RESPONSE"
/* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */
, "internal-error"), _defineProperty$1(_SERVER_ERROR_MAP, "RECAPTCHA_NOT_ENABLED"
/* ServerError.RECAPTCHA_NOT_ENABLED */
, "recaptcha-not-enabled"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_RECAPTCHA_TOKEN"
/* ServerError.MISSING_RECAPTCHA_TOKEN */
, "missing-recaptcha-token"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_TOKEN"
/* ServerError.INVALID_RECAPTCHA_TOKEN */
, "invalid-recaptcha-token"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_ACTION"
/* ServerError.INVALID_RECAPTCHA_ACTION */
, "invalid-recaptcha-action"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_CLIENT_TYPE"
/* ServerError.MISSING_CLIENT_TYPE */
, "missing-client-type"), _defineProperty$1(_SERVER_ERROR_MAP, "MISSING_RECAPTCHA_VERSION"
/* ServerError.MISSING_RECAPTCHA_VERSION */
, "missing-recaptcha-version"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_RECAPTCHA_VERSION"
/* ServerError.INVALID_RECAPTCHA_VERSION */
, "invalid-recaptcha-version"), _defineProperty$1(_SERVER_ERROR_MAP, "INVALID_REQ_TYPE"
/* ServerError.INVALID_REQ_TYPE */
, "invalid-req-type"), _SERVER_ERROR_MAP);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);

function _addTidIfNecessary(auth, request) {
  if (auth.tenantId && !request.tenantId) {
    return Object.assign(Object.assign({}, request), {
      tenantId: auth.tenantId
    });
  }

  return request;
}

function _performApiRequest(_x, _x2, _x3, _x4) {
  return _performApiRequest2.apply(this, arguments);
}

function _performApiRequest2() {
  _performApiRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee104(auth, method, path, request) {
    var customErrorMap,
        _args104 = arguments;
    return regenerator.wrap(function _callee104$(_context104) {
      while (1) {
        switch (_context104.prev = _context104.next) {
          case 0:
            customErrorMap = _args104.length > 4 && _args104[4] !== undefined ? _args104[4] : {};
            return _context104.abrupt("return", _performFetchWithErrorHandling(auth, customErrorMap, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee103() {
              var body, params, query, headers;
              return regenerator.wrap(function _callee103$(_context103) {
                while (1) {
                  switch (_context103.prev = _context103.next) {
                    case 0:
                      body = {};
                      params = {};

                      if (request) {
                        if (method === "GET"
                        /* HttpMethod.GET */
                        ) {
                          params = request;
                        } else {
                          body = {
                            body: JSON.stringify(request)
                          };
                        }
                      }

                      query = querystring(Object.assign({
                        key: auth.config.apiKey
                      }, params)).slice(1);
                      _context103.next = 6;
                      return auth._getAdditionalHeaders();

                    case 6:
                      headers = _context103.sent;
                      headers["Content-Type"
                      /* HttpHeader.CONTENT_TYPE */
                      ] = 'application/json';

                      if (auth.languageCode) {
                        headers["X-Firebase-Locale"
                        /* HttpHeader.X_FIREBASE_LOCALE */
                        ] = auth.languageCode;
                      }

                      return _context103.abrupt("return", FetchProvider.fetch()(_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                        method: method,
                        headers: headers,
                        referrerPolicy: 'no-referrer'
                      }, body)));

                    case 10:
                    case "end":
                      return _context103.stop();
                  }
                }
              }, _callee103);
            }))));

          case 2:
          case "end":
            return _context104.stop();
        }
      }
    }, _callee104);
  }));
  return _performApiRequest2.apply(this, arguments);
}

function _performFetchWithErrorHandling(_x5, _x6, _x7) {
  return _performFetchWithErrorHandling2.apply(this, arguments);
}

function _performFetchWithErrorHandling2() {
  _performFetchWithErrorHandling2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee105(auth, customErrorMap, fetchFn) {
    var errorMap, networkTimeout, response, json, errorMessage, _errorMessage$split, _errorMessage$split2, serverErrorCode, serverErrorMessage, authError;

    return regenerator.wrap(function _callee105$(_context105) {
      while (1) {
        switch (_context105.prev = _context105.next) {
          case 0:
            auth._canInitEmulator = false;
            errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
            _context105.prev = 2;
            networkTimeout = new NetworkTimeout(auth);
            _context105.next = 6;
            return Promise.race([fetchFn(), networkTimeout.promise]);

          case 6:
            response = _context105.sent;
            // If we've reached this point, the fetch succeeded and the networkTimeout
            // didn't throw; clear the network timeout delay so that Node won't hang
            networkTimeout.clearNetworkTimeout();
            _context105.next = 10;
            return response.json();

          case 10:
            json = _context105.sent;

            if (!('needConfirmation' in json)) {
              _context105.next = 13;
              break;
            }

            throw _makeTaggedError(auth, "account-exists-with-different-credential"
            /* AuthErrorCode.NEED_CONFIRMATION */
            , json);

          case 13:
            if (!(response.ok && !('errorMessage' in json))) {
              _context105.next = 17;
              break;
            }

            return _context105.abrupt("return", json);

          case 17:
            errorMessage = response.ok ? json.errorMessage : json.error.message;
            _errorMessage$split = errorMessage.split(' : '), _errorMessage$split2 = _slicedToArray(_errorMessage$split, 2), serverErrorCode = _errorMessage$split2[0], serverErrorMessage = _errorMessage$split2[1];

            if (!(serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED"
            /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */
            )) {
              _context105.next = 23;
              break;
            }

            throw _makeTaggedError(auth, "credential-already-in-use"
            /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */
            , json);

          case 23:
            if (!(serverErrorCode === "EMAIL_EXISTS"
            /* ServerError.EMAIL_EXISTS */
            )) {
              _context105.next = 27;
              break;
            }

            throw _makeTaggedError(auth, "email-already-in-use"
            /* AuthErrorCode.EMAIL_EXISTS */
            , json);

          case 27:
            if (!(serverErrorCode === "USER_DISABLED"
            /* ServerError.USER_DISABLED */
            )) {
              _context105.next = 29;
              break;
            }

            throw _makeTaggedError(auth, "user-disabled"
            /* AuthErrorCode.USER_DISABLED */
            , json);

          case 29:
            authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');

            if (!serverErrorMessage) {
              _context105.next = 34;
              break;
            }

            throw _errorWithCustomMessage(auth, authError, serverErrorMessage);

          case 34:
            _fail(auth, authError);

          case 35:
            _context105.next = 42;
            break;

          case 37:
            _context105.prev = 37;
            _context105.t0 = _context105["catch"](2);

            if (!(_context105.t0 instanceof FirebaseError)) {
              _context105.next = 41;
              break;
            }

            throw _context105.t0;

          case 41:
            // Changing this to a different error code will log user out when there is a network error
            // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
            // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
            _fail(auth, "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
            , {
              'message': String(_context105.t0)
            });

          case 42:
          case "end":
            return _context105.stop();
        }
      }
    }, _callee105, null, [[2, 37]]);
  }));
  return _performFetchWithErrorHandling2.apply(this, arguments);
}

function _performSignInRequest(_x8, _x9, _x10, _x11) {
  return _performSignInRequest2.apply(this, arguments);
}

function _performSignInRequest2() {
  _performSignInRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee106(auth, method, path, request) {
    var customErrorMap,
        serverResponse,
        _args106 = arguments;
    return regenerator.wrap(function _callee106$(_context106) {
      while (1) {
        switch (_context106.prev = _context106.next) {
          case 0:
            customErrorMap = _args106.length > 4 && _args106[4] !== undefined ? _args106[4] : {};
            _context106.next = 3;
            return _performApiRequest(auth, method, path, request, customErrorMap);

          case 3:
            serverResponse = _context106.sent;

            if ('mfaPendingCredential' in serverResponse) {
              _fail(auth, "multi-factor-auth-required"
              /* AuthErrorCode.MFA_REQUIRED */
              , {
                _serverResponse: serverResponse
              });
            }

            return _context106.abrupt("return", serverResponse);

          case 6:
          case "end":
            return _context106.stop();
        }
      }
    }, _callee106);
  }));
  return _performSignInRequest2.apply(this, arguments);
}

function _getFinalTarget(auth, host, path, query) {
  var base = "".concat(host).concat(path, "?").concat(query);

  if (!auth.config.emulator) {
    return "".concat(auth.config.apiScheme, "://").concat(base);
  }

  return _emulatorUrl(auth.config, base);
}

function _parseEnforcementState(enforcementStateStr) {
  switch (enforcementStateStr) {
    case 'ENFORCE':
      return "ENFORCE"
      /* EnforcementState.ENFORCE */
      ;

    case 'AUDIT':
      return "AUDIT"
      /* EnforcementState.AUDIT */
      ;

    case 'OFF':
      return "OFF"
      /* EnforcementState.OFF */
      ;

    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED"
      /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */
      ;
  }
}

var NetworkTimeout = /*#__PURE__*/function () {
  function NetworkTimeout(auth) {
    var _this = this;

    _classCallCheck(this, NetworkTimeout);

    this.auth = auth; // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    this.timer = null;
    this.promise = new Promise(function (_, reject) {
      _this.timer = setTimeout(function () {
        return reject(_createError(_this.auth, "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, DEFAULT_API_TIMEOUT_MS.get());
    });
  }

  _createClass(NetworkTimeout, [{
    key: "clearNetworkTimeout",
    value: function clearNetworkTimeout() {
      clearTimeout(this.timer);
    }
  }]);

  return NetworkTimeout;
}();

function _makeTaggedError(auth, code, response) {
  var errorParams = {
    appName: auth.name
  };

  if (response.email) {
    errorParams.email = response.email;
  }

  if (response.phoneNumber) {
    errorParams.phoneNumber = response.phoneNumber;
  }

  var error = _createError(auth, code, errorParams); // We know customData is defined on error because errorParams is defined


  error.customData._tokenResponse = response;
  return error;
}

function isEnterprise(grecaptcha) {
  return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}

var RecaptchaConfig = /*#__PURE__*/function () {
  function RecaptchaConfig(response) {
    _classCallCheck(this, RecaptchaConfig);

    /**
     * The reCAPTCHA site key.
     */
    this.siteKey = '';
    /**
     * The list of providers and their enablement status for reCAPTCHA Enterprise.
     */

    this.recaptchaEnforcementState = [];

    if (response.recaptchaKey === undefined) {
      throw new Error('recaptchaKey undefined');
    } // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"


    this.siteKey = response.recaptchaKey.split('/')[3];
    this.recaptchaEnforcementState = response.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */


  _createClass(RecaptchaConfig, [{
    key: "getProviderEnforcementState",
    value: function getProviderEnforcementState(providerStr) {
      if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) {
        return null;
      }

      var _iterator = _createForOfIteratorHelper$3(this.recaptchaEnforcementState),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var recaptchaEnforcementState = _step.value;

          if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) {
            return _parseEnforcementState(recaptchaEnforcementState.enforcementState);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */

  }, {
    key: "isProviderEnabled",
    value: function isProviderEnabled(providerStr) {
      return this.getProviderEnforcementState(providerStr) === "ENFORCE"
      /* EnforcementState.ENFORCE */
      || this.getProviderEnforcementState(providerStr) === "AUDIT"
      /* EnforcementState.AUDIT */
      ;
    }
  }]);

  return RecaptchaConfig;
}();

function getRecaptchaConfig(_x13, _x14) {
  return _getRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getRecaptchaConfig() {
  _getRecaptchaConfig = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee108(auth, request) {
    return regenerator.wrap(function _callee108$(_context108) {
      while (1) {
        switch (_context108.prev = _context108.next) {
          case 0:
            return _context108.abrupt("return", _performApiRequest(auth, "GET"
            /* HttpMethod.GET */
            , "/v2/recaptchaConfig"
            /* Endpoint.GET_RECAPTCHA_CONFIG */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context108.stop();
        }
      }
    }, _callee108);
  }));
  return _getRecaptchaConfig.apply(this, arguments);
}

function deleteAccount(_x15, _x16) {
  return _deleteAccount.apply(this, arguments);
}

function _deleteAccount() {
  _deleteAccount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee109(auth, request) {
    return regenerator.wrap(function _callee109$(_context109) {
      while (1) {
        switch (_context109.prev = _context109.next) {
          case 0:
            return _context109.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:delete"
            /* Endpoint.DELETE_ACCOUNT */
            , request));

          case 1:
          case "end":
            return _context109.stop();
        }
      }
    }, _callee109);
  }));
  return _deleteAccount.apply(this, arguments);
}

function getAccountInfo(_x19, _x20) {
  return _getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getAccountInfo() {
  _getAccountInfo = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee111(auth, request) {
    return regenerator.wrap(function _callee111$(_context111) {
      while (1) {
        switch (_context111.prev = _context111.next) {
          case 0:
            return _context111.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:lookup"
            /* Endpoint.GET_ACCOUNT_INFO */
            , request));

          case 1:
          case "end":
            return _context111.stop();
        }
      }
    }, _callee111);
  }));
  return _getAccountInfo.apply(this, arguments);
}

function utcTimestampToDateString(utcTimestamp) {
  if (!utcTimestamp) {
    return undefined;
  }

  try {
    // Convert to date object.
    var date = new Date(Number(utcTimestamp)); // Test date is valid.

    if (!isNaN(date.getTime())) {
      // Convert to UTC date string.
      return date.toUTCString();
    }
  } catch (e) {// Do nothing. undefined will be returned.
  }

  return undefined;
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */


function _getIdTokenResult2(_x21) {
  return _getIdTokenResult.apply(this, arguments);
}

function _getIdTokenResult() {
  _getIdTokenResult = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee112(user) {
    var forceRefresh,
        userInternal,
        token,
        claims,
        firebase,
        signInProvider,
        _args112 = arguments;
    return regenerator.wrap(function _callee112$(_context112) {
      while (1) {
        switch (_context112.prev = _context112.next) {
          case 0:
            forceRefresh = _args112.length > 1 && _args112[1] !== undefined ? _args112[1] : false;
            userInternal = getModularInstance(user);
            _context112.next = 4;
            return userInternal.getIdToken(forceRefresh);

          case 4:
            token = _context112.sent;
            claims = _parseToken(token);

            _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            firebase = _typeof(claims.firebase) === 'object' ? claims.firebase : undefined;
            signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
            return _context112.abrupt("return", {
              claims: claims,
              token: token,
              authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
              issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
              expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
              signInProvider: signInProvider || null,
              signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
            });

          case 10:
          case "end":
            return _context112.stop();
        }
      }
    }, _callee112);
  }));
  return _getIdTokenResult.apply(this, arguments);
}

function secondsStringToMilliseconds(seconds) {
  return Number(seconds) * 1000;
}

function _parseToken(token) {
  var _token$split = token.split('.'),
      _token$split2 = _slicedToArray(_token$split, 3),
      algorithm = _token$split2[0],
      payload = _token$split2[1],
      signature = _token$split2[2];

  if (algorithm === undefined || payload === undefined || signature === undefined) {
    _logError('JWT malformed, contained fewer than 3 sections');

    return null;
  }

  try {
    var decoded = base64Decode(payload);

    if (!decoded) {
      _logError('Failed to decode base64 JWT payload');

      return null;
    }

    return JSON.parse(decoded);
  } catch (e) {
    _logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());

    return null;
  }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */


function _tokenExpiresIn(token) {
  var parsedToken = _parseToken(token);

  _assert(parsedToken, "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
  );

  _assert(typeof parsedToken.exp !== 'undefined', "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
  );

  _assert(typeof parsedToken.iat !== 'undefined', "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
  );

  return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _logoutIfInvalidated(_x22, _x23) {
  return _logoutIfInvalidated2.apply(this, arguments);
}

function _logoutIfInvalidated2() {
  _logoutIfInvalidated2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee113(user, promise) {
    var bypassAuthState,
        _args113 = arguments;
    return regenerator.wrap(function _callee113$(_context113) {
      while (1) {
        switch (_context113.prev = _context113.next) {
          case 0:
            bypassAuthState = _args113.length > 2 && _args113[2] !== undefined ? _args113[2] : false;

            if (!bypassAuthState) {
              _context113.next = 3;
              break;
            }

            return _context113.abrupt("return", promise);

          case 3:
            _context113.prev = 3;
            _context113.next = 6;
            return promise;

          case 6:
            return _context113.abrupt("return", _context113.sent);

          case 9:
            _context113.prev = 9;
            _context113.t0 = _context113["catch"](3);

            if (!(_context113.t0 instanceof FirebaseError && isUserInvalidated(_context113.t0))) {
              _context113.next = 15;
              break;
            }

            if (!(user.auth.currentUser === user)) {
              _context113.next = 15;
              break;
            }

            _context113.next = 15;
            return user.auth.signOut();

          case 15:
            throw _context113.t0;

          case 16:
          case "end":
            return _context113.stop();
        }
      }
    }, _callee113, null, [[3, 9]]);
  }));
  return _logoutIfInvalidated2.apply(this, arguments);
}

function isUserInvalidated(_ref3) {
  var code = _ref3.code;
  return code === "auth/".concat("user-disabled"
  /* AuthErrorCode.USER_DISABLED */
  ) || code === "auth/".concat("user-token-expired"
  /* AuthErrorCode.TOKEN_EXPIRED */
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ProactiveRefresh = /*#__PURE__*/function () {
  function ProactiveRefresh(user) {
    _classCallCheck(this, ProactiveRefresh);

    this.user = user;
    this.isRunning = false; // Node timers and browser timers return fundamentally different types.
    // We don't actually care what the value is but TS won't accept unknown and
    // we can't cast properly in both environments.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    this.timerId = null;
    this.errorBackoff = 30000
    /* Duration.RETRY_BACKOFF_MIN */
    ;
  }

  _createClass(ProactiveRefresh, [{
    key: "_start",
    value: function _start() {
      if (this.isRunning) {
        return;
      }

      this.isRunning = true;
      this.schedule();
    }
  }, {
    key: "_stop",
    value: function _stop() {
      if (!this.isRunning) {
        return;
      }

      this.isRunning = false;

      if (this.timerId !== null) {
        clearTimeout(this.timerId);
      }
    }
  }, {
    key: "getInterval",
    value: function getInterval(wasError) {
      var _a;

      if (wasError) {
        var interval = this.errorBackoff;
        this.errorBackoff = Math.min(this.errorBackoff * 2, 960000
        /* Duration.RETRY_BACKOFF_MAX */
        );
        return interval;
      } else {
        // Reset the error backoff
        this.errorBackoff = 30000
        /* Duration.RETRY_BACKOFF_MIN */
        ;
        var expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;

        var _interval = expTime - Date.now() - 300000
        /* Duration.OFFSET */
        ;

        return Math.max(0, _interval);
      }
    }
  }, {
    key: "schedule",
    value: function schedule() {
      var _this2 = this;

      var wasError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isRunning) {
        // Just in case...
        return;
      }

      var interval = this.getInterval(wasError);
      this.timerId = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.iteration();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), interval);
    }
  }, {
    key: "iteration",
    value: function () {
      var _iteration = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.user.getIdToken(true);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                // Only retry on network errors
                if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.code) === "auth/".concat("network-request-failed"
                /* AuthErrorCode.NETWORK_REQUEST_FAILED */
                )) {
                  this.schedule(
                  /* wasError */
                  true);
                }

                return _context2.abrupt("return");

              case 9:
                this.schedule();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function iteration() {
        return _iteration.apply(this, arguments);
      }

      return iteration;
    }()
  }]);

  return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var UserMetadata = /*#__PURE__*/function () {
  function UserMetadata(createdAt, lastLoginAt) {
    _classCallCheck(this, UserMetadata);

    this.createdAt = createdAt;
    this.lastLoginAt = lastLoginAt;

    this._initializeTime();
  }

  _createClass(UserMetadata, [{
    key: "_initializeTime",
    value: function _initializeTime() {
      this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
      this.creationTime = utcTimestampToDateString(this.createdAt);
    }
  }, {
    key: "_copy",
    value: function _copy(metadata) {
      this.createdAt = metadata.createdAt;
      this.lastLoginAt = metadata.lastLoginAt;

      this._initializeTime();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        createdAt: this.createdAt,
        lastLoginAt: this.lastLoginAt
      };
    }
  }]);

  return UserMetadata;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reloadWithoutSaving(_x24) {
  return _reloadWithoutSaving2.apply(this, arguments);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */


function _reloadWithoutSaving2() {
  _reloadWithoutSaving2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee114(user) {
    var _a, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;

    return regenerator.wrap(function _callee114$(_context114) {
      while (1) {
        switch (_context114.prev = _context114.next) {
          case 0:
            auth = user.auth;
            _context114.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context114.sent;
            _context114.next = 6;
            return _logoutIfInvalidated(user, getAccountInfo(auth, {
              idToken: idToken
            }));

          case 6:
            response = _context114.sent;

            _assert(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            coreAccount = response.users[0];

            user._notifyReloadListener(coreAccount);

            newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? extractProviderData(coreAccount.providerUserInfo) : [];
            providerData = mergeProviderData(user.providerData, newProviderData); // Preserves the non-nonymous status of the stored user, even if no more
            // credentials (federated or email/password) are linked to the user. If
            // the user was previously anonymous, then use provider data to update.
            // On the other hand, if it was not anonymous before, it should never be
            // considered anonymous now.

            oldIsAnonymous = user.isAnonymous;
            newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
            isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
            updates = {
              uid: coreAccount.localId,
              displayName: coreAccount.displayName || null,
              photoURL: coreAccount.photoUrl || null,
              email: coreAccount.email || null,
              emailVerified: coreAccount.emailVerified || false,
              phoneNumber: coreAccount.phoneNumber || null,
              tenantId: coreAccount.tenantId || null,
              providerData: providerData,
              metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
              isAnonymous: isAnonymous
            };
            Object.assign(user, updates);

          case 17:
          case "end":
            return _context114.stop();
        }
      }
    }, _callee114);
  }));
  return _reloadWithoutSaving2.apply(this, arguments);
}

function _reload2(_x25) {
  return _reload.apply(this, arguments);
}

function _reload() {
  _reload = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee115(user) {
    var userInternal;
    return regenerator.wrap(function _callee115$(_context115) {
      while (1) {
        switch (_context115.prev = _context115.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context115.next = 3;
            return _reloadWithoutSaving(userInternal);

          case 3:
            _context115.next = 5;
            return userInternal.auth._persistUserIfCurrent(userInternal);

          case 5:
            userInternal.auth._notifyListenersIfCurrent(userInternal);

          case 6:
          case "end":
            return _context115.stop();
        }
      }
    }, _callee115);
  }));
  return _reload.apply(this, arguments);
}

function mergeProviderData(original, newData) {
  var deduped = original.filter(function (o) {
    return !newData.some(function (n) {
      return n.providerId === o.providerId;
    });
  });
  return [].concat(_toConsumableArray(deduped), _toConsumableArray(newData));
}

function extractProviderData(providers) {
  return providers.map(function (_a) {
    var providerId = _a.providerId,
        provider = __rest(_a, ["providerId"]);

    return {
      providerId: providerId,
      uid: provider.rawId || '',
      displayName: provider.displayName || null,
      email: provider.email || null,
      phoneNumber: provider.phoneNumber || null,
      photoURL: provider.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function requestStsToken(_x26, _x27) {
  return _requestStsToken.apply(this, arguments);
}

function _requestStsToken() {
  _requestStsToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee117(auth, refreshToken) {
    var response;
    return regenerator.wrap(function _callee117$(_context117) {
      while (1) {
        switch (_context117.prev = _context117.next) {
          case 0:
            _context117.next = 2;
            return _performFetchWithErrorHandling(auth, {}, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee116() {
              var body, _auth$config, tokenApiHost, apiKey, url, headers;

              return regenerator.wrap(function _callee116$(_context116) {
                while (1) {
                  switch (_context116.prev = _context116.next) {
                    case 0:
                      body = querystring({
                        'grant_type': 'refresh_token',
                        'refresh_token': refreshToken
                      }).slice(1);
                      _auth$config = auth.config, tokenApiHost = _auth$config.tokenApiHost, apiKey = _auth$config.apiKey;
                      url = _getFinalTarget(auth, tokenApiHost, "/v1/token"
                      /* Endpoint.TOKEN */
                      , "key=".concat(apiKey));
                      _context116.next = 5;
                      return auth._getAdditionalHeaders();

                    case 5:
                      headers = _context116.sent;
                      headers["Content-Type"
                      /* HttpHeader.CONTENT_TYPE */
                      ] = 'application/x-www-form-urlencoded';
                      return _context116.abrupt("return", FetchProvider.fetch()(url, {
                        method: "POST"
                        /* HttpMethod.POST */
                        ,
                        headers: headers,
                        body: body
                      }));

                    case 8:
                    case "end":
                      return _context116.stop();
                  }
                }
              }, _callee116);
            })));

          case 2:
            response = _context117.sent;
            return _context117.abrupt("return", {
              accessToken: response.access_token,
              expiresIn: response.expires_in,
              refreshToken: response.refresh_token
            });

          case 4:
          case "end":
            return _context117.stop();
        }
      }
    }, _callee117);
  }));
  return _requestStsToken.apply(this, arguments);
}

function revokeToken(_x28, _x29) {
  return _revokeToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */


function _revokeToken() {
  _revokeToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee118(auth, request) {
    return regenerator.wrap(function _callee118$(_context118) {
      while (1) {
        switch (_context118.prev = _context118.next) {
          case 0:
            return _context118.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v2/accounts:revokeToken"
            /* Endpoint.REVOKE_TOKEN */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context118.stop();
        }
      }
    }, _callee118);
  }));
  return _revokeToken.apply(this, arguments);
}

var StsTokenManager = /*#__PURE__*/function () {
  function StsTokenManager() {
    _classCallCheck(this, StsTokenManager);

    this.refreshToken = null;
    this.accessToken = null;
    this.expirationTime = null;
  }

  _createClass(StsTokenManager, [{
    key: "isExpired",
    get: function get() {
      return !this.expirationTime || Date.now() > this.expirationTime - 30000
      /* Buffer.TOKEN_REFRESH */
      ;
    }
  }, {
    key: "updateFromServerResponse",
    value: function updateFromServerResponse(response) {
      _assert(response.idToken, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      _assert(typeof response.idToken !== 'undefined', "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      _assert(typeof response.refreshToken !== 'undefined', "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      var expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : _tokenExpiresIn(response.idToken);
      this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
  }, {
    key: "updateFromIdToken",
    value: function updateFromIdToken(idToken) {
      _assert(idToken.length !== 0, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      var expiresIn = _tokenExpiresIn(idToken);

      this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
  }, {
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(auth) {
        var forceRefresh,
            _args3 = arguments;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                forceRefresh = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;

                if (!(!forceRefresh && this.accessToken && !this.isExpired)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", this.accessToken);

              case 3:
                _assert(this.refreshToken, auth, "user-token-expired"
                /* AuthErrorCode.TOKEN_EXPIRED */
                );

                if (!this.refreshToken) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 7;
                return this.refresh(auth, this.refreshToken);

              case 7:
                return _context3.abrupt("return", this.accessToken);

              case 8:
                return _context3.abrupt("return", null);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getToken(_x30) {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "clearRefreshToken",
    value: function clearRefreshToken() {
      this.refreshToken = null;
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(auth, oldToken) {
        var _yield$requestStsToke, accessToken, refreshToken, expiresIn;

        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return requestStsToken(auth, oldToken);

              case 2:
                _yield$requestStsToke = _context4.sent;
                accessToken = _yield$requestStsToke.accessToken;
                refreshToken = _yield$requestStsToke.refreshToken;
                expiresIn = _yield$requestStsToke.expiresIn;
                this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refresh(_x31, _x32) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "updateTokensAndExpiration",
    value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
      this.refreshToken = refreshToken || null;
      this.accessToken = accessToken || null;
      this.expirationTime = Date.now() + expiresInSec * 1000;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        refreshToken: this.refreshToken,
        accessToken: this.accessToken,
        expirationTime: this.expirationTime
      };
    }
  }, {
    key: "_assign",
    value: function _assign(stsTokenManager) {
      this.accessToken = stsTokenManager.accessToken;
      this.refreshToken = stsTokenManager.refreshToken;
      this.expirationTime = stsTokenManager.expirationTime;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      return Object.assign(new StsTokenManager(), this.toJSON());
    }
  }, {
    key: "_performRefresh",
    value: function _performRefresh() {
      return debugFail('not implemented');
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(appName, object) {
      var refreshToken = object.refreshToken,
          accessToken = object.accessToken,
          expirationTime = object.expirationTime;
      var manager = new StsTokenManager();

      if (refreshToken) {
        _assert(typeof refreshToken === 'string', "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        , {
          appName: appName
        });

        manager.refreshToken = refreshToken;
      }

      if (accessToken) {
        _assert(typeof accessToken === 'string', "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        , {
          appName: appName
        });

        manager.accessToken = accessToken;
      }

      if (expirationTime) {
        _assert(typeof expirationTime === 'number', "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        , {
          appName: appName
        });

        manager.expirationTime = expirationTime;
      }

      return manager;
    }
  }]);

  return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function assertStringOrUndefined(assertion, appName) {
  _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
  , {
    appName: appName
  });
}

var UserImpl = /*#__PURE__*/function () {
  function UserImpl(_a) {
    _classCallCheck(this, UserImpl);

    var uid = _a.uid,
        auth = _a.auth,
        stsTokenManager = _a.stsTokenManager,
        opt = __rest(_a, ["uid", "auth", "stsTokenManager"]); // For the user object, provider is always Firebase.


    this.providerId = "firebase"
    /* ProviderId.FIREBASE */
    ;
    this.proactiveRefresh = new ProactiveRefresh(this);
    this.reloadUserInfo = null;
    this.reloadListener = null;
    this.uid = uid;
    this.auth = auth;
    this.stsTokenManager = stsTokenManager;
    this.accessToken = stsTokenManager.accessToken;
    this.displayName = opt.displayName || null;
    this.email = opt.email || null;
    this.emailVerified = opt.emailVerified || false;
    this.phoneNumber = opt.phoneNumber || null;
    this.photoURL = opt.photoURL || null;
    this.isAnonymous = opt.isAnonymous || false;
    this.tenantId = opt.tenantId || null;
    this.providerData = opt.providerData ? _toConsumableArray(opt.providerData) : [];
    this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
  }

  _createClass(UserImpl, [{
    key: "getIdToken",
    value: function () {
      var _getIdToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(forceRefresh) {
        var accessToken;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));

              case 2:
                accessToken = _context5.sent;

                _assert(accessToken, this.auth, "internal-error"
                /* AuthErrorCode.INTERNAL_ERROR */
                );

                if (!(this.accessToken !== accessToken)) {
                  _context5.next = 9;
                  break;
                }

                this.accessToken = accessToken;
                _context5.next = 8;
                return this.auth._persistUserIfCurrent(this);

              case 8:
                this.auth._notifyListenersIfCurrent(this);

              case 9:
                return _context5.abrupt("return", accessToken);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getIdToken(_x33) {
        return _getIdToken.apply(this, arguments);
      }

      return getIdToken;
    }()
  }, {
    key: "getIdTokenResult",
    value: function getIdTokenResult(forceRefresh) {
      return _getIdTokenResult2(this, forceRefresh);
    }
  }, {
    key: "reload",
    value: function reload() {
      return _reload2(this);
    }
  }, {
    key: "_assign",
    value: function _assign(user) {
      if (this === user) {
        return;
      }

      _assert(this.uid === user.uid, this.auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      this.displayName = user.displayName;
      this.photoURL = user.photoURL;
      this.email = user.email;
      this.emailVerified = user.emailVerified;
      this.phoneNumber = user.phoneNumber;
      this.isAnonymous = user.isAnonymous;
      this.tenantId = user.tenantId;
      this.providerData = user.providerData.map(function (userInfo) {
        return Object.assign({}, userInfo);
      });

      this.metadata._copy(user.metadata);

      this.stsTokenManager._assign(user.stsTokenManager);
    }
  }, {
    key: "_clone",
    value: function _clone(auth) {
      var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
        auth: auth,
        stsTokenManager: this.stsTokenManager._clone()
      }));

      newUser.metadata._copy(this.metadata);

      return newUser;
    }
  }, {
    key: "_onReload",
    value: function _onReload(callback) {
      // There should only ever be one listener, and that is a single instance of MultiFactorUser
      _assert(!this.reloadListener, this.auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      this.reloadListener = callback;

      if (this.reloadUserInfo) {
        this._notifyReloadListener(this.reloadUserInfo);

        this.reloadUserInfo = null;
      }
    }
  }, {
    key: "_notifyReloadListener",
    value: function _notifyReloadListener(userInfo) {
      if (this.reloadListener) {
        this.reloadListener(userInfo);
      } else {
        // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
      }
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.proactiveRefresh._start();
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.proactiveRefresh._stop();
    }
  }, {
    key: "_updateTokensIfNecessary",
    value: function () {
      var _updateTokensIfNecessary2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(response) {
        var reload,
            tokensRefreshed,
            _args6 = arguments;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                reload = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                tokensRefreshed = false;

                if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
                  this.stsTokenManager.updateFromServerResponse(response);
                  tokensRefreshed = true;
                }

                if (!reload) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 6;
                return _reloadWithoutSaving(this);

              case 6:
                _context6.next = 8;
                return this.auth._persistUserIfCurrent(this);

              case 8:
                if (tokensRefreshed) {
                  this.auth._notifyListenersIfCurrent(this);
                }

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _updateTokensIfNecessary(_x34) {
        return _updateTokensIfNecessary2.apply(this, arguments);
      }

      return _updateTokensIfNecessary;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
        var idToken;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_isFirebaseServerApp(this.auth.app)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this.auth)));

              case 2:
                _context7.next = 4;
                return this.getIdToken();

              case 4:
                idToken = _context7.sent;
                _context7.next = 7;
                return _logoutIfInvalidated(this, deleteAccount(this.auth, {
                  idToken: idToken
                }));

              case 7:
                this.stsTokenManager.clearRefreshToken(); // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
                //       cancels pending actions...

                return _context7.abrupt("return", this.auth.signOut());

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.assign(Object.assign({
        uid: this.uid,
        email: this.email || undefined,
        emailVerified: this.emailVerified,
        displayName: this.displayName || undefined,
        isAnonymous: this.isAnonymous,
        photoURL: this.photoURL || undefined,
        phoneNumber: this.phoneNumber || undefined,
        tenantId: this.tenantId || undefined,
        providerData: this.providerData.map(function (userInfo) {
          return Object.assign({}, userInfo);
        }),
        stsTokenManager: this.stsTokenManager.toJSON(),
        // Redirect event ID must be maintained in case there is a pending
        // redirect event.
        _redirectEventId: this._redirectEventId
      }, this.metadata.toJSON()), {
        // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
        apiKey: this.auth.config.apiKey,
        appName: this.auth.name
      });
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this.stsTokenManager.refreshToken || '';
    }
  }], [{
    key: "_fromJSON",
    value: function _fromJSON(auth, object) {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      var displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
      var email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
      var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
      var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
      var tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;

      var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;

      var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
      var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
      var uid = object.uid,
          emailVerified = object.emailVerified,
          isAnonymous = object.isAnonymous,
          providerData = object.providerData,
          plainObjectTokenManager = object.stsTokenManager;

      _assert(uid && plainObjectTokenManager, auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      var stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);

      _assert(typeof uid === 'string', auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      assertStringOrUndefined(displayName, auth.name);
      assertStringOrUndefined(email, auth.name);

      _assert(typeof emailVerified === 'boolean', auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      _assert(typeof isAnonymous === 'boolean', auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      assertStringOrUndefined(phoneNumber, auth.name);
      assertStringOrUndefined(photoURL, auth.name);
      assertStringOrUndefined(tenantId, auth.name);
      assertStringOrUndefined(_redirectEventId, auth.name);
      assertStringOrUndefined(createdAt, auth.name);
      assertStringOrUndefined(lastLoginAt, auth.name);
      var user = new UserImpl({
        uid: uid,
        auth: auth,
        email: email,
        emailVerified: emailVerified,
        displayName: displayName,
        isAnonymous: isAnonymous,
        photoURL: photoURL,
        phoneNumber: phoneNumber,
        tenantId: tenantId,
        stsTokenManager: stsTokenManager,
        createdAt: createdAt,
        lastLoginAt: lastLoginAt
      });

      if (providerData && Array.isArray(providerData)) {
        user.providerData = providerData.map(function (userInfo) {
          return Object.assign({}, userInfo);
        });
      }

      if (_redirectEventId) {
        user._redirectEventId = _redirectEventId;
      }

      return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */

  }, {
    key: "_fromIdTokenResponse",
    value: function () {
      var _fromIdTokenResponse2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(auth, idTokenResponse) {
        var isAnonymous,
            stsTokenManager,
            user,
            _args8 = arguments;
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                isAnonymous = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : false;
                stsTokenManager = new StsTokenManager();
                stsTokenManager.updateFromServerResponse(idTokenResponse); // Initialize the Firebase Auth user.

                user = new UserImpl({
                  uid: idTokenResponse.localId,
                  auth: auth,
                  stsTokenManager: stsTokenManager,
                  isAnonymous: isAnonymous
                }); // Updates the user info and data and resolves with a user instance.

                _context8.next = 6;
                return _reloadWithoutSaving(user);

              case 6:
                return _context8.abrupt("return", user);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function _fromIdTokenResponse(_x35, _x36) {
        return _fromIdTokenResponse2.apply(this, arguments);
      }

      return _fromIdTokenResponse;
    }()
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */

  }, {
    key: "_fromGetAccountInfoResponse",
    value: function () {
      var _fromGetAccountInfoResponse2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(auth, response, idToken) {
        var coreAccount, providerData, isAnonymous, stsTokenManager, user, updates;
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                coreAccount = response.users[0];

                _assert(coreAccount.localId !== undefined, "internal-error"
                /* AuthErrorCode.INTERNAL_ERROR */
                );

                providerData = coreAccount.providerUserInfo !== undefined ? extractProviderData(coreAccount.providerUserInfo) : [];
                isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                stsTokenManager = new StsTokenManager();
                stsTokenManager.updateFromIdToken(idToken); // Initialize the Firebase Auth user.

                user = new UserImpl({
                  uid: coreAccount.localId,
                  auth: auth,
                  stsTokenManager: stsTokenManager,
                  isAnonymous: isAnonymous
                }); // update the user with data from the GetAccountInfo response.

                updates = {
                  uid: coreAccount.localId,
                  displayName: coreAccount.displayName || null,
                  photoURL: coreAccount.photoUrl || null,
                  email: coreAccount.email || null,
                  emailVerified: coreAccount.emailVerified || false,
                  phoneNumber: coreAccount.phoneNumber || null,
                  tenantId: coreAccount.tenantId || null,
                  providerData: providerData,
                  metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                  isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
                };
                Object.assign(user, updates);
                return _context9.abrupt("return", user);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function _fromGetAccountInfoResponse(_x37, _x38, _x39) {
        return _fromGetAccountInfoResponse2.apply(this, arguments);
      }

      return _fromGetAccountInfoResponse;
    }()
  }]);

  return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var instanceCache = new Map();

function _getInstance(cls) {
  debugAssert(cls instanceof Function, 'Expected a class definition');
  var instance = instanceCache.get(cls);

  if (instance) {
    debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
    return instance;
  }

  instance = new cls();
  instanceCache.set(cls, instance);
  return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var InMemoryPersistence = /*#__PURE__*/function () {
  function InMemoryPersistence() {
    _classCallCheck(this, InMemoryPersistence);

    this.type = "NONE"
    /* PersistenceType.NONE */
    ;
    this.storage = {};
  }

  _createClass(InMemoryPersistence, [{
    key: "_isAvailable",
    value: function () {
      var _isAvailable2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10() {
        return regenerator.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", true);

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function _isAvailable() {
        return _isAvailable2.apply(this, arguments);
      }

      return _isAvailable;
    }()
  }, {
    key: "_set",
    value: function () {
      var _set2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(key, value) {
        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.storage[key] = value;

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _set(_x40, _x41) {
        return _set2.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(key) {
        var value;
        return regenerator.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                value = this.storage[key];
                return _context12.abrupt("return", value === undefined ? null : value);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _get(_x42) {
        return _get2.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(key) {
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                delete this.storage[key];

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _remove(_x43) {
        return _remove2.apply(this, arguments);
      }

      return _remove;
    }()
  }, {
    key: "_addListener",
    value: function _addListener(_key, _listener) {
      // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
      return;
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(_key, _listener) {
      // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
      return;
    }
  }]);

  return InMemoryPersistence;
}();

InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */

var inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _persistenceKeyName(key, apiKey, appName) {
  return "firebase"
  /* Namespace.PERSISTENCE */
  .concat(":", key, ":").concat(apiKey, ":").concat(appName);
}

var PersistenceUserManager = /*#__PURE__*/function () {
  function PersistenceUserManager(persistence, auth, userKey) {
    _classCallCheck(this, PersistenceUserManager);

    this.persistence = persistence;
    this.auth = auth;
    this.userKey = userKey;
    var _this$auth = this.auth,
        config = _this$auth.config,
        name = _this$auth.name;
    this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
    this.fullPersistenceKey = _persistenceKeyName("persistence"
    /* KeyName.PERSISTENCE_USER */
    , config.apiKey, name);
    this.boundEventHandler = auth._onStorageEvent.bind(auth);

    this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }

  _createClass(PersistenceUserManager, [{
    key: "setCurrentUser",
    value: function setCurrentUser(user) {
      return this.persistence._set(this.fullUserKey, user.toJSON());
    }
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14() {
        var blob;
        return regenerator.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.persistence._get(this.fullUserKey);

              case 2:
                blob = _context14.sent;
                return _context14.abrupt("return", blob ? UserImpl._fromJSON(this.auth, blob) : null);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getCurrentUser() {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
  }, {
    key: "removeCurrentUser",
    value: function removeCurrentUser() {
      return this.persistence._remove(this.fullUserKey);
    }
  }, {
    key: "savePersistenceForRedirect",
    value: function savePersistenceForRedirect() {
      return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
  }, {
    key: "setPersistence",
    value: function () {
      var _setPersistence = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee15(newPersistence) {
        var currentUser;
        return regenerator.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(this.persistence === newPersistence)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                _context15.next = 4;
                return this.getCurrentUser();

              case 4:
                currentUser = _context15.sent;
                _context15.next = 7;
                return this.removeCurrentUser();

              case 7:
                this.persistence = newPersistence;

                if (!currentUser) {
                  _context15.next = 10;
                  break;
                }

                return _context15.abrupt("return", this.setCurrentUser(currentUser));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setPersistence(_x44) {
        return _setPersistence.apply(this, arguments);
      }

      return setPersistence;
    }()
  }, {
    key: "delete",
    value: function _delete() {
      this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee18(auth, persistenceHierarchy) {
        var userKey,
            availablePersistences,
            selectedPersistence,
            key,
            userToMigrate,
            _iterator2,
            _step2,
            persistence,
            blob,
            user,
            migrationHierarchy,
            _args18 = arguments;

        return regenerator.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                userKey = _args18.length > 2 && _args18[2] !== undefined ? _args18[2] : "authUser";

                if (persistenceHierarchy.length) {
                  _context18.next = 3;
                  break;
                }

                return _context18.abrupt("return", new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey));

              case 3:
                _context18.next = 5;
                return Promise.all(persistenceHierarchy.map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee16(persistence) {
                    return regenerator.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _context16.next = 2;
                            return persistence._isAvailable();

                          case 2:
                            if (!_context16.sent) {
                              _context16.next = 4;
                              break;
                            }

                            return _context16.abrupt("return", persistence);

                          case 4:
                            return _context16.abrupt("return", undefined);

                          case 5:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));

                  return function (_x47) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 5:
                availablePersistences = _context18.sent.filter(function (persistence) {
                  return persistence;
                });
                // Fall back to the first persistence listed, or in memory if none available
                selectedPersistence = availablePersistences[0] || _getInstance(inMemoryPersistence);
                key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name); // Pull out the existing user, setting the chosen persistence to that
                // persistence if the user exists.

                userToMigrate = null; // Note, here we check for a user in _all_ persistences, not just the
                // ones deemed available. If we can migrate a user out of a broken
                // persistence, we will (but only if that persistence supports migration).

                _iterator2 = _createForOfIteratorHelper$3(persistenceHierarchy);
                _context18.prev = 10;

                _iterator2.s();

              case 12:
                if ((_step2 = _iterator2.n()).done) {
                  _context18.next = 29;
                  break;
                }

                persistence = _step2.value;
                _context18.prev = 14;
                _context18.next = 17;
                return persistence._get(key);

              case 17:
                blob = _context18.sent;

                if (!blob) {
                  _context18.next = 23;
                  break;
                }

                user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)

                if (persistence !== selectedPersistence) {
                  userToMigrate = user;
                }

                selectedPersistence = persistence;
                return _context18.abrupt("break", 29);

              case 23:
                _context18.next = 27;
                break;

              case 25:
                _context18.prev = 25;
                _context18.t0 = _context18["catch"](14);

              case 27:
                _context18.next = 12;
                break;

              case 29:
                _context18.next = 34;
                break;

              case 31:
                _context18.prev = 31;
                _context18.t1 = _context18["catch"](10);

                _iterator2.e(_context18.t1);

              case 34:
                _context18.prev = 34;

                _iterator2.f();

                return _context18.finish(34);

              case 37:
                // If we find the user in a persistence that does support migration, use
                // that migration path (of only persistences that support migration)
                migrationHierarchy = availablePersistences.filter(function (p) {
                  return p._shouldAllowMigration;
                }); // If the persistence does _not_ allow migration, just finish off here

                if (!(!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length)) {
                  _context18.next = 40;
                  break;
                }

                return _context18.abrupt("return", new PersistenceUserManager(selectedPersistence, auth, userKey));

              case 40:
                selectedPersistence = migrationHierarchy[0];

                if (!userToMigrate) {
                  _context18.next = 44;
                  break;
                }

                _context18.next = 44;
                return selectedPersistence._set(key, userToMigrate.toJSON());

              case 44:
                _context18.next = 46;
                return Promise.all(persistenceHierarchy.map( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee17(persistence) {
                    return regenerator.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            if (!(persistence !== selectedPersistence)) {
                              _context17.next = 8;
                              break;
                            }

                            _context17.prev = 1;
                            _context17.next = 4;
                            return persistence._remove(key);

                          case 4:
                            _context17.next = 8;
                            break;

                          case 6:
                            _context17.prev = 6;
                            _context17.t0 = _context17["catch"](1);

                          case 8:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17, null, [[1, 6]]);
                  }));

                  return function (_x48) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 46:
                return _context18.abrupt("return", new PersistenceUserManager(selectedPersistence, auth, userKey));

              case 47:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[10, 31, 34, 37], [14, 25]]);
      }));

      function create(_x45, _x46) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Determine the browser for the purposes of reporting usage to the API
 */


function _getBrowserName(userAgent) {
  var ua = userAgent.toLowerCase();

  if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) {
    return "Opera"
    /* BrowserName.OPERA */
    ;
  } else if (_isIEMobile(ua)) {
    // Windows phone IEMobile browser.
    return "IEMobile"
    /* BrowserName.IEMOBILE */
    ;
  } else if (ua.includes('msie') || ua.includes('trident/')) {
    return "IE"
    /* BrowserName.IE */
    ;
  } else if (ua.includes('edge/')) {
    return "Edge"
    /* BrowserName.EDGE */
    ;
  } else if (_isFirefox(ua)) {
    return "Firefox"
    /* BrowserName.FIREFOX */
    ;
  } else if (ua.includes('silk/')) {
    return "Silk"
    /* BrowserName.SILK */
    ;
  } else if (_isBlackBerry(ua)) {
    // Blackberry browser.
    return "Blackberry"
    /* BrowserName.BLACKBERRY */
    ;
  } else if (_isWebOS(ua)) {
    // WebOS default browser.
    return "Webos"
    /* BrowserName.WEBOS */
    ;
  } else if (_isSafari(ua)) {
    return "Safari"
    /* BrowserName.SAFARI */
    ;
  } else if ((ua.includes('chrome/') || _isChromeIOS(ua)) && !ua.includes('edge/')) {
    return "Chrome"
    /* BrowserName.CHROME */
    ;
  } else if (_isAndroid(ua)) {
    // Android stock browser.
    return "Android"
    /* BrowserName.ANDROID */
    ;
  } else {
    // Most modern browsers have name/version at end of user agent string.
    var re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
    var matches = userAgent.match(re);

    if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) {
      return matches[1];
    }
  }

  return "Other"
  /* BrowserName.OTHER */
  ;
}

function _isFirefox() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /firefox\//i.test(ua);
}

function _isSafari() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  var ua = userAgent.toLowerCase();
  return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}

function _isChromeIOS() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /crios\//i.test(ua);
}

function _isIEMobile() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /iemobile/i.test(ua);
}

function _isAndroid() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /android/i.test(ua);
}

function _isBlackBerry() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /blackberry/i.test(ua);
}

function _isWebOS() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /webos/i.test(ua);
}

function _isIOS() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}

function _isIOSStandalone() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();

  var _a;

  return _isIOS(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}

function _isIE10() {
  return isIE() && document.documentMode === 10;
}

function _isMobileBrowser() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUA();
  // TODO: implement getBrowserName equivalent for OS.
  return _isIOS(ua) || _isAndroid(ua) || _isWebOS(ua) || _isBlackBerry(ua) || /windows phone/i.test(ua) || _isIEMobile(ua);
}

function _isIframe() {
  try {
    // Check that the current window is not the top window.
    // If so, return true.
    return !!(window && window !== window.top);
  } catch (e) {
    return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * Determine the SDK version string
 */


function _getClientVersion(clientPlatform) {
  var frameworks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reportedPlatform;

  switch (clientPlatform) {
    case "Browser"
    /* ClientPlatform.BROWSER */
    :
      // In a browser environment, report the browser name.
      reportedPlatform = _getBrowserName(getUA());
      break;

    case "Worker"
    /* ClientPlatform.WORKER */
    :
      // Technically a worker runs from a browser but we need to differentiate a
      // worker from a browser.
      // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
      reportedPlatform = "".concat(_getBrowserName(getUA()), "-").concat(clientPlatform);
      break;

    default:
      reportedPlatform = clientPlatform;
  }

  var reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web';
  /* default value if no other framework is used */

  return "".concat(reportedPlatform, "/", "JsCore"
  /* ClientImplementation.CORE */
  , "/").concat(SDK_VERSION, "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var AuthMiddlewareQueue = /*#__PURE__*/function () {
  function AuthMiddlewareQueue(auth) {
    _classCallCheck(this, AuthMiddlewareQueue);

    this.auth = auth;
    this.queue = [];
  }

  _createClass(AuthMiddlewareQueue, [{
    key: "pushCallback",
    value: function pushCallback(callback, onAbort) {
      var _this3 = this;

      // The callback could be sync or async. Wrap it into a
      // function that is always async.
      var wrappedCallback = function wrappedCallback(user) {
        return new Promise(function (resolve, reject) {
          try {
            var result = callback(user); // Either resolve with existing promise or wrap a non-promise
            // return value into a promise.

            resolve(result);
          } catch (e) {
            // Sync callback throws.
            reject(e);
          }
        });
      }; // Attach the onAbort if present


      wrappedCallback.onAbort = onAbort;
      this.queue.push(wrappedCallback);
      var index = this.queue.length - 1;
      return function () {
        // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
        // indexing of other elements.
        _this3.queue[index] = function () {
          return Promise.resolve();
        };
      };
    }
  }, {
    key: "runMiddleware",
    value: function () {
      var _runMiddleware = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee19(nextUser) {
        var onAbortStack, _iterator3, _step3, beforeStateCallback, _iterator4, _step4, onAbort;

        return regenerator.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(this.auth.currentUser === nextUser)) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt("return");

              case 2:
                // While running the middleware, build a temporary stack of onAbort
                // callbacks to call if one middleware callback rejects.
                onAbortStack = [];
                _context19.prev = 3;
                _iterator3 = _createForOfIteratorHelper$3(this.queue);
                _context19.prev = 5;

                _iterator3.s();

              case 7:
                if ((_step3 = _iterator3.n()).done) {
                  _context19.next = 14;
                  break;
                }

                beforeStateCallback = _step3.value;
                _context19.next = 11;
                return beforeStateCallback(nextUser);

              case 11:
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) {
                  onAbortStack.push(beforeStateCallback.onAbort);
                }

              case 12:
                _context19.next = 7;
                break;

              case 14:
                _context19.next = 19;
                break;

              case 16:
                _context19.prev = 16;
                _context19.t0 = _context19["catch"](5);

                _iterator3.e(_context19.t0);

              case 19:
                _context19.prev = 19;

                _iterator3.f();

                return _context19.finish(19);

              case 22:
                _context19.next = 30;
                break;

              case 24:
                _context19.prev = 24;
                _context19.t1 = _context19["catch"](3);
                // Run all onAbort, with separate try/catch to ignore any errors and
                // continue
                onAbortStack.reverse();
                _iterator4 = _createForOfIteratorHelper$3(onAbortStack);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    onAbort = _step4.value;

                    try {
                      onAbort();
                    } catch (_) {
                      /* swallow error */
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                throw this.auth._errorFactory.create("login-blocked"
                /* AuthErrorCode.LOGIN_BLOCKED */
                , {
                  originalMessage: _context19.t1 === null || _context19.t1 === void 0 ? void 0 : _context19.t1.message
                });

              case 30:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[3, 24], [5, 16, 19, 22]]);
      }));

      function runMiddleware(_x49) {
        return _runMiddleware.apply(this, arguments);
      }

      return runMiddleware;
    }()
  }]);

  return AuthMiddlewareQueue;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */


function _getPasswordPolicy(_x50) {
  return _getPasswordPolicy2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Minimum min password length enforced by the backend, even if no minimum length is set.


function _getPasswordPolicy2() {
  _getPasswordPolicy2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee119(auth) {
    var request,
        _args119 = arguments;
    return regenerator.wrap(function _callee119$(_context119) {
      while (1) {
        switch (_context119.prev = _context119.next) {
          case 0:
            request = _args119.length > 1 && _args119[1] !== undefined ? _args119[1] : {};
            return _context119.abrupt("return", _performApiRequest(auth, "GET"
            /* HttpMethod.GET */
            , "/v2/passwordPolicy"
            /* Endpoint.GET_PASSWORD_POLICY */
            , _addTidIfNecessary(auth, request)));

          case 2:
          case "end":
            return _context119.stop();
        }
      }
    }, _callee119);
  }));
  return _getPasswordPolicy2.apply(this, arguments);
}

var MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */

var PasswordPolicyImpl = /*#__PURE__*/function () {
  function PasswordPolicyImpl(response) {
    _classCallCheck(this, PasswordPolicyImpl);

    var _a, _b, _c, _d; // Only include custom strength options defined in the response.


    var responseOptions = response.customStrengthOptions;
    this.customStrengthOptions = {}; // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.

    this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : MINIMUM_MIN_PASSWORD_LENGTH;

    if (responseOptions.maxPasswordLength) {
      this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
    }

    if (responseOptions.containsLowercaseCharacter !== undefined) {
      this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
    }

    if (responseOptions.containsUppercaseCharacter !== undefined) {
      this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
    }

    if (responseOptions.containsNumericCharacter !== undefined) {
      this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
    }

    if (responseOptions.containsNonAlphanumericCharacter !== undefined) {
      this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
    }

    this.enforcementState = response.enforcementState;

    if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') {
      this.enforcementState = 'OFF';
    } // Use an empty string if no non-alphanumeric characters are specified in the response.


    this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
    this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
    this.schemaVersion = response.schemaVersion;
  }

  _createClass(PasswordPolicyImpl, [{
    key: "validatePassword",
    value: function validatePassword(password) {
      var _a, _b, _c, _d, _e, _f;

      var status = {
        isValid: true,
        passwordPolicy: this
      }; // Check the password length and character options.

      this.validatePasswordLengthOptions(password, status);
      this.validatePasswordCharacterOptions(password, status); // Combine the status into single isValid property.

      status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
      status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
      status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
      status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
      status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
      status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
      return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */

  }, {
    key: "validatePasswordLengthOptions",
    value: function validatePasswordLengthOptions(password, status) {
      var minPasswordLength = this.customStrengthOptions.minPasswordLength;
      var maxPasswordLength = this.customStrengthOptions.maxPasswordLength;

      if (minPasswordLength) {
        status.meetsMinPasswordLength = password.length >= minPasswordLength;
      }

      if (maxPasswordLength) {
        status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
      }
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */

  }, {
    key: "validatePasswordCharacterOptions",
    value: function validatePasswordCharacterOptions(password, status) {
      // Assign statuses for requirements even if the password is an empty string.
      this.updatePasswordCharacterOptionsStatuses(status,
      /* containsLowercaseCharacter= */
      false,
      /* containsUppercaseCharacter= */
      false,
      /* containsNumericCharacter= */
      false,
      /* containsNonAlphanumericCharacter= */
      false);
      var passwordChar;

      for (var i = 0; i < password.length; i++) {
        passwordChar = password.charAt(i);
        this.updatePasswordCharacterOptionsStatuses(status,
        /* containsLowercaseCharacter= */
        passwordChar >= 'a' && passwordChar <= 'z',
        /* containsUppercaseCharacter= */
        passwordChar >= 'A' && passwordChar <= 'Z',
        /* containsNumericCharacter= */
        passwordChar >= '0' && passwordChar <= '9',
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(passwordChar));
      }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */

  }, {
    key: "updatePasswordCharacterOptionsStatuses",
    value: function updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
      if (this.customStrengthOptions.containsLowercaseLetter) {
        status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
      }

      if (this.customStrengthOptions.containsUppercaseLetter) {
        status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
      }

      if (this.customStrengthOptions.containsNumericCharacter) {
        status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
      }

      if (this.customStrengthOptions.containsNonAlphanumericCharacter) {
        status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
      }
    }
  }]);

  return PasswordPolicyImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var AuthImpl = /*#__PURE__*/function () {
  function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
    _classCallCheck(this, AuthImpl);

    this.app = app;
    this.heartbeatServiceProvider = heartbeatServiceProvider;
    this.appCheckServiceProvider = appCheckServiceProvider;
    this.config = config;
    this.currentUser = null;
    this.emulatorConfig = null;
    this.operations = Promise.resolve();
    this.authStateSubscription = new Subscription(this);
    this.idTokenSubscription = new Subscription(this);
    this.beforeStateQueue = new AuthMiddlewareQueue(this);
    this.redirectUser = null;
    this.isProactiveRefreshEnabled = false;
    this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1; // Any network calls will set this to true and prevent subsequent emulator
    // initialization

    this._canInitEmulator = true;
    this._isInitialized = false;
    this._deleted = false;
    this._initializationPromise = null;
    this._popupRedirectResolver = null;
    this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
    this._agentRecaptchaConfig = null;
    this._tenantRecaptchaConfigs = {};
    this._projectPasswordPolicy = null;
    this._tenantPasswordPolicies = {}; // Tracks the last notified UID for state change listeners to prevent
    // repeated calls to the callbacks. Undefined means it's never been
    // called, whereas null means it's been called with a signed out user

    this.lastNotifiedUid = undefined;
    this.languageCode = null;
    this.tenantId = null;
    this.settings = {
      appVerificationDisabledForTesting: false
    };
    this.frameworks = [];
    this.name = app.name;
    this.clientVersion = config.sdkClientVersion;
  }

  _createClass(AuthImpl, [{
    key: "_initializeWithPersistence",
    value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
      var _this4 = this;

      if (popupRedirectResolver) {
        this._popupRedirectResolver = _getInstance(popupRedirectResolver);
      } // Have to check for app deletion throughout initialization (after each
      // promise resolution)


      this._initializationPromise = this.queue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee20() {
        var _a, _b;

        return regenerator.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!_this4._deleted) {
                  _context20.next = 2;
                  break;
                }

                return _context20.abrupt("return");

              case 2:
                _context20.next = 4;
                return PersistenceUserManager.create(_this4, persistenceHierarchy);

              case 4:
                _this4.persistenceManager = _context20.sent;

                if (!_this4._deleted) {
                  _context20.next = 7;
                  break;
                }

                return _context20.abrupt("return");

              case 7:
                if (!((_a = _this4._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively)) {
                  _context20.next = 15;
                  break;
                }

                _context20.prev = 8;
                _context20.next = 11;
                return _this4._popupRedirectResolver._initialize(_this4);

              case 11:
                _context20.next = 15;
                break;

              case 13:
                _context20.prev = 13;
                _context20.t0 = _context20["catch"](8);

              case 15:
                _context20.next = 17;
                return _this4.initializeCurrentUser(popupRedirectResolver);

              case 17:
                _this4.lastNotifiedUid = ((_b = _this4.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;

                if (!_this4._deleted) {
                  _context20.next = 20;
                  break;
                }

                return _context20.abrupt("return");

              case 20:
                _this4._isInitialized = true;

              case 21:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[8, 13]]);
      })));
      return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */

  }, {
    key: "_onStorageEvent",
    value: function () {
      var _onStorageEvent2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee21() {
        var user;
        return regenerator.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!this._deleted) {
                  _context21.next = 2;
                  break;
                }

                return _context21.abrupt("return");

              case 2:
                _context21.next = 4;
                return this.assertedPersistence.getCurrentUser();

              case 4:
                user = _context21.sent;

                if (!(!this.currentUser && !user)) {
                  _context21.next = 7;
                  break;
                }

                return _context21.abrupt("return");

              case 7:
                if (!(this.currentUser && user && this.currentUser.uid === user.uid)) {
                  _context21.next = 12;
                  break;
                }

                // Data update, simply copy data changes.
                this._currentUser._assign(user); // If tokens changed from previous user tokens, this will trigger
                // notifyAuthListeners_.


                _context21.next = 11;
                return this.currentUser.getIdToken();

              case 11:
                return _context21.abrupt("return");

              case 12:
                _context21.next = 14;
                return this._updateCurrentUser(user,
                /* skipBeforeStateCallbacks */
                true);

              case 14:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function _onStorageEvent() {
        return _onStorageEvent2.apply(this, arguments);
      }

      return _onStorageEvent;
    }()
  }, {
    key: "initializeCurrentUserFromIdToken",
    value: function () {
      var _initializeCurrentUserFromIdToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee22(idToken) {
        var response, user;
        return regenerator.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return getAccountInfo(this, {
                  idToken: idToken
                });

              case 3:
                response = _context22.sent;
                _context22.next = 6;
                return UserImpl._fromGetAccountInfoResponse(this, response, idToken);

              case 6:
                user = _context22.sent;
                _context22.next = 9;
                return this.directlySetCurrentUser(user);

              case 9:
                _context22.next = 16;
                break;

              case 11:
                _context22.prev = 11;
                _context22.t0 = _context22["catch"](0);
                console.warn('FirebaseServerApp could not login user with provided authIdToken: ', _context22.t0);
                _context22.next = 16;
                return this.directlySetCurrentUser(null);

              case 16:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 11]]);
      }));

      function initializeCurrentUserFromIdToken(_x51) {
        return _initializeCurrentUserFromIdToken.apply(this, arguments);
      }

      return initializeCurrentUserFromIdToken;
    }()
  }, {
    key: "initializeCurrentUser",
    value: function () {
      var _initializeCurrentUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee23(popupRedirectResolver) {
        var _this5 = this;

        var _a, idToken, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result;

        return regenerator.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!_isFirebaseServerApp(this.app)) {
                  _context23.next = 7;
                  break;
                }

                idToken = this.app.settings.authIdToken;

                if (!idToken) {
                  _context23.next = 6;
                  break;
                }

                return _context23.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    return _this5.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve);
                  });
                }));

              case 6:
                return _context23.abrupt("return", this.directlySetCurrentUser(null));

              case 7:
                _context23.next = 9;
                return this.assertedPersistence.getCurrentUser();

              case 9:
                previouslyStoredUser = _context23.sent;
                futureCurrentUser = previouslyStoredUser;
                needsTocheckMiddleware = false;

                if (!(popupRedirectResolver && this.config.authDomain)) {
                  _context23.next = 21;
                  break;
                }

                _context23.next = 15;
                return this.getOrInitRedirectPersistenceManager();

              case 15:
                redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                _context23.next = 19;
                return this.tryRedirectSignIn(popupRedirectResolver);

              case 19:
                result = _context23.sent;

                // If the stored user (i.e. the old "currentUser") has a redirectId that
                // matches the redirect user, then we want to initially sign in with the
                // new user object from result.
                // TODO(samgho): More thoroughly test all of this
                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                  futureCurrentUser = result.user;
                  needsTocheckMiddleware = true;
                }

              case 21:
                if (futureCurrentUser) {
                  _context23.next = 23;
                  break;
                }

                return _context23.abrupt("return", this.directlySetCurrentUser(null));

              case 23:
                if (futureCurrentUser._redirectEventId) {
                  _context23.next = 39;
                  break;
                }

                if (!needsTocheckMiddleware) {
                  _context23.next = 34;
                  break;
                }

                _context23.prev = 25;
                _context23.next = 28;
                return this.beforeStateQueue.runMiddleware(futureCurrentUser);

              case 28:
                _context23.next = 34;
                break;

              case 30:
                _context23.prev = 30;
                _context23.t0 = _context23["catch"](25);
                futureCurrentUser = previouslyStoredUser; // We know this is available since the bit is only set when the
                // resolver is available

                this._popupRedirectResolver._overrideRedirectResult(this, function () {
                  return Promise.reject(_context23.t0);
                });

              case 34:
                if (!futureCurrentUser) {
                  _context23.next = 38;
                  break;
                }

                return _context23.abrupt("return", this.reloadAndSetCurrentUserOrClear(futureCurrentUser));

              case 38:
                return _context23.abrupt("return", this.directlySetCurrentUser(null));

              case 39:
                _assert(this._popupRedirectResolver, this, "argument-error"
                /* AuthErrorCode.ARGUMENT_ERROR */
                );

                _context23.next = 42;
                return this.getOrInitRedirectPersistenceManager();

              case 42:
                if (!(this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId)) {
                  _context23.next = 44;
                  break;
                }

                return _context23.abrupt("return", this.directlySetCurrentUser(futureCurrentUser));

              case 44:
                return _context23.abrupt("return", this.reloadAndSetCurrentUserOrClear(futureCurrentUser));

              case 45:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[25, 30]]);
      }));

      function initializeCurrentUser(_x52) {
        return _initializeCurrentUser.apply(this, arguments);
      }

      return initializeCurrentUser;
    }()
  }, {
    key: "tryRedirectSignIn",
    value: function () {
      var _tryRedirectSignIn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee24(redirectResolver) {
        var result;
        return regenerator.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                // The redirect user needs to be checked (and signed in if available)
                // during auth initialization. All of the normal sign in and link/reauth
                // flows call back into auth and push things onto the promise queue. We
                // need to await the result of the redirect sign in *inside the promise
                // queue*. This presents a problem: we run into deadlock. See:
                //    ┌> [Initialization] ─────┐
                //    ┌> [<other queue tasks>] │
                //    └─ [getRedirectResult] <─┘
                //    where [] are tasks on the queue and arrows denote awaits
                // Initialization will never complete because it's waiting on something
                // that's waiting for initialization to complete!
                //
                // Instead, this method calls getRedirectResult() (stored in
                // _completeRedirectFn) with an optional parameter that instructs all of
                // the underlying auth operations to skip anything that mutates auth state.
                result = null;
                _context24.prev = 1;
                _context24.next = 4;
                return this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);

              case 4:
                result = _context24.sent;
                _context24.next = 11;
                break;

              case 7:
                _context24.prev = 7;
                _context24.t0 = _context24["catch"](1);
                _context24.next = 11;
                return this._setRedirectUser(null);

              case 11:
                return _context24.abrupt("return", result);

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[1, 7]]);
      }));

      function tryRedirectSignIn(_x53) {
        return _tryRedirectSignIn.apply(this, arguments);
      }

      return tryRedirectSignIn;
    }()
  }, {
    key: "reloadAndSetCurrentUserOrClear",
    value: function () {
      var _reloadAndSetCurrentUserOrClear = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee25(user) {
        return regenerator.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;
                _context25.next = 3;
                return _reloadWithoutSaving(user);

              case 3:
                _context25.next = 9;
                break;

              case 5:
                _context25.prev = 5;
                _context25.t0 = _context25["catch"](0);

                if (!((_context25.t0 === null || _context25.t0 === void 0 ? void 0 : _context25.t0.code) !== "auth/".concat("network-request-failed"
                /* AuthErrorCode.NETWORK_REQUEST_FAILED */
                ))) {
                  _context25.next = 9;
                  break;
                }

                return _context25.abrupt("return", this.directlySetCurrentUser(null));

              case 9:
                return _context25.abrupt("return", this.directlySetCurrentUser(user));

              case 10:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[0, 5]]);
      }));

      function reloadAndSetCurrentUserOrClear(_x54) {
        return _reloadAndSetCurrentUserOrClear.apply(this, arguments);
      }

      return reloadAndSetCurrentUserOrClear;
    }()
  }, {
    key: "useDeviceLanguage",
    value: function useDeviceLanguage() {
      this.languageCode = _getUserLanguage();
    }
  }, {
    key: "_delete",
    value: function () {
      var _delete3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee26() {
        return regenerator.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this._deleted = true;

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function _delete() {
        return _delete3.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "updateCurrentUser",
    value: function () {
      var _updateCurrentUser2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee27(userExtern) {
        var user;
        return regenerator.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!_isFirebaseServerApp(this.app)) {
                  _context27.next = 2;
                  break;
                }

                return _context27.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this)));

              case 2:
                // The public updateCurrentUser method needs to make a copy of the user,
                // and also check that the project matches
                user = userExtern ? getModularInstance(userExtern) : null;

                if (user) {
                  _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token"
                  /* AuthErrorCode.INVALID_AUTH */
                  );
                }

                return _context27.abrupt("return", this._updateCurrentUser(user && user._clone(this)));

              case 5:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function updateCurrentUser(_x55) {
        return _updateCurrentUser2.apply(this, arguments);
      }

      return updateCurrentUser;
    }()
  }, {
    key: "_updateCurrentUser",
    value: function () {
      var _updateCurrentUser3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee29(user) {
        var _this6 = this;

        var skipBeforeStateCallbacks,
            _args29 = arguments;
        return regenerator.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                skipBeforeStateCallbacks = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : false;

                if (!this._deleted) {
                  _context29.next = 3;
                  break;
                }

                return _context29.abrupt("return");

              case 3:
                if (user) {
                  _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch"
                  /* AuthErrorCode.TENANT_ID_MISMATCH */
                  );
                }

                if (skipBeforeStateCallbacks) {
                  _context29.next = 7;
                  break;
                }

                _context29.next = 7;
                return this.beforeStateQueue.runMiddleware(user);

              case 7:
                return _context29.abrupt("return", this.queue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee28() {
                  return regenerator.wrap(function _callee28$(_context28) {
                    while (1) {
                      switch (_context28.prev = _context28.next) {
                        case 0:
                          _context28.next = 2;
                          return _this6.directlySetCurrentUser(user);

                        case 2:
                          _this6.notifyAuthListeners();

                        case 3:
                        case "end":
                          return _context28.stop();
                      }
                    }
                  }, _callee28);
                }))));

              case 8:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function _updateCurrentUser(_x56) {
        return _updateCurrentUser3.apply(this, arguments);
      }

      return _updateCurrentUser;
    }()
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee30() {
        return regenerator.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                if (!_isFirebaseServerApp(this.app)) {
                  _context30.next = 2;
                  break;
                }

                return _context30.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this)));

              case 2:
                _context30.next = 4;
                return this.beforeStateQueue.runMiddleware(null);

              case 4:
                if (!(this.redirectPersistenceManager || this._popupRedirectResolver)) {
                  _context30.next = 7;
                  break;
                }

                _context30.next = 7;
                return this._setRedirectUser(null);

              case 7:
                return _context30.abrupt("return", this._updateCurrentUser(null,
                /* skipBeforeStateCallbacks */
                true));

              case 8:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function signOut() {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "setPersistence",
    value: function setPersistence(persistence) {
      var _this7 = this;

      if (_isFirebaseServerApp(this.app)) {
        return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
      }

      return this.queue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee31() {
        return regenerator.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return _this7.assertedPersistence.setPersistence(_getInstance(persistence));

              case 2:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      })));
    }
  }, {
    key: "_getRecaptchaConfig",
    value: function _getRecaptchaConfig() {
      if (this.tenantId == null) {
        return this._agentRecaptchaConfig;
      } else {
        return this._tenantRecaptchaConfigs[this.tenantId];
      }
    }
  }, {
    key: "validatePassword",
    value: function () {
      var _validatePassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee32(password) {
        var passwordPolicy;
        return regenerator.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (this._getPasswordPolicyInternal()) {
                  _context32.next = 3;
                  break;
                }

                _context32.next = 3;
                return this._updatePasswordPolicy();

              case 3:
                // Password policy will be defined after fetching.
                passwordPolicy = this._getPasswordPolicyInternal(); // Check that the policy schema version is supported by the SDK.
                // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.

                if (!(passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION)) {
                  _context32.next = 6;
                  break;
                }

                return _context32.abrupt("return", Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version"
                /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */
                , {})));

              case 6:
                return _context32.abrupt("return", passwordPolicy.validatePassword(password));

              case 7:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function validatePassword(_x57) {
        return _validatePassword.apply(this, arguments);
      }

      return validatePassword;
    }()
  }, {
    key: "_getPasswordPolicyInternal",
    value: function _getPasswordPolicyInternal() {
      if (this.tenantId === null) {
        return this._projectPasswordPolicy;
      } else {
        return this._tenantPasswordPolicies[this.tenantId];
      }
    }
  }, {
    key: "_updatePasswordPolicy",
    value: function () {
      var _updatePasswordPolicy2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee33() {
        var response, passwordPolicy;
        return regenerator.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return _getPasswordPolicy(this);

              case 2:
                response = _context33.sent;
                passwordPolicy = new PasswordPolicyImpl(response);

                if (this.tenantId === null) {
                  this._projectPasswordPolicy = passwordPolicy;
                } else {
                  this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
                }

              case 5:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function _updatePasswordPolicy() {
        return _updatePasswordPolicy2.apply(this, arguments);
      }

      return _updatePasswordPolicy;
    }()
  }, {
    key: "_getPersistence",
    value: function _getPersistence() {
      return this.assertedPersistence.persistence.type;
    }
  }, {
    key: "_updateErrorMap",
    value: function _updateErrorMap(errorMap) {
      this._errorFactory = new ErrorFactory('auth', 'Firebase', errorMap());
    }
  }, {
    key: "onAuthStateChanged",
    value: function onAuthStateChanged(nextOrObserver, error, completed) {
      return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
  }, {
    key: "beforeAuthStateChanged",
    value: function beforeAuthStateChanged(callback, onAbort) {
      return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
  }, {
    key: "onIdTokenChanged",
    value: function onIdTokenChanged(nextOrObserver, error, completed) {
      return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
  }, {
    key: "authStateReady",
    value: function authStateReady() {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        if (_this8.currentUser) {
          resolve();
        } else {
          var unsubscribe = _this8.onAuthStateChanged(function () {
            unsubscribe();
            resolve();
          }, reject);
        }
      });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */

  }, {
    key: "revokeAccessToken",
    value: function () {
      var _revokeAccessToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee34(token) {
        var idToken, request;
        return regenerator.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                if (!this.currentUser) {
                  _context34.next = 8;
                  break;
                }

                _context34.next = 3;
                return this.currentUser.getIdToken();

              case 3:
                idToken = _context34.sent;
                // Generalize this to accept other providers once supported.
                request = {
                  providerId: 'apple.com',
                  tokenType: "ACCESS_TOKEN"
                  /* TokenType.ACCESS_TOKEN */
                  ,
                  token: token,
                  idToken: idToken
                };

                if (this.tenantId != null) {
                  request.tenantId = this.tenantId;
                }

                _context34.next = 8;
                return revokeToken(this, request);

              case 8:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function revokeAccessToken(_x58) {
        return _revokeAccessToken.apply(this, arguments);
      }

      return revokeAccessToken;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _a;

      return {
        apiKey: this.config.apiKey,
        authDomain: this.config.authDomain,
        appName: this.name,
        currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
      };
    }
  }, {
    key: "_setRedirectUser",
    value: function () {
      var _setRedirectUser2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee35(user, popupRedirectResolver) {
        var redirectManager;
        return regenerator.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.getOrInitRedirectPersistenceManager(popupRedirectResolver);

              case 2:
                redirectManager = _context35.sent;
                return _context35.abrupt("return", user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user));

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function _setRedirectUser(_x59, _x60) {
        return _setRedirectUser2.apply(this, arguments);
      }

      return _setRedirectUser;
    }()
  }, {
    key: "getOrInitRedirectPersistenceManager",
    value: function () {
      var _getOrInitRedirectPersistenceManager = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee36(popupRedirectResolver) {
        var resolver;
        return regenerator.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                if (this.redirectPersistenceManager) {
                  _context36.next = 9;
                  break;
                }

                resolver = popupRedirectResolver && _getInstance(popupRedirectResolver) || this._popupRedirectResolver;

                _assert(resolver, this, "argument-error"
                /* AuthErrorCode.ARGUMENT_ERROR */
                );

                _context36.next = 5;
                return PersistenceUserManager.create(this, [_getInstance(resolver._redirectPersistence)], "redirectUser"
                /* KeyName.REDIRECT_USER */
                );

              case 5:
                this.redirectPersistenceManager = _context36.sent;
                _context36.next = 8;
                return this.redirectPersistenceManager.getCurrentUser();

              case 8:
                this.redirectUser = _context36.sent;

              case 9:
                return _context36.abrupt("return", this.redirectPersistenceManager);

              case 10:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function getOrInitRedirectPersistenceManager(_x61) {
        return _getOrInitRedirectPersistenceManager.apply(this, arguments);
      }

      return getOrInitRedirectPersistenceManager;
    }()
  }, {
    key: "_redirectUserForId",
    value: function () {
      var _redirectUserForId2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee38(id) {
        var _a, _b;

        return regenerator.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!this._isInitialized) {
                  _context38.next = 3;
                  break;
                }

                _context38.next = 3;
                return this.queue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee37() {
                  return regenerator.wrap(function _callee37$(_context37) {
                    while (1) {
                      switch (_context37.prev = _context37.next) {
                        case 0:
                        case "end":
                          return _context37.stop();
                      }
                    }
                  }, _callee37);
                })));

              case 3:
                if (!(((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id)) {
                  _context38.next = 5;
                  break;
                }

                return _context38.abrupt("return", this._currentUser);

              case 5:
                if (!(((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id)) {
                  _context38.next = 7;
                  break;
                }

                return _context38.abrupt("return", this.redirectUser);

              case 7:
                return _context38.abrupt("return", null);

              case 8:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function _redirectUserForId(_x62) {
        return _redirectUserForId2.apply(this, arguments);
      }

      return _redirectUserForId;
    }()
  }, {
    key: "_persistUserIfCurrent",
    value: function () {
      var _persistUserIfCurrent2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee40(user) {
        var _this9 = this;

        return regenerator.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!(user === this.currentUser)) {
                  _context40.next = 2;
                  break;
                }

                return _context40.abrupt("return", this.queue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee39() {
                  return regenerator.wrap(function _callee39$(_context39) {
                    while (1) {
                      switch (_context39.prev = _context39.next) {
                        case 0:
                          return _context39.abrupt("return", _this9.directlySetCurrentUser(user));

                        case 1:
                        case "end":
                          return _context39.stop();
                      }
                    }
                  }, _callee39);
                }))));

              case 2:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function _persistUserIfCurrent(_x63) {
        return _persistUserIfCurrent2.apply(this, arguments);
      }

      return _persistUserIfCurrent;
    }()
    /** Notifies listeners only if the user is current */

  }, {
    key: "_notifyListenersIfCurrent",
    value: function _notifyListenersIfCurrent(user) {
      if (user === this.currentUser) {
        this.notifyAuthListeners();
      }
    }
  }, {
    key: "_key",
    value: function _key() {
      return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.isProactiveRefreshEnabled = true;

      if (this.currentUser) {
        this._currentUser._startProactiveRefresh();
      }
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.isProactiveRefreshEnabled = false;

      if (this.currentUser) {
        this._currentUser._stopProactiveRefresh();
      }
    }
    /** Returns the current user cast as the internal type */

  }, {
    key: "_currentUser",
    get: function get() {
      return this.currentUser;
    }
  }, {
    key: "notifyAuthListeners",
    value: function notifyAuthListeners() {
      var _a, _b;

      if (!this._isInitialized) {
        return;
      }

      this.idTokenSubscription.next(this.currentUser);
      var currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;

      if (this.lastNotifiedUid !== currentUid) {
        this.lastNotifiedUid = currentUid;
        this.authStateSubscription.next(this.currentUser);
      }
    }
  }, {
    key: "registerStateListener",
    value: function registerStateListener(subscription, nextOrObserver, error, completed) {
      var _this10 = this;

      if (this._deleted) {
        return function () {};
      }

      var cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
      var isUnsubscribed = false;
      var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;

      _assert(promise, this, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      ); // The callback needs to be called asynchronously per the spec.
      // eslint-disable-next-line @typescript-eslint/no-floating-promises


      promise.then(function () {
        if (isUnsubscribed) {
          return;
        }

        cb(_this10.currentUser);
      });

      if (typeof nextOrObserver === 'function') {
        var unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
        return function () {
          isUnsubscribed = true;
          unsubscribe();
        };
      } else {
        var _unsubscribe = subscription.addObserver(nextOrObserver);

        return function () {
          isUnsubscribed = true;

          _unsubscribe();
        };
      }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */

  }, {
    key: "directlySetCurrentUser",
    value: function () {
      var _directlySetCurrentUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee41(user) {
        return regenerator.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (this.currentUser && this.currentUser !== user) {
                  this._currentUser._stopProactiveRefresh();
                }

                if (user && this.isProactiveRefreshEnabled) {
                  user._startProactiveRefresh();
                }

                this.currentUser = user;

                if (!user) {
                  _context41.next = 8;
                  break;
                }

                _context41.next = 6;
                return this.assertedPersistence.setCurrentUser(user);

              case 6:
                _context41.next = 10;
                break;

              case 8:
                _context41.next = 10;
                return this.assertedPersistence.removeCurrentUser();

              case 10:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function directlySetCurrentUser(_x64) {
        return _directlySetCurrentUser.apply(this, arguments);
      }

      return directlySetCurrentUser;
    }()
  }, {
    key: "queue",
    value: function queue(action) {
      // In case something errors, the callback still should be called in order
      // to keep the promise chain alive
      this.operations = this.operations.then(action, action);
      return this.operations;
    }
  }, {
    key: "assertedPersistence",
    get: function get() {
      _assert(this.persistenceManager, this, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      return this.persistenceManager;
    }
  }, {
    key: "_logFramework",
    value: function _logFramework(framework) {
      if (!framework || this.frameworks.includes(framework)) {
        return;
      }

      this.frameworks.push(framework); // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
      // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.

      this.frameworks.sort();
      this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
  }, {
    key: "_getFrameworks",
    value: function _getFrameworks() {
      return this.frameworks;
    }
  }, {
    key: "_getAdditionalHeaders",
    value: function () {
      var _getAdditionalHeaders2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee42() {
        var _a, headers, heartbeatsHeader, appCheckToken;

        return regenerator.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                // Additional headers on every request
                headers = _defineProperty$1({}, "X-Client-Version"
                /* HttpHeader.X_CLIENT_VERSION */
                , this.clientVersion);

                if (this.app.options.appId) {
                  headers["X-Firebase-gmpid"
                  /* HttpHeader.X_FIREBASE_GMPID */
                  ] = this.app.options.appId;
                } // If the heartbeat service exists, add the heartbeat string


                _context42.next = 4;
                return (_a = this.heartbeatServiceProvider.getImmediate({
                  optional: true
                })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader();

              case 4:
                heartbeatsHeader = _context42.sent;

                if (heartbeatsHeader) {
                  headers["X-Firebase-Client"
                  /* HttpHeader.X_FIREBASE_CLIENT */
                  ] = heartbeatsHeader;
                } // If the App Check service exists, add the App Check token in the headers


                _context42.next = 8;
                return this._getAppCheckToken();

              case 8:
                appCheckToken = _context42.sent;

                if (appCheckToken) {
                  headers["X-Firebase-AppCheck"
                  /* HttpHeader.X_FIREBASE_APP_CHECK */
                  ] = appCheckToken;
                }

                return _context42.abrupt("return", headers);

              case 11:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function _getAdditionalHeaders() {
        return _getAdditionalHeaders2.apply(this, arguments);
      }

      return _getAdditionalHeaders;
    }()
  }, {
    key: "_getAppCheckToken",
    value: function () {
      var _getAppCheckToken2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee43() {
        var _a, appCheckTokenResult;

        return regenerator.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return (_a = this.appCheckServiceProvider.getImmediate({
                  optional: true
                })) === null || _a === void 0 ? void 0 : _a.getToken();

              case 2:
                appCheckTokenResult = _context43.sent;

                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) {
                  // Context: appCheck.getToken() will never throw even if an error happened.
                  // In the error case, a dummy token will be returned along with an error field describing
                  // the error. In general, we shouldn't care about the error condition and just use
                  // the token (actual or dummy) to send requests.
                  _logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                }

                return _context43.abrupt("return", appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token);

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function _getAppCheckToken() {
        return _getAppCheckToken2.apply(this, arguments);
      }

      return _getAppCheckToken;
    }()
  }]);

  return AuthImpl;
}();
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */


function _castAuth(auth) {
  return getModularInstance(auth);
}
/** Helper class to wrap subscriber logic */


var Subscription = /*#__PURE__*/function () {
  function Subscription(auth) {
    var _this11 = this;

    _classCallCheck(this, Subscription);

    this.auth = auth;
    this.observer = null;
    this.addObserver = createSubscribe(function (observer) {
      return _this11.observer = observer;
    });
  }

  _createClass(Subscription, [{
    key: "next",
    get: function get() {
      _assert(this.observer, this.auth, "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
      );

      return this.observer.next.bind(this.observer);
    }
  }]);

  return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var externalJSProvider = {
  loadJS: function loadJS() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee44() {
      return regenerator.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              throw new Error('Unable to load external scripts');

            case 1:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44);
    }))();
  },
  recaptchaV2Script: '',
  recaptchaEnterpriseScript: '',
  gapiScript: ''
};

function _setExternalJSProvider(p) {
  externalJSProvider = p;
}

function _loadJS(url) {
  return externalJSProvider.loadJS(url);
}

function _recaptchaEnterpriseScriptUrl() {
  return externalJSProvider.recaptchaEnterpriseScript;
}

function _gapiScriptUrl() {
  return externalJSProvider.gapiScript;
}

function _generateCallbackName(prefix) {
  return "__".concat(prefix).concat(Math.floor(Math.random() * 1000000));
}
/* eslint-disable @typescript-eslint/no-require-imports */


var RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
var FAKE_TOKEN = 'NO_RECAPTCHA';

var RecaptchaEnterpriseVerifier = /*#__PURE__*/function () {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  function RecaptchaEnterpriseVerifier(authExtern) {
    _classCallCheck(this, RecaptchaEnterpriseVerifier);

    /**
     * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
     */
    this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
    this.auth = _castAuth(authExtern);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */


  _createClass(RecaptchaEnterpriseVerifier, [{
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee47() {
        var _this12 = this;

        var action,
            forceRefresh,
            retrieveSiteKey,
            _retrieveSiteKey,
            retrieveRecaptchaToken,
            _args47 = arguments;

        return regenerator.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                retrieveRecaptchaToken = function _retrieveRecaptchaTok(siteKey, resolve, reject) {
                  var grecaptcha = window.grecaptcha;

                  if (isEnterprise(grecaptcha)) {
                    grecaptcha.enterprise.ready(function () {
                      grecaptcha.enterprise.execute(siteKey, {
                        action: action
                      }).then(function (token) {
                        resolve(token);
                      })["catch"](function () {
                        resolve(FAKE_TOKEN);
                      });
                    });
                  } else {
                    reject(Error('No reCAPTCHA enterprise script loaded.'));
                  }
                };

                _retrieveSiteKey = function _retrieveSiteKey3() {
                  _retrieveSiteKey = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee46(auth) {
                    return regenerator.wrap(function _callee46$(_context46) {
                      while (1) {
                        switch (_context46.prev = _context46.next) {
                          case 0:
                            if (forceRefresh) {
                              _context46.next = 5;
                              break;
                            }

                            if (!(auth.tenantId == null && auth._agentRecaptchaConfig != null)) {
                              _context46.next = 3;
                              break;
                            }

                            return _context46.abrupt("return", auth._agentRecaptchaConfig.siteKey);

                          case 3:
                            if (!(auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined)) {
                              _context46.next = 5;
                              break;
                            }

                            return _context46.abrupt("return", auth._tenantRecaptchaConfigs[auth.tenantId].siteKey);

                          case 5:
                            return _context46.abrupt("return", new Promise( /*#__PURE__*/function () {
                              var _ref12 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee45(resolve, reject) {
                                return regenerator.wrap(function _callee45$(_context45) {
                                  while (1) {
                                    switch (_context45.prev = _context45.next) {
                                      case 0:
                                        getRecaptchaConfig(auth, {
                                          clientType: "CLIENT_TYPE_WEB"
                                          /* RecaptchaClientType.WEB */
                                          ,
                                          version: "RECAPTCHA_ENTERPRISE"
                                          /* RecaptchaVersion.ENTERPRISE */

                                        }).then(function (response) {
                                          if (response.recaptchaKey === undefined) {
                                            reject(new Error('recaptcha Enterprise site key undefined'));
                                          } else {
                                            var config = new RecaptchaConfig(response);

                                            if (auth.tenantId == null) {
                                              auth._agentRecaptchaConfig = config;
                                            } else {
                                              auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                            }

                                            return resolve(config.siteKey);
                                          }
                                        })["catch"](function (error) {
                                          reject(error);
                                        });

                                      case 1:
                                      case "end":
                                        return _context45.stop();
                                    }
                                  }
                                }, _callee45);
                              }));

                              return function (_x66, _x67) {
                                return _ref12.apply(this, arguments);
                              };
                            }()));

                          case 6:
                          case "end":
                            return _context46.stop();
                        }
                      }
                    }, _callee46);
                  }));
                  return _retrieveSiteKey.apply(this, arguments);
                };

                retrieveSiteKey = function _retrieveSiteKey2(_x65) {
                  return _retrieveSiteKey.apply(this, arguments);
                };

                action = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : 'verify';
                forceRefresh = _args47.length > 1 && _args47[1] !== undefined ? _args47[1] : false;
                return _context47.abrupt("return", new Promise(function (resolve, reject) {
                  retrieveSiteKey(_this12.auth).then(function (siteKey) {
                    if (!forceRefresh && isEnterprise(window.grecaptcha)) {
                      retrieveRecaptchaToken(siteKey, resolve, reject);
                    } else {
                      if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                      }

                      var url = _recaptchaEnterpriseScriptUrl();

                      if (url.length !== 0) {
                        url += siteKey;
                      }

                      _loadJS(url).then(function () {
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                      })["catch"](function (error) {
                        reject(error);
                      });
                    }
                  })["catch"](function (error) {
                    reject(error);
                  });
                }));

              case 6:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47);
      }));

      function verify() {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return RecaptchaEnterpriseVerifier;
}();

function injectRecaptchaFields(_x68, _x69, _x70) {
  return _injectRecaptchaFields.apply(this, arguments);
}

function _injectRecaptchaFields() {
  _injectRecaptchaFields = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee120(auth, request, action) {
    var captchaResp,
        verifier,
        captchaResponse,
        newRequest,
        _args120 = arguments;
    return regenerator.wrap(function _callee120$(_context120) {
      while (1) {
        switch (_context120.prev = _context120.next) {
          case 0:
            captchaResp = _args120.length > 3 && _args120[3] !== undefined ? _args120[3] : false;
            verifier = new RecaptchaEnterpriseVerifier(auth);
            _context120.prev = 2;
            _context120.next = 5;
            return verifier.verify(action);

          case 5:
            captchaResponse = _context120.sent;
            _context120.next = 13;
            break;

          case 8:
            _context120.prev = 8;
            _context120.t0 = _context120["catch"](2);
            _context120.next = 12;
            return verifier.verify(action, true);

          case 12:
            captchaResponse = _context120.sent;

          case 13:
            newRequest = Object.assign({}, request);

            if (!captchaResp) {
              Object.assign(newRequest, {
                captchaResponse: captchaResponse
              });
            } else {
              Object.assign(newRequest, {
                'captchaResp': captchaResponse
              });
            }

            Object.assign(newRequest, {
              'clientType': "CLIENT_TYPE_WEB"
              /* RecaptchaClientType.WEB */

            });
            Object.assign(newRequest, {
              'recaptchaVersion': "RECAPTCHA_ENTERPRISE"
              /* RecaptchaVersion.ENTERPRISE */

            });
            return _context120.abrupt("return", newRequest);

          case 18:
          case "end":
            return _context120.stop();
        }
      }
    }, _callee120, null, [[2, 8]]);
  }));
  return _injectRecaptchaFields.apply(this, arguments);
}

function handleRecaptchaFlow(_x71, _x72, _x73, _x74) {
  return _handleRecaptchaFlow.apply(this, arguments);
}

function _handleRecaptchaFlow() {
  _handleRecaptchaFlow = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee122(authInstance, request, actionName, actionMethod) {
    var _a, requestWithRecaptcha;

    return regenerator.wrap(function _callee122$(_context122) {
      while (1) {
        switch (_context122.prev = _context122.next) {
          case 0:
            if (!((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER"
            /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */
            ))) {
              _context122.next = 7;
              break;
            }

            _context122.next = 3;
            return injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode"
            /* RecaptchaActionName.GET_OOB_CODE */
            );

          case 3:
            requestWithRecaptcha = _context122.sent;
            return _context122.abrupt("return", actionMethod(authInstance, requestWithRecaptcha));

          case 7:
            return _context122.abrupt("return", actionMethod(authInstance, request)["catch"]( /*#__PURE__*/function () {
              var _ref42 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee121(error) {
                var _requestWithRecaptcha;

                return regenerator.wrap(function _callee121$(_context121) {
                  while (1) {
                    switch (_context121.prev = _context121.next) {
                      case 0:
                        if (!(error.code === "auth/".concat("missing-recaptcha-token"
                        /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */
                        ))) {
                          _context121.next = 8;
                          break;
                        }

                        console.log("".concat(actionName, " is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow."));
                        _context121.next = 4;
                        return injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode"
                        /* RecaptchaActionName.GET_OOB_CODE */
                        );

                      case 4:
                        _requestWithRecaptcha = _context121.sent;
                        return _context121.abrupt("return", actionMethod(authInstance, _requestWithRecaptcha));

                      case 8:
                        return _context121.abrupt("return", Promise.reject(error));

                      case 9:
                      case "end":
                        return _context121.stop();
                    }
                  }
                }, _callee121);
              }));

              return function (_x289) {
                return _ref42.apply(this, arguments);
              };
            }()));

          case 8:
          case "end":
            return _context122.stop();
        }
      }
    }, _callee122);
  }));
  return _handleRecaptchaFlow.apply(this, arguments);
}

function initializeAuth(app, deps) {
  var provider = _getProvider(app, 'auth');

  if (provider.isInitialized()) {
    var _auth2 = provider.getImmediate();

    var initialOptions = provider.getOptions();

    if (deepEqual(initialOptions, deps !== null && deps !== void 0 ? deps : {})) {
      return _auth2;
    } else {
      _fail(_auth2, "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
      );
    }
  }

  var auth = provider.initialize({
    options: deps
  });
  return auth;
}

function _initializeAuthInstance(auth, deps) {
  var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
  var hierarchy = (Array.isArray(persistence) ? persistence : [persistence]).map(_getInstance);

  if (deps === null || deps === void 0 ? void 0 : deps.errorMap) {
    auth._updateErrorMap(deps.errorMap);
  } // This promise is intended to float; auth initialization happens in the
  // background, meanwhile the auth object may be used by the app.
  // eslint-disable-next-line @typescript-eslint/no-floating-promises


  auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */


function connectAuthEmulator(auth, url, options) {
  var authInternal = _castAuth(auth);

  _assert(authInternal._canInitEmulator, authInternal, "emulator-config-failed"
  /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
  );

  _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme"
  /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );

  var disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
  var protocol = extractProtocol(url);

  var _extractHostAndPort = extractHostAndPort(url),
      host = _extractHostAndPort.host,
      port = _extractHostAndPort.port;

  var portStr = port === null ? '' : ":".concat(port); // Always replace path with "/" (even if input url had no path at all, or had a different one).

  authInternal.config.emulator = {
    url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
  };
  authInternal.settings.appVerificationDisabledForTesting = true;
  authInternal.emulatorConfig = Object.freeze({
    host: host,
    port: port,
    protocol: protocol.replace(':', ''),
    options: Object.freeze({
      disableWarnings: disableWarnings
    })
  });

  if (!disableWarnings) {
    emitEmulatorWarning();
  }
}

function extractProtocol(url) {
  var protocolEnd = url.indexOf(':');
  return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}

function extractHostAndPort(url) {
  var protocol = extractProtocol(url);
  var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.

  if (!authority) {
    return {
      host: '',
      port: null
    };
  }

  var hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".

  var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);

  if (bracketedIPv6) {
    var host = bracketedIPv6[1];
    return {
      host: host,
      port: parsePort(hostAndPort.substr(host.length + 1))
    };
  } else {
    var _hostAndPort$split = hostAndPort.split(':'),
        _hostAndPort$split2 = _slicedToArray(_hostAndPort$split, 2),
        _host = _hostAndPort$split2[0],
        port = _hostAndPort$split2[1];

    return {
      host: _host,
      port: parsePort(port)
    };
  }
}

function parsePort(portStr) {
  if (!portStr) {
    return null;
  }

  var port = Number(portStr);

  if (isNaN(port)) {
    return null;
  }

  return port;
}

function emitEmulatorWarning() {
  function attachBanner() {
    var el = document.createElement('p');
    var sty = el.style;
    el.innerText = 'Running in emulator mode. Do not use with production credentials.';
    sty.position = 'fixed';
    sty.width = '100%';
    sty.backgroundColor = '#ffffff';
    sty.border = '.1em solid #000000';
    sty.color = '#b50000';
    sty.bottom = '0px';
    sty.left = '0px';
    sty.margin = '0px';
    sty.zIndex = '10000';
    sty.textAlign = 'center';
    el.classList.add('firebase-emulator-warning');
    document.body.appendChild(el);
  }

  if (typeof console !== 'undefined' && typeof console.info === 'function') {
    console.info('WARNING: You are using the Auth Emulator,' + ' which is intended for local testing only.  Do not use with' + ' production credentials.');
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', attachBanner);
    } else {
      attachBanner();
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */


var AuthCredential = /*#__PURE__*/function () {
  /** @internal */
  function AuthCredential(
  /**
   * The authentication provider ID for the credential.
   *
   * @remarks
   * For example, 'facebook.com', or 'google.com'.
   */
  providerId,
  /**
   * The authentication sign in method for the credential.
   *
   * @remarks
   * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
   * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
   * identifier as returned in {@link fetchSignInMethodsForEmail}.
   */
  signInMethod) {
    _classCallCheck(this, AuthCredential);

    this.providerId = providerId;
    this.signInMethod = signInMethod;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */


  _createClass(AuthCredential, [{
    key: "toJSON",
    value: function toJSON() {
      return debugFail('not implemented');
    }
    /** @internal */

  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(_auth) {
      return debugFail('not implemented');
    }
    /** @internal */

  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(_auth, _idToken) {
      return debugFail('not implemented');
    }
    /** @internal */

  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(_auth) {
      return debugFail('not implemented');
    }
  }]);

  return AuthCredential;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function resetPassword(_x76, _x77) {
  return _resetPassword.apply(this, arguments);
}

function _resetPassword() {
  _resetPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee124(auth, request) {
    return regenerator.wrap(function _callee124$(_context124) {
      while (1) {
        switch (_context124.prev = _context124.next) {
          case 0:
            return _context124.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:resetPassword"
            /* Endpoint.RESET_PASSWORD */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context124.stop();
        }
      }
    }, _callee124);
  }));
  return _resetPassword.apply(this, arguments);
}

function updateEmailPassword(_x78, _x79) {
  return _updateEmailPassword.apply(this, arguments);
} // Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.


function _updateEmailPassword() {
  _updateEmailPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee125(auth, request) {
    return regenerator.wrap(function _callee125$(_context125) {
      while (1) {
        switch (_context125.prev = _context125.next) {
          case 0:
            return _context125.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:update"
            /* Endpoint.SET_ACCOUNT_INFO */
            , request));

          case 1:
          case "end":
            return _context125.stop();
        }
      }
    }, _callee125);
  }));
  return _updateEmailPassword.apply(this, arguments);
}

function linkEmailPassword(_x80, _x81) {
  return _linkEmailPassword.apply(this, arguments);
}

function _linkEmailPassword() {
  _linkEmailPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee126(auth, request) {
    return regenerator.wrap(function _callee126$(_context126) {
      while (1) {
        switch (_context126.prev = _context126.next) {
          case 0:
            return _context126.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signUp"
            /* Endpoint.SIGN_UP */
            , request));

          case 1:
          case "end":
            return _context126.stop();
        }
      }
    }, _callee126);
  }));
  return _linkEmailPassword.apply(this, arguments);
}

function applyActionCode$1(_x82, _x83) {
  return _applyActionCode$.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _applyActionCode$() {
  _applyActionCode$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee127(auth, request) {
    return regenerator.wrap(function _callee127$(_context127) {
      while (1) {
        switch (_context127.prev = _context127.next) {
          case 0:
            return _context127.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:update"
            /* Endpoint.SET_ACCOUNT_INFO */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context127.stop();
        }
      }
    }, _callee127);
  }));
  return _applyActionCode$.apply(this, arguments);
}

function signInWithPassword(_x84, _x85) {
  return _signInWithPassword.apply(this, arguments);
}

function _signInWithPassword() {
  _signInWithPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee128(auth, request) {
    return regenerator.wrap(function _callee128$(_context128) {
      while (1) {
        switch (_context128.prev = _context128.next) {
          case 0:
            return _context128.abrupt("return", _performSignInRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signInWithPassword"
            /* Endpoint.SIGN_IN_WITH_PASSWORD */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context128.stop();
        }
      }
    }, _callee128);
  }));
  return _signInWithPassword.apply(this, arguments);
}

function sendOobCode(_x86, _x87) {
  return _sendOobCode.apply(this, arguments);
}

function _sendOobCode() {
  _sendOobCode = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee129(auth, request) {
    return regenerator.wrap(function _callee129$(_context129) {
      while (1) {
        switch (_context129.prev = _context129.next) {
          case 0:
            return _context129.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:sendOobCode"
            /* Endpoint.SEND_OOB_CODE */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context129.stop();
        }
      }
    }, _callee129);
  }));
  return _sendOobCode.apply(this, arguments);
}

function sendEmailVerification$1(_x88, _x89) {
  return _sendEmailVerification$.apply(this, arguments);
}

function _sendEmailVerification$() {
  _sendEmailVerification$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee130(auth, request) {
    return regenerator.wrap(function _callee130$(_context130) {
      while (1) {
        switch (_context130.prev = _context130.next) {
          case 0:
            return _context130.abrupt("return", sendOobCode(auth, request));

          case 1:
          case "end":
            return _context130.stop();
        }
      }
    }, _callee130);
  }));
  return _sendEmailVerification$.apply(this, arguments);
}

function sendPasswordResetEmail$1(_x90, _x91) {
  return _sendPasswordResetEmail$.apply(this, arguments);
}

function _sendPasswordResetEmail$() {
  _sendPasswordResetEmail$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee131(auth, request) {
    return regenerator.wrap(function _callee131$(_context131) {
      while (1) {
        switch (_context131.prev = _context131.next) {
          case 0:
            return _context131.abrupt("return", sendOobCode(auth, request));

          case 1:
          case "end":
            return _context131.stop();
        }
      }
    }, _callee131);
  }));
  return _sendPasswordResetEmail$.apply(this, arguments);
}

function verifyAndChangeEmail(_x94, _x95) {
  return _verifyAndChangeEmail.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _verifyAndChangeEmail() {
  _verifyAndChangeEmail = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee133(auth, request) {
    return regenerator.wrap(function _callee133$(_context133) {
      while (1) {
        switch (_context133.prev = _context133.next) {
          case 0:
            return _context133.abrupt("return", sendOobCode(auth, request));

          case 1:
          case "end":
            return _context133.stop();
        }
      }
    }, _callee133);
  }));
  return _verifyAndChangeEmail.apply(this, arguments);
}

function signInWithEmailLink$1(_x96, _x97) {
  return _signInWithEmailLink$.apply(this, arguments);
}

function _signInWithEmailLink$() {
  _signInWithEmailLink$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee134(auth, request) {
    return regenerator.wrap(function _callee134$(_context134) {
      while (1) {
        switch (_context134.prev = _context134.next) {
          case 0:
            return _context134.abrupt("return", _performSignInRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signInWithEmailLink"
            /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context134.stop();
        }
      }
    }, _callee134);
  }));
  return _signInWithEmailLink$.apply(this, arguments);
}

function signInWithEmailLinkForLinking(_x98, _x99) {
  return _signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */


function _signInWithEmailLinkForLinking() {
  _signInWithEmailLinkForLinking = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee135(auth, request) {
    return regenerator.wrap(function _callee135$(_context135) {
      while (1) {
        switch (_context135.prev = _context135.next) {
          case 0:
            return _context135.abrupt("return", _performSignInRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signInWithEmailLink"
            /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context135.stop();
        }
      }
    }, _callee135);
  }));
  return _signInWithEmailLinkForLinking.apply(this, arguments);
}

var EmailAuthCredential = /*#__PURE__*/function (_AuthCredential) {
  _inherits(EmailAuthCredential, _AuthCredential);

  var _super = _createSuper$2(EmailAuthCredential);

  /** @internal */
  function EmailAuthCredential(
  /** @internal */
  _email,
  /** @internal */
  _password, signInMethod) {
    var _this13;

    var _tenantId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, EmailAuthCredential);

    _this13 = _super.call(this, "password"
    /* ProviderId.PASSWORD */
    , signInMethod);
    _this13._email = _email;
    _this13._password = _password;
    _this13._tenantId = _tenantId;
    return _this13;
  }
  /** @internal */


  _createClass(EmailAuthCredential, [{
    key: "toJSON",
    value:
    /** {@inheritdoc AuthCredential.toJSON} */
    function toJSON() {
      return {
        email: this._email,
        password: this._password,
        signInMethod: this.signInMethod,
        tenantId: this._tenantId
      };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */

  }, {
    key: "_getIdTokenResponse",
    value:
    /** @internal */
    function () {
      var _getIdTokenResponse2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee48(auth) {
        var request;
        return regenerator.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.t0 = this.signInMethod;
                _context48.next = _context48.t0 === "password"
                /* SignInMethod.EMAIL_PASSWORD */
                ? 3 : _context48.t0 === "emailLink"
                /* SignInMethod.EMAIL_LINK */
                ? 5 : 6;
                break;

              case 3:
                request = {
                  returnSecureToken: true,
                  email: this._email,
                  password: this._password,
                  clientType: "CLIENT_TYPE_WEB"
                  /* RecaptchaClientType.WEB */

                };
                return _context48.abrupt("return", handleRecaptchaFlow(auth, request, "signInWithPassword"
                /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */
                , signInWithPassword));

              case 5:
                return _context48.abrupt("return", signInWithEmailLink$1(auth, {
                  email: this._email,
                  oobCode: this._password
                }));

              case 6:
                _fail(auth, "internal-error"
                /* AuthErrorCode.INTERNAL_ERROR */
                );

              case 7:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function _getIdTokenResponse(_x100) {
        return _getIdTokenResponse2.apply(this, arguments);
      }

      return _getIdTokenResponse;
    }()
    /** @internal */

  }, {
    key: "_linkToIdToken",
    value: function () {
      var _linkToIdToken2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee49(auth, idToken) {
        var request;
        return regenerator.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.t0 = this.signInMethod;
                _context49.next = _context49.t0 === "password"
                /* SignInMethod.EMAIL_PASSWORD */
                ? 3 : _context49.t0 === "emailLink"
                /* SignInMethod.EMAIL_LINK */
                ? 5 : 6;
                break;

              case 3:
                request = {
                  idToken: idToken,
                  returnSecureToken: true,
                  email: this._email,
                  password: this._password,
                  clientType: "CLIENT_TYPE_WEB"
                  /* RecaptchaClientType.WEB */

                };
                return _context49.abrupt("return", handleRecaptchaFlow(auth, request, "signUpPassword"
                /* RecaptchaActionName.SIGN_UP_PASSWORD */
                , linkEmailPassword));

              case 5:
                return _context49.abrupt("return", signInWithEmailLinkForLinking(auth, {
                  idToken: idToken,
                  email: this._email,
                  oobCode: this._password
                }));

              case 6:
                _fail(auth, "internal-error"
                /* AuthErrorCode.INTERNAL_ERROR */
                );

              case 7:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function _linkToIdToken(_x101, _x102) {
        return _linkToIdToken2.apply(this, arguments);
      }

      return _linkToIdToken;
    }()
    /** @internal */

  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      return this._getIdTokenResponse(auth);
    }
  }], [{
    key: "_fromEmailAndPassword",
    value: function _fromEmailAndPassword(email, password) {
      return new EmailAuthCredential(email, password, "password"
      /* SignInMethod.EMAIL_PASSWORD */
      );
    }
    /** @internal */

  }, {
    key: "_fromEmailAndCode",
    value: function _fromEmailAndCode(email, oobCode) {
      var tenantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new EmailAuthCredential(email, oobCode, "emailLink"
      /* SignInMethod.EMAIL_LINK */
      , tenantId);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = typeof json === 'string' ? JSON.parse(json) : json;

      if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
        if (obj.signInMethod === "password"
        /* SignInMethod.EMAIL_PASSWORD */
        ) {
          return this._fromEmailAndPassword(obj.email, obj.password);
        } else if (obj.signInMethod === "emailLink"
        /* SignInMethod.EMAIL_LINK */
        ) {
          return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
      }

      return null;
    }
  }]);

  return EmailAuthCredential;
}(AuthCredential);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function signInWithIdp(_x103, _x104) {
  return _signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signInWithIdp() {
  _signInWithIdp = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee136(auth, request) {
    return regenerator.wrap(function _callee136$(_context136) {
      while (1) {
        switch (_context136.prev = _context136.next) {
          case 0:
            return _context136.abrupt("return", _performSignInRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signInWithIdp"
            /* Endpoint.SIGN_IN_WITH_IDP */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context136.stop();
        }
      }
    }, _callee136);
  }));
  return _signInWithIdp.apply(this, arguments);
}

var IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */

var OAuthCredential = /*#__PURE__*/function (_AuthCredential2) {
  _inherits(OAuthCredential, _AuthCredential2);

  var _super2 = _createSuper$2(OAuthCredential);

  function OAuthCredential() {
    var _this14;

    _classCallCheck(this, OAuthCredential);

    _this14 = _super2.apply(this, arguments);
    _this14.pendingToken = null;
    return _this14;
  }
  /** @internal */


  _createClass(OAuthCredential, [{
    key: "toJSON",
    value:
    /** {@inheritdoc AuthCredential.toJSON}  */
    function toJSON() {
      return {
        idToken: this.idToken,
        accessToken: this.accessToken,
        secret: this.secret,
        nonce: this.nonce,
        pendingToken: this.pendingToken,
        providerId: this.providerId,
        signInMethod: this.signInMethod
      };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */

  }, {
    key: "_getIdTokenResponse",
    value:
    /** @internal */
    function _getIdTokenResponse(auth) {
      var request = this.buildRequest();
      return signInWithIdp(auth, request);
    }
    /** @internal */

  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      var request = this.buildRequest();
      request.idToken = idToken;
      return signInWithIdp(auth, request);
    }
    /** @internal */

  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      var request = this.buildRequest();
      request.autoCreate = false;
      return signInWithIdp(auth, request);
    }
  }, {
    key: "buildRequest",
    value: function buildRequest() {
      var request = {
        requestUri: IDP_REQUEST_URI$1,
        returnSecureToken: true
      };

      if (this.pendingToken) {
        request.pendingToken = this.pendingToken;
      } else {
        var postBody = {};

        if (this.idToken) {
          postBody['id_token'] = this.idToken;
        }

        if (this.accessToken) {
          postBody['access_token'] = this.accessToken;
        }

        if (this.secret) {
          postBody['oauth_token_secret'] = this.secret;
        }

        postBody['providerId'] = this.providerId;

        if (this.nonce && !this.pendingToken) {
          postBody['nonce'] = this.nonce;
        }

        request.postBody = querystring(postBody);
      }

      return request;
    }
  }], [{
    key: "_fromParams",
    value: function _fromParams(params) {
      var cred = new OAuthCredential(params.providerId, params.signInMethod);

      if (params.idToken || params.accessToken) {
        // OAuth 2 and either ID token or access token.
        if (params.idToken) {
          cred.idToken = params.idToken;
        }

        if (params.accessToken) {
          cred.accessToken = params.accessToken;
        } // Add nonce if available and no pendingToken is present.


        if (params.nonce && !params.pendingToken) {
          cred.nonce = params.nonce;
        }

        if (params.pendingToken) {
          cred.pendingToken = params.pendingToken;
        }
      } else if (params.oauthToken && params.oauthTokenSecret) {
        // OAuth 1 and OAuth token with token secret
        cred.accessToken = params.oauthToken;
        cred.secret = params.oauthTokenSecret;
      } else {
        _fail("argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
        );
      }

      return cred;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = typeof json === 'string' ? JSON.parse(json) : json;

      var providerId = obj.providerId,
          signInMethod = obj.signInMethod,
          rest = __rest(obj, ["providerId", "signInMethod"]);

      if (!providerId || !signInMethod) {
        return null;
      }

      var cred = new OAuthCredential(providerId, signInMethod);
      cred.idToken = rest.idToken || undefined;
      cred.accessToken = rest.accessToken || undefined;
      cred.secret = rest.secret;
      cred.nonce = rest.nonce;
      cred.pendingToken = rest.pendingToken || null;
      return cred;
    }
  }]);

  return OAuthCredential;
}(AuthCredential);

_defineProperty$1({}, "USER_NOT_FOUND"
/* ServerError.USER_NOT_FOUND */
, "user-not-found");
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */


function parseMode(mode) {
  switch (mode) {
    case 'recoverEmail':
      return "RECOVER_EMAIL"
      /* ActionCodeOperation.RECOVER_EMAIL */
      ;

    case 'resetPassword':
      return "PASSWORD_RESET"
      /* ActionCodeOperation.PASSWORD_RESET */
      ;

    case 'signIn':
      return "EMAIL_SIGNIN"
      /* ActionCodeOperation.EMAIL_SIGNIN */
      ;

    case 'verifyEmail':
      return "VERIFY_EMAIL"
      /* ActionCodeOperation.VERIFY_EMAIL */
      ;

    case 'verifyAndChangeEmail':
      return "VERIFY_AND_CHANGE_EMAIL"
      /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */
      ;

    case 'revertSecondFactorAddition':
      return "REVERT_SECOND_FACTOR_ADDITION"
      /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */
      ;

    default:
      return null;
  }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */


function parseDeepLink(url) {
  var link = querystringDecode(extractQuerystring(url))['link']; // Double link case (automatic redirect).

  var doubleDeepLink = link ? querystringDecode(extractQuerystring(link))['deep_link_id'] : null; // iOS custom scheme links.

  var iOSDeepLink = querystringDecode(extractQuerystring(url))['deep_link_id'];
  var iOSDoubleDeepLink = iOSDeepLink ? querystringDecode(extractQuerystring(iOSDeepLink))['link'] : null;
  return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */


var ActionCodeURL = /*#__PURE__*/function () {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  function ActionCodeURL(actionLink) {
    _classCallCheck(this, ActionCodeURL);

    var _a, _b, _c, _d, _e, _f;

    var searchParams = querystringDecode(extractQuerystring(actionLink));
    var apiKey = (_a = searchParams["apiKey"
    /* QueryField.API_KEY */
    ]) !== null && _a !== void 0 ? _a : null;
    var code = (_b = searchParams["oobCode"
    /* QueryField.CODE */
    ]) !== null && _b !== void 0 ? _b : null;
    var operation = parseMode((_c = searchParams["mode"
    /* QueryField.MODE */
    ]) !== null && _c !== void 0 ? _c : null); // Validate API key, code and mode.

    _assert(apiKey && code && operation, "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
    );

    this.apiKey = apiKey;
    this.operation = operation;
    this.code = code;
    this.continueUrl = (_d = searchParams["continueUrl"
    /* QueryField.CONTINUE_URL */
    ]) !== null && _d !== void 0 ? _d : null;
    this.languageCode = (_e = searchParams["languageCode"
    /* QueryField.LANGUAGE_CODE */
    ]) !== null && _e !== void 0 ? _e : null;
    this.tenantId = (_f = searchParams["tenantId"
    /* QueryField.TENANT_ID */
    ]) !== null && _f !== void 0 ? _f : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */


  _createClass(ActionCodeURL, null, [{
    key: "parseLink",
    value: function parseLink(link) {
      var actionLink = parseDeepLink(link);

      try {
        return new ActionCodeURL(actionLink);
      } catch (_a) {
        return null;
      }
    }
  }]);

  return ActionCodeURL;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */


var EmailAuthProvider = /*#__PURE__*/function () {
  function EmailAuthProvider() {
    _classCallCheck(this, EmailAuthProvider);

    /**
     * Always set to {@link ProviderId}.PASSWORD, even for email link.
     */
    this.providerId = EmailAuthProvider.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */


  _createClass(EmailAuthProvider, null, [{
    key: "credential",
    value: function credential(email, password) {
      return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */

  }, {
    key: "credentialWithLink",
    value: function credentialWithLink(email, emailLink) {
      var actionCodeUrl = ActionCodeURL.parseLink(emailLink);

      _assert(actionCodeUrl, "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
      );

      return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
  }]);

  return EmailAuthProvider;
}();
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */


EmailAuthProvider.PROVIDER_ID = "password"
/* ProviderId.PASSWORD */
;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */

EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password"
/* SignInMethod.EMAIL_PASSWORD */
;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */

EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink"
/* SignInMethod.EMAIL_LINK */
;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */

var FederatedAuthProvider = /*#__PURE__*/function () {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  function FederatedAuthProvider(providerId) {
    _classCallCheck(this, FederatedAuthProvider);

    this.providerId = providerId;
    /** @internal */

    this.defaultLanguageCode = null;
    /** @internal */

    this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */


  _createClass(FederatedAuthProvider, [{
    key: "setDefaultLanguage",
    value: function setDefaultLanguage(languageCode) {
      this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */

  }, {
    key: "setCustomParameters",
    value: function setCustomParameters(customOAuthParameters) {
      this.customParameters = customOAuthParameters;
      return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */

  }, {
    key: "getCustomParameters",
    value: function getCustomParameters() {
      return this.customParameters;
    }
  }]);

  return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */


var BaseOAuthProvider = /*#__PURE__*/function (_FederatedAuthProvide) {
  _inherits(BaseOAuthProvider, _FederatedAuthProvide);

  var _super4 = _createSuper$2(BaseOAuthProvider);

  function BaseOAuthProvider() {
    var _this16;

    _classCallCheck(this, BaseOAuthProvider);

    _this16 = _super4.apply(this, arguments);
    /** @internal */

    _this16.scopes = [];
    return _this16;
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */


  _createClass(BaseOAuthProvider, [{
    key: "addScope",
    value: function addScope(scope) {
      // If not already added, add scope to list.
      if (!this.scopes.includes(scope)) {
        this.scopes.push(scope);
      }

      return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */

  }, {
    key: "getScopes",
    value: function getScopes() {
      return _toConsumableArray(this.scopes);
    }
  }]);

  return BaseOAuthProvider;
}(FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */


var FacebookAuthProvider = /*#__PURE__*/function (_BaseOAuthProvider2) {
  _inherits(FacebookAuthProvider, _BaseOAuthProvider2);

  var _super6 = _createSuper$2(FacebookAuthProvider);

  function FacebookAuthProvider() {
    _classCallCheck(this, FacebookAuthProvider);

    return _super6.call(this, "facebook.com"
    /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */


  _createClass(FacebookAuthProvider, null, [{
    key: "credential",
    value: function credential(accessToken) {
      return OAuthCredential._fromParams({
        providerId: FacebookAuthProvider.PROVIDER_ID,
        signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
        accessToken: accessToken
      });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */

  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */

  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref14) {
      var tokenResponse = _ref14._tokenResponse;

      if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) {
        return null;
      }

      if (!tokenResponse.oauthAccessToken) {
        return null;
      }

      try {
        return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
      } catch (_a) {
        return null;
      }
    }
  }]);

  return FacebookAuthProvider;
}(BaseOAuthProvider);
/** Always set to {@link SignInMethod}.FACEBOOK. */


FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com"
/* SignInMethod.FACEBOOK */
;
/** Always set to {@link ProviderId}.FACEBOOK. */

FacebookAuthProvider.PROVIDER_ID = "facebook.com"
/* ProviderId.FACEBOOK */
;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */

var GoogleAuthProvider = /*#__PURE__*/function (_BaseOAuthProvider3) {
  _inherits(GoogleAuthProvider, _BaseOAuthProvider3);

  var _super7 = _createSuper$2(GoogleAuthProvider);

  function GoogleAuthProvider() {
    var _this17;

    _classCallCheck(this, GoogleAuthProvider);

    _this17 = _super7.call(this, "google.com"
    /* ProviderId.GOOGLE */
    );

    _this17.addScope('profile');

    return _this17;
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */


  _createClass(GoogleAuthProvider, null, [{
    key: "credential",
    value: function credential(idToken, accessToken) {
      return OAuthCredential._fromParams({
        providerId: GoogleAuthProvider.PROVIDER_ID,
        signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
        idToken: idToken,
        accessToken: accessToken
      });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */

  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(userCredential) {
      return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */

  }, {
    key: "credentialFromError",
    value: function credentialFromError(error) {
      return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref15) {
      var tokenResponse = _ref15._tokenResponse;

      if (!tokenResponse) {
        return null;
      }

      var oauthIdToken = tokenResponse.oauthIdToken,
          oauthAccessToken = tokenResponse.oauthAccessToken;

      if (!oauthIdToken && !oauthAccessToken) {
        // This could be an oauth 1 credential or a phone credential
        return null;
      }

      try {
        return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
      } catch (_a) {
        return null;
      }
    }
  }]);

  return GoogleAuthProvider;
}(BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GOOGLE. */


GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com"
/* SignInMethod.GOOGLE */
;
/** Always set to {@link ProviderId}.GOOGLE. */

GoogleAuthProvider.PROVIDER_ID = "google.com"
/* ProviderId.GOOGLE */
;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function signUp(_x113, _x114) {
  return _signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _signUp() {
  _signUp = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee141(auth, request) {
    return regenerator.wrap(function _callee141$(_context141) {
      while (1) {
        switch (_context141.prev = _context141.next) {
          case 0:
            return _context141.abrupt("return", _performSignInRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:signUp"
            /* Endpoint.SIGN_UP */
            , _addTidIfNecessary(auth, request)));

          case 1:
          case "end":
            return _context141.stop();
        }
      }
    }, _callee141);
  }));
  return _signUp.apply(this, arguments);
}

var UserCredentialImpl = /*#__PURE__*/function () {
  function UserCredentialImpl(params) {
    _classCallCheck(this, UserCredentialImpl);

    this.user = params.user;
    this.providerId = params.providerId;
    this._tokenResponse = params._tokenResponse;
    this.operationType = params.operationType;
  }

  _createClass(UserCredentialImpl, null, [{
    key: "_fromIdTokenResponse",
    value: function () {
      var _fromIdTokenResponse3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee50(auth, operationType, idTokenResponse) {
        var isAnonymous,
            user,
            providerId,
            userCred,
            _args50 = arguments;
        return regenerator.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                isAnonymous = _args50.length > 3 && _args50[3] !== undefined ? _args50[3] : false;
                _context50.next = 3;
                return UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);

              case 3:
                user = _context50.sent;
                providerId = providerIdForResponse(idTokenResponse);
                userCred = new UserCredentialImpl({
                  user: user,
                  providerId: providerId,
                  _tokenResponse: idTokenResponse,
                  operationType: operationType
                });
                return _context50.abrupt("return", userCred);

              case 7:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50);
      }));

      function _fromIdTokenResponse(_x115, _x116, _x117) {
        return _fromIdTokenResponse3.apply(this, arguments);
      }

      return _fromIdTokenResponse;
    }()
  }, {
    key: "_forOperation",
    value: function () {
      var _forOperation2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee51(user, operationType, response) {
        var providerId;
        return regenerator.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return user._updateTokensIfNecessary(response,
                /* reload */
                true);

              case 2:
                providerId = providerIdForResponse(response);
                return _context51.abrupt("return", new UserCredentialImpl({
                  user: user,
                  providerId: providerId,
                  _tokenResponse: response,
                  operationType: operationType
                }));

              case 4:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51);
      }));

      function _forOperation(_x118, _x119, _x120) {
        return _forOperation2.apply(this, arguments);
      }

      return _forOperation;
    }()
  }]);

  return UserCredentialImpl;
}();

function providerIdForResponse(response) {
  if (response.providerId) {
    return response.providerId;
  }

  if ('phoneNumber' in response) {
    return "phone"
    /* ProviderId.PHONE */
    ;
  }

  return null;
}

var MultiFactorError = /*#__PURE__*/function (_FirebaseError) {
  _inherits(MultiFactorError, _FirebaseError);

  var _super12 = _createSuper$2(MultiFactorError);

  function MultiFactorError(auth, error, operationType, user) {
    var _this19;

    _classCallCheck(this, MultiFactorError);

    var _a;

    _this19 = _super12.call(this, error.code, error.message);
    _this19.operationType = operationType;
    _this19.user = user; // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work

    Object.setPrototypeOf(_assertThisInitialized(_this19), MultiFactorError.prototype);
    _this19.customData = {
      appName: auth.name,
      tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
      _serverResponse: error.customData._serverResponse,
      operationType: operationType
    };
    return _this19;
  }

  _createClass(MultiFactorError, null, [{
    key: "_fromErrorAndOperation",
    value: function _fromErrorAndOperation(auth, error, operationType, user) {
      return new MultiFactorError(auth, error, operationType, user);
    }
  }]);

  return MultiFactorError;
}(FirebaseError);

function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
  var idTokenProvider = operationType === "reauthenticate"
  /* OperationType.REAUTHENTICATE */
  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
  return idTokenProvider["catch"](function (error) {
    if (error.code === "auth/".concat("multi-factor-auth-required"
    /* AuthErrorCode.MFA_REQUIRED */
    )) {
      throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
    }

    throw error;
  });
}

function _link$1(_x124, _x125) {
  return _link$.apply(this, arguments);
}

function _link$() {
  _link$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee144(user, credential) {
    var bypassAuthState,
        response,
        _args144 = arguments;
    return regenerator.wrap(function _callee144$(_context144) {
      while (1) {
        switch (_context144.prev = _context144.next) {
          case 0:
            bypassAuthState = _args144.length > 2 && _args144[2] !== undefined ? _args144[2] : false;
            _context144.t0 = _logoutIfInvalidated;
            _context144.t1 = user;
            _context144.t2 = credential;
            _context144.t3 = user.auth;
            _context144.next = 7;
            return user.getIdToken();

          case 7:
            _context144.t4 = _context144.sent;
            _context144.t5 = _context144.t2._linkToIdToken.call(_context144.t2, _context144.t3, _context144.t4);
            _context144.t6 = bypassAuthState;
            _context144.next = 12;
            return (0, _context144.t0)(_context144.t1, _context144.t5, _context144.t6);

          case 12:
            response = _context144.sent;
            return _context144.abrupt("return", UserCredentialImpl._forOperation(user, "link"
            /* OperationType.LINK */
            , response));

          case 14:
          case "end":
            return _context144.stop();
        }
      }
    }, _callee144);
  }));
  return _link$.apply(this, arguments);
}

function _reauthenticate(_x129, _x130) {
  return _reauthenticate2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reauthenticate2() {
  _reauthenticate2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee146(user, credential) {
    var bypassAuthState,
        auth,
        operationType,
        response,
        parsed,
        localId,
        _args146 = arguments;
    return regenerator.wrap(function _callee146$(_context146) {
      while (1) {
        switch (_context146.prev = _context146.next) {
          case 0:
            bypassAuthState = _args146.length > 2 && _args146[2] !== undefined ? _args146[2] : false;
            auth = user.auth;

            if (!_isFirebaseServerApp(auth.app)) {
              _context146.next = 4;
              break;
            }

            return _context146.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth)));

          case 4:
            operationType = "reauthenticate";
            _context146.prev = 5;
            _context146.next = 8;
            return _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);

          case 8:
            response = _context146.sent;

            _assert(response.idToken, auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            parsed = _parseToken(response.idToken);

            _assert(parsed, auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            localId = parsed.sub;

            _assert(user.uid === localId, auth, "user-mismatch"
            /* AuthErrorCode.USER_MISMATCH */
            );

            return _context146.abrupt("return", UserCredentialImpl._forOperation(user, operationType, response));

          case 17:
            _context146.prev = 17;
            _context146.t0 = _context146["catch"](5);

            // Convert user deleted error into user mismatch
            if ((_context146.t0 === null || _context146.t0 === void 0 ? void 0 : _context146.t0.code) === "auth/".concat("user-not-found"
            /* AuthErrorCode.USER_DELETED */
            )) {
              _fail(auth, "user-mismatch"
              /* AuthErrorCode.USER_MISMATCH */
              );
            }

            throw _context146.t0;

          case 21:
          case "end":
            return _context146.stop();
        }
      }
    }, _callee146, null, [[5, 17]]);
  }));
  return _reauthenticate2.apply(this, arguments);
}

function _signInWithCredential(_x131, _x132) {
  return _signInWithCredential2.apply(this, arguments);
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */


function _signInWithCredential2() {
  _signInWithCredential2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee147(auth, credential) {
    var bypassAuthState,
        operationType,
        response,
        userCredential,
        _args147 = arguments;
    return regenerator.wrap(function _callee147$(_context147) {
      while (1) {
        switch (_context147.prev = _context147.next) {
          case 0:
            bypassAuthState = _args147.length > 2 && _args147[2] !== undefined ? _args147[2] : false;

            if (!_isFirebaseServerApp(auth.app)) {
              _context147.next = 3;
              break;
            }

            return _context147.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth)));

          case 3:
            operationType = "signIn";
            _context147.next = 6;
            return _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);

          case 6:
            response = _context147.sent;
            _context147.next = 9;
            return UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);

          case 9:
            userCredential = _context147.sent;

            if (bypassAuthState) {
              _context147.next = 13;
              break;
            }

            _context147.next = 13;
            return auth._updateCurrentUser(userCredential.user);

          case 13:
            return _context147.abrupt("return", userCredential);

          case 14:
          case "end":
            return _context147.stop();
        }
      }
    }, _callee147);
  }));
  return _signInWithCredential2.apply(this, arguments);
}

function signInWithCredential(_x133, _x134) {
  return _signInWithCredential3.apply(this, arguments);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */


function _signInWithCredential3() {
  _signInWithCredential3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee148(auth, credential) {
    return regenerator.wrap(function _callee148$(_context148) {
      while (1) {
        switch (_context148.prev = _context148.next) {
          case 0:
            return _context148.abrupt("return", _signInWithCredential(_castAuth(auth), credential));

          case 1:
          case "end":
            return _context148.stop();
        }
      }
    }, _callee148);
  }));
  return _signInWithCredential3.apply(this, arguments);
}

function reauthenticateWithCredential(_x137, _x138) {
  return _reauthenticateWithCredential.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _reauthenticateWithCredential() {
  _reauthenticateWithCredential = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee150(user, credential) {
    return regenerator.wrap(function _callee150$(_context150) {
      while (1) {
        switch (_context150.prev = _context150.next) {
          case 0:
            return _context150.abrupt("return", _reauthenticate(getModularInstance(user), credential));

          case 1:
          case "end":
            return _context150.stop();
        }
      }
    }, _callee150);
  }));
  return _reauthenticateWithCredential.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
  var _a;

  _assert(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri"
  /* AuthErrorCode.INVALID_CONTINUE_URI */
  );

  _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain"
  /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */
  );

  request.continueUrl = actionCodeSettings.url;
  request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
  request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;

  if (actionCodeSettings.iOS) {
    _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id"
    /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */
    );

    request.iOSBundleId = actionCodeSettings.iOS.bundleId;
  }

  if (actionCodeSettings.android) {
    _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name"
    /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */
    );

    request.androidInstallApp = actionCodeSettings.android.installApp;
    request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
    request.androidPackageName = actionCodeSettings.android.packageName;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */


function recachePasswordPolicy(_x143) {
  return _recachePasswordPolicy.apply(this, arguments);
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */


function _recachePasswordPolicy() {
  _recachePasswordPolicy = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee153(auth) {
    var authInternal;
    return regenerator.wrap(function _callee153$(_context153) {
      while (1) {
        switch (_context153.prev = _context153.next) {
          case 0:
            authInternal = _castAuth(auth);

            if (!authInternal._getPasswordPolicyInternal()) {
              _context153.next = 4;
              break;
            }

            _context153.next = 4;
            return authInternal._updatePasswordPolicy();

          case 4:
          case "end":
            return _context153.stop();
        }
      }
    }, _callee153);
  }));
  return _recachePasswordPolicy.apply(this, arguments);
}

function sendPasswordResetEmail(_x144, _x145, _x146) {
  return _sendPasswordResetEmail.apply(this, arguments);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */


function _sendPasswordResetEmail() {
  _sendPasswordResetEmail = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee154(auth, email, actionCodeSettings) {
    var authInternal, request;
    return regenerator.wrap(function _callee154$(_context154) {
      while (1) {
        switch (_context154.prev = _context154.next) {
          case 0:
            authInternal = _castAuth(auth);
            request = {
              requestType: "PASSWORD_RESET"
              /* ActionCodeOperation.PASSWORD_RESET */
              ,
              email: email,
              clientType: "CLIENT_TYPE_WEB"
              /* RecaptchaClientType.WEB */

            };

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
            }

            _context154.next = 5;
            return handleRecaptchaFlow(authInternal, request, "getOobCode"
            /* RecaptchaActionName.GET_OOB_CODE */
            , sendPasswordResetEmail$1);

          case 5:
          case "end":
            return _context154.stop();
        }
      }
    }, _callee154);
  }));
  return _sendPasswordResetEmail.apply(this, arguments);
}

function confirmPasswordReset(_x147, _x148, _x149) {
  return _confirmPasswordReset.apply(this, arguments);
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */


function _confirmPasswordReset() {
  _confirmPasswordReset = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee156(auth, oobCode, newPassword) {
    return regenerator.wrap(function _callee156$(_context156) {
      while (1) {
        switch (_context156.prev = _context156.next) {
          case 0:
            _context156.next = 2;
            return resetPassword(getModularInstance(auth), {
              oobCode: oobCode,
              newPassword: newPassword
            })["catch"]( /*#__PURE__*/function () {
              var _ref43 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee155(error) {
                return regenerator.wrap(function _callee155$(_context155) {
                  while (1) {
                    switch (_context155.prev = _context155.next) {
                      case 0:
                        if (error.code === "auth/".concat("password-does-not-meet-requirements"
                        /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */
                        )) {
                          void recachePasswordPolicy(auth);
                        }

                        throw error;

                      case 2:
                      case "end":
                        return _context155.stop();
                    }
                  }
                }, _callee155);
              }));

              return function (_x290) {
                return _ref43.apply(this, arguments);
              };
            }());

          case 2:
          case "end":
            return _context156.stop();
        }
      }
    }, _callee156);
  }));
  return _confirmPasswordReset.apply(this, arguments);
}

function applyActionCode(_x150, _x151) {
  return _applyActionCode.apply(this, arguments);
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */


function _applyActionCode() {
  _applyActionCode = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee157(auth, oobCode) {
    return regenerator.wrap(function _callee157$(_context157) {
      while (1) {
        switch (_context157.prev = _context157.next) {
          case 0:
            _context157.next = 2;
            return applyActionCode$1(getModularInstance(auth), {
              oobCode: oobCode
            });

          case 2:
          case "end":
            return _context157.stop();
        }
      }
    }, _callee157);
  }));
  return _applyActionCode.apply(this, arguments);
}

function createUserWithEmailAndPassword(_x156, _x157, _x158) {
  return _createUserWithEmailAndPassword.apply(this, arguments);
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */


function _createUserWithEmailAndPassword() {
  _createUserWithEmailAndPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee160(auth, email, password) {
    var authInternal, request, signUpResponse, response, userCredential;
    return regenerator.wrap(function _callee160$(_context160) {
      while (1) {
        switch (_context160.prev = _context160.next) {
          case 0:
            if (!_isFirebaseServerApp(auth.app)) {
              _context160.next = 2;
              break;
            }

            return _context160.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth)));

          case 2:
            authInternal = _castAuth(auth);
            request = {
              returnSecureToken: true,
              email: email,
              password: password,
              clientType: "CLIENT_TYPE_WEB"
              /* RecaptchaClientType.WEB */

            };
            signUpResponse = handleRecaptchaFlow(authInternal, request, "signUpPassword"
            /* RecaptchaActionName.SIGN_UP_PASSWORD */
            , signUp);
            _context160.next = 7;
            return signUpResponse["catch"](function (error) {
              if (error.code === "auth/".concat("password-does-not-meet-requirements"
              /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */
              )) {
                void recachePasswordPolicy(auth);
              }

              throw error;
            });

          case 7:
            response = _context160.sent;
            _context160.next = 10;
            return UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn"
            /* OperationType.SIGN_IN */
            , response);

          case 10:
            userCredential = _context160.sent;
            _context160.next = 13;
            return authInternal._updateCurrentUser(userCredential.user);

          case 13:
            return _context160.abrupt("return", userCredential);

          case 14:
          case "end":
            return _context160.stop();
        }
      }
    }, _callee160);
  }));
  return _createUserWithEmailAndPassword.apply(this, arguments);
}

function signInWithEmailAndPassword(auth, email, password) {
  if (_isFirebaseServerApp(auth.app)) {
    return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
  }

  return signInWithCredential(getModularInstance(auth), EmailAuthProvider.credential(email, password))["catch"]( /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee52(error) {
      return regenerator.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              if (error.code === "auth/".concat("password-does-not-meet-requirements"
              /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */
              )) {
                void recachePasswordPolicy(auth);
              }

              throw error;

            case 2:
            case "end":
              return _context52.stop();
          }
        }
      }, _callee52);
    }));

    return function (_x159) {
      return _ref20.apply(this, arguments);
    };
  }());
}

function sendEmailVerification(_x170, _x171) {
  return _sendEmailVerification.apply(this, arguments);
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */


function _sendEmailVerification() {
  _sendEmailVerification = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee165(user, actionCodeSettings) {
    var userInternal, idToken, request, _yield$sendEmailVerif, email;

    return regenerator.wrap(function _callee165$(_context165) {
      while (1) {
        switch (_context165.prev = _context165.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context165.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context165.sent;
            request = {
              requestType: "VERIFY_EMAIL"
              /* ActionCodeOperation.VERIFY_EMAIL */
              ,
              idToken: idToken
            };

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
            }

            _context165.next = 8;
            return sendEmailVerification$1(userInternal.auth, request);

          case 8:
            _yield$sendEmailVerif = _context165.sent;
            email = _yield$sendEmailVerif.email;

            if (!(email !== user.email)) {
              _context165.next = 13;
              break;
            }

            _context165.next = 13;
            return user.reload();

          case 13:
          case "end":
            return _context165.stop();
        }
      }
    }, _callee165);
  }));
  return _sendEmailVerification.apply(this, arguments);
}

function verifyBeforeUpdateEmail(_x172, _x173, _x174) {
  return _verifyBeforeUpdateEmail.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _verifyBeforeUpdateEmail() {
  _verifyBeforeUpdateEmail = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee166(user, newEmail, actionCodeSettings) {
    var userInternal, idToken, request, _yield$verifyAndChang, email;

    return regenerator.wrap(function _callee166$(_context166) {
      while (1) {
        switch (_context166.prev = _context166.next) {
          case 0:
            userInternal = getModularInstance(user);
            _context166.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context166.sent;
            request = {
              requestType: "VERIFY_AND_CHANGE_EMAIL"
              /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */
              ,
              idToken: idToken,
              newEmail: newEmail
            };

            if (actionCodeSettings) {
              _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
            }

            _context166.next = 8;
            return verifyAndChangeEmail(userInternal.auth, request);

          case 8:
            _yield$verifyAndChang = _context166.sent;
            email = _yield$verifyAndChang.email;

            if (!(email !== user.email)) {
              _context166.next = 13;
              break;
            }

            _context166.next = 13;
            return user.reload();

          case 13:
          case "end":
            return _context166.stop();
        }
      }
    }, _callee166);
  }));
  return _verifyBeforeUpdateEmail.apply(this, arguments);
}

function updateProfile$1(_x175, _x176) {
  return _updateProfile$.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */


function _updateProfile$() {
  _updateProfile$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee167(auth, request) {
    return regenerator.wrap(function _callee167$(_context167) {
      while (1) {
        switch (_context167.prev = _context167.next) {
          case 0:
            return _context167.abrupt("return", _performApiRequest(auth, "POST"
            /* HttpMethod.POST */
            , "/v1/accounts:update"
            /* Endpoint.SET_ACCOUNT_INFO */
            , request));

          case 1:
          case "end":
            return _context167.stop();
        }
      }
    }, _callee167);
  }));
  return _updateProfile$.apply(this, arguments);
}

function updateProfile(_x177, _x178) {
  return _updateProfile.apply(this, arguments);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */


function _updateProfile() {
  _updateProfile = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee168(user, _ref21) {
    var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
    return regenerator.wrap(function _callee168$(_context168) {
      while (1) {
        switch (_context168.prev = _context168.next) {
          case 0:
            displayName = _ref21.displayName, photoUrl = _ref21.photoURL;

            if (!(displayName === undefined && photoUrl === undefined)) {
              _context168.next = 3;
              break;
            }

            return _context168.abrupt("return");

          case 3:
            userInternal = getModularInstance(user);
            _context168.next = 6;
            return userInternal.getIdToken();

          case 6:
            idToken = _context168.sent;
            profileRequest = {
              idToken: idToken,
              displayName: displayName,
              photoUrl: photoUrl,
              returnSecureToken: true
            };
            _context168.next = 10;
            return _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));

          case 10:
            response = _context168.sent;
            userInternal.displayName = response.displayName || null;
            userInternal.photoURL = response.photoUrl || null; // Update the password provider as well

            passwordProvider = userInternal.providerData.find(function (_ref44) {
              var providerId = _ref44.providerId;
              return providerId === "password";
            }
            /* ProviderId.PASSWORD */
            );

            if (passwordProvider) {
              passwordProvider.displayName = userInternal.displayName;
              passwordProvider.photoURL = userInternal.photoURL;
            }

            _context168.next = 17;
            return userInternal._updateTokensIfNecessary(response);

          case 17:
          case "end":
            return _context168.stop();
        }
      }
    }, _callee168);
  }));
  return _updateProfile.apply(this, arguments);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */


function updatePassword(user, newPassword) {
  return updateEmailOrPassword(getModularInstance(user), null, newPassword);
}

function updateEmailOrPassword(_x179, _x180, _x181) {
  return _updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */


function _updateEmailOrPassword() {
  _updateEmailOrPassword = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee169(user, email, password) {
    var auth, idToken, request, response;
    return regenerator.wrap(function _callee169$(_context169) {
      while (1) {
        switch (_context169.prev = _context169.next) {
          case 0:
            auth = user.auth;
            _context169.next = 3;
            return user.getIdToken();

          case 3:
            idToken = _context169.sent;
            request = {
              idToken: idToken,
              returnSecureToken: true
            };

            if (email) {
              request.email = email;
            }

            if (password) {
              request.password = password;
            }

            _context169.next = 9;
            return _logoutIfInvalidated(user, updateEmailPassword(auth, request));

          case 9:
            response = _context169.sent;
            _context169.next = 12;
            return user._updateTokensIfNecessary(response,
            /* reload */
            true);

          case 12:
          case "end":
            return _context169.stop();
        }
      }
    }, _callee169);
  }));
  return _updateEmailOrPassword.apply(this, arguments);
}

function _fromIdTokenResponse(idTokenResponse) {
  var _a, _b;

  if (!idTokenResponse) {
    return null;
  }

  var providerId = idTokenResponse.providerId;
  var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
  var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse"
  /* IdTokenResponseKind.SignupNewUser */
  ;

  if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
    var signInProvider = (_b = (_a = _parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];

    if (signInProvider) {
      var filteredProviderId = signInProvider !== "anonymous"
      /* ProviderId.ANONYMOUS */
      && signInProvider !== "custom"
      /* ProviderId.CUSTOM */
      ? signInProvider : null; // Uses generic class in accordance with the legacy SDK.

      return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
    }
  }

  if (!providerId) {
    return null;
  }

  switch (providerId) {
    case "facebook.com"
    /* ProviderId.FACEBOOK */
    :
      return new FacebookAdditionalUserInfo(isNewUser, profile);

    case "github.com"
    /* ProviderId.GITHUB */
    :
      return new GithubAdditionalUserInfo(isNewUser, profile);

    case "google.com"
    /* ProviderId.GOOGLE */
    :
      return new GoogleAdditionalUserInfo(isNewUser, profile);

    case "twitter.com"
    /* ProviderId.TWITTER */
    :
      return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);

    case "custom"
    /* ProviderId.CUSTOM */
    :
    case "anonymous"
    /* ProviderId.ANONYMOUS */
    :
      return new GenericAdditionalUserInfo(isNewUser, null);

    default:
      return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
  }
}

var GenericAdditionalUserInfo = /*#__PURE__*/_createClass(function GenericAdditionalUserInfo(isNewUser, providerId) {
  var profile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _classCallCheck(this, GenericAdditionalUserInfo);

  this.isNewUser = isNewUser;
  this.providerId = providerId;
  this.profile = profile;
});

var FederatedAdditionalUserInfoWithUsername = /*#__PURE__*/function (_GenericAdditionalUse) {
  _inherits(FederatedAdditionalUserInfoWithUsername, _GenericAdditionalUse);

  var _super15 = _createSuper$2(FederatedAdditionalUserInfoWithUsername);

  function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
    var _this21;

    _classCallCheck(this, FederatedAdditionalUserInfoWithUsername);

    _this21 = _super15.call(this, isNewUser, providerId, profile);
    _this21.username = username;
    return _this21;
  }

  return _createClass(FederatedAdditionalUserInfoWithUsername);
}(GenericAdditionalUserInfo);

var FacebookAdditionalUserInfo = /*#__PURE__*/function (_GenericAdditionalUse2) {
  _inherits(FacebookAdditionalUserInfo, _GenericAdditionalUse2);

  var _super16 = _createSuper$2(FacebookAdditionalUserInfo);

  function FacebookAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck(this, FacebookAdditionalUserInfo);

    return _super16.call(this, isNewUser, "facebook.com"
    /* ProviderId.FACEBOOK */
    , profile);
  }

  return _createClass(FacebookAdditionalUserInfo);
}(GenericAdditionalUserInfo);

var GithubAdditionalUserInfo = /*#__PURE__*/function (_FederatedAdditionalU) {
  _inherits(GithubAdditionalUserInfo, _FederatedAdditionalU);

  var _super17 = _createSuper$2(GithubAdditionalUserInfo);

  function GithubAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck(this, GithubAdditionalUserInfo);

    return _super17.call(this, isNewUser, "github.com"
    /* ProviderId.GITHUB */
    , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
  }

  return _createClass(GithubAdditionalUserInfo);
}(FederatedAdditionalUserInfoWithUsername);

var GoogleAdditionalUserInfo = /*#__PURE__*/function (_GenericAdditionalUse3) {
  _inherits(GoogleAdditionalUserInfo, _GenericAdditionalUse3);

  var _super18 = _createSuper$2(GoogleAdditionalUserInfo);

  function GoogleAdditionalUserInfo(isNewUser, profile) {
    _classCallCheck(this, GoogleAdditionalUserInfo);

    return _super18.call(this, isNewUser, "google.com"
    /* ProviderId.GOOGLE */
    , profile);
  }

  return _createClass(GoogleAdditionalUserInfo);
}(GenericAdditionalUserInfo);

var TwitterAdditionalUserInfo = /*#__PURE__*/function (_FederatedAdditionalU2) {
  _inherits(TwitterAdditionalUserInfo, _FederatedAdditionalU2);

  var _super19 = _createSuper$2(TwitterAdditionalUserInfo);

  function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
    _classCallCheck(this, TwitterAdditionalUserInfo);

    return _super19.call(this, isNewUser, "twitter.com"
    /* ProviderId.TWITTER */
    , profile, screenName);
  }

  return _createClass(TwitterAdditionalUserInfo);
}(FederatedAdditionalUserInfoWithUsername);
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */


function getAdditionalUserInfo(userCredential) {
  var user = userCredential.user,
      _tokenResponse = userCredential._tokenResponse;

  if (user.isAnonymous && !_tokenResponse) {
    // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
      providerId: null,
      isNewUser: false,
      profile: null
    };
  }

  return _fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Non-optional auth methods.

/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */


function setPersistence(auth, persistence) {
  return getModularInstance(auth).setPersistence(persistence);
}

function onIdTokenChanged(auth, nextOrObserver, error, completed) {
  return getModularInstance(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */


function beforeAuthStateChanged(auth, callback, onAbort) {
  return getModularInstance(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */


function onAuthStateChanged(auth, nextOrObserver, error, completed) {
  return getModularInstance(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */


function signOut(auth) {
  return getModularInstance(auth).signOut();
}

var STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.

var BrowserPersistenceClass = /*#__PURE__*/function () {
  function BrowserPersistenceClass(storageRetriever, type) {
    _classCallCheck(this, BrowserPersistenceClass);

    this.storageRetriever = storageRetriever;
    this.type = type;
  }

  _createClass(BrowserPersistenceClass, [{
    key: "_isAvailable",
    value: function _isAvailable() {
      try {
        if (!this.storage) {
          return Promise.resolve(false);
        }

        this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
        this.storage.removeItem(STORAGE_AVAILABLE_KEY);
        return Promise.resolve(true);
      } catch (_a) {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "_set",
    value: function _set(key, value) {
      this.storage.setItem(key, JSON.stringify(value));
      return Promise.resolve();
    }
  }, {
    key: "_get",
    value: function _get(key) {
      var json = this.storage.getItem(key);
      return Promise.resolve(json ? JSON.parse(json) : null);
    }
  }, {
    key: "_remove",
    value: function _remove(key) {
      this.storage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: "storage",
    get: function get() {
      return this.storageRetriever();
    }
  }]);

  return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _iframeCannotSyncWebStorage() {
  var ua = getUA();
  return _isSafari(ua) || _isIOS(ua);
} // The polling period in case events are not supported


var _POLLING_INTERVAL_MS$1 = 1000; // The IE 10 localStorage cross tab synchronization delay in milliseconds

var IE10_LOCAL_STORAGE_SYNC_DELAY = 10;

var BrowserLocalPersistence = /*#__PURE__*/function (_BrowserPersistenceCl) {
  _inherits(BrowserLocalPersistence, _BrowserPersistenceCl);

  var _super20 = _createSuper$2(BrowserLocalPersistence);

  function BrowserLocalPersistence() {
    var _this23;

    _classCallCheck(this, BrowserLocalPersistence);

    _this23 = _super20.call(this, function () {
      return window.localStorage;
    }, "LOCAL"
    /* PersistenceType.LOCAL */
    );

    _this23.boundEventHandler = function (event, poll) {
      return _this23.onStorageEvent(event, poll);
    };

    _this23.listeners = {};
    _this23.localCache = {}; // setTimeout return value is platform specific
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    _this23.pollTimer = null; // Safari or iOS browser and embedded in an iframe.

    _this23.safariLocalStorageNotSynced = _iframeCannotSyncWebStorage() && _isIframe(); // Whether to use polling instead of depending on window events

    _this23.fallbackToPolling = _isMobileBrowser();
    _this23._shouldAllowMigration = true;
    return _this23;
  }

  _createClass(BrowserLocalPersistence, [{
    key: "forAllChangedKeys",
    value: function forAllChangedKeys(cb) {
      // Check all keys with listeners on them.
      for (var _i = 0, _Object$keys = Object.keys(this.listeners); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Get value from localStorage.
        var newValue = this.storage.getItem(key);
        var oldValue = this.localCache[key]; // If local map value does not match, trigger listener with storage event.
        // Differentiate this simulated event from the real storage event.

        if (newValue !== oldValue) {
          cb(key, oldValue, newValue);
        }
      }
    }
  }, {
    key: "onStorageEvent",
    value: function onStorageEvent(event) {
      var _this24 = this;

      var poll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Key would be null in some situations, like when localStorage is cleared
      if (!event.key) {
        this.forAllChangedKeys(function (key, _oldValue, newValue) {
          _this24.notifyListeners(key, newValue);
        });
        return;
      }

      var key = event.key; // Check the mechanism how this event was detected.
      // The first event will dictate the mechanism to be used.

      if (poll) {
        // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
      } else {
        // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
      } // Safari embedded iframe. Storage event will trigger with the delta
      // changes but no changes will be applied to the iframe localStorage.


      if (this.safariLocalStorageNotSynced) {
        // Get current iframe page value.
        var _storedValue = this.storage.getItem(key); // Value not synchronized, synchronize manually.


        if (event.newValue !== _storedValue) {
          if (event.newValue !== null) {
            // Value changed from current value.
            this.storage.setItem(key, event.newValue);
          } else {
            // Current value deleted.
            this.storage.removeItem(key);
          }
        } else if (this.localCache[key] === event.newValue && !poll) {
          // Already detected and processed, do not trigger listeners again.
          return;
        }
      }

      var triggerListeners = function triggerListeners() {
        // Keep local map up to date in case storage event is triggered before
        // poll.
        var storedValue = _this24.storage.getItem(key);

        if (!poll && _this24.localCache[key] === storedValue) {
          // Real storage event which has already been detected, do nothing.
          // This seems to trigger in some IE browsers for some reason.
          return;
        }

        _this24.notifyListeners(key, storedValue);
      };

      var storedValue = this.storage.getItem(key);

      if (_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) {
        // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
      } else {
        triggerListeners();
      }
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(key, value) {
      this.localCache[key] = value;
      var listeners = this.listeners[key];

      if (listeners) {
        for (var _i2 = 0, _Array$from = Array.from(listeners); _i2 < _Array$from.length; _i2++) {
          var listener = _Array$from[_i2];
          listener(value ? JSON.parse(value) : value);
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this25 = this;

      this.stopPolling();
      this.pollTimer = setInterval(function () {
        _this25.forAllChangedKeys(function (key, oldValue, newValue) {
          _this25.onStorageEvent(new StorageEvent('storage', {
            key: key,
            oldValue: oldValue,
            newValue: newValue
          }),
          /* poll */
          true);
        });
      }, _POLLING_INTERVAL_MS$1);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      window.addEventListener('storage', this.boundEventHandler);
    }
  }, {
    key: "detachListener",
    value: function detachListener() {
      window.removeEventListener('storage', this.boundEventHandler);
    }
  }, {
    key: "_addListener",
    value: function _addListener(key, listener) {
      if (Object.keys(this.listeners).length === 0) {
        // Whether browser can detect storage event when it had already been pushed to the background.
        // This may happen in some mobile browsers. A localStorage change in the foreground window
        // will not be detected in the background window via the storage event.
        // This was detected in iOS 7.x mobile browsers
        if (this.fallbackToPolling) {
          this.startPolling();
        } else {
          this.attachListener();
        }
      }

      if (!this.listeners[key]) {
        this.listeners[key] = new Set(); // Populate the cache to avoid spuriously triggering on first poll.

        this.localCache[key] = this.storage.getItem(key);
      }

      this.listeners[key].add(listener);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(key, listener) {
      if (this.listeners[key]) {
        this.listeners[key]["delete"](listener);

        if (this.listeners[key].size === 0) {
          delete this.listeners[key];
        }
      }

      if (Object.keys(this.listeners).length === 0) {
        this.detachListener();
        this.stopPolling();
      }
    } // Update local cache on base operations:

  }, {
    key: "_set",
    value: function () {
      var _set3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee58(key, value) {
        return regenerator.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return _get(_getPrototypeOf(BrowserLocalPersistence.prototype), "_set", this).call(this, key, value);

              case 2:
                this.localCache[key] = JSON.stringify(value);

              case 3:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function _set(_x190, _x191) {
        return _set3.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee59(key) {
        var value;
        return regenerator.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return _get(_getPrototypeOf(BrowserLocalPersistence.prototype), "_get", this).call(this, key);

              case 2:
                value = _context59.sent;
                this.localCache[key] = JSON.stringify(value);
                return _context59.abrupt("return", value);

              case 5:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function _get$1(_x192) {
        return _get4.apply(this, arguments);
      }

      return _get$1;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee60(key) {
        return regenerator.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return _get(_getPrototypeOf(BrowserLocalPersistence.prototype), "_remove", this).call(this, key);

              case 2:
                delete this.localCache[key];

              case 3:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function _remove(_x193) {
        return _remove3.apply(this, arguments);
      }

      return _remove;
    }()
  }]);

  return BrowserLocalPersistence;
}(BrowserPersistenceClass);

BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */

var browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var BrowserSessionPersistence = /*#__PURE__*/function (_BrowserPersistenceCl2) {
  _inherits(BrowserSessionPersistence, _BrowserPersistenceCl2);

  var _super21 = _createSuper$2(BrowserSessionPersistence);

  function BrowserSessionPersistence() {
    _classCallCheck(this, BrowserSessionPersistence);

    return _super21.call(this, function () {
      return window.sessionStorage;
    }, "SESSION"
    /* PersistenceType.SESSION */
    );
  }

  _createClass(BrowserSessionPersistence, [{
    key: "_addListener",
    value: function _addListener(_key, _listener) {
      // Listeners are not supported for session storage since it cannot be shared across windows
      return;
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(_key, _listener) {
      // Listeners are not supported for session storage since it cannot be shared across windows
      return;
    }
  }]);

  return BrowserSessionPersistence;
}(BrowserPersistenceClass);

BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */

var browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */

function _allSettled(promises) {
  return Promise.all(promises.map( /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee61(promise) {
      var value;
      return regenerator.wrap(function _callee61$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              _context61.prev = 0;
              _context61.next = 3;
              return promise;

            case 3:
              value = _context61.sent;
              return _context61.abrupt("return", {
                fulfilled: true,
                value: value
              });

            case 7:
              _context61.prev = 7;
              _context61.t0 = _context61["catch"](0);
              return _context61.abrupt("return", {
                fulfilled: false,
                reason: _context61.t0
              });

            case 10:
            case "end":
              return _context61.stop();
          }
        }
      }, _callee61, null, [[0, 7]]);
    }));

    return function (_x194) {
      return _ref24.apply(this, arguments);
    };
  }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Interface class for receiving messages.
 *
 */


var Receiver = /*#__PURE__*/function () {
  function Receiver(eventTarget) {
    _classCallCheck(this, Receiver);

    this.eventTarget = eventTarget;
    this.handlersMap = {};
    this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */


  _createClass(Receiver, [{
    key: "isListeningto",
    value: function isListeningto(eventTarget) {
      return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */

  }, {
    key: "handleEvent",
    value: function () {
      var _handleEvent = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee63(event) {
        var messageEvent, _messageEvent$data, eventId, eventType, data, handlers, promises, response;

        return regenerator.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                messageEvent = event;
                _messageEvent$data = messageEvent.data, eventId = _messageEvent$data.eventId, eventType = _messageEvent$data.eventType, data = _messageEvent$data.data;
                handlers = this.handlersMap[eventType];

                if (handlers === null || handlers === void 0 ? void 0 : handlers.size) {
                  _context63.next = 5;
                  break;
                }

                return _context63.abrupt("return");

              case 5:
                messageEvent.ports[0].postMessage({
                  status: "ack"
                  /* _Status.ACK */
                  ,
                  eventId: eventId,
                  eventType: eventType
                });
                promises = Array.from(handlers).map( /*#__PURE__*/function () {
                  var _ref25 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee62(handler) {
                    return regenerator.wrap(function _callee62$(_context62) {
                      while (1) {
                        switch (_context62.prev = _context62.next) {
                          case 0:
                            return _context62.abrupt("return", handler(messageEvent.origin, data));

                          case 1:
                          case "end":
                            return _context62.stop();
                        }
                      }
                    }, _callee62);
                  }));

                  return function (_x196) {
                    return _ref25.apply(this, arguments);
                  };
                }());
                _context63.next = 9;
                return _allSettled(promises);

              case 9:
                response = _context63.sent;
                messageEvent.ports[0].postMessage({
                  status: "done"
                  /* _Status.DONE */
                  ,
                  eventId: eventId,
                  eventType: eventType,
                  response: response
                });

              case 11:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function handleEvent(_x195) {
        return _handleEvent.apply(this, arguments);
      }

      return handleEvent;
    }()
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */

  }, {
    key: "_subscribe",
    value: function _subscribe(eventType, eventHandler) {
      if (Object.keys(this.handlersMap).length === 0) {
        this.eventTarget.addEventListener('message', this.boundEventHandler);
      }

      if (!this.handlersMap[eventType]) {
        this.handlersMap[eventType] = new Set();
      }

      this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */

  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(eventType, eventHandler) {
      if (this.handlersMap[eventType] && eventHandler) {
        this.handlersMap[eventType]["delete"](eventHandler);
      }

      if (!eventHandler || this.handlersMap[eventType].size === 0) {
        delete this.handlersMap[eventType];
      }

      if (Object.keys(this.handlersMap).length === 0) {
        this.eventTarget.removeEventListener('message', this.boundEventHandler);
      }
    }
  }], [{
    key: "_getInstance",
    value: function _getInstance(eventTarget) {
      // The results are stored in an array since objects can't be keys for other
      // objects. In addition, setting a unique property on an event target as a
      // hash map key may not be allowed due to CORS restrictions.
      var existingInstance = this.receivers.find(function (receiver) {
        return receiver.isListeningto(eventTarget);
      });

      if (existingInstance) {
        return existingInstance;
      }

      var newInstance = new Receiver(eventTarget);
      this.receivers.push(newInstance);
      return newInstance;
    }
  }]);

  return Receiver;
}();

Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function _generateEventId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var random = '';

  for (var i = 0; i < digits; i++) {
    random += Math.floor(Math.random() * 10);
  }

  return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Interface for sending messages and waiting for a completion response.
 *
 */


var Sender = /*#__PURE__*/function () {
  function Sender(target) {
    _classCallCheck(this, Sender);

    this.target = target;
    this.handlers = new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */


  _createClass(Sender, [{
    key: "removeMessageHandler",
    value: function removeMessageHandler(handler) {
      if (handler.messageChannel) {
        handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
        handler.messageChannel.port1.close();
      }

      this.handlers["delete"](handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */

  }, {
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee64(eventType, data) {
        var _this26 = this;

        var timeout,
            messageChannel,
            completionTimer,
            handler,
            _args64 = arguments;
        return regenerator.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                timeout = _args64.length > 2 && _args64[2] !== undefined ? _args64[2] : 50;
                messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;

                if (messageChannel) {
                  _context64.next = 4;
                  break;
                }

                throw new Error("connection_unavailable"
                /* _MessageError.CONNECTION_UNAVAILABLE */
                );

              case 4:
                return _context64.abrupt("return", new Promise(function (resolve, reject) {
                  var eventId = _generateEventId('', 20);

                  messageChannel.port1.start();
                  var ackTimer = setTimeout(function () {
                    reject(new Error("unsupported_event"
                    /* _MessageError.UNSUPPORTED_EVENT */
                    ));
                  }, timeout);
                  handler = {
                    messageChannel: messageChannel,
                    onMessage: function onMessage(event) {
                      var messageEvent = event;

                      if (messageEvent.data.eventId !== eventId) {
                        return;
                      }

                      switch (messageEvent.data.status) {
                        case "ack"
                        /* _Status.ACK */
                        :
                          // The receiver should ACK first.
                          clearTimeout(ackTimer);
                          completionTimer = setTimeout(function () {
                            reject(new Error("timeout"
                            /* _MessageError.TIMEOUT */
                            ));
                          }, 3000
                          /* _TimeoutDuration.COMPLETION */
                          );
                          break;

                        case "done"
                        /* _Status.DONE */
                        :
                          // Once the receiver's handlers are finished we will get the results.
                          clearTimeout(completionTimer);
                          resolve(messageEvent.data.response);
                          break;

                        default:
                          clearTimeout(ackTimer);
                          clearTimeout(completionTimer);
                          reject(new Error("invalid_response"
                          /* _MessageError.INVALID_RESPONSE */
                          ));
                          break;
                      }
                    }
                  };

                  _this26.handlers.add(handler);

                  messageChannel.port1.addEventListener('message', handler.onMessage);

                  _this26.target.postMessage({
                    eventType: eventType,
                    eventId: eventId,
                    data: data
                  }, [messageChannel.port2]);
                })["finally"](function () {
                  if (handler) {
                    _this26.removeMessageHandler(handler);
                  }
                }));

              case 5:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64);
      }));

      function _send(_x197, _x198) {
        return _send2.apply(this, arguments);
      }

      return _send;
    }()
  }]);

  return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */


function _window() {
  return window;
}

function _setWindowLocation(url) {
  _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _isWorker() {
  return typeof _window()['WorkerGlobalScope'] !== 'undefined' && typeof _window()['importScripts'] === 'function';
}

function _getActiveServiceWorker() {
  return _getActiveServiceWorker2.apply(this, arguments);
}

function _getActiveServiceWorker2() {
  _getActiveServiceWorker2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee172() {
    var registration;
    return regenerator.wrap(function _callee172$(_context172) {
      while (1) {
        switch (_context172.prev = _context172.next) {
          case 0:
            if (navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) {
              _context172.next = 2;
              break;
            }

            return _context172.abrupt("return", null);

          case 2:
            _context172.prev = 2;
            _context172.next = 5;
            return navigator.serviceWorker.ready;

          case 5:
            registration = _context172.sent;
            return _context172.abrupt("return", registration.active);

          case 9:
            _context172.prev = 9;
            _context172.t0 = _context172["catch"](2);
            return _context172.abrupt("return", null);

          case 12:
          case "end":
            return _context172.stop();
        }
      }
    }, _callee172, null, [[2, 9]]);
  }));
  return _getActiveServiceWorker2.apply(this, arguments);
}

function _getServiceWorkerController() {
  var _a;

  return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}

function _getWorkerGlobalScope() {
  return _isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME$1 = 'firebaseLocalStorageDb';
var DB_VERSION$1 = 1;
var DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
var DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */

var DBPromise = /*#__PURE__*/function () {
  function DBPromise(request) {
    _classCallCheck(this, DBPromise);

    this.request = request;
  }

  _createClass(DBPromise, [{
    key: "toPromise",
    value: function toPromise() {
      var _this27 = this;

      return new Promise(function (resolve, reject) {
        _this27.request.addEventListener('success', function () {
          resolve(_this27.request.result);
        });

        _this27.request.addEventListener('error', function () {
          reject(_this27.request.error);
        });
      });
    }
  }]);

  return DBPromise;
}();

function getObjectStore(db, isReadWrite) {
  return db.transaction([DB_OBJECTSTORE_NAME], isReadWrite ? 'readwrite' : 'readonly').objectStore(DB_OBJECTSTORE_NAME);
}

function _deleteDatabase() {
  var request = indexedDB.deleteDatabase(DB_NAME$1);
  return new DBPromise(request).toPromise();
}

function _openDatabase() {
  var request = indexedDB.open(DB_NAME$1, DB_VERSION$1);
  return new Promise(function (resolve, reject) {
    request.addEventListener('error', function () {
      reject(request.error);
    });
    request.addEventListener('upgradeneeded', function () {
      var db = request.result;

      try {
        db.createObjectStore(DB_OBJECTSTORE_NAME, {
          keyPath: DB_DATA_KEYPATH
        });
      } catch (e) {
        reject(e);
      }
    });
    request.addEventListener('success', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee65() {
      var db;
      return regenerator.wrap(function _callee65$(_context65) {
        while (1) {
          switch (_context65.prev = _context65.next) {
            case 0:
              db = request.result; // Strange bug that occurs in Firefox when multiple tabs are opened at the
              // same time. The only way to recover seems to be deleting the database
              // and re-initializing it.
              // https://github.com/firebase/firebase-js-sdk/issues/634

              if (db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                _context65.next = 12;
                break;
              }

              // Need to close the database or else you get a `blocked` event
              db.close();
              _context65.next = 5;
              return _deleteDatabase();

            case 5:
              _context65.t0 = resolve;
              _context65.next = 8;
              return _openDatabase();

            case 8:
              _context65.t1 = _context65.sent;
              (0, _context65.t0)(_context65.t1);
              _context65.next = 13;
              break;

            case 12:
              resolve(db);

            case 13:
            case "end":
              return _context65.stop();
          }
        }
      }, _callee65);
    })));
  });
}

function _putObject(_x199, _x200, _x201) {
  return _putObject2.apply(this, arguments);
}

function _putObject2() {
  _putObject2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee173(db, key, value) {
    var _getObjectStore$put;

    var request;
    return regenerator.wrap(function _callee173$(_context173) {
      while (1) {
        switch (_context173.prev = _context173.next) {
          case 0:
            request = getObjectStore(db, true).put((_getObjectStore$put = {}, _defineProperty$1(_getObjectStore$put, DB_DATA_KEYPATH, key), _defineProperty$1(_getObjectStore$put, "value", value), _getObjectStore$put));
            return _context173.abrupt("return", new DBPromise(request).toPromise());

          case 2:
          case "end":
            return _context173.stop();
        }
      }
    }, _callee173);
  }));
  return _putObject2.apply(this, arguments);
}

function getObject(_x202, _x203) {
  return _getObject.apply(this, arguments);
}

function _getObject() {
  _getObject = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee174(db, key) {
    var request, data;
    return regenerator.wrap(function _callee174$(_context174) {
      while (1) {
        switch (_context174.prev = _context174.next) {
          case 0:
            request = getObjectStore(db, false).get(key);
            _context174.next = 3;
            return new DBPromise(request).toPromise();

          case 3:
            data = _context174.sent;
            return _context174.abrupt("return", data === undefined ? null : data.value);

          case 5:
          case "end":
            return _context174.stop();
        }
      }
    }, _callee174);
  }));
  return _getObject.apply(this, arguments);
}

function _deleteObject(db, key) {
  var request = getObjectStore(db, true)["delete"](key);
  return new DBPromise(request).toPromise();
}

var _POLLING_INTERVAL_MS = 800;
var _TRANSACTION_RETRY_COUNT = 3;

var IndexedDBLocalPersistence = /*#__PURE__*/function () {
  function IndexedDBLocalPersistence() {
    _classCallCheck(this, IndexedDBLocalPersistence);

    this.type = "LOCAL"
    /* PersistenceType.LOCAL */
    ;
    this._shouldAllowMigration = true;
    this.listeners = {};
    this.localCache = {}; // setTimeout return value is platform specific
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

    this.pollTimer = null;
    this.pendingWrites = 0;
    this.receiver = null;
    this.sender = null;
    this.serviceWorkerReceiverAvailable = false;
    this.activeServiceWorker = null; // Fire & forget the service worker registration as it may never resolve

    this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function () {}, function () {});
  }

  _createClass(IndexedDBLocalPersistence, [{
    key: "_openDb",
    value: function () {
      var _openDb2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee66() {
        return regenerator.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                if (!this.db) {
                  _context66.next = 2;
                  break;
                }

                return _context66.abrupt("return", this.db);

              case 2:
                _context66.next = 4;
                return _openDatabase();

              case 4:
                this.db = _context66.sent;
                return _context66.abrupt("return", this.db);

              case 6:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function _openDb() {
        return _openDb2.apply(this, arguments);
      }

      return _openDb;
    }()
  }, {
    key: "_withRetries",
    value: function () {
      var _withRetries2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee67(op) {
        var numAttempts, db;
        return regenerator.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                numAttempts = 0;

              case 1:

                _context67.prev = 2;
                _context67.next = 5;
                return this._openDb();

              case 5:
                db = _context67.sent;
                _context67.next = 8;
                return op(db);

              case 8:
                return _context67.abrupt("return", _context67.sent);

              case 11:
                _context67.prev = 11;
                _context67.t0 = _context67["catch"](2);

                if (!(numAttempts++ > _TRANSACTION_RETRY_COUNT)) {
                  _context67.next = 15;
                  break;
                }

                throw _context67.t0;

              case 15:
                if (this.db) {
                  this.db.close();
                  this.db = undefined;
                } // TODO: consider adding exponential backoff


              case 16:
                _context67.next = 1;
                break;

              case 18:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this, [[2, 11]]);
      }));

      function _withRetries(_x204) {
        return _withRetries2.apply(this, arguments);
      }

      return _withRetries;
    }()
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */

  }, {
    key: "initializeServiceWorkerMessaging",
    value: function () {
      var _initializeServiceWorkerMessaging = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee68() {
        return regenerator.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                return _context68.abrupt("return", _isWorker() ? this.initializeReceiver() : this.initializeSender());

              case 1:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function initializeServiceWorkerMessaging() {
        return _initializeServiceWorkerMessaging.apply(this, arguments);
      }

      return initializeServiceWorkerMessaging;
    }()
    /**
     * As the worker we should listen to events from the main window.
     */

  }, {
    key: "initializeReceiver",
    value: function () {
      var _initializeReceiver = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee71() {
        var _this28 = this;

        return regenerator.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                this.receiver = Receiver._getInstance(_getWorkerGlobalScope()); // Refresh from persistence if we receive a KeyChanged message.

                this.receiver._subscribe("keyChanged"
                /* _EventType.KEY_CHANGED */
                , /*#__PURE__*/function () {
                  var _ref27 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee69(_origin, data) {
                    var keys;
                    return regenerator.wrap(function _callee69$(_context69) {
                      while (1) {
                        switch (_context69.prev = _context69.next) {
                          case 0:
                            _context69.next = 2;
                            return _this28._poll();

                          case 2:
                            keys = _context69.sent;
                            return _context69.abrupt("return", {
                              keyProcessed: keys.includes(data.key)
                            });

                          case 4:
                          case "end":
                            return _context69.stop();
                        }
                      }
                    }, _callee69);
                  }));

                  return function (_x205, _x206) {
                    return _ref27.apply(this, arguments);
                  };
                }()); // Let the sender know that we are listening so they give us more timeout.


                this.receiver._subscribe("ping"
                /* _EventType.PING */
                , /*#__PURE__*/function () {
                  var _ref28 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee70(_origin, _data) {
                    return regenerator.wrap(function _callee70$(_context70) {
                      while (1) {
                        switch (_context70.prev = _context70.next) {
                          case 0:
                            return _context70.abrupt("return", ["keyChanged"
                            /* _EventType.KEY_CHANGED */
                            ]);

                          case 1:
                          case "end":
                            return _context70.stop();
                        }
                      }
                    }, _callee70);
                  }));

                  return function (_x207, _x208) {
                    return _ref28.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function initializeReceiver() {
        return _initializeReceiver.apply(this, arguments);
      }

      return initializeReceiver;
    }()
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */

  }, {
    key: "initializeSender",
    value: function () {
      var _initializeSender = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee72() {
        var _a, _b, results;

        return regenerator.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.next = 2;
                return _getActiveServiceWorker();

              case 2:
                this.activeServiceWorker = _context72.sent;

                if (this.activeServiceWorker) {
                  _context72.next = 5;
                  break;
                }

                return _context72.abrupt("return");

              case 5:
                this.sender = new Sender(this.activeServiceWorker); // Ping the service worker to check what events they can handle.

                _context72.next = 8;
                return this.sender._send("ping"
                /* _EventType.PING */
                , {}, 800
                /* _TimeoutDuration.LONG_ACK */
                );

              case 8:
                results = _context72.sent;

                if (results) {
                  _context72.next = 11;
                  break;
                }

                return _context72.abrupt("return");

              case 11:
                if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged"
                /* _EventType.KEY_CHANGED */
                ))) {
                  this.serviceWorkerReceiverAvailable = true;
                }

              case 12:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function initializeSender() {
        return _initializeSender.apply(this, arguments);
      }

      return initializeSender;
    }()
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */

  }, {
    key: "notifyServiceWorker",
    value: function () {
      var _notifyServiceWorker = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee73(key) {
        return regenerator.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                if (!(!this.sender || !this.activeServiceWorker || _getServiceWorkerController() !== this.activeServiceWorker)) {
                  _context73.next = 2;
                  break;
                }

                return _context73.abrupt("return");

              case 2:
                _context73.prev = 2;
                _context73.next = 5;
                return this.sender._send("keyChanged"
                /* _EventType.KEY_CHANGED */
                , {
                  key: key
                }, // Use long timeout if receiver has previously responded to a ping from us.
                this.serviceWorkerReceiverAvailable ? 800
                /* _TimeoutDuration.LONG_ACK */
                : 50
                /* _TimeoutDuration.ACK */
                );

              case 5:
                _context73.next = 9;
                break;

              case 7:
                _context73.prev = 7;
                _context73.t0 = _context73["catch"](2);

              case 9:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this, [[2, 7]]);
      }));

      function notifyServiceWorker(_x209) {
        return _notifyServiceWorker.apply(this, arguments);
      }

      return notifyServiceWorker;
    }()
  }, {
    key: "_isAvailable",
    value: function () {
      var _isAvailable3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee74() {
        var db;
        return regenerator.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.prev = 0;

                if (indexedDB) {
                  _context74.next = 3;
                  break;
                }

                return _context74.abrupt("return", false);

              case 3:
                _context74.next = 5;
                return _openDatabase();

              case 5:
                db = _context74.sent;
                _context74.next = 8;
                return _putObject(db, STORAGE_AVAILABLE_KEY, '1');

              case 8:
                _context74.next = 10;
                return _deleteObject(db, STORAGE_AVAILABLE_KEY);

              case 10:
                return _context74.abrupt("return", true);

              case 13:
                _context74.prev = 13;
                _context74.t0 = _context74["catch"](0);

              case 15:
                return _context74.abrupt("return", false);

              case 16:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, null, [[0, 13]]);
      }));

      function _isAvailable() {
        return _isAvailable3.apply(this, arguments);
      }

      return _isAvailable;
    }()
  }, {
    key: "_withPendingWrite",
    value: function () {
      var _withPendingWrite2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee75(write) {
        return regenerator.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                this.pendingWrites++;
                _context75.prev = 1;
                _context75.next = 4;
                return write();

              case 4:
                _context75.prev = 4;
                this.pendingWrites--;
                return _context75.finish(4);

              case 7:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this, [[1,, 4, 7]]);
      }));

      function _withPendingWrite(_x210) {
        return _withPendingWrite2.apply(this, arguments);
      }

      return _withPendingWrite;
    }()
  }, {
    key: "_set",
    value: function () {
      var _set4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee77(key, value) {
        var _this29 = this;

        return regenerator.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                return _context77.abrupt("return", this._withPendingWrite( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee76() {
                  return regenerator.wrap(function _callee76$(_context76) {
                    while (1) {
                      switch (_context76.prev = _context76.next) {
                        case 0:
                          _context76.next = 2;
                          return _this29._withRetries(function (db) {
                            return _putObject(db, key, value);
                          });

                        case 2:
                          _this29.localCache[key] = value;
                          return _context76.abrupt("return", _this29.notifyServiceWorker(key));

                        case 4:
                        case "end":
                          return _context76.stop();
                      }
                    }
                  }, _callee76);
                }))));

              case 1:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function _set(_x211, _x212) {
        return _set4.apply(this, arguments);
      }

      return _set;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee78(key) {
        var obj;
        return regenerator.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                _context78.next = 2;
                return this._withRetries(function (db) {
                  return getObject(db, key);
                });

              case 2:
                obj = _context78.sent;
                this.localCache[key] = obj;
                return _context78.abrupt("return", obj);

              case 5:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function _get(_x213) {
        return _get5.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_remove",
    value: function () {
      var _remove4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee80(key) {
        var _this30 = this;

        return regenerator.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                return _context80.abrupt("return", this._withPendingWrite( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee79() {
                  return regenerator.wrap(function _callee79$(_context79) {
                    while (1) {
                      switch (_context79.prev = _context79.next) {
                        case 0:
                          _context79.next = 2;
                          return _this30._withRetries(function (db) {
                            return _deleteObject(db, key);
                          });

                        case 2:
                          delete _this30.localCache[key];
                          return _context79.abrupt("return", _this30.notifyServiceWorker(key));

                        case 4:
                        case "end":
                          return _context79.stop();
                      }
                    }
                  }, _callee79);
                }))));

              case 1:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));

      function _remove(_x214) {
        return _remove4.apply(this, arguments);
      }

      return _remove;
    }()
  }, {
    key: "_poll",
    value: function () {
      var _poll2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee81() {
        var result, keys, keysInResult, _iterator5, _step5, _step5$value, key, value, _i3, _Object$keys2, localKey;

        return regenerator.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                _context81.next = 2;
                return this._withRetries(function (db) {
                  var getAllRequest = getObjectStore(db, false).getAll();
                  return new DBPromise(getAllRequest).toPromise();
                });

              case 2:
                result = _context81.sent;

                if (result) {
                  _context81.next = 5;
                  break;
                }

                return _context81.abrupt("return", []);

              case 5:
                if (!(this.pendingWrites !== 0)) {
                  _context81.next = 7;
                  break;
                }

                return _context81.abrupt("return", []);

              case 7:
                keys = [];
                keysInResult = new Set();

                if (result.length !== 0) {
                  _iterator5 = _createForOfIteratorHelper$3(result);

                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      _step5$value = _step5.value, key = _step5$value.fbase_key, value = _step5$value.value;
                      keysInResult.add(key);

                      if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                        this.notifyListeners(key, value);
                        keys.push(key);
                      }
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }

                for (_i3 = 0, _Object$keys2 = Object.keys(this.localCache); _i3 < _Object$keys2.length; _i3++) {
                  localKey = _Object$keys2[_i3];

                  if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                    // Deleted
                    this.notifyListeners(localKey, null);
                    keys.push(localKey);
                  }
                }

                return _context81.abrupt("return", keys);

              case 12:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function _poll() {
        return _poll2.apply(this, arguments);
      }

      return _poll;
    }()
  }, {
    key: "notifyListeners",
    value: function notifyListeners(key, newValue) {
      this.localCache[key] = newValue;
      var listeners = this.listeners[key];

      if (listeners) {
        for (var _i4 = 0, _Array$from2 = Array.from(listeners); _i4 < _Array$from2.length; _i4++) {
          var listener = _Array$from2[_i4];
          listener(newValue);
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this31 = this;

      this.stopPolling();
      this.pollTimer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee82() {
        return regenerator.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                return _context82.abrupt("return", _this31._poll());

              case 1:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82);
      })), _POLLING_INTERVAL_MS);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }
  }, {
    key: "_addListener",
    value: function _addListener(key, listener) {
      if (Object.keys(this.listeners).length === 0) {
        this.startPolling();
      }

      if (!this.listeners[key]) {
        this.listeners[key] = new Set(); // Populate the cache to avoid spuriously triggering on first poll.

        void this._get(key); // This can happen in the background async and we can return immediately.
      }

      this.listeners[key].add(listener);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(key, listener) {
      if (this.listeners[key]) {
        this.listeners[key]["delete"](listener);

        if (this.listeners[key].size === 0) {
          delete this.listeners[key];
        }
      }

      if (Object.keys(this.listeners).length === 0) {
        this.stopPolling();
      }
    }
  }]);

  return IndexedDBLocalPersistence;
}();

IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */

var indexedDBLocalPersistence = IndexedDBLocalPersistence;

new Delay(30000, 60000);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */

function _withDefaultResolver(auth, resolverOverride) {
  if (resolverOverride) {
    return _getInstance(resolverOverride);
  }

  _assert(auth._popupRedirectResolver, auth, "argument-error"
  /* AuthErrorCode.ARGUMENT_ERROR */
  );

  return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var IdpCredential = /*#__PURE__*/function (_AuthCredential5) {
  _inherits(IdpCredential, _AuthCredential5);

  var _super22 = _createSuper$2(IdpCredential);

  function IdpCredential(params) {
    var _this39;

    _classCallCheck(this, IdpCredential);

    _this39 = _super22.call(this, "custom"
    /* ProviderId.CUSTOM */
    , "custom"
    /* ProviderId.CUSTOM */
    );
    _this39.params = params;
    return _this39;
  }

  _createClass(IdpCredential, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(auth) {
      return signInWithIdp(auth, this._buildIdpRequest());
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(auth, idToken) {
      return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(auth) {
      return signInWithIdp(auth, this._buildIdpRequest());
    }
  }, {
    key: "_buildIdpRequest",
    value: function _buildIdpRequest(idToken) {
      var request = {
        requestUri: this.params.requestUri,
        sessionId: this.params.sessionId,
        postBody: this.params.postBody,
        tenantId: this.params.tenantId,
        pendingToken: this.params.pendingToken,
        returnSecureToken: true,
        returnIdpCredential: true
      };

      if (idToken) {
        request.idToken = idToken;
      }

      return request;
    }
  }]);

  return IdpCredential;
}(AuthCredential);

function _signIn(params) {
  return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}

function _reauth(params) {
  var auth = params.auth,
      user = params.user;

  _assert(user, auth, "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
  );

  return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}

function _link(_x231) {
  return _link2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */


function _link2() {
  _link2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee180(params) {
    var auth, user;
    return regenerator.wrap(function _callee180$(_context180) {
      while (1) {
        switch (_context180.prev = _context180.next) {
          case 0:
            auth = params.auth, user = params.user;

            _assert(user, auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            return _context180.abrupt("return", _link$1(user, new IdpCredential(params), params.bypassAuthState));

          case 3:
          case "end":
            return _context180.stop();
        }
      }
    }, _callee180);
  }));
  return _link2.apply(this, arguments);
}

var AbstractPopupRedirectOperation = /*#__PURE__*/function () {
  function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
    var bypassAuthState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, AbstractPopupRedirectOperation);

    this.auth = auth;
    this.resolver = resolver;
    this.user = user;
    this.bypassAuthState = bypassAuthState;
    this.pendingPromise = null;
    this.eventManager = null;
    this.filter = Array.isArray(filter) ? filter : [filter];
  }

  _createClass(AbstractPopupRedirectOperation, [{
    key: "execute",
    value: function execute() {
      var _this40 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref33 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee88(resolve, reject) {
          return regenerator.wrap(function _callee88$(_context88) {
            while (1) {
              switch (_context88.prev = _context88.next) {
                case 0:
                  _this40.pendingPromise = {
                    resolve: resolve,
                    reject: reject
                  };
                  _context88.prev = 1;
                  _context88.next = 4;
                  return _this40.resolver._initialize(_this40.auth);

                case 4:
                  _this40.eventManager = _context88.sent;
                  _context88.next = 7;
                  return _this40.onExecution();

                case 7:
                  _this40.eventManager.registerConsumer(_this40);

                  _context88.next = 13;
                  break;

                case 10:
                  _context88.prev = 10;
                  _context88.t0 = _context88["catch"](1);

                  _this40.reject(_context88.t0);

                case 13:
                case "end":
                  return _context88.stop();
              }
            }
          }, _callee88, null, [[1, 10]]);
        }));

        return function (_x232, _x233) {
          return _ref33.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "onAuthEvent",
    value: function () {
      var _onAuthEvent = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee89(event) {
        var urlResponse, sessionId, postBody, tenantId, error, type, params;
        return regenerator.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;

                if (!error) {
                  _context89.next = 4;
                  break;
                }

                this.reject(error);
                return _context89.abrupt("return");

              case 4:
                params = {
                  auth: this.auth,
                  requestUri: urlResponse,
                  sessionId: sessionId,
                  tenantId: tenantId || undefined,
                  postBody: postBody || undefined,
                  user: this.user,
                  bypassAuthState: this.bypassAuthState
                };
                _context89.prev = 5;
                _context89.t0 = this;
                _context89.next = 9;
                return this.getIdpTask(type)(params);

              case 9:
                _context89.t1 = _context89.sent;

                _context89.t0.resolve.call(_context89.t0, _context89.t1);

                _context89.next = 16;
                break;

              case 13:
                _context89.prev = 13;
                _context89.t2 = _context89["catch"](5);
                this.reject(_context89.t2);

              case 16:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this, [[5, 13]]);
      }));

      function onAuthEvent(_x234) {
        return _onAuthEvent.apply(this, arguments);
      }

      return onAuthEvent;
    }()
  }, {
    key: "onError",
    value: function onError(error) {
      this.reject(error);
    }
  }, {
    key: "getIdpTask",
    value: function getIdpTask(type) {
      switch (type) {
        case "signInViaPopup"
        /* AuthEventType.SIGN_IN_VIA_POPUP */
        :
        case "signInViaRedirect"
        /* AuthEventType.SIGN_IN_VIA_REDIRECT */
        :
          return _signIn;

        case "linkViaPopup"
        /* AuthEventType.LINK_VIA_POPUP */
        :
        case "linkViaRedirect"
        /* AuthEventType.LINK_VIA_REDIRECT */
        :
          return _link;

        case "reauthViaPopup"
        /* AuthEventType.REAUTH_VIA_POPUP */
        :
        case "reauthViaRedirect"
        /* AuthEventType.REAUTH_VIA_REDIRECT */
        :
          return _reauth;

        default:
          _fail(this.auth, "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
          );

      }
    }
  }, {
    key: "resolve",
    value: function resolve(cred) {
      debugAssert(this.pendingPromise, 'Pending promise was never set');
      this.pendingPromise.resolve(cred);
      this.unregisterAndCleanUp();
    }
  }, {
    key: "reject",
    value: function reject(error) {
      debugAssert(this.pendingPromise, 'Pending promise was never set');
      this.pendingPromise.reject(error);
      this.unregisterAndCleanUp();
    }
  }, {
    key: "unregisterAndCleanUp",
    value: function unregisterAndCleanUp() {
      if (this.eventManager) {
        this.eventManager.unregisterConsumer(this);
      }

      this.pendingPromise = null;
      this.cleanUp();
    }
  }]);

  return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */


function signInWithPopup(_x235, _x236, _x237) {
  return _signInWithPopup.apply(this, arguments);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */


function _signInWithPopup() {
  _signInWithPopup = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee181(auth, provider, resolver) {
    var authInternal, resolverInternal, action;
    return regenerator.wrap(function _callee181$(_context181) {
      while (1) {
        switch (_context181.prev = _context181.next) {
          case 0:
            if (!_isFirebaseServerApp(auth.app)) {
              _context181.next = 2;
              break;
            }

            return _context181.abrupt("return", Promise.reject(_createError(auth, "operation-not-supported-in-this-environment"
            /* AuthErrorCode.OPERATION_NOT_SUPPORTED */
            )));

          case 2:
            authInternal = _castAuth(auth);

            _assertInstanceOf(auth, provider, FederatedAuthProvider);

            resolverInternal = _withDefaultResolver(authInternal, resolver);
            action = new PopupOperation(authInternal, "signInViaPopup"
            /* AuthEventType.SIGN_IN_VIA_POPUP */
            , provider, resolverInternal);
            return _context181.abrupt("return", action.executeNotNull());

          case 7:
          case "end":
            return _context181.stop();
        }
      }
    }, _callee181);
  }));
  return _signInWithPopup.apply(this, arguments);
}

function reauthenticateWithPopup(_x238, _x239, _x240) {
  return _reauthenticateWithPopup.apply(this, arguments);
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */


function _reauthenticateWithPopup() {
  _reauthenticateWithPopup = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee182(user, provider, resolver) {
    var userInternal, resolverInternal, action;
    return regenerator.wrap(function _callee182$(_context182) {
      while (1) {
        switch (_context182.prev = _context182.next) {
          case 0:
            userInternal = getModularInstance(user);

            if (!_isFirebaseServerApp(userInternal.auth.app)) {
              _context182.next = 3;
              break;
            }

            return _context182.abrupt("return", Promise.reject(_createError(userInternal.auth, "operation-not-supported-in-this-environment"
            /* AuthErrorCode.OPERATION_NOT_SUPPORTED */
            )));

          case 3:
            _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);

            resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
            action = new PopupOperation(userInternal.auth, "reauthViaPopup"
            /* AuthEventType.REAUTH_VIA_POPUP */
            , provider, resolverInternal, userInternal);
            return _context182.abrupt("return", action.executeNotNull());

          case 7:
          case "end":
            return _context182.stop();
        }
      }
    }, _callee182);
  }));
  return _reauthenticateWithPopup.apply(this, arguments);
}

var PopupOperation = /*#__PURE__*/function (_AbstractPopupRedirec) {
  _inherits(PopupOperation, _AbstractPopupRedirec);

  var _super23 = _createSuper$2(PopupOperation);

  function PopupOperation(auth, filter, provider, resolver, user) {
    var _this41;

    _classCallCheck(this, PopupOperation);

    _this41 = _super23.call(this, auth, filter, resolver, user);
    _this41.provider = provider;
    _this41.authWindow = null;
    _this41.pollId = null;

    if (PopupOperation.currentPopupAction) {
      PopupOperation.currentPopupAction.cancel();
    }

    PopupOperation.currentPopupAction = _assertThisInitialized(_this41);
    return _this41;
  }

  _createClass(PopupOperation, [{
    key: "executeNotNull",
    value: function () {
      var _executeNotNull = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee90() {
        var result;
        return regenerator.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.next = 2;
                return this.execute();

              case 2:
                result = _context90.sent;

                _assert(result, this.auth, "internal-error"
                /* AuthErrorCode.INTERNAL_ERROR */
                );

                return _context90.abrupt("return", result);

              case 5:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function executeNotNull() {
        return _executeNotNull.apply(this, arguments);
      }

      return executeNotNull;
    }()
  }, {
    key: "onExecution",
    value: function () {
      var _onExecution = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee91() {
        var _this42 = this;

        var eventId;
        return regenerator.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
                eventId = _generateEventId();
                _context91.next = 4;
                return this.resolver._openPopup(this.auth, this.provider, this.filter[0], // There's always one, see constructor
                eventId);

              case 4:
                this.authWindow = _context91.sent;
                this.authWindow.associatedEvent = eventId; // Check for web storage support and origin validation _after_ the popup is
                // loaded. These operations are slow (~1 second or so) Rather than
                // waiting on them before opening the window, optimistically open the popup
                // and check for storage support at the same time. If storage support is
                // not available, this will cause the whole thing to reject properly. It
                // will also close the popup, but since the promise has already rejected,
                // the popup closed by user poll will reject into the void.

                this.resolver._originValidation(this.auth)["catch"](function (e) {
                  _this42.reject(e);
                });

                this.resolver._isIframeWebStorageSupported(this.auth, function (isSupported) {
                  if (!isSupported) {
                    _this42.reject(_createError(_this42.auth, "web-storage-unsupported"
                    /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
                    ));
                  }
                }); // Handle user closure. Notice this does *not* use await


                this.pollUserCancellation();

              case 9:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function onExecution() {
        return _onExecution.apply(this, arguments);
      }

      return onExecution;
    }()
  }, {
    key: "eventId",
    get: function get() {
      var _a;

      return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.reject(_createError(this.auth, "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
      ));
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      if (this.authWindow) {
        this.authWindow.close();
      }

      if (this.pollId) {
        window.clearTimeout(this.pollId);
      }

      this.authWindow = null;
      this.pollId = null;
      PopupOperation.currentPopupAction = null;
    }
  }, {
    key: "pollUserCancellation",
    value: function pollUserCancellation() {
      var _this43 = this;

      var poll = function poll() {
        var _a, _b;

        if ((_b = (_a = _this43.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
          // Make sure that there is sufficient time for whatever action to
          // complete. The window could have closed but the sign in network
          // call could still be in flight. This is specifically true for
          // Firefox or if the opener is in an iframe, in which case the oauth
          // helper closes the popup.
          _this43.pollId = window.setTimeout(function () {
            _this43.pollId = null;

            _this43.reject(_createError(_this43.auth, "popup-closed-by-user"
            /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          }, 8000
          /* _Timeout.AUTH_EVENT */
          );
          return;
        }

        _this43.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
      };

      poll();
    }
  }]);

  return PopupOperation;
}(AbstractPopupRedirectOperation); // Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.


PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var PENDING_REDIRECT_KEY = 'pendingRedirect'; // We only get one redirect outcome for any one auth, so just store it
// in here.

var redirectOutcomeMap = new Map();

var RedirectAction = /*#__PURE__*/function (_AbstractPopupRedirec2) {
  _inherits(RedirectAction, _AbstractPopupRedirec2);

  var _super24 = _createSuper$2(RedirectAction);

  function RedirectAction(auth, resolver) {
    var _this44;

    var bypassAuthState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, RedirectAction);

    _this44 = _super24.call(this, auth, ["signInViaRedirect"
    /* AuthEventType.SIGN_IN_VIA_REDIRECT */
    , "linkViaRedirect"
    /* AuthEventType.LINK_VIA_REDIRECT */
    , "reauthViaRedirect"
    /* AuthEventType.REAUTH_VIA_REDIRECT */
    , "unknown"
    /* AuthEventType.UNKNOWN */
    ], resolver, undefined, bypassAuthState);
    _this44.eventId = null;
    return _this44;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */


  _createClass(RedirectAction, [{
    key: "execute",
    value: function () {
      var _execute2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee92() {
        var readyOutcome, hasPendingRedirect, result;
        return regenerator.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                readyOutcome = redirectOutcomeMap.get(this.auth._key());

                if (readyOutcome) {
                  _context92.next = 21;
                  break;
                }

                _context92.prev = 2;
                _context92.next = 5;
                return _getAndClearPendingRedirectStatus(this.resolver, this.auth);

              case 5:
                hasPendingRedirect = _context92.sent;

                if (!hasPendingRedirect) {
                  _context92.next = 12;
                  break;
                }

                _context92.next = 9;
                return _get(_getPrototypeOf(RedirectAction.prototype), "execute", this).call(this);

              case 9:
                _context92.t0 = _context92.sent;
                _context92.next = 13;
                break;

              case 12:
                _context92.t0 = null;

              case 13:
                result = _context92.t0;

                readyOutcome = function readyOutcome() {
                  return Promise.resolve(result);
                };

                _context92.next = 20;
                break;

              case 17:
                _context92.prev = 17;
                _context92.t1 = _context92["catch"](2);

                readyOutcome = function readyOutcome() {
                  return Promise.reject(_context92.t1);
                };

              case 20:
                redirectOutcomeMap.set(this.auth._key(), readyOutcome);

              case 21:
                // If we're not bypassing auth state, the ready outcome should be set to
                // null.
                if (!this.bypassAuthState) {
                  redirectOutcomeMap.set(this.auth._key(), function () {
                    return Promise.resolve(null);
                  });
                }

                return _context92.abrupt("return", readyOutcome());

              case 23:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this, [[2, 17]]);
      }));

      function execute() {
        return _execute2.apply(this, arguments);
      }

      return execute;
    }()
  }, {
    key: "onAuthEvent",
    value: function () {
      var _onAuthEvent2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee93(event) {
        var user;
        return regenerator.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                if (!(event.type === "signInViaRedirect"
                /* AuthEventType.SIGN_IN_VIA_REDIRECT */
                )) {
                  _context93.next = 4;
                  break;
                }

                return _context93.abrupt("return", _get(_getPrototypeOf(RedirectAction.prototype), "onAuthEvent", this).call(this, event));

              case 4:
                if (!(event.type === "unknown"
                /* AuthEventType.UNKNOWN */
                )) {
                  _context93.next = 7;
                  break;
                }

                // This is a sentinel value indicating there's no pending redirect
                this.resolve(null);
                return _context93.abrupt("return");

              case 7:
                if (!event.eventId) {
                  _context93.next = 17;
                  break;
                }

                _context93.next = 10;
                return this.auth._redirectUserForId(event.eventId);

              case 10:
                user = _context93.sent;

                if (!user) {
                  _context93.next = 16;
                  break;
                }

                this.user = user;
                return _context93.abrupt("return", _get(_getPrototypeOf(RedirectAction.prototype), "onAuthEvent", this).call(this, event));

              case 16:
                this.resolve(null);

              case 17:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function onAuthEvent(_x244) {
        return _onAuthEvent2.apply(this, arguments);
      }

      return onAuthEvent;
    }()
  }, {
    key: "onExecution",
    value: function () {
      var _onExecution2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee94() {
        return regenerator.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94);
      }));

      function onExecution() {
        return _onExecution2.apply(this, arguments);
      }

      return onExecution;
    }()
  }, {
    key: "cleanUp",
    value: function cleanUp() {}
  }]);

  return RedirectAction;
}(AbstractPopupRedirectOperation);

function _getAndClearPendingRedirectStatus(_x245, _x246) {
  return _getAndClearPendingRedirectStatus2.apply(this, arguments);
}

function _getAndClearPendingRedirectStatus2() {
  _getAndClearPendingRedirectStatus2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee184(resolver, auth) {
    var key, persistence, hasPendingRedirect;
    return regenerator.wrap(function _callee184$(_context184) {
      while (1) {
        switch (_context184.prev = _context184.next) {
          case 0:
            key = pendingRedirectKey(auth);
            persistence = resolverPersistence(resolver);
            _context184.next = 4;
            return persistence._isAvailable();

          case 4:
            if (_context184.sent) {
              _context184.next = 6;
              break;
            }

            return _context184.abrupt("return", false);

          case 6:
            _context184.next = 8;
            return persistence._get(key);

          case 8:
            _context184.t0 = _context184.sent;
            hasPendingRedirect = _context184.t0 === 'true';
            _context184.next = 12;
            return persistence._remove(key);

          case 12:
            return _context184.abrupt("return", hasPendingRedirect);

          case 13:
          case "end":
            return _context184.stop();
        }
      }
    }, _callee184);
  }));
  return _getAndClearPendingRedirectStatus2.apply(this, arguments);
}

function _overrideRedirectResult(auth, result) {
  redirectOutcomeMap.set(auth._key(), result);
}

function resolverPersistence(resolver) {
  return _getInstance(resolver._redirectPersistence);
}

function pendingRedirectKey(auth) {
  return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}

function _getRedirectResult(_x260, _x261) {
  return _getRedirectResult3.apply(this, arguments);
}

function _getRedirectResult3() {
  _getRedirectResult3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee190(auth, resolverExtern) {
    var bypassAuthState,
        authInternal,
        resolver,
        action,
        result,
        _args190 = arguments;
    return regenerator.wrap(function _callee190$(_context190) {
      while (1) {
        switch (_context190.prev = _context190.next) {
          case 0:
            bypassAuthState = _args190.length > 2 && _args190[2] !== undefined ? _args190[2] : false;

            if (!_isFirebaseServerApp(auth.app)) {
              _context190.next = 3;
              break;
            }

            return _context190.abrupt("return", Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth)));

          case 3:
            authInternal = _castAuth(auth);
            resolver = _withDefaultResolver(authInternal, resolverExtern);
            action = new RedirectAction(authInternal, resolver, bypassAuthState);
            _context190.next = 8;
            return action.execute();

          case 8:
            result = _context190.sent;

            if (!(result && !bypassAuthState)) {
              _context190.next = 15;
              break;
            }

            delete result.user._redirectEventId;
            _context190.next = 13;
            return authInternal._persistUserIfCurrent(result.user);

          case 13:
            _context190.next = 15;
            return authInternal._setRedirectUser(null, resolverExtern);

          case 15:
            return _context190.abrupt("return", result);

          case 16:
          case "end":
            return _context190.stop();
        }
      }
    }, _callee190);
  }));
  return _getRedirectResult3.apply(this, arguments);
}

var EVENT_DUPLICATION_CACHE_DURATION_MS = 10 * 60 * 1000;

var AuthEventManager = /*#__PURE__*/function () {
  function AuthEventManager(auth) {
    _classCallCheck(this, AuthEventManager);

    this.auth = auth;
    this.cachedEventUids = new Set();
    this.consumers = new Set();
    this.queuedRedirectEvent = null;
    this.hasHandledPotentialRedirect = false;
    this.lastProcessedEventTime = Date.now();
  }

  _createClass(AuthEventManager, [{
    key: "registerConsumer",
    value: function registerConsumer(authEventConsumer) {
      this.consumers.add(authEventConsumer);

      if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
        this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
        this.saveEventToCache(this.queuedRedirectEvent);
        this.queuedRedirectEvent = null;
      }
    }
  }, {
    key: "unregisterConsumer",
    value: function unregisterConsumer(authEventConsumer) {
      this.consumers["delete"](authEventConsumer);
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var _this45 = this;

      // Check if the event has already been handled
      if (this.hasEventBeenHandled(event)) {
        return false;
      }

      var handled = false;
      this.consumers.forEach(function (consumer) {
        if (_this45.isEventForConsumer(event, consumer)) {
          handled = true;

          _this45.sendToConsumer(event, consumer);

          _this45.saveEventToCache(event);
        }
      });

      if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) {
        // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
      }

      this.hasHandledPotentialRedirect = true; // If the redirect wasn't handled, hang on to it

      if (!handled) {
        this.queuedRedirectEvent = event;
        handled = true;
      }

      return handled;
    }
  }, {
    key: "sendToConsumer",
    value: function sendToConsumer(event, consumer) {
      var _a;

      if (event.error && !isNullRedirectEvent(event)) {
        var code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        ;
        consumer.onError(_createError(this.auth, code));
      } else {
        consumer.onAuthEvent(event);
      }
    }
  }, {
    key: "isEventForConsumer",
    value: function isEventForConsumer(event, consumer) {
      var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
      return consumer.filter.includes(event.type) && eventIdMatches;
    }
  }, {
    key: "hasEventBeenHandled",
    value: function hasEventBeenHandled(event) {
      if (Date.now() - this.lastProcessedEventTime >= EVENT_DUPLICATION_CACHE_DURATION_MS) {
        this.cachedEventUids.clear();
      }

      return this.cachedEventUids.has(eventUid(event));
    }
  }, {
    key: "saveEventToCache",
    value: function saveEventToCache(event) {
      this.cachedEventUids.add(eventUid(event));
      this.lastProcessedEventTime = Date.now();
    }
  }]);

  return AuthEventManager;
}();

function eventUid(e) {
  return [e.type, e.eventId, e.sessionId, e.tenantId].filter(function (v) {
    return v;
  }).join('-');
}

function isNullRedirectEvent(_ref34) {
  var type = _ref34.type,
      error = _ref34.error;
  return type === "unknown"
  /* AuthEventType.UNKNOWN */
  && (error === null || error === void 0 ? void 0 : error.code) === "auth/".concat("no-auth-event"
  /* AuthErrorCode.NO_AUTH_EVENT */
  );
}

function isRedirectEvent(event) {
  switch (event.type) {
    case "signInViaRedirect"
    /* AuthEventType.SIGN_IN_VIA_REDIRECT */
    :
    case "linkViaRedirect"
    /* AuthEventType.LINK_VIA_REDIRECT */
    :
    case "reauthViaRedirect"
    /* AuthEventType.REAUTH_VIA_REDIRECT */
    :
      return true;

    case "unknown"
    /* AuthEventType.UNKNOWN */
    :
      return isNullRedirectEvent(event);

    default:
      return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getProjectConfig(_x263) {
  return _getProjectConfig2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _getProjectConfig2() {
  _getProjectConfig2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee192(auth) {
    var request,
        _args192 = arguments;
    return regenerator.wrap(function _callee192$(_context192) {
      while (1) {
        switch (_context192.prev = _context192.next) {
          case 0:
            request = _args192.length > 1 && _args192[1] !== undefined ? _args192[1] : {};
            return _context192.abrupt("return", _performApiRequest(auth, "GET"
            /* HttpMethod.GET */
            , "/v1/projects"
            /* Endpoint.GET_PROJECT_CONFIG */
            , request));

          case 2:
          case "end":
            return _context192.stop();
        }
      }
    }, _callee192);
  }));
  return _getProjectConfig2.apply(this, arguments);
}

var IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var HTTP_REGEX = /^https?/;

function _validateOrigin(_x264) {
  return _validateOrigin2.apply(this, arguments);
}

function _validateOrigin2() {
  _validateOrigin2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee193(auth) {
    var _yield$_getProjectCon, authorizedDomains, _iterator6, _step6, domain;

    return regenerator.wrap(function _callee193$(_context193) {
      while (1) {
        switch (_context193.prev = _context193.next) {
          case 0:
            if (!auth.config.emulator) {
              _context193.next = 2;
              break;
            }

            return _context193.abrupt("return");

          case 2:
            _context193.next = 4;
            return _getProjectConfig(auth);

          case 4:
            _yield$_getProjectCon = _context193.sent;
            authorizedDomains = _yield$_getProjectCon.authorizedDomains;
            _iterator6 = _createForOfIteratorHelper$3(authorizedDomains);
            _context193.prev = 7;

            _iterator6.s();

          case 9:
            if ((_step6 = _iterator6.n()).done) {
              _context193.next = 20;
              break;
            }

            domain = _step6.value;
            _context193.prev = 11;

            if (!matchDomain(domain)) {
              _context193.next = 14;
              break;
            }

            return _context193.abrupt("return");

          case 14:
            _context193.next = 18;
            break;

          case 16:
            _context193.prev = 16;
            _context193.t0 = _context193["catch"](11);

          case 18:
            _context193.next = 9;
            break;

          case 20:
            _context193.next = 25;
            break;

          case 22:
            _context193.prev = 22;
            _context193.t1 = _context193["catch"](7);

            _iterator6.e(_context193.t1);

          case 25:
            _context193.prev = 25;

            _iterator6.f();

            return _context193.finish(25);

          case 28:
            // In the old SDK, this error also provides helpful messages.
            _fail(auth, "unauthorized-domain"
            /* AuthErrorCode.INVALID_ORIGIN */
            );

          case 29:
          case "end":
            return _context193.stop();
        }
      }
    }, _callee193, null, [[7, 22, 25, 28], [11, 16]]);
  }));
  return _validateOrigin2.apply(this, arguments);
}

function matchDomain(expected) {
  var currentUrl = _getCurrentUrl();

  var _URL = new URL(currentUrl),
      protocol = _URL.protocol,
      hostname = _URL.hostname;

  if (expected.startsWith('chrome-extension://')) {
    var ceUrl = new URL(expected);

    if (ceUrl.hostname === '' && hostname === '') {
      // For some reason we're not parsing chrome URLs properly
      return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
    }

    return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
  }

  if (!HTTP_REGEX.test(protocol)) {
    return false;
  }

  if (IP_ADDRESS_REGEX.test(expected)) {
    // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
  } // Dots in pattern should be escaped.


  var escapedDomainPattern = expected.replace(/\./g, '\\.'); // Non ip address domains.
  // domain.com = *.domain.com OR domain.com

  var re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
  return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */

function resetUnloadedGapiModules() {
  // Clear last failed gapi.load state to force next gapi.load to first
  // load the failed gapi.iframes module.
  // Get gapix.beacon context.
  var beacon = _window().___jsl; // Get current hint.


  if (beacon === null || beacon === void 0 ? void 0 : beacon.H) {
    // Get gapi hint.
    for (var _i5 = 0, _Object$keys3 = Object.keys(beacon.H); _i5 < _Object$keys3.length; _i5++) {
      var hint = _Object$keys3[_i5];
      // Requested modules.
      beacon.H[hint].r = beacon.H[hint].r || []; // Loaded modules.

      beacon.H[hint].L = beacon.H[hint].L || []; // Set requested modules to a copy of the loaded modules.

      beacon.H[hint].r = _toConsumableArray(beacon.H[hint].L); // Clear pending callbacks.

      if (beacon.CP) {
        for (var i = 0; i < beacon.CP.length; i++) {
          // Remove all failed pending callbacks.
          beacon.CP[i] = null;
        }
      }
    }
  }
}

function loadGapi(auth) {
  return new Promise(function (resolve, reject) {
    var _a, _b, _c; // Function to run when gapi.load is ready.


    function loadGapiIframe() {
      // The developer may have tried to previously run gapi.load and failed.
      // Run this to fix that.
      resetUnloadedGapiModules();
      gapi.load('gapi.iframes', {
        callback: function callback() {
          resolve(gapi.iframes.getContext());
        },
        ontimeout: function ontimeout() {
          // The above reset may be sufficient, but having this reset after
          // failure ensures that if the developer calls gapi.load after the
          // connection is re-established and before another attempt to embed
          // the iframe, it would work and would not be broken because of our
          // failed attempt.
          // Timeout when gapi.iframes.Iframe not loaded.
          resetUnloadedGapiModules();
          reject(_createError(auth, "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: NETWORK_TIMEOUT.get()
      });
    }

    if ((_b = (_a = _window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) {
      // If gapi.iframes.Iframe available, resolve.
      resolve(gapi.iframes.getContext());
    } else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) {
      // Gapi loader ready, load gapi.iframes.
      loadGapiIframe();
    } else {
      // Create a new iframe callback when this is called so as not to overwrite
      // any previous defined callback. This happens if this method is called
      // multiple times in parallel and could result in the later callback
      // overwriting the previous one. This would end up with a iframe
      // timeout.
      var cbName = _generateCallbackName('iframefcb'); // GApi loader not available, dynamically load platform.js.


      _window()[cbName] = function () {
        // GApi loader should be ready.
        if (!!gapi.load) {
          loadGapiIframe();
        } else {
          // Gapi loader failed, throw error.
          reject(_createError(auth, "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        }
      }; // Load GApi loader.


      return _loadJS("".concat(_gapiScriptUrl(), "?onload=").concat(cbName))["catch"](function (e) {
        return reject(e);
      });
    }
  })["catch"](function (error) {
    // Reset cached promise to allow for retrial.
    cachedGApiLoader = null;
    throw error;
  });
}

var cachedGApiLoader = null;

function _loadGapi(auth) {
  cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
  return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var PING_TIMEOUT = new Delay(5000, 15000);
var IFRAME_PATH = '__/auth/iframe';
var EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
var IFRAME_ATTRIBUTES = {
  style: {
    position: 'absolute',
    top: '-100px',
    width: '1px',
    height: '1px'
  },
  'aria-hidden': 'true',
  tabindex: '-1'
}; // Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.

var EID_FROM_APIHOST = new Map([["identitytoolkit.googleapis.com"
/* DefaultConfig.API_HOST */
, 'p'], ['staging-identitytoolkit.sandbox.googleapis.com', 's'], ['test-identitytoolkit.sandbox.googleapis.com', 't'] // test
]);

function getIframeUrl(auth) {
  var config = auth.config;

  _assert(config.authDomain, auth, "auth-domain-config-required"
  /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );

  var url = config.emulator ? _emulatorUrl(config, EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat(IFRAME_PATH);
  var params = {
    apiKey: config.apiKey,
    appName: auth.name,
    v: SDK_VERSION
  };
  var eid = EID_FROM_APIHOST.get(auth.config.apiHost);

  if (eid) {
    params.eid = eid;
  }

  var frameworks = auth._getFrameworks();

  if (frameworks.length) {
    params.fw = frameworks.join(',');
  }

  return "".concat(url, "?").concat(querystring(params).slice(1));
}

function _openIframe(_x265) {
  return _openIframe2.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _openIframe2() {
  _openIframe2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee195(auth) {
    var context, gapi;
    return regenerator.wrap(function _callee195$(_context195) {
      while (1) {
        switch (_context195.prev = _context195.next) {
          case 0:
            _context195.next = 2;
            return _loadGapi(auth);

          case 2:
            context = _context195.sent;
            gapi = _window().gapi;

            _assert(gapi, auth, "internal-error"
            /* AuthErrorCode.INTERNAL_ERROR */
            );

            return _context195.abrupt("return", context.open({
              where: document.body,
              url: getIframeUrl(auth),
              messageHandlersFilter: gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
              attributes: IFRAME_ATTRIBUTES,
              dontclear: true
            }, function (iframe) {
              return new Promise( /*#__PURE__*/function () {
                var _ref45 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee194(resolve, reject) {
                  var networkError, networkErrorTimer, clearTimerAndResolve;
                  return regenerator.wrap(function _callee194$(_context194) {
                    while (1) {
                      switch (_context194.prev = _context194.next) {
                        case 0:
                          clearTimerAndResolve = function _clearTimerAndResolve() {
                            _window().clearTimeout(networkErrorTimer);

                            resolve(iframe);
                          };

                          _context194.next = 3;
                          return iframe.restyle({
                            // Prevent iframe from closing on mouse out.
                            setHideOnLeave: false
                          });

                        case 3:
                          networkError = _createError(auth, "network-request-failed"
                          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
                          ); // Confirm iframe is correctly loaded.
                          // To fallback on failure, set a timeout.

                          networkErrorTimer = _window().setTimeout(function () {
                            reject(networkError);
                          }, PING_TIMEOUT.get()); // Clear timer and resolve pending iframe ready promise.

                          // This returns an IThenable. However the reject part does not call
                          // when the iframe is not loaded.
                          iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function () {
                            reject(networkError);
                          });

                        case 6:
                        case "end":
                          return _context194.stop();
                      }
                    }
                  }, _callee194);
                }));

                return function (_x291, _x292) {
                  return _ref45.apply(this, arguments);
                };
              }());
            }));

          case 6:
          case "end":
            return _context195.stop();
        }
      }
    }, _callee195);
  }));
  return _openIframe2.apply(this, arguments);
}

var BASE_POPUP_OPTIONS = {
  location: 'yes',
  resizable: 'yes',
  statusbar: 'yes',
  toolbar: 'no'
};
var DEFAULT_WIDTH = 500;
var DEFAULT_HEIGHT = 600;
var TARGET_BLANK = '_blank';
var FIREFOX_EMPTY_URL = 'http://localhost';

var AuthPopup = /*#__PURE__*/function () {
  function AuthPopup(window) {
    _classCallCheck(this, AuthPopup);

    this.window = window;
    this.associatedEvent = null;
  }

  _createClass(AuthPopup, [{
    key: "close",
    value: function close() {
      if (this.window) {
        try {
          this.window.close();
        } catch (e) {}
      }
    }
  }]);

  return AuthPopup;
}();

function _open(auth, url, name) {
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_WIDTH;
  var height = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_HEIGHT;
  var top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
  var left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
  var target = '';
  var options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), {
    width: width.toString(),
    height: height.toString(),
    top: top,
    left: left
  }); // Chrome iOS 7 and 8 is returning an undefined popup win when target is
  // specified, even though the popup is not necessarily blocked.

  var ua = getUA().toLowerCase();

  if (name) {
    target = _isChromeIOS(ua) ? TARGET_BLANK : name;
  }

  if (_isFirefox(ua)) {
    // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
    url = url || FIREFOX_EMPTY_URL; // Firefox disables by default scrolling on popup windows, which can create
    // issues when the user has many Google accounts, for instance.

    options.scrollbars = 'yes';
  }

  var optionsString = Object.entries(options).reduce(function (accum, _ref35) {
    var _ref36 = _slicedToArray(_ref35, 2),
        key = _ref36[0],
        value = _ref36[1];

    return "".concat(accum).concat(key, "=").concat(value, ",");
  }, '');

  if (_isIOSStandalone(ua) && target !== '_self') {
    openAsNewWindowIOS(url || '', target);
    return new AuthPopup(null);
  } // about:blank getting sanitized causing browsers like IE/Edge to display
  // brief error message before redirecting to handler.


  var newWin = window.open(url || '', target, optionsString);

  _assert(newWin, auth, "popup-blocked"
  /* AuthErrorCode.POPUP_BLOCKED */
  ); // Flaky on IE edge, encapsulate with a try and catch.


  try {
    newWin.focus();
  } catch (e) {}

  return new AuthPopup(newWin);
}

function openAsNewWindowIOS(url, target) {
  var el = document.createElement('a');
  el.href = url;
  el.target = target;
  var click = document.createEvent('MouseEvent');
  click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
  el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */


var WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */

var EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */

var FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');

function _getRedirectUrl(_x266, _x267, _x268, _x269, _x270, _x271) {
  return _getRedirectUrl2.apply(this, arguments);
}

function _getRedirectUrl2() {
  _getRedirectUrl2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee196(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    var params, _i6, _Object$entries, _Object$entries$_i, key, value, scopes, paramsDict, _i7, _Object$keys4, _key8, appCheckToken, appCheckTokenFragment;

    return regenerator.wrap(function _callee196$(_context196) {
      while (1) {
        switch (_context196.prev = _context196.next) {
          case 0:
            _assert(auth.config.authDomain, auth, "auth-domain-config-required"
            /* AuthErrorCode.MISSING_AUTH_DOMAIN */
            );

            _assert(auth.config.apiKey, auth, "invalid-api-key"
            /* AuthErrorCode.INVALID_API_KEY */
            );

            params = {
              apiKey: auth.config.apiKey,
              appName: auth.name,
              authType: authType,
              redirectUrl: redirectUrl,
              v: SDK_VERSION,
              eventId: eventId
            };

            if (provider instanceof FederatedAuthProvider) {
              provider.setDefaultLanguage(auth.languageCode);
              params.providerId = provider.providerId || '';

              if (!isEmpty$1(provider.getCustomParameters())) {
                params.customParameters = JSON.stringify(provider.getCustomParameters());
              } // TODO set additionalParams from the provider as well?


              for (_i6 = 0, _Object$entries = Object.entries(additionalParams || {}); _i6 < _Object$entries.length; _i6++) {
                _Object$entries$_i = _slicedToArray(_Object$entries[_i6], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                params[key] = value;
              }
            }

            if (provider instanceof BaseOAuthProvider) {
              scopes = provider.getScopes().filter(function (scope) {
                return scope !== '';
              });

              if (scopes.length > 0) {
                params.scopes = scopes.join(',');
              }
            }

            if (auth.tenantId) {
              params.tid = auth.tenantId;
            } // TODO: maybe set eid as endipointId
            // TODO: maybe set fw as Frameworks.join(",")


            paramsDict = params;

            for (_i7 = 0, _Object$keys4 = Object.keys(paramsDict); _i7 < _Object$keys4.length; _i7++) {
              _key8 = _Object$keys4[_i7];

              if (paramsDict[_key8] === undefined) {
                delete paramsDict[_key8];
              }
            } // Sets the App Check token to pass to the widget


            _context196.next = 10;
            return auth._getAppCheckToken();

          case 10:
            appCheckToken = _context196.sent;
            appCheckTokenFragment = appCheckToken ? "#".concat(FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : ''; // Start at index 1 to skip the leading '&' in the query string

            return _context196.abrupt("return", "".concat(getHandlerBase(auth), "?").concat(querystring(paramsDict).slice(1)).concat(appCheckTokenFragment));

          case 13:
          case "end":
            return _context196.stop();
        }
      }
    }, _callee196);
  }));
  return _getRedirectUrl2.apply(this, arguments);
}

function getHandlerBase(_ref37) {
  var config = _ref37.config;

  if (!config.emulator) {
    return "https://".concat(config.authDomain, "/").concat(WIDGET_PATH);
  }

  return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The special web storage event
 *
 */


var WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';

var BrowserPopupRedirectResolver = /*#__PURE__*/function () {
  function BrowserPopupRedirectResolver() {
    _classCallCheck(this, BrowserPopupRedirectResolver);

    this.eventManagers = {};
    this.iframes = {};
    this.originValidationPromises = {};
    this._redirectPersistence = browserSessionPersistence;
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  } // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections


  _createClass(BrowserPopupRedirectResolver, [{
    key: "_openPopup",
    value: function () {
      var _openPopup2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee95(auth, provider, authType, eventId) {
        var _a, url;

        return regenerator.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                debugAssert((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
                _context95.next = 3;
                return _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);

              case 3:
                url = _context95.sent;
                return _context95.abrupt("return", _open(auth, url, _generateEventId()));

              case 5:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));

      function _openPopup(_x272, _x273, _x274, _x275) {
        return _openPopup2.apply(this, arguments);
      }

      return _openPopup;
    }()
  }, {
    key: "_openRedirect",
    value: function () {
      var _openRedirect2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee96(auth, provider, authType, eventId) {
        var url;
        return regenerator.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                _context96.next = 2;
                return this._originValidation(auth);

              case 2:
                _context96.next = 4;
                return _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);

              case 4:
                url = _context96.sent;

                _setWindowLocation(url);

                return _context96.abrupt("return", new Promise(function () {}));

              case 7:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function _openRedirect(_x276, _x277, _x278, _x279) {
        return _openRedirect2.apply(this, arguments);
      }

      return _openRedirect;
    }()
  }, {
    key: "_initialize",
    value: function _initialize(auth) {
      var _this46 = this;

      var key = auth._key();

      if (this.eventManagers[key]) {
        var _this$eventManagers$k = this.eventManagers[key],
            manager = _this$eventManagers$k.manager,
            _promise = _this$eventManagers$k.promise;

        if (manager) {
          return Promise.resolve(manager);
        } else {
          debugAssert(_promise, 'If manager is not set, promise should be');
          return _promise;
        }
      }

      var promise = this.initAndGetManager(auth);
      this.eventManagers[key] = {
        promise: promise
      }; // If the promise is rejected, the key should be removed so that the
      // operation can be retried later.

      promise["catch"](function () {
        delete _this46.eventManagers[key];
      });
      return promise;
    }
  }, {
    key: "initAndGetManager",
    value: function () {
      var _initAndGetManager = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee97(auth) {
        var iframe, manager;
        return regenerator.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                _context97.next = 2;
                return _openIframe(auth);

              case 2:
                iframe = _context97.sent;
                manager = new AuthEventManager(auth);
                iframe.register('authEvent', function (iframeEvent) {
                  _assert(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event"
                  /* AuthErrorCode.INVALID_AUTH_EVENT */
                  ); // TODO: Consider splitting redirect and popup events earlier on


                  var handled = manager.onEvent(iframeEvent.authEvent);
                  return {
                    status: handled ? "ACK"
                    /* GapiOutcome.ACK */
                    : "ERROR"
                    /* GapiOutcome.ERROR */

                  };
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                this.eventManagers[auth._key()] = {
                  manager: manager
                };
                this.iframes[auth._key()] = iframe;
                return _context97.abrupt("return", manager);

              case 8:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function initAndGetManager(_x280) {
        return _initAndGetManager.apply(this, arguments);
      }

      return initAndGetManager;
    }()
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(auth, cb) {
      var iframe = this.iframes[auth._key()];

      iframe.send(WEB_STORAGE_SUPPORT_KEY, {
        type: WEB_STORAGE_SUPPORT_KEY
      }, function (result) {
        var _a;

        var isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[WEB_STORAGE_SUPPORT_KEY];

        if (isSupported !== undefined) {
          cb(!!isSupported);
        }

        _fail(auth, "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        );
      }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(auth) {
      var key = auth._key();

      if (!this.originValidationPromises[key]) {
        this.originValidationPromises[key] = _validateOrigin(auth);
      }

      return this.originValidationPromises[key];
    }
  }, {
    key: "_shouldInitProactively",
    get: function get() {
      // Mobile browsers and Safari need to optimistically initialize
      return _isMobileBrowser() || _isSafari() || _isIOS();
    }
  }]);

  return BrowserPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */


var browserPopupRedirectResolver = BrowserPopupRedirectResolver;

var name$2 = "@firebase/auth";
var version$2 = "1.7.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var AuthInterop = /*#__PURE__*/function () {
  function AuthInterop(auth) {
    _classCallCheck(this, AuthInterop);

    this.auth = auth;
    this.internalListeners = new Map();
  }

  _createClass(AuthInterop, [{
    key: "getUid",
    value: function getUid() {
      var _a;

      this.assertAuthConfigured();
      return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
  }, {
    key: "getToken",
    value: function () {
      var _getToken2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee101(forceRefresh) {
        var accessToken;
        return regenerator.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                this.assertAuthConfigured();
                _context101.next = 3;
                return this.auth._initializationPromise;

              case 3:
                if (this.auth.currentUser) {
                  _context101.next = 5;
                  break;
                }

                return _context101.abrupt("return", null);

              case 5:
                _context101.next = 7;
                return this.auth.currentUser.getIdToken(forceRefresh);

              case 7:
                accessToken = _context101.sent;
                return _context101.abrupt("return", {
                  accessToken: accessToken
                });

              case 9:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function getToken(_x287) {
        return _getToken2.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "addAuthTokenListener",
    value: function addAuthTokenListener(listener) {
      this.assertAuthConfigured();

      if (this.internalListeners.has(listener)) {
        return;
      }

      var unsubscribe = this.auth.onIdTokenChanged(function (user) {
        listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
      });
      this.internalListeners.set(listener, unsubscribe);
      this.updateProactiveRefresh();
    }
  }, {
    key: "removeAuthTokenListener",
    value: function removeAuthTokenListener(listener) {
      this.assertAuthConfigured();
      var unsubscribe = this.internalListeners.get(listener);

      if (!unsubscribe) {
        return;
      }

      this.internalListeners["delete"](listener);
      unsubscribe();
      this.updateProactiveRefresh();
    }
  }, {
    key: "assertAuthConfigured",
    value: function assertAuthConfigured() {
      _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
      );
    }
  }, {
    key: "updateProactiveRefresh",
    value: function updateProactiveRefresh() {
      if (this.internalListeners.size > 0) {
        this.auth._startProactiveRefresh();
      } else {
        this.auth._stopProactiveRefresh();
      }
    }
  }]);

  return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getVersionForPlatform(clientPlatform) {
  switch (clientPlatform) {
    case "Node"
    /* ClientPlatform.NODE */
    :
      return 'node';

    case "ReactNative"
    /* ClientPlatform.REACT_NATIVE */
    :
      return 'rn';

    case "Worker"
    /* ClientPlatform.WORKER */
    :
      return 'webworker';

    case "Cordova"
    /* ClientPlatform.CORDOVA */
    :
      return 'cordova';

    case "WebExtension"
    /* ClientPlatform.WEB_EXTENSION */
    :
      return 'web-extension';

    default:
      return undefined;
  }
}
/** @internal */


function registerAuth(clientPlatform) {
  _registerComponent(new Component("auth"
  /* _ComponentName.AUTH */
  , function (container, _ref38) {
    var deps = _ref38.options;
    var app = container.getProvider('app').getImmediate();
    var heartbeatServiceProvider = container.getProvider('heartbeat');
    var appCheckServiceProvider = container.getProvider('app-check-internal');
    var _app$options = app.options,
        apiKey = _app$options.apiKey,
        authDomain = _app$options.authDomain;

    _assert(apiKey && !apiKey.includes(':'), "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
    , {
      appName: app.name
    });

    var config = {
      apiKey: apiKey,
      authDomain: authDomain,
      clientPlatform: clientPlatform,
      apiHost: "identitytoolkit.googleapis.com"
      /* DefaultConfig.API_HOST */
      ,
      tokenApiHost: "securetoken.googleapis.com"
      /* DefaultConfig.TOKEN_API_HOST */
      ,
      apiScheme: "https"
      /* DefaultConfig.API_SCHEME */
      ,
      sdkClientVersion: _getClientVersion(clientPlatform)
    };
    var authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);

    _initializeAuthInstance(authInstance, deps);

    return authInstance;
  }, "PUBLIC"
  /* ComponentType.PUBLIC */
  )
  /**
   * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
   * For why we do this, See go/firebase-next-auth-init
   */
  .setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  )
  /**
   * Because all firebase products that depend on auth depend on auth-internal directly,
   * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
   */
  .setInstanceCreatedCallback(function (container, _instanceIdentifier, _instance) {
    var authInternalProvider = container.getProvider("auth-internal"
    /* _ComponentName.AUTH_INTERNAL */
    );
    authInternalProvider.initialize();
  }));

  _registerComponent(new Component("auth-internal"
  /* _ComponentName.AUTH_INTERNAL */
  , function (container) {
    var auth = _castAuth(container.getProvider("auth"
    /* _ComponentName.AUTH */
    ).getImmediate());

    return function (auth) {
      return new AuthInterop(auth);
    }(auth);
  }, "PRIVATE"
  /* ComponentType.PRIVATE */
  ).setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  ));

  registerVersion(name$2, version$2, getVersionForPlatform(clientPlatform)); // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation

  registerVersion(name$2, version$2, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ID_TOKEN_MAX_AGE = 5 * 60;
var authIdTokenMaxAge = getExperimentalSetting('authIdTokenMaxAge') || DEFAULT_ID_TOKEN_MAX_AGE;
var lastPostedIdToken = null;

var mintCookieFactory = function mintCookieFactory(url) {
  return /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee102(user) {
      var idTokenResult, idTokenAge, idToken;
      return regenerator.wrap(function _callee102$(_context102) {
        while (1) {
          switch (_context102.prev = _context102.next) {
            case 0:
              _context102.t0 = user;

              if (!_context102.t0) {
                _context102.next = 5;
                break;
              }

              _context102.next = 4;
              return user.getIdTokenResult();

            case 4:
              _context102.t0 = _context102.sent;

            case 5:
              idTokenResult = _context102.t0;
              idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;

              if (!(idTokenAge && idTokenAge > authIdTokenMaxAge)) {
                _context102.next = 9;
                break;
              }

              return _context102.abrupt("return");

            case 9:
              // Specifically trip null => undefined when logged out, to delete any existing cookie
              idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;

              if (!(lastPostedIdToken === idToken)) {
                _context102.next = 12;
                break;
              }

              return _context102.abrupt("return");

            case 12:
              lastPostedIdToken = idToken;
              _context102.next = 15;
              return fetch(url, {
                method: idToken ? 'POST' : 'DELETE',
                headers: idToken ? {
                  'Authorization': "Bearer ".concat(idToken)
                } : {}
              });

            case 15:
            case "end":
              return _context102.stop();
          }
        }
      }, _callee102);
    }));

    return function (_x288) {
      return _ref39.apply(this, arguments);
    };
  }();
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */


function getAuth() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();

  var provider = _getProvider(app, 'auth');

  if (provider.isInitialized()) {
    return provider.getImmediate();
  }

  var auth = initializeAuth(app, {
    popupRedirectResolver: browserPopupRedirectResolver,
    persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence]
  });
  var authTokenSyncPath = getExperimentalSetting('authTokenSyncURL'); // Only do the Cookie exchange in a secure context

  if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
    // Don't allow urls (XSS possibility), only paths on the same domain
    var authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);

    if (location.origin === authTokenSyncUrl.origin) {
      var mintCookie = mintCookieFactory(authTokenSyncUrl.toString());
      beforeAuthStateChanged(auth, mintCookie, function () {
        return mintCookie(auth.currentUser);
      });
      onIdTokenChanged(auth, function (user) {
        return mintCookie(user);
      });
    }
  }

  var authEmulatorHost = getDefaultEmulatorHost('auth');

  if (authEmulatorHost) {
    connectAuthEmulator(auth, "http://".concat(authEmulatorHost));
  }

  return auth;
}

function getScriptParentElement() {
  var _a, _b;

  return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}

_setExternalJSProvider({
  loadJS: function loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise(function (resolve, reject) {
      var el = document.createElement('script');
      el.setAttribute('src', url);
      el.onload = resolve;

      el.onerror = function (e) {
        var error = _createError("internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
        );

        error.customData = e;
        reject(error);
      };

      el.type = 'text/javascript';
      el.charset = 'UTF-8';
      getScriptParentElement().appendChild(el);
    });
  },
  gapiScript: 'https://apis.google.com/js/api.js',
  recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
  recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});

registerAuth("Browser"
/* ClientPlatform.BROWSER */
);

/** Used for built-in method references. */
var objectProto$g = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$g;
  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;

var isPrototype$3 = _isPrototype,
    nativeKeys = _nativeKeys;
/** Used for built-in method references. */

var objectProto$f = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$d = objectProto$f.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$d.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys$2;

var freeGlobal$1 = _typeof(commonjsGlobal$2) == 'object' && commonjsGlobal$2 && commonjsGlobal$2.Object === Object && commonjsGlobal$2;
var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$8 = freeGlobal || freeSelf || Function('return this')();
var _root = root$8;

var root$7 = _root;
/** Built-in value references. */

var _Symbol2 = root$7.Symbol;
var _Symbol$5 = _Symbol2;

var _Symbol$4 = _Symbol$5;
/** Used for built-in method references. */

var objectProto$e = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$c = objectProto$e.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$e.toString;
/** Built-in value references. */

var symToStringTag$1 = _Symbol$4 ? _Symbol$4.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag$1(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$d.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var _Symbol$3 = _Symbol$5,
    getRawTag = _getRawTag,
    objectToString = _objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = _Symbol$3 ? _Symbol$3.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

function isObject$5(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$5;

var baseGetTag$4 = _baseGetTag,
    isObject$4 = isObject_1;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag$4(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;
/** Used to detect overreaching core-js shims. */

var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$3 = isObject_1,
    toSource$1 = _toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$c = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$b = objectProto$c.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$b).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative$1(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$5 = _root;
/* Built-in method references that are verified to be native. */

var DataView$2 = getNative$6(root$5, 'DataView');
var _DataView = DataView$2;

var getNative$5 = _getNative,
    root$4 = _root;
/* Built-in method references that are verified to be native. */

var Map$4 = getNative$5(root$4, 'Map');
var _Map = Map$4;

var getNative$4 = _getNative,
    root$3 = _root;
/* Built-in method references that are verified to be native. */

var Promise$2 = getNative$4(root$3, 'Promise');
var _Promise = Promise$2;

var getNative$3 = _getNative,
    root$2 = _root;
/* Built-in method references that are verified to be native. */

var Set$2 = getNative$3(root$2, 'Set');
var _Set = Set$2;

var getNative$2 = _getNative,
    root$1 = _root;
/* Built-in method references that are verified to be native. */

var WeakMap$2 = getNative$2(root$1, 'WeakMap');
var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$3 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$3 = _baseGetTag,
    toSource = _toSource;
/** `Object#toString` result references. */

var mapTag$6 = '[object Map]',
    objectTag$3 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$2 = '[object WeakMap]';
var dataViewTag$4 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$3),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag$5 = baseGetTag$3; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$1 && getTag$5(new DataView$1(new ArrayBuffer(1))) != dataViewTag$4 || Map$3 && getTag$5(new Map$3()) != mapTag$6 || Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag || Set$1 && getTag$5(new Set$1()) != setTag$6 || WeakMap$1 && getTag$5(new WeakMap$1()) != weakMapTag$2) {
  getTag$5 = function getTag(value) {
    var result = baseGetTag$3(value),
        Ctor = result == objectTag$3 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$4;

        case mapCtorString:
          return mapTag$6;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$6;

        case weakMapCtorString:
          return weakMapTag$2;
      }
    }

    return result;
  };
}

var _getTag = getTag$5;

function isObjectLike$7(value) {
  return value != null && _typeof(value) == 'object';
}

var isObjectLike_1 = isObjectLike$7;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$6 = isObjectLike_1;
/** `Object#toString` result references. */

var argsTag$3 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments$1(value) {
  return isObjectLike$6(value) && baseGetTag$2(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$5 = isObjectLike_1;
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$b.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments$3 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$5(value) && hasOwnProperty$a.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$3;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$a = Array.isArray;
var isArray_1 = isArray$a;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$3;

var isFunction = isFunction_1,
    isLength$2 = isLength_1;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike$3(value) {
  return value != null && isLength$2(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$3;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
  var root = _root,
      stubFalse = stubFalse_1;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse;
  module.exports = isBuffer;
})(isBuffer$4, isBuffer$4.exports);

var baseGetTag$1 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$4 = isObjectLike_1;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray$1(value) {
  return isObjectLike$4(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$3(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$3;

var _nodeUtil = {exports: {}};

(function (module, exports) {
  var freeGlobal = _freeGlobal;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray$3 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;

var baseKeys$1 = _baseKeys,
    getTag$4 = _getTag,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isArrayLike$2 = isArrayLike_1,
    isBuffer$3 = isBuffer$4.exports,
    isPrototype$2 = _isPrototype,
    isTypedArray$2 = isTypedArray_1;
/** `Object#toString` result references. */

var mapTag$4 = '[object Map]',
    setTag$4 = '[object Set]';
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */

function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (isArrayLike$2(value) && (isArray$9(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$3(value) || isTypedArray$2(value) || isArguments$2(value))) {
    return !value.length;
  }

  var tag = getTag$4(value);

  if (tag == mapTag$4 || tag == setTag$4) {
    return !value.size;
  }

  if (isPrototype$2(value)) {
    return !baseKeys$1(value).length;
  }

  for (var key in value) {
    if (hasOwnProperty$9.call(value, key)) {
      return false;
    }
  }

  return true;
}

var isEmpty_1 = isEmpty;

class ShopifyService {
    constructor(config) {
        this.isMultipassEnabled = () => this.config.hasMultipass;
        this.generateMultipassLink = (email) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.isMultipassEnabled())
                    return {
                        success: false,
                        message: 'Multipass disabled',
                        code: '405',
                    };
                if (!this.config.multipassAuthReturnTo)
                    return {
                        success: false,
                        message: 'multipassAuthReturnTo parameter is missing',
                        code: 'multipassAuthReturnToMissing',
                    };
                if (!window)
                    return {
                        success: false,
                        message: 'Problem with client session occured - no window detected',
                        code: '500',
                    };
                const data = {
                    email,
                    return_to: this.config.multipassAuthReturnTo,
                };
                const response = yield axios('/api/shopify/multipass', {
                    method: 'POST',
                    data,
                });
                if (!response.data.success)
                    return response.data;
                return {
                    success: true,
                    url: response.data.url,
                };
            }
            catch (e) {
                return {
                    success: false,
                    message: e.message,
                    code: e.code,
                };
            }
        });
        this.signIn = (multipassUrl) => {
            window.location.href = multipassUrl;
        };
        this.getUserIdByEmail = ({ clientEmail, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const query = `email:${clientEmail}`;
                const apiPath = `/customers/search.json?query=${query}`;
                const config = {
                    data: {
                        apiPath,
                        method: 'GET',
                    },
                };
                const response = yield axios.post('/api/shopify/admin-api', config);
                return response.data;
            }
            catch (e) {
                return {
                    success: false,
                    message: e.message,
                    code: e.code,
                };
            }
        });
        this.getUserData = ({ clientId, scope, }) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const baseApiUrl = `/customers/${clientId}`;
                const apiPath = scope ? `${baseApiUrl}/${scope}.json` : baseApiUrl;
                const config = {
                    data: {
                        apiPath,
                        method: 'GET',
                    },
                };
                const response = yield axios.post('/api/shopify/admin-api', config);
                return {
                    orders: response.data.data.orders,
                    success: response.data.success,
                    code: (_a = response.data.code) === null || _a === void 0 ? void 0 : _a.toString(),
                };
            }
            catch (e) {
                return {
                    success: false,
                    message: e.message,
                    code: e.code,
                };
            }
        });
        this.config = config;
    }
}

var FieldCategory;
(function (FieldCategory) {
    FieldCategory["Technical"] = "technical";
    FieldCategory["DeliveryAddresses"] = "deliveryAddresses";
    FieldCategory["UserDetails"] = "userDetails";
    FieldCategory["Security"] = "security";
    FieldCategory["OrderHistory"] = "orderHistory";
    FieldCategory["AdditionalDeliveryAddresses"] = "additionalDeliveryAddresses";
})(FieldCategory || (FieldCategory = {}));
var LdsSystem;
(function (LdsSystem) {
    LdsSystem["Health"] = "Health";
    LdsSystem["Hyho"] = "Hyho";
})(LdsSystem || (LdsSystem = {}));
var InputType;
(function (InputType) {
    InputType["textbox"] = "textbox";
    InputType["password"] = "password";
    InputType["date"] = "date";
    InputType["checkbox"] = "checkbox";
    InputType["radio"] = "radio";
    InputType["textarea"] = "textarea";
    InputType["phone"] = "phone";
})(InputType || (InputType = {}));
var OobMode;
(function (OobMode) {
    OobMode["verifyEmail"] = "verifyEmail";
    OobMode["recoverEmail"] = "recoverEmail";
    OobMode["resetPassword"] = "resetPassword";
    OobMode["verifyAndChangeEmail"] = "verifyAndChangeEmail";
})(OobMode || (OobMode = {}));
var Events;
(function (Events) {
    Events["onConfirmSignUp"] = "onConfirmSignUp ";
    Events["onAuthStateChange"] = "onAuthStateChange";
    Events["onTermsChanged"] = "onTermsChanged";
    Events["onLdsConfirmation"] = "onLdsConfirmation";
    Events["onDeleteAccount"] = "onDeleteAccount";
})(Events || (Events = {}));
var ThirdPartyProvider;
(function (ThirdPartyProvider) {
    ThirdPartyProvider["Google"] = "Google";
    ThirdPartyProvider["Facebook"] = "Facebook";
})(ThirdPartyProvider || (ThirdPartyProvider = {}));
var UserIdentifierType;
(function (UserIdentifierType) {
    UserIdentifierType[UserIdentifierType["Email"] = 0] = "Email";
})(UserIdentifierType || (UserIdentifierType = {}));

class DefaultLdsService {
    constructor(ldsConfig) {
        this.ldsConfig = ldsConfig;
        this.getSocialLds = () => __awaiter(this, void 0, void 0, function* () {
            const lds = yield this.getLds();
            const socialLegals = lds
                .filter(({ socialTerm }) => socialTerm)
                .map(({ businessId }) => businessId);
            return this.createLdsFields(socialLegals);
        });
        this.createLdsFields = (legals) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!Array.isArray(legals)) {
                return [];
            }
            const ldsArray = yield this.getLds();
            return ((_a = ldsArray
                .filter(({ businessId }) => legals.includes(businessId))
                .map(({ businessId, isRequired, description, validFrom, validTo, versionId, }) => ({
                system: this.ldsConfig.system.toString(),
                acceptanceDate: new Date().toISOString(),
                businessId,
                versionId,
                validFrom: validFrom === null || validFrom === void 0 ? void 0 : validFrom.toISOString(),
                validTo: validTo === null || validTo === void 0 ? void 0 : validTo.toISOString(),
                description,
                isRequired,
                accepted: true,
            }))) !== null && _a !== void 0 ? _a : []);
        });
        this.getLds = () => this.getLdsPromise;
        this.getLdsByBusinessId = (businessId) => __awaiter(this, void 0, void 0, function* () {
            const ldsList = yield this.getLdsPromise;
            return ldsList.find(({ businessId: bId }) => bId === businessId);
        });
        this.dispatchEventIfLegalsUpdated = (lds, isExternalProviderUser) => __awaiter(this, void 0, void 0, function* () {
            const updatedLds = yield this.getUpdatedLds(lds, isExternalProviderUser);
            if (updatedLds === null || updatedLds === void 0 ? void 0 : updatedLds.length) {
                window.dispatchEvent(new CustomEvent(Events.onTermsChanged, {
                    detail: { updatedLds, visible: true },
                }));
            }
        });
        this.getMissingLegalsForProfileEdit = (attributes) => __awaiter(this, void 0, void 0, function* () {
            const siteLegals = yield this.getLds();
            const acceptedLegals = attributes ? this.getAcceptedLegals(attributes) : {};
            return siteLegals.filter((siteLegal) => !siteLegal.socialTerm &&
                siteLegal.isRequired &&
                (!(siteLegal.businessId in acceptedLegals) ||
                    acceptedLegals[siteLegal.businessId] !== siteLegal.versionId));
        });
        this.getAcceptedLegals = (attributes) => {
            var _a;
            const userLegals = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.lds) !== null && _a !== void 0 ? _a : [];
            return userLegals
                .filter(({ accepted }) => accepted)
                .reduce((result, { businessId, versionId }) => {
                const newResult = Object.assign(result, {});
                newResult[businessId] = versionId;
                return newResult;
            }, {});
        };
        this.getUpdatedLds = (userLegals, isExternalProviderUser) => __awaiter(this, void 0, void 0, function* () {
            const ldsList = yield this.getLdsPromise;
            return ldsList.filter((currentLds) => {
                const { businessId, versionId, isRequired, socialTerm } = currentLds;
                const userLds = userLegals.find((legal) => legal.businessId === businessId);
                const requiredNotAccepted = !userLds &&
                    isRequired &&
                    (isExternalProviderUser ? socialTerm : !socialTerm);
                const versionUpdated = userLds && userLds.versionId !== versionId;
                return versionUpdated || requiredNotAccepted;
            });
        });
        this.getLdsData = () => Promise.resolve(this.ldsConfig.legals.map((legal) => (Object.assign(Object.assign({}, legal), { system: this.ldsConfig.system }))));
        this.getLdsPromise = this.getLdsData();
    }
}

var name$1 = "firebase";
var version$1 = "10.12.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

registerVersion(name$1, version$1, 'app');

var _ERRORS;

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var APP_CHECK_STATES = new Map();
var DEFAULT_STATE = {
  activated: false,
  tokenObservers: []
};
var DEBUG_STATE = {
  initialized: false,
  enabled: false
};
/**
 * Gets a reference to the state object.
 */

function getStateReference(app) {
  return APP_CHECK_STATES.get(app) || Object.assign({}, DEFAULT_STATE);
}
/**
 * Set once on initialization. The map should hold the same reference to the
 * same object until this entry is deleted.
 */


function setInitialState(app, state) {
  APP_CHECK_STATES.set(app, state);
  return APP_CHECK_STATES.get(app);
}

function getDebugState() {
  return DEBUG_STATE;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var BASE_ENDPOINT = 'https://content-firebaseappcheck.googleapis.com/v1';
var EXCHANGE_RECAPTCHA_TOKEN_METHOD = 'exchangeRecaptchaV3Token';
var EXCHANGE_DEBUG_TOKEN_METHOD = 'exchangeDebugToken';
var TOKEN_REFRESH_TIME = {
  /**
   * The offset time before token natural expiration to run the refresh.
   * This is currently 5 minutes.
   */
  OFFSET_DURATION: 5 * 60 * 1000,

  /**
   * This is the first retrial wait after an error. This is currently
   * 30 seconds.
   */
  RETRIAL_MIN_WAIT: 30 * 1000,

  /**
   * This is the maximum retrial wait, currently 16 minutes.
   */
  RETRIAL_MAX_WAIT: 16 * 60 * 1000
};
/**
 * One day in millis, for certain error code backoffs.
 */

var ONE_DAY = 24 * 60 * 60 * 1000;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Port from auth proactiverefresh.js
 *
 */
// TODO: move it to @firebase/util?
// TODO: allow to config whether refresh should happen in the background

var Refresher = /*#__PURE__*/function () {
  function Refresher(operation, retryPolicy, getWaitDuration, lowerBound, upperBound) {
    _classCallCheck(this, Refresher);

    this.operation = operation;
    this.retryPolicy = retryPolicy;
    this.getWaitDuration = getWaitDuration;
    this.lowerBound = lowerBound;
    this.upperBound = upperBound;
    this.pending = null;
    this.nextErrorWaitInterval = lowerBound;

    if (lowerBound > upperBound) {
      throw new Error('Proactive refresh lower bound greater than upper bound!');
    }
  }

  _createClass(Refresher, [{
    key: "start",
    value: function start() {
      this.nextErrorWaitInterval = this.lowerBound;
      this.process(true)["catch"](function () {
        /* we don't care about the result */
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.pending) {
        this.pending.reject('cancelled');
        this.pending = null;
      }
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return !!this.pending;
    }
  }, {
    key: "process",
    value: function () {
      var _process = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(hasSucceeded) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.stop();
                _context.prev = 1;
                this.pending = new Deferred();
                this.pending.promise["catch"](function (_e) {
                  /* ignore */
                });
                _context.next = 6;
                return sleep(this.getNextRun(hasSucceeded));

              case 6:
                // Why do we resolve a promise, then immediate wait for it?
                // We do it to make the promise chain cancellable.
                // We can call stop() which rejects the promise before the following line execute, which makes
                // the code jump to the catch block.
                // TODO: unit test this
                this.pending.resolve();
                _context.next = 9;
                return this.pending.promise;

              case 9:
                this.pending = new Deferred();
                this.pending.promise["catch"](function (_e) {
                  /* ignore */
                });
                _context.next = 13;
                return this.operation();

              case 13:
                this.pending.resolve();
                _context.next = 16;
                return this.pending.promise;

              case 16:
                this.process(true)["catch"](function () {
                  /* we don't care about the result */
                });
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](1);

                if (this.retryPolicy(_context.t0)) {
                  this.process(false)["catch"](function () {
                    /* we don't care about the result */
                  });
                } else {
                  this.stop();
                }

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 19]]);
      }));

      function process(_x) {
        return _process.apply(this, arguments);
      }

      return process;
    }()
  }, {
    key: "getNextRun",
    value: function getNextRun(hasSucceeded) {
      if (hasSucceeded) {
        // If last operation succeeded, reset next error wait interval and return
        // the default wait duration.
        this.nextErrorWaitInterval = this.lowerBound; // Return typical wait duration interval after a successful operation.

        return this.getWaitDuration();
      } else {
        // Get next error wait interval.
        var currentErrorWaitInterval = this.nextErrorWaitInterval; // Double interval for next consecutive error.

        this.nextErrorWaitInterval *= 2; // Make sure next wait interval does not exceed the maximum upper bound.

        if (this.nextErrorWaitInterval > this.upperBound) {
          this.nextErrorWaitInterval = this.upperBound;
        }

        return currentErrorWaitInterval;
      }
    }
  }]);

  return Refresher;
}();

function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERRORS = (_ERRORS = {}, _defineProperty$1(_ERRORS, "already-initialized"
/* AppCheckError.ALREADY_INITIALIZED */
, 'You have already called initializeAppCheck() for FirebaseApp {$appName} with ' + 'different options. To avoid this error, call initializeAppCheck() with the ' + 'same options as when it was originally called. This will return the ' + 'already initialized instance.'), _defineProperty$1(_ERRORS, "use-before-activation"
/* AppCheckError.USE_BEFORE_ACTIVATION */
, 'App Check is being used before initializeAppCheck() is called for FirebaseApp {$appName}. ' + 'Call initializeAppCheck() before instantiating other Firebase services.'), _defineProperty$1(_ERRORS, "fetch-network-error"
/* AppCheckError.FETCH_NETWORK_ERROR */
, 'Fetch failed to connect to a network. Check Internet connection. ' + 'Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS, "fetch-parse-error"
/* AppCheckError.FETCH_PARSE_ERROR */
, 'Fetch client could not parse response.' + ' Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS, "fetch-status-error"
/* AppCheckError.FETCH_STATUS_ERROR */
, 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.'), _defineProperty$1(_ERRORS, "storage-open"
/* AppCheckError.STORAGE_OPEN */
, 'Error thrown when opening storage. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS, "storage-get"
/* AppCheckError.STORAGE_GET */
, 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS, "storage-set"
/* AppCheckError.STORAGE_WRITE */
, 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.'), _defineProperty$1(_ERRORS, "recaptcha-error"
/* AppCheckError.RECAPTCHA_ERROR */
, 'ReCAPTCHA error.'), _defineProperty$1(_ERRORS, "throttled"
/* AppCheckError.THROTTLED */
, "Requests throttled due to {$httpStatus} error. Attempts allowed again after {$time}"), _ERRORS);
var ERROR_FACTORY = new ErrorFactory('appCheck', 'AppCheck', ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function getRecaptcha() {
  var isEnterprise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _a;

  if (isEnterprise) {
    return (_a = self.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise;
  }

  return self.grecaptcha;
}

function ensureActivated(app) {
  if (!getStateReference(app).activated) {
    throw ERROR_FACTORY.create("use-before-activation"
    /* AppCheckError.USE_BEFORE_ACTIVATION */
    , {
      appName: app.name
    });
  }
}

function getDurationString(durationInMillis) {
  var totalSeconds = Math.round(durationInMillis / 1000);
  var days = Math.floor(totalSeconds / (3600 * 24));
  var hours = Math.floor((totalSeconds - days * 3600 * 24) / 3600);
  var minutes = Math.floor((totalSeconds - days * 3600 * 24 - hours * 3600) / 60);
  var seconds = totalSeconds - days * 3600 * 24 - hours * 3600 - minutes * 60;
  var result = '';

  if (days) {
    result += pad(days) + 'd:';
  }

  if (hours) {
    result += pad(hours) + 'h:';
  }

  result += pad(minutes) + 'm:' + pad(seconds) + 's';
  return result;
}

function pad(value) {
  if (value === 0) {
    return '00';
  }

  return value >= 10 ? value.toString() : '0' + value;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function exchangeToken(_x2, _x3) {
  return _exchangeToken.apply(this, arguments);
}

function _exchangeToken() {
  _exchangeToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(_ref, heartbeatServiceProvider) {
    var url, body, headers, heartbeatService, heartbeatsHeader, options, response, responseBody, match, timeToLiveAsNumber, now;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = _ref.url, body = _ref.body;
            headers = {
              'Content-Type': 'application/json'
            }; // If heartbeat service exists, add heartbeat header string to the header.

            heartbeatService = heartbeatServiceProvider.getImmediate({
              optional: true
            });

            if (!heartbeatService) {
              _context6.next = 8;
              break;
            }

            _context6.next = 6;
            return heartbeatService.getHeartbeatsHeader();

          case 6:
            heartbeatsHeader = _context6.sent;

            if (heartbeatsHeader) {
              headers['X-Firebase-Client'] = heartbeatsHeader;
            }

          case 8:
            options = {
              method: 'POST',
              body: JSON.stringify(body),
              headers: headers
            };
            _context6.prev = 9;
            _context6.next = 12;
            return fetch(url, options);

          case 12:
            response = _context6.sent;
            _context6.next = 18;
            break;

          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](9);
            throw ERROR_FACTORY.create("fetch-network-error"
            /* AppCheckError.FETCH_NETWORK_ERROR */
            , {
              originalErrorMessage: _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message
            });

          case 18:
            if (!(response.status !== 200)) {
              _context6.next = 20;
              break;
            }

            throw ERROR_FACTORY.create("fetch-status-error"
            /* AppCheckError.FETCH_STATUS_ERROR */
            , {
              httpStatus: response.status
            });

          case 20:
            _context6.prev = 20;
            _context6.next = 23;
            return response.json();

          case 23:
            responseBody = _context6.sent;
            _context6.next = 29;
            break;

          case 26:
            _context6.prev = 26;
            _context6.t1 = _context6["catch"](20);
            throw ERROR_FACTORY.create("fetch-parse-error"
            /* AppCheckError.FETCH_PARSE_ERROR */
            , {
              originalErrorMessage: _context6.t1 === null || _context6.t1 === void 0 ? void 0 : _context6.t1.message
            });

          case 29:
            // Protobuf duration format.
            // https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/Duration
            match = responseBody.ttl.match(/^([\d.]+)(s)$/);

            if (!(!match || !match[2] || isNaN(Number(match[1])))) {
              _context6.next = 32;
              break;
            }

            throw ERROR_FACTORY.create("fetch-parse-error"
            /* AppCheckError.FETCH_PARSE_ERROR */
            , {
              originalErrorMessage: "ttl field (timeToLive) is not in standard Protobuf Duration " + "format: ".concat(responseBody.ttl)
            });

          case 32:
            timeToLiveAsNumber = Number(match[1]) * 1000;
            now = Date.now();
            return _context6.abrupt("return", {
              token: responseBody.token,
              expireTimeMillis: now + timeToLiveAsNumber,
              issuedAtTimeMillis: now
            });

          case 35:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[9, 15], [20, 26]]);
  }));
  return _exchangeToken.apply(this, arguments);
}

function getExchangeRecaptchaV3TokenRequest(app, reCAPTCHAToken) {
  var _app$options = app.options,
      projectId = _app$options.projectId,
      appId = _app$options.appId,
      apiKey = _app$options.apiKey;
  return {
    url: "".concat(BASE_ENDPOINT, "/projects/").concat(projectId, "/apps/").concat(appId, ":").concat(EXCHANGE_RECAPTCHA_TOKEN_METHOD, "?key=").concat(apiKey),
    body: {
      'recaptcha_v3_token': reCAPTCHAToken
    }
  };
}

function getExchangeDebugTokenRequest(app, debugToken) {
  var _app$options3 = app.options,
      projectId = _app$options3.projectId,
      appId = _app$options3.appId,
      apiKey = _app$options3.apiKey;
  return {
    url: "".concat(BASE_ENDPOINT, "/projects/").concat(projectId, "/apps/").concat(appId, ":").concat(EXCHANGE_DEBUG_TOKEN_METHOD, "?key=").concat(apiKey),
    body: {
      // eslint-disable-next-line
      debug_token: debugToken
    }
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME = 'firebase-app-check-database';
var DB_VERSION = 1;
var STORE_NAME = 'firebase-app-check-store';
var DEBUG_TOKEN_KEY = 'debug-token';
var dbPromise = null;

function getDBPromise() {
  if (dbPromise) {
    return dbPromise;
  }

  dbPromise = new Promise(function (resolve, reject) {
    try {
      var request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onsuccess = function (event) {
        resolve(event.target.result);
      };

      request.onerror = function (event) {
        var _a;

        reject(ERROR_FACTORY.create("storage-open"
        /* AppCheckError.STORAGE_OPEN */
        , {
          originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
        }));
      };

      request.onupgradeneeded = function (event) {
        var db = event.target.result; // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case

        switch (event.oldVersion) {
          case 0:
            db.createObjectStore(STORE_NAME, {
              keyPath: 'compositeKey'
            });
        }
      };
    } catch (e) {
      reject(ERROR_FACTORY.create("storage-open"
      /* AppCheckError.STORAGE_OPEN */
      , {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
      }));
    }
  });
  return dbPromise;
}

function readTokenFromIndexedDB(app) {
  return read(computeKey(app));
}

function writeTokenToIndexedDB(app, token) {
  return write(computeKey(app), token);
}

function writeDebugTokenToIndexedDB(token) {
  return write(DEBUG_TOKEN_KEY, token);
}

function readDebugTokenFromIndexedDB() {
  return read(DEBUG_TOKEN_KEY);
}

function write(_x4, _x5) {
  return _write.apply(this, arguments);
}

function _write() {
  _write = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(key, value) {
    var db, transaction, store, request;
    return regenerator.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getDBPromise();

          case 2:
            db = _context7.sent;
            transaction = db.transaction(STORE_NAME, 'readwrite');
            store = transaction.objectStore(STORE_NAME);
            request = store.put({
              compositeKey: key,
              value: value
            });
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function (_event) {
                resolve();
              };

              transaction.onerror = function (event) {
                var _a;

                reject(ERROR_FACTORY.create("storage-set"
                /* AppCheckError.STORAGE_WRITE */
                , {
                  originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
                }));
              };
            }));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _write.apply(this, arguments);
}

function read(_x6) {
  return _read.apply(this, arguments);
}

function _read() {
  _read = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(key) {
    var db, transaction, store, request;
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getDBPromise();

          case 2:
            db = _context8.sent;
            transaction = db.transaction(STORE_NAME, 'readonly');
            store = transaction.objectStore(STORE_NAME);
            request = store.get(key);
            return _context8.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function (event) {
                var result = event.target.result;

                if (result) {
                  resolve(result.value);
                } else {
                  resolve(undefined);
                }
              };

              transaction.onerror = function (event) {
                var _a;

                reject(ERROR_FACTORY.create("storage-get"
                /* AppCheckError.STORAGE_GET */
                , {
                  originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
                }));
              };
            }));

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _read.apply(this, arguments);
}

function computeKey(app) {
  return "".concat(app.options.appId, "-").concat(app.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var logger = new Logger$1('@firebase/app-check');
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Always resolves. In case of an error reading from indexeddb, resolve with undefined
 */

function readTokenFromStorage(_x7) {
  return _readTokenFromStorage.apply(this, arguments);
}
/**
 * Always resolves. In case of an error writing to indexeddb, print a warning and resolve the promise
 */


function _readTokenFromStorage() {
  _readTokenFromStorage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(app) {
    var token;
    return regenerator.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!isIndexedDBAvailable()) {
              _context9.next = 12;
              break;
            }

            token = undefined;
            _context9.prev = 2;
            _context9.next = 5;
            return readTokenFromIndexedDB(app);

          case 5:
            token = _context9.sent;
            _context9.next = 11;
            break;

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](2);
            // swallow the error and return undefined
            logger.warn("Failed to read token from IndexedDB. Error: ".concat(_context9.t0));

          case 11:
            return _context9.abrupt("return", token);

          case 12:
            return _context9.abrupt("return", undefined);

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[2, 8]]);
  }));
  return _readTokenFromStorage.apply(this, arguments);
}

function writeTokenToStorage(app, token) {
  if (isIndexedDBAvailable()) {
    return writeTokenToIndexedDB(app, token)["catch"](function (e) {
      // swallow the error and resolve the promise
      logger.warn("Failed to write token to IndexedDB. Error: ".concat(e));
    });
  }

  return Promise.resolve();
}

function readOrCreateDebugTokenFromStorage() {
  return _readOrCreateDebugTokenFromStorage.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _readOrCreateDebugTokenFromStorage() {
  _readOrCreateDebugTokenFromStorage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10() {
    var existingDebugToken, newToken;
    return regenerator.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            /**
             * Theoretically race condition can happen if we read, then write in 2 separate transactions.
             * But it won't happen here, because this function will be called exactly once.
             */
            existingDebugToken = undefined;
            _context10.prev = 1;
            _context10.next = 4;
            return readDebugTokenFromIndexedDB();

          case 4:
            existingDebugToken = _context10.sent;
            _context10.next = 9;
            break;

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](1);

          case 9:
            if (existingDebugToken) {
              _context10.next = 15;
              break;
            }

            // create a new debug token
            newToken = uuidv4(); // We don't need to block on writing to indexeddb
            // In case persistence failed, a new debug token will be generated everytime the page is refreshed.
            // It renders the debug token useless because you have to manually register(whitelist) the new token in the firebase console again and again.
            // If you see this error trying to use debug token, it probably means you are using a browser that doesn't support indexeddb.
            // You should switch to a different browser that supports indexeddb

            writeDebugTokenToIndexedDB(newToken)["catch"](function (e) {
              return logger.warn("Failed to persist debug token to IndexedDB. Error: ".concat(e));
            });
            return _context10.abrupt("return", newToken);

          case 15:
            return _context10.abrupt("return", existingDebugToken);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 7]]);
  }));
  return _readOrCreateDebugTokenFromStorage.apply(this, arguments);
}

function isDebugMode() {
  var debugState = getDebugState();
  return debugState.enabled;
}

function getDebugToken() {
  return _getDebugToken.apply(this, arguments);
}

function _getDebugToken() {
  _getDebugToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11() {
    var state;
    return regenerator.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            state = getDebugState();

            if (!(state.enabled && state.token)) {
              _context11.next = 5;
              break;
            }

            return _context11.abrupt("return", state.token.promise);

          case 5:
            throw Error("\n            Can't get debug token in production mode.\n        ");

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getDebugToken.apply(this, arguments);
}

function initializeDebugMode() {
  var globals = getGlobal();
  var debugState = getDebugState(); // Set to true if this function has been called, whether or not
  // it enabled debug mode.

  debugState.initialized = true;

  if (typeof globals.FIREBASE_APPCHECK_DEBUG_TOKEN !== 'string' && globals.FIREBASE_APPCHECK_DEBUG_TOKEN !== true) {
    return;
  }

  debugState.enabled = true;
  var deferredToken = new Deferred();
  debugState.token = deferredToken;

  if (typeof globals.FIREBASE_APPCHECK_DEBUG_TOKEN === 'string') {
    deferredToken.resolve(globals.FIREBASE_APPCHECK_DEBUG_TOKEN);
  } else {
    deferredToken.resolve(readOrCreateDebugTokenFromStorage());
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Initial hardcoded value agreed upon across platforms for initial launch.
// Format left open for possible dynamic error values and other fields in the future.


var defaultTokenErrorData = {
  error: 'UNKNOWN_ERROR'
};
/**
 * Stringify and base64 encode token error data.
 *
 * @param tokenError Error data, currently hardcoded.
 */

function formatDummyToken(tokenErrorData) {
  return base64.encodeString(JSON.stringify(tokenErrorData),
  /* webSafe= */
  false);
}
/**
 * This function always resolves.
 * The result will contain an error field if there is any error.
 * In case there is an error, the token field in the result will be populated with a dummy value
 */


function getToken$2(_x8) {
  return _getToken$.apply(this, arguments);
}
/**
 * Internal API for limited use tokens. Skips all FAC state and simply calls
 * the underlying provider.
 */


function _getToken$() {
  _getToken$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(appCheck) {
    var forceRefresh,
        app,
        state,
        token,
        error,
        cachedToken,
        shouldCallListeners,
        tokenFromDebugExchange,
        interopTokenResult,
        _args12 = arguments;
    return regenerator.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            forceRefresh = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : false;
            app = appCheck.app;
            ensureActivated(app);
            state = getStateReference(app);
            /**
             * First check if there is a token in memory from a previous `getToken()` call.
             */

            token = state.token;
            error = undefined;
            /**
             * If an invalid token was found in memory, clear token from
             * memory and unset the local variable `token`.
             */

            if (token && !isValid(token)) {
              state.token = undefined;
              token = undefined;
            }
            /**
             * If there is no valid token in memory, try to load token from indexedDB.
             */


            if (token) {
              _context12.next = 18;
              break;
            }

            _context12.next = 10;
            return state.cachedTokenPromise;

          case 10:
            cachedToken = _context12.sent;

            if (!cachedToken) {
              _context12.next = 18;
              break;
            }

            if (!isValid(cachedToken)) {
              _context12.next = 16;
              break;
            }

            token = cachedToken;
            _context12.next = 18;
            break;

          case 16:
            _context12.next = 18;
            return writeTokenToStorage(app, undefined);

          case 18:
            if (!(!forceRefresh && token && isValid(token))) {
              _context12.next = 20;
              break;
            }

            return _context12.abrupt("return", {
              token: token.token
            });

          case 20:
            // Only set to true if this `getToken()` call is making the actual
            // REST call to the exchange endpoint, versus waiting for an already
            // in-flight call (see debug and regular exchange endpoint paths below)
            shouldCallListeners = false;
            /**
             * DEBUG MODE
             * If debug mode is set, and there is no cached token, fetch a new App
             * Check token using the debug token, and return it directly.
             */

            if (!isDebugMode()) {
              _context12.next = 40;
              break;
            }

            if (state.exchangeTokenPromise) {
              _context12.next = 33;
              break;
            }

            _context12.t0 = exchangeToken;
            _context12.t1 = getExchangeDebugTokenRequest;
            _context12.t2 = app;
            _context12.next = 28;
            return getDebugToken();

          case 28:
            _context12.t3 = _context12.sent;
            _context12.t4 = (0, _context12.t1)(_context12.t2, _context12.t3);
            _context12.t5 = appCheck.heartbeatServiceProvider;
            state.exchangeTokenPromise = (0, _context12.t0)(_context12.t4, _context12.t5)["finally"](function () {
              // Clear promise when settled - either resolved or rejected.
              state.exchangeTokenPromise = undefined;
            });
            shouldCallListeners = true;

          case 33:
            _context12.next = 35;
            return state.exchangeTokenPromise;

          case 35:
            tokenFromDebugExchange = _context12.sent;
            _context12.next = 38;
            return writeTokenToStorage(app, tokenFromDebugExchange);

          case 38:
            // Write debug token to state.
            state.token = tokenFromDebugExchange;
            return _context12.abrupt("return", {
              token: tokenFromDebugExchange.token
            });

          case 40:
            _context12.prev = 40;

            // Avoid making another call to the exchange endpoint if one is in flight.
            if (!state.exchangeTokenPromise) {
              // state.provider is populated in initializeAppCheck()
              // ensureActivated() at the top of this function checks that
              // initializeAppCheck() has been called.
              state.exchangeTokenPromise = state.provider.getToken()["finally"](function () {
                // Clear promise when settled - either resolved or rejected.
                state.exchangeTokenPromise = undefined;
              });
              shouldCallListeners = true;
            }

            _context12.next = 44;
            return getStateReference(app).exchangeTokenPromise;

          case 44:
            token = _context12.sent;
            _context12.next = 51;
            break;

          case 47:
            _context12.prev = 47;
            _context12.t6 = _context12["catch"](40);

            if (_context12.t6.code === "appCheck/".concat("throttled"
            /* AppCheckError.THROTTLED */
            )) {
              // Warn if throttled, but do not treat it as an error.
              logger.warn(_context12.t6.message);
            } else {
              // `getToken()` should never throw, but logging error text to console will aid debugging.
              logger.error(_context12.t6);
            } // Always save error to be added to dummy token.


            error = _context12.t6;

          case 51:
            if (token) {
              _context12.next = 55;
              break;
            }

            // If token is undefined, there must be an error.
            // Return a dummy token along with the error.
            interopTokenResult = makeDummyTokenResult(error);
            _context12.next = 63;
            break;

          case 55:
            if (!error) {
              _context12.next = 59;
              break;
            }

            if (isValid(token)) {
              // It's also possible a valid token exists, but there's also an error.
              // (Such as if the token is almost expired, tries to refresh, and
              // the exchange request fails.)
              // We add a special error property here so that the refresher will
              // count this as a failed attempt and use the backoff instead of
              // retrying repeatedly with no delay, but any 3P listeners will not
              // be hindered in getting the still-valid token.
              interopTokenResult = {
                token: token.token,
                internalError: error
              };
            } else {
              // No invalid tokens should make it to this step. Memory and cached tokens
              // are checked. Other tokens are from fresh exchanges. But just in case.
              interopTokenResult = makeDummyTokenResult(error);
            }

            _context12.next = 63;
            break;

          case 59:
            interopTokenResult = {
              token: token.token
            }; // write the new token to the memory state as well as the persistent storage.
            // Only do it if we got a valid new token

            state.token = token;
            _context12.next = 63;
            return writeTokenToStorage(app, token);

          case 63:
            if (shouldCallListeners) {
              notifyTokenListeners(app, interopTokenResult);
            }

            return _context12.abrupt("return", interopTokenResult);

          case 65:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[40, 47]]);
  }));
  return _getToken$.apply(this, arguments);
}

function getLimitedUseToken$1(_x9) {
  return _getLimitedUseToken$.apply(this, arguments);
}

function _getLimitedUseToken$() {
  _getLimitedUseToken$ = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(appCheck) {
    var app, _getStateReference2, provider, debugToken, _yield$exchangeToken, token, _yield$provider$getTo, _token;

    return regenerator.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            app = appCheck.app;
            ensureActivated(app);
            _getStateReference2 = getStateReference(app), provider = _getStateReference2.provider;

            if (!isDebugMode()) {
              _context13.next = 14;
              break;
            }

            _context13.next = 6;
            return getDebugToken();

          case 6:
            debugToken = _context13.sent;
            _context13.next = 9;
            return exchangeToken(getExchangeDebugTokenRequest(app, debugToken), appCheck.heartbeatServiceProvider);

          case 9:
            _yield$exchangeToken = _context13.sent;
            token = _yield$exchangeToken.token;
            return _context13.abrupt("return", {
              token: token
            });

          case 14:
            _context13.next = 16;
            return provider.getToken();

          case 16:
            _yield$provider$getTo = _context13.sent;
            _token = _yield$provider$getTo.token;
            return _context13.abrupt("return", {
              token: _token
            });

          case 19:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _getLimitedUseToken$.apply(this, arguments);
}

function _addTokenListener(appCheck, type, listener, onError) {
  var app = appCheck.app;
  var state = getStateReference(app);
  var tokenObserver = {
    next: listener,
    error: onError,
    type: type
  };
  state.tokenObservers = [].concat(_toConsumableArray(state.tokenObservers), [tokenObserver]); // Invoke the listener async immediately if there is a valid token
  // in memory.

  if (state.token && isValid(state.token)) {
    var validToken = state.token;
    Promise.resolve().then(function () {
      listener({
        token: validToken.token
      });
      initTokenRefresher(appCheck);
    })["catch"](function () {
      /* we don't care about exceptions thrown in listeners */
    });
  }
  /**
   * Wait for any cached token promise to resolve before starting the token
   * refresher. The refresher checks to see if there is an existing token
   * in state and calls the exchange endpoint if not. We should first let the
   * IndexedDB check have a chance to populate state if it can.
   *
   * Listener call isn't needed here because cachedTokenPromise will call any
   * listeners that exist when it resolves.
   */
  // state.cachedTokenPromise is always populated in `activate()`.


  void state.cachedTokenPromise.then(function () {
    return initTokenRefresher(appCheck);
  });
}

function _removeTokenListener(app, listener) {
  var state = getStateReference(app);
  var newObservers = state.tokenObservers.filter(function (tokenObserver) {
    return tokenObserver.next !== listener;
  });

  if (newObservers.length === 0 && state.tokenRefresher && state.tokenRefresher.isRunning()) {
    state.tokenRefresher.stop();
  }

  state.tokenObservers = newObservers;
}
/**
 * Logic to create and start refresher as needed.
 */


function initTokenRefresher(appCheck) {
  var app = appCheck.app;
  var state = getStateReference(app); // Create the refresher but don't start it if `isTokenAutoRefreshEnabled`
  // is not true.

  var refresher = state.tokenRefresher;

  if (!refresher) {
    refresher = createTokenRefresher(appCheck);
    state.tokenRefresher = refresher;
  }

  if (!refresher.isRunning() && state.isTokenAutoRefreshEnabled) {
    refresher.start();
  }
}

function createTokenRefresher(appCheck) {
  var app = appCheck.app;
  return new Refresher(
  /*#__PURE__*/
  // Keep in mind when this fails for any reason other than the ones
  // for which we should retry, it will effectively stop the proactive refresh.
  _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var state, result;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = getStateReference(app); // If there is no token, we will try to load it from storage and use it
            // If there is a token, we force refresh it because we know it's going to expire soon

            if (state.token) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return getToken$2(appCheck);

          case 4:
            result = _context2.sent;
            _context2.next = 10;
            break;

          case 7:
            _context2.next = 9;
            return getToken$2(appCheck, true);

          case 9:
            result = _context2.sent;

          case 10:
            if (!result.error) {
              _context2.next = 12;
              break;
            }

            throw result.error;

          case 12:
            if (!result.internalError) {
              _context2.next = 14;
              break;
            }

            throw result.internalError;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), function () {
    return true;
  }, function () {
    var state = getStateReference(app);

    if (state.token) {
      // issuedAtTime + (50% * total TTL) + 5 minutes
      var nextRefreshTimeMillis = state.token.issuedAtTimeMillis + (state.token.expireTimeMillis - state.token.issuedAtTimeMillis) * 0.5 + 5 * 60 * 1000; // Do not allow refresh time to be past (expireTime - 5 minutes)

      var latestAllowableRefresh = state.token.expireTimeMillis - 5 * 60 * 1000;
      nextRefreshTimeMillis = Math.min(nextRefreshTimeMillis, latestAllowableRefresh);
      return Math.max(0, nextRefreshTimeMillis - Date.now());
    } else {
      return 0;
    }
  }, TOKEN_REFRESH_TIME.RETRIAL_MIN_WAIT, TOKEN_REFRESH_TIME.RETRIAL_MAX_WAIT);
}

function notifyTokenListeners(app, token) {
  var observers = getStateReference(app).tokenObservers;

  var _iterator = _createForOfIteratorHelper$2(observers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var observer = _step.value;

      try {
        if (observer.type === "EXTERNAL"
        /* ListenerType.EXTERNAL */
        && token.error != null) {
          // If this listener was added by a 3P call, send any token error to
          // the supplied error handler. A 3P observer always has an error
          // handler.
          observer.error(token.error);
        } else {
          // If the token has no error field, always return the token.
          // If this is a 2P listener, return the token, whether or not it
          // has an error field.
          observer.next(token);
        }
      } catch (e) {// Errors in the listener function itself are always ignored.
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function isValid(token) {
  return token.expireTimeMillis - Date.now() > 0;
}

function makeDummyTokenResult(error) {
  return {
    token: formatDummyToken(defaultTokenErrorData),
    error: error
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * AppCheck Service class.
 */


var AppCheckService = /*#__PURE__*/function () {
  function AppCheckService(app, heartbeatServiceProvider) {
    _classCallCheck(this, AppCheckService);

    this.app = app;
    this.heartbeatServiceProvider = heartbeatServiceProvider;
  }

  _createClass(AppCheckService, [{
    key: "_delete",
    value: function _delete() {
      var _getStateReference = getStateReference(this.app),
          tokenObservers = _getStateReference.tokenObservers;

      var _iterator2 = _createForOfIteratorHelper$2(tokenObservers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tokenObserver = _step2.value;

          _removeTokenListener(this.app, tokenObserver.next);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return Promise.resolve();
    }
  }]);

  return AppCheckService;
}();

function factory(app, heartbeatServiceProvider) {
  return new AppCheckService(app, heartbeatServiceProvider);
}

function internalFactory(appCheck) {
  return {
    getToken: function getToken(forceRefresh) {
      return getToken$2(appCheck, forceRefresh);
    },
    getLimitedUseToken: function getLimitedUseToken() {
      return getLimitedUseToken$1(appCheck);
    },
    addTokenListener: function addTokenListener(listener) {
      return _addTokenListener(appCheck, "INTERNAL"
      /* ListenerType.INTERNAL */
      , listener);
    },
    removeTokenListener: function removeTokenListener(listener) {
      return _removeTokenListener(appCheck.app, listener);
    }
  };
}

var name = "@firebase/app-check";
var version = "0.8.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';

function initializeV3(app, siteKey) {
  var initialized = new Deferred();
  var state = getStateReference(app);
  state.reCAPTCHAState = {
    initialized: initialized
  };
  var divId = makeDiv(app);
  var grecaptcha = getRecaptcha(false);

  if (!grecaptcha) {
    loadReCAPTCHAV3Script(function () {
      var grecaptcha = getRecaptcha(false);

      if (!grecaptcha) {
        // it shouldn't happen.
        throw new Error('no recaptcha');
      }

      queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
    });
  } else {
    queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
  }

  return initialized.promise;
}
/**
 * Add listener to render the widget and resolve the promise when
 * the grecaptcha.ready() event fires.
 */


function queueWidgetRender(app, siteKey, grecaptcha, container, initialized) {
  grecaptcha.ready(function () {
    // Invisible widgets allow us to set a different siteKey for each widget,
    // so we use them to support multiple apps
    renderInvisibleWidget(app, siteKey, grecaptcha, container);
    initialized.resolve(grecaptcha);
  });
}
/**
 * Add invisible div to page.
 */


function makeDiv(app) {
  var divId = "fire_app_check_".concat(app.name);
  var invisibleDiv = document.createElement('div');
  invisibleDiv.id = divId;
  invisibleDiv.style.display = 'none';
  document.body.appendChild(invisibleDiv);
  return divId;
}

function getToken$1(_x10) {
  return _getToken$2.apply(this, arguments);
}
/**
 *
 * @param app
 * @param container - Id of a HTML element.
 */


function _getToken$2() {
  _getToken$2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(app) {
    var reCAPTCHAState, recaptcha;
    return regenerator.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            ensureActivated(app); // ensureActivated() guarantees that reCAPTCHAState is set

            reCAPTCHAState = getStateReference(app).reCAPTCHAState;
            _context14.next = 4;
            return reCAPTCHAState.initialized.promise;

          case 4:
            recaptcha = _context14.sent;
            return _context14.abrupt("return", new Promise(function (resolve, _reject) {
              // Updated after initialization is complete.
              var reCAPTCHAState = getStateReference(app).reCAPTCHAState;
              recaptcha.ready(function () {
                resolve( // widgetId is guaranteed to be available if reCAPTCHAState.initialized.promise resolved.
                recaptcha.execute(reCAPTCHAState.widgetId, {
                  action: 'fire_app_check'
                }));
              });
            }));

          case 6:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _getToken$2.apply(this, arguments);
}

function renderInvisibleWidget(app, siteKey, grecaptcha, container) {
  var widgetId = grecaptcha.render(container, {
    sitekey: siteKey,
    size: 'invisible',
    // Success callback - set state
    callback: function callback() {
      getStateReference(app).reCAPTCHAState.succeeded = true;
    },
    // Failure callback - set state
    'error-callback': function errorCallback() {
      getStateReference(app).reCAPTCHAState.succeeded = false;
    }
  });
  var state = getStateReference(app);
  state.reCAPTCHAState = Object.assign(Object.assign({}, state.reCAPTCHAState), {
    // state.reCAPTCHAState is set in the initialize()
    widgetId: widgetId
  });
}

function loadReCAPTCHAV3Script(onload) {
  var script = document.createElement('script');
  script.src = RECAPTCHA_URL;
  script.onload = onload;
  document.head.appendChild(script);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * App Check provider that can obtain a reCAPTCHA V3 token and exchange it
 * for an App Check token.
 *
 * @public
 */


var ReCaptchaV3Provider = /*#__PURE__*/function () {
  /**
   * Create a ReCaptchaV3Provider instance.
   * @param siteKey - ReCAPTCHA V3 siteKey.
   */
  function ReCaptchaV3Provider(_siteKey) {
    _classCallCheck(this, ReCaptchaV3Provider);

    this._siteKey = _siteKey;
    /**
     * Throttle requests on certain error codes to prevent too many retries
     * in a short time.
     */

    this._throttleData = null;
  }
  /**
   * Returns an App Check token.
   * @internal
   */


  _createClass(ReCaptchaV3Provider, [{
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        var _a, _b, _c, attestedClaimsToken, result;

        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throwIfThrottled(this._throttleData); // Top-level `getToken()` has already checked that App Check is initialized
                // and therefore this._app and this._heartbeatServiceProvider are available.

                _context3.next = 3;
                return getToken$1(this._app)["catch"](function (_e) {
                  // reCaptcha.execute() throws null which is not very descriptive.
                  throw ERROR_FACTORY.create("recaptcha-error"
                  /* AppCheckError.RECAPTCHA_ERROR */
                  );
                });

              case 3:
                attestedClaimsToken = _context3.sent;

                if ((_a = getStateReference(this._app).reCAPTCHAState) === null || _a === void 0 ? void 0 : _a.succeeded) {
                  _context3.next = 6;
                  break;
                }

                throw ERROR_FACTORY.create("recaptcha-error"
                /* AppCheckError.RECAPTCHA_ERROR */
                );

              case 6:
                _context3.prev = 6;
                _context3.next = 9;
                return exchangeToken(getExchangeRecaptchaV3TokenRequest(this._app, attestedClaimsToken), this._heartbeatServiceProvider);

              case 9:
                result = _context3.sent;
                _context3.next = 20;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](6);

                if (!((_b = _context3.t0.code) === null || _b === void 0 ? void 0 : _b.includes("fetch-status-error"
                /* AppCheckError.FETCH_STATUS_ERROR */
                ))) {
                  _context3.next = 19;
                  break;
                }

                this._throttleData = setBackoff(Number((_c = _context3.t0.customData) === null || _c === void 0 ? void 0 : _c.httpStatus), this._throttleData);
                throw ERROR_FACTORY.create("throttled"
                /* AppCheckError.THROTTLED */
                , {
                  time: getDurationString(this._throttleData.allowRequestsAfter - Date.now()),
                  httpStatus: this._throttleData.httpStatus
                });

              case 19:
                throw _context3.t0;

              case 20:
                // If successful, clear throttle data.
                this._throttleData = null;
                return _context3.abrupt("return", result);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 12]]);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
    /**
     * @internal
     */

  }, {
    key: "initialize",
    value: function initialize(app) {
      this._app = app;
      this._heartbeatServiceProvider = _getProvider(app, 'heartbeat');
      initializeV3(app, this._siteKey)["catch"](function () {
        /* we don't care about the initialization result */
      });
    }
    /**
     * @internal
     */

  }, {
    key: "isEqual",
    value: function isEqual(otherProvider) {
      if (otherProvider instanceof ReCaptchaV3Provider) {
        return this._siteKey === otherProvider._siteKey;
      } else {
        return false;
      }
    }
  }]);

  return ReCaptchaV3Provider;
}();
/**
 * Set throttle data to block requests until after a certain time
 * depending on the failed request's status code.
 * @param httpStatus - Status code of failed request.
 * @param throttleData - `ThrottleData` object containing previous throttle
 * data state.
 * @returns Data about current throttle state and expiration time.
 */


function setBackoff(httpStatus, throttleData) {
  /**
   * Block retries for 1 day for the following error codes:
   *
   * 404: Likely malformed URL.
   *
   * 403:
   * - Attestation failed
   * - Wrong API key
   * - Project deleted
   */
  if (httpStatus === 404 || httpStatus === 403) {
    return {
      backoffCount: 1,
      allowRequestsAfter: Date.now() + ONE_DAY,
      httpStatus: httpStatus
    };
  } else {
    /**
     * For all other error codes, the time when it is ok to retry again
     * is based on exponential backoff.
     */
    var backoffCount = throttleData ? throttleData.backoffCount : 0;
    var backoffMillis = calculateBackoffMillis(backoffCount, 1000, 2);
    return {
      backoffCount: backoffCount + 1,
      allowRequestsAfter: Date.now() + backoffMillis,
      httpStatus: httpStatus
    };
  }
}

function throwIfThrottled(throttleData) {
  if (throttleData) {
    if (Date.now() - throttleData.allowRequestsAfter <= 0) {
      // If before, throw.
      throw ERROR_FACTORY.create("throttled"
      /* AppCheckError.THROTTLED */
      , {
        time: getDurationString(throttleData.allowRequestsAfter - Date.now()),
        httpStatus: throttleData.httpStatus
      });
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Activate App Check for the given app. Can be called only once per app.
 * @param app - the {@link @firebase/app#FirebaseApp} to activate App Check for
 * @param options - App Check initialization options
 * @public
 */


function initializeAppCheck() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();
  var options = arguments.length > 1 ? arguments[1] : undefined;
  app = getModularInstance(app);

  var provider = _getProvider(app, 'app-check'); // Ensure initializeDebugMode() is only called once.


  if (!getDebugState().initialized) {
    initializeDebugMode();
  } // Log a message containing the debug token when `initializeAppCheck()`
  // is called in debug mode.


  if (isDebugMode()) {
    // Do not block initialization to get the token for the message.
    void getDebugToken().then(function (token) {
      return (// Not using logger because I don't think we ever want this accidentally hidden.
        console.log("App Check debug token: ".concat(token, ". You will need to add it to your app's App Check settings in the Firebase console for it to work."))
      );
    });
  }

  if (provider.isInitialized()) {
    var existingInstance = provider.getImmediate();
    var initialOptions = provider.getOptions();

    if (initialOptions.isTokenAutoRefreshEnabled === options.isTokenAutoRefreshEnabled && initialOptions.provider.isEqual(options.provider)) {
      return existingInstance;
    } else {
      throw ERROR_FACTORY.create("already-initialized"
      /* AppCheckError.ALREADY_INITIALIZED */
      , {
        appName: app.name
      });
    }
  }

  var appCheck = provider.initialize({
    options: options
  });

  _activate(app, options.provider, options.isTokenAutoRefreshEnabled); // If isTokenAutoRefreshEnabled is false, do not send any requests to the
  // exchange endpoint without an explicit call from the user either directly
  // or through another Firebase library (storage, functions, etc.)


  if (getStateReference(app).isTokenAutoRefreshEnabled) {
    // Adding a listener will start the refresher and fetch a token if needed.
    // This gets a token ready and prevents a delay when an internal library
    // requests the token.
    // Listener function does not need to do anything, its base functionality
    // of calling getToken() already fetches token and writes it to memory/storage.
    _addTokenListener(appCheck, "INTERNAL"
    /* ListenerType.INTERNAL */
    , function () {});
  }

  return appCheck;
}
/**
 * Activate App Check
 * @param app - Firebase app to activate App Check for.
 * @param provider - reCAPTCHA v3 provider or
 * custom token provider.
 * @param isTokenAutoRefreshEnabled - If true, the SDK automatically
 * refreshes App Check tokens as needed. If undefined, defaults to the
 * value of `app.automaticDataCollectionEnabled`, which defaults to
 * false and can be set in the app config.
 */


function _activate(app, provider, isTokenAutoRefreshEnabled) {
  // Create an entry in the APP_CHECK_STATES map. Further changes should
  // directly mutate this object.
  var state = setInitialState(app, Object.assign({}, DEFAULT_STATE));
  state.activated = true;
  state.provider = provider; // Read cached token from storage if it exists and store it in memory.

  state.cachedTokenPromise = readTokenFromStorage(app).then(function (cachedToken) {
    if (cachedToken && isValid(cachedToken)) {
      state.token = cachedToken; // notify all listeners with the cached token

      notifyTokenListeners(app, {
        token: cachedToken.token
      });
    }

    return cachedToken;
  }); // Use value of global `automaticDataCollectionEnabled` (which
  // itself defaults to false if not specified in config) if
  // `isTokenAutoRefreshEnabled` param was not provided by user.

  state.isTokenAutoRefreshEnabled = isTokenAutoRefreshEnabled === undefined ? app.automaticDataCollectionEnabled : isTokenAutoRefreshEnabled;
  state.provider.initialize(app);
}
/**
 * The Firebase App Check Web SDK.
 *
 * @remarks
 * Firebase App Check does not work in a Node.js environment using `ReCaptchaV3Provider` or
 * `ReCaptchaEnterpriseProvider`, but can be used in Node.js if you use
 * `CustomProvider` and write your own attestation method.
 *
 * @packageDocumentation
 */


var APP_CHECK_NAME = 'app-check';
var APP_CHECK_NAME_INTERNAL = 'app-check-internal';

function registerAppCheck() {
  // The public interface
  _registerComponent(new Component(APP_CHECK_NAME, function (container) {
    // getImmediate for FirebaseApp will always succeed
    var app = container.getProvider('app').getImmediate();
    var heartbeatServiceProvider = container.getProvider('heartbeat');
    return factory(app, heartbeatServiceProvider);
  }, "PUBLIC"
  /* ComponentType.PUBLIC */
  ).setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  )
  /**
   * Initialize app-check-internal after app-check is initialized to make AppCheck available to
   * other Firebase SDKs
   */
  .setInstanceCreatedCallback(function (container, _identifier, _appcheckService) {
    container.getProvider(APP_CHECK_NAME_INTERNAL).initialize();
  })); // The internal interface used by other Firebase products


  _registerComponent(new Component(APP_CHECK_NAME_INTERNAL, function (container) {
    var appCheck = container.getProvider('app-check').getImmediate();
    return internalFactory(appCheck);
  }, "PUBLIC"
  /* ComponentType.PUBLIC */
  ).setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  ));

  registerVersion(name, version);
}

registerAppCheck();

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/

var Integer;
var Md5;
(function () {
  var h;
  /** @license
  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
  */

  function k(f, a) {
    function c() {}

    c.prototype = a.prototype;
    f.D = a.prototype;
    f.prototype = new c();
    f.prototype.constructor = f;

    f.C = function (d, e, g) {
      for (var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++) {
        b[r - 2] = arguments[r];
      }

      return a.prototype[e].apply(d, b);
    };
  }

  function l() {
    this.blockSize = -1;
  }

  function m() {
    this.blockSize = -1;
    this.blockSize = 64;
    this.g = Array(4);
    this.B = Array(this.blockSize);
    this.o = this.h = 0;
    this.s();
  }

  k(m, l);

  m.prototype.s = function () {
    this.g[0] = 1732584193;
    this.g[1] = 4023233417;
    this.g[2] = 2562383102;
    this.g[3] = 271733878;
    this.o = this.h = 0;
  };

  function n(f, a, c) {
    c || (c = 0);
    var d = Array(16);
    if ("string" === typeof a) for (var e = 0; 16 > e; ++e) {
      d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
    } else for (e = 0; 16 > e; ++e) {
      d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
    }
    a = f.g[0];
    c = f.g[1];
    e = f.g[2];
    var g = f.g[3];
    var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
    a = c + (b << 7 & 4294967295 | b >>> 25);
    b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
    g = a + (b << 12 & 4294967295 | b >>> 20);
    b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
    e = g + (b << 17 & 4294967295 | b >>> 15);
    b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
    c = e + (b << 22 & 4294967295 | b >>> 10);
    b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
    a = c + (b << 7 & 4294967295 | b >>> 25);
    b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
    g = a + (b << 12 & 4294967295 | b >>> 20);
    b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
    e = g + (b << 17 & 4294967295 | b >>> 15);
    b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
    c = e + (b << 22 & 4294967295 | b >>> 10);
    b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
    a = c + (b << 7 & 4294967295 | b >>> 25);
    b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
    g = a + (b << 12 & 4294967295 | b >>> 20);
    b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
    e = g + (b << 17 & 4294967295 | b >>> 15);
    b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
    c = e + (b << 22 & 4294967295 | b >>> 10);
    b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
    a = c + (b << 7 & 4294967295 | b >>> 25);
    b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
    g = a + (b << 12 & 4294967295 | b >>> 20);
    b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
    e = g + (b << 17 & 4294967295 | b >>> 15);
    b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
    c = e + (b << 22 & 4294967295 | b >>> 10);
    b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
    a = c + (b << 5 & 4294967295 | b >>> 27);
    b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
    g = a + (b << 9 & 4294967295 | b >>> 23);
    b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
    e = g + (b << 14 & 4294967295 | b >>> 18);
    b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
    c = e + (b << 20 & 4294967295 | b >>> 12);
    b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
    a = c + (b << 5 & 4294967295 | b >>> 27);
    b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
    g = a + (b << 9 & 4294967295 | b >>> 23);
    b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
    e = g + (b << 14 & 4294967295 | b >>> 18);
    b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
    c = e + (b << 20 & 4294967295 | b >>> 12);
    b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
    a = c + (b << 5 & 4294967295 | b >>> 27);
    b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
    g = a + (b << 9 & 4294967295 | b >>> 23);
    b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
    e = g + (b << 14 & 4294967295 | b >>> 18);
    b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
    c = e + (b << 20 & 4294967295 | b >>> 12);
    b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
    a = c + (b << 5 & 4294967295 | b >>> 27);
    b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
    g = a + (b << 9 & 4294967295 | b >>> 23);
    b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
    e = g + (b << 14 & 4294967295 | b >>> 18);
    b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
    c = e + (b << 20 & 4294967295 | b >>> 12);
    b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
    a = c + (b << 4 & 4294967295 | b >>> 28);
    b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
    g = a + (b << 11 & 4294967295 | b >>> 21);
    b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
    e = g + (b << 16 & 4294967295 | b >>> 16);
    b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
    c = e + (b << 23 & 4294967295 | b >>> 9);
    b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
    a = c + (b << 4 & 4294967295 | b >>> 28);
    b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
    g = a + (b << 11 & 4294967295 | b >>> 21);
    b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
    e = g + (b << 16 & 4294967295 | b >>> 16);
    b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
    c = e + (b << 23 & 4294967295 | b >>> 9);
    b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
    a = c + (b << 4 & 4294967295 | b >>> 28);
    b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
    g = a + (b << 11 & 4294967295 | b >>> 21);
    b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
    e = g + (b << 16 & 4294967295 | b >>> 16);
    b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
    c = e + (b << 23 & 4294967295 | b >>> 9);
    b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
    a = c + (b << 4 & 4294967295 | b >>> 28);
    b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
    g = a + (b << 11 & 4294967295 | b >>> 21);
    b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
    e = g + (b << 16 & 4294967295 | b >>> 16);
    b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
    c = e + (b << 23 & 4294967295 | b >>> 9);
    b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
    a = c + (b << 6 & 4294967295 | b >>> 26);
    b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
    g = a + (b << 10 & 4294967295 | b >>> 22);
    b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
    e = g + (b << 15 & 4294967295 | b >>> 17);
    b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
    c = e + (b << 21 & 4294967295 | b >>> 11);
    b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
    a = c + (b << 6 & 4294967295 | b >>> 26);
    b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
    g = a + (b << 10 & 4294967295 | b >>> 22);
    b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
    e = g + (b << 15 & 4294967295 | b >>> 17);
    b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
    c = e + (b << 21 & 4294967295 | b >>> 11);
    b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
    a = c + (b << 6 & 4294967295 | b >>> 26);
    b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
    g = a + (b << 10 & 4294967295 | b >>> 22);
    b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
    e = g + (b << 15 & 4294967295 | b >>> 17);
    b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
    c = e + (b << 21 & 4294967295 | b >>> 11);
    b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
    a = c + (b << 6 & 4294967295 | b >>> 26);
    b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
    g = a + (b << 10 & 4294967295 | b >>> 22);
    b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
    e = g + (b << 15 & 4294967295 | b >>> 17);
    b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
    f.g[0] = f.g[0] + a & 4294967295;
    f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
    f.g[2] = f.g[2] + e & 4294967295;
    f.g[3] = f.g[3] + g & 4294967295;
  }

  m.prototype.u = function (f, a) {
    void 0 === a && (a = f.length);

    for (var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;) {
      if (0 == e) for (; g <= c;) {
        n(this, f, g), g += this.blockSize;
      }
      if ("string" === typeof f) for (; g < a;) {
        if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
          n(this, d);
          e = 0;
          break;
        }
      } else for (; g < a;) {
        if (d[e++] = f[g++], e == this.blockSize) {
          n(this, d);
          e = 0;
          break;
        }
      }
    }

    this.h = e;
    this.o += a;
  };

  m.prototype.v = function () {
    var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    f[0] = 128;

    for (var a = 1; a < f.length - 8; ++a) {
      f[a] = 0;
    }

    var c = 8 * this.o;

    for (a = f.length - 8; a < f.length; ++a) {
      f[a] = c & 255, c /= 256;
    }

    this.u(f);
    f = Array(16);

    for (a = c = 0; 4 > a; ++a) {
      for (var d = 0; 32 > d; d += 8) {
        f[c++] = this.g[a] >>> d & 255;
      }
    }

    return f;
  };

  function p(f, a) {
    var c = q;
    return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
  }

  function t(f, a) {
    this.h = a;

    for (var c = [], d = !0, e = f.length - 1; 0 <= e; e--) {
      var g = f[e] | 0;
      d && g == a || (c[e] = g, d = !1);
    }

    this.g = c;
  }

  var q = {};

  function u(f) {
    return -128 <= f && 128 > f ? p(f, function (a) {
      return new t([a | 0], 0 > a ? -1 : 0);
    }) : new t([f | 0], 0 > f ? -1 : 0);
  }

  function v(f) {
    if (isNaN(f) || !isFinite(f)) return w;
    if (0 > f) return x(v(-f));

    for (var a = [], c = 1, d = 0; f >= c; d++) {
      a[d] = f / c | 0, c *= 4294967296;
    }

    return new t(a, 0);
  }

  function y(f, a) {
    if (0 == f.length) throw Error("number format error: empty string");
    a = a || 10;
    if (2 > a || 36 < a) throw Error("radix out of range: " + a);
    if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
    if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');

    for (var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8) {
      var g = Math.min(8, f.length - e),
          b = parseInt(f.substring(e, e + g), a);
      8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
    }

    return d;
  }

  var w = u(0),
      z = u(1),
      A = u(16777216);
  h = t.prototype;

  h.m = function () {
    if (B(this)) return -x(this).m();

    for (var f = 0, a = 1, c = 0; c < this.g.length; c++) {
      var d = this.i(c);
      f += (0 <= d ? d : 4294967296 + d) * a;
      a *= 4294967296;
    }

    return f;
  };

  h.toString = function (f) {
    f = f || 10;
    if (2 > f || 36 < f) throw Error("radix out of range: " + f);
    if (C(this)) return "0";
    if (B(this)) return "-" + x(this).toString(f);

    for (var a = v(Math.pow(f, 6)), c = this, d = "";;) {
      var e = D(c, a).g;
      c = F(c, e.j(a));
      var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
      c = e;
      if (C(c)) return g + d;

      for (; 6 > g.length;) {
        g = "0" + g;
      }

      d = g + d;
    }
  };

  h.i = function (f) {
    return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
  };

  function C(f) {
    if (0 != f.h) return !1;

    for (var a = 0; a < f.g.length; a++) {
      if (0 != f.g[a]) return !1;
    }

    return !0;
  }

  function B(f) {
    return -1 == f.h;
  }

  h.l = function (f) {
    f = F(this, f);
    return B(f) ? -1 : C(f) ? 0 : 1;
  };

  function x(f) {
    for (var a = f.g.length, c = [], d = 0; d < a; d++) {
      c[d] = ~f.g[d];
    }

    return new t(c, ~f.h).add(z);
  }

  h.abs = function () {
    return B(this) ? x(this) : this;
  };

  h.add = function (f) {
    for (var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++) {
      var g = d + (this.i(e) & 65535) + (f.i(e) & 65535),
          b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
      d = b >>> 16;
      g &= 65535;
      b &= 65535;
      c[e] = b << 16 | g;
    }

    return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
  };

  function F(f, a) {
    return f.add(x(a));
  }

  h.j = function (f) {
    if (C(this) || C(f)) return w;
    if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
    if (B(f)) return x(this.j(x(f)));
    if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());

    for (var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++) {
      c[d] = 0;
    }

    for (d = 0; d < this.g.length; d++) {
      for (var e = 0; e < f.g.length; e++) {
        var g = this.i(d) >>> 16,
            b = this.i(d) & 65535,
            r = f.i(e) >>> 16,
            E = f.i(e) & 65535;
        c[2 * d + 2 * e] += b * E;
        G(c, 2 * d + 2 * e);
        c[2 * d + 2 * e + 1] += g * E;
        G(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 1] += b * r;
        G(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 2] += g * r;
        G(c, 2 * d + 2 * e + 2);
      }
    }

    for (d = 0; d < a; d++) {
      c[d] = c[2 * d + 1] << 16 | c[2 * d];
    }

    for (d = a; d < 2 * a; d++) {
      c[d] = 0;
    }

    return new t(c, 0);
  };

  function G(f, a) {
    for (; (f[a] & 65535) != f[a];) {
      f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
  }

  function H(f, a) {
    this.g = f;
    this.h = a;
  }

  function D(f, a) {
    if (C(a)) throw Error("division by zero");
    if (C(f)) return new H(w, w);
    if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
    if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);

    if (30 < f.g.length) {
      if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");

      for (var c = z, d = a; 0 >= d.l(f);) {
        c = I(c), d = I(d);
      }

      var e = J(c, 1),
          g = J(d, 1);
      d = J(d, 2);

      for (c = J(c, 2); !C(d);) {
        var b = g.add(d);
        0 >= b.l(f) && (e = e.add(c), g = b);
        d = J(d, 1);
        c = J(c, 1);
      }

      a = F(f, e.j(a));
      return new H(e, a);
    }

    for (e = w; 0 <= f.l(a);) {
      c = Math.max(1, Math.floor(f.m() / a.m()));
      d = Math.ceil(Math.log(c) / Math.LN2);
      d = 48 >= d ? 1 : Math.pow(2, d - 48);
      g = v(c);

      for (b = g.j(a); B(b) || 0 < b.l(f);) {
        c -= d, g = v(c), b = g.j(a);
      }

      C(g) && (g = z);
      e = e.add(g);
      f = F(f, b);
    }

    return new H(e, f);
  }

  h.A = function (f) {
    return D(this, f).h;
  };

  h.and = function (f) {
    for (var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++) {
      c[d] = this.i(d) & f.i(d);
    }

    return new t(c, this.h & f.h);
  };

  h.or = function (f) {
    for (var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++) {
      c[d] = this.i(d) | f.i(d);
    }

    return new t(c, this.h | f.h);
  };

  h.xor = function (f) {
    for (var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++) {
      c[d] = this.i(d) ^ f.i(d);
    }

    return new t(c, this.h ^ f.h);
  };

  function I(f) {
    for (var a = f.g.length + 1, c = [], d = 0; d < a; d++) {
      c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
    }

    return new t(c, f.h);
  }

  function J(f, a) {
    var c = a >> 5;
    a %= 32;

    for (var d = f.g.length - c, e = [], g = 0; g < d; g++) {
      e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
    }

    return new t(e, f.h);
  }

  m.prototype.digest = m.prototype.v;
  m.prototype.reset = m.prototype.s;
  m.prototype.update = m.prototype.u;
  Md5 = m;
  t.prototype.add = t.prototype.add;
  t.prototype.multiply = t.prototype.j;
  t.prototype.modulo = t.prototype.A;
  t.prototype.compare = t.prototype.l;
  t.prototype.toNumber = t.prototype.m;
  t.prototype.toString = t.prototype.toString;
  t.prototype.getBits = t.prototype.i;
  t.fromNumber = v;
  t.fromString = y;
  Integer = t;
}).apply(typeof commonjsGlobal$1 !== 'undefined' ? commonjsGlobal$1 : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/

var XhrIo;
var FetchXmlHttpFactory;
var WebChannel;
var EventType;
var ErrorCode;
var Stat;
var Event;
var getStatEventTarget;
var createWebChannelTransport;
(function () {
  var h,
      aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
    if (a == Array.prototype || a == Object.prototype) return a;
    a[b] = c.value;
    return a;
  };

  function ba(a) {
    a = ["object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis, a, "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window, "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self, "object" == _typeof(commonjsGlobal) && commonjsGlobal];

    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math) return c;
    }

    throw Error("Cannot find global object");
  }

  var ca = ba(this);

  function da(a, b) {
    if (b) a: {
      var c = ca;
      a = a.split(".");

      for (var d = 0; d < a.length - 1; d++) {
        var e = a[d];
        if (!(e in c)) break a;
        c = c[e];
      }

      a = a[a.length - 1];
      d = c[a];
      b = b(d);
      b != d && null != b && aa(c, a, {
        configurable: !0,
        writable: !0,
        value: b
      });
    }
  }

  function ea(a, b) {
    a instanceof String && (a += "");
    var c = 0,
        d = !1,
        e = {
      next: function next() {
        if (!d && c < a.length) {
          var f = c++;
          return {
            value: b(f, a[f]),
            done: !1
          };
        }

        d = !0;
        return {
          done: !0,
          value: void 0
        };
      }
    };

    e[Symbol.iterator] = function () {
      return e;
    };

    return e;
  }

  da("Array.prototype.values", function (a) {
    return a ? a : function () {
      return ea(this, function (b, c) {
        return c;
      });
    };
  });
  /** @license
  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
  */

  var fa = fa || {},
      k = this || self;

  function ha(a) {
    var b = _typeof(a);

    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
  }

  function n(a) {
    var b = _typeof(a);

    return "object" == b && null != a || "function" == b;
  }

  function ia(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }

  function ja(a, b, c) {
    if (!a) throw Error();

    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function () {
        var e = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(e, d);
        return a.apply(b, e);
      };
    }

    return function () {
      return a.apply(b, arguments);
    };
  }

  function p(a, b, c) {
    p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
    return p.apply(null, arguments);
  }

  function ka(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function () {
      var d = c.slice();
      d.push.apply(d, arguments);
      return a.apply(this, d);
    };
  }

  function r(a, b) {
    function c() {}

    c.prototype = b.prototype;
    a.aa = b.prototype;
    a.prototype = new c();
    a.prototype.constructor = a;

    a.Qb = function (d, e, f) {
      for (var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++) {
        g[m - 2] = arguments[m];
      }

      return b.prototype[e].apply(d, g);
    };
  }

  function la(a) {
    var b = a.length;

    if (0 < b) {
      var c = Array(b);

      for (var d = 0; d < b; d++) {
        c[d] = a[d];
      }

      return c;
    }

    return [];
  }

  function ma(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];

      if (ha(d)) {
        var e = a.length || 0,
            f = d.length || 0;
        a.length = e + f;

        for (var g = 0; g < f; g++) {
          a[e + g] = d[g];
        }
      } else a.push(d);
    }
  }

  var na = /*#__PURE__*/function () {
    function na(a, b) {
      _classCallCheck(this, na);

      this.i = a;
      this.j = b;
      this.h = 0;
      this.g = null;
    }

    _createClass(na, [{
      key: "get",
      value: function get() {
        var a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
      }
    }]);

    return na;
  }();

  function t(a) {
    return /^[\s\xa0]*$/.test(a);
  }

  function u() {
    var a = k.navigator;
    return a && (a = a.userAgent) ? a : "";
  }

  function oa(a) {
    oa[" "](a);
    return a;
  }

  oa[" "] = function () {};

  var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");

  function qa(a, b, c) {
    for (var d in a) {
      b.call(c, a[d], d, a);
    }
  }

  function ra(a, b) {
    for (var c in a) {
      b.call(void 0, a[c], c, a);
    }
  }

  function sa(a) {
    var b = {};

    for (var c in a) {
      b[c] = a[c];
    }

    return b;
  }

  var ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

  function ua(a, b) {
    var c, d;

    for (var e = 1; e < arguments.length; e++) {
      d = arguments[e];

      for (c in d) {
        a[c] = d[c];
      }

      for (var f = 0; f < ta.length; f++) {
        c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  }

  function va(a) {
    var b = 1;
    a = a.split(":");
    var c = [];

    for (; 0 < b && a.length;) {
      c.push(a.shift()), b--;
    }

    a.length && c.push(a.join(":"));
    return c;
  }

  function wa(a) {
    k.setTimeout(function () {
      throw a;
    }, 0);
  }

  function xa() {
    var a = za;
    var b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
  }

  var Aa = /*#__PURE__*/function () {
    function Aa() {
      _classCallCheck(this, Aa);

      this.h = this.g = null;
    }

    _createClass(Aa, [{
      key: "add",
      value: function add(a, b) {
        var c = Ba.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
      }
    }]);

    return Aa;
  }();

  var Ba = new na(function () {
    return new Ca();
  }, function (a) {
    return a.reset();
  });

  var Ca = /*#__PURE__*/function () {
    function Ca() {
      _classCallCheck(this, Ca);

      this.next = this.g = this.h = null;
    }

    _createClass(Ca, [{
      key: "set",
      value: function set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
      }
    }, {
      key: "reset",
      value: function reset() {
        this.next = this.g = this.h = null;
      }
    }]);

    return Ca;
  }();

  var x,
      y = !1,
      za = new Aa(),
      Ea = function Ea() {
    var a = k.Promise.resolve(void 0);

    x = function x() {
      a.then(Da);
    };
  };

  var Da = function Da() {
    for (var a; a = xa();) {
      try {
        a.h.call(a.g);
      } catch (c) {
        wa(c);
      }

      var b = Ba;
      b.j(a);
      100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }

    y = !1;
  };

  function z() {
    this.s = this.s;
    this.C = this.C;
  }

  z.prototype.s = !1;

  z.prototype.ma = function () {
    this.s || (this.s = !0, this.N());
  };

  z.prototype.N = function () {
    if (this.C) for (; this.C.length;) {
      this.C.shift()();
    }
  };

  function A(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
  }

  A.prototype.h = function () {
    this.defaultPrevented = !0;
  };

  var Fa = function () {
    if (!k.addEventListener || !Object.defineProperty) return !1;
    var a = !1,
        b = Object.defineProperty({}, "passive", {
      get: function get() {
        a = !0;
      }
    });

    try {
      var c = function c() {};

      k.addEventListener("test", c, b);
      k.removeEventListener("test", c, b);
    } catch (c) {}

    return a;
  }();

  function C(a, b) {
    A.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;

    if (a) {
      var c = this.type = a.type,
          d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
      this.target = a.target || a.srcElement;
      this.g = b;

      if (b = a.relatedTarget) {
        if (pa) {
          a: {
            try {
              oa(b.nodeName);
              var e = !0;
              break a;
            } catch (f) {}

            e = !1;
          }

          e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);

      this.relatedTarget = b;
      d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
      this.button = a.button;
      this.key = a.key || "";
      this.ctrlKey = a.ctrlKey;
      this.altKey = a.altKey;
      this.shiftKey = a.shiftKey;
      this.metaKey = a.metaKey;
      this.pointerId = a.pointerId || 0;
      this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
      this.state = a.state;
      this.i = a;
      a.defaultPrevented && C.aa.h.call(this);
    }
  }

  r(C, A);
  var Ga = {
    2: "touch",
    3: "pen",
    4: "mouse"
  };

  C.prototype.h = function () {
    C.aa.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
  };

  var D = "closure_listenable_" + (1E6 * Math.random() | 0);
  var Ha = 0;

  function Ia(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ha = e;
    this.key = ++Ha;
    this.da = this.fa = !1;
  }

  function Ja(a) {
    a.da = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ha = null;
  }

  function Ka(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
  }

  Ka.prototype.add = function (a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var g = La(a, b, d, e);
    -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
    return b;
  };

  function Ma(a, b) {
    var c = b.type;

    if (c in a.g) {
      var d = a.g[c],
          e = Array.prototype.indexOf.call(d, b, void 0),
          f;
      (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
      f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
  }

  function La(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];
      if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
    }

    return -1;
  }

  var Na = "closure_lm_" + (1E6 * Math.random() | 0),
      Oa = {};

  function Qa(a, b, c, d, e) {
    if (d && d.once) return Ra(a, b, c, d, e);

    if (Array.isArray(b)) {
      for (var f = 0; f < b.length; f++) {
        Qa(a, b[f], c, d, e);
      }

      return null;
    }

    c = Sa(c);
    return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
  }

  function Ta(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var g = n(e) ? !!e.capture : !!e,
        m = Ua(a);
    m || (a[Na] = m = new Ka(a));
    c = m.add(b, c, d, g, f);
    if (c.proxy) return c;
    d = Va();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
  }

  function Va() {
    function a(c) {
      return b.call(a.src, a.listener, c);
    }

    var b = Xa;
    return a;
  }

  function Ra(a, b, c, d, e) {
    if (Array.isArray(b)) {
      for (var f = 0; f < b.length; f++) {
        Ra(a, b[f], c, d, e);
      }

      return null;
    }

    c = Sa(c);
    return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
  }

  function Ya(a, b, c, d, e) {
    if (Array.isArray(b)) for (var f = 0; f < b.length; f++) {
      Ya(a, b[f], c, d, e);
    } else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
  }

  function Za(a) {
    if ("number" !== typeof a && a && !a.da) {
      var b = a.src;
      if (b && b[D]) Ma(b.i, a);else {
        var c = a.type,
            d = a.proxy;
        b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
        (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
      }
    }
  }

  function Wa(a) {
    return a in Oa ? Oa[a] : Oa[a] = "on" + a;
  }

  function Xa(a, b) {
    if (a.da) a = !0;else {
      b = new C(b, this);
      var c = a.listener,
          d = a.ha || a.src;
      a.fa && Za(a);
      a = c.call(d, b);
    }
    return a;
  }

  function Ua(a) {
    a = a[Na];
    return a instanceof Ka ? a : null;
  }

  var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

  function Sa(a) {
    if ("function" === typeof a) return a;
    a[$a] || (a[$a] = function (b) {
      return a.handleEvent(b);
    });
    return a[$a];
  }

  function E() {
    z.call(this);
    this.i = new Ka(this);
    this.M = this;
    this.F = null;
  }

  r(E, z);
  E.prototype[D] = !0;

  E.prototype.removeEventListener = function (a, b, c, d) {
    Ya(this, a, b, c, d);
  };

  function F(a, b) {
    var c,
        d = a.F;
    if (d) for (c = []; d; d = d.F) {
      c.push(d);
    }
    a = a.M;
    d = b.type || b;
    if ("string" === typeof b) b = new A(b, a);else if (b instanceof A) b.target = b.target || a;else {
      var e = b;
      b = new A(d, a);
      ua(b, e);
    }
    e = !0;
    if (c) for (var f = c.length - 1; 0 <= f; f--) {
      var g = b.g = c[f];
      e = ab(g, d, !0, b) && e;
    }
    g = b.g = a;
    e = ab(g, d, !0, b) && e;
    e = ab(g, d, !1, b) && e;
    if (c) for (f = 0; f < c.length; f++) {
      g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
  }

  E.prototype.N = function () {
    E.aa.N.call(this);

    if (this.i) {
      var a = this.i,
          c;

      for (c in a.g) {
        for (var d = a.g[c], e = 0; e < d.length; e++) {
          Ja(d[e]);
        }

        delete a.g[c];
        a.h--;
      }
    }

    this.F = null;
  };

  E.prototype.K = function (a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
  };

  E.prototype.L = function (a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
  };

  function ab(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();

    for (var e = !0, f = 0; f < b.length; ++f) {
      var g = b[f];

      if (g && !g.da && g.capture == c) {
        var m = g.listener,
            q = g.ha || g.src;
        g.fa && Ma(a.i, g);
        e = !1 !== m.call(q, d) && e;
      }
    }

    return e && !d.defaultPrevented;
  }

  function bb(a, b, c) {
    if ("function" === typeof a) c && (a = p(a, c));else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
  }

  function cb(a) {
    a.g = bb(function () {
      a.g = null;
      a.i && (a.i = !1, cb(a));
    }, a.l);
    var b = a.h;
    a.h = null;
    a.m.apply(null, b);
  }

  var eb = /*#__PURE__*/function (_z) {
    _inherits(eb, _z);

    var _super = _createSuper$1(eb);

    function eb(a, b) {
      var _this;

      _classCallCheck(this, eb);

      _this = _super.call(this);
      _this.m = a;
      _this.l = b;
      _this.h = null;
      _this.i = !1;
      _this.g = null;
      return _this;
    }

    _createClass(eb, [{
      key: "j",
      value: function j(a) {
        this.h = arguments;
        this.g ? this.i = !0 : cb(this);
      }
    }, {
      key: "N",
      value: function N() {
        _get(_getPrototypeOf(eb.prototype), "N", this).call(this);

        this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
      }
    }]);

    return eb;
  }(z);

  function G(a) {
    z.call(this);
    this.h = a;
    this.g = {};
  }

  r(G, z);
  var fb = [];

  function gb(a) {
    qa(a.g, function (b, c) {
      this.g.hasOwnProperty(c) && Za(b);
    }, a);
    a.g = {};
  }

  G.prototype.N = function () {
    G.aa.N.call(this);
    gb(this);
  };

  G.prototype.handleEvent = function () {
    throw Error("EventHandler.handleEvent not implemented");
  };

  var hb = k.JSON.stringify;
  var ib = k.JSON.parse;

  var jb = /*#__PURE__*/function () {
    function jb() {
      _classCallCheck(this, jb);
    }

    _createClass(jb, [{
      key: "stringify",
      value: function stringify(a) {
        return k.JSON.stringify(a, void 0);
      }
    }, {
      key: "parse",
      value: function parse(a) {
        return k.JSON.parse(a, void 0);
      }
    }]);

    return jb;
  }();

  function kb() {}

  kb.prototype.h = null;

  function lb(a) {
    return a.h || (a.h = a.i());
  }

  function mb() {}

  var H = {
    OPEN: "a",
    kb: "b",
    Ja: "c",
    wb: "d"
  };

  function nb() {
    A.call(this, "d");
  }

  r(nb, A);

  function ob() {
    A.call(this, "c");
  }

  r(ob, A);
  var I = {},
      pb = null;

  function qb() {
    return pb = pb || new E();
  }

  I.La = "serverreachability";

  function rb(a) {
    A.call(this, I.La, a);
  }

  r(rb, A);

  function J(a) {
    var b = qb();
    F(b, new rb(b));
  }

  I.STAT_EVENT = "statevent";

  function sb(a, b) {
    A.call(this, I.STAT_EVENT, a);
    this.stat = b;
  }

  r(sb, A);

  function K(a) {
    var b = qb();
    F(b, new sb(b, a));
  }

  I.Ma = "timingevent";

  function tb(a, b) {
    A.call(this, I.Ma, a);
    this.size = b;
  }

  r(tb, A);

  function ub(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return k.setTimeout(function () {
      a();
    }, b);
  }

  function vb() {
    this.g = !0;
  }

  vb.prototype.xa = function () {
    this.g = !1;
  };

  function wb(a, b, c, d, e, f) {
    a.info(function () {
      if (a.g) {
        if (f) {
          var g = "";

          for (var m = f.split("&"), q = 0; q < m.length; q++) {
            var l = m[q].split("=");

            if (1 < l.length) {
              var v = l[0];
              l = l[1];
              var w = v.split("_");
              g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
            }
          }
        } else g = null;
      } else g = f;
      return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
    });
  }

  function xb(a, b, c, d, e, f, g) {
    a.info(function () {
      return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
    });
  }

  function L(a, b, c, d) {
    a.info(function () {
      return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
    });
  }

  function zb(a, b) {
    a.info(function () {
      return "TIMEOUT: " + b;
    });
  }

  vb.prototype.info = function () {};

  function yb(a, b) {
    if (!a.g) return b;
    if (!b) return null;

    try {
      var c = JSON.parse(b);
      if (c) for (a = 0; a < c.length; a++) {
        if (Array.isArray(c[a])) {
          var d = c[a];

          if (!(2 > d.length)) {
            var e = d[1];

            if (Array.isArray(e) && !(1 > e.length)) {
              var f = e[0];
              if ("noop" != f && "stop" != f && "close" != f) for (var g = 1; g < e.length; g++) {
                e[g] = "";
              }
            }
          }
        }
      }
      return hb(c);
    } catch (m) {
      return b;
    }
  }

  var Ab = {
    NO_ERROR: 0,
    gb: 1,
    tb: 2,
    sb: 3,
    nb: 4,
    rb: 5,
    ub: 6,
    Ia: 7,
    TIMEOUT: 8,
    xb: 9
  };
  var Bb = {
    lb: "complete",
    Hb: "success",
    Ja: "error",
    Ia: "abort",
    zb: "ready",
    Ab: "readystatechange",
    TIMEOUT: "timeout",
    vb: "incrementaldata",
    yb: "progress",
    ob: "downloadprogress",
    Pb: "uploadprogress"
  };
  var Cb;

  function Db() {}

  r(Db, kb);

  Db.prototype.g = function () {
    return new XMLHttpRequest();
  };

  Db.prototype.i = function () {
    return {};
  };

  Cb = new Db();

  function M(a, b, c, d) {
    this.j = a;
    this.i = b;
    this.l = c;
    this.R = d || 1;
    this.U = new G(this);
    this.I = 45E3;
    this.H = null;
    this.o = !1;
    this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
    this.D = [];
    this.g = null;
    this.C = 0;
    this.s = this.u = null;
    this.X = -1;
    this.J = !1;
    this.O = 0;
    this.M = null;
    this.W = this.K = this.T = this.P = !1;
    this.h = new Eb();
  }

  function Eb() {
    this.i = null;
    this.g = "";
    this.h = !1;
  }

  var Fb = {},
      Gb = {};

  function Hb(a, b, c) {
    a.L = 1;
    a.v = Ib(N(b));
    a.m = c;
    a.P = !0;
    Jb(a, null);
  }

  function Jb(a, b) {
    a.F = Date.now();
    Kb(a);
    a.A = N(a.v);
    var c = a.A,
        d = a.R;
    Array.isArray(d) || (d = [String(d)]);
    Lb(c.i, "t", d);
    a.C = 0;
    c = a.j.J;
    a.h = new Eb();
    a.g = Mb(a.j, c ? b : null, !a.m);
    0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
    b = a.U;
    c = a.g;
    d = a.ca;
    var e = "readystatechange";
    Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);

    for (var f = 0; f < e.length; f++) {
      var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
      if (!g) break;
      b.g[g.key] = g;
    }

    b = a.H ? sa(a.H) : {};
    a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
    J();
    wb(a.i, a.u, a.A, a.l, a.R, a.m);
  }

  M.prototype.ca = function (a) {
    a = a.target;
    var b = this.M;
    b && 3 == P(a) ? b.j() : this.Y(a);
  };

  M.prototype.Y = function (a) {
    try {
      if (a == this.g) a: {
        var w = P(this.g);
        var b = this.g.Ba();
        var O = this.g.Z();

        if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
          this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
          Ob(this);
          var c = this.g.Z();
          this.X = c;

          b: if (Pb(this)) {
            var d = Nb(this.g);
            a = "";
            var e = d.length,
                f = 4 == P(this.g);

            if (!this.h.i) {
              if ("undefined" === typeof TextDecoder) {
                Q(this);
                Qb(this);
                var g = "";
                break b;
              }

              this.h.i = new k.TextDecoder();
            }

            for (b = 0; b < e; b++) {
              this.h.h = !0, a += this.h.i.decode(d[b], {
                stream: !(f && b == e - 1)
              });
            }

            d.length = 0;
            this.h.g += a;
            this.C = 0;
            g = this.h.g;
          } else g = this.g.oa();

          this.o = 200 == c;
          xb(this.i, this.u, this.A, this.l, this.R, w, c);

          if (this.o) {
            if (this.T && !this.K) {
              b: {
                if (this.g) {
                  var m,
                      q = this.g;

                  if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                    var l = m;
                    break b;
                  }
                }

                l = null;
              }

              if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);else {
                this.o = !1;
                this.s = 3;
                K(12);
                Q(this);
                Qb(this);
                break a;
              }
            }

            if (this.P) {
              c = !0;
              var B;

              for (; !this.J && this.C < g.length;) {
                if (B = Sb(this, g), B == Gb) {
                  4 == w && (this.s = 4, K(14), c = !1);
                  L(this.i, this.l, null, "[Incomplete Response]");
                  break;
                } else if (B == Fb) {
                  this.s = 4;
                  K(15);
                  L(this.i, this.l, g, "[Invalid Chunk]");
                  c = !1;
                  break;
                } else L(this.i, this.l, B, null), Rb(this, B);
              }

              Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
              4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
              this.o = this.o && c;
              if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);else if (0 < g.length && !this.W) {
                this.W = !0;
                var v = this.j;
                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
              }
            } else L(this.i, this.l, g, null), Rb(this, g);

            4 == w && Q(this);
            this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
          } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
        }
      }
    } catch (w) {} finally {}
  };

  function Pb(a) {
    return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
  }

  function Sb(a, b) {
    var c = a.C,
        d = b.indexOf("\n", c);
    if (-1 == d) return Gb;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return Fb;
    d += 1;
    if (d + c > b.length) return Gb;
    b = b.slice(d, d + c);
    a.C = d + c;
    return b;
  }

  M.prototype.cancel = function () {
    this.J = !0;
    Q(this);
  };

  function Kb(a) {
    a.S = Date.now() + a.I;
    Wb(a, a.I);
  }

  function Wb(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = ub(p(a.ba, a), b);
  }

  function Ob(a) {
    a.B && (k.clearTimeout(a.B), a.B = null);
  }

  M.prototype.ba = function () {
    this.B = null;
    var a = Date.now();
    0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
  };

  function Qb(a) {
    0 == a.j.G || a.J || Ub(a.j, a);
  }

  function Q(a) {
    Ob(a);
    var b = a.M;
    b && "function" == typeof b.ma && b.ma();
    a.M = null;
    gb(a.U);
    a.g && (b = a.g, a.g = null, b.abort(), b.ma());
  }

  function Rb(a, b) {
    try {
      var c = a.j;
      if (0 != c.G && (c.g == a || Xb(c.h, a))) if (!a.K && Xb(c.h, a) && 3 == c.G) {
        try {
          var d = c.Da.g.parse(b);
        } catch (l) {
          d = null;
        }

        if (Array.isArray(d) && 3 == d.length) {
          var e = d;
          if (0 == e[0]) a: {
            if (!c.u) {
              if (c.g) if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);else break a;
              $b(c);
              K(18);
            }
          } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));

          if (1 >= ac(c.h) && c.ca) {
            try {
              c.ca();
            } catch (l) {}

            c.ca = void 0;
          }
        } else R(c, 11);
      } else if ((a.K || c.g == a) && Yb(c), !t(b)) for (e = c.Da.g.parse(b), b = 0; b < e.length; b++) {
        var l = e[b];
        c.T = l[0];
        l = l[1];
        if (2 == c.G) {
          if ("c" == l[0]) {
            c.K = l[1];
            c.ia = l[2];
            var v = l[3];
            null != v && (c.la = v, c.j.info("VER=" + c.la));
            var w = l[4];
            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
            var O = l[5];
            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
            d = c;
            var B = a.g;

            if (B) {
              var ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;

              if (ya) {
                var f = d.h;
                f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set(), f.h && (bc(f, f.h), f.h = null));
              }

              if (d.D) {
                var db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                db && (d.ya = db, S(d.I, d.D, db));
              }
            }

            c.G = 3;
            c.l && c.l.ua();
            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
            d = c;
            var g = a;
            d.qa = cc(d, d.J ? d.ia : null, d.W);

            if (g.K) {
              dc(d.h, g);
              var m = g,
                  q = d.L;
              q && (m.I = q);
              m.B && (Ob(m), Kb(m));
              d.g = g;
            } else ec(d);

            0 < c.i.length && fc(c);
          } else "stop" != l[0] && "close" != l[0] || R(c, 7);
        } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
      }
      J(4);
    } catch (l) {}
  }

  var hc = /*#__PURE__*/_createClass(function hc(a, b) {
    _classCallCheck(this, hc);

    this.g = a;
    this.map = b;
  });

  function ic(a) {
    this.l = a || 10;
    k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set());
    this.h = null;
    this.i = [];
  }

  function jc(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
  }

  function ac(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
  }

  function Xb(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
  }

  function bc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
  }

  function dc(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g["delete"](b);
  }

  ic.prototype.cancel = function () {
    this.i = kc(this);
    if (this.h) this.h.cancel(), this.h = null;else if (this.g && 0 !== this.g.size) {
      var _iterator = _createForOfIteratorHelper$1(this.g.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var a = _step.value;
          a.cancel();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.g.clear();
    }
  };

  function kc(a) {
    if (null != a.h) return a.i.concat(a.h.D);

    if (null != a.g && 0 !== a.g.size) {
      var b = a.i;

      var _iterator2 = _createForOfIteratorHelper$1(a.g.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          b = b.concat(c.D);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return b;
    }

    return la(a.i);
  }

  function lc(a) {
    if (a.V && "function" == typeof a.V) return a.V();
    if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
    if ("string" === typeof a) return a.split("");

    if (ha(a)) {
      for (var b = [], c = a.length, d = 0; d < c; d++) {
        b.push(a[d]);
      }

      return b;
    }

    b = [];
    c = 0;

    for (d in a) {
      b[c++] = a[d];
    }

    return b;
  }

  function mc(a) {
    if (a.na && "function" == typeof a.na) return a.na();

    if (!a.V || "function" != typeof a.V) {
      if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());

      if (!("undefined" !== typeof Set && a instanceof Set)) {
        if (ha(a) || "string" === typeof a) {
          var b = [];
          a = a.length;

          for (var c = 0; c < a; c++) {
            b.push(c);
          }

          return b;
        }

        b = [];
        c = 0;

        for (var d in a) {
          b[c++] = d;
        }

        return b;
      }
    }
  }

  function nc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);else for (var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++) {
      b.call(void 0, d[f], c && c[f], a);
    }
  }

  var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");

  function pc(a, b) {
    if (a) {
      a = a.split("&");

      for (var c = 0; c < a.length; c++) {
        var d = a[c].indexOf("="),
            e = null;

        if (0 <= d) {
          var f = a[c].substring(0, d);
          e = a[c].substring(d + 1);
        } else f = a[c];

        b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
      }
    }
  }

  function T(a) {
    this.g = this.o = this.j = "";
    this.s = null;
    this.m = this.l = "";
    this.h = !1;

    if (a instanceof T) {
      this.h = a.h;
      qc(this, a.j);
      this.o = a.o;
      this.g = a.g;
      rc(this, a.s);
      this.l = a.l;
      var b = a.i;
      var c = new sc();
      c.i = b.i;
      b.g && (c.g = new Map(b.g), c.h = b.h);
      tc(this, c);
      this.m = a.m;
    } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
  }

  T.prototype.toString = function () {
    var a = [],
        b = this.j;
    b && a.push(vc(b, wc, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
    if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
    (c = this.i.toString()) && a.push("?", c);
    (c = this.m) && a.push("#", vc(c, zc));
    return a.join("");
  };

  function N(a) {
    return new T(a);
  }

  function qc(a, b, c) {
    a.j = c ? uc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
  }

  function rc(a, b) {
    if (b) {
      b = Number(b);
      if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
      a.s = b;
    } else a.s = null;
  }

  function tc(a, b, c) {
    b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
  }

  function S(a, b, c) {
    a.i.set(b, c);
  }

  function Ib(a) {
    S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
  }

  function uc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }

  function vc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }

  function Cc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }

  var wc = /[#\/\?@]/g,
      yc = /[#\?:]/g,
      xc = /[#\?]/g,
      Bc = /[#\?@]/g,
      zc = /#/g;

  function sc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
  }

  function U(a) {
    a.g || (a.g = new Map(), a.h = 0, a.i && pc(a.i, function (b, c) {
      a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
  }

  h = sc.prototype;

  h.add = function (a, b) {
    U(this);
    this.i = null;
    a = V(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
  };

  function Dc(a, b) {
    U(a);
    b = V(a, b);
    a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g["delete"](b));
  }

  function Ec(a, b) {
    U(a);
    b = V(a, b);
    return a.g.has(b);
  }

  h.forEach = function (a, b) {
    U(this);
    this.g.forEach(function (c, d) {
      c.forEach(function (e) {
        a.call(b, e, d, this);
      }, this);
    }, this);
  };

  h.na = function () {
    U(this);
    var a = Array.from(this.g.values()),
        b = Array.from(this.g.keys()),
        c = [];

    for (var d = 0; d < b.length; d++) {
      var e = a[d];

      for (var f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }

    return c;
  };

  h.V = function (a) {
    U(this);
    var b = [];
    if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));else {
      a = Array.from(this.g.values());

      for (var c = 0; c < a.length; c++) {
        b = b.concat(a[c]);
      }
    }
    return b;
  };

  h.set = function (a, b) {
    U(this);
    this.i = null;
    a = V(this, a);
    Ec(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [b]);
    this.h += 1;
    return this;
  };

  h.get = function (a, b) {
    if (!a) return b;
    a = this.V(a);
    return 0 < a.length ? String(a[0]) : b;
  };

  function Lb(a, b, c) {
    Dc(a, b);
    0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
  }

  h.toString = function () {
    if (this.i) return this.i;
    if (!this.g) return "";
    var a = [],
        b = Array.from(this.g.keys());

    for (var c = 0; c < b.length; c++) {
      var d = b[c];
      var f = encodeURIComponent(String(d)),
          g = this.V(d);

      for (d = 0; d < g.length; d++) {
        var e = f;
        "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
        a.push(e);
      }
    }

    return this.i = a.join("&");
  };

  function V(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
  }

  function Ac(a, b) {
    b && !a.j && (U(a), a.i = null, a.g.forEach(function (c, d) {
      var e = d.toLowerCase();
      d != e && (Dc(this, d), Lb(this, e, c));
    }, a));
    a.j = b;
  }

  function Fc(a, b) {
    var c = new vb();

    if (k.Image) {
      var d = new Image();
      d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
      d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
      d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
      d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
      k.setTimeout(function () {
        if (d.ontimeout) d.ontimeout();
      }, 1E4);
      d.src = a;
    } else b(!1);
  }

  function Gc(a, b) {
    var c = new vb(),
        d = new AbortController(),
        e = setTimeout(function () {
      d.abort();
      W(c, "TestPingServer: timeout", !1, b);
    }, 1E4);
    fetch(a, {
      signal: d.signal
    }).then(function (f) {
      clearTimeout(e);
      f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
    })["catch"](function () {
      clearTimeout(e);
      W(c, "TestPingServer: error", !1, b);
    });
  }

  function W(a, b, c, d, e) {
    try {
      e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
    } catch (f) {}
  }

  function Hc() {
    this.g = new jb();
  }

  function Ic(a, b, c) {
    var d = c || "";

    try {
      nc(a, function (e, f) {
        var g = e;
        n(e) && (g = hb(e));
        b.push(d + f + "=" + encodeURIComponent(g));
      });
    } catch (e) {
      throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
  }

  function Jc(a) {
    this.l = a.Ub || null;
    this.j = a.eb || !1;
  }

  r(Jc, kb);

  Jc.prototype.g = function () {
    return new Kc(this.l, this.j);
  };

  Jc.prototype.i = function (a) {
    return function () {
      return a;
    };
  }({});

  function Kc(a, b) {
    E.call(this);
    this.D = a;
    this.o = b;
    this.m = void 0;
    this.status = this.readyState = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.u = new Headers();
    this.h = null;
    this.B = "GET";
    this.A = "";
    this.g = !1;
    this.v = this.j = this.l = null;
  }

  r(Kc, E);
  h = Kc.prototype;

  h.open = function (a, b) {
    if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
    this.B = a;
    this.A = b;
    this.readyState = 1;
    Lc(this);
  };

  h.send = function (a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    var b = {
      headers: this.u,
      method: this.B,
      credentials: this.m,
      cache: void 0
    };
    a && (b.body = a);
    (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
  };

  h.abort = function () {
    this.response = this.responseText = "";
    this.u = new Headers();
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.")["catch"](function () {});
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
    this.readyState = 0;
  };

  h.Sa = function (a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
      this.j = a.body.getReader();

      if (this.o) {
        if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
        this.response = [];
      } else this.response = this.responseText = "", this.v = new TextDecoder();

      Nc(this);
    } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
  };

  function Nc(a) {
    a.j.read().then(a.Pa.bind(a))["catch"](a.ga.bind(a));
  }

  h.Pa = function (a) {
    if (this.g) {
      if (this.o && a.value) this.response.push(a.value);else if (!this.o) {
        var b = a.value ? a.value : new Uint8Array(0);
        if (b = this.v.decode(b, {
          stream: !a.done
        })) this.response = this.responseText += b;
      }
      a.done ? Mc(this) : Lc(this);
      3 == this.readyState && Nc(this);
    }
  };

  h.Ra = function (a) {
    this.g && (this.response = this.responseText = a, Mc(this));
  };

  h.Qa = function (a) {
    this.g && (this.response = a, Mc(this));
  };

  h.ga = function () {
    this.g && Mc(this);
  };

  function Mc(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.v = null;
    Lc(a);
  }

  h.setRequestHeader = function (a, b) {
    this.u.append(a, b);
  };

  h.getResponseHeader = function (a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
  };

  h.getAllResponseHeaders = function () {
    if (!this.h) return "";
    var a = [],
        b = this.h.entries();

    for (var c = b.next(); !c.done;) {
      c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    }

    return a.join("\r\n");
  };

  function Lc(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
  }

  Object.defineProperty(Kc.prototype, "withCredentials", {
    get: function get() {
      return "include" === this.m;
    },
    set: function set(a) {
      this.m = a ? "include" : "same-origin";
    }
  });

  function Oc(a) {
    var b = "";
    qa(a, function (c, d) {
      b += d;
      b += ":";
      b += c;
      b += "\r\n";
    });
    return b;
  }

  function Pc(a, b, c) {
    a: {
      for (d in c) {
        var d = !1;
        break a;
      }

      d = !0;
    }

    d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
  }

  function X(a) {
    E.call(this);
    this.headers = new Map();
    this.o = a || null;
    this.h = !1;
    this.v = this.g = null;
    this.D = "";
    this.m = 0;
    this.l = "";
    this.j = this.B = this.u = this.A = !1;
    this.I = null;
    this.H = "";
    this.J = !1;
  }

  r(X, E);
  var Qc = /^https?$/i,
      Rc = ["POST", "PUT"];
  h = X.prototype;

  h.Ha = function (a) {
    this.J = a;
  };

  h.ea = function (a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.D = a;
    this.l = "";
    this.m = 0;
    this.A = !1;
    this.h = !0;
    this.g = this.o ? this.o.g() : Cb.g();
    this.v = this.o ? lb(this.o) : lb(Cb);
    this.g.onreadystatechange = p(this.Ea, this);

    try {
      this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
    } catch (f) {
      Sc(this, f);
      return;
    }

    a = c || "";
    c = new Map(this.headers);
    if (d) if (Object.getPrototypeOf(d) === Object.prototype) for (var e in d) {
      c.set(e, d[e]);
    } else if ("function" === typeof d.keys && "function" === typeof d.get) {
      var _iterator3 = _createForOfIteratorHelper$1(d.keys()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var f = _step3.value;
          c.set(f, d.get(f));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    } else throw Error("Unknown input type for opt_headers: " + String(d));
    d = Array.from(c.keys()).find(function (f) {
      return "content-type" == f.toLowerCase();
    });
    e = k.FormData && a instanceof k.FormData;
    !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");

    var _iterator4 = _createForOfIteratorHelper$1(c),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
            _f = _step4$value[0],
            g = _step4$value[1];

        this.g.setRequestHeader(_f, g);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    this.H && (this.g.responseType = this.H);
    "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);

    try {
      Tc(this), this.u = !0, this.g.send(a), this.u = !1;
    } catch (f) {
      Sc(this, f);
    }
  };

  function Sc(a, b) {
    a.h = !1;
    a.g && (a.j = !0, a.g.abort(), a.j = !1);
    a.l = b;
    a.m = 5;
    Uc(a);
    Vc(a);
  }

  function Uc(a) {
    a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
  }

  h.abort = function (a) {
    this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
  };

  h.N = function () {
    this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
    X.aa.N.call(this);
  };

  h.Ea = function () {
    this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
  };

  h.bb = function () {
    Wc(this);
  };

  function Wc(a) {
    if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) if (a.u && 4 == P(a)) bb(a.Ea, 0, a);else if (F(a, "readystatechange"), 4 == P(a)) {
      a.h = !1;

      try {
        var g = a.Z();

        a: switch (g) {
          case 200:
          case 201:
          case 202:
          case 204:
          case 206:
          case 304:
          case 1223:
            var b = !0;
            break a;

          default:
            b = !1;
        }

        var c;

        if (!(c = b)) {
          var d;

          if (d = 0 === g) {
            var e = String(a.D).match(oc)[1] || null;
            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
            d = !Qc.test(e ? e.toLowerCase() : "");
          }

          c = d;
        }

        if (c) F(a, "complete"), F(a, "success");else {
          a.m = 6;

          try {
            var f = 2 < P(a) ? a.g.statusText : "";
          } catch (m) {
            f = "";
          }

          a.l = f + " [" + a.Z() + "]";
          Uc(a);
        }
      } finally {
        Vc(a);
      }
    }
  }

  function Vc(a, b) {
    if (a.g) {
      Tc(a);
      var c = a.g,
          d = a.v[0] ? function () {} : null;
      a.g = null;
      a.v = null;
      b || F(a, "ready");

      try {
        c.onreadystatechange = d;
      } catch (e) {}
    }
  }

  function Tc(a) {
    a.I && (k.clearTimeout(a.I), a.I = null);
  }

  h.isActive = function () {
    return !!this.g;
  };

  function P(a) {
    return a.g ? a.g.readyState : 0;
  }

  h.Z = function () {
    try {
      return 2 < P(this) ? this.g.status : -1;
    } catch (a) {
      return -1;
    }
  };

  h.oa = function () {
    try {
      return this.g ? this.g.responseText : "";
    } catch (a) {
      return "";
    }
  };

  h.Oa = function (a) {
    if (this.g) {
      var b = this.g.responseText;
      a && 0 == b.indexOf(a) && (b = b.substring(a.length));
      return ib(b);
    }
  };

  function Nb(a) {
    try {
      if (!a.g) return null;
      if ("response" in a.g) return a.g.response;

      switch (a.H) {
        case "":
        case "text":
          return a.g.responseText;

        case "arraybuffer":
          if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
      }

      return null;
    } catch (b) {
      return null;
    }
  }

  function Vb(a) {
    var b = {};
    a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");

    for (var d = 0; d < a.length; d++) {
      if (t(a[d])) continue;
      var c = va(a[d]);
      var e = c[0];
      c = c[1];
      if ("string" !== typeof c) continue;
      c = c.trim();
      var f = b[e] || [];
      b[e] = f;
      f.push(c);
    }

    ra(b, function (d) {
      return d.join(", ");
    });
  }

  h.Ba = function () {
    return this.m;
  };

  h.Ka = function () {
    return "string" === typeof this.l ? this.l : String(this.l);
  };

  function Xc(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
  }

  function Yc(a) {
    this.Aa = 0;
    this.i = [];
    this.j = new vb();
    this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
    this.Ya = this.U = 0;
    this.Va = Xc("failFast", !1, a);
    this.F = this.C = this.u = this.s = this.l = null;
    this.X = !0;
    this.za = this.T = -1;
    this.Y = this.v = this.B = 0;
    this.Ta = Xc("baseRetryDelayMs", 5E3, a);
    this.cb = Xc("retryDelaySeedMs", 1E4, a);
    this.Wa = Xc("forwardChannelMaxRetries", 2, a);
    this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
    this.pa = a && a.xmlHttpFactory || void 0;
    this.Xa = a && a.Tb || void 0;
    this.Ca = a && a.useFetchStreams || !1;
    this.L = void 0;
    this.J = a && a.supportsCrossDomainXhr || !1;
    this.K = "";
    this.h = new ic(a && a.concurrentRequestLimit);
    this.Da = new Hc();
    this.P = a && a.fastHandshake || !1;
    this.O = a && a.encodeInitMessageHeaders || !1;
    this.P && this.O && (this.O = !1);
    this.Ua = a && a.Rb || !1;
    a && a.xa && this.j.xa();
    a && a.forceLongPolling && (this.X = !1);
    this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
    this.ja = void 0;
    a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
    this.ca = void 0;
    this.R = 0;
    this.M = !1;
    this.ka = this.A = null;
  }

  h = Yc.prototype;
  h.la = 8;
  h.G = 1;

  h.connect = function (a, b, c, d) {
    K(0);
    this.W = a;
    this.H = b || {};
    c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
    this.F = this.X;
    this.I = cc(this, null, this.W);
    fc(this);
  };

  function gc(a) {
    Zc(a);

    if (3 == a.G) {
      var b = a.U++,
          c = N(a.I);
      S(c, "SID", a.K);
      S(c, "RID", b);
      S(c, "TYPE", "terminate");
      $c(a, c);
      b = new M(a, a.j, b);
      b.L = 2;
      b.v = Ib(N(c));
      c = !1;
      if (k.navigator && k.navigator.sendBeacon) try {
        c = k.navigator.sendBeacon(b.v.toString(), "");
      } catch (d) {}
      !c && k.Image && (new Image().src = b.v, c = !0);
      c || (b.g = Mb(b.j, null), b.g.ea(b.v));
      b.F = Date.now();
      Kb(b);
    }

    ad(a);
  }

  function Zb(a) {
    a.g && (Tb(a), a.g.cancel(), a.g = null);
  }

  function Zc(a) {
    Zb(a);
    a.u && (k.clearTimeout(a.u), a.u = null);
    Yb(a);
    a.h.cancel();
    a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
  }

  function fc(a) {
    if (!jc(a.h) && !a.s) {
      a.s = !0;
      var b = a.Ga;
      x || Ea();
      y || (x(), y = !0);
      za.add(b, a);
      a.B = 0;
    }
  }

  function bd(a, b) {
    if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
    if (a.s) return a.i = b.D.concat(a.i), !0;
    if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
    a.s = ub(p(a.Ga, a, b), cd(a, a.B));
    a.B++;
    return !0;
  }

  h.Ga = function (a) {
    if (this.s) if (this.s = null, 1 == this.G) {
      if (!a) {
        this.U = Math.floor(1E5 * Math.random());
        a = this.U++;
        var e = new M(this, this.j, a);
        var f = this.o;
        this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
        null !== this.m || this.O || (e.H = f, f = null);
        if (this.P) a: {
          var b = 0;

          for (var c = 0; c < this.i.length; c++) {
            b: {
              var d = this.i[c];

              if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                d = d.length;
                break b;
              }

              d = void 0;
            }

            if (void 0 === d) break;
            b += d;

            if (4096 < b) {
              b = c;
              break a;
            }

            if (4096 === b || c === this.i.length - 1) {
              b = c + 1;
              break a;
            }
          }

          b = 1E3;
        } else b = 1E3;
        b = dd(this, e, b);
        c = N(this.I);
        S(c, "RID", a);
        S(c, "CVER", 22);
        this.D && S(c, "X-HTTP-Session-Id", this.D);
        $c(this, c);
        f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
        bc(this.h, e);
        this.Ua && S(c, "TYPE", "init");
        this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
        this.G = 2;
      }
    } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
  };

  function ed(a, b) {
    var c;
    b ? c = b.l : c = a.U++;
    var d = N(a.I);
    S(d, "SID", a.K);
    S(d, "RID", c);
    S(d, "AID", a.T);
    $c(a, d);
    a.m && a.o && Pc(d, a.m, a.o);
    c = new M(a, a.j, c, a.B + 1);
    null === a.m && (c.H = a.o);
    b && (a.i = b.D.concat(a.i));
    b = dd(a, c, 1E3);
    c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
    bc(a.h, c);
    Hb(c, d, b);
  }

  function $c(a, b) {
    a.H && qa(a.H, function (c, d) {
      S(b, d, c);
    });
    a.l && nc({}, function (c, d) {
      S(b, d, c);
    });
  }

  function dd(a, b, c) {
    c = Math.min(a.i.length, c);
    var d = a.l ? p(a.l.Na, a.l, a) : null;

    a: {
      var e = a.i;
      var f = -1;

      for (;;) {
        var g = ["count=" + c];
        -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
        var m = !0;

        for (var q = 0; q < c; q++) {
          var l = e[q].g;
          var v = e[q].map;
          l -= f;
          if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;else try {
            Ic(v, g, "req" + l + "_");
          } catch (w) {
            d && d(v);
          }
        }

        if (m) {
          d = g.join("&");
          break a;
        }
      }
    }

    a = a.i.splice(0, c);
    b.D = a;
    return d;
  }

  function ec(a) {
    if (!a.g && !a.u) {
      a.Y = 1;
      var b = a.Fa;
      x || Ea();
      y || (x(), y = !0);
      za.add(b, a);
      a.v = 0;
    }
  }

  function $b(a) {
    if (a.g || a.u || 3 <= a.v) return !1;
    a.Y++;
    a.u = ub(p(a.Fa, a), cd(a, a.v));
    a.v++;
    return !0;
  }

  h.Fa = function () {
    this.u = null;
    fd(this);

    if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
      var a = 2 * this.R;
      this.j.info("BP detection timer enabled: " + a);
      this.A = ub(p(this.ab, this), a);
    }
  };

  h.ab = function () {
    this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
  };

  function Tb(a) {
    null != a.A && (k.clearTimeout(a.A), a.A = null);
  }

  function fd(a) {
    a.g = new M(a, a.j, "rpc", a.Y);
    null === a.m && (a.g.H = a.o);
    a.g.O = 0;
    var b = N(a.qa);
    S(b, "RID", "rpc");
    S(b, "SID", a.K);
    S(b, "AID", a.T);
    S(b, "CI", a.F ? "0" : "1");
    !a.F && a.ja && S(b, "TO", a.ja);
    S(b, "TYPE", "xmlhttp");
    $c(a, b);
    a.m && a.o && Pc(b, a.m, a.o);
    a.L && (a.g.I = a.L);
    var c = a.g;
    a = a.ia;
    c.L = 1;
    c.v = Ib(N(b));
    c.m = null;
    c.P = !0;
    Jb(c, a);
  }

  h.Za = function () {
    null != this.C && (this.C = null, Zb(this), $b(this), K(19));
  };

  function Yb(a) {
    null != a.C && (k.clearTimeout(a.C), a.C = null);
  }

  function Ub(a, b) {
    var c = null;

    if (a.g == b) {
      Yb(a);
      Tb(a);
      a.g = null;
      var d = 2;
    } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;else return;

    if (0 != a.G) if (b.o) {
      if (1 == d) {
        c = b.m ? b.m.length : 0;
        b = Date.now() - b.F;
        var e = a.B;
        d = qb();
        F(d, new tb(d, c));
        fc(a);
      } else ec(a);
    } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch (c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e) {
      case 1:
        R(a, 5);
        break;

      case 4:
        R(a, 10);
        break;

      case 3:
        R(a, 6);
        break;

      default:
        R(a, 2);
    }
  }

  function cd(a, b) {
    var c = a.Ta + Math.floor(Math.random() * a.cb);
    a.isActive() || (c *= 2);
    return c * b;
  }

  function R(a, b) {
    a.j.info("Error code " + b);

    if (2 == b) {
      var c = p(a.fb, a),
          d = a.Xa;
      var e = !d;
      d = new T(d || "//www.google.com/images/cleardot.gif");
      k.location && "http" == k.location.protocol || qc(d, "https");
      Ib(d);
      e ? Fc(d.toString(), c) : Gc(d.toString(), c);
    } else K(2);

    a.G = 0;
    a.l && a.l.sa(b);
    ad(a);
    Zc(a);
  }

  h.fb = function (a) {
    a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
  };

  function ad(a) {
    a.G = 0;
    a.ka = [];

    if (a.l) {
      var b = kc(a.h);
      if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
      a.l.ra();
    }
  }

  function cc(a, b, c) {
    var d = c instanceof T ? N(c) : new T(c);
    if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);else {
      var e = k.location;
      d = e.protocol;
      b = b ? b + "." + e.hostname : e.hostname;
      e = +e.port;
      var f = new T(null);
      d && qc(f, d);
      b && (f.g = b);
      e && rc(f, e);
      c && (f.l = c);
      d = f;
    }
    c = a.D;
    b = a.ya;
    c && b && S(d, c, b);
    S(d, "VER", a.la);
    $c(a, d);
    return d;
  }

  function Mb(a, b, c) {
    if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
    b = a.Ca && !a.pa ? new X(new Jc({
      eb: c
    })) : new X(a.pa);
    b.Ha(a.J);
    return b;
  }

  h.isActive = function () {
    return !!this.l && this.l.isActive(this);
  };

  function gd() {}

  h = gd.prototype;

  h.ua = function () {};

  h.ta = function () {};

  h.sa = function () {};

  h.ra = function () {};

  h.isActive = function () {
    return !0;
  };

  h.Na = function () {};

  function hd() {}

  hd.prototype.g = function (a, b) {
    return new Y(a, b);
  };

  function Y(a, b) {
    E.call(this);
    this.g = new Yc(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
      "X-Client-Protocol": "webchannel"
    });
    this.g.o = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
      "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
      "X-WebChannel-Client-Profile": b.va
    });
    this.g.S = a;
    (a = b && b.Sb) && !t(a) && (this.g.m = a);
    this.v = b && b.supportsCrossDomainXhr || !1;
    this.u = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new Z(this);
  }

  r(Y, E);

  Y.prototype.m = function () {
    this.g.l = this.j;
    this.v && (this.g.J = !0);
    this.g.connect(this.l, this.h || void 0);
  };

  Y.prototype.close = function () {
    gc(this.g);
  };

  Y.prototype.o = function (a) {
    var b = this.g;

    if ("string" === typeof a) {
      var c = {};
      c.__data__ = a;
      a = c;
    } else this.u && (c = {}, c.__data__ = hb(a), a = c);

    b.i.push(new hc(b.Ya++, a));
    3 == b.G && fc(b);
  };

  Y.prototype.N = function () {
    this.g.l = null;
    delete this.j;
    gc(this.g);
    delete this.g;
    Y.aa.N.call(this);
  };

  function id(a) {
    nb.call(this);
    a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
    var b = a.__sm__;

    if (b) {
      a: {
        for (var c in b) {
          a = c;
          break a;
        }

        a = void 0;
      }

      if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
      this.data = b;
    } else this.data = a;
  }

  r(id, nb);

  function jd() {
    ob.call(this);
    this.status = 1;
  }

  r(jd, ob);

  function Z(a) {
    this.g = a;
  }

  r(Z, gd);

  Z.prototype.ua = function () {
    F(this.g, "a");
  };

  Z.prototype.ta = function (a) {
    F(this.g, new id(a));
  };

  Z.prototype.sa = function (a) {
    F(this.g, new jd());
  };

  Z.prototype.ra = function () {
    F(this.g, "b");
  };

  hd.prototype.createWebChannel = hd.prototype.g;
  Y.prototype.send = Y.prototype.o;
  Y.prototype.open = Y.prototype.m;
  Y.prototype.close = Y.prototype.close;

  createWebChannelTransport = function () {
    return new hd();
  };

  getStatEventTarget = function () {
    return qb();
  };

  Event = I;
  Stat = {
    mb: 0,
    pb: 1,
    qb: 2,
    Jb: 3,
    Ob: 4,
    Lb: 5,
    Mb: 6,
    Kb: 7,
    Ib: 8,
    Nb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Gb: 12,
    Cb: 13,
    Db: 14,
    Bb: 15,
    Eb: 16,
    Fb: 17,
    ib: 18,
    hb: 19,
    jb: 20
  };
  Ab.NO_ERROR = 0;
  Ab.TIMEOUT = 8;
  Ab.HTTP_ERROR = 6;
  ErrorCode = Ab;
  Bb.COMPLETE = "complete";
  EventType = Bb;
  mb.EventType = H;
  H.OPEN = "a";
  H.CLOSE = "b";
  H.ERROR = "c";
  H.MESSAGE = "d";
  E.prototype.listen = E.prototype.K;
  WebChannel = mb;
  FetchXmlHttpFactory = Jc;
  X.prototype.listenOnce = X.prototype.L;
  X.prototype.getLastError = X.prototype.Ka;
  X.prototype.getLastErrorCode = X.prototype.Ba;
  X.prototype.getStatus = X.prototype.Z;
  X.prototype.getResponseJson = X.prototype.Oa;
  X.prototype.getResponseText = X.prototype.oa;
  X.prototype.send = X.prototype.ea;
  X.prototype.setWithCredentials = X.prototype.Ha;
  XhrIo = X;
}).apply(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

function _createForOfIteratorHelper(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return {s:F,n:function n(){if(i>=o.length)return {done:true};return {done:false,value:o[i++]};},e:function e(_e140){throw _e140;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return {s:function s(){it=it.call(o);},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e141){didErr=true;err=_e141;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else {result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var S="@firebase/firestore";/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */var User=/*#__PURE__*/function(){function User(e){_classCallCheck(this,User);this.uid=e;}_createClass(User,[{key:"isAuthenticated",value:function isAuthenticated(){return null!=this.uid;}/**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */},{key:"toKey",value:function toKey(){return this.isAuthenticated()?"uid:"+this.uid:"anonymous-user";}},{key:"isEqual",value:function isEqual(e){return e.uid===this.uid;}}]);return User;}();/** A user with a null UID. */User.UNAUTHENTICATED=new User(null),// TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS=new User("google-credentials-uid"),User.FIRST_PARTY=new User("first-party-uid"),User.MOCK_USER=new User("mock-user");/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var b="10.12.1";/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var D=new Logger$1("@firebase/firestore");// Helper methods are needed because variables can't be exported as read/write
function __PRIVATE_getLogLevel(){return D.logLevel;}function __PRIVATE_logDebug(e){if(D.logLevel<=LogLevel.DEBUG){for(var _len=arguments.length,t=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){t[_key-1]=arguments[_key];}var n=t.map(__PRIVATE_argToString);D.debug.apply(D,["Firestore (".concat(b,"): ").concat(e)].concat(_toConsumableArray(n)));}}function __PRIVATE_logError(e){if(D.logLevel<=LogLevel.ERROR){for(var _len2=arguments.length,t=new Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){t[_key2-1]=arguments[_key2];}var n=t.map(__PRIVATE_argToString);D.error.apply(D,["Firestore (".concat(b,"): ").concat(e)].concat(_toConsumableArray(n)));}}/**
 * @internal
 */function __PRIVATE_logWarn(e){if(D.logLevel<=LogLevel.WARN){for(var _len3=arguments.length,t=new Array(_len3>1?_len3-1:0),_key3=1;_key3<_len3;_key3++){t[_key3-1]=arguments[_key3];}var n=t.map(__PRIVATE_argToString);D.warn.apply(D,["Firestore (".concat(b,"): ").concat(e)].concat(_toConsumableArray(n)));}}/**
 * Converts an additional log parameter to a string representation.
 */function __PRIVATE_argToString(e){if("string"==typeof e)return e;try{/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */return function __PRIVATE_formatJSON(e){return JSON.stringify(e);}(e);}catch(t){// Converting to JSON failed, just log the object directly
return e;}}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */function fail(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"Unexpected state";// Log the failure in addition to throw an exception, just in case the
// exception is swallowed.
var t="FIRESTORE (".concat(b,") INTERNAL ASSERTION FAILED: ")+e;// NOTE: We don't use FirestoreError here because these are internal failures
// that cannot be handled by the user. (Also it would create a circular
// dependency between the error and assert modules which doesn't work.)
throw __PRIVATE_logError(t),new Error(t);}/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */function __PRIVATE_hardAssert(e,t){e||fail();}/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */function __PRIVATE_debugCast(e,// eslint-disable-next-line @typescript-eslint/no-explicit-any
t){return e;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var C={// Causes are copied from:
// https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
/** Not an error; returned on success. */OK:"ok",/** The operation was cancelled (typically by the caller). */CANCELLED:"cancelled",/** Unknown error or an error from a different error domain. */UNKNOWN:"unknown",/**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */INVALID_ARGUMENT:"invalid-argument",/**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */DEADLINE_EXCEEDED:"deadline-exceeded",/** Some requested entity (e.g., file or directory) was not found. */NOT_FOUND:"not-found",/**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ALREADY_EXISTS:"already-exists",/**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */PERMISSION_DENIED:"permission-denied",/**
     * The request does not have valid authentication credentials for the
     * operation.
     */UNAUTHENTICATED:"unauthenticated",/**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */RESOURCE_EXHAUSTED:"resource-exhausted",/**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */FAILED_PRECONDITION:"failed-precondition",/**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ABORTED:"aborted",/**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */OUT_OF_RANGE:"out-of-range",/** Operation is not implemented or not supported/enabled in this service. */UNIMPLEMENTED:"unimplemented",/**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */INTERNAL:"internal",/**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */UNAVAILABLE:"unavailable",/** Unrecoverable data loss or corruption. */DATA_LOSS:"data-loss"};/** An error returned by a Firestore operation. */var FirestoreError=/*#__PURE__*/function(_FirebaseError){_inherits(FirestoreError,_FirebaseError);var _super=_createSuper(FirestoreError);/** @hideconstructor */function FirestoreError(/**
     * The backend error code associated with this error.
     */e,/**
     * A custom error description.
     */t){var _this;_classCallCheck(this,FirestoreError);_this=_super.call(this,e,t),_this.code=e,_this.message=t,// HACK: We write a toString property directly because Error is not a real
// class and so inheritance does not work correctly. We could alternatively
// do the same "back-door inheritance" trick that FirebaseError does.
_this.toString=function(){return "".concat(_this.name,": [code=").concat(_this.code,"]: ").concat(_this.message);};return _this;}return _createClass(FirestoreError);}(FirebaseError);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_Deferred=/*#__PURE__*/_createClass(function __PRIVATE_Deferred(){var _this2=this;_classCallCheck(this,__PRIVATE_Deferred);this.promise=new Promise(function(e,t){_this2.resolve=e,_this2.reject=t;});});/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_OAuthToken=/*#__PURE__*/_createClass(function __PRIVATE_OAuthToken(e,t){_classCallCheck(this,__PRIVATE_OAuthToken);this.user=t,this.type="OAuth",this.headers=new Map(),this.headers.set("Authorization","Bearer ".concat(e));});/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */var __PRIVATE_EmptyAuthCredentialsProvider=/*#__PURE__*/function(){function __PRIVATE_EmptyAuthCredentialsProvider(){_classCallCheck(this,__PRIVATE_EmptyAuthCredentialsProvider);}_createClass(__PRIVATE_EmptyAuthCredentialsProvider,[{key:"getToken",value:function getToken(){return Promise.resolve(null);}},{key:"invalidateToken",value:function invalidateToken(){}},{key:"start",value:function start(e,t){// Fire with initial user.
e.enqueueRetryable(function(){return t(User.UNAUTHENTICATED);});}},{key:"shutdown",value:function shutdown(){}}]);return __PRIVATE_EmptyAuthCredentialsProvider;}();var __PRIVATE_FirebaseAuthCredentialsProvider=/*#__PURE__*/function(){function __PRIVATE_FirebaseAuthCredentialsProvider(e){_classCallCheck(this,__PRIVATE_FirebaseAuthCredentialsProvider);this.t=e,/** Tracks the current User. */this.currentUser=User.UNAUTHENTICATED,/**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */this.i=0,this.forceRefresh=!1,this.auth=null;}_createClass(__PRIVATE_FirebaseAuthCredentialsProvider,[{key:"start",value:function start(e,t){var _this4=this;var n=this.i;// A change listener that prevents double-firing for the same token change.
var __PRIVATE_guardedChangeListener=function __PRIVATE_guardedChangeListener(e){return _this4.i!==n?(n=_this4.i,t(e)):Promise.resolve();};// A promise that can be waited on to block on the next token change.
// This promise is re-created after each change.
var r=new __PRIVATE_Deferred();this.o=function(){_this4.i++,_this4.currentUser=_this4.u(),r.resolve(),r=new __PRIVATE_Deferred(),e.enqueueRetryable(function(){return __PRIVATE_guardedChangeListener(_this4.currentUser);});};var __PRIVATE_awaitNextToken=function __PRIVATE_awaitNextToken(){var t=r;e.enqueueRetryable(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee(){return regenerator.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return t.promise;case 2:_context.next=4;return __PRIVATE_guardedChangeListener(_this4.currentUser);case 4:case"end":return _context.stop();}}},_callee);})));},__PRIVATE_registerAuth=function __PRIVATE_registerAuth(e){__PRIVATE_logDebug("FirebaseAuthCredentialsProvider","Auth detected"),_this4.auth=e,_this4.auth.addAuthTokenListener(_this4.o),__PRIVATE_awaitNextToken();};this.t.onInit(function(e){return __PRIVATE_registerAuth(e);}),// Our users can initialize Auth right after Firestore, so we give it
// a chance to register itself with the component framework before we
// determine whether to start up in unauthenticated mode.
setTimeout(function(){if(!_this4.auth){var _e2=_this4.t.getImmediate({optional:!0});_e2?__PRIVATE_registerAuth(_e2):(// If auth is still not available, proceed with `null` user
__PRIVATE_logDebug("FirebaseAuthCredentialsProvider","Auth not yet detected"),r.resolve(),r=new __PRIVATE_Deferred());}},0),__PRIVATE_awaitNextToken();}},{key:"getToken",value:function getToken(){var _this5=this;// Take note of the current value of the tokenCounter so that this method
// can fail (with an ABORTED error) if there is a token change while the
// request is outstanding.
var e=this.i,t=this.forceRefresh;return this.forceRefresh=!1,this.auth?this.auth.getToken(t).then(function(t){return(// Cancel the request since the token changed while the request was
// outstanding so the response is potentially for a previous user (which
// user, we can't be sure).
_this5.i!==e?(__PRIVATE_logDebug("FirebaseAuthCredentialsProvider","getToken aborted due to token change."),_this5.getToken()):t?(__PRIVATE_hardAssert("string"==typeof t.accessToken),new __PRIVATE_OAuthToken(t.accessToken,_this5.currentUser)):null);}):Promise.resolve(null);}},{key:"invalidateToken",value:function invalidateToken(){this.forceRefresh=!0;}},{key:"shutdown",value:function shutdown(){this.auth&&this.auth.removeAuthTokenListener(this.o);}// Auth.getUid() can return null even with a user logged in. It is because
// getUid() is synchronous, but the auth code populating Uid is asynchronous.
// This method should only be called in the AuthTokenListener callback
// to guarantee to get the actual user.
},{key:"u",value:function u(){var e=this.auth&&this.auth.getUid();return __PRIVATE_hardAssert(null===e||"string"==typeof e),new User(e);}}]);return __PRIVATE_FirebaseAuthCredentialsProvider;}();/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */var __PRIVATE_FirstPartyToken=/*#__PURE__*/function(){function __PRIVATE_FirstPartyToken(e,t,n){_classCallCheck(this,__PRIVATE_FirstPartyToken);this.l=e,this.h=t,this.P=n,this.type="FirstParty",this.user=User.FIRST_PARTY,this.I=new Map();}/**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */_createClass(__PRIVATE_FirstPartyToken,[{key:"T",value:function T(){return this.P?this.P():null;}},{key:"headers",get:function get(){this.I.set("X-Goog-AuthUser",this.l);// Use array notation to prevent minification
var e=this.T();return e&&this.I.set("Authorization",e),this.h&&this.I.set("X-Goog-Iam-Authorization-Token",this.h),this.I;}}]);return __PRIVATE_FirstPartyToken;}();/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */var __PRIVATE_FirstPartyAuthCredentialsProvider=/*#__PURE__*/function(){function __PRIVATE_FirstPartyAuthCredentialsProvider(e,t,n){_classCallCheck(this,__PRIVATE_FirstPartyAuthCredentialsProvider);this.l=e,this.h=t,this.P=n;}_createClass(__PRIVATE_FirstPartyAuthCredentialsProvider,[{key:"getToken",value:function getToken(){return Promise.resolve(new __PRIVATE_FirstPartyToken(this.l,this.h,this.P));}},{key:"start",value:function start(e,t){// Fire with initial uid.
e.enqueueRetryable(function(){return t(User.FIRST_PARTY);});}},{key:"shutdown",value:function shutdown(){}},{key:"invalidateToken",value:function invalidateToken(){}}]);return __PRIVATE_FirstPartyAuthCredentialsProvider;}();var AppCheckToken=/*#__PURE__*/_createClass(function AppCheckToken(e){_classCallCheck(this,AppCheckToken);this.value=e,this.type="AppCheck",this.headers=new Map(),e&&e.length>0&&this.headers.set("x-firebase-appcheck",this.value);});var __PRIVATE_FirebaseAppCheckTokenProvider=/*#__PURE__*/function(){function __PRIVATE_FirebaseAppCheckTokenProvider(e){_classCallCheck(this,__PRIVATE_FirebaseAppCheckTokenProvider);this.A=e,this.forceRefresh=!1,this.appCheck=null,this.R=null;}_createClass(__PRIVATE_FirebaseAppCheckTokenProvider,[{key:"start",value:function start(e,t){var _this6=this;var onTokenChanged=function onTokenChanged(e){null!=e.error&&__PRIVATE_logDebug("FirebaseAppCheckTokenProvider","Error getting App Check token; using placeholder token instead. Error: ".concat(e.error.message));var n=e.token!==_this6.R;return _this6.R=e.token,__PRIVATE_logDebug("FirebaseAppCheckTokenProvider","Received ".concat(n?"new":"existing"," token.")),n?t(e.token):Promise.resolve();};this.o=function(t){e.enqueueRetryable(function(){return onTokenChanged(t);});};var __PRIVATE_registerAppCheck=function __PRIVATE_registerAppCheck(e){__PRIVATE_logDebug("FirebaseAppCheckTokenProvider","AppCheck detected"),_this6.appCheck=e,_this6.appCheck.addTokenListener(_this6.o);};this.A.onInit(function(e){return __PRIVATE_registerAppCheck(e);}),// Our users can initialize AppCheck after Firestore, so we give it
// a chance to register itself with the component framework.
setTimeout(function(){if(!_this6.appCheck){var _e3=_this6.A.getImmediate({optional:!0});_e3?__PRIVATE_registerAppCheck(_e3):// If AppCheck is still not available, proceed without it.
__PRIVATE_logDebug("FirebaseAppCheckTokenProvider","AppCheck not yet detected");}},0);}},{key:"getToken",value:function getToken(){var _this7=this;var e=this.forceRefresh;return this.forceRefresh=!1,this.appCheck?this.appCheck.getToken(e).then(function(e){return e?(__PRIVATE_hardAssert("string"==typeof e.token),_this7.R=e.token,new AppCheckToken(e.token)):null;}):Promise.resolve(null);}},{key:"invalidateToken",value:function invalidateToken(){this.forceRefresh=!0;}},{key:"shutdown",value:function shutdown(){this.appCheck&&this.appCheck.removeTokenListener(this.o);}}]);return __PRIVATE_FirebaseAppCheckTokenProvider;}();/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */function __PRIVATE_randomBytes(e){// Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
var t=// eslint-disable-next-line @typescript-eslint/no-explicit-any
"undefined"!=typeof self&&(self.crypto||self.msCrypto),n=new Uint8Array(e);if(t&&"function"==typeof t.getRandomValues)t.getRandomValues(n);else// Falls back to Math.random
for(var _t=0;_t<e;_t++){n[_t]=Math.floor(256*Math.random());}return n;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */var __PRIVATE_AutoId=/*#__PURE__*/function(){function __PRIVATE_AutoId(){_classCallCheck(this,__PRIVATE_AutoId);}_createClass(__PRIVATE_AutoId,null,[{key:"newId",value:function newId(){// Alphanumeric characters
var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",t=Math.floor(256/e.length)*e.length;// The largest byte value that is a multiple of `char.length`.
var n="";for(;n.length<20;){var r=__PRIVATE_randomBytes(40);for(var i=0;i<r.length;++i){// Only accept values that are [0, maxMultiple), this ensures they can
// be evenly mapped to indices of `chars` via a modulo operation.
n.length<20&&r[i]<t&&(n+=e.charAt(r[i]%e.length));}}return n;}}]);return __PRIVATE_AutoId;}();function __PRIVATE_primitiveComparator(e,t){return e<t?-1:e>t?1:0;}/** Helper to compare arrays using isEqual(). */function __PRIVATE_arrayEquals(e,t,n){return e.length===t.length&&e.every(function(e,r){return n(e,t[r]);});}/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */var Timestamp=/*#__PURE__*/function(){/**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */function Timestamp(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */e,/**
     * The fractions of a second at nanosecond resolution.*
     */t){_classCallCheck(this,Timestamp);if(this.seconds=e,this.nanoseconds=t,t<0)throw new FirestoreError(C.INVALID_ARGUMENT,"Timestamp nanoseconds out of range: "+t);if(t>=1e9)throw new FirestoreError(C.INVALID_ARGUMENT,"Timestamp nanoseconds out of range: "+t);if(e<-62135596800)throw new FirestoreError(C.INVALID_ARGUMENT,"Timestamp seconds out of range: "+e);// This will break in the year 10,000.
if(e>=253402300800)throw new FirestoreError(C.INVALID_ARGUMENT,"Timestamp seconds out of range: "+e);}/**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */_createClass(Timestamp,[{key:"toDate",value:/**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */function toDate(){return new Date(this.toMillis());}/**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */},{key:"toMillis",value:function toMillis(){return 1e3*this.seconds+this.nanoseconds/1e6;}},{key:"_compareTo",value:function _compareTo(e){return this.seconds===e.seconds?__PRIVATE_primitiveComparator(this.nanoseconds,e.nanoseconds):__PRIVATE_primitiveComparator(this.seconds,e.seconds);}/**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */},{key:"isEqual",value:function isEqual(e){return e.seconds===this.seconds&&e.nanoseconds===this.nanoseconds;}/** Returns a textual representation of this `Timestamp`. */},{key:"toString",value:function toString(){return "Timestamp(seconds="+this.seconds+", nanoseconds="+this.nanoseconds+")";}/** Returns a JSON-serializable representation of this `Timestamp`. */},{key:"toJSON",value:function toJSON(){return {seconds:this.seconds,nanoseconds:this.nanoseconds};}/**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */},{key:"valueOf",value:function valueOf(){// This method returns a string of the form <seconds>.<nanoseconds> where
// <seconds> is translated to have a non-negative value and both <seconds>
// and <nanoseconds> are left-padded with zeroes to be a consistent length.
// Strings with this format then have a lexiographical ordering that matches
// the expected ordering. The <seconds> translation is done to avoid having
// a leading negative sign (i.e. a leading '-' character) in its string
// representation, which would affect its lexiographical ordering.
var e=this.seconds- -62135596800;// Note: Up to 12 decimal digits are required to represent all valid
// 'seconds' values.
return String(e).padStart(12,"0")+"."+String(this.nanoseconds).padStart(9,"0");}}],[{key:"now",value:function now(){return Timestamp.fromMillis(Date.now());}/**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */},{key:"fromDate",value:function fromDate(e){return Timestamp.fromMillis(e.getTime());}/**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */},{key:"fromMillis",value:function fromMillis(e){var t=Math.floor(e/1e3),n=Math.floor(1e6*(e-1e3*t));return new Timestamp(t,n);}}]);return Timestamp;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */var SnapshotVersion=/*#__PURE__*/function(){function SnapshotVersion(e){_classCallCheck(this,SnapshotVersion);this.timestamp=e;}_createClass(SnapshotVersion,[{key:"compareTo",value:function compareTo(e){return this.timestamp._compareTo(e.timestamp);}},{key:"isEqual",value:function isEqual(e){return this.timestamp.isEqual(e.timestamp);}/** Returns a number representation of the version for use in spec tests. */},{key:"toMicroseconds",value:function toMicroseconds(){// Convert to microseconds.
return 1e6*this.timestamp.seconds+this.timestamp.nanoseconds/1e3;}},{key:"toString",value:function toString(){return "SnapshotVersion("+this.timestamp.toString()+")";}},{key:"toTimestamp",value:function toTimestamp(){return this.timestamp;}}],[{key:"fromTimestamp",value:function fromTimestamp(e){return new SnapshotVersion(e);}},{key:"min",value:function min(){return new SnapshotVersion(new Timestamp(0,0));}},{key:"max",value:function max(){return new SnapshotVersion(new Timestamp(253402300799,999999999));}}]);return SnapshotVersion;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */var BasePath=/*#__PURE__*/function(){function BasePath(e,t,n){_classCallCheck(this,BasePath);void 0===t?t=0:t>e.length&&fail(),void 0===n?n=e.length-t:n>e.length-t&&fail(),this.segments=e,this.offset=t,this.len=n;}_createClass(BasePath,[{key:"length",get:function get(){return this.len;}},{key:"isEqual",value:function isEqual(e){return 0===BasePath.comparator(this,e);}},{key:"child",value:function child(e){var t=this.segments.slice(this.offset,this.limit());return e instanceof BasePath?e.forEach(function(e){t.push(e);}):t.push(e),this.construct(t);}/** The index of one past the last segment of the path. */},{key:"limit",value:function limit(){return this.offset+this.length;}},{key:"popFirst",value:function popFirst(e){return e=void 0===e?1:e,this.construct(this.segments,this.offset+e,this.length-e);}},{key:"popLast",value:function popLast(){return this.construct(this.segments,this.offset,this.length-1);}},{key:"firstSegment",value:function firstSegment(){return this.segments[this.offset];}},{key:"lastSegment",value:function lastSegment(){return this.get(this.length-1);}},{key:"get",value:function get(e){return this.segments[this.offset+e];}},{key:"isEmpty",value:function isEmpty(){return 0===this.length;}},{key:"isPrefixOf",value:function isPrefixOf(e){if(e.length<this.length)return !1;for(var t=0;t<this.length;t++){if(this.get(t)!==e.get(t))return !1;}return !0;}},{key:"isImmediateParentOf",value:function isImmediateParentOf(e){if(this.length+1!==e.length)return !1;for(var t=0;t<this.length;t++){if(this.get(t)!==e.get(t))return !1;}return !0;}},{key:"forEach",value:function forEach(e){for(var t=this.offset,n=this.limit();t<n;t++){e(this.segments[t]);}}},{key:"toArray",value:function toArray(){return this.segments.slice(this.offset,this.limit());}}],[{key:"comparator",value:function comparator(e,t){var n=Math.min(e.length,t.length);for(var r=0;r<n;r++){var _n=e.get(r),i=t.get(r);if(_n<i)return -1;if(_n>i)return 1;}return e.length<t.length?-1:e.length>t.length?1:0;}}]);return BasePath;}();/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */var ResourcePath=/*#__PURE__*/function(_BasePath){_inherits(ResourcePath,_BasePath);var _super2=_createSuper(ResourcePath);function ResourcePath(){_classCallCheck(this,ResourcePath);return _super2.apply(this,arguments);}_createClass(ResourcePath,[{key:"construct",value:function construct(e,t,n){return new ResourcePath(e,t,n);}},{key:"canonicalString",value:function canonicalString(){// NOTE: The client is ignorant of any path segments containing escape
// sequences (e.g. __id123__) and just passes them through raw (they exist
// for legacy reasons and should not be used frequently).
return this.toArray().join("/");}},{key:"toString",value:function toString(){return this.canonicalString();}/**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */},{key:"toUriEncodedString",value:function toUriEncodedString(){return this.toArray().map(encodeURIComponent).join("/");}/**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */}],[{key:"fromString",value:function fromString(){// NOTE: The client is ignorant of any path segments containing escape
// sequences (e.g. __id123__) and just passes them through raw (they exist
// for legacy reasons and should not be used frequently).
var t=[];for(var _len4=arguments.length,e=new Array(_len4),_key4=0;_key4<_len4;_key4++){e[_key4]=arguments[_key4];}for(var _i=0,_e4=e;_i<_e4.length;_i++){var n=_e4[_i];if(n.indexOf("//")>=0)throw new FirestoreError(C.INVALID_ARGUMENT,"Invalid segment (".concat(n,"). Paths must not contain // in them."));// Strip leading and traling slashed.
t.push.apply(t,_toConsumableArray(n.split("/").filter(function(e){return e.length>0;})));}return new ResourcePath(t);}},{key:"emptyPath",value:function emptyPath(){return new ResourcePath([]);}}]);return ResourcePath;}(BasePath);var v=/^[_a-zA-Z][_a-zA-Z0-9]*$/;/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */var FieldPath$1=/*#__PURE__*/function(_BasePath2){_inherits(FieldPath$1,_BasePath2);var _super3=_createSuper(FieldPath$1);function FieldPath$1(){_classCallCheck(this,FieldPath$1);return _super3.apply(this,arguments);}_createClass(FieldPath$1,[{key:"construct",value:function construct(e,t,n){return new FieldPath$1(e,t,n);}/**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */},{key:"canonicalString",value:function canonicalString(){return this.toArray().map(function(e){return e=e.replace(/\\/g,"\\\\").replace(/`/g,"\\`"),FieldPath$1.isValidIdentifier(e)||(e="`"+e+"`"),e;}).join(".");}},{key:"toString",value:function toString(){return this.canonicalString();}/**
     * Returns true if this field references the key of a document.
     */},{key:"isKeyField",value:function isKeyField(){return 1===this.length&&"__name__"===this.get(0);}/**
     * The field designating the key of a document.
     */}],[{key:"isValidIdentifier",value:function isValidIdentifier(e){return v.test(e);}},{key:"keyField",value:function keyField(){return new FieldPath$1(["__name__"]);}/**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */},{key:"fromServerFormat",value:function fromServerFormat(e){var t=[];var n="",r=0;var __PRIVATE_addCurrentSegment=function __PRIVATE_addCurrentSegment(){if(0===n.length)throw new FirestoreError(C.INVALID_ARGUMENT,"Invalid field path (".concat(e,"). Paths must not be empty, begin with '.', end with '.', or contain '..'"));t.push(n),n="";};var i=!1;for(;r<e.length;){var _t2=e[r];if("\\"===_t2){if(r+1===e.length)throw new FirestoreError(C.INVALID_ARGUMENT,"Path has trailing escape character: "+e);var _t3=e[r+1];if("\\"!==_t3&&"."!==_t3&&"`"!==_t3)throw new FirestoreError(C.INVALID_ARGUMENT,"Path has invalid escape sequence: "+e);n+=_t3,r+=2;}else "`"===_t2?(i=!i,r++):"."!==_t2||i?(n+=_t2,r++):(__PRIVATE_addCurrentSegment(),r++);}if(__PRIVATE_addCurrentSegment(),i)throw new FirestoreError(C.INVALID_ARGUMENT,"Unterminated ` in path: "+e);return new FieldPath$1(t);}},{key:"emptyPath",value:function emptyPath(){return new FieldPath$1([]);}}]);return FieldPath$1;}(BasePath);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */var DocumentKey=/*#__PURE__*/function(){function DocumentKey(e){_classCallCheck(this,DocumentKey);this.path=e;}_createClass(DocumentKey,[{key:"collectionGroup",get:function get(){return this.path.popLast().lastSegment();}/** Returns true if the document is in the specified collectionId. */},{key:"hasCollectionId",value:function hasCollectionId(e){return this.path.length>=2&&this.path.get(this.path.length-2)===e;}/** Returns the collection group (i.e. the name of the parent collection) for this key. */},{key:"getCollectionGroup",value:function getCollectionGroup(){return this.path.get(this.path.length-2);}/** Returns the fully qualified path to the parent collection. */},{key:"getCollectionPath",value:function getCollectionPath(){return this.path.popLast();}},{key:"isEqual",value:function isEqual(e){return null!==e&&0===ResourcePath.comparator(this.path,e.path);}},{key:"toString",value:function toString(){return this.path.toString();}}],[{key:"fromPath",value:function fromPath(e){return new DocumentKey(ResourcePath.fromString(e));}},{key:"fromName",value:function fromName(e){return new DocumentKey(ResourcePath.fromString(e).popFirst(5));}},{key:"empty",value:function empty(){return new DocumentKey(ResourcePath.emptyPath());}},{key:"comparator",value:function comparator(e,t){return ResourcePath.comparator(e.path,t.path);}},{key:"isDocumentKey",value:function isDocumentKey(e){return e.length%2==0;}/**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */},{key:"fromSegments",value:function fromSegments(e){return new DocumentKey(new ResourcePath(e.slice()));}}]);return DocumentKey;}();/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */var FieldIndex=/*#__PURE__*/_createClass(function FieldIndex(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */e,/** The collection ID this index applies to. */t,/** The field segments for this index. */n,/** Shows how up-to-date the index is for the current user. */r){_classCallCheck(this,FieldIndex);this.indexId=e,this.collectionGroup=t,this.fields=n,this.indexState=r;});/** Returns a debug representation of the field index */FieldIndex.UNKNOWN_ID=-1;/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e,t){// We want to create an offset that matches all documents with a read time
// greater than the provided read time. To do so, we technically need to
// create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
// Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
// `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
// all valid document IDs.
var n=e.toTimestamp().seconds,r=e.toTimestamp().nanoseconds+1,i=SnapshotVersion.fromTimestamp(1e9===r?new Timestamp(n+1,0):new Timestamp(n,r));return new IndexOffset(i,DocumentKey.empty(),t);}/** Creates a new offset based on the provided document. */function __PRIVATE_newIndexOffsetFromDocument(e){return new IndexOffset(e.readTime,e.key,-1);}/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */var IndexOffset=/*#__PURE__*/function(){function IndexOffset(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */e,/**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */t,/*
     * The largest mutation batch id that's been processed by Firestore.
     */n){_classCallCheck(this,IndexOffset);this.readTime=e,this.documentKey=t,this.largestBatchId=n;}/** Returns an offset that sorts before all regular offsets. */_createClass(IndexOffset,null,[{key:"min",value:function min(){return new IndexOffset(SnapshotVersion.min(),DocumentKey.empty(),-1);}/** Returns an offset that sorts after all regular offsets. */},{key:"max",value:function max(){return new IndexOffset(SnapshotVersion.max(),DocumentKey.empty(),-1);}}]);return IndexOffset;}();function __PRIVATE_indexOffsetComparator(e,t){var n=e.readTime.compareTo(t.readTime);return 0!==n?n:(n=DocumentKey.comparator(e.documentKey,t.documentKey),0!==n?n:__PRIVATE_primitiveComparator(e.largestBatchId,t.largestBatchId));}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var F="The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */var PersistenceTransaction=/*#__PURE__*/function(){function PersistenceTransaction(){_classCallCheck(this,PersistenceTransaction);this.onCommittedListeners=[];}_createClass(PersistenceTransaction,[{key:"addOnCommittedListener",value:function addOnCommittedListener(e){this.onCommittedListeners.push(e);}},{key:"raiseOnCommittedEvent",value:function raiseOnCommittedEvent(){this.onCommittedListeners.forEach(function(e){return e();});}}]);return PersistenceTransaction;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */function __PRIVATE_ignoreIfPrimaryLeaseLoss(_x){return _PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this,arguments);}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */function _PRIVATE_ignoreIfPrimaryLeaseLoss(){_PRIVATE_ignoreIfPrimaryLeaseLoss=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee78(e){return regenerator.wrap(function _callee78$(_context78){while(1){switch(_context78.prev=_context78.next){case 0:if(!(e.code!==C.FAILED_PRECONDITION||e.message!==F)){_context78.next=2;break;}throw e;case 2:__PRIVATE_logDebug("LocalStore","Unexpectedly lost primary lease");case 3:case"end":return _context78.stop();}}},_callee78);}));return _PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this,arguments);}var PersistencePromise=/*#__PURE__*/function(){function PersistencePromise(e){var _this8=this;_classCallCheck(this,PersistencePromise);// NOTE: next/catchCallback will always point to our own wrapper functions,
// not the user's raw next() or catch() callbacks.
this.nextCallback=null,this.catchCallback=null,// When the operation resolves, we'll set result or error and mark isDone.
this.result=void 0,this.error=void 0,this.isDone=!1,// Set to true when .then() or .catch() are called and prevents additional
// chaining.
this.callbackAttached=!1,e(function(e){_this8.isDone=!0,_this8.result=e,_this8.nextCallback&&// value should be defined unless T is Void, but we can't express
// that in the type system.
_this8.nextCallback(e);},function(e){_this8.isDone=!0,_this8.error=e,_this8.catchCallback&&_this8.catchCallback(e);});}_createClass(PersistencePromise,[{key:"catch",value:function _catch(e){return this.next(void 0,e);}},{key:"next",value:function next(e,t){var _this9=this;return this.callbackAttached&&fail(),this.callbackAttached=!0,this.isDone?this.error?this.wrapFailure(t,this.error):this.wrapSuccess(e,this.result):new PersistencePromise(function(n,r){_this9.nextCallback=function(t){_this9.wrapSuccess(e,t).next(n,r);},_this9.catchCallback=function(e){_this9.wrapFailure(t,e).next(n,r);};});}},{key:"toPromise",value:function toPromise(){var _this10=this;return new Promise(function(e,t){_this10.next(e,t);});}},{key:"wrapUserFunction",value:function wrapUserFunction(e){try{var t=e();return t instanceof PersistencePromise?t:PersistencePromise.resolve(t);}catch(e){return PersistencePromise.reject(e);}}},{key:"wrapSuccess",value:function wrapSuccess(e,t){return e?this.wrapUserFunction(function(){return e(t);}):PersistencePromise.resolve(t);}},{key:"wrapFailure",value:function wrapFailure(e,t){return e?this.wrapUserFunction(function(){return e(t);}):PersistencePromise.reject(t);}}],[{key:"resolve",value:function resolve(e){return new PersistencePromise(function(t,n){t(e);});}},{key:"reject",value:function reject(e){return new PersistencePromise(function(t,n){n(e);});}},{key:"waitFor",value:function waitFor(// Accept all Promise types in waitFor().
// eslint-disable-next-line @typescript-eslint/no-explicit-any
e){return new PersistencePromise(function(t,n){var r=0,i=0,s=!1;e.forEach(function(e){++r,e.next(function(){++i,s&&i===r&&t();},function(e){return n(e);});}),s=!0,i===r&&t();});}/**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */},{key:"or",value:function or(e){var t=PersistencePromise.resolve(!1);var _iterator=_createForOfIteratorHelper(e),_step;try{var _loop=function _loop(){var n=_step.value;t=t.next(function(e){return e?PersistencePromise.resolve(e):n();});};for(_iterator.s();!(_step=_iterator.n()).done;){_loop();}}catch(err){_iterator.e(err);}finally{_iterator.f();}return t;}},{key:"forEach",value:function forEach(e,t){var _this11=this;var n=[];return e.forEach(function(e,r){n.push(t.call(_this11,e,r));}),this.waitFor(n);}/**
     * Concurrently map all array elements through asynchronous function.
     */},{key:"mapArray",value:function mapArray(e,t){return new PersistencePromise(function(n,r){var i=e.length,s=new Array(i);var o=0;var _loop2=function _loop2(_){var a=_;t(e[a]).next(function(e){s[a]=e,++o,o===i&&n(s);},function(e){return r(e);});};for(var _=0;_<i;_++){_loop2(_);}});}/**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */},{key:"doWhile",value:function doWhile(e,t){return new PersistencePromise(function(n,r){var process=function process(){!0===e()?t().next(function(){process();},r):n();};process();});}}]);return PersistencePromise;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/** Parse User Agent to determine Android version. Returns -1 if not found. */function __PRIVATE_getAndroidVersion(e){var t=e.match(/Android ([\d.]+)/i),n=t?t[1].split(".").slice(0,2).join("."):"-1";return Number(n);}/** Verifies whether `e` is an IndexedDbTransactionError. */function __PRIVATE_isIndexedDbTransactionError(e){// Use name equality, as instanceof checks on errors don't work with errors
// that wrap other errors.
return "IndexedDbTransactionError"===e.name;}/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */var __PRIVATE_ListenSequence=/*#__PURE__*/function(){function __PRIVATE_ListenSequence(e,t){var _this21=this;_classCallCheck(this,__PRIVATE_ListenSequence);this.previousValue=e,t&&(t.sequenceNumberHandler=function(e){return _this21.ie(e);},this.se=function(e){return t.writeSequenceNumber(e);});}_createClass(__PRIVATE_ListenSequence,[{key:"ie",value:function ie(e){return this.previousValue=Math.max(e,this.previousValue),this.previousValue;}},{key:"next",value:function next(){var e=++this.previousValue;return this.se&&this.se(e),e;}}]);return __PRIVATE_ListenSequence;}();__PRIVATE_ListenSequence.oe=-1;/**
 * Returns whether a variable is either undefined or null.
 */function __PRIVATE_isNullOrUndefined(e){return null==e;}/** Returns whether the value represents -0. */function __PRIVATE_isNegativeZero(e){// Detect if the value is -0.0. Based on polyfill from
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
return 0===e&&1/e==-1/0;}/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */function isSafeInteger(e){return "number"==typeof e&&Number.isInteger(e)&&!__PRIVATE_isNegativeZero(e)&&e<=Number.MAX_SAFE_INTEGER&&e>=Number.MIN_SAFE_INTEGER;}/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */var J=["mutationQueues","mutations","documentMutations","remoteDocuments","targets","owner","targetGlobal","targetDocuments"].concat(["clientMetadata"]).concat(["remoteDocumentGlobal"]).concat(["collectionParents"]).concat(["bundles","namedQueries"]);[].concat(_toConsumableArray(J),["documentOverlays"]);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function __PRIVATE_objectSize(e){var t=0;for(var n in e){Object.prototype.hasOwnProperty.call(e,n)&&t++;}return t;}function _forEach(e,t){for(var n in e){Object.prototype.hasOwnProperty.call(e,n)&&t(n,e[n]);}}function _isEmpty(e){for(var t in e){if(Object.prototype.hasOwnProperty.call(e,t))return !1;}return !0;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap=/*#__PURE__*/function(){function SortedMap(e,t){_classCallCheck(this,SortedMap);this.comparator=e,this.root=t||LLRBNode.EMPTY;}// Returns a copy of the map, with the specified key/value added or replaced.
_createClass(SortedMap,[{key:"insert",value:function insert(e,t){return new SortedMap(this.comparator,this.root.insert(e,t,this.comparator).copy(null,null,LLRBNode.BLACK,null,null));}// Returns a copy of the map, with the specified key removed.
},{key:"remove",value:function remove(e){return new SortedMap(this.comparator,this.root.remove(e,this.comparator).copy(null,null,LLRBNode.BLACK,null,null));}// Returns the value of the node with the given key, or null.
},{key:"get",value:function get(e){var t=this.root;for(;!t.isEmpty();){var n=this.comparator(e,t.key);if(0===n)return t.value;n<0?t=t.left:n>0&&(t=t.right);}return null;}// Returns the index of the element in this sorted map, or -1 if it doesn't
// exist.
},{key:"indexOf",value:function indexOf(e){// Number of nodes that were pruned when descending right
var t=0,n=this.root;for(;!n.isEmpty();){var r=this.comparator(e,n.key);if(0===r)return t+n.left.size;r<0?n=n.left:(// Count all nodes left of the node plus the node itself
t+=n.left.size+1,n=n.right);}// Node not found
return -1;}},{key:"isEmpty",value:function isEmpty(){return this.root.isEmpty();}// Returns the total number of nodes in the map.
},{key:"size",get:function get(){return this.root.size;}// Returns the minimum key in the map.
},{key:"minKey",value:function minKey(){return this.root.minKey();}// Returns the maximum key in the map.
},{key:"maxKey",value:function maxKey(){return this.root.maxKey();}// Traverses the map in key order and calls the specified action function
// for each key/value pair. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
},{key:"inorderTraversal",value:function inorderTraversal(e){return this.root.inorderTraversal(e);}},{key:"forEach",value:function forEach(e){this.inorderTraversal(function(t,n){return e(t,n),!1;});}},{key:"toString",value:function toString(){var e=[];return this.inorderTraversal(function(t,n){return e.push("".concat(t,":").concat(n)),!1;}),"{".concat(e.join(", "),"}");}// Traverses the map in reverse key order and calls the specified action
// function for each key/value pair. If action returns true, traversal is
// aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
},{key:"reverseTraversal",value:function reverseTraversal(e){return this.root.reverseTraversal(e);}// Returns an iterator over the SortedMap.
},{key:"getIterator",value:function getIterator(){return new SortedMapIterator(this.root,null,this.comparator,!1);}},{key:"getIteratorFrom",value:function getIteratorFrom(e){return new SortedMapIterator(this.root,e,this.comparator,!1);}},{key:"getReverseIterator",value:function getReverseIterator(){return new SortedMapIterator(this.root,null,this.comparator,!0);}},{key:"getReverseIteratorFrom",value:function getReverseIteratorFrom(e){return new SortedMapIterator(this.root,e,this.comparator,!0);}}]);return SortedMap;}();// end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator=/*#__PURE__*/function(){function SortedMapIterator(e,t,n,r){_classCallCheck(this,SortedMapIterator);this.isReverse=r,this.nodeStack=[];var i=1;for(;!e.isEmpty();){if(i=t?n(e.key,t):1,// flip the comparison if we're going in reverse
t&&r&&(i*=-1),i<0)// This node is less than our start key. ignore it
e=this.isReverse?e.left:e.right;else {if(0===i){// This node is exactly equal to our start key. Push it on the stack,
// but stop iterating;
this.nodeStack.push(e);break;}// This node is greater than our start key, add it to the stack and move
// to the next one
this.nodeStack.push(e),e=this.isReverse?e.right:e.left;}}}_createClass(SortedMapIterator,[{key:"getNext",value:function getNext(){var e=this.nodeStack.pop();var t={key:e.key,value:e.value};if(this.isReverse)for(e=e.left;!e.isEmpty();){this.nodeStack.push(e),e=e.right;}else for(e=e.right;!e.isEmpty();){this.nodeStack.push(e),e=e.left;}return t;}},{key:"hasNext",value:function hasNext(){return this.nodeStack.length>0;}},{key:"peek",value:function peek(){if(0===this.nodeStack.length)return null;var e=this.nodeStack[this.nodeStack.length-1];return {key:e.key,value:e.value};}}]);return SortedMapIterator;}();// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode=/*#__PURE__*/function(){function LLRBNode(e,t,n,r,i){_classCallCheck(this,LLRBNode);this.key=e,this.value=t,this.color=null!=n?n:LLRBNode.RED,this.left=null!=r?r:LLRBNode.EMPTY,this.right=null!=i?i:LLRBNode.EMPTY,this.size=this.left.size+1+this.right.size;}// Returns a copy of the current node, optionally replacing pieces of it.
_createClass(LLRBNode,[{key:"copy",value:function copy(e,t,n,r,i){return new LLRBNode(null!=e?e:this.key,null!=t?t:this.value,null!=n?n:this.color,null!=r?r:this.left,null!=i?i:this.right);}},{key:"isEmpty",value:function isEmpty(){return !1;}// Traverses the tree in key order and calls the specified action function
// for each node. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
},{key:"inorderTraversal",value:function inorderTraversal(e){return this.left.inorderTraversal(e)||e(this.key,this.value)||this.right.inorderTraversal(e);}// Traverses the tree in reverse key order and calls the specified action
// function for each node. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
},{key:"reverseTraversal",value:function reverseTraversal(e){return this.right.reverseTraversal(e)||e(this.key,this.value)||this.left.reverseTraversal(e);}// Returns the minimum node in the tree.
},{key:"min",value:function min(){return this.left.isEmpty()?this:this.left.min();}// Returns the maximum key in the tree.
},{key:"minKey",value:function minKey(){return this.min().key;}// Returns the maximum key in the tree.
},{key:"maxKey",value:function maxKey(){return this.right.isEmpty()?this.key:this.right.maxKey();}// Returns new tree, with the key/value added.
},{key:"insert",value:function insert(e,t,n){var r=this;var i=n(e,r.key);return r=i<0?r.copy(null,null,null,r.left.insert(e,t,n),null):0===i?r.copy(null,t,null,null,null):r.copy(null,null,null,null,r.right.insert(e,t,n)),r.fixUp();}},{key:"removeMin",value:function removeMin(){if(this.left.isEmpty())return LLRBNode.EMPTY;var e=this;return e.left.isRed()||e.left.left.isRed()||(e=e.moveRedLeft()),e=e.copy(null,null,null,e.left.removeMin(),null),e.fixUp();}// Returns new tree, with the specified item removed.
},{key:"remove",value:function remove(e,t){var n,r=this;if(t(e,r.key)<0)r.left.isEmpty()||r.left.isRed()||r.left.left.isRed()||(r=r.moveRedLeft()),r=r.copy(null,null,null,r.left.remove(e,t),null);else {if(r.left.isRed()&&(r=r.rotateRight()),r.right.isEmpty()||r.right.isRed()||r.right.left.isRed()||(r=r.moveRedRight()),0===t(e,r.key)){if(r.right.isEmpty())return LLRBNode.EMPTY;n=r.right.min(),r=r.copy(n.key,n.value,null,null,r.right.removeMin());}r=r.copy(null,null,null,null,r.right.remove(e,t));}return r.fixUp();}},{key:"isRed",value:function isRed(){return this.color;}// Returns new tree after performing any needed rotations.
},{key:"fixUp",value:function fixUp(){var e=this;return e.right.isRed()&&!e.left.isRed()&&(e=e.rotateLeft()),e.left.isRed()&&e.left.left.isRed()&&(e=e.rotateRight()),e.left.isRed()&&e.right.isRed()&&(e=e.colorFlip()),e;}},{key:"moveRedLeft",value:function moveRedLeft(){var e=this.colorFlip();return e.right.left.isRed()&&(e=e.copy(null,null,null,null,e.right.rotateRight()),e=e.rotateLeft(),e=e.colorFlip()),e;}},{key:"moveRedRight",value:function moveRedRight(){var e=this.colorFlip();return e.left.left.isRed()&&(e=e.rotateRight(),e=e.colorFlip()),e;}},{key:"rotateLeft",value:function rotateLeft(){var e=this.copy(null,null,LLRBNode.RED,null,this.right.left);return this.right.copy(null,null,this.color,e,null);}},{key:"rotateRight",value:function rotateRight(){var e=this.copy(null,null,LLRBNode.RED,this.left.right,null);return this.left.copy(null,null,this.color,null,e);}},{key:"colorFlip",value:function colorFlip(){var e=this.left.copy(null,null,!this.left.color,null,null),t=this.right.copy(null,null,!this.right.color,null,null);return this.copy(null,null,!this.color,e,t);}// For testing.
},{key:"checkMaxDepth",value:function checkMaxDepth(){var e=this.check();return Math.pow(2,e)<=this.size+1;}// In a balanced RB tree, the black-depth (number of black nodes) from root to
// leaves is equal on both sides.  This function verifies that or asserts.
},{key:"check",value:function check(){if(this.isRed()&&this.left.isRed())throw fail();if(this.right.isRed())throw fail();var e=this.left.check();if(e!==this.right.check())throw fail();return e+(this.isRed()?0:1);}}]);return LLRBNode;}();// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
LLRBNode.EMPTY=null,LLRBNode.RED=!0,LLRBNode.BLACK=!1;// end LLRBEmptyNode
LLRBNode.EMPTY=new(/*#__PURE__*/ // Represents an empty node (a leaf node in the Red-Black Tree).
function(){function LLRBEmptyNode(){_classCallCheck(this,LLRBEmptyNode);this.size=0;}_createClass(LLRBEmptyNode,[{key:"key",get:function get(){throw fail();}},{key:"value",get:function get(){throw fail();}},{key:"color",get:function get(){throw fail();}},{key:"left",get:function get(){throw fail();}},{key:"right",get:function get(){throw fail();}// Returns a copy of the current node.
},{key:"copy",value:function copy(e,t,n,r,i){return this;}// Returns a copy of the tree, with the specified key/value added.
},{key:"insert",value:function insert(e,t,n){return new LLRBNode(e,t);}// Returns a copy of the tree, with the specified key removed.
},{key:"remove",value:function remove(e,t){return this;}},{key:"isEmpty",value:function isEmpty(){return !0;}},{key:"inorderTraversal",value:function inorderTraversal(e){return !1;}},{key:"reverseTraversal",value:function reverseTraversal(e){return !1;}},{key:"minKey",value:function minKey(){return null;}},{key:"maxKey",value:function maxKey(){return null;}},{key:"isRed",value:function isRed(){return !1;}// For testing.
},{key:"checkMaxDepth",value:function checkMaxDepth(){return !0;}},{key:"check",value:function check(){return 0;}}]);return LLRBEmptyNode;}())();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */var SortedSet=/*#__PURE__*/function(){function SortedSet(e){_classCallCheck(this,SortedSet);this.comparator=e,this.data=new SortedMap(this.comparator);}_createClass(SortedSet,[{key:"has",value:function has(e){return null!==this.data.get(e);}},{key:"first",value:function first(){return this.data.minKey();}},{key:"last",value:function last(){return this.data.maxKey();}},{key:"size",get:function get(){return this.data.size;}},{key:"indexOf",value:function indexOf(e){return this.data.indexOf(e);}/** Iterates elements in order defined by "comparator" */},{key:"forEach",value:function forEach(e){this.data.inorderTraversal(function(t,n){return e(t),!1;});}/** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */},{key:"forEachInRange",value:function forEachInRange(e,t){var n=this.data.getIteratorFrom(e[0]);for(;n.hasNext();){var r=n.getNext();if(this.comparator(r.key,e[1])>=0)return;t(r.key);}}/**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */},{key:"forEachWhile",value:function forEachWhile(e,t){var n;for(n=void 0!==t?this.data.getIteratorFrom(t):this.data.getIterator();n.hasNext();){if(!e(n.getNext().key))return;}}/** Finds the least element greater than or equal to `elem`. */},{key:"firstAfterOrEqual",value:function firstAfterOrEqual(e){var t=this.data.getIteratorFrom(e);return t.hasNext()?t.getNext().key:null;}},{key:"getIterator",value:function getIterator(){return new SortedSetIterator(this.data.getIterator());}},{key:"getIteratorFrom",value:function getIteratorFrom(e){return new SortedSetIterator(this.data.getIteratorFrom(e));}/** Inserts or updates an element */},{key:"add",value:function add(e){return this.copy(this.data.remove(e).insert(e,!0));}/** Deletes an element */},{key:"delete",value:function _delete(e){return this.has(e)?this.copy(this.data.remove(e)):this;}},{key:"isEmpty",value:function isEmpty(){return this.data.isEmpty();}},{key:"unionWith",value:function unionWith(e){var t=this;// Make sure `result` always refers to the larger one of the two sets.
return t.size<e.size&&(t=e,e=this),e.forEach(function(e){t=t.add(e);}),t;}},{key:"isEqual",value:function isEqual(e){if(!(e instanceof SortedSet))return !1;if(this.size!==e.size)return !1;var t=this.data.getIterator(),n=e.data.getIterator();for(;t.hasNext();){var _e9=t.getNext().key,r=n.getNext().key;if(0!==this.comparator(_e9,r))return !1;}return !0;}},{key:"toArray",value:function toArray(){var e=[];return this.forEach(function(t){e.push(t);}),e;}},{key:"toString",value:function toString(){var e=[];return this.forEach(function(t){return e.push(t);}),"SortedSet("+e.toString()+")";}},{key:"copy",value:function copy(e){var t=new SortedSet(this.comparator);return t.data=e,t;}}]);return SortedSet;}();var SortedSetIterator=/*#__PURE__*/function(){function SortedSetIterator(e){_classCallCheck(this,SortedSetIterator);this.iter=e;}_createClass(SortedSetIterator,[{key:"getNext",value:function getNext(){return this.iter.getNext().key;}},{key:"hasNext",value:function hasNext(){return this.iter.hasNext();}}]);return SortedSetIterator;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */var FieldMask=/*#__PURE__*/function(){function FieldMask(e){_classCallCheck(this,FieldMask);this.fields=e,// TODO(dimond): validation of FieldMask
// Sort the field mask to support `FieldMask.isEqual()` and assert below.
e.sort(FieldPath$1.comparator);}_createClass(FieldMask,[{key:"unionWith",value:/**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */function unionWith(e){var t=new SortedSet(FieldPath$1.comparator);var _iterator2=_createForOfIteratorHelper(this.fields),_step2;try{for(_iterator2.s();!(_step2=_iterator2.n()).done;){var _e10=_step2.value;t=t.add(_e10);}}catch(err){_iterator2.e(err);}finally{_iterator2.f();}var _iterator3=_createForOfIteratorHelper(e),_step3;try{for(_iterator3.s();!(_step3=_iterator3.n()).done;){var n=_step3.value;t=t.add(n);}}catch(err){_iterator3.e(err);}finally{_iterator3.f();}return new FieldMask(t.toArray());}/**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */},{key:"covers",value:function covers(e){var _iterator4=_createForOfIteratorHelper(this.fields),_step4;try{for(_iterator4.s();!(_step4=_iterator4.n()).done;){var t=_step4.value;if(t.isPrefixOf(e))return !0;}}catch(err){_iterator4.e(err);}finally{_iterator4.f();}return !1;}},{key:"isEqual",value:function isEqual(e){return __PRIVATE_arrayEquals(this.fields,e.fields,function(e,t){return e.isEqual(t);});}}],[{key:"empty",value:function empty(){return new FieldMask([]);}}]);return FieldMask;}();/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */var __PRIVATE_Base64DecodeError=/*#__PURE__*/function(_Error){_inherits(__PRIVATE_Base64DecodeError,_Error);var _super6=_createSuper(__PRIVATE_Base64DecodeError);function __PRIVATE_Base64DecodeError(){var _this23;_classCallCheck(this,__PRIVATE_Base64DecodeError);_this23=_super6.apply(this,arguments),_this23.name="Base64DecodeError";return _this23;}return _createClass(__PRIVATE_Base64DecodeError);}(/*#__PURE__*/_wrapNativeSuper(Error));/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */var ByteString=/*#__PURE__*/function(_Symbol$iterator){function ByteString(e){_classCallCheck(this,ByteString);this.binaryString=e;}_createClass(ByteString,[{key:_Symbol$iterator,value:function value(){var _this24=this;var e=0;return {next:function next(){return e<_this24.binaryString.length?{value:_this24.binaryString.charCodeAt(e++),done:!1}:{value:void 0,done:!0};}};}},{key:"toBase64",value:function toBase64(){return function __PRIVATE_encodeBase64(e){return btoa(e);}(this.binaryString);}},{key:"toUint8Array",value:function toUint8Array(){return function __PRIVATE_uint8ArrayFromBinaryString(e){var t=new Uint8Array(e.length);for(var n=0;n<e.length;n++){t[n]=e.charCodeAt(n);}return t;}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A RegExp matching ISO 8601 UTC timestamps with optional fraction.
(this.binaryString);}},{key:"approximateByteSize",value:function approximateByteSize(){return 2*this.binaryString.length;}},{key:"compareTo",value:function compareTo(e){return __PRIVATE_primitiveComparator(this.binaryString,e.binaryString);}},{key:"isEqual",value:function isEqual(e){return this.binaryString===e.binaryString;}}],[{key:"fromBase64String",value:function fromBase64String(e){var t=function __PRIVATE_decodeBase64(e){try{return atob(e);}catch(e){// Check that `DOMException` is defined before using it to avoid
// "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
// (https://github.com/firebase/firebase-js-sdk/issues/7115)
throw "undefined"!=typeof DOMException&&e instanceof DOMException?new __PRIVATE_Base64DecodeError("Invalid base64 string: "+e):e;}}/** Converts a binary string to a Base64 encoded string. */(e);return new ByteString(t);}},{key:"fromUint8Array",value:function fromUint8Array(e){// TODO(indexing); Remove the copy of the byte string here as this method
// is frequently called during indexing.
var t=/**
 * Helper function to convert an Uint8array to a binary string.
 */function __PRIVATE_binaryStringFromUint8Array(e){var t="";for(var n=0;n<e.length;++n){t+=String.fromCharCode(e[n]);}return t;}/**
 * Helper function to convert a binary string to an Uint8Array.
 */(e);return new ByteString(t);}}]);return ByteString;}(Symbol.iterator);ByteString.EMPTY_BYTE_STRING=new ByteString("");var ne=new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */function __PRIVATE_normalizeTimestamp(e){// The json interface (for the browser) will return an iso timestamp string,
// while the proto js library (for node) will return a
// google.protobuf.Timestamp instance.
if(__PRIVATE_hardAssert(!!e),"string"==typeof e){// The date string can have higher precision (nanos) than the Date class
// (millis), so we do some custom parsing here.
// Parse the nanos right out of the string.
var t=0;var n=ne.exec(e);if(__PRIVATE_hardAssert(!!n),n[1]){// Pad the fraction out to 9 digits (nanos).
var _e11=n[1];_e11=(_e11+"000000000").substr(0,9),t=Number(_e11);}// Parse the date to get the seconds.
var r=new Date(e);return {seconds:Math.floor(r.getTime()/1e3),nanos:t};}return {seconds:__PRIVATE_normalizeNumber(e.seconds),nanos:__PRIVATE_normalizeNumber(e.nanos)};}/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */function __PRIVATE_normalizeNumber(e){// TODO(bjornick): Handle int64 greater than 53 bits.
return "number"==typeof e?e:"string"==typeof e?Number(e):0;}/** Converts the possible Proto types for Blobs into a ByteString. */function __PRIVATE_normalizeByteString(e){return "string"==typeof e?ByteString.fromBase64String(e):ByteString.fromUint8Array(e);}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */function __PRIVATE_isServerTimestamp(e){var t,n;return "server_timestamp"===(null===(n=((null===(t=null==e?void 0:e.mapValue)||void 0===t?void 0:t.fields)||{}).__type__)||void 0===n?void 0:n.stringValue);}/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */function __PRIVATE_getPreviousValue(e){var t=e.mapValue.fields.__previous_value__;return __PRIVATE_isServerTimestamp(t)?__PRIVATE_getPreviousValue(t):t;}/**
 * Returns the local time at which this timestamp was first set.
 */function __PRIVATE_getLocalWriteTime(e){var t=__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);return new Timestamp(t.seconds,t.nanos);}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var DatabaseInfo=/*#__PURE__*/_createClass(/**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */function DatabaseInfo(e,t,n,r,i,s,o,_,a){_classCallCheck(this,DatabaseInfo);this.databaseId=e,this.appId=t,this.persistenceKey=n,this.host=r,this.ssl=i,this.forceLongPolling=s,this.autoDetectLongPolling=o,this.longPollingOptions=_,this.useFetchStreams=a;});/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */var DatabaseId=/*#__PURE__*/function(){function DatabaseId(e,t){_classCallCheck(this,DatabaseId);this.projectId=e,this.database=t||"(default)";}_createClass(DatabaseId,[{key:"isDefaultDatabase",get:function get(){return "(default)"===this.database;}},{key:"isEqual",value:function isEqual(e){return e instanceof DatabaseId&&e.projectId===this.projectId&&e.database===this.database;}}],[{key:"empty",value:function empty(){return new DatabaseId("","");}}]);return DatabaseId;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var re={mapValue:{fields:{__type__:{stringValue:"__max__"}}}};/** Extracts the backend's type order for the provided value. */function __PRIVATE_typeOrder(e){return "nullValue"in e?0/* TypeOrder.NullValue */:"booleanValue"in e?1/* TypeOrder.BooleanValue */:"integerValue"in e||"doubleValue"in e?2/* TypeOrder.NumberValue */:"timestampValue"in e?3/* TypeOrder.TimestampValue */:"stringValue"in e?5/* TypeOrder.StringValue */:"bytesValue"in e?6/* TypeOrder.BlobValue */:"referenceValue"in e?7/* TypeOrder.RefValue */:"geoPointValue"in e?8/* TypeOrder.GeoPointValue */:"arrayValue"in e?9/* TypeOrder.ArrayValue */:"mapValue"in e?__PRIVATE_isServerTimestamp(e)?4/* TypeOrder.ServerTimestampValue */:__PRIVATE_isMaxValue(e)?9007199254740991/* TypeOrder.MaxValue */:10/* TypeOrder.ObjectValue */:fail();}/** Tests `left` and `right` for equality based on the backend semantics. */function __PRIVATE_valueEquals(e,t){if(e===t)return !0;var n=__PRIVATE_typeOrder(e);if(n!==__PRIVATE_typeOrder(t))return !1;switch(n){case 0/* TypeOrder.NullValue */:case 9007199254740991/* TypeOrder.MaxValue */:return !0;case 1/* TypeOrder.BooleanValue */:return e.booleanValue===t.booleanValue;case 4/* TypeOrder.ServerTimestampValue */:return __PRIVATE_getLocalWriteTime(e).isEqual(__PRIVATE_getLocalWriteTime(t));case 3/* TypeOrder.TimestampValue */:return function __PRIVATE_timestampEquals(e,t){if("string"==typeof e.timestampValue&&"string"==typeof t.timestampValue&&e.timestampValue.length===t.timestampValue.length)// Use string equality for ISO 8601 timestamps
return e.timestampValue===t.timestampValue;var n=__PRIVATE_normalizeTimestamp(e.timestampValue),r=__PRIVATE_normalizeTimestamp(t.timestampValue);return n.seconds===r.seconds&&n.nanos===r.nanos;}(e,t);case 5/* TypeOrder.StringValue */:return e.stringValue===t.stringValue;case 6/* TypeOrder.BlobValue */:return function __PRIVATE_blobEquals(e,t){return __PRIVATE_normalizeByteString(e.bytesValue).isEqual(__PRIVATE_normalizeByteString(t.bytesValue));}(e,t);case 7/* TypeOrder.RefValue */:return e.referenceValue===t.referenceValue;case 8/* TypeOrder.GeoPointValue */:return function __PRIVATE_geoPointEquals(e,t){return __PRIVATE_normalizeNumber(e.geoPointValue.latitude)===__PRIVATE_normalizeNumber(t.geoPointValue.latitude)&&__PRIVATE_normalizeNumber(e.geoPointValue.longitude)===__PRIVATE_normalizeNumber(t.geoPointValue.longitude);}(e,t);case 2/* TypeOrder.NumberValue */:return function __PRIVATE_numberEquals(e,t){if("integerValue"in e&&"integerValue"in t)return __PRIVATE_normalizeNumber(e.integerValue)===__PRIVATE_normalizeNumber(t.integerValue);if("doubleValue"in e&&"doubleValue"in t){var _n3=__PRIVATE_normalizeNumber(e.doubleValue),r=__PRIVATE_normalizeNumber(t.doubleValue);return _n3===r?__PRIVATE_isNegativeZero(_n3)===__PRIVATE_isNegativeZero(r):isNaN(_n3)&&isNaN(r);}return !1;}(e,t);case 9/* TypeOrder.ArrayValue */:return __PRIVATE_arrayEquals(e.arrayValue.values||[],t.arrayValue.values||[],__PRIVATE_valueEquals);case 10/* TypeOrder.ObjectValue */:return function __PRIVATE_objectEquals(e,t){var n=e.mapValue.fields||{},r=t.mapValue.fields||{};if(__PRIVATE_objectSize(n)!==__PRIVATE_objectSize(r))return !1;for(var _e12 in n){if(n.hasOwnProperty(_e12)&&(void 0===r[_e12]||!__PRIVATE_valueEquals(n[_e12],r[_e12])))return !1;}return !0;}/** Returns true if the ArrayValue contains the specified element. */(e,t);default:return fail();}}function __PRIVATE_arrayValueContains(e,t){return void 0!==(e.values||[]).find(function(e){return __PRIVATE_valueEquals(e,t);});}function __PRIVATE_valueCompare(e,t){if(e===t)return 0;var n=__PRIVATE_typeOrder(e),r=__PRIVATE_typeOrder(t);if(n!==r)return __PRIVATE_primitiveComparator(n,r);switch(n){case 0/* TypeOrder.NullValue */:case 9007199254740991/* TypeOrder.MaxValue */:return 0;case 1/* TypeOrder.BooleanValue */:return __PRIVATE_primitiveComparator(e.booleanValue,t.booleanValue);case 2/* TypeOrder.NumberValue */:return function __PRIVATE_compareNumbers(e,t){var n=__PRIVATE_normalizeNumber(e.integerValue||e.doubleValue),r=__PRIVATE_normalizeNumber(t.integerValue||t.doubleValue);return n<r?-1:n>r?1:n===r?0:// one or both are NaN.
isNaN(n)?isNaN(r)?0:-1:1;}(e,t);case 3/* TypeOrder.TimestampValue */:return __PRIVATE_compareTimestamps(e.timestampValue,t.timestampValue);case 4/* TypeOrder.ServerTimestampValue */:return __PRIVATE_compareTimestamps(__PRIVATE_getLocalWriteTime(e),__PRIVATE_getLocalWriteTime(t));case 5/* TypeOrder.StringValue */:return __PRIVATE_primitiveComparator(e.stringValue,t.stringValue);case 6/* TypeOrder.BlobValue */:return function __PRIVATE_compareBlobs(e,t){var n=__PRIVATE_normalizeByteString(e),r=__PRIVATE_normalizeByteString(t);return n.compareTo(r);}(e.bytesValue,t.bytesValue);case 7/* TypeOrder.RefValue */:return function __PRIVATE_compareReferences(e,t){var n=e.split("/"),r=t.split("/");for(var _e13=0;_e13<n.length&&_e13<r.length;_e13++){var _t9=__PRIVATE_primitiveComparator(n[_e13],r[_e13]);if(0!==_t9)return _t9;}return __PRIVATE_primitiveComparator(n.length,r.length);}(e.referenceValue,t.referenceValue);case 8/* TypeOrder.GeoPointValue */:return function __PRIVATE_compareGeoPoints(e,t){var n=__PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.latitude),__PRIVATE_normalizeNumber(t.latitude));if(0!==n)return n;return __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.longitude),__PRIVATE_normalizeNumber(t.longitude));}(e.geoPointValue,t.geoPointValue);case 9/* TypeOrder.ArrayValue */:return function __PRIVATE_compareArrays(e,t){var n=e.values||[],r=t.values||[];for(var _e14=0;_e14<n.length&&_e14<r.length;++_e14){var _t10=__PRIVATE_valueCompare(n[_e14],r[_e14]);if(_t10)return _t10;}return __PRIVATE_primitiveComparator(n.length,r.length);}(e.arrayValue,t.arrayValue);case 10/* TypeOrder.ObjectValue */:return function __PRIVATE_compareMaps(e,t){if(e===re.mapValue&&t===re.mapValue)return 0;if(e===re.mapValue)return 1;if(t===re.mapValue)return -1;var n=e.fields||{},r=Object.keys(n),i=t.fields||{},s=Object.keys(i);// Even though MapValues are likely sorted correctly based on their insertion
// order (e.g. when received from the backend), local modifications can bring
// elements out of order. We need to re-sort the elements to ensure that
// canonical IDs are independent of insertion order.
r.sort(),s.sort();for(var _e15=0;_e15<r.length&&_e15<s.length;++_e15){var _t11=__PRIVATE_primitiveComparator(r[_e15],s[_e15]);if(0!==_t11)return _t11;var o=__PRIVATE_valueCompare(n[r[_e15]],i[s[_e15]]);if(0!==o)return o;}return __PRIVATE_primitiveComparator(r.length,s.length);}/**
 * Generates the canonical ID for the provided field value (as used in Target
 * serialization).
 */(e.mapValue,t.mapValue);default:throw fail();}}function __PRIVATE_compareTimestamps(e,t){if("string"==typeof e&&"string"==typeof t&&e.length===t.length)return __PRIVATE_primitiveComparator(e,t);var n=__PRIVATE_normalizeTimestamp(e),r=__PRIVATE_normalizeTimestamp(t),i=__PRIVATE_primitiveComparator(n.seconds,r.seconds);return 0!==i?i:__PRIVATE_primitiveComparator(n.nanos,r.nanos);}function canonicalId(e){return __PRIVATE_canonifyValue(e);}function __PRIVATE_canonifyValue(e){return "nullValue"in e?"null":"booleanValue"in e?""+e.booleanValue:"integerValue"in e?""+e.integerValue:"doubleValue"in e?""+e.doubleValue:"timestampValue"in e?function __PRIVATE_canonifyTimestamp(e){var t=__PRIVATE_normalizeTimestamp(e);return "time(".concat(t.seconds,",").concat(t.nanos,")");}(e.timestampValue):"stringValue"in e?e.stringValue:"bytesValue"in e?function __PRIVATE_canonifyByteString(e){return __PRIVATE_normalizeByteString(e).toBase64();}(e.bytesValue):"referenceValue"in e?function __PRIVATE_canonifyReference(e){return DocumentKey.fromName(e).toString();}(e.referenceValue):"geoPointValue"in e?function __PRIVATE_canonifyGeoPoint(e){return "geo(".concat(e.latitude,",").concat(e.longitude,")");}(e.geoPointValue):"arrayValue"in e?function __PRIVATE_canonifyArray(e){var t="[",n=!0;var _iterator5=_createForOfIteratorHelper(e.values||[]),_step5;try{for(_iterator5.s();!(_step5=_iterator5.n()).done;){var r=_step5.value;n?n=!1:t+=",",t+=__PRIVATE_canonifyValue(r);}}catch(err){_iterator5.e(err);}finally{_iterator5.f();}return t+"]";}/**
 * Returns an approximate (and wildly inaccurate) in-memory size for the field
 * value.
 *
 * The memory size takes into account only the actual user data as it resides
 * in memory and ignores object overhead.
 */(e.arrayValue):"mapValue"in e?function __PRIVATE_canonifyMap(e){// Iteration order in JavaScript is not guaranteed. To ensure that we generate
// matching canonical IDs for identical maps, we need to sort the keys.
var t=Object.keys(e.fields||{}).sort();var n="{",r=!0;var _iterator6=_createForOfIteratorHelper(t),_step6;try{for(_iterator6.s();!(_step6=_iterator6.n()).done;){var i=_step6.value;r?r=!1:n+=",",n+="".concat(i,":").concat(__PRIVATE_canonifyValue(e.fields[i]));}}catch(err){_iterator6.e(err);}finally{_iterator6.f();}return n+"}";}(e.mapValue):fail();}/** Returns true if `value` is an IntegerValue . */function isInteger(e){return !!e&&"integerValue"in e;}/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */function isArray$8(e){return !!e&&"arrayValue"in e;}/** Returns true if `value` is a NullValue. */function __PRIVATE_isNullValue(e){return !!e&&"nullValue"in e;}/** Returns true if `value` is NaN. */function __PRIVATE_isNanValue(e){return !!e&&"doubleValue"in e&&isNaN(Number(e.doubleValue));}/** Returns true if `value` is a MapValue. */function __PRIVATE_isMapValue(e){return !!e&&"mapValue"in e;}/** Creates a deep copy of `source`. */function __PRIVATE_deepClone(e){if(e.geoPointValue)return {geoPointValue:Object.assign({},e.geoPointValue)};if(e.timestampValue&&"object"==_typeof(e.timestampValue))return {timestampValue:Object.assign({},e.timestampValue)};if(e.mapValue){var t={mapValue:{fields:{}}};return _forEach(e.mapValue.fields,function(e,n){return t.mapValue.fields[e]=__PRIVATE_deepClone(n);}),t;}if(e.arrayValue){var _t12={arrayValue:{values:[]}};for(var n=0;n<(e.arrayValue.values||[]).length;++n){_t12.arrayValue.values[n]=__PRIVATE_deepClone(e.arrayValue.values[n]);}return _t12;}return Object.assign({},e);}/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */function __PRIVATE_isMaxValue(e){return "__max__"===(((e.mapValue||{}).fields||{}).__type__||{}).stringValue;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */var ObjectValue=/*#__PURE__*/function(){function ObjectValue(e){_classCallCheck(this,ObjectValue);this.value=e;}_createClass(ObjectValue,[{key:"field",value:/**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */function field(e){if(e.isEmpty())return this.value;{var t=this.value;for(var n=0;n<e.length-1;++n){if(t=(t.mapValue.fields||{})[e.get(n)],!__PRIVATE_isMapValue(t))return null;}return t=(t.mapValue.fields||{})[e.lastSegment()],t||null;}}/**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */},{key:"set",value:function set(e,t){this.getFieldsMap(e.popLast())[e.lastSegment()]=__PRIVATE_deepClone(t);}/**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */},{key:"setAll",value:function setAll(e){var _this25=this;var t=FieldPath$1.emptyPath(),n={},r=[];e.forEach(function(e,i){if(!t.isImmediateParentOf(i)){// Insert the accumulated changes at this parent location
var _e16=_this25.getFieldsMap(t);_this25.applyChanges(_e16,n,r),n={},r=[],t=i.popLast();}e?n[i.lastSegment()]=__PRIVATE_deepClone(e):r.push(i.lastSegment());});var i=this.getFieldsMap(t);this.applyChanges(i,n,r);}/**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */},{key:"delete",value:function _delete(e){var t=this.field(e.popLast());__PRIVATE_isMapValue(t)&&t.mapValue.fields&&delete t.mapValue.fields[e.lastSegment()];}},{key:"isEqual",value:function isEqual(e){return __PRIVATE_valueEquals(this.value,e.value);}/**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */},{key:"getFieldsMap",value:function getFieldsMap(e){var t=this.value;t.mapValue.fields||(t.mapValue={fields:{}});for(var n=0;n<e.length;++n){var r=t.mapValue.fields[e.get(n)];__PRIVATE_isMapValue(r)&&r.mapValue.fields||(r={mapValue:{fields:{}}},t.mapValue.fields[e.get(n)]=r),t=r;}return t.mapValue.fields;}/**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */},{key:"applyChanges",value:function applyChanges(e,t,n){_forEach(t,function(t,n){return e[t]=n;});var _iterator7=_createForOfIteratorHelper(n),_step7;try{for(_iterator7.s();!(_step7=_iterator7.n()).done;){var _t13=_step7.value;delete e[_t13];}}catch(err){_iterator7.e(err);}finally{_iterator7.f();}}},{key:"clone",value:function clone(){return new ObjectValue(__PRIVATE_deepClone(this.value));}}],[{key:"empty",value:function empty(){return new ObjectValue({mapValue:{}});}}]);return ObjectValue;}();/**
 * Returns a FieldMask built from all fields in a MapValue.
 */function __PRIVATE_extractFieldMask(e){var t=[];return _forEach(e.fields,function(e,n){var r=new FieldPath$1([e]);if(__PRIVATE_isMapValue(n)){var _e17=__PRIVATE_extractFieldMask(n.mapValue).fields;if(0===_e17.length)// Preserve the empty map by adding it to the FieldMask.
t.push(r);else {// For nested and non-empty ObjectValues, add the FieldPath of the
// leaf nodes.
var _iterator8=_createForOfIteratorHelper(_e17),_step8;try{for(_iterator8.s();!(_step8=_iterator8.n()).done;){var _n4=_step8.value;t.push(r.child(_n4));}}catch(err){_iterator8.e(err);}finally{_iterator8.f();}}}else// For nested and non-empty ObjectValues, add the FieldPath of the leaf
// nodes.
t.push(r);}),new FieldMask(t);}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */var MutableDocument=/*#__PURE__*/function(){function MutableDocument(e,t,n,r,i,s,o){_classCallCheck(this,MutableDocument);this.key=e,this.documentType=t,this.version=n,this.readTime=r,this.createTime=i,this.data=s,this.documentState=o;}/**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */_createClass(MutableDocument,[{key:"convertToFoundDocument",value:/**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */function convertToFoundDocument(e,t){// If a document is switching state from being an invalid or deleted
// document to a valid (FOUND_DOCUMENT) document, either due to receiving an
// update from Watch or due to applying a local set mutation on top
// of a deleted document, our best guess about its createTime would be the
// version at which the document transitioned to a FOUND_DOCUMENT.
return !this.createTime.isEqual(SnapshotVersion.min())||2/* DocumentType.NO_DOCUMENT */!==this.documentType&&0/* DocumentType.INVALID */!==this.documentType||(this.createTime=e),this.version=e,this.documentType=1/* DocumentType.FOUND_DOCUMENT */,this.data=t,this.documentState=0/* DocumentState.SYNCED */,this;}/**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */},{key:"convertToNoDocument",value:function convertToNoDocument(e){return this.version=e,this.documentType=2/* DocumentType.NO_DOCUMENT */,this.data=ObjectValue.empty(),this.documentState=0/* DocumentState.SYNCED */,this;}/**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */},{key:"convertToUnknownDocument",value:function convertToUnknownDocument(e){return this.version=e,this.documentType=3/* DocumentType.UNKNOWN_DOCUMENT */,this.data=ObjectValue.empty(),this.documentState=2/* DocumentState.HAS_COMMITTED_MUTATIONS */,this;}},{key:"setHasCommittedMutations",value:function setHasCommittedMutations(){return this.documentState=2/* DocumentState.HAS_COMMITTED_MUTATIONS */,this;}},{key:"setHasLocalMutations",value:function setHasLocalMutations(){return this.documentState=1/* DocumentState.HAS_LOCAL_MUTATIONS */,this.version=SnapshotVersion.min(),this;}},{key:"setReadTime",value:function setReadTime(e){return this.readTime=e,this;}},{key:"hasLocalMutations",get:function get(){return 1/* DocumentState.HAS_LOCAL_MUTATIONS */===this.documentState;}},{key:"hasCommittedMutations",get:function get(){return 2/* DocumentState.HAS_COMMITTED_MUTATIONS */===this.documentState;}},{key:"hasPendingWrites",get:function get(){return this.hasLocalMutations||this.hasCommittedMutations;}},{key:"isValidDocument",value:function isValidDocument(){return 0/* DocumentType.INVALID */!==this.documentType;}},{key:"isFoundDocument",value:function isFoundDocument(){return 1/* DocumentType.FOUND_DOCUMENT */===this.documentType;}},{key:"isNoDocument",value:function isNoDocument(){return 2/* DocumentType.NO_DOCUMENT */===this.documentType;}},{key:"isUnknownDocument",value:function isUnknownDocument(){return 3/* DocumentType.UNKNOWN_DOCUMENT */===this.documentType;}},{key:"isEqual",value:function isEqual(e){return e instanceof MutableDocument&&this.key.isEqual(e.key)&&this.version.isEqual(e.version)&&this.documentType===e.documentType&&this.documentState===e.documentState&&this.data.isEqual(e.data);}},{key:"mutableCopy",value:function mutableCopy(){return new MutableDocument(this.key,this.documentType,this.version,this.readTime,this.createTime,this.data.clone(),this.documentState);}},{key:"toString",value:function toString(){return "Document(".concat(this.key,", ").concat(this.version,", ").concat(JSON.stringify(this.data.value),", {createTime: ").concat(this.createTime,"}), {documentType: ").concat(this.documentType,"}), {documentState: ").concat(this.documentState,"})");}}],[{key:"newInvalidDocument",value:function newInvalidDocument(e){return new MutableDocument(e,0/* DocumentType.INVALID */,/* version */SnapshotVersion.min(),/* readTime */SnapshotVersion.min(),/* createTime */SnapshotVersion.min(),ObjectValue.empty(),0/* DocumentState.SYNCED */);}/**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */},{key:"newFoundDocument",value:function newFoundDocument(e,t,n,r){return new MutableDocument(e,1/* DocumentType.FOUND_DOCUMENT */,/* version */t,/* readTime */SnapshotVersion.min(),/* createTime */n,r,0/* DocumentState.SYNCED */);}/** Creates a new document that is known to not exist at the given version. */},{key:"newNoDocument",value:function newNoDocument(e,t){return new MutableDocument(e,2/* DocumentType.NO_DOCUMENT */,/* version */t,/* readTime */SnapshotVersion.min(),/* createTime */SnapshotVersion.min(),ObjectValue.empty(),0/* DocumentState.SYNCED */);}/**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */},{key:"newUnknownDocument",value:function newUnknownDocument(e,t){return new MutableDocument(e,3/* DocumentType.UNKNOWN_DOCUMENT */,/* version */t,/* readTime */SnapshotVersion.min(),/* createTime */SnapshotVersion.min(),ObjectValue.empty(),2/* DocumentState.HAS_COMMITTED_MUTATIONS */);}}]);return MutableDocument;}();/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */var Bound=/*#__PURE__*/_createClass(function Bound(e,t){_classCallCheck(this,Bound);this.position=e,this.inclusive=t;});function __PRIVATE_boundCompareToDocument(e,t,n){var r=0;for(var i=0;i<e.position.length;i++){var s=t[i],o=e.position[i];if(s.field.isKeyField())r=DocumentKey.comparator(DocumentKey.fromName(o.referenceValue),n.key);else {r=__PRIVATE_valueCompare(o,n.data.field(s.field));}if("desc"/* Direction.DESCENDING */===s.dir&&(r*=-1),0!==r)break;}return r;}/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */function __PRIVATE_boundEquals(e,t){if(null===e)return null===t;if(null===t)return !1;if(e.inclusive!==t.inclusive||e.position.length!==t.position.length)return !1;for(var n=0;n<e.position.length;n++){if(!__PRIVATE_valueEquals(e.position[n],t.position[n]))return !1;}return !0;}/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */var OrderBy=/*#__PURE__*/_createClass(function OrderBy(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"asc";_classCallCheck(this,OrderBy);this.field=e,this.dir=t;});function __PRIVATE_orderByEquals(e,t){return e.dir===t.dir&&e.field.isEqual(t.field);}/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Filter=/*#__PURE__*/_createClass(function Filter(){_classCallCheck(this,Filter);});var FieldFilter=/*#__PURE__*/function(_Filter){_inherits(FieldFilter,_Filter);var _super7=_createSuper(FieldFilter);function FieldFilter(e,t,n){var _this26;_classCallCheck(this,FieldFilter);_this26=_super7.call(this),_this26.field=e,_this26.op=t,_this26.value=n;return _this26;}/**
     * Creates a filter based on the provided arguments.
     */_createClass(FieldFilter,[{key:"matches",value:function matches(e){var t=e.data.field(this.field);// Types do not have to match in NOT_EQUAL filters.
return "!="/* Operator.NOT_EQUAL */===this.op?null!==t&&this.matchesComparison(__PRIVATE_valueCompare(t,this.value)):null!==t&&__PRIVATE_typeOrder(this.value)===__PRIVATE_typeOrder(t)&&this.matchesComparison(__PRIVATE_valueCompare(t,this.value));// Only compare types with matching backend order (such as double and int).
}},{key:"matchesComparison",value:function matchesComparison(e){switch(this.op){case"<"/* Operator.LESS_THAN */:return e<0;case"<="/* Operator.LESS_THAN_OR_EQUAL */:return e<=0;case"=="/* Operator.EQUAL */:return 0===e;case"!="/* Operator.NOT_EQUAL */:return 0!==e;case">"/* Operator.GREATER_THAN */:return e>0;case">="/* Operator.GREATER_THAN_OR_EQUAL */:return e>=0;default:return fail();}}},{key:"isInequality",value:function isInequality(){return ["<"/* Operator.LESS_THAN */,"<="/* Operator.LESS_THAN_OR_EQUAL */,">"/* Operator.GREATER_THAN */,">="/* Operator.GREATER_THAN_OR_EQUAL */,"!="/* Operator.NOT_EQUAL */,"not-in"/* Operator.NOT_IN */].indexOf(this.op)>=0;}},{key:"getFlattenedFilters",value:function getFlattenedFilters(){return [this];}},{key:"getFilters",value:function getFilters(){return [this];}}],[{key:"create",value:function create(e,t,n){return e.isKeyField()?"in"/* Operator.IN */===t||"not-in"/* Operator.NOT_IN */===t?this.createKeyFieldInFilter(e,t,n):new __PRIVATE_KeyFieldFilter(e,t,n):"array-contains"/* Operator.ARRAY_CONTAINS */===t?new __PRIVATE_ArrayContainsFilter(e,n):"in"/* Operator.IN */===t?new __PRIVATE_InFilter(e,n):"not-in"/* Operator.NOT_IN */===t?new __PRIVATE_NotInFilter(e,n):"array-contains-any"/* Operator.ARRAY_CONTAINS_ANY */===t?new __PRIVATE_ArrayContainsAnyFilter(e,n):new FieldFilter(e,t,n);}},{key:"createKeyFieldInFilter",value:function createKeyFieldInFilter(e,t,n){return "in"/* Operator.IN */===t?new __PRIVATE_KeyFieldInFilter(e,n):new __PRIVATE_KeyFieldNotInFilter(e,n);}}]);return FieldFilter;}(Filter);var CompositeFilter=/*#__PURE__*/function(_Filter2){_inherits(CompositeFilter,_Filter2);var _super8=_createSuper(CompositeFilter);function CompositeFilter(e,t){var _this27;_classCallCheck(this,CompositeFilter);_this27=_super8.call(this),_this27.filters=e,_this27.op=t,_this27.ae=null;return _this27;}/**
     * Creates a filter based on the provided arguments.
     */_createClass(CompositeFilter,[{key:"matches",value:function matches(e){return __PRIVATE_compositeFilterIsConjunction(this)?void 0===this.filters.find(function(t){return !t.matches(e);}):void 0!==this.filters.find(function(t){return t.matches(e);});}},{key:"getFlattenedFilters",value:function getFlattenedFilters(){return null!==this.ae||(this.ae=this.filters.reduce(function(e,t){return e.concat(t.getFlattenedFilters());},[])),this.ae;}// Returns a mutable copy of `this.filters`
},{key:"getFilters",value:function getFilters(){return Object.assign([],this.filters);}}],[{key:"create",value:function create(e,t){return new CompositeFilter(e,t);}}]);return CompositeFilter;}(Filter);function __PRIVATE_compositeFilterIsConjunction(e){return "and"/* CompositeOperator.AND */===e.op;}/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */function __PRIVATE_compositeFilterIsFlatConjunction(e){return __PRIVATE_compositeFilterIsFlat(e)&&__PRIVATE_compositeFilterIsConjunction(e);}/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */function __PRIVATE_compositeFilterIsFlat(e){var _iterator9=_createForOfIteratorHelper(e.filters),_step9;try{for(_iterator9.s();!(_step9=_iterator9.n()).done;){var t=_step9.value;if(t instanceof CompositeFilter)return !1;}}catch(err){_iterator9.e(err);}finally{_iterator9.f();}return !0;}function __PRIVATE_canonifyFilter(e){if(e instanceof FieldFilter)// TODO(b/29183165): Technically, this won't be unique if two values have
// the same description, such as the int 3 and the string "3". So we should
// add the types in here somehow, too.
return e.field.canonicalString()+e.op.toString()+canonicalId(e.value);if(__PRIVATE_compositeFilterIsFlatConjunction(e))// Older SDK versions use an implicit AND operation between their filters.
// In the new SDK versions, the developer may use an explicit AND filter.
// To stay consistent with the old usages, we add a special case to ensure
// the canonical ID for these two are the same. For example:
// `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
// canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
return e.filters.map(function(e){return __PRIVATE_canonifyFilter(e);}).join(",");{// filter instanceof CompositeFilter
var t=e.filters.map(function(e){return __PRIVATE_canonifyFilter(e);}).join(",");return "".concat(e.op,"(").concat(t,")");}}function __PRIVATE_filterEquals(e,t){return e instanceof FieldFilter?function __PRIVATE_fieldFilterEquals(e,t){return t instanceof FieldFilter&&e.op===t.op&&e.field.isEqual(t.field)&&__PRIVATE_valueEquals(e.value,t.value);}(e,t):e instanceof CompositeFilter?function __PRIVATE_compositeFilterEquals(e,t){if(t instanceof CompositeFilter&&e.op===t.op&&e.filters.length===t.filters.length){return e.filters.reduce(function(e,n,r){return e&&__PRIVATE_filterEquals(n,t.filters[r]);},!0);}return !1;}/**
 * Returns a new composite filter that contains all filter from
 * `compositeFilter` plus all the given filters in `otherFilters`.
 */(e,t):void fail();}/** Returns a debug description for `filter`. */function __PRIVATE_stringifyFilter(e){return e instanceof FieldFilter?function __PRIVATE_stringifyFieldFilter(e){return "".concat(e.field.canonicalString()," ").concat(e.op," ").concat(canonicalId(e.value));}/** Filter that matches on key fields (i.e. '__name__'). */(e):e instanceof CompositeFilter?function __PRIVATE_stringifyCompositeFilter(e){return e.op.toString()+" {"+e.getFilters().map(__PRIVATE_stringifyFilter).join(" ,")+"}";}(e):"Filter";}var __PRIVATE_KeyFieldFilter=/*#__PURE__*/function(_FieldFilter){_inherits(__PRIVATE_KeyFieldFilter,_FieldFilter);var _super9=_createSuper(__PRIVATE_KeyFieldFilter);function __PRIVATE_KeyFieldFilter(e,t,n){var _this28;_classCallCheck(this,__PRIVATE_KeyFieldFilter);_this28=_super9.call(this,e,t,n),_this28.key=DocumentKey.fromName(n.referenceValue);return _this28;}_createClass(__PRIVATE_KeyFieldFilter,[{key:"matches",value:function matches(e){var t=DocumentKey.comparator(e.key,this.key);return this.matchesComparison(t);}}]);return __PRIVATE_KeyFieldFilter;}(FieldFilter);/** Filter that matches on key fields within an array. */var __PRIVATE_KeyFieldInFilter=/*#__PURE__*/function(_FieldFilter2){_inherits(__PRIVATE_KeyFieldInFilter,_FieldFilter2);var _super10=_createSuper(__PRIVATE_KeyFieldInFilter);function __PRIVATE_KeyFieldInFilter(e,t){var _this29;_classCallCheck(this,__PRIVATE_KeyFieldInFilter);_this29=_super10.call(this,e,"in"/* Operator.IN */,t),_this29.keys=__PRIVATE_extractDocumentKeysFromArrayValue("in"/* Operator.IN */,t);return _this29;}_createClass(__PRIVATE_KeyFieldInFilter,[{key:"matches",value:function matches(e){return this.keys.some(function(t){return t.isEqual(e.key);});}}]);return __PRIVATE_KeyFieldInFilter;}(FieldFilter);/** Filter that matches on key fields not present within an array. */var __PRIVATE_KeyFieldNotInFilter=/*#__PURE__*/function(_FieldFilter3){_inherits(__PRIVATE_KeyFieldNotInFilter,_FieldFilter3);var _super11=_createSuper(__PRIVATE_KeyFieldNotInFilter);function __PRIVATE_KeyFieldNotInFilter(e,t){var _this30;_classCallCheck(this,__PRIVATE_KeyFieldNotInFilter);_this30=_super11.call(this,e,"not-in"/* Operator.NOT_IN */,t),_this30.keys=__PRIVATE_extractDocumentKeysFromArrayValue("not-in"/* Operator.NOT_IN */,t);return _this30;}_createClass(__PRIVATE_KeyFieldNotInFilter,[{key:"matches",value:function matches(e){return !this.keys.some(function(t){return t.isEqual(e.key);});}}]);return __PRIVATE_KeyFieldNotInFilter;}(FieldFilter);function __PRIVATE_extractDocumentKeysFromArrayValue(e,t){var n;return ((null===(n=t.arrayValue)||void 0===n?void 0:n.values)||[]).map(function(e){return DocumentKey.fromName(e.referenceValue);});}/** A Filter that implements the array-contains operator. */var __PRIVATE_ArrayContainsFilter=/*#__PURE__*/function(_FieldFilter4){_inherits(__PRIVATE_ArrayContainsFilter,_FieldFilter4);var _super12=_createSuper(__PRIVATE_ArrayContainsFilter);function __PRIVATE_ArrayContainsFilter(e,t){_classCallCheck(this,__PRIVATE_ArrayContainsFilter);return _super12.call(this,e,"array-contains"/* Operator.ARRAY_CONTAINS */,t);}_createClass(__PRIVATE_ArrayContainsFilter,[{key:"matches",value:function matches(e){var t=e.data.field(this.field);return isArray$8(t)&&__PRIVATE_arrayValueContains(t.arrayValue,this.value);}}]);return __PRIVATE_ArrayContainsFilter;}(FieldFilter);/** A Filter that implements the IN operator. */var __PRIVATE_InFilter=/*#__PURE__*/function(_FieldFilter5){_inherits(__PRIVATE_InFilter,_FieldFilter5);var _super13=_createSuper(__PRIVATE_InFilter);function __PRIVATE_InFilter(e,t){_classCallCheck(this,__PRIVATE_InFilter);return _super13.call(this,e,"in"/* Operator.IN */,t);}_createClass(__PRIVATE_InFilter,[{key:"matches",value:function matches(e){var t=e.data.field(this.field);return null!==t&&__PRIVATE_arrayValueContains(this.value.arrayValue,t);}}]);return __PRIVATE_InFilter;}(FieldFilter);/** A Filter that implements the not-in operator. */var __PRIVATE_NotInFilter=/*#__PURE__*/function(_FieldFilter6){_inherits(__PRIVATE_NotInFilter,_FieldFilter6);var _super14=_createSuper(__PRIVATE_NotInFilter);function __PRIVATE_NotInFilter(e,t){_classCallCheck(this,__PRIVATE_NotInFilter);return _super14.call(this,e,"not-in"/* Operator.NOT_IN */,t);}_createClass(__PRIVATE_NotInFilter,[{key:"matches",value:function matches(e){if(__PRIVATE_arrayValueContains(this.value.arrayValue,{nullValue:"NULL_VALUE"}))return !1;var t=e.data.field(this.field);return null!==t&&!__PRIVATE_arrayValueContains(this.value.arrayValue,t);}}]);return __PRIVATE_NotInFilter;}(FieldFilter);/** A Filter that implements the array-contains-any operator. */var __PRIVATE_ArrayContainsAnyFilter=/*#__PURE__*/function(_FieldFilter7){_inherits(__PRIVATE_ArrayContainsAnyFilter,_FieldFilter7);var _super15=_createSuper(__PRIVATE_ArrayContainsAnyFilter);function __PRIVATE_ArrayContainsAnyFilter(e,t){_classCallCheck(this,__PRIVATE_ArrayContainsAnyFilter);return _super15.call(this,e,"array-contains-any"/* Operator.ARRAY_CONTAINS_ANY */,t);}_createClass(__PRIVATE_ArrayContainsAnyFilter,[{key:"matches",value:function matches(e){var _this31=this;var t=e.data.field(this.field);return !(!isArray$8(t)||!t.arrayValue.values)&&t.arrayValue.values.some(function(e){return __PRIVATE_arrayValueContains(_this31.value.arrayValue,e);});}}]);return __PRIVATE_ArrayContainsAnyFilter;}(FieldFilter);/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
var __PRIVATE_TargetImpl=/*#__PURE__*/_createClass(function __PRIVATE_TargetImpl(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var s=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;var o=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;_classCallCheck(this,__PRIVATE_TargetImpl);this.path=e,this.collectionGroup=t,this.orderBy=n,this.filters=r,this.limit=i,this.startAt=s,this.endAt=o,this.ue=null;});/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */function __PRIVATE_newTarget(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var s=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;var o=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;return new __PRIVATE_TargetImpl(e,t,n,r,i,s,o);}function __PRIVATE_canonifyTarget(e){var t=__PRIVATE_debugCast(e);if(null===t.ue){var _e18=t.path.canonicalString();null!==t.collectionGroup&&(_e18+="|cg:"+t.collectionGroup),_e18+="|f:",_e18+=t.filters.map(function(e){return __PRIVATE_canonifyFilter(e);}).join(","),_e18+="|ob:",_e18+=t.orderBy.map(function(e){return function __PRIVATE_canonifyOrderBy(e){// TODO(b/29183165): Make this collision robust.
return e.field.canonicalString()+e.dir;}(e);}).join(","),__PRIVATE_isNullOrUndefined(t.limit)||(_e18+="|l:",_e18+=t.limit),t.startAt&&(_e18+="|lb:",_e18+=t.startAt.inclusive?"b:":"a:",_e18+=t.startAt.position.map(function(e){return canonicalId(e);}).join(",")),t.endAt&&(_e18+="|ub:",_e18+=t.endAt.inclusive?"a:":"b:",_e18+=t.endAt.position.map(function(e){return canonicalId(e);}).join(",")),t.ue=_e18;}return t.ue;}function __PRIVATE_targetEquals(e,t){if(e.limit!==t.limit)return !1;if(e.orderBy.length!==t.orderBy.length)return !1;for(var n=0;n<e.orderBy.length;n++){if(!__PRIVATE_orderByEquals(e.orderBy[n],t.orderBy[n]))return !1;}if(e.filters.length!==t.filters.length)return !1;for(var _n5=0;_n5<e.filters.length;_n5++){if(!__PRIVATE_filterEquals(e.filters[_n5],t.filters[_n5]))return !1;}return e.collectionGroup===t.collectionGroup&&!!e.path.isEqual(t.path)&&!!__PRIVATE_boundEquals(e.startAt,t.startAt)&&__PRIVATE_boundEquals(e.endAt,t.endAt);}function __PRIVATE_targetIsDocumentTarget(e){return DocumentKey.isDocumentKey(e.path)&&null===e.collectionGroup&&0===e.filters.length;}/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */var __PRIVATE_QueryImpl=/*#__PURE__*/_createClass(/**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */function __PRIVATE_QueryImpl(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var s=arguments.length>5&&arguments[5]!==undefined?arguments[5]:"F";var o=arguments.length>6&&arguments[6]!==undefined?arguments[6]:null;var _=arguments.length>7&&arguments[7]!==undefined?arguments[7]:null;_classCallCheck(this,__PRIVATE_QueryImpl);this.path=e,this.collectionGroup=t,this.explicitOrderBy=n,this.filters=r,this.limit=i,this.limitType=s,this.startAt=o,this.endAt=_,this.ce=null,// The corresponding `Target` of this `Query` instance, for use with
// non-aggregate queries.
this.le=null,// The corresponding `Target` of this `Query` instance, for use with
// aggregate queries. Unlike targets for non-aggregate queries,
// aggregate query targets do not contain normalized order-bys, they only
// contain explicit order-bys.
this.he=null,this.startAt,this.endAt;});/** Creates a new Query instance with the options provided. */function __PRIVATE_newQuery(e,t,n,r,i,s,o,_){return new __PRIVATE_QueryImpl(e,t,n,r,i,s,o,_);}/** Creates a new Query for a query that matches all documents at `path` */function __PRIVATE_newQueryForPath(e){return new __PRIVATE_QueryImpl(e);}/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */function __PRIVATE_queryMatchesAllDocuments(e){return 0===e.filters.length&&null===e.limit&&null==e.startAt&&null==e.endAt&&(0===e.explicitOrderBy.length||1===e.explicitOrderBy.length&&e.explicitOrderBy[0].field.isKeyField());}// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */function __PRIVATE_isCollectionGroupQuery(e){return null!==e.collectionGroup;}/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */function __PRIVATE_queryNormalizedOrderBy(e){var t=__PRIVATE_debugCast(e);if(null===t.ce){t.ce=[];var _e23=new Set();// Any explicit order by fields should be added as is.
var _iterator12=_createForOfIteratorHelper(t.explicitOrderBy),_step12;try{for(_iterator12.s();!(_step12=_iterator12.n()).done;){var _n8=_step12.value;t.ce.push(_n8),_e23.add(_n8.field.canonicalString());}// The order of the implicit ordering always matches the last explicit order by.
}catch(err){_iterator12.e(err);}finally{_iterator12.f();}var n=t.explicitOrderBy.length>0?t.explicitOrderBy[t.explicitOrderBy.length-1].dir:"asc"/* Direction.ASCENDING */,r=function __PRIVATE_getInequalityFilterFields(e){var t=new SortedSet(FieldPath$1.comparator);return e.filters.forEach(function(e){e.getFlattenedFilters().forEach(function(e){e.isInequality()&&(t=t.add(e.field));});}),t;}/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */(t);// Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
// order. When there are multiple inequality filters on the same field, the field should be added
// only once.
// Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
// field to be sorted last.
r.forEach(function(r){_e23.has(r.canonicalString())||r.isKeyField()||t.ce.push(new OrderBy(r,n));}),// Add the document key field to the last if it is not explicitly ordered.
_e23.has(FieldPath$1.keyField().canonicalString())||t.ce.push(new OrderBy(FieldPath$1.keyField(),n));}return t.ce;}/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */function __PRIVATE_queryToTarget(e){var t=__PRIVATE_debugCast(e);return t.le||(t.le=__PRIVATE__queryToTarget(t,__PRIVATE_queryNormalizedOrderBy(e))),t.le;}function __PRIVATE__queryToTarget(e,t){if("F"/* LimitType.First */===e.limitType)return __PRIVATE_newTarget(e.path,e.collectionGroup,t,e.filters,e.limit,e.startAt,e.endAt);{// Flip the orderBy directions since we want the last results
t=t.map(function(e){var t="desc"/* Direction.DESCENDING */===e.dir?"asc"/* Direction.ASCENDING */:"desc"/* Direction.DESCENDING */;return new OrderBy(e.field,t);});// We need to swap the cursors to match the now-flipped query ordering.
var n=e.endAt?new Bound(e.endAt.position,e.endAt.inclusive):null,r=e.startAt?new Bound(e.startAt.position,e.startAt.inclusive):null;// Now return as a LimitType.First query.
return __PRIVATE_newTarget(e.path,e.collectionGroup,t,e.filters,e.limit,n,r);}}function __PRIVATE_queryWithLimit(e,t,n){return new __PRIVATE_QueryImpl(e.path,e.collectionGroup,e.explicitOrderBy.slice(),e.filters.slice(),t,n,e.startAt,e.endAt);}function __PRIVATE_queryEquals(e,t){return __PRIVATE_targetEquals(__PRIVATE_queryToTarget(e),__PRIVATE_queryToTarget(t))&&e.limitType===t.limitType;}// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function __PRIVATE_canonifyQuery(e){return "".concat(__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e)),"|lt:").concat(e.limitType);}function __PRIVATE_stringifyQuery(e){return "Query(target=".concat(function __PRIVATE_stringifyTarget(e){var t=e.path.canonicalString();return null!==e.collectionGroup&&(t+=" collectionGroup="+e.collectionGroup),e.filters.length>0&&(t+=", filters: [".concat(e.filters.map(function(e){return __PRIVATE_stringifyFilter(e);}).join(", "),"]")),__PRIVATE_isNullOrUndefined(e.limit)||(t+=", limit: "+e.limit),e.orderBy.length>0&&(t+=", orderBy: [".concat(e.orderBy.map(function(e){return function __PRIVATE_stringifyOrderBy(e){return "".concat(e.field.canonicalString()," (").concat(e.dir,")");}(e);}).join(", "),"]")),e.startAt&&(t+=", startAt: ",t+=e.startAt.inclusive?"b:":"a:",t+=e.startAt.position.map(function(e){return canonicalId(e);}).join(",")),e.endAt&&(t+=", endAt: ",t+=e.endAt.inclusive?"a:":"b:",t+=e.endAt.position.map(function(e){return canonicalId(e);}).join(",")),"Target(".concat(t,")");}(__PRIVATE_queryToTarget(e)),"; limitType=").concat(e.limitType,")");}/** Returns whether `doc` matches the constraints of `query`. */function __PRIVATE_queryMatches(e,t){return t.isFoundDocument()&&function __PRIVATE_queryMatchesPathAndCollectionGroup(e,t){var n=t.key.path;return null!==e.collectionGroup?t.key.hasCollectionId(e.collectionGroup)&&e.path.isPrefixOf(n):DocumentKey.isDocumentKey(e.path)?e.path.isEqual(n):e.path.isImmediateParentOf(n);}/**
 * A document must have a value for every ordering clause in order to show up
 * in the results.
 */(e,t)&&function __PRIVATE_queryMatchesOrderBy(e,t){// We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
// Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
// be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
// to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
// A document with content of {b:1} matches the filters, but does not match the orderBy because
// it's missing the field 'a'.
var _iterator13=_createForOfIteratorHelper(__PRIVATE_queryNormalizedOrderBy(e)),_step13;try{for(_iterator13.s();!(_step13=_iterator13.n()).done;){var n=_step13.value;// order-by key always matches
if(!n.field.isKeyField()&&null===t.data.field(n.field))return !1;}}catch(err){_iterator13.e(err);}finally{_iterator13.f();}return !0;}(e,t)&&function __PRIVATE_queryMatchesFilters(e,t){var _iterator14=_createForOfIteratorHelper(e.filters),_step14;try{for(_iterator14.s();!(_step14=_iterator14.n()).done;){var n=_step14.value;if(!n.matches(t))return !1;}}catch(err){_iterator14.e(err);}finally{_iterator14.f();}return !0;}/** Makes sure a document is within the bounds, if provided. */(e,t)&&function __PRIVATE_queryMatchesBounds(e,t){if(e.startAt&&!/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */function __PRIVATE_boundSortsBeforeDocument(e,t,n){var r=__PRIVATE_boundCompareToDocument(e,t,n);return e.inclusive?r<=0:r<0;}(e.startAt,__PRIVATE_queryNormalizedOrderBy(e),t))return !1;if(e.endAt&&!function __PRIVATE_boundSortsAfterDocument(e,t,n){var r=__PRIVATE_boundCompareToDocument(e,t,n);return e.inclusive?r>=0:r>0;}(e.endAt,__PRIVATE_queryNormalizedOrderBy(e),t))return !1;return !0;}/**
 * Returns the collection group that this query targets.
 *
 * PORTING NOTE: This is only used in the Web SDK to facilitate multi-tab
 * synchronization for query results.
 */(e,t);}function __PRIVATE_queryCollectionGroup(e){return e.collectionGroup||(e.path.length%2==1?e.path.lastSegment():e.path.get(e.path.length-2));}/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */function __PRIVATE_newQueryComparator(e){return function(t,n){var r=!1;var _iterator15=_createForOfIteratorHelper(__PRIVATE_queryNormalizedOrderBy(e)),_step15;try{for(_iterator15.s();!(_step15=_iterator15.n()).done;){var i=_step15.value;var _e24=__PRIVATE_compareDocs(i,t,n);if(0!==_e24)return _e24;r=r||i.field.isKeyField();}}catch(err){_iterator15.e(err);}finally{_iterator15.f();}return 0;};}function __PRIVATE_compareDocs(e,t,n){var r=e.field.isKeyField()?DocumentKey.comparator(t.key,n.key):function __PRIVATE_compareDocumentsByField(e,t,n){var r=t.data.field(e),i=n.data.field(e);return null!==r&&null!==i?__PRIVATE_valueCompare(r,i):fail();}(e.field,t,n);switch(e.dir){case"asc"/* Direction.ASCENDING */:return r;case"desc"/* Direction.DESCENDING */:return -1*r;default:return fail();}}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */var ObjectMap=/*#__PURE__*/function(){function ObjectMap(e,t){_classCallCheck(this,ObjectMap);this.mapKeyFn=e,this.equalsFn=t,/**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */this.inner={},/** The number of entries stored in the map */this.innerSize=0;}/** Get a value for this key, or undefined if it does not exist. */_createClass(ObjectMap,[{key:"get",value:function get(e){var t=this.mapKeyFn(e),n=this.inner[t];if(void 0!==n){var _iterator16=_createForOfIteratorHelper(n),_step16;try{for(_iterator16.s();!(_step16=_iterator16.n()).done;){var _step16$value=_slicedToArray(_step16.value,2),_t16=_step16$value[0],r=_step16$value[1];if(this.equalsFn(_t16,e))return r;}}catch(err){_iterator16.e(err);}finally{_iterator16.f();}}}},{key:"has",value:function has(e){return void 0!==this.get(e);}/** Put this key and value in the map. */},{key:"set",value:function set(e,t){var n=this.mapKeyFn(e),r=this.inner[n];if(void 0===r)return this.inner[n]=[[e,t]],void this.innerSize++;for(var _n9=0;_n9<r.length;_n9++){if(this.equalsFn(r[_n9][0],e))// This is updating an existing entry and does not increase `innerSize`.
return void(r[_n9]=[e,t]);}r.push([e,t]),this.innerSize++;}/**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */},{key:"delete",value:function _delete(e){var t=this.mapKeyFn(e),n=this.inner[t];if(void 0===n)return !1;for(var r=0;r<n.length;r++){if(this.equalsFn(n[r][0],e))return 1===n.length?delete this.inner[t]:n.splice(r,1),this.innerSize--,!0;}return !1;}},{key:"forEach",value:function forEach(e){_forEach(this.inner,function(t,n){var _iterator17=_createForOfIteratorHelper(n),_step17;try{for(_iterator17.s();!(_step17=_iterator17.n()).done;){var _step17$value=_slicedToArray(_step17.value,2),_t17=_step17$value[0],r=_step17$value[1];e(_t17,r);}}catch(err){_iterator17.e(err);}finally{_iterator17.f();}});}},{key:"isEmpty",value:function isEmpty(){return _isEmpty(this.inner);}},{key:"size",value:function size(){return this.innerSize;}}]);return ObjectMap;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var se=new SortedMap(DocumentKey.comparator);function __PRIVATE_mutableDocumentMap(){return se;}var oe=new SortedMap(DocumentKey.comparator);function documentMap(){var t=oe;for(var _len5=arguments.length,e=new Array(_len5),_key5=0;_key5<_len5;_key5++){e[_key5]=arguments[_key5];}for(var _i2=0,_e25=e;_i2<_e25.length;_i2++){var n=_e25[_i2];t=t.insert(n.key,n);}return t;}function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e){var t=oe;return e.forEach(function(e,n){return t=t.insert(e,n.overlayedDocument);}),t;}function __PRIVATE_newOverlayMap(){return __PRIVATE_newDocumentKeyMap();}function __PRIVATE_newMutationMap(){return __PRIVATE_newDocumentKeyMap();}function __PRIVATE_newDocumentKeyMap(){return new ObjectMap(function(e){return e.toString();},function(e,t){return e.isEqual(t);});}var _e=new SortedMap(DocumentKey.comparator);var ae=new SortedSet(DocumentKey.comparator);function __PRIVATE_documentKeySet(){var t=ae;for(var _len6=arguments.length,e=new Array(_len6),_key6=0;_key6<_len6;_key6++){e[_key6]=arguments[_key6];}for(var _i3=0,_e26=e;_i3<_e26.length;_i3++){var n=_e26[_i3];t=t.add(n);}return t;}var ue=new SortedSet(__PRIVATE_primitiveComparator);function __PRIVATE_targetIdSet(){return ue;}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */function __PRIVATE_toDouble(e,t){if(e.useProto3Json){if(isNaN(t))return {doubleValue:"NaN"};if(t===1/0)return {doubleValue:"Infinity"};if(t===-1/0)return {doubleValue:"-Infinity"};}return {doubleValue:__PRIVATE_isNegativeZero(t)?"-0":t};}/**
 * Returns an IntegerValue for `value`.
 */function __PRIVATE_toInteger(e){return {integerValue:""+e};}/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */function toNumber(e,t){return isSafeInteger(t)?__PRIVATE_toInteger(t):__PRIVATE_toDouble(e,t);}/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */var TransformOperation=/*#__PURE__*/_createClass(function TransformOperation(){_classCallCheck(this,TransformOperation);// Make sure that the structural type of `TransformOperation` is unique.
// See https://github.com/microsoft/TypeScript/issues/5451
this._=void 0;});/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */function __PRIVATE_applyTransformOperationToLocalView(e,t,n){return e instanceof __PRIVATE_ServerTimestampTransform?function serverTimestamp$1(e,t){var n={fields:{__type__:{stringValue:"server_timestamp"},__local_write_time__:{timestampValue:{seconds:e.seconds,nanos:e.nanoseconds}}}};// We should avoid storing deeply nested server timestamp map values
// because we never use the intermediate "previous values".
// For example:
// previous: 42L, add: t1, result: t1 -> 42L
// previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
// previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
// `getPreviousValue` recursively traverses server timestamps to find the
// least recent Value.
return t&&__PRIVATE_isServerTimestamp(t)&&(t=__PRIVATE_getPreviousValue(t)),t&&(n.fields.__previous_value__=t),{mapValue:n};}(n,t):e instanceof __PRIVATE_ArrayUnionTransformOperation?__PRIVATE_applyArrayUnionTransformOperation(e,t):e instanceof __PRIVATE_ArrayRemoveTransformOperation?__PRIVATE_applyArrayRemoveTransformOperation(e,t):function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e,t){// PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
// precision and resolves overflows by reducing precision, we do not
// manually cap overflows at 2^63.
var n=__PRIVATE_computeTransformOperationBaseValue(e,t),r=asNumber(n)+asNumber(e.Pe);return isInteger(n)&&isInteger(e.Pe)?__PRIVATE_toInteger(r):__PRIVATE_toDouble(e.serializer,r);}(e,t);}/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */function __PRIVATE_applyTransformOperationToRemoteDocument(e,t,n){// The server just sends null as the transform result for array operations,
// so we have to calculate a result the same as we do for local
// applications.
return e instanceof __PRIVATE_ArrayUnionTransformOperation?__PRIVATE_applyArrayUnionTransformOperation(e,t):e instanceof __PRIVATE_ArrayRemoveTransformOperation?__PRIVATE_applyArrayRemoveTransformOperation(e,t):n;}/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */function __PRIVATE_computeTransformOperationBaseValue(e,t){return e instanceof __PRIVATE_NumericIncrementTransformOperation?/** Returns true if `value` is either an IntegerValue or a DoubleValue. */function __PRIVATE_isNumber(e){return isInteger(e)||function __PRIVATE_isDouble(e){return !!e&&"doubleValue"in e;}(e);}(t)?t:{integerValue:0}:null;}/** Transforms a value into a server-generated timestamp. */var __PRIVATE_ServerTimestampTransform=/*#__PURE__*/function(_TransformOperation){_inherits(__PRIVATE_ServerTimestampTransform,_TransformOperation);var _super16=_createSuper(__PRIVATE_ServerTimestampTransform);function __PRIVATE_ServerTimestampTransform(){_classCallCheck(this,__PRIVATE_ServerTimestampTransform);return _super16.apply(this,arguments);}return _createClass(__PRIVATE_ServerTimestampTransform);}(TransformOperation);/** Transforms an array value via a union operation. */var __PRIVATE_ArrayUnionTransformOperation=/*#__PURE__*/function(_TransformOperation2){_inherits(__PRIVATE_ArrayUnionTransformOperation,_TransformOperation2);var _super17=_createSuper(__PRIVATE_ArrayUnionTransformOperation);function __PRIVATE_ArrayUnionTransformOperation(e){var _this32;_classCallCheck(this,__PRIVATE_ArrayUnionTransformOperation);_this32=_super17.call(this),_this32.elements=e;return _this32;}return _createClass(__PRIVATE_ArrayUnionTransformOperation);}(TransformOperation);function __PRIVATE_applyArrayUnionTransformOperation(e,t){var n=__PRIVATE_coercedFieldValuesArray(t);var _iterator18=_createForOfIteratorHelper(e.elements),_step18;try{var _loop3=function _loop3(){var t=_step18.value;n.some(function(e){return __PRIVATE_valueEquals(e,t);})||n.push(t);};for(_iterator18.s();!(_step18=_iterator18.n()).done;){_loop3();}}catch(err){_iterator18.e(err);}finally{_iterator18.f();}return {arrayValue:{values:n}};}/** Transforms an array value via a remove operation. */var __PRIVATE_ArrayRemoveTransformOperation=/*#__PURE__*/function(_TransformOperation3){_inherits(__PRIVATE_ArrayRemoveTransformOperation,_TransformOperation3);var _super18=_createSuper(__PRIVATE_ArrayRemoveTransformOperation);function __PRIVATE_ArrayRemoveTransformOperation(e){var _this33;_classCallCheck(this,__PRIVATE_ArrayRemoveTransformOperation);_this33=_super18.call(this),_this33.elements=e;return _this33;}return _createClass(__PRIVATE_ArrayRemoveTransformOperation);}(TransformOperation);function __PRIVATE_applyArrayRemoveTransformOperation(e,t){var n=__PRIVATE_coercedFieldValuesArray(t);var _iterator19=_createForOfIteratorHelper(e.elements),_step19;try{var _loop4=function _loop4(){var t=_step19.value;n=n.filter(function(e){return !__PRIVATE_valueEquals(e,t);});};for(_iterator19.s();!(_step19=_iterator19.n()).done;){_loop4();}}catch(err){_iterator19.e(err);}finally{_iterator19.f();}return {arrayValue:{values:n}};}/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */var __PRIVATE_NumericIncrementTransformOperation=/*#__PURE__*/function(_TransformOperation4){_inherits(__PRIVATE_NumericIncrementTransformOperation,_TransformOperation4);var _super19=_createSuper(__PRIVATE_NumericIncrementTransformOperation);function __PRIVATE_NumericIncrementTransformOperation(e,t){var _this34;_classCallCheck(this,__PRIVATE_NumericIncrementTransformOperation);_this34=_super19.call(this),_this34.serializer=e,_this34.Pe=t;return _this34;}return _createClass(__PRIVATE_NumericIncrementTransformOperation);}(TransformOperation);function asNumber(e){return __PRIVATE_normalizeNumber(e.integerValue||e.doubleValue);}function __PRIVATE_coercedFieldValuesArray(e){return isArray$8(e)&&e.arrayValue.values?e.arrayValue.values.slice():[];}function __PRIVATE_fieldTransformEquals(e,t){return e.field.isEqual(t.field)&&function __PRIVATE_transformOperationEquals(e,t){return e instanceof __PRIVATE_ArrayUnionTransformOperation&&t instanceof __PRIVATE_ArrayUnionTransformOperation||e instanceof __PRIVATE_ArrayRemoveTransformOperation&&t instanceof __PRIVATE_ArrayRemoveTransformOperation?__PRIVATE_arrayEquals(e.elements,t.elements,__PRIVATE_valueEquals):e instanceof __PRIVATE_NumericIncrementTransformOperation&&t instanceof __PRIVATE_NumericIncrementTransformOperation?__PRIVATE_valueEquals(e.Pe,t.Pe):e instanceof __PRIVATE_ServerTimestampTransform&&t instanceof __PRIVATE_ServerTimestampTransform;}(e.transform,t.transform);}/** The result of successfully applying a mutation to the backend. */var MutationResult=/*#__PURE__*/_createClass(function MutationResult(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */e,/**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */t){_classCallCheck(this,MutationResult);this.version=e,this.transformResults=t;});/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */var Precondition=/*#__PURE__*/function(){function Precondition(e,t){_classCallCheck(this,Precondition);this.updateTime=e,this.exists=t;}/** Creates a new empty Precondition. */_createClass(Precondition,[{key:"isNone",get:/** Returns whether this Precondition is empty. */function get(){return void 0===this.updateTime&&void 0===this.exists;}},{key:"isEqual",value:function isEqual(e){return this.exists===e.exists&&(this.updateTime?!!e.updateTime&&this.updateTime.isEqual(e.updateTime):!e.updateTime);}}],[{key:"none",value:function none(){return new Precondition();}/** Creates a new Precondition with an exists flag. */},{key:"exists",value:function exists(e){return new Precondition(void 0,e);}/** Creates a new Precondition based on a version a document exists at. */},{key:"updateTime",value:function updateTime(e){return new Precondition(e);}}]);return Precondition;}();/** Returns true if the preconditions is valid for the given document. */function __PRIVATE_preconditionIsValidForDocument(e,t){return void 0!==e.updateTime?t.isFoundDocument()&&t.version.isEqual(e.updateTime):void 0===e.exists||e.exists===t.isFoundDocument();}/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */var Mutation=/*#__PURE__*/_createClass(function Mutation(){_classCallCheck(this,Mutation);});/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */function __PRIVATE_calculateOverlayMutation(e,t){if(!e.hasLocalMutations||t&&0===t.fields.length)return null;// mask is null when sets or deletes are applied to the current document.
if(null===t)return e.isNoDocument()?new __PRIVATE_DeleteMutation(e.key,Precondition.none()):new __PRIVATE_SetMutation(e.key,e.data,Precondition.none());{var n=e.data,r=ObjectValue.empty();var i=new SortedSet(FieldPath$1.comparator);var _iterator20=_createForOfIteratorHelper(t.fields),_step20;try{for(_iterator20.s();!(_step20=_iterator20.n()).done;){var _e27=_step20.value;if(!i.has(_e27)){var _t18=n.field(_e27);// If we are deleting a nested field, we take the immediate parent as
// the mask used to construct the resulting mutation.
// Justification: Nested fields can create parent fields implicitly. If
// only a leaf entry is deleted in later mutations, the parent field
// should still remain, but we may have lost this information.
// Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
// This leaves the final result (foo, {}). Despite the fact that `doc`
// has the correct result, `foo` is not in `mask`, and the resulting
// mutation would miss `foo`.
null===_t18&&_e27.length>1&&(_e27=_e27.popLast(),_t18=n.field(_e27)),null===_t18?r["delete"](_e27):r.set(_e27,_t18),i=i.add(_e27);}}}catch(err){_iterator20.e(err);}finally{_iterator20.f();}return new __PRIVATE_PatchMutation(e.key,r,new FieldMask(i.toArray()),Precondition.none());}}/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */function __PRIVATE_mutationApplyToRemoteDocument(e,t,n){e instanceof __PRIVATE_SetMutation?function __PRIVATE_setMutationApplyToRemoteDocument(e,t,n){// Unlike setMutationApplyToLocalView, if we're applying a mutation to a
// remote document the server has accepted the mutation so the precondition
// must have held.
var r=e.value.clone(),i=__PRIVATE_serverTransformResults(e.fieldTransforms,t,n.transformResults);r.setAll(i),t.convertToFoundDocument(n.version,r).setHasCommittedMutations();}(e,t,n):e instanceof __PRIVATE_PatchMutation?function __PRIVATE_patchMutationApplyToRemoteDocument(e,t,n){if(!__PRIVATE_preconditionIsValidForDocument(e.precondition,t))// Since the mutation was not rejected, we know that the precondition
// matched on the backend. We therefore must not have the expected version
// of the document in our cache and convert to an UnknownDocument with a
// known updateTime.
return void t.convertToUnknownDocument(n.version);var r=__PRIVATE_serverTransformResults(e.fieldTransforms,t,n.transformResults),i=t.data;i.setAll(__PRIVATE_getPatch(e)),i.setAll(r),t.convertToFoundDocument(n.version,i).setHasCommittedMutations();}(e,t,n):function __PRIVATE_deleteMutationApplyToRemoteDocument(e,t,n){// Unlike applyToLocalView, if we're applying a mutation to a remote
// document the server has accepted the mutation so the precondition must
// have held.
t.convertToNoDocument(n.version).setHasCommittedMutations();}(0,t,n);}/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */function __PRIVATE_mutationApplyToLocalView(e,t,n,r){return e instanceof __PRIVATE_SetMutation?function __PRIVATE_setMutationApplyToLocalView(e,t,n,r){if(!__PRIVATE_preconditionIsValidForDocument(e.precondition,t))// The mutation failed to apply (e.g. a document ID created with add()
// caused a name collision).
return n;var i=e.value.clone(),s=__PRIVATE_localTransformResults(e.fieldTransforms,r,t);return i.setAll(s),t.convertToFoundDocument(t.version,i).setHasLocalMutations(),null;// SetMutation overwrites all fields.
}/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */(e,t,n,r):e instanceof __PRIVATE_PatchMutation?function __PRIVATE_patchMutationApplyToLocalView(e,t,n,r){if(!__PRIVATE_preconditionIsValidForDocument(e.precondition,t))return n;var i=__PRIVATE_localTransformResults(e.fieldTransforms,r,t),s=t.data;if(s.setAll(__PRIVATE_getPatch(e)),s.setAll(i),t.convertToFoundDocument(t.version,s).setHasLocalMutations(),null===n)return null;return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(function(e){return e.field;}));}/**
 * Returns a FieldPath/Value map with the content of the PatchMutation.
 */(e,t,n,r):function __PRIVATE_deleteMutationApplyToLocalView(e,t,n){if(__PRIVATE_preconditionIsValidForDocument(e.precondition,t))return t.convertToNoDocument(t.version).setHasLocalMutations(),null;return n;}/**
 * A mutation that verifies the existence of the document at the given key with
 * the provided precondition.
 *
 * The `verify` operation is only used in Transactions, and this class serves
 * primarily to facilitate serialization into protos.
 */(e,t,n);}/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */function __PRIVATE_mutationExtractBaseValue(e,t){var n=null;var _iterator21=_createForOfIteratorHelper(e.fieldTransforms),_step21;try{for(_iterator21.s();!(_step21=_iterator21.n()).done;){var r=_step21.value;var _e28=t.data.field(r.field),i=__PRIVATE_computeTransformOperationBaseValue(r.transform,_e28||null);null!=i&&(null===n&&(n=ObjectValue.empty()),n.set(r.field,i));}}catch(err){_iterator21.e(err);}finally{_iterator21.f();}return n||null;}function __PRIVATE_mutationEquals(e,t){return e.type===t.type&&!!e.key.isEqual(t.key)&&!!e.precondition.isEqual(t.precondition)&&!!function __PRIVATE_fieldTransformsAreEqual(e,t){return void 0===e&&void 0===t||!(!e||!t)&&__PRIVATE_arrayEquals(e,t,function(e,t){return __PRIVATE_fieldTransformEquals(e,t);});}(e.fieldTransforms,t.fieldTransforms)&&(0/* MutationType.Set */===e.type?e.value.isEqual(t.value):1/* MutationType.Patch */!==e.type||e.data.isEqual(t.data)&&e.fieldMask.isEqual(t.fieldMask));}/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */var __PRIVATE_SetMutation=/*#__PURE__*/function(_Mutation){_inherits(__PRIVATE_SetMutation,_Mutation);var _super20=_createSuper(__PRIVATE_SetMutation);function __PRIVATE_SetMutation(e,t,n){var _this35;var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];_classCallCheck(this,__PRIVATE_SetMutation);_this35=_super20.call(this),_this35.key=e,_this35.value=t,_this35.precondition=n,_this35.fieldTransforms=r,_this35.type=0/* MutationType.Set */;return _this35;}_createClass(__PRIVATE_SetMutation,[{key:"getFieldMask",value:function getFieldMask(){return null;}}]);return __PRIVATE_SetMutation;}(Mutation);var __PRIVATE_PatchMutation=/*#__PURE__*/function(_Mutation2){_inherits(__PRIVATE_PatchMutation,_Mutation2);var _super21=_createSuper(__PRIVATE_PatchMutation);function __PRIVATE_PatchMutation(e,t,n,r){var _this36;var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];_classCallCheck(this,__PRIVATE_PatchMutation);_this36=_super21.call(this),_this36.key=e,_this36.data=t,_this36.fieldMask=n,_this36.precondition=r,_this36.fieldTransforms=i,_this36.type=1/* MutationType.Patch */;return _this36;}_createClass(__PRIVATE_PatchMutation,[{key:"getFieldMask",value:function getFieldMask(){return this.fieldMask;}}]);return __PRIVATE_PatchMutation;}(Mutation);function __PRIVATE_getPatch(e){var t=new Map();return e.fieldMask.fields.forEach(function(n){if(!n.isEmpty()){var r=e.data.field(n);t.set(n,r);}}),t;}/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */function __PRIVATE_serverTransformResults(e,t,n){var r=new Map();__PRIVATE_hardAssert(e.length===n.length);for(var i=0;i<n.length;i++){var s=e[i],o=s.transform,_=t.data.field(s.field);r.set(s.field,__PRIVATE_applyTransformOperationToRemoteDocument(o,_,n[i]));}return r;}/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */function __PRIVATE_localTransformResults(e,t,n){var r=new Map();var _iterator22=_createForOfIteratorHelper(e),_step22;try{for(_iterator22.s();!(_step22=_iterator22.n()).done;){var i=_step22.value;var _e29=i.transform,s=n.data.field(i.field);r.set(i.field,__PRIVATE_applyTransformOperationToLocalView(_e29,s,t));}}catch(err){_iterator22.e(err);}finally{_iterator22.f();}return r;}/** A mutation that deletes the document at the given key. */var __PRIVATE_DeleteMutation=/*#__PURE__*/function(_Mutation3){_inherits(__PRIVATE_DeleteMutation,_Mutation3);var _super22=_createSuper(__PRIVATE_DeleteMutation);function __PRIVATE_DeleteMutation(e,t){var _this37;_classCallCheck(this,__PRIVATE_DeleteMutation);_this37=_super22.call(this),_this37.key=e,_this37.precondition=t,_this37.type=2/* MutationType.Delete */,_this37.fieldTransforms=[];return _this37;}_createClass(__PRIVATE_DeleteMutation,[{key:"getFieldMask",value:function getFieldMask(){return null;}}]);return __PRIVATE_DeleteMutation;}(Mutation);var __PRIVATE_VerifyMutation=/*#__PURE__*/function(_Mutation4){_inherits(__PRIVATE_VerifyMutation,_Mutation4);var _super23=_createSuper(__PRIVATE_VerifyMutation);function __PRIVATE_VerifyMutation(e,t){var _this38;_classCallCheck(this,__PRIVATE_VerifyMutation);_this38=_super23.call(this),_this38.key=e,_this38.precondition=t,_this38.type=3/* MutationType.Verify */,_this38.fieldTransforms=[];return _this38;}_createClass(__PRIVATE_VerifyMutation,[{key:"getFieldMask",value:function getFieldMask(){return null;}}]);return __PRIVATE_VerifyMutation;}(Mutation);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */var MutationBatch=/*#__PURE__*/function(){/**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */function MutationBatch(e,t,n,r){_classCallCheck(this,MutationBatch);this.batchId=e,this.localWriteTime=t,this.baseMutations=n,this.mutations=r;}/**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */_createClass(MutationBatch,[{key:"applyToRemoteDocument",value:function applyToRemoteDocument(e,t){var n=t.mutationResults;for(var _t19=0;_t19<this.mutations.length;_t19++){var r=this.mutations[_t19];if(r.key.isEqual(e.key)){__PRIVATE_mutationApplyToRemoteDocument(r,e,n[_t19]);}}}/**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */},{key:"applyToLocalView",value:function applyToLocalView(e,t){// First, apply the base state. This allows us to apply non-idempotent
// transform against a consistent set of values.
var _iterator23=_createForOfIteratorHelper(this.baseMutations),_step23;try{for(_iterator23.s();!(_step23=_iterator23.n()).done;){var n=_step23.value;n.key.isEqual(e.key)&&(t=__PRIVATE_mutationApplyToLocalView(n,e,t,this.localWriteTime));}// Second, apply all user-provided mutations.
}catch(err){_iterator23.e(err);}finally{_iterator23.f();}var _iterator24=_createForOfIteratorHelper(this.mutations),_step24;try{for(_iterator24.s();!(_step24=_iterator24.n()).done;){var _n10=_step24.value;_n10.key.isEqual(e.key)&&(t=__PRIVATE_mutationApplyToLocalView(_n10,e,t,this.localWriteTime));}}catch(err){_iterator24.e(err);}finally{_iterator24.f();}return t;}/**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */},{key:"applyToLocalDocumentSet",value:function applyToLocalDocumentSet(e,t){var _this39=this;// TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
// directly (as done in `applyToLocalView()`), we can reduce the complexity
// to O(n).
var n=__PRIVATE_newMutationMap();return this.mutations.forEach(function(r){var i=e.get(r.key),s=i.overlayedDocument;// TODO(mutabledocuments): This method should take a MutableDocumentMap
// and we should remove this cast.
var o=_this39.applyToLocalView(s,i.mutatedFields);// Set mutatedFields to null if the document is only from local mutations.
// This creates a Set or Delete mutation, instead of trying to create a
// patch mutation as the overlay.
o=t.has(r.key)?null:o;var _=__PRIVATE_calculateOverlayMutation(s,o);null!==_&&n.set(r.key,_),s.isValidDocument()||s.convertToNoDocument(SnapshotVersion.min());}),n;}},{key:"keys",value:function keys(){return this.mutations.reduce(function(e,t){return e.add(t.key);},__PRIVATE_documentKeySet());}},{key:"isEqual",value:function isEqual(e){return this.batchId===e.batchId&&__PRIVATE_arrayEquals(this.mutations,e.mutations,function(e,t){return __PRIVATE_mutationEquals(e,t);})&&__PRIVATE_arrayEquals(this.baseMutations,e.baseMutations,function(e,t){return __PRIVATE_mutationEquals(e,t);});}}]);return MutationBatch;}();/** The result of applying a mutation batch to the backend. */var MutationBatchResult=/*#__PURE__*/function(){function MutationBatchResult(e,t,n,/**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */r){_classCallCheck(this,MutationBatchResult);this.batch=e,this.commitVersion=t,this.mutationResults=n,this.docVersions=r;}/**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */_createClass(MutationBatchResult,null,[{key:"from",value:function from(e,t,n){__PRIVATE_hardAssert(e.mutations.length===n.length);var r=function __PRIVATE_documentVersionMap(){return _e;}();var i=e.mutations;for(var _e30=0;_e30<i.length;_e30++){r=r.insert(i[_e30].key,n[_e30].version);}return new MutationBatchResult(e,t,n,r);}}]);return MutationBatchResult;}();/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */var Overlay=/*#__PURE__*/function(){function Overlay(e,t){_classCallCheck(this,Overlay);this.largestBatchId=e,this.mutation=t;}_createClass(Overlay,[{key:"getKey",value:function getKey(){return this.mutation.key;}},{key:"isEqual",value:function isEqual(e){return null!==e&&this.mutation===e.mutation;}},{key:"toString",value:function toString(){return "Overlay{\n      largestBatchId: ".concat(this.largestBatchId,",\n      mutation: ").concat(this.mutation.toString(),"\n    }");}}]);return Overlay;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var ExistenceFilter=/*#__PURE__*/_createClass(function ExistenceFilter(e,t){_classCallCheck(this,ExistenceFilter);this.count=e,this.unchangedNames=t;});/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */var ce,le;/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */function __PRIVATE_isPermanentError(e){switch(e){default:return fail();case C.CANCELLED:case C.UNKNOWN:case C.DEADLINE_EXCEEDED:case C.RESOURCE_EXHAUSTED:case C.INTERNAL:case C.UNAVAILABLE:// Unauthenticated means something went wrong with our token and we need
// to retry with new credentials which will happen automatically.
case C.UNAUTHENTICATED:return !1;case C.INVALID_ARGUMENT:case C.NOT_FOUND:case C.ALREADY_EXISTS:case C.PERMISSION_DENIED:case C.FAILED_PRECONDITION:// Aborted might be retried in some scenarios, but that is dependant on
// the context and should handled individually by the calling code.
// See https://cloud.google.com/apis/design/errors.
case C.ABORTED:case C.OUT_OF_RANGE:case C.UNIMPLEMENTED:case C.DATA_LOSS:return !0;}}/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */function __PRIVATE_mapCodeFromRpcCode(e){if(void 0===e)// This shouldn't normally happen, but in certain error cases (like trying
// to send invalid proto messages) we may get an error with no GRPC code.
return __PRIVATE_logError("GRPC error has no .code"),C.UNKNOWN;switch(e){case ce.OK:return C.OK;case ce.CANCELLED:return C.CANCELLED;case ce.UNKNOWN:return C.UNKNOWN;case ce.DEADLINE_EXCEEDED:return C.DEADLINE_EXCEEDED;case ce.RESOURCE_EXHAUSTED:return C.RESOURCE_EXHAUSTED;case ce.INTERNAL:return C.INTERNAL;case ce.UNAVAILABLE:return C.UNAVAILABLE;case ce.UNAUTHENTICATED:return C.UNAUTHENTICATED;case ce.INVALID_ARGUMENT:return C.INVALID_ARGUMENT;case ce.NOT_FOUND:return C.NOT_FOUND;case ce.ALREADY_EXISTS:return C.ALREADY_EXISTS;case ce.PERMISSION_DENIED:return C.PERMISSION_DENIED;case ce.FAILED_PRECONDITION:return C.FAILED_PRECONDITION;case ce.ABORTED:return C.ABORTED;case ce.OUT_OF_RANGE:return C.OUT_OF_RANGE;case ce.UNIMPLEMENTED:return C.UNIMPLEMENTED;case ce.DATA_LOSS:return C.DATA_LOSS;default:return fail();}}/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */(le=ce||(ce={}))[le.OK=0]="OK",le[le.CANCELLED=1]="CANCELLED",le[le.UNKNOWN=2]="UNKNOWN",le[le.INVALID_ARGUMENT=3]="INVALID_ARGUMENT",le[le.DEADLINE_EXCEEDED=4]="DEADLINE_EXCEEDED",le[le.NOT_FOUND=5]="NOT_FOUND",le[le.ALREADY_EXISTS=6]="ALREADY_EXISTS",le[le.PERMISSION_DENIED=7]="PERMISSION_DENIED",le[le.UNAUTHENTICATED=16]="UNAUTHENTICATED",le[le.RESOURCE_EXHAUSTED=8]="RESOURCE_EXHAUSTED",le[le.FAILED_PRECONDITION=9]="FAILED_PRECONDITION",le[le.ABORTED=10]="ABORTED",le[le.OUT_OF_RANGE=11]="OUT_OF_RANGE",le[le.UNIMPLEMENTED=12]="UNIMPLEMENTED",le[le.INTERNAL=13]="INTERNAL",le[le.UNAVAILABLE=14]="UNAVAILABLE",le[le.DATA_LOSS=15]="DATA_LOSS";/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */function __PRIVATE_newTextEncoder(){return new TextEncoder();}/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Pe=new Integer([4294967295,4294967295],0);// Hash a string using md5 hashing algorithm.
function __PRIVATE_getMd5HashValue(e){var t=__PRIVATE_newTextEncoder().encode(e),n=new Md5();return n.update(t),new Uint8Array(n.digest());}// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function __PRIVATE_get64BitUints(e){var t=new DataView(e.buffer),n=t.getUint32(0,/* littleEndian= */!0),r=t.getUint32(4,/* littleEndian= */!0),i=t.getUint32(8,/* littleEndian= */!0),s=t.getUint32(12,/* littleEndian= */!0);return [new Integer([n,r],0),new Integer([i,s],0)];}var BloomFilter=/*#__PURE__*/function(){function BloomFilter(e,t,n){_classCallCheck(this,BloomFilter);if(this.bitmap=e,this.padding=t,this.hashCount=n,t<0||t>=8)throw new __PRIVATE_BloomFilterError("Invalid padding: ".concat(t));if(n<0)throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));if(e.length>0&&0===this.hashCount)// Only empty bloom filter can have 0 hash count.
throw new __PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));if(0===e.length&&0!==t)// Empty bloom filter should have 0 padding.
throw new __PRIVATE_BloomFilterError("Invalid padding when bitmap length is 0: ".concat(t));this.Ie=8*e.length-t,// Set the bit count in Integer to avoid repetition in mightContain().
this.Te=Integer.fromNumber(this.Ie);}// Calculate the ith hash value based on the hashed 64bit integers,
// and calculate its corresponding bit index in the bitmap to be checked.
_createClass(BloomFilter,[{key:"Ee",value:function Ee(e,t,n){// Calculate hashed value h(i) = h1 + (i * h2).
var r=e.add(t.multiply(Integer.fromNumber(n)));// Wrap if hash value overflow 64bit.
return 1===r.compare(Pe)&&(r=new Integer([r.getBits(0),r.getBits(1)],0)),r.modulo(this.Te).toNumber();}// Return whether the bit on the given index in the bitmap is set to 1.
},{key:"de",value:function de(e){return 0!=(this.bitmap[Math.floor(e/8)]&1<<e%8);}},{key:"mightContain",value:function mightContain(e){// Empty bitmap should always return false on membership check.
if(0===this.Ie)return !1;var t=__PRIVATE_getMd5HashValue(e),_PRIVATE_get64BitUin=__PRIVATE_get64BitUints(t),_PRIVATE_get64BitUin2=_slicedToArray(_PRIVATE_get64BitUin,2),n=_PRIVATE_get64BitUin2[0],r=_PRIVATE_get64BitUin2[1];for(var _e31=0;_e31<this.hashCount;_e31++){var _t20=this.Ee(n,r,_e31);if(!this.de(_t20))return !1;}return !0;}/** Create bloom filter for testing purposes only. */},{key:"insert",value:function insert(e){if(0===this.Ie)return;var t=__PRIVATE_getMd5HashValue(e),_PRIVATE_get64BitUin3=__PRIVATE_get64BitUints(t),_PRIVATE_get64BitUin4=_slicedToArray(_PRIVATE_get64BitUin3,2),n=_PRIVATE_get64BitUin4[0],r=_PRIVATE_get64BitUin4[1];for(var _e32=0;_e32<this.hashCount;_e32++){var _t21=this.Ee(n,r,_e32);this.Ae(_t21);}}},{key:"Ae",value:function Ae(e){var t=Math.floor(e/8),n=e%8;this.bitmap[t]|=1<<n;}}],[{key:"create",value:function create(e,t,n){var r=e%8==0?0:8-e%8,i=new Uint8Array(Math.ceil(e/8)),s=new BloomFilter(i,r,t);return n.forEach(function(e){return s.insert(e);}),s;}}]);return BloomFilter;}();var __PRIVATE_BloomFilterError=/*#__PURE__*/function(_Error2){_inherits(__PRIVATE_BloomFilterError,_Error2);var _super24=_createSuper(__PRIVATE_BloomFilterError);function __PRIVATE_BloomFilterError(){var _this40;_classCallCheck(this,__PRIVATE_BloomFilterError);_this40=_super24.apply(this,arguments),_this40.name="BloomFilterError";return _this40;}return _createClass(__PRIVATE_BloomFilterError);}(/*#__PURE__*/_wrapNativeSuper(Error));/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */var RemoteEvent=/*#__PURE__*/function(){function RemoteEvent(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */e,/**
     * A map from target to changes to the target. See TargetChange.
     */t,/**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */n,/**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */r,/**
     * A set of which document updates are due only to limbo resolution targets.
     */i){_classCallCheck(this,RemoteEvent);this.snapshotVersion=e,this.targetChanges=t,this.targetMismatches=n,this.documentUpdates=r,this.resolvedLimboDocuments=i;}/**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
_createClass(RemoteEvent,null,[{key:"createSynthesizedRemoteEventForCurrentChange",value:function createSynthesizedRemoteEventForCurrentChange(e,t,n){var r=new Map();return r.set(e,TargetChange.createSynthesizedTargetChangeForCurrentChange(e,t,n)),new RemoteEvent(SnapshotVersion.min(),r,new SortedMap(__PRIVATE_primitiveComparator),__PRIVATE_mutableDocumentMap(),__PRIVATE_documentKeySet());}}]);return RemoteEvent;}();/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */var TargetChange=/*#__PURE__*/function(){function TargetChange(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */e,/**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */t,/**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */n,/**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */r,/**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */i){_classCallCheck(this,TargetChange);this.resumeToken=e,this.current=t,this.addedDocuments=n,this.modifiedDocuments=r,this.removedDocuments=i;}/**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */_createClass(TargetChange,null,[{key:"createSynthesizedTargetChangeForCurrentChange",value:function createSynthesizedTargetChangeForCurrentChange(e,t,n){return new TargetChange(n,t,__PRIVATE_documentKeySet(),__PRIVATE_documentKeySet(),__PRIVATE_documentKeySet());}}]);return TargetChange;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */var __PRIVATE_DocumentWatchChange=/*#__PURE__*/_createClass(function __PRIVATE_DocumentWatchChange(/** The new document applies to all of these targets. */e,/** The new document is removed from all of these targets. */t,/** The key of the document for this change. */n,/**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */r){_classCallCheck(this,__PRIVATE_DocumentWatchChange);this.Re=e,this.removedTargetIds=t,this.key=n,this.Ve=r;});var __PRIVATE_ExistenceFilterChange=/*#__PURE__*/_createClass(function __PRIVATE_ExistenceFilterChange(e,t){_classCallCheck(this,__PRIVATE_ExistenceFilterChange);this.targetId=e,this.me=t;});var __PRIVATE_WatchTargetChange=/*#__PURE__*/_createClass(function __PRIVATE_WatchTargetChange(/** What kind of change occurred to the watch target. */e,/** The target IDs that were added/removed/set. */t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:ByteString.EMPTY_BYTE_STRING;var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;_classCallCheck(this,__PRIVATE_WatchTargetChange);this.state=e,this.targetIds=t,this.resumeToken=n,this.cause=r;});/** Tracks the internal state of a Watch target. */var __PRIVATE_TargetState=/*#__PURE__*/function(){function __PRIVATE_TargetState(){_classCallCheck(this,__PRIVATE_TargetState);/**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */this.fe=0,/**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */this.ge=__PRIVATE_snapshotChangesMap(),/** See public getters for explanations of these fields. */this.pe=ByteString.EMPTY_BYTE_STRING,this.ye=!1,/**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */this.we=!0;}/**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */_createClass(__PRIVATE_TargetState,[{key:"current",get:function get(){return this.ye;}/** The last resume token sent to us for this target. */},{key:"resumeToken",get:function get(){return this.pe;}/** Whether this target has pending target adds or target removes. */},{key:"Se",get:function get(){return 0!==this.fe;}/** Whether we have modified any state that should trigger a snapshot. */},{key:"be",get:function get(){return this.we;}/**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */},{key:"De",value:function De(e){e.approximateByteSize()>0&&(this.we=!0,this.pe=e);}/**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */},{key:"Ce",value:function Ce(){var e=__PRIVATE_documentKeySet(),t=__PRIVATE_documentKeySet(),n=__PRIVATE_documentKeySet();return this.ge.forEach(function(r,i){switch(i){case 0/* ChangeType.Added */:e=e.add(r);break;case 2/* ChangeType.Modified */:t=t.add(r);break;case 1/* ChangeType.Removed */:n=n.add(r);break;default:fail();}}),new TargetChange(this.pe,this.ye,e,t,n);}/**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */},{key:"ve",value:function ve(){this.we=!1,this.ge=__PRIVATE_snapshotChangesMap();}},{key:"Fe",value:function Fe(e,t){this.we=!0,this.ge=this.ge.insert(e,t);}},{key:"Me",value:function Me(e){this.we=!0,this.ge=this.ge.remove(e);}},{key:"xe",value:function xe(){this.fe+=1;}},{key:"Oe",value:function Oe(){this.fe-=1,__PRIVATE_hardAssert(this.fe>=0);}},{key:"Ne",value:function Ne(){this.we=!0,this.ye=!0;}}]);return __PRIVATE_TargetState;}();/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */var __PRIVATE_WatchChangeAggregator=/*#__PURE__*/function(){function __PRIVATE_WatchChangeAggregator(e){_classCallCheck(this,__PRIVATE_WatchChangeAggregator);this.Le=e,/** The internal state of all tracked targets. */this.Be=new Map(),/** Keeps track of the documents to update since the last raised snapshot. */this.ke=__PRIVATE_mutableDocumentMap(),/** A mapping of document keys to their set of target IDs. */this.qe=__PRIVATE_documentTargetMap(),/**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */this.Qe=new SortedMap(__PRIVATE_primitiveComparator);}/**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */_createClass(__PRIVATE_WatchChangeAggregator,[{key:"Ke",value:function Ke(e){var _iterator25=_createForOfIteratorHelper(e.Re),_step25;try{for(_iterator25.s();!(_step25=_iterator25.n()).done;){var t=_step25.value;e.Ve&&e.Ve.isFoundDocument()?this.$e(t,e.Ve):this.Ue(t,e.key,e.Ve);}}catch(err){_iterator25.e(err);}finally{_iterator25.f();}var _iterator26=_createForOfIteratorHelper(e.removedTargetIds),_step26;try{for(_iterator26.s();!(_step26=_iterator26.n()).done;){var _t22=_step26.value;this.Ue(_t22,e.key,e.Ve);}}catch(err){_iterator26.e(err);}finally{_iterator26.f();}}/** Processes and adds the WatchTargetChange to the current set of changes. */},{key:"We",value:function We(e){var _this41=this;this.forEachTarget(e,function(t){var n=_this41.Ge(t);switch(e.state){case 0/* WatchTargetChangeState.NoChange */:_this41.ze(t)&&n.De(e.resumeToken);break;case 1/* WatchTargetChangeState.Added */:// We need to decrement the number of pending acks needed from watch
// for this targetId.
n.Oe(),n.Se||// We have a freshly added target, so we need to reset any state
// that we had previously. This can happen e.g. when remove and add
// back a target for existence filter mismatches.
n.ve(),n.De(e.resumeToken);break;case 2/* WatchTargetChangeState.Removed */:// We need to keep track of removed targets to we can post-filter and
// remove any target changes.
// We need to decrement the number of pending acks needed from watch
// for this targetId.
n.Oe(),n.Se||_this41.removeTarget(t);break;case 3/* WatchTargetChangeState.Current */:_this41.ze(t)&&(n.Ne(),n.De(e.resumeToken));break;case 4/* WatchTargetChangeState.Reset */:_this41.ze(t)&&(// Reset the target and synthesizes removes for all existing
// documents. The backend will re-add any documents that still
// match the target before it sends the next global snapshot.
_this41.je(t),n.De(e.resumeToken));break;default:fail();}});}/**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */},{key:"forEachTarget",value:function forEachTarget(e,t){var _this42=this;e.targetIds.length>0?e.targetIds.forEach(t):this.Be.forEach(function(e,n){_this42.ze(n)&&t(n);});}/**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */},{key:"He",value:function He(e){var t=e.targetId,n=e.me.count,r=this.Je(t);if(r){var i=r.target;if(__PRIVATE_targetIsDocumentTarget(i)){if(0===n){// The existence filter told us the document does not exist. We deduce
// that this document does not exist and apply a deleted document to
// our updates. Without applying this deleted document there might be
// another query that will raise this document as part of a snapshot
// until it is resolved, essentially exposing inconsistency between
// queries.
var _e33=new DocumentKey(i.path);this.Ue(t,_e33,MutableDocument.newNoDocument(_e33,SnapshotVersion.min()));}else __PRIVATE_hardAssert(1===n);}else {var _r2=this.Ye(t);// Existence filter mismatch. Mark the documents as being in limbo, and
// raise a snapshot with `isFromCache:true`.
if(_r2!==n){// Apply bloom filter to identify and mark removed documents.
var _n11=this.Ze(e),_i4=_n11?this.Xe(_n11,e,_r2):1/* BloomFilterApplicationStatus.Skipped */;if(0/* BloomFilterApplicationStatus.Success */!==_i4){// If bloom filter application fails, we reset the mapping and
// trigger re-run of the query.
this.je(t);var _e34=2/* BloomFilterApplicationStatus.FalsePositive */===_i4?"TargetPurposeExistenceFilterMismatchBloom"/* TargetPurpose.ExistenceFilterMismatchBloom */:"TargetPurposeExistenceFilterMismatch"/* TargetPurpose.ExistenceFilterMismatch */;this.Qe=this.Qe.insert(t,_e34);}}}}}/**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */},{key:"Ze",value:function Ze(e){var t=e.me.unchangedNames;if(!t||!t.bits)return null;var _t$bits=t.bits,_t$bits$bitmap=_t$bits.bitmap,n=_t$bits$bitmap===void 0?"":_t$bits$bitmap,_t$bits$padding=_t$bits.padding,r=_t$bits$padding===void 0?0:_t$bits$padding,_t$hashCount=t.hashCount,i=_t$hashCount===void 0?0:_t$hashCount;var s,o;try{s=__PRIVATE_normalizeByteString(n).toUint8Array();}catch(e){if(e instanceof __PRIVATE_Base64DecodeError)return __PRIVATE_logWarn("Decoding the base64 bloom filter in existence filter failed ("+e.message+"); ignoring the bloom filter and falling back to full re-query."),null;throw e;}try{// BloomFilter throws error if the inputs are invalid.
o=new BloomFilter(s,r,i);}catch(e){return __PRIVATE_logWarn(e instanceof __PRIVATE_BloomFilterError?"BloomFilter error: ":"Applying bloom filter failed: ",e),null;}return 0===o.Ie?null:o;}/**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */},{key:"Xe",value:function Xe(e,t,n){return t.me.count===n-this.nt(e,t.targetId)?0/* BloomFilterApplicationStatus.Success */:2/* BloomFilterApplicationStatus.FalsePositive */;}/**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */},{key:"nt",value:function nt(e,t){var _this43=this;var n=this.Le.getRemoteKeysForTarget(t);var r=0;return n.forEach(function(n){var i=_this43.Le.tt(),s="projects/".concat(i.projectId,"/databases/").concat(i.database,"/documents/").concat(n.path.canonicalString());e.mightContain(s)||(_this43.Ue(t,n,/*updatedDocument=*/null),r++);}),r;}/**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */},{key:"rt",value:function rt(e){var _this44=this;var t=new Map();this.Be.forEach(function(n,r){var i=_this44.Je(r);if(i){if(n.current&&__PRIVATE_targetIsDocumentTarget(i.target)){// Document queries for document that don't exist can produce an empty
// result set. To update our local cache, we synthesize a document
// delete if we have not previously received the document. This
// resolves the limbo state of the document, removing it from
// limboDocumentRefs.
// TODO(dimond): Ideally we would have an explicit lookup target
// instead resulting in an explicit delete message and we could
// remove this special logic.
var _t23=new DocumentKey(i.target.path);null!==_this44.ke.get(_t23)||_this44.it(r,_t23)||_this44.Ue(r,_t23,MutableDocument.newNoDocument(_t23,e));}n.be&&(t.set(r,n.Ce()),n.ve());}});var n=__PRIVATE_documentKeySet();// We extract the set of limbo-only document updates as the GC logic
// special-cases documents that do not appear in the target cache.
// TODO(gsoltis): Expand on this comment once GC is available in the JS
// client.
this.qe.forEach(function(e,t){var r=!0;t.forEachWhile(function(e){var t=_this44.Je(e);return !t||"TargetPurposeLimboResolution"/* TargetPurpose.LimboResolution */===t.purpose||(r=!1,!1);}),r&&(n=n.add(e));}),this.ke.forEach(function(t,n){return n.setReadTime(e);});var r=new RemoteEvent(e,t,this.Qe,this.ke,n);return this.ke=__PRIVATE_mutableDocumentMap(),this.qe=__PRIVATE_documentTargetMap(),this.Qe=new SortedMap(__PRIVATE_primitiveComparator),r;}/**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
},{key:"$e",value:function $e(e,t){if(!this.ze(e))return;var n=this.it(e,t.key)?2/* ChangeType.Modified */:0/* ChangeType.Added */;this.Ge(e).Fe(t.key,n),this.ke=this.ke.insert(t.key,t),this.qe=this.qe.insert(t.key,this.st(t.key).add(e));}/**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
},{key:"Ue",value:function Ue(e,t,n){if(!this.ze(e))return;var r=this.Ge(e);this.it(e,t)?r.Fe(t,1/* ChangeType.Removed */):// The document may have entered and left the target before we raised a
// snapshot, so we can just ignore the change.
r.Me(t),this.qe=this.qe.insert(t,this.st(t)["delete"](e)),n&&(this.ke=this.ke.insert(t,n));}},{key:"removeTarget",value:function removeTarget(e){this.Be["delete"](e);}/**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */},{key:"Ye",value:function Ye(e){var t=this.Ge(e).Ce();return this.Le.getRemoteKeysForTarget(e).size+t.addedDocuments.size-t.removedDocuments.size;}/**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */},{key:"xe",value:function xe(e){this.Ge(e).xe();}},{key:"Ge",value:function Ge(e){var t=this.Be.get(e);return t||(t=new __PRIVATE_TargetState(),this.Be.set(e,t)),t;}},{key:"st",value:function st(e){var t=this.qe.get(e);return t||(t=new SortedSet(__PRIVATE_primitiveComparator),this.qe=this.qe.insert(e,t)),t;}/**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */},{key:"ze",value:function ze(e){var t=null!==this.Je(e);return t||__PRIVATE_logDebug("WatchChangeAggregator","Detected inactive target",e),t;}/**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */},{key:"Je",value:function Je(e){var t=this.Be.get(e);return t&&t.Se?null:this.Le.ot(e);}/**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */},{key:"je",value:function je(e){var _this45=this;this.Be.set(e,new __PRIVATE_TargetState());this.Le.getRemoteKeysForTarget(e).forEach(function(t){_this45.Ue(e,t,/*updatedDocument=*/null);});}/**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */},{key:"it",value:function it(e,t){return this.Le.getRemoteKeysForTarget(e).has(t);}}]);return __PRIVATE_WatchChangeAggregator;}();function __PRIVATE_documentTargetMap(){return new SortedMap(DocumentKey.comparator);}function __PRIVATE_snapshotChangesMap(){return new SortedMap(DocumentKey.comparator);}var Ie=function(){var e={asc:"ASCENDING",desc:"DESCENDING"};return e;}(),Te=function(){var e={"<":"LESS_THAN","<=":"LESS_THAN_OR_EQUAL",">":"GREATER_THAN",">=":"GREATER_THAN_OR_EQUAL","==":"EQUAL","!=":"NOT_EQUAL","array-contains":"ARRAY_CONTAINS","in":"IN","not-in":"NOT_IN","array-contains-any":"ARRAY_CONTAINS_ANY"};return e;}(),Ee=function(){var e={and:"AND",or:"OR"};return e;}();/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */var JsonProtoSerializer=/*#__PURE__*/_createClass(function JsonProtoSerializer(e,t){_classCallCheck(this,JsonProtoSerializer);this.databaseId=e,this.useProto3Json=t;});/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */function __PRIVATE_toInt32Proto(e,t){return e.useProto3Json||__PRIVATE_isNullOrUndefined(t)?t:{value:t};}/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */function toTimestamp(e,t){if(e.useProto3Json){return "".concat(new Date(1e3*t.seconds).toISOString().replace(/\.\d*/,"").replace("Z",""),".").concat(("000000000"+t.nanoseconds).slice(-9),"Z");}return {seconds:""+t.seconds,nanos:t.nanoseconds};}/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */function __PRIVATE_toBytes(e,t){return e.useProto3Json?t.toBase64():t.toUint8Array();}/**
 * Returns a ByteString based on the proto string value.
 */function __PRIVATE_toVersion(e,t){return toTimestamp(e,t.toTimestamp());}function __PRIVATE_fromVersion(e){return __PRIVATE_hardAssert(!!e),SnapshotVersion.fromTimestamp(function fromTimestamp(e){var t=__PRIVATE_normalizeTimestamp(e);return new Timestamp(t.seconds,t.nanos);}(e));}function __PRIVATE_toResourceName(e,t){return __PRIVATE_toResourcePath(e,t).canonicalString();}function __PRIVATE_toResourcePath(e,t){var n=function __PRIVATE_fullyQualifiedPrefixPath(e){return new ResourcePath(["projects",e.projectId,"databases",e.database]);}(e).child("documents");return void 0===t?n:n.child(t);}function __PRIVATE_fromResourceName(e){var t=ResourcePath.fromString(e);return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t)),t;}function __PRIVATE_toName(e,t){return __PRIVATE_toResourceName(e.databaseId,t.path);}function fromName(e,t){var n=__PRIVATE_fromResourceName(t);if(n.get(1)!==e.databaseId.projectId)throw new FirestoreError(C.INVALID_ARGUMENT,"Tried to deserialize key from different project: "+n.get(1)+" vs "+e.databaseId.projectId);if(n.get(3)!==e.databaseId.database)throw new FirestoreError(C.INVALID_ARGUMENT,"Tried to deserialize key from different database: "+n.get(3)+" vs "+e.databaseId.database);return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(n));}function __PRIVATE_toQueryPath(e,t){return __PRIVATE_toResourceName(e.databaseId,t);}function __PRIVATE_fromQueryPath(e){var t=__PRIVATE_fromResourceName(e);// In v1beta1 queries for collections at the root did not have a trailing
// "/documents". In v1 all resource paths contain "/documents". Preserve the
// ability to read the v1beta1 form for compatibility with queries persisted
// in the local target cache.
return 4===t.length?ResourcePath.emptyPath():__PRIVATE_extractLocalPathFromResourceName(t);}function __PRIVATE_getEncodedDatabaseId(e){return new ResourcePath(["projects",e.databaseId.projectId,"databases",e.databaseId.database]).canonicalString();}function __PRIVATE_extractLocalPathFromResourceName(e){return __PRIVATE_hardAssert(e.length>4&&"documents"===e.get(4)),e.popFirst(5);}/** Creates a Document proto from key and fields (but no create/update time) */function __PRIVATE_toMutationDocument(e,t,n){return {name:__PRIVATE_toName(e,t),fields:n.value.mapValue.fields};}function __PRIVATE_fromWatchChange(e,t){var n;if("targetChange"in t){t.targetChange;// proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
// if unset
var r=function __PRIVATE_fromWatchTargetChangeState(e){return "NO_CHANGE"===e?0/* WatchTargetChangeState.NoChange */:"ADD"===e?1/* WatchTargetChangeState.Added */:"REMOVE"===e?2/* WatchTargetChangeState.Removed */:"CURRENT"===e?3/* WatchTargetChangeState.Current */:"RESET"===e?4/* WatchTargetChangeState.Reset */:fail();}(t.targetChange.targetChangeType||"NO_CHANGE"),i=t.targetChange.targetIds||[],s=function __PRIVATE_fromBytes(e,t){return e.useProto3Json?(__PRIVATE_hardAssert(void 0===t||"string"==typeof t),ByteString.fromBase64String(t||"")):(__PRIVATE_hardAssert(void 0===t||// Check if the value is an instance of both Buffer and Uint8Array,
// despite the fact that Buffer extends Uint8Array. In some
// environments, such as jsdom, the prototype chain of Buffer
// does not indicate that it extends Uint8Array.
t instanceof Buffer||t instanceof Uint8Array),ByteString.fromUint8Array(t||new Uint8Array()));}(e,t.targetChange.resumeToken),o=t.targetChange.cause,_=o&&function __PRIVATE_fromRpcStatus(e){var t=void 0===e.code?C.UNKNOWN:__PRIVATE_mapCodeFromRpcCode(e.code);return new FirestoreError(t,e.message||"");}(o);n=new __PRIVATE_WatchTargetChange(r,i,s,_||null);}else if("documentChange"in t){t.documentChange;var _r3=t.documentChange;_r3.document,_r3.document.name,_r3.document.updateTime;var _i5=fromName(e,_r3.document.name),_s=__PRIVATE_fromVersion(_r3.document.updateTime),_o=_r3.document.createTime?__PRIVATE_fromVersion(_r3.document.createTime):SnapshotVersion.min(),_2=new ObjectValue({mapValue:{fields:_r3.document.fields}}),a=MutableDocument.newFoundDocument(_i5,_s,_o,_2),u=_r3.targetIds||[],c=_r3.removedTargetIds||[];n=new __PRIVATE_DocumentWatchChange(u,c,a.key,a);}else if("documentDelete"in t){t.documentDelete;var _r4=t.documentDelete;_r4.document;var _i6=fromName(e,_r4.document),_s2=_r4.readTime?__PRIVATE_fromVersion(_r4.readTime):SnapshotVersion.min(),_o2=MutableDocument.newNoDocument(_i6,_s2),_3=_r4.removedTargetIds||[];n=new __PRIVATE_DocumentWatchChange([],_3,_o2.key,_o2);}else if("documentRemove"in t){t.documentRemove;var _r5=t.documentRemove;_r5.document;var _i7=fromName(e,_r5.document),_s3=_r5.removedTargetIds||[];n=new __PRIVATE_DocumentWatchChange([],_s3,_i7,null);}else {if(!("filter"in t))return fail();{t.filter;var _e35=t.filter;_e35.targetId;var _e35$count=_e35.count,_r6=_e35$count===void 0?0:_e35$count,_i8=_e35.unchangedNames,_s4=new ExistenceFilter(_r6,_i8),_o3=_e35.targetId;n=new __PRIVATE_ExistenceFilterChange(_o3,_s4);}}return n;}function toMutation(e,t){var n;if(t instanceof __PRIVATE_SetMutation)n={update:__PRIVATE_toMutationDocument(e,t.key,t.value)};else if(t instanceof __PRIVATE_DeleteMutation)n={"delete":__PRIVATE_toName(e,t.key)};else if(t instanceof __PRIVATE_PatchMutation)n={update:__PRIVATE_toMutationDocument(e,t.key,t.data),updateMask:__PRIVATE_toDocumentMask(t.fieldMask)};else {if(!(t instanceof __PRIVATE_VerifyMutation))return fail();n={verify:__PRIVATE_toName(e,t.key)};}return t.fieldTransforms.length>0&&(n.updateTransforms=t.fieldTransforms.map(function(e){return function __PRIVATE_toFieldTransform(e,t){var n=t.transform;if(n instanceof __PRIVATE_ServerTimestampTransform)return {fieldPath:t.field.canonicalString(),setToServerValue:"REQUEST_TIME"};if(n instanceof __PRIVATE_ArrayUnionTransformOperation)return {fieldPath:t.field.canonicalString(),appendMissingElements:{values:n.elements}};if(n instanceof __PRIVATE_ArrayRemoveTransformOperation)return {fieldPath:t.field.canonicalString(),removeAllFromArray:{values:n.elements}};if(n instanceof __PRIVATE_NumericIncrementTransformOperation)return {fieldPath:t.field.canonicalString(),increment:n.Pe};throw fail();}(0,e);})),t.precondition.isNone||(n.currentDocument=function __PRIVATE_toPrecondition(e,t){return void 0!==t.updateTime?{updateTime:__PRIVATE_toVersion(e,t.updateTime)}:void 0!==t.exists?{exists:t.exists}:fail();}(e,t.precondition)),n;}function __PRIVATE_fromWriteResults(e,t){return e&&e.length>0?(__PRIVATE_hardAssert(void 0!==t),e.map(function(e){return function __PRIVATE_fromWriteResult(e,t){// NOTE: Deletes don't have an updateTime.
var n=e.updateTime?__PRIVATE_fromVersion(e.updateTime):__PRIVATE_fromVersion(t);return n.isEqual(SnapshotVersion.min())&&(// The Firestore Emulator currently returns an update time of 0 for
// deletes of non-existing documents (rather than null). This breaks the
// test "get deleted doc while offline with source=cache" as NoDocuments
// with version 0 are filtered by IndexedDb's RemoteDocumentCache.
// TODO(#2149): Remove this when Emulator is fixed
n=__PRIVATE_fromVersion(t)),new MutationResult(n,e.transformResults||[]);}(e,t);})):[];}function __PRIVATE_toDocumentsTarget(e,t){return {documents:[__PRIVATE_toQueryPath(e,t.path)]};}function __PRIVATE_toQueryTarget(e,t){// Dissect the path into parent, collectionId, and optional key filter.
var n={structuredQuery:{}},r=t.path;var i;null!==t.collectionGroup?(i=r,n.structuredQuery.from=[{collectionId:t.collectionGroup,allDescendants:!0}]):(i=r.popLast(),n.structuredQuery.from=[{collectionId:r.lastSegment()}]),n.parent=__PRIVATE_toQueryPath(e,i);var s=function __PRIVATE_toFilters(e){if(0===e.length)return;return __PRIVATE_toFilter(CompositeFilter.create(e,"and"/* CompositeOperator.AND */));}(t.filters);s&&(n.structuredQuery.where=s);var o=function __PRIVATE_toOrder(e){if(0===e.length)return;return e.map(function(e){return(// visible for testing
function __PRIVATE_toPropertyOrder(e){return {field:__PRIVATE_toFieldPathReference(e.field),direction:__PRIVATE_toDirection(e.dir)};}(e));});}(t.orderBy);o&&(n.structuredQuery.orderBy=o);var _=__PRIVATE_toInt32Proto(e,t.limit);return null!==_&&(n.structuredQuery.limit=_),t.startAt&&(n.structuredQuery.startAt=function __PRIVATE_toStartAtCursor(e){return {before:e.inclusive,values:e.position};}(t.startAt)),t.endAt&&(n.structuredQuery.endAt=function __PRIVATE_toEndAtCursor(e){return {before:!e.inclusive,values:e.position};}(t.endAt)),{_t:n,parent:i};}function __PRIVATE_convertQueryTargetToQuery(e){var t=__PRIVATE_fromQueryPath(e.parent);var n=e.structuredQuery,r=n.from?n.from.length:0;var i=null;if(r>0){__PRIVATE_hardAssert(1===r);var _e39=n.from[0];_e39.allDescendants?i=_e39.collectionId:t=t.child(_e39.collectionId);}var s=[];n.where&&(s=function __PRIVATE_fromFilters(e){var t=__PRIVATE_fromFilter(e);if(t instanceof CompositeFilter&&__PRIVATE_compositeFilterIsFlatConjunction(t))return t.getFilters();return [t];}(n.where));var o=[];n.orderBy&&(o=function __PRIVATE_fromOrder(e){return e.map(function(e){return function __PRIVATE_fromPropertyOrder(e){return new OrderBy(__PRIVATE_fromFieldPathReference(e.field),// visible for testing
function __PRIVATE_fromDirection(e){switch(e){case"ASCENDING":return "asc"/* Direction.ASCENDING */;case"DESCENDING":return "desc"/* Direction.DESCENDING */;default:return;}}// visible for testing
(e.direction));}// visible for testing
(e);});}(n.orderBy));var _=null;n.limit&&(_=function __PRIVATE_fromInt32Proto(e){var t;return t="object"==_typeof(e)?e.value:e,__PRIVATE_isNullOrUndefined(t)?null:t;}(n.limit));var a=null;n.startAt&&(a=function __PRIVATE_fromStartAtCursor(e){var t=!!e.before,n=e.values||[];return new Bound(n,t);}(n.startAt));var u=null;return n.endAt&&(u=function __PRIVATE_fromEndAtCursor(e){var t=!e.before,n=e.values||[];return new Bound(n,t);}// visible for testing
(n.endAt)),__PRIVATE_newQuery(t,i,o,s,_,"F"/* LimitType.First */,a,u);}function __PRIVATE_toListenRequestLabels(e,t){var n=function __PRIVATE_toLabel(e){switch(e){case"TargetPurposeListen"/* TargetPurpose.Listen */:return null;case"TargetPurposeExistenceFilterMismatch"/* TargetPurpose.ExistenceFilterMismatch */:return "existence-filter-mismatch";case"TargetPurposeExistenceFilterMismatchBloom"/* TargetPurpose.ExistenceFilterMismatchBloom */:return "existence-filter-mismatch-bloom";case"TargetPurposeLimboResolution"/* TargetPurpose.LimboResolution */:return "limbo-document";default:return fail();}}(t.purpose);return null==n?null:{"goog-listen-tags":n};}function __PRIVATE_fromFilter(e){return void 0!==e.unaryFilter?function __PRIVATE_fromUnaryFilter(e){switch(e.unaryFilter.op){case"IS_NAN":var t=__PRIVATE_fromFieldPathReference(e.unaryFilter.field);return FieldFilter.create(t,"=="/* Operator.EQUAL */,{doubleValue:NaN});case"IS_NULL":var n=__PRIVATE_fromFieldPathReference(e.unaryFilter.field);return FieldFilter.create(n,"=="/* Operator.EQUAL */,{nullValue:"NULL_VALUE"});case"IS_NOT_NAN":var r=__PRIVATE_fromFieldPathReference(e.unaryFilter.field);return FieldFilter.create(r,"!="/* Operator.NOT_EQUAL */,{doubleValue:NaN});case"IS_NOT_NULL":var i=__PRIVATE_fromFieldPathReference(e.unaryFilter.field);return FieldFilter.create(i,"!="/* Operator.NOT_EQUAL */,{nullValue:"NULL_VALUE"});default:return fail();}}(e):void 0!==e.fieldFilter?function __PRIVATE_fromFieldFilter(e){return FieldFilter.create(__PRIVATE_fromFieldPathReference(e.fieldFilter.field),function __PRIVATE_fromOperatorName(e){switch(e){case"EQUAL":return "=="/* Operator.EQUAL */;case"NOT_EQUAL":return "!="/* Operator.NOT_EQUAL */;case"GREATER_THAN":return ">"/* Operator.GREATER_THAN */;case"GREATER_THAN_OR_EQUAL":return ">="/* Operator.GREATER_THAN_OR_EQUAL */;case"LESS_THAN":return "<"/* Operator.LESS_THAN */;case"LESS_THAN_OR_EQUAL":return "<="/* Operator.LESS_THAN_OR_EQUAL */;case"ARRAY_CONTAINS":return "array-contains"/* Operator.ARRAY_CONTAINS */;case"IN":return "in"/* Operator.IN */;case"NOT_IN":return "not-in"/* Operator.NOT_IN */;case"ARRAY_CONTAINS_ANY":return "array-contains-any"/* Operator.ARRAY_CONTAINS_ANY */;default:return fail();}}(e.fieldFilter.op),e.fieldFilter.value);}(e):void 0!==e.compositeFilter?function __PRIVATE_fromCompositeFilter(e){return CompositeFilter.create(e.compositeFilter.filters.map(function(e){return __PRIVATE_fromFilter(e);}),function __PRIVATE_fromCompositeOperatorName(e){switch(e){case"AND":return "and"/* CompositeOperator.AND */;case"OR":return "or"/* CompositeOperator.OR */;default:return fail();}}(e.compositeFilter.op));}(e):fail();}function __PRIVATE_toDirection(e){return Ie[e];}function __PRIVATE_toOperatorName(e){return Te[e];}function __PRIVATE_toCompositeOperatorName(e){return Ee[e];}function __PRIVATE_toFieldPathReference(e){return {fieldPath:e.canonicalString()};}function __PRIVATE_fromFieldPathReference(e){return FieldPath$1.fromServerFormat(e.fieldPath);}function __PRIVATE_toFilter(e){return e instanceof FieldFilter?function __PRIVATE_toUnaryOrFieldFilter(e){if("=="/* Operator.EQUAL */===e.op){if(__PRIVATE_isNanValue(e.value))return {unaryFilter:{field:__PRIVATE_toFieldPathReference(e.field),op:"IS_NAN"}};if(__PRIVATE_isNullValue(e.value))return {unaryFilter:{field:__PRIVATE_toFieldPathReference(e.field),op:"IS_NULL"}};}else if("!="/* Operator.NOT_EQUAL */===e.op){if(__PRIVATE_isNanValue(e.value))return {unaryFilter:{field:__PRIVATE_toFieldPathReference(e.field),op:"IS_NOT_NAN"}};if(__PRIVATE_isNullValue(e.value))return {unaryFilter:{field:__PRIVATE_toFieldPathReference(e.field),op:"IS_NOT_NULL"}};}return {fieldFilter:{field:__PRIVATE_toFieldPathReference(e.field),op:__PRIVATE_toOperatorName(e.op),value:e.value}};}(e):e instanceof CompositeFilter?function __PRIVATE_toCompositeFilter(e){var t=e.getFilters().map(function(e){return __PRIVATE_toFilter(e);});if(1===t.length)return t[0];return {compositeFilter:{op:__PRIVATE_toCompositeOperatorName(e.op),filters:t}};}(e):fail();}function __PRIVATE_toDocumentMask(e){var t=[];return e.fields.forEach(function(e){return t.push(e.canonicalString());}),{fieldPaths:t};}function __PRIVATE_isValidResourceName(e){// Resource names have at least 4 components (project ID, database ID)
return e.length>=4&&"projects"===e.get(0)&&"databases"===e.get(2);}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */var TargetData=/*#__PURE__*/function(){function TargetData(/** The target being listened to. */e,/**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */t,/** The purpose of the target. */n,/**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */r){var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:SnapshotVersion.min();var s=arguments.length>5&&arguments[5]!==undefined?arguments[5]:SnapshotVersion.min();var o=arguments.length>6&&arguments[6]!==undefined?arguments[6]:ByteString.EMPTY_BYTE_STRING;var _=arguments.length>7&&arguments[7]!==undefined?arguments[7]:null;_classCallCheck(this,TargetData);this.target=e,this.targetId=t,this.purpose=n,this.sequenceNumber=r,this.snapshotVersion=i,this.lastLimboFreeSnapshotVersion=s,this.resumeToken=o,this.expectedCount=_;}/** Creates a new target data instance with an updated sequence number. */_createClass(TargetData,[{key:"withSequenceNumber",value:function withSequenceNumber(e){return new TargetData(this.target,this.targetId,this.purpose,e,this.snapshotVersion,this.lastLimboFreeSnapshotVersion,this.resumeToken,this.expectedCount);}/**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */},{key:"withResumeToken",value:function withResumeToken(e,t){return new TargetData(this.target,this.targetId,this.purpose,this.sequenceNumber,t,this.lastLimboFreeSnapshotVersion,e,/* expectedCount= */null);}/**
     * Creates a new target data instance with an updated expected count.
     */},{key:"withExpectedCount",value:function withExpectedCount(e){return new TargetData(this.target,this.targetId,this.purpose,this.sequenceNumber,this.snapshotVersion,this.lastLimboFreeSnapshotVersion,this.resumeToken,e);}/**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */},{key:"withLastLimboFreeSnapshotVersion",value:function withLastLimboFreeSnapshotVersion(e){return new TargetData(this.target,this.targetId,this.purpose,this.sequenceNumber,this.snapshotVersion,e,this.resumeToken,this.expectedCount);}}]);return TargetData;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */var __PRIVATE_LocalSerializer=/*#__PURE__*/_createClass(function __PRIVATE_LocalSerializer(e){_classCallCheck(this,__PRIVATE_LocalSerializer);this.ct=e;});/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */function __PRIVATE_fromBundledQuery(e){var t=__PRIVATE_convertQueryTargetToQuery({parent:e.parent,structuredQuery:e.structuredQuery});return "LAST"===e.limitType?__PRIVATE_queryWithLimit(t,t.limit,"L"/* LimitType.Last */):t;}// Firestore was removed.
/** Firestore index value writer.  */var __PRIVATE_FirestoreIndexValueWriter=/*#__PURE__*/function(){function __PRIVATE_FirestoreIndexValueWriter(){_classCallCheck(this,__PRIVATE_FirestoreIndexValueWriter);}// The write methods below short-circuit writing terminators for values
// containing a (terminating) truncated value.
// As an example, consider the resulting encoding for:
// ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
// ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
// ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
/** Writes an index value.  */_createClass(__PRIVATE_FirestoreIndexValueWriter,[{key:"Pt",value:function Pt(e,t){this.It(e,t),// Write separator to split index values
// (see go/firestore-storage-format#encodings).
t.Tt();}},{key:"It",value:function It(e,t){if("nullValue"in e)this.Et(t,5);else if("booleanValue"in e)this.Et(t,10),t.dt(e.booleanValue?1:0);else if("integerValue"in e)this.Et(t,15),t.dt(__PRIVATE_normalizeNumber(e.integerValue));else if("doubleValue"in e){var n=__PRIVATE_normalizeNumber(e.doubleValue);isNaN(n)?this.Et(t,13):(this.Et(t,15),__PRIVATE_isNegativeZero(n)?// -0.0, 0 and 0.0 are all considered the same
t.dt(0):t.dt(n));}else if("timestampValue"in e){var _n13=e.timestampValue;this.Et(t,20),"string"==typeof _n13&&(_n13=__PRIVATE_normalizeTimestamp(_n13)),t.At("".concat(_n13.seconds||"")),t.dt(_n13.nanos||0);}else if("stringValue"in e)this.Rt(e.stringValue,t),this.Vt(t);else if("bytesValue"in e)this.Et(t,30),t.ft(__PRIVATE_normalizeByteString(e.bytesValue)),this.Vt(t);else if("referenceValue"in e)this.gt(e.referenceValue,t);else if("geoPointValue"in e){var _n14=e.geoPointValue;this.Et(t,45),t.dt(_n14.latitude||0),t.dt(_n14.longitude||0);}else "mapValue"in e?__PRIVATE_isMaxValue(e)?this.Et(t,Number.MAX_SAFE_INTEGER):(this.yt(e.mapValue,t),this.Vt(t)):"arrayValue"in e?(this.wt(e.arrayValue,t),this.Vt(t)):fail();}},{key:"Rt",value:function Rt(e,t){this.Et(t,25),this.St(e,t);}},{key:"St",value:function St(e,t){t.At(e);}},{key:"yt",value:function yt(e,t){var n=e.fields||{};this.Et(t,55);for(var _i9=0,_Object$keys=Object.keys(n);_i9<_Object$keys.length;_i9++){var _e44=_Object$keys[_i9];this.Rt(_e44,t),this.It(n[_e44],t);}}},{key:"wt",value:function wt(e,t){var n=e.values||[];this.Et(t,50);var _iterator28=_createForOfIteratorHelper(n),_step28;try{for(_iterator28.s();!(_step28=_iterator28.n()).done;){var _e45=_step28.value;this.It(_e45,t);}}catch(err){_iterator28.e(err);}finally{_iterator28.f();}}},{key:"gt",value:function gt(e,t){var _this52=this;this.Et(t,37);DocumentKey.fromName(e).path.forEach(function(e){_this52.Et(t,60),_this52.St(e,t);});}},{key:"Et",value:function Et(e,t){e.dt(t);}},{key:"Vt",value:function Vt(e){// While the SDK does not implement truncation, the truncation marker is
// used to terminate all variable length values (which are strings, bytes,
// references, arrays and maps).
e.dt(2);}}]);return __PRIVATE_FirestoreIndexValueWriter;}();__PRIVATE_FirestoreIndexValueWriter.bt=new __PRIVATE_FirestoreIndexValueWriter();/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */var __PRIVATE_MemoryIndexManager=/*#__PURE__*/function(){function __PRIVATE_MemoryIndexManager(){_classCallCheck(this,__PRIVATE_MemoryIndexManager);this._n=new __PRIVATE_MemoryCollectionParentIndex();}_createClass(__PRIVATE_MemoryIndexManager,[{key:"addToCollectionParentIndex",value:function addToCollectionParentIndex(e,t){return this._n.add(t),PersistencePromise.resolve();}},{key:"getCollectionParents",value:function getCollectionParents(e,t){return PersistencePromise.resolve(this._n.getEntries(t));}},{key:"addFieldIndex",value:function addFieldIndex(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}},{key:"deleteFieldIndex",value:function deleteFieldIndex(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}},{key:"deleteAllFieldIndexes",value:function deleteAllFieldIndexes(e){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}},{key:"createTargetIndexes",value:function createTargetIndexes(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}},{key:"getDocumentsMatchingTarget",value:function getDocumentsMatchingTarget(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve(null);}},{key:"getIndexType",value:function getIndexType(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve(0/* IndexType.NONE */);}},{key:"getFieldIndexes",value:function getFieldIndexes(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve([]);}},{key:"getNextCollectionGroupToUpdate",value:function getNextCollectionGroupToUpdate(e){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve(null);}},{key:"getMinOffset",value:function getMinOffset(e,t){return PersistencePromise.resolve(IndexOffset.min());}},{key:"getMinOffsetFromCollectionGroup",value:function getMinOffsetFromCollectionGroup(e,t){return PersistencePromise.resolve(IndexOffset.min());}},{key:"updateCollectionGroup",value:function updateCollectionGroup(e,t,n){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}},{key:"updateIndexEntries",value:function updateIndexEntries(e,t){// Field indices are not supported with memory persistence.
return PersistencePromise.resolve();}}]);return __PRIVATE_MemoryIndexManager;}();/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */var __PRIVATE_MemoryCollectionParentIndex=/*#__PURE__*/function(){function __PRIVATE_MemoryCollectionParentIndex(){_classCallCheck(this,__PRIVATE_MemoryCollectionParentIndex);this.index={};}// Returns false if the entry already existed.
_createClass(__PRIVATE_MemoryCollectionParentIndex,[{key:"add",value:function add(e){var t=e.lastSegment(),n=e.popLast(),r=this.index[t]||new SortedSet(ResourcePath.comparator),i=!r.has(n);return this.index[t]=r.add(n),i;}},{key:"has",value:function has(e){var t=e.lastSegment(),n=e.popLast(),r=this.index[t];return r&&r.has(n);}},{key:"getEntries",value:function getEntries(e){return (this.index[e]||new SortedSet(ResourcePath.comparator)).toArray();}}]);return __PRIVATE_MemoryCollectionParentIndex;}();var LruParams=/*#__PURE__*/function(){function LruParams(// When we attempt to collect, we will only do so if the cache size is greater than this
// threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
e,// The percentage of sequence numbers that we will attempt to collect
t,// A cap on the total number of sequence numbers that will be collected. This prevents
// us from collecting a huge number of sequence numbers if the cache has grown very large.
n){_classCallCheck(this,LruParams);this.cacheSizeCollectionThreshold=e,this.percentileToCollect=t,this.maximumSequenceNumbersToCollect=n;}_createClass(LruParams,null,[{key:"withCacheSize",value:function withCacheSize(e){return new LruParams(e,LruParams.DEFAULT_COLLECTION_PERCENTILE,LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);}}]);return LruParams;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */LruParams.DEFAULT_COLLECTION_PERCENTILE=10,LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT=1e3,LruParams.DEFAULT=new LruParams(41943040,LruParams.DEFAULT_COLLECTION_PERCENTILE,LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT),LruParams.DISABLED=new LruParams(-1,0,0);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */var __PRIVATE_TargetIdGenerator=/*#__PURE__*/function(){function __PRIVATE_TargetIdGenerator(e){_classCallCheck(this,__PRIVATE_TargetIdGenerator);this.On=e;}_createClass(__PRIVATE_TargetIdGenerator,[{key:"next",value:function next(){return this.On+=2,this.On;}}],[{key:"Nn",value:function Nn(){// The target cache generator must return '2' in its first call to `next()`
// as there is no differentiation in the protocol layer between an unset
// number and the number '0'. If we were to sent a target with target ID
// '0', the backend would consider it unset and replace it with its own ID.
return new __PRIVATE_TargetIdGenerator(0);}},{key:"Ln",value:function Ln(){// Sync engine assigns target IDs for limbo document detection.
return new __PRIVATE_TargetIdGenerator(-1);}}]);return __PRIVATE_TargetIdGenerator;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */var RemoteDocumentChangeBuffer=/*#__PURE__*/function(){function RemoteDocumentChangeBuffer(){_classCallCheck(this,RemoteDocumentChangeBuffer);// A mapping of document key to the new cache entry that should be written.
this.changes=new ObjectMap(function(e){return e.toString();},function(e,t){return e.isEqual(t);}),this.changesApplied=!1;}/**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */_createClass(RemoteDocumentChangeBuffer,[{key:"addEntry",value:function addEntry(e){this.assertNotApplied(),this.changes.set(e.key,e);}/**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */},{key:"removeEntry",value:function removeEntry(e,t){this.assertNotApplied(),this.changes.set(e,MutableDocument.newInvalidDocument(e).setReadTime(t));}/**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */},{key:"getEntry",value:function getEntry(e,t){this.assertNotApplied();var n=this.changes.get(t);return void 0!==n?PersistencePromise.resolve(n):this.getFromCache(e,t);}/**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */},{key:"getEntries",value:function getEntries(e,t){return this.getAllFromCache(e,t);}/**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */},{key:"apply",value:function apply(e){return this.assertNotApplied(),this.changesApplied=!0,this.applyChanges(e);}/** Helper to assert this.changes is not null  */},{key:"assertNotApplied",value:function assertNotApplied(){}}]);return RemoteDocumentChangeBuffer;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */var OverlayedDocument=/*#__PURE__*/_createClass(function OverlayedDocument(e,/**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */t){_classCallCheck(this,OverlayedDocument);this.overlayedDocument=e,this.mutatedFields=t;});/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */var LocalDocumentsView=/*#__PURE__*/function(){function LocalDocumentsView(e,t,n,r){_classCallCheck(this,LocalDocumentsView);this.remoteDocumentCache=e,this.mutationQueue=t,this.documentOverlayCache=n,this.indexManager=r;}/**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */_createClass(LocalDocumentsView,[{key:"getDocument",value:function getDocument(e,t){var _this99=this;var n=null;return this.documentOverlayCache.getOverlay(e,t).next(function(r){return n=r,_this99.remoteDocumentCache.getEntry(e,t);}).next(function(e){return null!==n&&__PRIVATE_mutationApplyToLocalView(n.mutation,e,FieldMask.empty(),Timestamp.now()),e;});}/**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */},{key:"getDocuments",value:function getDocuments(e,t){var _this100=this;return this.remoteDocumentCache.getEntries(e,t).next(function(t){return _this100.getLocalViewOfDocuments(e,t,__PRIVATE_documentKeySet()).next(function(){return t;});});}/**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */},{key:"getLocalViewOfDocuments",value:function getLocalViewOfDocuments(e,t){var _this101=this;var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__PRIVATE_documentKeySet();var r=__PRIVATE_newOverlayMap();return this.populateOverlays(e,r,t).next(function(){return _this101.computeViews(e,t,r,n).next(function(e){var t=documentMap();return e.forEach(function(e,n){t=t.insert(e,n.overlayedDocument);}),t;});});}/**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */},{key:"getOverlayedDocuments",value:function getOverlayedDocuments(e,t){var _this102=this;var n=__PRIVATE_newOverlayMap();return this.populateOverlays(e,n,t).next(function(){return _this102.computeViews(e,t,n,__PRIVATE_documentKeySet());});}/**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */},{key:"populateOverlays",value:function populateOverlays(e,t,n){var r=[];return n.forEach(function(e){t.has(e)||r.push(e);}),this.documentOverlayCache.getOverlays(e,r).next(function(e){e.forEach(function(e,n){t.set(e,n);});});}/**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */},{key:"computeViews",value:function computeViews(e,t,n,r){var i=__PRIVATE_mutableDocumentMap();var s=__PRIVATE_newDocumentKeyMap(),o=function __PRIVATE_newOverlayedDocumentMap(){return __PRIVATE_newDocumentKeyMap();}();return t.forEach(function(e,t){var o=n.get(t.key);// Recalculate an overlay if the document's existence state changed due to
// a remote event *and* the overlay is a PatchMutation. This is because
// document existence state can change if some patch mutation's
// preconditions are met.
// NOTE: we recalculate when `overlay` is undefined as well, because there
// might be a patch mutation whose precondition does not match before the
// change (hence overlay is undefined), but would now match.
r.has(t.key)&&(void 0===o||o.mutation instanceof __PRIVATE_PatchMutation)?i=i.insert(t.key,t):void 0!==o?(s.set(t.key,o.mutation.getFieldMask()),__PRIVATE_mutationApplyToLocalView(o.mutation,t,o.mutation.getFieldMask(),Timestamp.now())):// no overlay exists
// Using EMPTY to indicate there is no overlay for the document.
s.set(t.key,FieldMask.empty());}),this.recalculateAndSaveOverlays(e,i).next(function(e){return e.forEach(function(e,t){return s.set(e,t);}),t.forEach(function(e,t){var n;return o.set(e,new OverlayedDocument(t,null!==(n=s.get(e))&&void 0!==n?n:null));}),o;});}},{key:"recalculateAndSaveOverlays",value:function recalculateAndSaveOverlays(e,t){var _this103=this;var n=__PRIVATE_newDocumentKeyMap();// A reverse lookup map from batch id to the documents within that batch.
var r=new SortedMap(function(e,t){return e-t;}),i=__PRIVATE_documentKeySet();return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e,t).next(function(e){var _iterator56=_createForOfIteratorHelper(e),_step56;try{var _loop6=function _loop6(){var i=_step56.value;i.keys().forEach(function(e){var s=t.get(e);if(null===s)return;var o=n.get(e)||FieldMask.empty();o=i.applyToLocalView(s,o),n.set(e,o);var _=(r.get(i.batchId)||__PRIVATE_documentKeySet()).add(e);r=r.insert(i.batchId,_);});};for(_iterator56.s();!(_step56=_iterator56.n()).done;){_loop6();}}catch(err){_iterator56.e(err);}finally{_iterator56.f();}}).next(function(){var s=[],o=r.getReverseIterator();// Iterate in descending order of batch IDs, and skip documents that are
// already saved.
var _loop7=function _loop7(){var r=o.getNext(),_=r.key,a=r.value,u=__PRIVATE_newMutationMap();a.forEach(function(e){if(!i.has(e)){var _r20=__PRIVATE_calculateOverlayMutation(t.get(e),n.get(e));null!==_r20&&u.set(e,_r20),i=i.add(e);}}),s.push(_this103.documentOverlayCache.saveOverlays(e,_,u));};for(;o.hasNext();){_loop7();}return PersistencePromise.waitFor(s);}).next(function(){return n;});}/**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */},{key:"recalculateAndSaveOverlaysForDocumentKeys",value:function recalculateAndSaveOverlaysForDocumentKeys(e,t){var _this104=this;return this.remoteDocumentCache.getEntries(e,t).next(function(t){return _this104.recalculateAndSaveOverlays(e,t);});}/**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */},{key:"getDocumentsMatchingQuery",value:function getDocumentsMatchingQuery(e,t,n,r){/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */return function __PRIVATE_isDocumentQuery$1(e){return DocumentKey.isDocumentKey(e.path)&&null===e.collectionGroup&&0===e.filters.length;}(t)?this.getDocumentsMatchingDocumentQuery(e,t.path):__PRIVATE_isCollectionGroupQuery(t)?this.getDocumentsMatchingCollectionGroupQuery(e,t,n,r):this.getDocumentsMatchingCollectionQuery(e,t,n,r);}/**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */},{key:"getNextDocuments",value:function getNextDocuments(e,t,n,r){var _this105=this;return this.remoteDocumentCache.getAllFromCollectionGroup(e,t,n,r).next(function(i){var s=r-i.size>0?_this105.documentOverlayCache.getOverlaysForCollectionGroup(e,t,n.largestBatchId,r-i.size):PersistencePromise.resolve(__PRIVATE_newOverlayMap());// The callsite will use the largest batch ID together with the latest read time to create
// a new index offset. Since we only process batch IDs if all remote documents have been read,
// no overlay will increase the overall read time. This is why we only need to special case
// the batch id.
var o=-1,_=i;return s.next(function(t){return PersistencePromise.forEach(t,function(t,n){return o<n.largestBatchId&&(o=n.largestBatchId),i.get(t)?PersistencePromise.resolve():_this105.remoteDocumentCache.getEntry(e,t).next(function(e){_=_.insert(t,e);});}).next(function(){return _this105.populateOverlays(e,t,i);}).next(function(){return _this105.computeViews(e,_,t,__PRIVATE_documentKeySet());}).next(function(e){return {batchId:o,changes:__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)};});});});}},{key:"getDocumentsMatchingDocumentQuery",value:function getDocumentsMatchingDocumentQuery(e,t){// Just do a simple document lookup.
return this.getDocument(e,new DocumentKey(t)).next(function(e){var t=documentMap();return e.isFoundDocument()&&(t=t.insert(e.key,e)),t;});}},{key:"getDocumentsMatchingCollectionGroupQuery",value:function getDocumentsMatchingCollectionGroupQuery(e,t,n,r){var _this106=this;var i=t.collectionGroup;var s=documentMap();return this.indexManager.getCollectionParents(e,i).next(function(o){return PersistencePromise.forEach(o,function(o){var _=function __PRIVATE_asCollectionQueryAtPath(e,t){return new __PRIVATE_QueryImpl(t,/*collectionGroup=*/null,e.explicitOrderBy.slice(),e.filters.slice(),e.limit,e.limitType,e.startAt,e.endAt);}(t,o.child(i));return _this106.getDocumentsMatchingCollectionQuery(e,_,n,r).next(function(e){e.forEach(function(e,t){s=s.insert(e,t);});});}).next(function(){return s;});});}},{key:"getDocumentsMatchingCollectionQuery",value:function getDocumentsMatchingCollectionQuery(e,t,n,r){var _this107=this;// Query the remote documents and overlay mutations.
var i;return this.documentOverlayCache.getOverlaysForCollection(e,t.path,n.largestBatchId).next(function(s){return i=s,_this107.remoteDocumentCache.getDocumentsMatchingQuery(e,t,n,i,r);}).next(function(e){// As documents might match the query because of their overlay we need to
// include documents for all overlays in the initial document set.
i.forEach(function(t,n){var r=n.getKey();null===e.get(r)&&(e=e.insert(r,MutableDocument.newInvalidDocument(r)));});// Apply the overlays and match against the query.
var n=documentMap();return e.forEach(function(e,r){var s=i.get(e);void 0!==s&&__PRIVATE_mutationApplyToLocalView(s.mutation,r,FieldMask.empty(),Timestamp.now()),// Finally, insert the documents that still match the query
__PRIVATE_queryMatches(t,r)&&(n=n.insert(e,r));}),n;});}}]);return LocalDocumentsView;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_MemoryBundleCache=/*#__PURE__*/function(){function __PRIVATE_MemoryBundleCache(e){_classCallCheck(this,__PRIVATE_MemoryBundleCache);this.serializer=e,this.cr=new Map(),this.lr=new Map();}_createClass(__PRIVATE_MemoryBundleCache,[{key:"getBundleMetadata",value:function getBundleMetadata(e,t){return PersistencePromise.resolve(this.cr.get(t));}},{key:"saveBundleMetadata",value:function saveBundleMetadata(e,t){return this.cr.set(t.id,/** Decodes a BundleMetadata proto into a BundleMetadata object. */function __PRIVATE_fromBundleMetadata(e){return {id:e.id,version:e.version,createTime:__PRIVATE_fromVersion(e.createTime)};}(t)),PersistencePromise.resolve();}},{key:"getNamedQuery",value:function getNamedQuery(e,t){return PersistencePromise.resolve(this.lr.get(t));}},{key:"saveNamedQuery",value:function saveNamedQuery(e,t){return this.lr.set(t.name,function __PRIVATE_fromProtoNamedQuery(e){return {name:e.name,query:__PRIVATE_fromBundledQuery(e.bundledQuery),readTime:__PRIVATE_fromVersion(e.readTime)};}(t)),PersistencePromise.resolve();}}]);return __PRIVATE_MemoryBundleCache;}();/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */var __PRIVATE_MemoryDocumentOverlayCache=/*#__PURE__*/function(){function __PRIVATE_MemoryDocumentOverlayCache(){_classCallCheck(this,__PRIVATE_MemoryDocumentOverlayCache);// A map sorted by DocumentKey, whose value is a pair of the largest batch id
// for the overlay and the overlay itself.
this.overlays=new SortedMap(DocumentKey.comparator),this.hr=new Map();}_createClass(__PRIVATE_MemoryDocumentOverlayCache,[{key:"getOverlay",value:function getOverlay(e,t){return PersistencePromise.resolve(this.overlays.get(t));}},{key:"getOverlays",value:function getOverlays(e,t){var _this108=this;var n=__PRIVATE_newOverlayMap();return PersistencePromise.forEach(t,function(t){return _this108.getOverlay(e,t).next(function(e){null!==e&&n.set(t,e);});}).next(function(){return n;});}},{key:"saveOverlays",value:function saveOverlays(e,t,n){var _this109=this;return n.forEach(function(n,r){_this109.ht(e,t,r);}),PersistencePromise.resolve();}},{key:"removeOverlaysForBatchId",value:function removeOverlaysForBatchId(e,t,n){var _this110=this;var r=this.hr.get(n);return void 0!==r&&(r.forEach(function(e){return _this110.overlays=_this110.overlays.remove(e);}),this.hr["delete"](n)),PersistencePromise.resolve();}},{key:"getOverlaysForCollection",value:function getOverlaysForCollection(e,t,n){var r=__PRIVATE_newOverlayMap(),i=t.length+1,s=new DocumentKey(t.child("")),o=this.overlays.getIteratorFrom(s);for(;o.hasNext();){var _e72=o.getNext().value,_s5=_e72.getKey();if(!t.isPrefixOf(_s5.path))break;// Documents from sub-collections
_s5.path.length===i&&_e72.largestBatchId>n&&r.set(_e72.getKey(),_e72);}return PersistencePromise.resolve(r);}},{key:"getOverlaysForCollectionGroup",value:function getOverlaysForCollectionGroup(e,t,n,r){var i=new SortedMap(function(e,t){return e-t;});var s=this.overlays.getIterator();for(;s.hasNext();){var _e73=s.getNext().value;if(_e73.getKey().getCollectionGroup()===t&&_e73.largestBatchId>n){var _t36=i.get(_e73.largestBatchId);null===_t36&&(_t36=__PRIVATE_newOverlayMap(),i=i.insert(_e73.largestBatchId,_t36)),_t36.set(_e73.getKey(),_e73);}}var o=__PRIVATE_newOverlayMap(),_=i.getIterator();for(;_.hasNext();){if(_.getNext().value.forEach(function(e,t){return o.set(e,t);}),o.size()>=r)break;}return PersistencePromise.resolve(o);}},{key:"ht",value:function ht(e,t,n){// Remove the association of the overlay to its batch id.
var r=this.overlays.get(n.key);if(null!==r){var _e74=this.hr.get(r.largestBatchId)["delete"](n.key);this.hr.set(r.largestBatchId,_e74);}this.overlays=this.overlays.insert(n.key,new Overlay(t,n));// Create the association of this overlay to the given largestBatchId.
var i=this.hr.get(t);void 0===i&&(i=__PRIVATE_documentKeySet(),this.hr.set(t,i)),this.hr.set(t,i.add(n.key));}}]);return __PRIVATE_MemoryDocumentOverlayCache;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */var __PRIVATE_ReferenceSet=/*#__PURE__*/function(){function __PRIVATE_ReferenceSet(){_classCallCheck(this,__PRIVATE_ReferenceSet);// A set of outstanding references to a document sorted by key.
this.Pr=new SortedSet(__PRIVATE_DocReference.Ir),// A set of outstanding references to a document sorted by target id.
this.Tr=new SortedSet(__PRIVATE_DocReference.Er);}/** Returns true if the reference set contains no references. */_createClass(__PRIVATE_ReferenceSet,[{key:"isEmpty",value:function isEmpty(){return this.Pr.isEmpty();}/** Adds a reference to the given document key for the given ID. */},{key:"addReference",value:function addReference(e,t){var n=new __PRIVATE_DocReference(e,t);this.Pr=this.Pr.add(n),this.Tr=this.Tr.add(n);}/** Add references to the given document keys for the given ID. */},{key:"dr",value:function dr(e,t){var _this111=this;e.forEach(function(e){return _this111.addReference(e,t);});}/**
     * Removes a reference to the given document key for the given
     * ID.
     */},{key:"removeReference",value:function removeReference(e,t){this.Ar(new __PRIVATE_DocReference(e,t));}},{key:"Rr",value:function Rr(e,t){var _this112=this;e.forEach(function(e){return _this112.removeReference(e,t);});}/**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */},{key:"Vr",value:function Vr(e){var _this113=this;var t=new DocumentKey(new ResourcePath([])),n=new __PRIVATE_DocReference(t,e),r=new __PRIVATE_DocReference(t,e+1),i=[];return this.Tr.forEachInRange([n,r],function(e){_this113.Ar(e),i.push(e.key);}),i;}},{key:"mr",value:function mr(){var _this114=this;this.Pr.forEach(function(e){return _this114.Ar(e);});}},{key:"Ar",value:function Ar(e){this.Pr=this.Pr["delete"](e),this.Tr=this.Tr["delete"](e);}},{key:"gr",value:function gr(e){var t=new DocumentKey(new ResourcePath([])),n=new __PRIVATE_DocReference(t,e),r=new __PRIVATE_DocReference(t,e+1);var i=__PRIVATE_documentKeySet();return this.Tr.forEachInRange([n,r],function(e){i=i.add(e.key);}),i;}},{key:"containsKey",value:function containsKey(e){var t=new __PRIVATE_DocReference(e,0),n=this.Pr.firstAfterOrEqual(t);return null!==n&&e.isEqual(n.key);}}]);return __PRIVATE_ReferenceSet;}();var __PRIVATE_DocReference=/*#__PURE__*/function(){function __PRIVATE_DocReference(e,t){_classCallCheck(this,__PRIVATE_DocReference);this.key=e,this.pr=t;}/** Compare by key then by ID */_createClass(__PRIVATE_DocReference,null,[{key:"Ir",value:function Ir(e,t){return DocumentKey.comparator(e.key,t.key)||__PRIVATE_primitiveComparator(e.pr,t.pr);}/** Compare by ID then by key */},{key:"Er",value:function Er(e,t){return __PRIVATE_primitiveComparator(e.pr,t.pr)||DocumentKey.comparator(e.key,t.key);}}]);return __PRIVATE_DocReference;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_MemoryMutationQueue=/*#__PURE__*/function(){function __PRIVATE_MemoryMutationQueue(e,t){_classCallCheck(this,__PRIVATE_MemoryMutationQueue);this.indexManager=e,this.referenceDelegate=t,/**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */this.mutationQueue=[],/** Next value to use when assigning sequential IDs to each mutation batch. */this.yr=1,/** An ordered mapping between documents and the mutations batch IDs. */this.wr=new SortedSet(__PRIVATE_DocReference.Ir);}_createClass(__PRIVATE_MemoryMutationQueue,[{key:"checkEmpty",value:function checkEmpty(e){return PersistencePromise.resolve(0===this.mutationQueue.length);}},{key:"addMutationBatch",value:function addMutationBatch(e,t,n,r){var i=this.yr;this.yr++,this.mutationQueue.length>0&&this.mutationQueue[this.mutationQueue.length-1];var s=new MutationBatch(i,t,n,r);this.mutationQueue.push(s);// Track references by document key and index collection parents.
var _iterator57=_createForOfIteratorHelper(r),_step57;try{for(_iterator57.s();!(_step57=_iterator57.n()).done;){var _t37=_step57.value;this.wr=this.wr.add(new __PRIVATE_DocReference(_t37.key,i)),this.indexManager.addToCollectionParentIndex(e,_t37.key.path.popLast());}}catch(err){_iterator57.e(err);}finally{_iterator57.f();}return PersistencePromise.resolve(s);}},{key:"lookupMutationBatch",value:function lookupMutationBatch(e,t){return PersistencePromise.resolve(this.Sr(t));}},{key:"getNextMutationBatchAfterBatchId",value:function getNextMutationBatchAfterBatchId(e,t){var n=t+1,r=this.br(n),i=r<0?0:r;// The requested batchId may still be out of range so normalize it to the
// start of the queue.
return PersistencePromise.resolve(this.mutationQueue.length>i?this.mutationQueue[i]:null);}},{key:"getHighestUnacknowledgedBatchId",value:function getHighestUnacknowledgedBatchId(){return PersistencePromise.resolve(0===this.mutationQueue.length?-1:this.yr-1);}},{key:"getAllMutationBatches",value:function getAllMutationBatches(e){return PersistencePromise.resolve(this.mutationQueue.slice());}},{key:"getAllMutationBatchesAffectingDocumentKey",value:function getAllMutationBatchesAffectingDocumentKey(e,t){var _this115=this;var n=new __PRIVATE_DocReference(t,0),r=new __PRIVATE_DocReference(t,Number.POSITIVE_INFINITY),i=[];return this.wr.forEachInRange([n,r],function(e){var t=_this115.Sr(e.pr);i.push(t);}),PersistencePromise.resolve(i);}},{key:"getAllMutationBatchesAffectingDocumentKeys",value:function getAllMutationBatchesAffectingDocumentKeys(e,t){var _this116=this;var n=new SortedSet(__PRIVATE_primitiveComparator);return t.forEach(function(e){var t=new __PRIVATE_DocReference(e,0),r=new __PRIVATE_DocReference(e,Number.POSITIVE_INFINITY);_this116.wr.forEachInRange([t,r],function(e){n=n.add(e.pr);});}),PersistencePromise.resolve(this.Dr(n));}},{key:"getAllMutationBatchesAffectingQuery",value:function getAllMutationBatchesAffectingQuery(e,t){// Use the query path as a prefix for testing if a document matches the
// query.
var n=t.path,r=n.length+1;// Construct a document reference for actually scanning the index. Unlike
// the prefix the document key in this reference must have an even number of
// segments. The empty segment can be used a suffix of the query path
// because it precedes all other segments in an ordered traversal.
var i=n;DocumentKey.isDocumentKey(i)||(i=i.child(""));var s=new __PRIVATE_DocReference(new DocumentKey(i),0);// Find unique batchIDs referenced by all documents potentially matching the
// query.
var o=new SortedSet(__PRIVATE_primitiveComparator);return this.wr.forEachWhile(function(e){var t=e.key.path;return !!n.isPrefixOf(t)&&(// Rows with document keys more than one segment longer than the query
// path can't be matches. For example, a query on 'rooms' can't match
// the document /rooms/abc/messages/xyx.
// TODO(mcg): we'll need a different scanner when we implement
// ancestor queries.
t.length===r&&(o=o.add(e.pr)),!0);},s),PersistencePromise.resolve(this.Dr(o));}},{key:"Dr",value:function Dr(e){var _this117=this;// Construct an array of matching batches, sorted by batchID to ensure that
// multiple mutations affecting the same document key are applied in order.
var t=[];return e.forEach(function(e){var n=_this117.Sr(e);null!==n&&t.push(n);}),t;}},{key:"removeMutationBatch",value:function removeMutationBatch(e,t){var _this118=this;__PRIVATE_hardAssert(0===this.Cr(t.batchId,"removed")),this.mutationQueue.shift();var n=this.wr;return PersistencePromise.forEach(t.mutations,function(r){var i=new __PRIVATE_DocReference(r.key,t.batchId);return n=n["delete"](i),_this118.referenceDelegate.markPotentiallyOrphaned(e,r.key);}).next(function(){_this118.wr=n;});}},{key:"Mn",value:function Mn(e){// No-op since the memory mutation queue does not maintain a separate cache.
}},{key:"containsKey",value:function containsKey(e,t){var n=new __PRIVATE_DocReference(t,0),r=this.wr.firstAfterOrEqual(n);return PersistencePromise.resolve(t.isEqual(r&&r.key));}},{key:"performConsistencyCheck",value:function performConsistencyCheck(e){return this.mutationQueue.length,PersistencePromise.resolve();}/**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */},{key:"Cr",value:function Cr(e,t){return this.br(e);}/**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */},{key:"br",value:function br(e){if(0===this.mutationQueue.length)// As an index this is past the end of the queue
return 0;// Examine the front of the queue to figure out the difference between the
// batchId and indexes in the array. Note that since the queue is ordered
// by batchId, if the first batch has a larger batchId then the requested
// batchId doesn't exist in the queue.
return e-this.mutationQueue[0].batchId;}/**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */},{key:"Sr",value:function Sr(e){var t=this.br(e);if(t<0||t>=this.mutationQueue.length)return null;return this.mutationQueue[t];}}]);return __PRIVATE_MemoryMutationQueue;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */var __PRIVATE_MemoryRemoteDocumentCacheImpl=/*#__PURE__*/function(){/**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */function __PRIVATE_MemoryRemoteDocumentCacheImpl(e){_classCallCheck(this,__PRIVATE_MemoryRemoteDocumentCacheImpl);this.vr=e,/** Underlying cache of documents and their read times. */this.docs=function __PRIVATE_documentEntryMap(){return new SortedMap(DocumentKey.comparator);}(),/** Size of all cached documents. */this.size=0;}_createClass(__PRIVATE_MemoryRemoteDocumentCacheImpl,[{key:"setIndexManager",value:function setIndexManager(e){this.indexManager=e;}/**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */},{key:"addEntry",value:function addEntry(e,t){var n=t.key,r=this.docs.get(n),i=r?r.size:0,s=this.vr(t);return this.docs=this.docs.insert(n,{document:t.mutableCopy(),size:s}),this.size+=s-i,this.indexManager.addToCollectionParentIndex(e,n.path.popLast());}/**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */},{key:"removeEntry",value:function removeEntry(e){var t=this.docs.get(e);t&&(this.docs=this.docs.remove(e),this.size-=t.size);}},{key:"getEntry",value:function getEntry(e,t){var n=this.docs.get(t);return PersistencePromise.resolve(n?n.document.mutableCopy():MutableDocument.newInvalidDocument(t));}},{key:"getEntries",value:function getEntries(e,t){var _this119=this;var n=__PRIVATE_mutableDocumentMap();return t.forEach(function(e){var t=_this119.docs.get(e);n=n.insert(e,t?t.document.mutableCopy():MutableDocument.newInvalidDocument(e));}),PersistencePromise.resolve(n);}},{key:"getDocumentsMatchingQuery",value:function getDocumentsMatchingQuery(e,t,n,r){var i=__PRIVATE_mutableDocumentMap();// Documents are ordered by key, so we can use a prefix scan to narrow down
// the documents we need to match the query against.
var s=t.path,o=new DocumentKey(s.child("")),_=this.docs.getIteratorFrom(o);for(;_.hasNext();){var _$getNext=_.getNext(),_e75=_$getNext.key,_o4=_$getNext.value.document;if(!s.isPrefixOf(_e75.path))break;_e75.path.length>s.length+1||__PRIVATE_indexOffsetComparator(__PRIVATE_newIndexOffsetFromDocument(_o4),n)<=0||(r.has(_o4.key)||__PRIVATE_queryMatches(t,_o4))&&(i=i.insert(_o4.key,_o4.mutableCopy()));}return PersistencePromise.resolve(i);}},{key:"getAllFromCollectionGroup",value:function getAllFromCollectionGroup(e,t,n,r){// This method should only be called from the IndexBackfiller if persistence
// is enabled.
fail();}},{key:"Fr",value:function Fr(e,t){return PersistencePromise.forEach(this.docs,function(e){return t(e);});}},{key:"newChangeBuffer",value:function newChangeBuffer(e){// `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
// a separate changelog and does not need special handling for removals.
return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);}},{key:"getSize",value:function getSize(e){return PersistencePromise.resolve(this.size);}}]);return __PRIVATE_MemoryRemoteDocumentCacheImpl;}();/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */var __PRIVATE_MemoryRemoteDocumentChangeBuffer=/*#__PURE__*/function(_RemoteDocumentChange2){_inherits(__PRIVATE_MemoryRemoteDocumentChangeBuffer,_RemoteDocumentChange2);var _super26=_createSuper(__PRIVATE_MemoryRemoteDocumentChangeBuffer);function __PRIVATE_MemoryRemoteDocumentChangeBuffer(e){var _this120;_classCallCheck(this,__PRIVATE_MemoryRemoteDocumentChangeBuffer);_this120=_super26.call(this),_this120.ar=e;return _this120;}_createClass(__PRIVATE_MemoryRemoteDocumentChangeBuffer,[{key:"applyChanges",value:function applyChanges(e){var _this121=this;var t=[];return this.changes.forEach(function(n,r){r.isValidDocument()?t.push(_this121.ar.addEntry(e,r)):_this121.ar.removeEntry(n);}),PersistencePromise.waitFor(t);}},{key:"getFromCache",value:function getFromCache(e,t){return this.ar.getEntry(e,t);}},{key:"getAllFromCache",value:function getAllFromCache(e,t){return this.ar.getEntries(e,t);}}]);return __PRIVATE_MemoryRemoteDocumentChangeBuffer;}(RemoteDocumentChangeBuffer);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_MemoryTargetCache=/*#__PURE__*/function(){function __PRIVATE_MemoryTargetCache(e){_classCallCheck(this,__PRIVATE_MemoryTargetCache);this.persistence=e,/**
         * Maps a target to the data about that target
         */this.Mr=new ObjectMap(function(e){return __PRIVATE_canonifyTarget(e);},__PRIVATE_targetEquals),/** The last received snapshot version. */this.lastRemoteSnapshotVersion=SnapshotVersion.min(),/** The highest numbered target ID encountered. */this.highestTargetId=0,/** The highest sequence number encountered. */this.Or=0,/**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */this.Nr=new __PRIVATE_ReferenceSet(),this.targetCount=0,this.Lr=__PRIVATE_TargetIdGenerator.Nn();}_createClass(__PRIVATE_MemoryTargetCache,[{key:"forEachTarget",value:function forEachTarget(e,t){return this.Mr.forEach(function(e,n){return t(n);}),PersistencePromise.resolve();}},{key:"getLastRemoteSnapshotVersion",value:function getLastRemoteSnapshotVersion(e){return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);}},{key:"getHighestSequenceNumber",value:function getHighestSequenceNumber(e){return PersistencePromise.resolve(this.Or);}},{key:"allocateTargetId",value:function allocateTargetId(e){return this.highestTargetId=this.Lr.next(),PersistencePromise.resolve(this.highestTargetId);}},{key:"setTargetsMetadata",value:function setTargetsMetadata(e,t,n){return n&&(this.lastRemoteSnapshotVersion=n),t>this.Or&&(this.Or=t),PersistencePromise.resolve();}},{key:"qn",value:function qn(e){this.Mr.set(e.target,e);var t=e.targetId;t>this.highestTargetId&&(this.Lr=new __PRIVATE_TargetIdGenerator(t),this.highestTargetId=t),e.sequenceNumber>this.Or&&(this.Or=e.sequenceNumber);}},{key:"addTargetData",value:function addTargetData(e,t){return this.qn(t),this.targetCount+=1,PersistencePromise.resolve();}},{key:"updateTargetData",value:function updateTargetData(e,t){return this.qn(t),PersistencePromise.resolve();}},{key:"removeTargetData",value:function removeTargetData(e,t){return this.Mr["delete"](t.target),this.Nr.Vr(t.targetId),this.targetCount-=1,PersistencePromise.resolve();}},{key:"removeTargets",value:function removeTargets(e,t,n){var _this122=this;var r=0;var i=[];return this.Mr.forEach(function(s,o){o.sequenceNumber<=t&&null===n.get(o.targetId)&&(_this122.Mr["delete"](s),i.push(_this122.removeMatchingKeysForTargetId(e,o.targetId)),r++);}),PersistencePromise.waitFor(i).next(function(){return r;});}},{key:"getTargetCount",value:function getTargetCount(e){return PersistencePromise.resolve(this.targetCount);}},{key:"getTargetData",value:function getTargetData(e,t){var n=this.Mr.get(t)||null;return PersistencePromise.resolve(n);}},{key:"addMatchingKeys",value:function addMatchingKeys(e,t,n){return this.Nr.dr(t,n),PersistencePromise.resolve();}},{key:"removeMatchingKeys",value:function removeMatchingKeys(e,t,n){this.Nr.Rr(t,n);var r=this.persistence.referenceDelegate,i=[];return r&&t.forEach(function(t){i.push(r.markPotentiallyOrphaned(e,t));}),PersistencePromise.waitFor(i);}},{key:"removeMatchingKeysForTargetId",value:function removeMatchingKeysForTargetId(e,t){return this.Nr.Vr(t),PersistencePromise.resolve();}},{key:"getMatchingKeysForTargetId",value:function getMatchingKeysForTargetId(e,t){var n=this.Nr.gr(t);return PersistencePromise.resolve(n);}},{key:"containsKey",value:function containsKey(e,t){return PersistencePromise.resolve(this.Nr.containsKey(t));}}]);return __PRIVATE_MemoryTargetCache;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */var __PRIVATE_MemoryPersistence=/*#__PURE__*/function(){/**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */function __PRIVATE_MemoryPersistence(e,t){var _this123=this;_classCallCheck(this,__PRIVATE_MemoryPersistence);this.Br={},this.overlays={},this.kr=new __PRIVATE_ListenSequence(0),this.qr=!1,this.qr=!0,this.referenceDelegate=e(this),this.Qr=new __PRIVATE_MemoryTargetCache(this);this.indexManager=new __PRIVATE_MemoryIndexManager(),this.remoteDocumentCache=function __PRIVATE_newMemoryRemoteDocumentCache(e){return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e);}(function(e){return _this123.referenceDelegate.Kr(e);}),this.serializer=new __PRIVATE_LocalSerializer(t),this.$r=new __PRIVATE_MemoryBundleCache(this.serializer);}_createClass(__PRIVATE_MemoryPersistence,[{key:"start",value:function start(){return Promise.resolve();}},{key:"shutdown",value:function shutdown(){// No durable state to ensure is closed on shutdown.
return this.qr=!1,Promise.resolve();}},{key:"started",get:function get(){return this.qr;}},{key:"setDatabaseDeletedListener",value:function setDatabaseDeletedListener(){// No op.
}},{key:"setNetworkEnabled",value:function setNetworkEnabled(){// No op.
}},{key:"getIndexManager",value:function getIndexManager(e){// We do not currently support indices for memory persistence, so we can
// return the same shared instance of the memory index manager.
return this.indexManager;}},{key:"getDocumentOverlayCache",value:function getDocumentOverlayCache(e){var t=this.overlays[e.toKey()];return t||(t=new __PRIVATE_MemoryDocumentOverlayCache(),this.overlays[e.toKey()]=t),t;}},{key:"getMutationQueue",value:function getMutationQueue(e,t){var n=this.Br[e.toKey()];return n||(n=new __PRIVATE_MemoryMutationQueue(t,this.referenceDelegate),this.Br[e.toKey()]=n),n;}},{key:"getTargetCache",value:function getTargetCache(){return this.Qr;}},{key:"getRemoteDocumentCache",value:function getRemoteDocumentCache(){return this.remoteDocumentCache;}},{key:"getBundleCache",value:function getBundleCache(){return this.$r;}},{key:"runTransaction",value:function runTransaction(e,t,n){var _this124=this;__PRIVATE_logDebug("MemoryPersistence","Starting transaction:",e);var r=new __PRIVATE_MemoryTransaction(this.kr.next());return this.referenceDelegate.Ur(),n(r).next(function(e){return _this124.referenceDelegate.Wr(r).next(function(){return e;});}).toPromise().then(function(e){return r.raiseOnCommittedEvent(),e;});}},{key:"Gr",value:function Gr(e,t){return PersistencePromise.or(Object.values(this.Br).map(function(n){return function(){return n.containsKey(e,t);};}));}}]);return __PRIVATE_MemoryPersistence;}();/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */var __PRIVATE_MemoryTransaction=/*#__PURE__*/function(_PersistenceTransacti2){_inherits(__PRIVATE_MemoryTransaction,_PersistenceTransacti2);var _super27=_createSuper(__PRIVATE_MemoryTransaction);function __PRIVATE_MemoryTransaction(e){var _this125;_classCallCheck(this,__PRIVATE_MemoryTransaction);_this125=_super27.call(this),_this125.currentSequenceNumber=e;return _this125;}return _createClass(__PRIVATE_MemoryTransaction);}(PersistenceTransaction);var __PRIVATE_MemoryEagerDelegate=/*#__PURE__*/function(){function __PRIVATE_MemoryEagerDelegate(e){_classCallCheck(this,__PRIVATE_MemoryEagerDelegate);this.persistence=e,/** Tracks all documents that are active in Query views. */this.zr=new __PRIVATE_ReferenceSet(),/** The list of documents that are potentially GCed after each transaction. */this.jr=null;}_createClass(__PRIVATE_MemoryEagerDelegate,[{key:"Jr",get:function get(){if(this.jr)return this.jr;throw fail();}},{key:"addReference",value:function addReference(e,t,n){return this.zr.addReference(n,t),this.Jr["delete"](n.toString()),PersistencePromise.resolve();}},{key:"removeReference",value:function removeReference(e,t,n){return this.zr.removeReference(n,t),this.Jr.add(n.toString()),PersistencePromise.resolve();}},{key:"markPotentiallyOrphaned",value:function markPotentiallyOrphaned(e,t){return this.Jr.add(t.toString()),PersistencePromise.resolve();}},{key:"removeTarget",value:function removeTarget(e,t){var _this126=this;this.zr.Vr(t.targetId).forEach(function(e){return _this126.Jr.add(e.toString());});var n=this.persistence.getTargetCache();return n.getMatchingKeysForTargetId(e,t.targetId).next(function(e){e.forEach(function(e){return _this126.Jr.add(e.toString());});}).next(function(){return n.removeTargetData(e,t);});}},{key:"Ur",value:function Ur(){this.jr=new Set();}},{key:"Wr",value:function Wr(e){var _this127=this;// Remove newly orphaned documents.
var t=this.persistence.getRemoteDocumentCache().newChangeBuffer();return PersistencePromise.forEach(this.Jr,function(n){var r=DocumentKey.fromPath(n);return _this127.Yr(e,r).next(function(e){e||t.removeEntry(r,SnapshotVersion.min());});}).next(function(){return _this127.jr=null,t.apply(e);});}},{key:"updateLimboDocument",value:function updateLimboDocument(e,t){var _this128=this;return this.Yr(e,t).next(function(e){e?_this128.Jr["delete"](t.toString()):_this128.Jr.add(t.toString());});}},{key:"Kr",value:function Kr(e){// For eager GC, we don't care about the document size, there are no size thresholds.
return 0;}},{key:"Yr",value:function Yr(e,t){var _this129=this;return PersistencePromise.or([function(){return PersistencePromise.resolve(_this129.zr.containsKey(t));},function(){return _this129.persistence.getTargetCache().containsKey(e,t);},function(){return _this129.persistence.Gr(e,t);}]);}}],[{key:"Hr",value:function Hr(e){return new __PRIVATE_MemoryEagerDelegate(e);}}]);return __PRIVATE_MemoryEagerDelegate;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */var __PRIVATE_LocalViewChanges=/*#__PURE__*/function(){function __PRIVATE_LocalViewChanges(e,t,n,r){_classCallCheck(this,__PRIVATE_LocalViewChanges);this.targetId=e,this.fromCache=t,this.qi=n,this.Qi=r;}_createClass(__PRIVATE_LocalViewChanges,null,[{key:"Ki",value:function Ki(e,t){var n=__PRIVATE_documentKeySet(),r=__PRIVATE_documentKeySet();var _iterator59=_createForOfIteratorHelper(t.docChanges),_step59;try{for(_iterator59.s();!(_step59=_iterator59.n()).done;){var _e76=_step59.value;switch(_e76.type){case 0/* ChangeType.Added */:n=n.add(_e76.doc.key);break;case 1/* ChangeType.Removed */:r=r.add(_e76.doc.key);// do nothing
}}}catch(err){_iterator59.e(err);}finally{_iterator59.f();}return new __PRIVATE_LocalViewChanges(e,t.fromCache,n,r);}}]);return __PRIVATE_LocalViewChanges;}();/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */var QueryContext=/*#__PURE__*/function(){function QueryContext(){_classCallCheck(this,QueryContext);/**
         * Counts the number of documents passed through during local query execution.
         */this._documentReadCount=0;}_createClass(QueryContext,[{key:"documentReadCount",get:function get(){return this._documentReadCount;}},{key:"incrementDocumentReadCount",value:function incrementDocumentReadCount(e){this._documentReadCount+=e;}}]);return QueryContext;}();/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */var __PRIVATE_QueryEngine=/*#__PURE__*/function(){function __PRIVATE_QueryEngine(){_classCallCheck(this,__PRIVATE_QueryEngine);this.$i=!1,this.Ui=!1,/**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */this.Wi=100,this.Gi=/**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument(){// These values were derived from an experiment where several members of the
// Firestore SDK team ran a performance test in various environments.
// Googlers can see b/299284287 for details.
return isSafari()?8:__PRIVATE_getAndroidVersion(getUA())>0?6:4;}();}/** Sets the document view to query against. */_createClass(__PRIVATE_QueryEngine,[{key:"initialize",value:function initialize(e,t){this.zi=e,this.indexManager=t,this.$i=!0;}/** Returns all local documents matching the specified query. */},{key:"getDocumentsMatchingQuery",value:function getDocumentsMatchingQuery(e,t,n,r){var _this153=this;// Stores the result from executing the query; using this object is more
// convenient than passing the result between steps of the persistence
// transaction and improves readability comparatively.
var i={result:null};return this.ji(e,t).next(function(e){i.result=e;}).next(function(){if(!i.result)return _this153.Hi(e,t,r,n).next(function(e){i.result=e;});}).next(function(){if(i.result)return;var n=new QueryContext();return _this153.Ji(e,t,n).next(function(r){if(i.result=r,_this153.Ui)return _this153.Yi(e,t,n,r.size);});}).next(function(){return i.result;});}},{key:"Yi",value:function Yi(e,t,n,r){return n.documentReadCount<this.Wi?(__PRIVATE_getLogLevel()<=LogLevel.DEBUG&&__PRIVATE_logDebug("QueryEngine","SDK will not create cache indexes for query:",__PRIVATE_stringifyQuery(t),"since it only creates cache indexes for collection contains","more than or equal to",this.Wi,"documents"),PersistencePromise.resolve()):(__PRIVATE_getLogLevel()<=LogLevel.DEBUG&&__PRIVATE_logDebug("QueryEngine","Query:",__PRIVATE_stringifyQuery(t),"scans",n.documentReadCount,"local documents and returns",r,"documents as results."),n.documentReadCount>this.Gi*r?(__PRIVATE_getLogLevel()<=LogLevel.DEBUG&&__PRIVATE_logDebug("QueryEngine","The SDK decides to create cache indexes for query:",__PRIVATE_stringifyQuery(t),"as using cache indexes may help improve performance."),this.indexManager.createTargetIndexes(e,__PRIVATE_queryToTarget(t))):PersistencePromise.resolve());}/**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */},{key:"ji",value:function ji(e,t){var _this154=this;if(__PRIVATE_queryMatchesAllDocuments(t))// Queries that match all documents don't benefit from using
// key-based lookups. It is more efficient to scan all documents in a
// collection, rather than to perform individual lookups.
return PersistencePromise.resolve(null);var n=__PRIVATE_queryToTarget(t);return this.indexManager.getIndexType(e,n).next(function(r){return 0/* IndexType.NONE */===r?null:(null!==t.limit&&1/* IndexType.PARTIAL */===r&&(// We cannot apply a limit for targets that are served using a partial
// index. If a partial index will be used to serve the target, the
// query may return a superset of documents that match the target
// (e.g. if the index doesn't include all the target's filters), or
// may return the correct set of documents in the wrong order (e.g. if
// the index doesn't include a segment for one of the orderBys).
// Therefore, a limit should not be applied in such cases.
t=__PRIVATE_queryWithLimit(t,null,"F"/* LimitType.First */),n=__PRIVATE_queryToTarget(t)),_this154.indexManager.getDocumentsMatchingTarget(e,n).next(function(r){var i=__PRIVATE_documentKeySet.apply(void 0,_toConsumableArray(r));return _this154.zi.getDocuments(e,i).next(function(r){return _this154.indexManager.getMinOffset(e,n).next(function(n){var s=_this154.Zi(t,r);return _this154.Xi(t,s,i,n.readTime)?_this154.ji(e,__PRIVATE_queryWithLimit(t,null,"F"/* LimitType.First */)):_this154.es(e,s,t,n);});});}));});}/**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */},{key:"Hi",value:function Hi(e,t,n,r){var _this155=this;return __PRIVATE_queryMatchesAllDocuments(t)||r.isEqual(SnapshotVersion.min())?PersistencePromise.resolve(null):this.zi.getDocuments(e,n).next(function(i){var s=_this155.Zi(t,i);return _this155.Xi(t,s,n,r)?PersistencePromise.resolve(null):(__PRIVATE_getLogLevel()<=LogLevel.DEBUG&&__PRIVATE_logDebug("QueryEngine","Re-using previous result from %s to execute query: %s",r.toString(),__PRIVATE_stringifyQuery(t)),_this155.es(e,s,t,__PRIVATE_newIndexOffsetSuccessorFromReadTime(r,-1)).next(function(e){return e;}));});// Queries that have never seen a snapshot without limbo free documents
// should also be run as a full collection scan.
}/** Applies the query filter and sorting to the provided documents.  */},{key:"Zi",value:function Zi(e,t){// Sort the documents and re-apply the query filter since previously
// matching documents do not necessarily still match the query.
var n=new SortedSet(__PRIVATE_newQueryComparator(e));return t.forEach(function(t,r){__PRIVATE_queryMatches(e,r)&&(n=n.add(r));}),n;}/**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */},{key:"Xi",value:function Xi(e,t,n,r){if(null===e.limit)// Queries without limits do not need to be refilled.
return !1;if(n.size!==t.size)// The query needs to be refilled if a previously matching document no
// longer matches.
return !0;// Limit queries are not eligible for index-free query execution if there is
// a potential that an older document from cache now sorts before a document
// that was previously part of the limit. This, however, can only happen if
// the document at the edge of the limit goes out of limit.
// If a document that is not the limit boundary sorts differently,
// the boundary of the limit itself did not change and documents from cache
// will continue to be "rejected" by this boundary. Therefore, we can ignore
// any modifications that don't affect the last document.
var i="F"/* LimitType.First */===e.limitType?t.last():t.first();return !!i&&(i.hasPendingWrites||i.version.compareTo(r)>0);}},{key:"Ji",value:function Ji(e,t,n){return __PRIVATE_getLogLevel()<=LogLevel.DEBUG&&__PRIVATE_logDebug("QueryEngine","Using full collection scan to execute query:",__PRIVATE_stringifyQuery(t)),this.zi.getDocumentsMatchingQuery(e,t,IndexOffset.min(),n);}/**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */},{key:"es",value:function es(e,t,n,r){// Retrieve all results for documents that were updated since the offset.
return this.zi.getDocumentsMatchingQuery(e,n,r).next(function(e){return(// Merge with existing results
t.forEach(function(t){e=e.insert(t.key,t);}),e);});}}]);return __PRIVATE_QueryEngine;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */var __PRIVATE_LocalStoreImpl=/*#__PURE__*/function(){function __PRIVATE_LocalStoreImpl(/** Manages our in-memory or durable persistence. */e,t,n,r){_classCallCheck(this,__PRIVATE_LocalStoreImpl);this.persistence=e,this.ts=t,this.serializer=r,/**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */this.ns=new SortedMap(__PRIVATE_primitiveComparator),/** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
this.rs=new ObjectMap(function(e){return __PRIVATE_canonifyTarget(e);},__PRIVATE_targetEquals),/**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */this.ss=new Map(),this.os=e.getRemoteDocumentCache(),this.Qr=e.getTargetCache(),this.$r=e.getBundleCache(),this._s(n);}_createClass(__PRIVATE_LocalStoreImpl,[{key:"_s",value:function _s(e){// TODO(indexing): Add spec tests that test these components change after a
// user change
this.documentOverlayCache=this.persistence.getDocumentOverlayCache(e),this.indexManager=this.persistence.getIndexManager(e),this.mutationQueue=this.persistence.getMutationQueue(e,this.indexManager),this.localDocuments=new LocalDocumentsView(this.os,this.mutationQueue,this.documentOverlayCache,this.indexManager),this.os.setIndexManager(this.indexManager),this.ts.initialize(this.localDocuments,this.indexManager);}},{key:"collectGarbage",value:function collectGarbage(e){var _this156=this;return this.persistence.runTransaction("Collect garbage","readwrite-primary",function(t){return e.collect(t,_this156.ns);});}}]);return __PRIVATE_LocalStoreImpl;}();function __PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */e,t,n,r){return new __PRIVATE_LocalStoreImpl(e,t,n,r);}/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
function __PRIVATE_localStoreHandleUserChange(_x9,_x10){return _PRIVATE_localStoreHandleUserChange.apply(this,arguments);}/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */function _PRIVATE_localStoreHandleUserChange(){_PRIVATE_localStoreHandleUserChange=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee79(e,t){var n;return regenerator.wrap(function _callee79$(_context79){while(1){switch(_context79.prev=_context79.next){case 0:n=__PRIVATE_debugCast(e);_context79.next=3;return n.persistence.runTransaction("Handle user change","readonly",function(e){// Swap out the mutation queue, grabbing the pending mutation batches
// before and after.
var r;return n.mutationQueue.getAllMutationBatches(e).next(function(i){return r=i,n._s(t),n.mutationQueue.getAllMutationBatches(e);}).next(function(t){var i=[],s=[];// Union the old/new changed keys.
var o=__PRIVATE_documentKeySet();var _iterator88=_createForOfIteratorHelper(r),_step88;try{for(_iterator88.s();!(_step88=_iterator88.n()).done;){var _e118=_step88.value;i.push(_e118.batchId);var _iterator90=_createForOfIteratorHelper(_e118.mutations),_step90;try{for(_iterator90.s();!(_step90=_iterator90.n()).done;){var _t57=_step90.value;o=o.add(_t57.key);}}catch(err){_iterator90.e(err);}finally{_iterator90.f();}}}catch(err){_iterator88.e(err);}finally{_iterator88.f();}var _iterator89=_createForOfIteratorHelper(t),_step89;try{for(_iterator89.s();!(_step89=_iterator89.n()).done;){var _e119=_step89.value;s.push(_e119.batchId);var _iterator91=_createForOfIteratorHelper(_e119.mutations),_step91;try{for(_iterator91.s();!(_step91=_iterator91.n()).done;){var _t58=_step91.value;o=o.add(_t58.key);}}catch(err){_iterator91.e(err);}finally{_iterator91.f();}}// Return the set of all (potentially) changed documents and the list
// of mutation batch IDs that were affected by change.
}catch(err){_iterator89.e(err);}finally{_iterator89.f();}return n.localDocuments.getDocuments(e,o).next(function(e){return {us:e,removedBatchIds:i,addedBatchIds:s};});});});case 3:return _context79.abrupt("return",_context79.sent);case 4:case"end":return _context79.stop();}}},_callee79);}));return _PRIVATE_localStoreHandleUserChange.apply(this,arguments);}function __PRIVATE_localStoreAcknowledgeBatch(e,t){var n=__PRIVATE_debugCast(e);return n.persistence.runTransaction("Acknowledge batch","readwrite-primary",function(e){var r=t.batch.keys(),i=n.os.newChangeBuffer({trackRemovals:!0});return function __PRIVATE_applyWriteToRemoteDocuments(e,t,n,r){var i=n.batch,s=i.keys();var o=PersistencePromise.resolve();return s.forEach(function(e){o=o.next(function(){return r.getEntry(t,e);}).next(function(t){var s=n.docVersions.get(e);__PRIVATE_hardAssert(null!==s),t.version.compareTo(s)<0&&(i.applyToRemoteDocument(t,n),t.isValidDocument()&&(// We use the commitVersion as the readTime rather than the
// document's updateTime since the updateTime is not advanced
// for updates that do not modify the underlying document.
t.setReadTime(n.commitVersion),r.addEntry(t)));});}),o.next(function(){return e.mutationQueue.removeMutationBatch(t,i);});}/** Returns the local view of the documents affected by a mutation batch. */ // PORTING NOTE: Multi-Tab only.
(n,e,t,i).next(function(){return i.apply(e);}).next(function(){return n.mutationQueue.performConsistencyCheck(e);}).next(function(){return n.documentOverlayCache.removeOverlaysForBatchId(e,r,t.batch.batchId);}).next(function(){return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e,function __PRIVATE_getKeysWithTransformResults(e){var t=__PRIVATE_documentKeySet();for(var _n25=0;_n25<e.mutationResults.length;++_n25){e.mutationResults[_n25].transformResults.length>0&&(t=t.add(e.batch.mutations[_n25].key));}return t;}/**
 * Removes mutations from the MutationQueue for the specified batch;
 * LocalDocuments will be recalculated.
 *
 * @returns The resulting modified documents.
 */(t));}).next(function(){return n.localDocuments.getDocuments(e,r);});});}/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e){var t=__PRIVATE_debugCast(e);return t.persistence.runTransaction("Get last remote snapshot version","readonly",function(e){return t.Qr.getLastRemoteSnapshotVersion(e);});}/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e,t){var n=__PRIVATE_debugCast(e),r=t.snapshotVersion;var i=n.ns;return n.persistence.runTransaction("Apply remote event","readwrite-primary",function(e){var s=n.os.newChangeBuffer({trackRemovals:!0});// Reset newTargetDataByTargetMap in case this transaction gets re-run.
i=n.ns;var o=[];t.targetChanges.forEach(function(s,_){var a=i.get(_);if(!a)return;// Only update the remote keys if the target is still active. This
// ensures that we can persist the updated target data along with
// the updated assignment.
o.push(n.Qr.removeMatchingKeys(e,s.removedDocuments,_).next(function(){return n.Qr.addMatchingKeys(e,s.addedDocuments,_);}));var u=a.withSequenceNumber(e.currentSequenceNumber);null!==t.targetMismatches.get(_)?u=u.withResumeToken(ByteString.EMPTY_BYTE_STRING,SnapshotVersion.min()).withLastLimboFreeSnapshotVersion(SnapshotVersion.min()):s.resumeToken.approximateByteSize()>0&&(u=u.withResumeToken(s.resumeToken,r)),i=i.insert(_,u),// Update the target data if there are target changes (or if
// sufficient time has passed since the last update).
/**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */function __PRIVATE_shouldPersistTargetData(e,t,n){// Always persist target data if we don't already have a resume token.
if(0===e.resumeToken.approximateByteSize())return !0;// Don't allow resume token changes to be buffered indefinitely. This
// allows us to be reasonably up-to-date after a crash and avoids needing
// to loop over all active queries on shutdown. Especially in the browser
// we may not get time to do anything interesting while the current tab is
// closing.
if(t.snapshotVersion.toMicroseconds()-e.snapshotVersion.toMicroseconds()>=3e8)return !0;// Otherwise if the only thing that has changed about a target is its resume
// token it's not worth persisting. Note that the RemoteStore keeps an
// in-memory view of the currently active targets which includes the current
// resume token, so stream failure or user changes will still use an
// up-to-date resume token regardless of what we do here.
return n.addedDocuments.size+n.modifiedDocuments.size+n.removedDocuments.size>0;}/**
 * Notifies local store of the changed views to locally pin documents.
 */(a,u,s)&&o.push(n.Qr.updateTargetData(e,u));});var _=__PRIVATE_mutableDocumentMap(),a=__PRIVATE_documentKeySet();// HACK: The only reason we allow a null snapshot version is so that we
// can synthesize remote events when we get permission denied errors while
// trying to resolve the state of a locally cached document that is in
// limbo.
if(t.documentUpdates.forEach(function(r){t.resolvedLimboDocuments.has(r)&&o.push(n.persistence.referenceDelegate.updateLimboDocument(e,r));}),// Each loop iteration only affects its "own" doc, so it's safe to get all
// the remote documents in advance in a single call.
o.push(__PRIVATE_populateDocumentChangeBuffer(e,s,t.documentUpdates).next(function(e){_=e.cs,a=e.ls;})),!r.isEqual(SnapshotVersion.min())){var _t40=n.Qr.getLastRemoteSnapshotVersion(e).next(function(t){return n.Qr.setTargetsMetadata(e,e.currentSequenceNumber,r);});o.push(_t40);}return PersistencePromise.waitFor(o).next(function(){return s.apply(e);}).next(function(){return n.localDocuments.getLocalViewOfDocuments(e,_,a);}).next(function(){return _;});}).then(function(e){return n.ns=i,e;});}/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */function __PRIVATE_populateDocumentChangeBuffer(e,t,n){var r=__PRIVATE_documentKeySet(),i=__PRIVATE_documentKeySet();return n.forEach(function(e){return r=r.add(e);}),t.getEntries(e,r).next(function(e){var r=__PRIVATE_mutableDocumentMap();return n.forEach(function(n,s){var o=e.get(n);// Check if see if there is a existence state change for this document.
s.isFoundDocument()!==o.isFoundDocument()&&(i=i.add(n)),// Note: The order of the steps below is important, since we want
// to ensure that rejected limbo resolutions (which fabricate
// NoDocuments with SnapshotVersion.min()) never add documents to
// cache.
s.isNoDocument()&&s.version.isEqual(SnapshotVersion.min())?(// NoDocuments with SnapshotVersion.min() are used in manufactured
// events. We remove these documents from cache since we lost
// access.
t.removeEntry(n,s.readTime),r=r.insert(n,s)):!o.isValidDocument()||s.version.compareTo(o.version)>0||0===s.version.compareTo(o.version)&&o.hasPendingWrites?(t.addEntry(s),r=r.insert(n,s)):__PRIVATE_logDebug("LocalStore","Ignoring outdated watch update for ",n,". Current version:",o.version," Watch version:",s.version);}),{cs:r,ls:i};});}/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */function __PRIVATE_localStoreGetNextMutationBatch(e,t){var n=__PRIVATE_debugCast(e);return n.persistence.runTransaction("Get next mutation batch","readonly",function(e){return void 0===t&&(t=-1),n.mutationQueue.getNextMutationBatchAfterBatchId(e,t);});}/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */function __PRIVATE_localStoreAllocateTarget(e,t){var n=__PRIVATE_debugCast(e);return n.persistence.runTransaction("Allocate target","readwrite",function(e){var r;return n.Qr.getTargetData(e,t).next(function(i){return i?(// This target has been listened to previously, so reuse the
// previous targetID.
// TODO(mcg): freshen last accessed date?
r=i,PersistencePromise.resolve(r)):n.Qr.allocateTargetId(e).next(function(i){return r=new TargetData(t,i,"TargetPurposeListen"/* TargetPurpose.Listen */,e.currentSequenceNumber),n.Qr.addTargetData(e,r).next(function(){return r;});});});}).then(function(e){// If Multi-Tab is enabled, the existing target data may be newer than
// the in-memory data
var r=n.ns.get(e.targetId);return (null===r||e.snapshotVersion.compareTo(r.snapshotVersion)>0)&&(n.ns=n.ns.insert(e.targetId,e),n.rs.set(t,e.targetId)),e;});}/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
function __PRIVATE_localStoreReleaseTarget(_x11,_x12,_x13){return _PRIVATE_localStoreReleaseTarget.apply(this,arguments);}/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */function _PRIVATE_localStoreReleaseTarget(){_PRIVATE_localStoreReleaseTarget=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee80(e,t,n){var r,i,s;return regenerator.wrap(function _callee80$(_context80){while(1){switch(_context80.prev=_context80.next){case 0:r=__PRIVATE_debugCast(e),i=r.ns.get(t),s=n?"readwrite":"readwrite-primary";_context80.prev=1;_context80.t0=n;if(_context80.t0){_context80.next=6;break;}_context80.next=6;return r.persistence.runTransaction("Release target",s,function(e){return r.persistence.referenceDelegate.removeTarget(e,i);});case 6:_context80.next=13;break;case 8:_context80.prev=8;_context80.t1=_context80["catch"](1);if(__PRIVATE_isIndexedDbTransactionError(_context80.t1)){_context80.next=12;break;}throw _context80.t1;case 12:// All `releaseTarget` does is record the final metadata state for the
// target, but we've been recording this periodically during target
// activity. If we lose this write this could cause a very slight
// difference in the order of target deletion during GC, but we
// don't define exact LRU semantics so this is acceptable.
__PRIVATE_logDebug("LocalStore","Failed to update sequence numbers for target ".concat(t,": ").concat(_context80.t1));case 13:r.ns=r.ns.remove(t),r.rs["delete"](i.target);case 14:case"end":return _context80.stop();}}},_callee80,null,[[1,8]]);}));return _PRIVATE_localStoreReleaseTarget.apply(this,arguments);}function __PRIVATE_localStoreExecuteQuery(e,t,n){var r=__PRIVATE_debugCast(e);var i=SnapshotVersion.min(),s=__PRIVATE_documentKeySet();return r.persistence.runTransaction("Execute query","readwrite",// Use readwrite instead of readonly so indexes can be created
// Use readwrite instead of readonly so indexes can be created
function(e){return function __PRIVATE_localStoreGetTargetData(e,t,n){var r=__PRIVATE_debugCast(e),i=r.rs.get(n);return void 0!==i?PersistencePromise.resolve(r.ns.get(i)):r.Qr.getTargetData(t,n);}(r,e,__PRIVATE_queryToTarget(t)).next(function(t){if(t)return i=t.lastLimboFreeSnapshotVersion,r.Qr.getMatchingKeysForTargetId(e,t.targetId).next(function(e){s=e;});}).next(function(){return r.ts.getDocumentsMatchingQuery(e,t,n?i:SnapshotVersion.min(),n?s:__PRIVATE_documentKeySet());}).next(function(e){return __PRIVATE_setMaxReadTime(r,__PRIVATE_queryCollectionGroup(t),e),{documents:e,hs:s};});});}// PORTING NOTE: Multi-Tab only.
function __PRIVATE_setMaxReadTime(e,t,n){var r=e.ss.get(t)||SnapshotVersion.min();n.forEach(function(e,t){t.readTime.compareTo(r)>0&&(r=t.readTime);}),e.ss.set(t,r);}var __PRIVATE_LocalClientState=/*#__PURE__*/function(){function __PRIVATE_LocalClientState(){_classCallCheck(this,__PRIVATE_LocalClientState);this.activeTargetIds=__PRIVATE_targetIdSet();}_createClass(__PRIVATE_LocalClientState,[{key:"As",value:function As(e){this.activeTargetIds=this.activeTargetIds.add(e);}},{key:"Rs",value:function Rs(e){this.activeTargetIds=this.activeTargetIds["delete"](e);}/**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */},{key:"ds",value:function ds(){var e={activeTargetIds:this.activeTargetIds.toArray(),updateTimeMs:Date.now()};return JSON.stringify(e);}}]);return __PRIVATE_LocalClientState;}();var __PRIVATE_MemorySharedClientState=/*#__PURE__*/function(){function __PRIVATE_MemorySharedClientState(){_classCallCheck(this,__PRIVATE_MemorySharedClientState);this.no=new __PRIVATE_LocalClientState(),this.ro={},this.onlineStateHandler=null,this.sequenceNumberHandler=null;}_createClass(__PRIVATE_MemorySharedClientState,[{key:"addPendingMutation",value:function addPendingMutation(e){// No op.
}},{key:"updateMutationState",value:function updateMutationState(e,t,n){// No op.
}},{key:"addLocalQueryTarget",value:function addLocalQueryTarget(e){return this.no.As(e),this.ro[e]||"not-current";}},{key:"updateQueryState",value:function updateQueryState(e,t,n){this.ro[e]=t;}},{key:"removeLocalQueryTarget",value:function removeLocalQueryTarget(e){this.no.Rs(e);}},{key:"isLocalQueryTarget",value:function isLocalQueryTarget(e){return this.no.activeTargetIds.has(e);}},{key:"clearQueryState",value:function clearQueryState(e){delete this.ro[e];}},{key:"getAllActiveQueryTargets",value:function getAllActiveQueryTargets(){return this.no.activeTargetIds;}},{key:"isActiveQueryTarget",value:function isActiveQueryTarget(e){return this.no.activeTargetIds.has(e);}},{key:"start",value:function start(){return this.no=new __PRIVATE_LocalClientState(),Promise.resolve();}},{key:"handleUserChange",value:function handleUserChange(e,t,n){// No op.
}},{key:"setOnlineState",value:function setOnlineState(e){// No op.
}},{key:"shutdown",value:function shutdown(){}},{key:"writeSequenceNumber",value:function writeSequenceNumber(e){}},{key:"notifyBundleLoaded",value:function notifyBundleLoaded(e){// No op.
}}]);return __PRIVATE_MemorySharedClientState;}();/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_NoopConnectivityMonitor=/*#__PURE__*/function(){function __PRIVATE_NoopConnectivityMonitor(){_classCallCheck(this,__PRIVATE_NoopConnectivityMonitor);}_createClass(__PRIVATE_NoopConnectivityMonitor,[{key:"io",value:function io(e){// No-op.
}},{key:"shutdown",value:function shutdown(){// No-op.
}}]);return __PRIVATE_NoopConnectivityMonitor;}();/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */var __PRIVATE_BrowserConnectivityMonitor=/*#__PURE__*/function(){function __PRIVATE_BrowserConnectivityMonitor(){var _this161=this;_classCallCheck(this,__PRIVATE_BrowserConnectivityMonitor);this.so=function(){return _this161.oo();},this._o=function(){return _this161.ao();},this.uo=[],this.co();}_createClass(__PRIVATE_BrowserConnectivityMonitor,[{key:"io",value:function io(e){this.uo.push(e);}},{key:"shutdown",value:function shutdown(){window.removeEventListener("online",this.so),window.removeEventListener("offline",this._o);}},{key:"co",value:function co(){window.addEventListener("online",this.so),window.addEventListener("offline",this._o);}},{key:"oo",value:function oo(){__PRIVATE_logDebug("ConnectivityMonitor","Network connectivity changed: AVAILABLE");var _iterator62=_createForOfIteratorHelper(this.uo),_step62;try{for(_iterator62.s();!(_step62=_iterator62.n()).done;){var e=_step62.value;e(0/* NetworkStatus.AVAILABLE */);}}catch(err){_iterator62.e(err);}finally{_iterator62.f();}}},{key:"ao",value:function ao(){__PRIVATE_logDebug("ConnectivityMonitor","Network connectivity changed: UNAVAILABLE");var _iterator63=_createForOfIteratorHelper(this.uo),_step63;try{for(_iterator63.s();!(_step63=_iterator63.n()).done;){var e=_step63.value;e(1/* NetworkStatus.UNAVAILABLE */);}}catch(err){_iterator63.e(err);}finally{_iterator63.f();}}// TODO(chenbrian): Consider passing in window either into this component or
// here for testing via FakeWindow.
/** Checks that all used attributes of window are available. */}],[{key:"D",value:function D(){return "undefined"!=typeof window&&void 0!==window.addEventListener&&void 0!==window.removeEventListener;}}]);return __PRIVATE_BrowserConnectivityMonitor;}();/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */var Ve=null;/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */function __PRIVATE_generateUniqueDebugId(){return null===Ve?Ve=function __PRIVATE_generateInitialUniqueDebugId(){return 268435456+Math.round(2147483648*Math.random());}():Ve++,"0x"+Ve.toString(16);}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var me={BatchGetDocuments:"batchGet",Commit:"commit",RunQuery:"runQuery",RunAggregationQuery:"runAggregationQuery"};/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */var __PRIVATE_StreamBridge=/*#__PURE__*/function(){function __PRIVATE_StreamBridge(e){_classCallCheck(this,__PRIVATE_StreamBridge);this.lo=e.lo,this.ho=e.ho;}_createClass(__PRIVATE_StreamBridge,[{key:"Po",value:function Po(e){this.Io=e;}},{key:"To",value:function To(e){this.Eo=e;}},{key:"Ao",value:function Ao(e){this.Ro=e;}},{key:"onMessage",value:function onMessage(e){this.Vo=e;}},{key:"close",value:function close(){this.ho();}},{key:"send",value:function send(e){this.lo(e);}},{key:"mo",value:function mo(){this.Io();}},{key:"fo",value:function fo(){this.Eo();}},{key:"po",value:function po(e){this.Ro(e);}},{key:"yo",value:function yo(e){this.Vo(e);}}]);return __PRIVATE_StreamBridge;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var fe="WebChannelConnection";var __PRIVATE_WebChannelConnection=/*#__PURE__*/function(_PRIVATE_RestConnect){_inherits(__PRIVATE_WebChannelConnection,_PRIVATE_RestConnect);var _super28=_createSuper(__PRIVATE_WebChannelConnection);function __PRIVATE_WebChannelConnection(e){var _this162;_classCallCheck(this,__PRIVATE_WebChannelConnection);_this162=_super28.call(this,e),_this162.forceLongPolling=e.forceLongPolling,_this162.autoDetectLongPolling=e.autoDetectLongPolling,_this162.useFetchStreams=e.useFetchStreams,_this162.longPollingOptions=e.longPollingOptions;return _this162;}_createClass(__PRIVATE_WebChannelConnection,[{key:"Mo",value:function Mo(e,t,n,r){var i=__PRIVATE_generateUniqueDebugId();return new Promise(function(s,o){var _=new XhrIo();_.setWithCredentials(!0),_.listenOnce(EventType.COMPLETE,function(){try{switch(_.getLastErrorCode()){case ErrorCode.NO_ERROR:var _t42=_.getResponseJson();__PRIVATE_logDebug(fe,"XHR for RPC '".concat(e,"' ").concat(i," received:"),JSON.stringify(_t42)),s(_t42);break;case ErrorCode.TIMEOUT:__PRIVATE_logDebug(fe,"RPC '".concat(e,"' ").concat(i," timed out")),o(new FirestoreError(C.DEADLINE_EXCEEDED,"Request time out"));break;case ErrorCode.HTTP_ERROR:var _n26=_.getStatus();if(__PRIVATE_logDebug(fe,"RPC '".concat(e,"' ").concat(i," failed with status:"),_n26,"response text:",_.getResponseText()),_n26>0){var _e88=_.getResponseJson();Array.isArray(_e88)&&(_e88=_e88[0]);var _t43=null==_e88?void 0:_e88.error;if(_t43&&_t43.status&&_t43.message){var _e89=function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e){var t=e.toLowerCase().replace(/_/g,"-");return Object.values(C).indexOf(t)>=0?t:C.UNKNOWN;}(_t43.status);o(new FirestoreError(_e89,_t43.message));}else o(new FirestoreError(C.UNKNOWN,"Server responded with status "+_.getStatus()));}else// If we received an HTTP_ERROR but there's no status code,
// it's most probably a connection issue
o(new FirestoreError(C.UNAVAILABLE,"Connection failed."));break;default:fail();}}finally{__PRIVATE_logDebug(fe,"RPC '".concat(e,"' ").concat(i," completed."));}});var a=JSON.stringify(r);__PRIVATE_logDebug(fe,"RPC '".concat(e,"' ").concat(i," sending request:"),r),_.send(t,"POST",a,n,15);});}},{key:"Oo",value:function Oo(e,t,n){var r=__PRIVATE_generateUniqueDebugId(),i=[this.wo,"/","google.firestore.v1.Firestore","/",e,"/channel"],s=createWebChannelTransport(),o=getStatEventTarget(),_={// Required for backend stickiness, routing behavior is based on this
// parameter.
httpSessionIdParam:"gsessionid",initMessageHeaders:{},messageUrlParams:{// This param is used to improve routing and project isolation by the
// backend and must be included in every request.
database:"projects/".concat(this.databaseId.projectId,"/databases/").concat(this.databaseId.database)},sendRawJson:!0,supportsCrossDomainXhr:!0,internalChannelParams:{// Override the default timeout (randomized between 10-20 seconds) since
// a large write batch on a slow internet connection may take a long
// time to send to the backend. Rather than have WebChannel impose a
// tight timeout which could lead to infinite timeouts and retries, we
// set it very large (5-10 minutes) and rely on the browser's builtin
// timeouts to kick in if the request isn't working.
forwardChannelRequestTimeoutMs:6e5},forceLongPolling:this.forceLongPolling,detectBufferingProxy:this.autoDetectLongPolling},a=this.longPollingOptions.timeoutSeconds;void 0!==a&&(_.longPollingTimeout=Math.round(1e3*a)),this.useFetchStreams&&(_.xmlHttpFactory=new FetchXmlHttpFactory({})),this.Fo(_.initMessageHeaders,t,n),// Sending the custom headers we just added to request.initMessageHeaders
// (Authorization, etc.) will trigger the browser to make a CORS preflight
// request because the XHR will no longer meet the criteria for a "simple"
// CORS request:
// https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
// Therefore to avoid the CORS preflight request (an extra network
// roundtrip), we use the encodeInitMessageHeaders option to specify that
// the headers should instead be encoded in the request's POST payload,
// which is recognized by the webchannel backend.
_.encodeInitMessageHeaders=!0;var u=i.join("");__PRIVATE_logDebug(fe,"Creating RPC '".concat(e,"' stream ").concat(r,": ").concat(u),_);var c=s.createWebChannel(u,_);// WebChannel supports sending the first message with the handshake - saving
// a network round trip. However, it will have to call send in the same
// JS event loop as open. In order to enforce this, we delay actually
// opening the WebChannel until send is called. Whether we have called
// open is tracked with this variable.
var l=!1,h=!1;// A flag to determine whether the stream was closed (by us or through an
// error/close event) to avoid delivering multiple close events or sending
// on a closed stream
var P=new __PRIVATE_StreamBridge({lo:function lo(t){h?__PRIVATE_logDebug(fe,"Not sending because RPC '".concat(e,"' stream ").concat(r," is closed:"),t):(l||(__PRIVATE_logDebug(fe,"Opening RPC '".concat(e,"' stream ").concat(r," transport.")),c.open(),l=!0),__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," sending:"),t),c.send(t));},ho:function ho(){return c.close();}}),__PRIVATE_unguardedEventListen=function __PRIVATE_unguardedEventListen(e,t,n){// TODO(dimond): closure typing seems broken because WebChannel does
// not implement goog.events.Listenable
e.listen(t,function(e){try{n(e);}catch(e){setTimeout(function(){throw e;},0);}});};// Closure events are guarded and exceptions are swallowed, so catch any
// exception and rethrow using a setTimeout so they become visible again.
// Note that eventually this function could go away if we are confident
// enough the code is exception free.
return __PRIVATE_unguardedEventListen(c,WebChannel.EventType.OPEN,function(){h||(__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," transport opened.")),P.mo());}),__PRIVATE_unguardedEventListen(c,WebChannel.EventType.CLOSE,function(){h||(h=!0,__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," transport closed")),P.po());}),__PRIVATE_unguardedEventListen(c,WebChannel.EventType.ERROR,function(t){h||(h=!0,__PRIVATE_logWarn(fe,"RPC '".concat(e,"' stream ").concat(r," transport errored:"),t),P.po(new FirestoreError(C.UNAVAILABLE,"The operation could not be completed")));}),__PRIVATE_unguardedEventListen(c,WebChannel.EventType.MESSAGE,function(t){var n;if(!h){var _i15=t.data[0];__PRIVATE_hardAssert(!!_i15);// TODO(b/35143891): There is a bug in One Platform that caused errors
// (and only errors) to be wrapped in an extra array. To be forward
// compatible with the bug we need to check either condition. The latter
// can be removed once the fix has been rolled out.
// Use any because msgData.error is not typed.
var _s6=_i15,_o5=_s6.error||(null===(n=_s6[0])||void 0===n?void 0:n.error);if(_o5){__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," received error:"),_o5);// error.status will be a string like 'OK' or 'NOT_FOUND'.
var _t44=_o5.status;var _n27=/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */function __PRIVATE_mapCodeFromRpcStatus(e){// lookup by string
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var t=ce[e];if(void 0!==t)return __PRIVATE_mapCodeFromRpcCode(t);}(_t44),_i16=_o5.message;void 0===_n27&&(_n27=C.INTERNAL,_i16="Unknown error status: "+_t44+" with message "+_o5.message),// Mark closed so no further events are propagated
h=!0,P.po(new FirestoreError(_n27,_i16)),c.close();}else __PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," received:"),_i15),P.yo(_i15);}}),__PRIVATE_unguardedEventListen(o,Event.STAT_EVENT,function(t){t.stat===Stat.PROXY?__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," detected buffering proxy")):t.stat===Stat.NOPROXY&&__PRIVATE_logDebug(fe,"RPC '".concat(e,"' stream ").concat(r," detected no buffering proxy"));}),setTimeout(function(){// Technically we could/should wait for the WebChannel opened event,
// but because we want to send the first message with the WebChannel
// handshake we pretend the channel opened here (asynchronously), and
// then delay the actual open until the first message is sent.
P.fo();},0),P;}}]);return __PRIVATE_WebChannelConnection;}(/*#__PURE__*/ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */function(){function __PRIVATE_RestConnection(e){_classCallCheck(this,__PRIVATE_RestConnection);this.databaseInfo=e,this.databaseId=e.databaseId;var t=e.ssl?"https":"http",n=encodeURIComponent(this.databaseId.projectId),r=encodeURIComponent(this.databaseId.database);this.wo=t+"://"+e.host,this.So="projects/".concat(n,"/databases/").concat(r),this.bo="(default)"===this.databaseId.database?"project_id=".concat(n):"project_id=".concat(n,"&database_id=").concat(r);}_createClass(__PRIVATE_RestConnection,[{key:"Do",get:function get(){// Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
// where to run the query, and expect the `request` to NOT specify the "path".
return !1;}},{key:"Co",value:function Co(e,t,n,r,i){var s=__PRIVATE_generateUniqueDebugId(),o=this.vo(e,t.toUriEncodedString());__PRIVATE_logDebug("RestConnection","Sending RPC '".concat(e,"' ").concat(s,":"),o,n);var _={"google-cloud-resource-prefix":this.So,"x-goog-request-params":this.bo};return this.Fo(_,r,i),this.Mo(e,o,_,n).then(function(t){return __PRIVATE_logDebug("RestConnection","Received RPC '".concat(e,"' ").concat(s,": "),t),t;},function(t){throw __PRIVATE_logWarn("RestConnection","RPC '".concat(e,"' ").concat(s," failed with error: "),t,"url: ",o,"request:",n),t;});}},{key:"xo",value:function xo(e,t,n,r,i,s){// The REST API automatically aggregates all of the streamed results, so we
// can just use the normal invoke() method.
return this.Co(e,t,n,r,i);}/**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */},{key:"Fo",value:function Fo(e,t,n){e["X-Goog-Api-Client"]=// SDK_VERSION is updated to different value at runtime depending on the entry point,
// so we need to get its value when we need it in a function.
function __PRIVATE_getGoogApiClientValue(){return "gl-js/ fire/"+b;}(),// Content-Type: text/plain will avoid preflight requests which might
// mess with CORS and redirects by proxies. If we add custom headers
// we will need to change this code to potentially use the $httpOverwrite
// parameter supported by ESF to avoid triggering preflight requests.
e["Content-Type"]="text/plain",this.databaseInfo.appId&&(e["X-Firebase-GMPID"]=this.databaseInfo.appId),t&&t.headers.forEach(function(t,n){return e[n]=t;}),n&&n.headers.forEach(function(t,n){return e[n]=t;});}},{key:"vo",value:function vo(e,t){var n=me[e];return "".concat(this.wo,"/v1/").concat(t,":").concat(n);}/**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */},{key:"terminate",value:function terminate(){// No-op
}}]);return __PRIVATE_RestConnection;}());/** The Platform's 'document' implementation or null if not available. */function getDocument(){// `document` is not always available, e.g. in ReactNative and WebWorkers.
// eslint-disable-next-line no-restricted-globals
return "undefined"!=typeof document?document:null;}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function __PRIVATE_newSerializer(e){return new JsonProtoSerializer(e,/* useProto3Json= */!0);}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */var __PRIVATE_ExponentialBackoff=/*#__PURE__*/function(){function __PRIVATE_ExponentialBackoff(/**
     * The AsyncQueue to run backoff operations on.
     */e,/**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1e3;var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1.5;var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:6e4;_classCallCheck(this,__PRIVATE_ExponentialBackoff);this.oi=e,this.timerId=t,this.No=n,this.Lo=r,this.Bo=i,this.ko=0,this.qo=null,/** The last backoff attempt, as epoch milliseconds. */this.Qo=Date.now(),this.reset();}/**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */_createClass(__PRIVATE_ExponentialBackoff,[{key:"reset",value:function reset(){this.ko=0;}/**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */},{key:"Ko",value:function Ko(){this.ko=this.Bo;}/**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */},{key:"$o",value:function $o(e){var _this163=this;// Cancel any pending backoff operation.
this.cancel();// First schedule using the current base (which may be 0 and should be
// honored as such).
var t=Math.floor(this.ko+this.Uo()),n=Math.max(0,Date.now()-this.Qo),r=Math.max(0,t-n);// Guard against lastAttemptTime being in the future due to a clock change.
r>0&&__PRIVATE_logDebug("ExponentialBackoff","Backing off for ".concat(r," ms (base delay: ").concat(this.ko," ms, delay with jitter: ").concat(t," ms, last attempt: ").concat(n," ms ago)")),this.qo=this.oi.enqueueAfterDelay(this.timerId,r,function(){return _this163.Qo=Date.now(),e();}),// Apply backoff factor to determine next delay and ensure it is within
// bounds.
this.ko*=this.Lo,this.ko<this.No&&(this.ko=this.No),this.ko>this.Bo&&(this.ko=this.Bo);}},{key:"Wo",value:function Wo(){null!==this.qo&&(this.qo.skipDelay(),this.qo=null);}},{key:"cancel",value:function cancel(){null!==this.qo&&(this.qo.cancel(),this.qo=null);}/** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */},{key:"Uo",value:function Uo(){return (Math.random()-.5)*this.ko;}}]);return __PRIVATE_ExponentialBackoff;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */var __PRIVATE_PersistentStream=/*#__PURE__*/function(){function __PRIVATE_PersistentStream(e,t,n,r,i,s,o,_){_classCallCheck(this,__PRIVATE_PersistentStream);this.oi=e,this.Go=n,this.zo=r,this.connection=i,this.authCredentialsProvider=s,this.appCheckCredentialsProvider=o,this.listener=_,this.state=0/* PersistentStreamState.Initial */,/**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */this.jo=0,this.Ho=null,this.Jo=null,this.stream=null,this.Yo=new __PRIVATE_ExponentialBackoff(e,t);}/**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */_createClass(__PRIVATE_PersistentStream,[{key:"Zo",value:function Zo(){return 1/* PersistentStreamState.Starting */===this.state||5/* PersistentStreamState.Backoff */===this.state||this.Xo();}/**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */},{key:"Xo",value:function Xo(){return 2/* PersistentStreamState.Open */===this.state||3/* PersistentStreamState.Healthy */===this.state;}/**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */},{key:"start",value:function start(){4/* PersistentStreamState.Error */!==this.state?this.auth():this.e_();}/**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */},{key:"stop",value:function(){var _stop=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee16(){return regenerator.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.t0=this.Zo();if(!_context16.t0){_context16.next=4;break;}_context16.next=4;return this.close(0/* PersistentStreamState.Initial */);case 4:case"end":return _context16.stop();}}},_callee16,this);}));function stop(){return _stop.apply(this,arguments);}return stop;}()/**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */},{key:"t_",value:function t_(){this.state=0/* PersistentStreamState.Initial */,this.Yo.reset();}/**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */},{key:"n_",value:function n_(){var _this164=this;// Starts the idle time if we are in state 'Open' and are not yet already
// running a timer (in which case the previous idle timeout still applies).
this.Xo()&&null===this.Ho&&(this.Ho=this.oi.enqueueAfterDelay(this.Go,6e4,function(){return _this164.r_();}));}/** Sends a message to the underlying stream. */},{key:"i_",value:function i_(e){this.s_(),this.stream.send(e);}/** Called by the idle timer when the stream should close due to inactivity. */},{key:"r_",value:function(){var _r_=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee17(){return regenerator.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:if(!this.Xo()){_context17.next=2;break;}return _context17.abrupt("return",this.close(0/* PersistentStreamState.Initial */));case 2:case"end":return _context17.stop();}}},_callee17,this);}));function r_(){return _r_.apply(this,arguments);}return r_;}()/** Marks the stream as active again. */},{key:"s_",value:function s_(){this.Ho&&(this.Ho.cancel(),this.Ho=null);}/** Cancels the health check delayed operation. */},{key:"o_",value:function o_(){this.Jo&&(this.Jo.cancel(),this.Jo=null);}/**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */},{key:"close",value:function(){var _close=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee18(e,t){return regenerator.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:this.s_();this.o_();this.Yo.cancel();// Invalidates any stream-related callbacks (e.g. from auth or the
// underlying stream), guaranteeing they won't execute.
this.jo++;4/* PersistentStreamState.Error */!==e?// If this is an intentional close ensure we don't delay our next connection attempt.
this.Yo.reset():t&&t.code===C.RESOURCE_EXHAUSTED?(// Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
__PRIVATE_logError(t.toString()),__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."),this.Yo.Ko()):t&&t.code===C.UNAUTHENTICATED&&3/* PersistentStreamState.Healthy */!==this.state&&(// "unauthenticated" error means the token was rejected. This should rarely
// happen since both Auth and AppCheck ensure a sufficient TTL when we
// request a token. If a user manually resets their system clock this can
// fail, however. In this case, we should get a Code.UNAUTHENTICATED error
// before we received the first message and we need to invalidate the token
// to ensure that we fetch a new token.
this.authCredentialsProvider.invalidateToken(),this.appCheckCredentialsProvider.invalidateToken());// Clean up the underlying stream because we are no longer interested in events.
null!==this.stream&&(this.__(),this.stream.close(),this.stream=null);// This state must be assigned before calling onClose() to allow the callback to
// inhibit backoff or otherwise manipulate the state in its non-started state.
this.state=e;_context18.next=9;return this.listener.Ao(t);case 9:case"end":return _context18.stop();}}},_callee18,this);}));function close(_x21,_x22){return _close.apply(this,arguments);}return close;}()/**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */},{key:"__",value:function __(){}},{key:"auth",value:function auth(){var _this165=this;this.state=1/* PersistentStreamState.Starting */;var e=this.a_(this.jo),t=this.jo;// TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
Promise.all([this.authCredentialsProvider.getToken(),this.appCheckCredentialsProvider.getToken()]).then(function(_ref22){var _ref23=_slicedToArray(_ref22,2),e=_ref23[0],n=_ref23[1];// Stream can be stopped while waiting for authentication.
// TODO(mikelehen): We really should just use dispatchIfNotClosed
// and let this dispatch onto the queue, but that opened a spec test can
// of worms that I don't want to deal with in this PR.
_this165.jo===t&&// Normally we'd have to schedule the callback on the AsyncQueue.
// However, the following calls are safe to be called outside the
// AsyncQueue since they don't chain asynchronous calls
_this165.u_(e,n);},function(t){e(function(){var e=new FirestoreError(C.UNKNOWN,"Fetching auth token failed: "+t.message);return _this165.c_(e);});});}},{key:"u_",value:function u_(e,t){var _this166=this;var n=this.a_(this.jo);this.stream=this.l_(e,t),this.stream.Po(function(){n(function(){return _this166.listener.Po();});}),this.stream.To(function(){n(function(){return _this166.state=2/* PersistentStreamState.Open */,_this166.Jo=_this166.oi.enqueueAfterDelay(_this166.zo,1e4,function(){return _this166.Xo()&&(_this166.state=3/* PersistentStreamState.Healthy */),Promise.resolve();}),_this166.listener.To();});}),this.stream.Ao(function(e){n(function(){return _this166.c_(e);});}),this.stream.onMessage(function(e){n(function(){return _this166.onMessage(e);});});}},{key:"e_",value:function e_(){var _this167=this;this.state=5/* PersistentStreamState.Backoff */,this.Yo.$o(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee19(){return regenerator.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_this167.state=0/* PersistentStreamState.Initial */,_this167.start();case 1:case"end":return _context19.stop();}}},_callee19);})));}// Visible for tests
},{key:"c_",value:function c_(e){// In theory the stream could close cleanly, however, in our current model
// we never expect this to happen because if we stop a stream ourselves,
// this callback will never be called. To prevent cases where we retry
// without a backoff accidentally, we set the stream to error in all cases.
return __PRIVATE_logDebug("PersistentStream","close with error: ".concat(e)),this.stream=null,this.close(4/* PersistentStreamState.Error */,e);}/**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */},{key:"a_",value:function a_(e){var _this168=this;return function(t){_this168.oi.enqueueAndForget(function(){return _this168.jo===e?t():(__PRIVATE_logDebug("PersistentStream","stream callback skipped by getCloseGuardedDispatcher."),Promise.resolve());});};}}]);return __PRIVATE_PersistentStream;}();/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */var __PRIVATE_PersistentListenStream=/*#__PURE__*/function(_PRIVATE_PersistentS){_inherits(__PRIVATE_PersistentListenStream,_PRIVATE_PersistentS);var _super29=_createSuper(__PRIVATE_PersistentListenStream);function __PRIVATE_PersistentListenStream(e,t,n,r,i,s){var _this169;_classCallCheck(this,__PRIVATE_PersistentListenStream);_this169=_super29.call(this,e,"listen_stream_connection_backoff"/* TimerId.ListenStreamConnectionBackoff */,"listen_stream_idle"/* TimerId.ListenStreamIdle */,"health_check_timeout"/* TimerId.HealthCheckTimeout */,t,n,r,s),_this169.serializer=i;return _this169;}_createClass(__PRIVATE_PersistentListenStream,[{key:"l_",value:function l_(e,t){return this.connection.Oo("Listen",e,t);}},{key:"onMessage",value:function onMessage(e){// A successful response means the stream is healthy
this.Yo.reset();var t=__PRIVATE_fromWatchChange(this.serializer,e),n=function __PRIVATE_versionFromListenResponse(e){// We have only reached a consistent snapshot for the entire stream if there
// is a read_time set and it applies to all targets (i.e. the list of
// targets is empty). The backend is guaranteed to send such responses.
if(!("targetChange"in e))return SnapshotVersion.min();var t=e.targetChange;return t.targetIds&&t.targetIds.length?SnapshotVersion.min():t.readTime?__PRIVATE_fromVersion(t.readTime):SnapshotVersion.min();}(e);return this.listener.h_(t,n);}/**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */},{key:"P_",value:function P_(e){var t={};t.database=__PRIVATE_getEncodedDatabaseId(this.serializer),t.addTarget=function __PRIVATE_toTarget(e,t){var n;var r=t.target;if(n=__PRIVATE_targetIsDocumentTarget(r)?{documents:__PRIVATE_toDocumentsTarget(e,r)}:{query:__PRIVATE_toQueryTarget(e,r)._t},n.targetId=t.targetId,t.resumeToken.approximateByteSize()>0){n.resumeToken=__PRIVATE_toBytes(e,t.resumeToken);var _r22=__PRIVATE_toInt32Proto(e,t.expectedCount);null!==_r22&&(n.expectedCount=_r22);}else if(t.snapshotVersion.compareTo(SnapshotVersion.min())>0){// TODO(wuandy): Consider removing above check because it is most likely true.
// Right now, many tests depend on this behaviour though (leaving min() out
// of serialization).
n.readTime=toTimestamp(e,t.snapshotVersion.toTimestamp());var _r23=__PRIVATE_toInt32Proto(e,t.expectedCount);null!==_r23&&(n.expectedCount=_r23);}return n;}(this.serializer,e);var n=__PRIVATE_toListenRequestLabels(this.serializer,e);n&&(t.labels=n),this.i_(t);}/**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */},{key:"I_",value:function I_(e){var t={};t.database=__PRIVATE_getEncodedDatabaseId(this.serializer),t.removeTarget=e,this.i_(t);}}]);return __PRIVATE_PersistentListenStream;}(__PRIVATE_PersistentStream);/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */var __PRIVATE_PersistentWriteStream=/*#__PURE__*/function(_PRIVATE_PersistentS2){_inherits(__PRIVATE_PersistentWriteStream,_PRIVATE_PersistentS2);var _super30=_createSuper(__PRIVATE_PersistentWriteStream);function __PRIVATE_PersistentWriteStream(e,t,n,r,i,s){var _this170;_classCallCheck(this,__PRIVATE_PersistentWriteStream);_this170=_super30.call(this,e,"write_stream_connection_backoff"/* TimerId.WriteStreamConnectionBackoff */,"write_stream_idle"/* TimerId.WriteStreamIdle */,"health_check_timeout"/* TimerId.HealthCheckTimeout */,t,n,r,s),_this170.serializer=i,_this170.T_=!1;return _this170;}/**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */_createClass(__PRIVATE_PersistentWriteStream,[{key:"E_",get:function get(){return this.T_;}// Override of PersistentStream.start
},{key:"start",value:function start(){this.T_=!1,this.lastStreamToken=void 0,_get(_getPrototypeOf(__PRIVATE_PersistentWriteStream.prototype),"start",this).call(this);}},{key:"__",value:function __(){this.T_&&this.d_([]);}},{key:"l_",value:function l_(e,t){return this.connection.Oo("Write",e,t);}},{key:"onMessage",value:function onMessage(e){if(// Always capture the last stream token.
__PRIVATE_hardAssert(!!e.streamToken),this.lastStreamToken=e.streamToken,this.T_){// A successful first write response means the stream is healthy,
// Note, that we could consider a successful handshake healthy, however,
// the write itself might be causing an error we want to back off from.
this.Yo.reset();var t=__PRIVATE_fromWriteResults(e.writeResults,e.commitTime),n=__PRIVATE_fromVersion(e.commitTime);return this.listener.A_(n,t);}// The first response is always the handshake response
return __PRIVATE_hardAssert(!e.writeResults||0===e.writeResults.length),this.T_=!0,this.listener.R_();}/**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */},{key:"V_",value:function V_(){// TODO(dimond): Support stream resumption. We intentionally do not set the
// stream token on the handshake, ignoring any stream token we might have.
var e={};e.database=__PRIVATE_getEncodedDatabaseId(this.serializer),this.i_(e);}/** Sends a group of mutations to the Firestore backend to apply. */},{key:"d_",value:function d_(e){var _this171=this;var t={streamToken:this.lastStreamToken,writes:e.map(function(e){return toMutation(_this171.serializer,e);})};this.i_(t);}}]);return __PRIVATE_PersistentWriteStream;}(__PRIVATE_PersistentStream);/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */var __PRIVATE_DatastoreImpl=/*#__PURE__*/function(_Datastore){_inherits(__PRIVATE_DatastoreImpl,_Datastore);var _super31=_createSuper(__PRIVATE_DatastoreImpl);function __PRIVATE_DatastoreImpl(e,t,n,r){var _this172;_classCallCheck(this,__PRIVATE_DatastoreImpl);_this172=_super31.call(this),_this172.authCredentials=e,_this172.appCheckCredentials=t,_this172.connection=n,_this172.serializer=r,_this172.m_=!1;return _this172;}_createClass(__PRIVATE_DatastoreImpl,[{key:"f_",value:function f_(){if(this.m_)throw new FirestoreError(C.FAILED_PRECONDITION,"The client has already been terminated.");}/** Invokes the provided RPC with auth and AppCheck tokens. */},{key:"Co",value:function Co(e,t,n,r){var _this173=this;return this.f_(),Promise.all([this.authCredentials.getToken(),this.appCheckCredentials.getToken()]).then(function(_ref25){var _ref26=_slicedToArray(_ref25,2),i=_ref26[0],s=_ref26[1];return _this173.connection.Co(e,__PRIVATE_toResourcePath(t,n),r,i,s);})["catch"](function(e){throw "FirebaseError"===e.name?(e.code===C.UNAUTHENTICATED&&(_this173.authCredentials.invalidateToken(),_this173.appCheckCredentials.invalidateToken()),e):new FirestoreError(C.UNKNOWN,e.toString());});}/** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */},{key:"xo",value:function xo(e,t,n,r,i){var _this174=this;return this.f_(),Promise.all([this.authCredentials.getToken(),this.appCheckCredentials.getToken()]).then(function(_ref27){var _ref28=_slicedToArray(_ref27,2),s=_ref28[0],o=_ref28[1];return _this174.connection.xo(e,__PRIVATE_toResourcePath(t,n),r,s,o,i);})["catch"](function(e){throw "FirebaseError"===e.name?(e.code===C.UNAUTHENTICATED&&(_this174.authCredentials.invalidateToken(),_this174.appCheckCredentials.invalidateToken()),e):new FirestoreError(C.UNKNOWN,e.toString());});}},{key:"terminate",value:function terminate(){this.m_=!0,this.connection.terminate();}}]);return __PRIVATE_DatastoreImpl;}(/*#__PURE__*/_createClass(function Datastore(){_classCallCheck(this,Datastore);}));// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */var __PRIVATE_OnlineStateTracker=/*#__PURE__*/function(){function __PRIVATE_OnlineStateTracker(e,t){_classCallCheck(this,__PRIVATE_OnlineStateTracker);this.asyncQueue=e,this.onlineStateHandler=t,/** The current OnlineState. */this.state="Unknown"/* OnlineState.Unknown */,/**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */this.g_=0,/**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */this.p_=null,/**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */this.y_=!0;}/**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */_createClass(__PRIVATE_OnlineStateTracker,[{key:"w_",value:function w_(){var _this175=this;0===this.g_&&(this.S_("Unknown"/* OnlineState.Unknown */),this.p_=this.asyncQueue.enqueueAfterDelay("online_state_timeout"/* TimerId.OnlineStateTimeout */,1e4,function(){return _this175.p_=null,_this175.b_("Backend didn't respond within 10 seconds."),_this175.S_("Offline"/* OnlineState.Offline */),Promise.resolve();}));}/**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */},{key:"D_",value:function D_(e){"Online"/* OnlineState.Online */===this.state?this.S_("Unknown"/* OnlineState.Unknown */):(this.g_++,this.g_>=1&&(this.C_(),this.b_("Connection failed 1 times. Most recent error: ".concat(e.toString())),this.S_("Offline"/* OnlineState.Offline */)));}/**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */},{key:"set",value:function set(e){this.C_(),this.g_=0,"Online"/* OnlineState.Online */===e&&(// We've connected to watch at least once. Don't warn the developer
// about being offline going forward.
this.y_=!1),this.S_(e);}},{key:"S_",value:function S_(e){e!==this.state&&(this.state=e,this.onlineStateHandler(e));}},{key:"b_",value:function b_(e){var t="Could not reach Cloud Firestore backend. ".concat(e,"\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.");this.y_?(__PRIVATE_logError(t),this.y_=!1):__PRIVATE_logDebug("OnlineStateTracker",t);}},{key:"C_",value:function C_(){null!==this.p_&&(this.p_.cancel(),this.p_=null);}}]);return __PRIVATE_OnlineStateTracker;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_RemoteStoreImpl=/*#__PURE__*/_createClass(function __PRIVATE_RemoteStoreImpl(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */e,/** The client-side proxy for interacting with the backend. */t,n,r,i){var _this176=this;_classCallCheck(this,__PRIVATE_RemoteStoreImpl);this.localStore=e,this.datastore=t,this.asyncQueue=n,this.remoteSyncer={},/**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */this.v_=[],/**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */this.F_=new Map(),/**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */this.M_=new Set(),/**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */this.x_=[],this.O_=i,this.O_.io(function(e){n.enqueueAndForget(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee21(){return regenerator.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.t0=__PRIVATE_canUseNetwork(_this176);if(!_context21.t0){_context21.next=5;break;}__PRIVATE_logDebug("RemoteStore","Restarting streams for network reachability change.");_context21.next=5;return function(){var _PRIVATE_restartNetwork=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee20(e){var t;return regenerator.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:t=__PRIVATE_debugCast(e);t.M_.add(4/* OfflineCause.ConnectivityChange */);_context20.next=4;return __PRIVATE_disableNetworkInternal(t);case 4:t.N_.set("Unknown"/* OnlineState.Unknown */);t.M_["delete"](4/* OfflineCause.ConnectivityChange */);_context20.next=8;return __PRIVATE_enableNetworkInternal(t);case 8:case"end":return _context20.stop();}}},_callee20);}));function __PRIVATE_restartNetwork(_x23){return _PRIVATE_restartNetwork.apply(this,arguments);}return __PRIVATE_restartNetwork;}()(_this176);case 5:case"end":return _context21.stop();}}},_callee21);})));}),this.N_=new __PRIVATE_OnlineStateTracker(n,r);});function __PRIVATE_enableNetworkInternal(_x24){return _PRIVATE_enableNetworkInternal.apply(this,arguments);}/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */function _PRIVATE_enableNetworkInternal(){_PRIVATE_enableNetworkInternal=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee83(e){var _iterator93,_step93,t;return regenerator.wrap(function _callee83$(_context83){while(1){switch(_context83.prev=_context83.next){case 0:if(!__PRIVATE_canUseNetwork(e)){_context83.next=18;break;}_iterator93=_createForOfIteratorHelper(e.x_);_context83.prev=2;_iterator93.s();case 4:if((_step93=_iterator93.n()).done){_context83.next=10;break;}t=_step93.value;_context83.next=8;return t(/* enabled= */!0);case 8:_context83.next=4;break;case 10:_context83.next=15;break;case 12:_context83.prev=12;_context83.t0=_context83["catch"](2);_iterator93.e(_context83.t0);case 15:_context83.prev=15;_iterator93.f();return _context83.finish(15);case 18:case"end":return _context83.stop();}}},_callee83,null,[[2,12,15,18]]);}));return _PRIVATE_enableNetworkInternal.apply(this,arguments);}function __PRIVATE_disableNetworkInternal(_x25){return _PRIVATE_disableNetworkInternal.apply(this,arguments);}/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */function _PRIVATE_disableNetworkInternal(){_PRIVATE_disableNetworkInternal=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee84(e){var _iterator94,_step94,t;return regenerator.wrap(function _callee84$(_context84){while(1){switch(_context84.prev=_context84.next){case 0:_iterator94=_createForOfIteratorHelper(e.x_);_context84.prev=1;_iterator94.s();case 3:if((_step94=_iterator94.n()).done){_context84.next=9;break;}t=_step94.value;_context84.next=7;return t(/* enabled= */!1);case 7:_context84.next=3;break;case 9:_context84.next=14;break;case 11:_context84.prev=11;_context84.t0=_context84["catch"](1);_iterator94.e(_context84.t0);case 14:_context84.prev=14;_iterator94.f();return _context84.finish(14);case 17:case"end":return _context84.stop();}}},_callee84,null,[[1,11,14,17]]);}));return _PRIVATE_disableNetworkInternal.apply(this,arguments);}function __PRIVATE_remoteStoreListen(e,t){var n=__PRIVATE_debugCast(e);n.F_.has(t.targetId)||(// Mark this as something the client is currently listening for.
n.F_.set(t.targetId,t),__PRIVATE_shouldStartWatchStream(n)?// The listen will be sent in onWatchStreamOpen
__PRIVATE_startWatchStream(n):__PRIVATE_ensureWatchStream(n).Xo()&&__PRIVATE_sendWatchRequest(n,t));}/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */function __PRIVATE_remoteStoreUnlisten(e,t){var n=__PRIVATE_debugCast(e),r=__PRIVATE_ensureWatchStream(n);n.F_["delete"](t),r.Xo()&&__PRIVATE_sendUnwatchRequest(n,t),0===n.F_.size&&(r.Xo()?r.n_():__PRIVATE_canUseNetwork(n)&&// Revert to OnlineState.Unknown if the watch stream is not open and we
// have no listeners, since without any listens to send we cannot
// confirm if the stream is healthy and upgrade to OnlineState.Online.
n.N_.set("Unknown"/* OnlineState.Unknown */));}/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */function __PRIVATE_sendWatchRequest(e,t){if(e.L_.xe(t.targetId),t.resumeToken.approximateByteSize()>0||t.snapshotVersion.compareTo(SnapshotVersion.min())>0){var n=e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;t=t.withExpectedCount(n);}__PRIVATE_ensureWatchStream(e).P_(t);}/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */function __PRIVATE_sendUnwatchRequest(e,t){e.L_.xe(t),__PRIVATE_ensureWatchStream(e).I_(t);}function __PRIVATE_startWatchStream(e){e.L_=new __PRIVATE_WatchChangeAggregator({getRemoteKeysForTarget:function getRemoteKeysForTarget(t){return e.remoteSyncer.getRemoteKeysForTarget(t);},ot:function ot(t){return e.F_.get(t)||null;},tt:function tt(){return e.datastore.serializer.databaseId;}}),__PRIVATE_ensureWatchStream(e).start(),e.N_.w_();}/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */function __PRIVATE_shouldStartWatchStream(e){return __PRIVATE_canUseNetwork(e)&&!__PRIVATE_ensureWatchStream(e).Zo()&&e.F_.size>0;}function __PRIVATE_canUseNetwork(e){return 0===__PRIVATE_debugCast(e).M_.size;}function __PRIVATE_cleanUpWatchStreamState(e){e.L_=void 0;}function __PRIVATE_onWatchStreamConnected(_x26){return _PRIVATE_onWatchStreamConnected.apply(this,arguments);}function _PRIVATE_onWatchStreamConnected(){_PRIVATE_onWatchStreamConnected=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee85(e){return regenerator.wrap(function _callee85$(_context85){while(1){switch(_context85.prev=_context85.next){case 0:// Mark the client as online since we got a "connected" notification.
e.N_.set("Online"/* OnlineState.Online */);case 1:case"end":return _context85.stop();}}},_callee85);}));return _PRIVATE_onWatchStreamConnected.apply(this,arguments);}function __PRIVATE_onWatchStreamOpen(_x27){return _PRIVATE_onWatchStreamOpen.apply(this,arguments);}function _PRIVATE_onWatchStreamOpen(){_PRIVATE_onWatchStreamOpen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee86(e){return regenerator.wrap(function _callee86$(_context86){while(1){switch(_context86.prev=_context86.next){case 0:e.F_.forEach(function(t,n){__PRIVATE_sendWatchRequest(e,t);});case 1:case"end":return _context86.stop();}}},_callee86);}));return _PRIVATE_onWatchStreamOpen.apply(this,arguments);}function __PRIVATE_onWatchStreamClose(_x28,_x29){return _PRIVATE_onWatchStreamClose.apply(this,arguments);}function _PRIVATE_onWatchStreamClose(){_PRIVATE_onWatchStreamClose=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee87(e,t){return regenerator.wrap(function _callee87$(_context87){while(1){switch(_context87.prev=_context87.next){case 0:__PRIVATE_cleanUpWatchStreamState(e),// If we still need the watch stream, retry the connection.
__PRIVATE_shouldStartWatchStream(e)?(e.N_.D_(t),__PRIVATE_startWatchStream(e)):// No need to restart watch stream because there are no active targets.
// The online state is set to unknown because there is no active attempt
// at establishing a connection
e.N_.set("Unknown"/* OnlineState.Unknown */);case 1:case"end":return _context87.stop();}}},_callee87);}));return _PRIVATE_onWatchStreamClose.apply(this,arguments);}function __PRIVATE_onWatchStreamChange(_x30,_x31,_x32){return _PRIVATE_onWatchStreamChange.apply(this,arguments);}/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */function _PRIVATE_onWatchStreamChange(){_PRIVATE_onWatchStreamChange=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee89(e,t,n){var _t59;return regenerator.wrap(function _callee89$(_context89){while(1){switch(_context89.prev=_context89.next){case 0:if(!(// Mark the client as online since we got a message from the server
e.N_.set("Online"/* OnlineState.Online */),t instanceof __PRIVATE_WatchTargetChange&&2/* WatchTargetChangeState.Removed */===t.state&&t.cause)){_context89.next=13;break;}_context89.prev=1;_context89.next=4;return(/** Handles an error on a target */function(){var _PRIVATE_handleTargetError=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee88(e,t){var n,_iterator95,_step95,_r42;return regenerator.wrap(function _callee88$(_context88){while(1){switch(_context88.prev=_context88.next){case 0:n=t.cause;_iterator95=_createForOfIteratorHelper(t.targetIds);_context88.prev=2;_iterator95.s();case 4:if((_step95=_iterator95.n()).done){_context88.next=14;break;}_r42=_step95.value;_context88.t0=e.F_.has(_r42);if(!_context88.t0){_context88.next=12;break;}_context88.next=10;return e.remoteSyncer.rejectListen(_r42,n);case 10:e.F_["delete"](_r42);e.L_.removeTarget(_r42);case 12:_context88.next=4;break;case 14:_context88.next=19;break;case 16:_context88.prev=16;_context88.t1=_context88["catch"](2);_iterator95.e(_context88.t1);case 19:_context88.prev=19;_iterator95.f();return _context88.finish(19);case 22:case"end":return _context88.stop();}}},_callee88,null,[[2,16,19,22]]);}));function __PRIVATE_handleTargetError(_x149,_x150){return _PRIVATE_handleTargetError.apply(this,arguments);}return __PRIVATE_handleTargetError;}()/**
 * Attempts to fill our write pipeline with writes from the LocalStore.
 *
 * Called internally to bootstrap or refill the write pipeline and by
 * SyncEngine whenever there are new mutations to process.
 *
 * Starts the write stream if necessary.
 */(e,t));case 4:_context89.next=11;break;case 6:_context89.prev=6;_context89.t0=_context89["catch"](1);__PRIVATE_logDebug("RemoteStore","Failed to remove targets %s: %s ",t.targetIds.join(","),_context89.t0);_context89.next=11;return __PRIVATE_disableNetworkUntilRecovery(e,_context89.t0);case 11:_context89.next=29;break;case 13:if(!(t instanceof __PRIVATE_DocumentWatchChange?e.L_.Ke(t):t instanceof __PRIVATE_ExistenceFilterChange?e.L_.He(t):e.L_.We(t),!n.isEqual(SnapshotVersion.min()))){_context89.next=29;break;}_context89.prev=14;_context89.next=17;return __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);case 17:_t59=_context89.sent;_context89.t1=n.compareTo(_t59)>=0;if(!_context89.t1){_context89.next=22;break;}_context89.next=22;return(/**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */function __PRIVATE_raiseWatchSnapshot(e,t){var n=e.L_.rt(t);// Update in-memory resume tokens. LocalStore will update the
// persistent view of these when applying the completed RemoteEvent.
return n.targetChanges.forEach(function(n,r){if(n.resumeToken.approximateByteSize()>0){var i=e.F_.get(r);// A watched target might have been removed already.
i&&e.F_.set(r,i.withResumeToken(n.resumeToken,t));}}),// Re-establish listens for the targets that have been invalidated by
// existence filter mismatches.
n.targetMismatches.forEach(function(t,n){var r=e.F_.get(t);if(!r)// A watched target might have been removed already.
return;// Clear the resume token for the target, since we're in a known mismatch
// state.
e.F_.set(t,r.withResumeToken(ByteString.EMPTY_BYTE_STRING,r.snapshotVersion)),// Cause a hard reset by unwatching and rewatching immediately, but
// deliberately don't send a resume token so that we get a full update.
__PRIVATE_sendUnwatchRequest(e,t);// Mark the target we send as being on behalf of an existence filter
// mismatch, but don't actually retain that in listenTargets. This ensures
// that we flag the first re-listen this way without impacting future
// listens of this target (that might happen e.g. on reconnect).
var i=new TargetData(r.target,t,n,r.sequenceNumber);__PRIVATE_sendWatchRequest(e,i);}),e.remoteSyncer.applyRemoteEvent(n);}(e,n));case 22:_context89.next=29;break;case 24:_context89.prev=24;_context89.t2=_context89["catch"](14);__PRIVATE_logDebug("RemoteStore","Failed to raise snapshot:",_context89.t2);_context89.next=29;return __PRIVATE_disableNetworkUntilRecovery(e,_context89.t2);case 29:case"end":return _context89.stop();}}},_callee89,null,[[1,6],[14,24]]);}));return _PRIVATE_onWatchStreamChange.apply(this,arguments);}function __PRIVATE_disableNetworkUntilRecovery(_x33,_x34,_x35){return _PRIVATE_disableNetworkUntilRecovery.apply(this,arguments);}/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */function _PRIVATE_disableNetworkUntilRecovery(){_PRIVATE_disableNetworkUntilRecovery=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee91(e,t,n){return regenerator.wrap(function _callee91$(_context91){while(1){switch(_context91.prev=_context91.next){case 0:if(__PRIVATE_isIndexedDbTransactionError(t)){_context91.next=2;break;}throw t;case 2:e.M_.add(1/* OfflineCause.IndexedDbFailed */);_context91.next=5;return __PRIVATE_disableNetworkInternal(e);case 5:e.N_.set("Offline"/* OnlineState.Offline */);n||(// Use a simple read operation to determine if IndexedDB recovered.
// Ideally, we would expose a health check directly on SimpleDb, but
// RemoteStore only has access to persistence through LocalStore.
n=function n(){return __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);});// Probe IndexedDB periodically and re-enable network
e.asyncQueue.enqueueRetryable(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee90(){return regenerator.wrap(function _callee90$(_context90){while(1){switch(_context90.prev=_context90.next){case 0:__PRIVATE_logDebug("RemoteStore","Retrying IndexedDB access");_context90.next=3;return n();case 3:e.M_["delete"](1/* OfflineCause.IndexedDbFailed */);_context90.next=6;return __PRIVATE_enableNetworkInternal(e);case 6:case"end":return _context90.stop();}}},_callee90);})));case 8:case"end":return _context91.stop();}}},_callee91);}));return _PRIVATE_disableNetworkUntilRecovery.apply(this,arguments);}function __PRIVATE_executeWithRecovery(e,t){return t()["catch"](function(n){return __PRIVATE_disableNetworkUntilRecovery(e,n,t);});}function __PRIVATE_fillWritePipeline(_x36){return _PRIVATE_fillWritePipeline.apply(this,arguments);}/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */function _PRIVATE_fillWritePipeline(){_PRIVATE_fillWritePipeline=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee92(e){var t,n,r,_e121;return regenerator.wrap(function _callee92$(_context92){while(1){switch(_context92.prev=_context92.next){case 0:t=__PRIVATE_debugCast(e),n=__PRIVATE_ensureWriteStream(t);r=t.v_.length>0?t.v_[t.v_.length-1].batchId:-1;case 2:if(!__PRIVATE_canAddToWritePipeline(t)){_context92.next=19;break;}_context92.prev=3;_context92.next=6;return __PRIVATE_localStoreGetNextMutationBatch(t.localStore,r);case 6:_e121=_context92.sent;if(!(null===_e121)){_context92.next=10;break;}0===t.v_.length&&n.n_();return _context92.abrupt("break",19);case 10:r=_e121.batchId,__PRIVATE_addToWritePipeline(t,_e121);_context92.next=17;break;case 13:_context92.prev=13;_context92.t0=_context92["catch"](3);_context92.next=17;return __PRIVATE_disableNetworkUntilRecovery(t,_context92.t0);case 17:_context92.next=2;break;case 19:__PRIVATE_shouldStartWriteStream(t)&&__PRIVATE_startWriteStream(t);case 20:case"end":return _context92.stop();}}},_callee92,null,[[3,13]]);}));return _PRIVATE_fillWritePipeline.apply(this,arguments);}function __PRIVATE_canAddToWritePipeline(e){return __PRIVATE_canUseNetwork(e)&&e.v_.length<10;}/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */function __PRIVATE_addToWritePipeline(e,t){e.v_.push(t);var n=__PRIVATE_ensureWriteStream(e);n.Xo()&&n.E_&&n.d_(t.mutations);}function __PRIVATE_shouldStartWriteStream(e){return __PRIVATE_canUseNetwork(e)&&!__PRIVATE_ensureWriteStream(e).Zo()&&e.v_.length>0;}function __PRIVATE_startWriteStream(e){__PRIVATE_ensureWriteStream(e).start();}function __PRIVATE_onWriteStreamOpen(_x37){return _PRIVATE_onWriteStreamOpen.apply(this,arguments);}function _PRIVATE_onWriteStreamOpen(){_PRIVATE_onWriteStreamOpen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee93(e){return regenerator.wrap(function _callee93$(_context93){while(1){switch(_context93.prev=_context93.next){case 0:__PRIVATE_ensureWriteStream(e).V_();case 1:case"end":return _context93.stop();}}},_callee93);}));return _PRIVATE_onWriteStreamOpen.apply(this,arguments);}function __PRIVATE_onWriteHandshakeComplete(_x38){return _PRIVATE_onWriteHandshakeComplete.apply(this,arguments);}function _PRIVATE_onWriteHandshakeComplete(){_PRIVATE_onWriteHandshakeComplete=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee94(e){var t,_iterator96,_step96,n;return regenerator.wrap(function _callee94$(_context94){while(1){switch(_context94.prev=_context94.next){case 0:t=__PRIVATE_ensureWriteStream(e);// Send the write pipeline now that the stream is established.
_iterator96=_createForOfIteratorHelper(e.v_);try{for(_iterator96.s();!(_step96=_iterator96.n()).done;){n=_step96.value;t.d_(n.mutations);}}catch(err){_iterator96.e(err);}finally{_iterator96.f();}case 3:case"end":return _context94.stop();}}},_callee94);}));return _PRIVATE_onWriteHandshakeComplete.apply(this,arguments);}function __PRIVATE_onMutationResult(_x39,_x40,_x41){return _PRIVATE_onMutationResult.apply(this,arguments);}function _PRIVATE_onMutationResult(){_PRIVATE_onMutationResult=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee95(e,t,n){var r,i;return regenerator.wrap(function _callee95$(_context95){while(1){switch(_context95.prev=_context95.next){case 0:r=e.v_.shift(),i=MutationBatchResult.from(r,t,n);_context95.next=3;return __PRIVATE_executeWithRecovery(e,function(){return e.remoteSyncer.applySuccessfulWrite(i);});case 3:_context95.next=5;return __PRIVATE_fillWritePipeline(e);case 5:case"end":return _context95.stop();}}},_callee95);}));return _PRIVATE_onMutationResult.apply(this,arguments);}function __PRIVATE_onWriteStreamClose(_x42,_x43){return _PRIVATE_onWriteStreamClose.apply(this,arguments);}function _PRIVATE_onWriteStreamClose(){_PRIVATE_onWriteStreamClose=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee97(e,t){return regenerator.wrap(function _callee97$(_context97){while(1){switch(_context97.prev=_context97.next){case 0:_context97.t0=t&&__PRIVATE_ensureWriteStream(e).E_;if(!_context97.t0){_context97.next=4;break;}_context97.next=4;return function(){var _PRIVATE_handleWriteError=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee96(e,t){var n;return regenerator.wrap(function _callee96$(_context96){while(1){switch(_context96.prev=_context96.next){case 0:if(!function __PRIVATE_isPermanentWriteError(e){return __PRIVATE_isPermanentError(e)&&e!==C.ABORTED;}(t.code)){_context96.next=7;break;}// This was a permanent error, the request itself was the problem
// so it's not going to succeed if we resend it.
n=e.v_.shift();// In this case it's also unlikely that the server itself is melting
// down -- this was just a bad request so inhibit backoff on the next
// restart.
__PRIVATE_ensureWriteStream(e).t_();_context96.next=5;return __PRIVATE_executeWithRecovery(e,function(){return e.remoteSyncer.rejectFailedWrite(n.batchId,t);});case 5:_context96.next=7;return __PRIVATE_fillWritePipeline(e);case 7:case"end":return _context96.stop();}}},_callee96);}));function __PRIVATE_handleWriteError(_x151,_x152){return _PRIVATE_handleWriteError.apply(this,arguments);}return __PRIVATE_handleWriteError;}()(e,t);case 4:// The write stream might have been started by refilling the write
// pipeline for failed writes
__PRIVATE_shouldStartWriteStream(e)&&__PRIVATE_startWriteStream(e);case 5:case"end":return _context97.stop();}}},_callee97);}));return _PRIVATE_onWriteStreamClose.apply(this,arguments);}function __PRIVATE_remoteStoreHandleCredentialChange(_x44,_x45){return _PRIVATE_remoteStoreHandleCredentialChange.apply(this,arguments);}/**
 * Toggles the network state when the client gains or loses its primary lease.
 */function _PRIVATE_remoteStoreHandleCredentialChange(){_PRIVATE_remoteStoreHandleCredentialChange=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee98(e,t){var n,r;return regenerator.wrap(function _callee98$(_context98){while(1){switch(_context98.prev=_context98.next){case 0:n=__PRIVATE_debugCast(e);n.asyncQueue.verifyOperationInProgress(),__PRIVATE_logDebug("RemoteStore","RemoteStore received new credentials");r=__PRIVATE_canUseNetwork(n);// Tear down and re-create our network streams. This will ensure we get a
// fresh auth token for the new user and re-fill the write pipeline with
// new mutations from the LocalStore (since mutations are per-user).
n.M_.add(3/* OfflineCause.CredentialChange */);_context98.next=6;return __PRIVATE_disableNetworkInternal(n);case 6:r&&// Don't set the network status to Unknown if we are offline.
n.N_.set("Unknown"/* OnlineState.Unknown */);_context98.next=9;return n.remoteSyncer.handleCredentialChange(t);case 9:n.M_["delete"](3/* OfflineCause.CredentialChange */);_context98.next=12;return __PRIVATE_enableNetworkInternal(n);case 12:case"end":return _context98.stop();}}},_callee98);}));return _PRIVATE_remoteStoreHandleCredentialChange.apply(this,arguments);}function __PRIVATE_remoteStoreApplyPrimaryState(_x46,_x47){return _PRIVATE_remoteStoreApplyPrimaryState.apply(this,arguments);}/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */function _PRIVATE_remoteStoreApplyPrimaryState(){_PRIVATE_remoteStoreApplyPrimaryState=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee99(e,t){var n;return regenerator.wrap(function _callee99$(_context99){while(1){switch(_context99.prev=_context99.next){case 0:n=__PRIVATE_debugCast(e);if(!t){_context99.next=7;break;}n.M_["delete"](2/* OfflineCause.IsSecondary */);_context99.next=5;return __PRIVATE_enableNetworkInternal(n);case 5:_context99.next=13;break;case 7:_context99.t0=t;if(_context99.t0){_context99.next=13;break;}n.M_.add(2/* OfflineCause.IsSecondary */);_context99.next=12;return __PRIVATE_disableNetworkInternal(n);case 12:n.N_.set("Unknown"/* OnlineState.Unknown */);case 13:case"end":return _context99.stop();}}},_callee99);}));return _PRIVATE_remoteStoreApplyPrimaryState.apply(this,arguments);}function __PRIVATE_ensureWatchStream(e){return e.B_||(// Create stream (but note that it is not started yet).
e.B_=function __PRIVATE_newPersistentWatchStream(e,t,n){var r=__PRIVATE_debugCast(e);return r.f_(),new __PRIVATE_PersistentListenStream(t,r.connection,r.authCredentials,r.appCheckCredentials,r.serializer,n);}/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */(e.datastore,e.asyncQueue,{Po:__PRIVATE_onWatchStreamConnected.bind(null,e),To:__PRIVATE_onWatchStreamOpen.bind(null,e),Ao:__PRIVATE_onWatchStreamClose.bind(null,e),h_:__PRIVATE_onWatchStreamChange.bind(null,e)}),e.x_.push(/*#__PURE__*/function(){var _ref30=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee22(t){return regenerator.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:if(!t){_context22.next=4;break;}e.B_.t_(),__PRIVATE_shouldStartWatchStream(e)?__PRIVATE_startWatchStream(e):e.N_.set("Unknown"/* OnlineState.Unknown */);_context22.next=7;break;case 4:_context22.next=6;return e.B_.stop();case 6:__PRIVATE_cleanUpWatchStreamState(e);case 7:case"end":return _context22.stop();}}},_callee22);}));return function(_x48){return _ref30.apply(this,arguments);};}())),e.B_;}/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */function __PRIVATE_ensureWriteStream(e){return e.k_||(// Create stream (but note that it is not started yet).
e.k_=function __PRIVATE_newPersistentWriteStream(e,t,n){var r=__PRIVATE_debugCast(e);return r.f_(),new __PRIVATE_PersistentWriteStream(t,r.connection,r.authCredentials,r.appCheckCredentials,r.serializer,n);}(e.datastore,e.asyncQueue,{Po:function Po(){return Promise.resolve();},To:__PRIVATE_onWriteStreamOpen.bind(null,e),Ao:__PRIVATE_onWriteStreamClose.bind(null,e),R_:__PRIVATE_onWriteHandshakeComplete.bind(null,e),A_:__PRIVATE_onMutationResult.bind(null,e)}),e.x_.push(/*#__PURE__*/function(){var _ref31=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee23(t){return regenerator.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:if(!t){_context23.next=6;break;}e.k_.t_();_context23.next=4;return __PRIVATE_fillWritePipeline(e);case 4:_context23.next=9;break;case 6:_context23.next=8;return e.k_.stop();case 8:e.v_.length>0&&(__PRIVATE_logDebug("RemoteStore","Stopping write stream with ".concat(e.v_.length," pending writes")),e.v_=[]);case 9:case"end":return _context23.stop();}}},_callee23);}));return function(_x49){return _ref31.apply(this,arguments);};}())),e.k_;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */var DelayedOperation=/*#__PURE__*/function(){function DelayedOperation(e,t,n,r,i){_classCallCheck(this,DelayedOperation);this.asyncQueue=e,this.timerId=t,this.targetTimeMs=n,this.op=r,this.removalCallback=i,this.deferred=new __PRIVATE_Deferred(),this.then=this.deferred.promise.then.bind(this.deferred.promise),// It's normal for the deferred promise to be canceled (due to cancellation)
// and so we attach a dummy catch callback to avoid
// 'UnhandledPromiseRejectionWarning' log spam.
this.deferred.promise["catch"](function(e){});}_createClass(DelayedOperation,[{key:"promise",get:function get(){return this.deferred.promise;}/**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */},{key:"start",value:/**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */function start(e){var _this177=this;this.timerHandle=setTimeout(function(){return _this177.handleDelayElapsed();},e);}/**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */},{key:"skipDelay",value:function skipDelay(){return this.handleDelayElapsed();}/**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */},{key:"cancel",value:function cancel(e){null!==this.timerHandle&&(this.clearTimeout(),this.deferred.reject(new FirestoreError(C.CANCELLED,"Operation cancelled"+(e?": "+e:""))));}},{key:"handleDelayElapsed",value:function handleDelayElapsed(){var _this178=this;this.asyncQueue.enqueueAndForget(function(){return null!==_this178.timerHandle?(_this178.clearTimeout(),_this178.op().then(function(e){return _this178.deferred.resolve(e);})):Promise.resolve();});}},{key:"clearTimeout",value:function(_clearTimeout){function clearTimeout(){return _clearTimeout.apply(this,arguments);}clearTimeout.toString=function(){return _clearTimeout.toString();};return clearTimeout;}(function(){null!==this.timerHandle&&(this.removalCallback(this),clearTimeout(this.timerHandle),this.timerHandle=null);})}],[{key:"createAndSchedule",value:function createAndSchedule(e,t,n,r,i){var s=Date.now()+n,o=new DelayedOperation(e,t,s,r,i);return o.start(n),o;}}]);return DelayedOperation;}();/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */function __PRIVATE_wrapInUserErrorIfRecoverable(e,t){if(__PRIVATE_logError("AsyncQueue","".concat(t,": ").concat(e)),__PRIVATE_isIndexedDbTransactionError(e))return new FirestoreError(C.UNAVAILABLE,"".concat(t,": ").concat(e));throw e;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */var DocumentSet=/*#__PURE__*/function(){/** The default ordering is by key if the comparator is omitted */function DocumentSet(e){_classCallCheck(this,DocumentSet);// We are adding document key comparator to the end as it's the only
// guaranteed unique property of a document.
this.comparator=e?function(t,n){return e(t,n)||DocumentKey.comparator(t.key,n.key);}:function(e,t){return DocumentKey.comparator(e.key,t.key);},this.keyedMap=documentMap(),this.sortedSet=new SortedMap(this.comparator);}/**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */_createClass(DocumentSet,[{key:"has",value:function has(e){return null!=this.keyedMap.get(e);}},{key:"get",value:function get(e){return this.keyedMap.get(e);}},{key:"first",value:function first(){return this.sortedSet.minKey();}},{key:"last",value:function last(){return this.sortedSet.maxKey();}},{key:"isEmpty",value:function isEmpty(){return this.sortedSet.isEmpty();}/**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */},{key:"indexOf",value:function indexOf(e){var t=this.keyedMap.get(e);return t?this.sortedSet.indexOf(t):-1;}},{key:"size",get:function get(){return this.sortedSet.size;}/** Iterates documents in order defined by "comparator" */},{key:"forEach",value:function forEach(e){this.sortedSet.inorderTraversal(function(t,n){return e(t),!1;});}/** Inserts or updates a document with the same key */},{key:"add",value:function add(e){// First remove the element if we have it.
var t=this["delete"](e.key);return t.copy(t.keyedMap.insert(e.key,e),t.sortedSet.insert(e,null));}/** Deletes a document with a given key */},{key:"delete",value:function _delete(e){var t=this.get(e);return t?this.copy(this.keyedMap.remove(e),this.sortedSet.remove(t)):this;}},{key:"isEqual",value:function isEqual(e){if(!(e instanceof DocumentSet))return !1;if(this.size!==e.size)return !1;var t=this.sortedSet.getIterator(),n=e.sortedSet.getIterator();for(;t.hasNext();){var _e90=t.getNext().key,r=n.getNext().key;if(!_e90.isEqual(r))return !1;}return !0;}},{key:"toString",value:function toString(){var e=[];return this.forEach(function(t){e.push(t.toString());}),0===e.length?"DocumentSet ()":"DocumentSet (\n  "+e.join("  \n")+"\n)";}},{key:"copy",value:function copy(e,t){var n=new DocumentSet();return n.comparator=this.comparator,n.keyedMap=e,n.sortedSet=t,n;}}],[{key:"emptySet",value:function emptySet(e){return new DocumentSet(e.comparator);}}]);return DocumentSet;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */var __PRIVATE_DocumentChangeSet=/*#__PURE__*/function(){function __PRIVATE_DocumentChangeSet(){_classCallCheck(this,__PRIVATE_DocumentChangeSet);this.q_=new SortedMap(DocumentKey.comparator);}_createClass(__PRIVATE_DocumentChangeSet,[{key:"track",value:function track(e){var t=e.doc.key,n=this.q_.get(t);n?// Merge the new change with the existing change.
0/* ChangeType.Added */!==e.type&&3/* ChangeType.Metadata */===n.type?this.q_=this.q_.insert(t,e):3/* ChangeType.Metadata */===e.type&&1/* ChangeType.Removed */!==n.type?this.q_=this.q_.insert(t,{type:n.type,doc:e.doc}):2/* ChangeType.Modified */===e.type&&2/* ChangeType.Modified */===n.type?this.q_=this.q_.insert(t,{type:2/* ChangeType.Modified */,doc:e.doc}):2/* ChangeType.Modified */===e.type&&0/* ChangeType.Added */===n.type?this.q_=this.q_.insert(t,{type:0/* ChangeType.Added */,doc:e.doc}):1/* ChangeType.Removed */===e.type&&0/* ChangeType.Added */===n.type?this.q_=this.q_.remove(t):1/* ChangeType.Removed */===e.type&&2/* ChangeType.Modified */===n.type?this.q_=this.q_.insert(t,{type:1/* ChangeType.Removed */,doc:n.doc}):0/* ChangeType.Added */===e.type&&1/* ChangeType.Removed */===n.type?this.q_=this.q_.insert(t,{type:2/* ChangeType.Modified */,doc:e.doc}):// This includes these cases, which don't make sense:
// Added->Added
// Removed->Removed
// Modified->Added
// Removed->Modified
// Metadata->Added
// Removed->Metadata
fail():this.q_=this.q_.insert(t,e);}},{key:"Q_",value:function Q_(){var e=[];return this.q_.inorderTraversal(function(t,n){e.push(n);}),e;}}]);return __PRIVATE_DocumentChangeSet;}();var ViewSnapshot=/*#__PURE__*/function(){function ViewSnapshot(e,t,n,r,i,s,o,_,a){_classCallCheck(this,ViewSnapshot);this.query=e,this.docs=t,this.oldDocs=n,this.docChanges=r,this.mutatedKeys=i,this.fromCache=s,this.syncStateChanged=o,this.excludesMetadataChanges=_,this.hasCachedResults=a;}/** Returns a view snapshot as if all documents in the snapshot were added. */_createClass(ViewSnapshot,[{key:"hasPendingWrites",get:function get(){return !this.mutatedKeys.isEmpty();}},{key:"isEqual",value:function isEqual(e){if(!(this.fromCache===e.fromCache&&this.hasCachedResults===e.hasCachedResults&&this.syncStateChanged===e.syncStateChanged&&this.mutatedKeys.isEqual(e.mutatedKeys)&&__PRIVATE_queryEquals(this.query,e.query)&&this.docs.isEqual(e.docs)&&this.oldDocs.isEqual(e.oldDocs)))return !1;var t=this.docChanges,n=e.docChanges;if(t.length!==n.length)return !1;for(var _e91=0;_e91<t.length;_e91++){if(t[_e91].type!==n[_e91].type||!t[_e91].doc.isEqual(n[_e91].doc))return !1;}return !0;}}],[{key:"fromInitialDocuments",value:function fromInitialDocuments(e,t,n,r,i){var s=[];return t.forEach(function(e){s.push({type:0/* ChangeType.Added */,doc:e});}),new ViewSnapshot(e,t,DocumentSet.emptySet(t),s,n,r,/* syncStateChanged= */!0,/* excludesMetadataChanges= */!1,i);}}]);return ViewSnapshot;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */var __PRIVATE_QueryListenersInfo=/*#__PURE__*/function(){function __PRIVATE_QueryListenersInfo(){_classCallCheck(this,__PRIVATE_QueryListenersInfo);this.K_=void 0,this.U_=[];}// Helper methods that checks if the query has listeners that listening to remote store
_createClass(__PRIVATE_QueryListenersInfo,[{key:"W_",value:function W_(){return this.U_.some(function(e){return e.G_();});}}]);return __PRIVATE_QueryListenersInfo;}();var __PRIVATE_EventManagerImpl=/*#__PURE__*/_createClass(function __PRIVATE_EventManagerImpl(){_classCallCheck(this,__PRIVATE_EventManagerImpl);this.queries=new ObjectMap(function(e){return __PRIVATE_canonifyQuery(e);},__PRIVATE_queryEquals),this.onlineState="Unknown"/* OnlineState.Unknown */,this.z_=new Set();});function __PRIVATE_eventManagerListen(_x50,_x51){return _PRIVATE_eventManagerListen.apply(this,arguments);}function _PRIVATE_eventManagerListen(){_PRIVATE_eventManagerListen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee100(e,t){var n,r,i,s,_n39;return regenerator.wrap(function _callee100$(_context100){while(1){switch(_context100.prev=_context100.next){case 0:n=__PRIVATE_debugCast(e);r=3;i=t.query;s=n.queries.get(i);s?!s.W_()&&t.G_()&&(// Query has been listening to local cache, and tries to add a new listener sourced from watch.
r=2/* ListenerSetupAction.RequireWatchConnectionOnly */):(s=new __PRIVATE_QueryListenersInfo(),r=t.G_()?0/* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */:1/* ListenerSetupAction.InitializeLocalListenOnly */);_context100.prev=5;_context100.t0=r;_context100.next=_context100.t0===0/* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */?9:_context100.t0===1/* ListenerSetupAction.InitializeLocalListenOnly */?13:_context100.t0===2/* ListenerSetupAction.RequireWatchConnectionOnly */?17:19;break;case 9:_context100.next=11;return n.onListen(i,/** enableRemoteListen= */!0);case 11:s.K_=_context100.sent;return _context100.abrupt("break",19);case 13:_context100.next=15;return n.onListen(i,/** enableRemoteListen= */!1);case 15:s.K_=_context100.sent;return _context100.abrupt("break",19);case 17:_context100.next=19;return n.onFirstRemoteStoreListen(i);case 19:_context100.next=25;break;case 21:_context100.prev=21;_context100.t1=_context100["catch"](5);_n39=__PRIVATE_wrapInUserErrorIfRecoverable(_context100.t1,"Initialization of query '".concat(__PRIVATE_stringifyQuery(t.query),"' failed"));return _context100.abrupt("return",void t.onError(_n39));case 25:if(n.queries.set(i,s),s.U_.push(t),// Run global snapshot listeners if a consistent snapshot has been emitted.
t.j_(n.onlineState),s.K_){t.H_(s.K_)&&__PRIVATE_raiseSnapshotsInSyncEvent(n);}case 26:case"end":return _context100.stop();}}},_callee100,null,[[5,21]]);}));return _PRIVATE_eventManagerListen.apply(this,arguments);}function __PRIVATE_eventManagerUnlisten(_x52,_x53){return _PRIVATE_eventManagerUnlisten.apply(this,arguments);}function _PRIVATE_eventManagerUnlisten(){_PRIVATE_eventManagerUnlisten=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee101(e,t){var n,r,i,s,_e122;return regenerator.wrap(function _callee101$(_context101){while(1){switch(_context101.prev=_context101.next){case 0:n=__PRIVATE_debugCast(e),r=t.query;i=3;s=n.queries.get(r);if(s){_e122=s.U_.indexOf(t);_e122>=0&&(s.U_.splice(_e122,1),0===s.U_.length?i=t.G_()?0/* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */:1/* ListenerRemovalAction.TerminateLocalListenOnly */:!s.W_()&&t.G_()&&(// The removed listener is the last one that sourced from watch.
i=2/* ListenerRemovalAction.RequireWatchDisconnectionOnly */));}_context101.t0=i;_context101.next=_context101.t0===0/* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */?7:_context101.t0===1/* ListenerRemovalAction.TerminateLocalListenOnly */?8:_context101.t0===2/* ListenerRemovalAction.RequireWatchDisconnectionOnly */?9:10;break;case 7:return _context101.abrupt("return",(n.queries["delete"](r),n.onUnlisten(r,/** disableRemoteListen= */!0)));case 8:return _context101.abrupt("return",(n.queries["delete"](r),n.onUnlisten(r,/** disableRemoteListen= */!1)));case 9:return _context101.abrupt("return",n.onLastRemoteStoreUnlisten(r));case 10:return _context101.abrupt("return");case 11:case"end":return _context101.stop();}}},_callee101);}));return _PRIVATE_eventManagerUnlisten.apply(this,arguments);}function __PRIVATE_eventManagerOnWatchChange(e,t){var n=__PRIVATE_debugCast(e);var r=!1;var _iterator64=_createForOfIteratorHelper(t),_step64;try{for(_iterator64.s();!(_step64=_iterator64.n()).done;){var _e92=_step64.value;var _t45=_e92.query,i=n.queries.get(_t45);if(i){var _iterator65=_createForOfIteratorHelper(i.U_),_step65;try{for(_iterator65.s();!(_step65=_iterator65.n()).done;){var _t46=_step65.value;_t46.H_(_e92)&&(r=!0);}}catch(err){_iterator65.e(err);}finally{_iterator65.f();}i.K_=_e92;}}}catch(err){_iterator64.e(err);}finally{_iterator64.f();}r&&__PRIVATE_raiseSnapshotsInSyncEvent(n);}function __PRIVATE_eventManagerOnWatchError(e,t,n){var r=__PRIVATE_debugCast(e),i=r.queries.get(t);if(i){var _iterator66=_createForOfIteratorHelper(i.U_),_step66;try{for(_iterator66.s();!(_step66=_iterator66.n()).done;){var _e93=_step66.value;_e93.onError(n);}}catch(err){_iterator66.e(err);}finally{_iterator66.f();}}// Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
// after an error.
r.queries["delete"](t);}// Call all global snapshot listeners that have been set.
function __PRIVATE_raiseSnapshotsInSyncEvent(e){e.z_.forEach(function(e){e.next();});}var ge,pe;/** Listen to both cache and server changes */(pe=ge||(ge={})).J_="default",/** Listen to changes in cache only */pe.Cache="cache";/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */var __PRIVATE_QueryListener=/*#__PURE__*/function(){function __PRIVATE_QueryListener(e,t,n){_classCallCheck(this,__PRIVATE_QueryListener);this.query=e,this.Y_=t,/**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */this.Z_=!1,this.X_=null,this.onlineState="Unknown"/* OnlineState.Unknown */,this.options=n||{};}/**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */_createClass(__PRIVATE_QueryListener,[{key:"H_",value:function H_(e){if(!this.options.includeMetadataChanges){// Remove the metadata only changes.
var _t47=[];var _iterator67=_createForOfIteratorHelper(e.docChanges),_step67;try{for(_iterator67.s();!(_step67=_iterator67.n()).done;){var n=_step67.value;3/* ChangeType.Metadata */!==n.type&&_t47.push(n);}}catch(err){_iterator67.e(err);}finally{_iterator67.f();}e=new ViewSnapshot(e.query,e.docs,e.oldDocs,_t47,e.mutatedKeys,e.fromCache,e.syncStateChanged,/* excludesMetadataChanges= */!0,e.hasCachedResults);}var t=!1;return this.Z_?this.ea(e)&&(this.Y_.next(e),t=!0):this.ta(e,this.onlineState)&&(this.na(e),t=!0),this.X_=e,t;}},{key:"onError",value:function onError(e){this.Y_.error(e);}/** Returns whether a snapshot was raised. */},{key:"j_",value:function j_(e){this.onlineState=e;var t=!1;return this.X_&&!this.Z_&&this.ta(this.X_,e)&&(this.na(this.X_),t=!0),t;}},{key:"ta",value:function ta(e,t){// Always raise the first event when we're synced
if(!e.fromCache)return !0;// Always raise event if listening to cache
if(!this.G_())return !0;// NOTE: We consider OnlineState.Unknown as online (it should become Offline
// or Online if we wait long enough).
var n="Offline"/* OnlineState.Offline */!==t;// Don't raise the event if we're online, aren't synced yet (checked
// above) and are waiting for a sync.
return (!this.options.ra||!n)&&(!e.docs.isEmpty()||e.hasCachedResults||"Offline"/* OnlineState.Offline */===t);// Raise data from cache if we have any documents, have cached results before,
// or we are offline.
}},{key:"ea",value:function ea(e){// We don't need to handle includeDocumentMetadataChanges here because
// the Metadata only changes have already been stripped out if needed.
// At this point the only changes we will see are the ones we should
// propagate.
if(e.docChanges.length>0)return !0;var t=this.X_&&this.X_.hasPendingWrites!==e.hasPendingWrites;return !(!e.syncStateChanged&&!t)&&!0===this.options.includeMetadataChanges;// Generally we should have hit one of the cases above, but it's possible
// to get here if there were only metadata docChanges and they got
// stripped out.
}},{key:"na",value:function na(e){e=ViewSnapshot.fromInitialDocuments(e.query,e.docs,e.mutatedKeys,e.fromCache,e.hasCachedResults),this.Z_=!0,this.Y_.next(e);}},{key:"G_",value:function G_(){return this.options.source!==ge.Cache;}}]);return __PRIVATE_QueryListener;}();/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_AddedLimboDocument=/*#__PURE__*/_createClass(function __PRIVATE_AddedLimboDocument(e){_classCallCheck(this,__PRIVATE_AddedLimboDocument);this.key=e;});var __PRIVATE_RemovedLimboDocument=/*#__PURE__*/_createClass(function __PRIVATE_RemovedLimboDocument(e){_classCallCheck(this,__PRIVATE_RemovedLimboDocument);this.key=e;});/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */var __PRIVATE_View=/*#__PURE__*/function(){function __PRIVATE_View(e,/** Documents included in the remote target */t){_classCallCheck(this,__PRIVATE_View);this.query=e,this.la=t,this.ha=null,this.hasCachedResults=!1,/**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */this.current=!1,/** Documents in the view but not in the remote target */this.Pa=__PRIVATE_documentKeySet(),/** Document Keys that have local changes */this.mutatedKeys=__PRIVATE_documentKeySet(),this.Ia=__PRIVATE_newQueryComparator(e),this.Ta=new DocumentSet(this.Ia);}/**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */_createClass(__PRIVATE_View,[{key:"Ea",get:function get(){return this.la;}/**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */},{key:"da",value:function da(e,t){var _this179=this;var n=t?t.Aa:new __PRIVATE_DocumentChangeSet(),r=t?t.Ta:this.Ta;var i=t?t.mutatedKeys:this.mutatedKeys,s=r,o=!1;// Track the last doc in a (full) limit. This is necessary, because some
// update (a delete, or an update moving a doc past the old limit) might
// mean there is some other document in the local cache that either should
// come (1) between the old last limit doc and the new last document, in the
// case of updates, or (2) after the new last document, in the case of
// deletes. So we keep this doc at the old limit to compare the updates to.
// Note that this should never get used in a refill (when previousChanges is
// set), because there will only be adds -- no deletes or updates.
var _="F"/* LimitType.First */===this.query.limitType&&r.size===this.query.limit?r.last():null,a="L"/* LimitType.Last */===this.query.limitType&&r.size===this.query.limit?r.first():null;// Drop documents out to meet limit/limitToLast requirement.
if(e.inorderTraversal(function(e,t){var u=r.get(e),c=__PRIVATE_queryMatches(_this179.query,t)?t:null,l=!!u&&_this179.mutatedKeys.has(u.key),h=!!c&&(c.hasLocalMutations||// We only consider committed mutations for documents that were
// mutated during the lifetime of the view.
_this179.mutatedKeys.has(c.key)&&c.hasCommittedMutations);var P=!1;// Calculate change
if(u&&c){u.data.isEqual(c.data)?l!==h&&(n.track({type:3/* ChangeType.Metadata */,doc:c}),P=!0):_this179.Ra(u,c)||(n.track({type:2/* ChangeType.Modified */,doc:c}),P=!0,(_&&_this179.Ia(c,_)>0||a&&_this179.Ia(c,a)<0)&&(// This doc moved from inside the limit to outside the limit.
// That means there may be some other doc in the local cache
// that should be included instead.
o=!0));}else !u&&c?(n.track({type:0/* ChangeType.Added */,doc:c}),P=!0):u&&!c&&(n.track({type:1/* ChangeType.Removed */,doc:u}),P=!0,(_||a)&&(// A doc was removed from a full limit query. We'll need to
// requery from the local cache to see if we know about some other
// doc that should be in the results.
o=!0));P&&(c?(s=s.add(c),i=h?i.add(e):i["delete"](e)):(s=s["delete"](e),i=i["delete"](e)));}),null!==this.query.limit)for(;s.size>this.query.limit;){var _e96="F"/* LimitType.First */===this.query.limitType?s.last():s.first();s=s["delete"](_e96.key),i=i["delete"](_e96.key),n.track({type:1/* ChangeType.Removed */,doc:_e96});}return {Ta:s,Aa:n,Xi:o,mutatedKeys:i};}},{key:"Ra",value:function Ra(e,t){// We suppress the initial change event for documents that were modified as
// part of a write acknowledgment (e.g. when the value of a server transform
// is applied) as Watch will send us the same document again.
// By suppressing the event, we only raise two user visible events (one with
// `hasPendingWrites` and the final state of the document) instead of three
// (one with `hasPendingWrites`, the modified document with
// `hasPendingWrites` and the final state of the document).
return e.hasLocalMutations&&t.hasCommittedMutations&&!t.hasLocalMutations;}/**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
},{key:"applyChanges",value:function applyChanges(e,t,n,r){var _this180=this;var i=this.Ta;this.Ta=e.Ta,this.mutatedKeys=e.mutatedKeys;// Sort changes based on type and query comparator
var s=e.Aa.Q_();s.sort(function(e,t){return function __PRIVATE_compareChangeType(e,t){var order=function order(e){switch(e){case 0/* ChangeType.Added */:return 1;case 2/* ChangeType.Modified */:case 3/* ChangeType.Metadata */:// A metadata change is converted to a modified change at the public
// api layer.  Since we sort by document key and then change type,
// metadata and modified changes must be sorted equivalently.
return 2;case 1/* ChangeType.Removed */:return 0;default:return fail();}};return order(e)-order(t);}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */(e.type,t.type)||_this180.Ia(e.doc,t.doc);}),this.Va(n),r=null!=r&&r;var o=t&&!r?this.ma():[],_=0===this.Pa.size&&this.current&&!r?1/* SyncState.Synced */:0/* SyncState.Local */,a=_!==this.ha;// We are at synced state if there is no limbo docs are waiting to be resolved, view is current
// with the backend, and the query is not pending to reset due to existence filter mismatch.
if(this.ha=_,0!==s.length||a){return {snapshot:new ViewSnapshot(this.query,e.Ta,i,s,e.mutatedKeys,0/* SyncState.Local */===_,a,/* excludesMetadataChanges= */!1,!!n&&n.resumeToken.approximateByteSize()>0),fa:o};}// no changes
return {fa:o};}/**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */},{key:"j_",value:function j_(e){return this.current&&"Offline"/* OnlineState.Offline */===e?(// If we're offline, set `current` to false and then call applyChanges()
// to refresh our syncState and generate a ViewChange as appropriate. We
// are guaranteed to get a new TargetChange that sets `current` back to
// true once the client is back online.
this.current=!1,this.applyChanges({Ta:this.Ta,Aa:new __PRIVATE_DocumentChangeSet(),mutatedKeys:this.mutatedKeys,Xi:!1},/* limboResolutionEnabled= */!1)):{fa:[]};}/**
     * Returns whether the doc for the given key should be in limbo.
     */},{key:"ga",value:function ga(e){// If the remote end says it's part of this query, it's not in limbo.
return !this.la.has(e)&&// The local store doesn't think it's a result, so it shouldn't be in limbo.
!!this.Ta.has(e)&&!this.Ta.get(e).hasLocalMutations;}/**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */},{key:"Va",value:function Va(e){var _this181=this;e&&(e.addedDocuments.forEach(function(e){return _this181.la=_this181.la.add(e);}),e.modifiedDocuments.forEach(function(e){}),e.removedDocuments.forEach(function(e){return _this181.la=_this181.la["delete"](e);}),this.current=e.current);}},{key:"ma",value:function ma(){var _this182=this;// We can only determine limbo documents when we're in-sync with the server.
if(!this.current)return [];// TODO(klimt): Do this incrementally so that it's not quadratic when
// updating many documents.
var e=this.Pa;this.Pa=__PRIVATE_documentKeySet(),this.Ta.forEach(function(e){_this182.ga(e.key)&&(_this182.Pa=_this182.Pa.add(e.key));});// Diff the new limbo docs with the old limbo docs.
var t=[];return e.forEach(function(e){_this182.Pa.has(e)||t.push(new __PRIVATE_RemovedLimboDocument(e));}),this.Pa.forEach(function(n){e.has(n)||t.push(new __PRIVATE_AddedLimboDocument(n));}),t;}/**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
},{key:"pa",value:function pa(e){this.la=e.hs,this.Pa=__PRIVATE_documentKeySet();var t=this.da(e.documents);return this.applyChanges(t,/* limboResolutionEnabled= */!0);}/**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
},{key:"ya",value:function ya(){return ViewSnapshot.fromInitialDocuments(this.query,this.Ta,this.mutatedKeys,0/* SyncState.Local */===this.ha,this.hasCachedResults);}}]);return __PRIVATE_View;}();/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */var __PRIVATE_QueryView=/*#__PURE__*/_createClass(function __PRIVATE_QueryView(/**
     * The query itself.
     */e,/**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */t,/**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */n){_classCallCheck(this,__PRIVATE_QueryView);this.query=e,this.targetId=t,this.view=n;});/** Tracks a limbo resolution. */var LimboResolution=/*#__PURE__*/_createClass(function LimboResolution(e){_classCallCheck(this,LimboResolution);this.key=e,/**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */this.wa=!1;});/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */var __PRIVATE_SyncEngineImpl=/*#__PURE__*/function(){function __PRIVATE_SyncEngineImpl(e,t,n,// PORTING NOTE: Manages state synchronization in multi-tab environments.
r,i,s){_classCallCheck(this,__PRIVATE_SyncEngineImpl);this.localStore=e,this.remoteStore=t,this.eventManager=n,this.sharedClientState=r,this.currentUser=i,this.maxConcurrentLimboResolutions=s,this.Sa={},this.ba=new ObjectMap(function(e){return __PRIVATE_canonifyQuery(e);},__PRIVATE_queryEquals),this.Da=new Map(),/**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */this.Ca=new Set(),/**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */this.va=new SortedMap(DocumentKey.comparator),/**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */this.Fa=new Map(),this.Ma=new __PRIVATE_ReferenceSet(),/** Stores user completion handlers, indexed by User and BatchId. */this.xa={},/** Stores user callbacks waiting for all pending writes to be acknowledged. */this.Oa=new Map(),this.Na=__PRIVATE_TargetIdGenerator.Ln(),this.onlineState="Unknown"/* OnlineState.Unknown */,// The primary state is set to `true` or `false` immediately after Firestore
// startup. In the interim, a client should only be considered primary if
// `isPrimary` is true.
this.La=void 0;}_createClass(__PRIVATE_SyncEngineImpl,[{key:"isPrimaryClient",get:function get(){return !0===this.La;}}]);return __PRIVATE_SyncEngineImpl;}();/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */function __PRIVATE_syncEngineListen(_x54,_x55){return _PRIVATE_syncEngineListen.apply(this,arguments);}/** Query has been listening to the cache, and tries to initiate the remote store listen */function _PRIVATE_syncEngineListen(){_PRIVATE_syncEngineListen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee102(e,t){var n,r,i,s,_args102=arguments;return regenerator.wrap(function _callee102$(_context102){while(1){switch(_context102.prev=_context102.next){case 0:n=_args102.length>2&&_args102[2]!==undefined?_args102[2]:!0;r=__PRIVATE_ensureWatchCallbacks(e);s=r.ba.get(t);if(!s){_context102.next=7;break;}// PORTING NOTE: With Multi-Tab Web, it is possible that a query view
// already exists when EventManager calls us for the first time. This
// happens when the primary tab is already listening to this query on
// behalf of another tab and the user of the primary also starts listening
// to the query. EventManager will not have an assigned target ID in this
// case and calls `listen` to obtain this ID.
r.sharedClientState.addLocalQueryTarget(s.targetId),i=s.view.ya();_context102.next=10;break;case 7:_context102.next=9;return __PRIVATE_allocateTargetAndMaybeListen(r,t,n,/** shouldInitializeView= */!0);case 9:i=_context102.sent;case 10:return _context102.abrupt("return",i);case 11:case"end":return _context102.stop();}}},_callee102);}));return _PRIVATE_syncEngineListen.apply(this,arguments);}function __PRIVATE_triggerRemoteStoreListen(_x56,_x57){return _PRIVATE_triggerRemoteStoreListen.apply(this,arguments);}function _PRIVATE_triggerRemoteStoreListen(){_PRIVATE_triggerRemoteStoreListen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee103(e,t){var n;return regenerator.wrap(function _callee103$(_context103){while(1){switch(_context103.prev=_context103.next){case 0:n=__PRIVATE_ensureWatchCallbacks(e);_context103.next=3;return __PRIVATE_allocateTargetAndMaybeListen(n,t,/** shouldListenToRemote= */!0,/** shouldInitializeView= */!1);case 3:case"end":return _context103.stop();}}},_callee103);}));return _PRIVATE_triggerRemoteStoreListen.apply(this,arguments);}function __PRIVATE_allocateTargetAndMaybeListen(_x58,_x59,_x60,_x61){return _PRIVATE_allocateTargetAndMaybeListen.apply(this,arguments);}/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */function _PRIVATE_allocateTargetAndMaybeListen(){_PRIVATE_allocateTargetAndMaybeListen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee104(e,t,n,r){var i,s,o,_;return regenerator.wrap(function _callee104$(_context104){while(1){switch(_context104.prev=_context104.next){case 0:_context104.next=2;return __PRIVATE_localStoreAllocateTarget(e.localStore,__PRIVATE_queryToTarget(t));case 2:i=_context104.sent;s=i.targetId;o=n?e.sharedClientState.addLocalQueryTarget(s):"not-current";_context104.t0=r;if(!_context104.t0){_context104.next=10;break;}_context104.next=9;return __PRIVATE_initializeViewAndComputeSnapshot(e,t,s,"current"===o,i.resumeToken);case 9:_=_context104.sent;case 10:e.isPrimaryClient&&n&&__PRIVATE_remoteStoreListen(e.remoteStore,i);return _context104.abrupt("return",_);case 12:case"end":return _context104.stop();}}},_callee104);}));return _PRIVATE_allocateTargetAndMaybeListen.apply(this,arguments);}function __PRIVATE_initializeViewAndComputeSnapshot(_x62,_x63,_x64,_x65,_x66){return _PRIVATE_initializeViewAndComputeSnapshot.apply(this,arguments);}/** Stops listening to the query. */function _PRIVATE_initializeViewAndComputeSnapshot(){_PRIVATE_initializeViewAndComputeSnapshot=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee106(e,t,n,r,i){var s,o,_,a,u,c;return regenerator.wrap(function _callee106$(_context106){while(1){switch(_context106.prev=_context106.next){case 0:// PORTING NOTE: On Web only, we inject the code that registers new Limbo
// targets based on view changes. This allows us to only depend on Limbo
// changes when user code includes queries.
e.Ba=function(t,n,r){return function(){var _PRIVATE_applyDocChanges=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee105(e,t,n,r){var i,s,o,_;return regenerator.wrap(function _callee105$(_context105){while(1){switch(_context105.prev=_context105.next){case 0:i=t.view.da(n);_context105.t0=i.Xi;if(!_context105.t0){_context105.next=6;break;}_context105.next=5;return __PRIVATE_localStoreExecuteQuery(e.localStore,t.query,/* usePreviousResults= */!1).then(function(_ref59){var e=_ref59.documents;return t.view.da(e,i);});case 5:i=_context105.sent;case 6:s=r&&r.targetChanges.get(t.targetId),o=r&&null!=r.targetMismatches.get(t.targetId),_=t.view.applyChanges(i,/* limboResolutionEnabled= */e.isPrimaryClient,s,o);return _context105.abrupt("return",(__PRIVATE_updateTrackedLimbos(e,t.targetId,_.fa),_.snapshot));case 8:case"end":return _context105.stop();}}},_callee105);}));function __PRIVATE_applyDocChanges(_x153,_x154,_x155,_x156){return _PRIVATE_applyDocChanges.apply(this,arguments);}return __PRIVATE_applyDocChanges;}()(e,t,n,r);};_context106.next=3;return __PRIVATE_localStoreExecuteQuery(e.localStore,t,/* usePreviousResults= */!0);case 3:s=_context106.sent;o=new __PRIVATE_View(t,s.hs);_=o.da(s.documents);a=TargetChange.createSynthesizedTargetChangeForCurrentChange(n,r&&"Offline"/* OnlineState.Offline */!==e.onlineState,i);u=o.applyChanges(_,/* limboResolutionEnabled= */e.isPrimaryClient,a);__PRIVATE_updateTrackedLimbos(e,n,u.fa);c=new __PRIVATE_QueryView(t,n,o);return _context106.abrupt("return",(e.ba.set(t,c),e.Da.has(n)?e.Da.get(n).push(t):e.Da.set(n,[t]),u.snapshot));case 11:case"end":return _context106.stop();}}},_callee106);}));return _PRIVATE_initializeViewAndComputeSnapshot.apply(this,arguments);}function __PRIVATE_syncEngineUnlisten(_x67,_x68,_x69){return _PRIVATE_syncEngineUnlisten.apply(this,arguments);}/** Unlistens to the remote store while still listening to the cache. */function _PRIVATE_syncEngineUnlisten(){_PRIVATE_syncEngineUnlisten=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee107(e,t,n){var r,i,s;return regenerator.wrap(function _callee107$(_context107){while(1){switch(_context107.prev=_context107.next){case 0:r=__PRIVATE_debugCast(e),i=r.ba.get(t),s=r.Da.get(i.targetId);if(!(s.length>1)){_context107.next=3;break;}return _context107.abrupt("return",(r.Da.set(i.targetId,s.filter(function(e){return !__PRIVATE_queryEquals(e,t);})),void r.ba["delete"](t)));case 3:if(!r.isPrimaryClient){_context107.next=11;break;}// We need to remove the local query target first to allow us to verify
// whether any other client is still interested in this target.
r.sharedClientState.removeLocalQueryTarget(i.targetId);_context107.t0=r.sharedClientState.isActiveQueryTarget(i.targetId);if(_context107.t0){_context107.next=9;break;}_context107.next=9;return __PRIVATE_localStoreReleaseTarget(r.localStore,i.targetId,/*keepPersistedTargetData=*/!1).then(function(){r.sharedClientState.clearQueryState(i.targetId),n&&__PRIVATE_remoteStoreUnlisten(r.remoteStore,i.targetId),__PRIVATE_removeAndCleanupTarget(r,i.targetId);})["catch"](__PRIVATE_ignoreIfPrimaryLeaseLoss);case 9:_context107.next=14;break;case 11:__PRIVATE_removeAndCleanupTarget(r,i.targetId);_context107.next=14;return __PRIVATE_localStoreReleaseTarget(r.localStore,i.targetId,/*keepPersistedTargetData=*/!0);case 14:case"end":return _context107.stop();}}},_callee107);}));return _PRIVATE_syncEngineUnlisten.apply(this,arguments);}function __PRIVATE_triggerRemoteStoreUnlisten(_x70,_x71){return _PRIVATE_triggerRemoteStoreUnlisten.apply(this,arguments);}/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */function _PRIVATE_triggerRemoteStoreUnlisten(){_PRIVATE_triggerRemoteStoreUnlisten=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee108(e,t){var n,r,i;return regenerator.wrap(function _callee108$(_context108){while(1){switch(_context108.prev=_context108.next){case 0:n=__PRIVATE_debugCast(e),r=n.ba.get(t),i=n.Da.get(r.targetId);n.isPrimaryClient&&1===i.length&&(// PORTING NOTE: Unregister the target ID with local Firestore client as
// watch target.
n.sharedClientState.removeLocalQueryTarget(r.targetId),__PRIVATE_remoteStoreUnlisten(n.remoteStore,r.targetId));case 2:case"end":return _context108.stop();}}},_callee108);}));return _PRIVATE_triggerRemoteStoreUnlisten.apply(this,arguments);}function __PRIVATE_syncEngineWrite(_x72,_x73,_x74){return _PRIVATE_syncEngineWrite.apply(this,arguments);}/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */function _PRIVATE_syncEngineWrite(){_PRIVATE_syncEngineWrite=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee109(e,t,n){var r,_e123,_t61;return regenerator.wrap(function _callee109$(_context109){while(1){switch(_context109.prev=_context109.next){case 0:r=__PRIVATE_syncEngineEnsureWriteCallbacks(e);_context109.prev=1;_context109.next=4;return function __PRIVATE_localStoreWriteLocally(e,t){var n=__PRIVATE_debugCast(e),r=Timestamp.now(),i=t.reduce(function(e,t){return e.add(t.key);},__PRIVATE_documentKeySet());var s,o;return n.persistence.runTransaction("Locally write mutations","readwrite",function(e){// Figure out which keys do not have a remote version in the cache, this
// is needed to create the right overlay mutation: if no remote version
// presents, we do not need to create overlays as patch mutations.
// TODO(Overlay): Is there a better way to determine this? Using the
//  document version does not work because local mutations set them back
//  to 0.
var _=__PRIVATE_mutableDocumentMap(),a=__PRIVATE_documentKeySet();return n.os.getEntries(e,i).next(function(e){_=e,_.forEach(function(e,t){t.isValidDocument()||(a=a.add(e));});}).next(function(){return n.localDocuments.getOverlayedDocuments(e,_);}).next(function(i){s=i;// For non-idempotent mutations (such as `FieldValue.increment()`),
// we record the base state in a separate patch mutation. This is
// later used to guarantee consistent values and prevents flicker
// even if the backend sends us an update that already includes our
// transform.
var o=[];var _iterator97=_createForOfIteratorHelper(t),_step97;try{for(_iterator97.s();!(_step97=_iterator97.n()).done;){var _e124=_step97.value;var _t60=__PRIVATE_mutationExtractBaseValue(_e124,s.get(_e124.key).overlayedDocument);null!=_t60&&// NOTE: The base state should only be applied if there's some
// existing document to override, so use a Precondition of
// exists=true
o.push(new __PRIVATE_PatchMutation(_e124.key,_t60,__PRIVATE_extractFieldMask(_t60.value.mapValue),Precondition.exists(!0)));}}catch(err){_iterator97.e(err);}finally{_iterator97.f();}return n.mutationQueue.addMutationBatch(e,r,o,t);}).next(function(t){o=t;var r=t.applyToLocalDocumentSet(s,a);return n.documentOverlayCache.saveOverlays(e,t.batchId,r);});}).then(function(){return {batchId:o.batchId,changes:__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)};});}(r.localStore,t);case 4:_e123=_context109.sent;r.sharedClientState.addPendingMutation(_e123.batchId);(function __PRIVATE_addMutationCallback(e,t,n){var r=e.xa[e.currentUser.toKey()];r||(r=new SortedMap(__PRIVATE_primitiveComparator));r=r.insert(t,n),e.xa[e.currentUser.toKey()]=r;}/**
 * Resolves or rejects the user callback for the given batch and then discards
 * it.
 */)(r,_e123.batchId,n);_context109.next=9;return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r,_e123.changes);case 9:_context109.next=11;return __PRIVATE_fillWritePipeline(r.remoteStore);case 11:_context109.next=17;break;case 13:_context109.prev=13;_context109.t0=_context109["catch"](1);// If we can't persist the mutation, we reject the user callback and
// don't send the mutation. The user can then retry the write.
_t61=__PRIVATE_wrapInUserErrorIfRecoverable(_context109.t0,"Failed to persist write");n.reject(_t61);case 17:case"end":return _context109.stop();}}},_callee109,null,[[1,13]]);}));return _PRIVATE_syncEngineWrite.apply(this,arguments);}function __PRIVATE_syncEngineApplyRemoteEvent(_x75,_x76){return _PRIVATE_syncEngineApplyRemoteEvent.apply(this,arguments);}/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */function _PRIVATE_syncEngineApplyRemoteEvent(){_PRIVATE_syncEngineApplyRemoteEvent=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee110(e,t){var n,_e125;return regenerator.wrap(function _callee110$(_context110){while(1){switch(_context110.prev=_context110.next){case 0:n=__PRIVATE_debugCast(e);_context110.prev=1;_context110.next=4;return __PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore,t);case 4:_e125=_context110.sent;t.targetChanges.forEach(function(e,t){var r=n.Fa.get(t);r&&(// Since this is a limbo resolution lookup, it's for a single document
// and it could be added, modified, or removed, but not a combination.
__PRIVATE_hardAssert(e.addedDocuments.size+e.modifiedDocuments.size+e.removedDocuments.size<=1),e.addedDocuments.size>0?r.wa=!0:e.modifiedDocuments.size>0?__PRIVATE_hardAssert(r.wa):e.removedDocuments.size>0&&(__PRIVATE_hardAssert(r.wa),r.wa=!1));});_context110.next=8;return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n,_e125,t);case 8:_context110.next=14;break;case 10:_context110.prev=10;_context110.t0=_context110["catch"](1);_context110.next=14;return __PRIVATE_ignoreIfPrimaryLeaseLoss(_context110.t0);case 14:case"end":return _context110.stop();}}},_callee110,null,[[1,10]]);}));return _PRIVATE_syncEngineApplyRemoteEvent.apply(this,arguments);}function __PRIVATE_syncEngineApplyOnlineStateChange(e,t,n){var r=__PRIVATE_debugCast(e);// If we are the secondary client, we explicitly ignore the remote store's
// online state (the local client may go offline, even though the primary
// tab remains online) and only apply the primary tab's online state from
// SharedClientState.
if(r.isPrimaryClient&&0/* OnlineStateSource.RemoteStore */===n||!r.isPrimaryClient&&1/* OnlineStateSource.SharedClientState */===n){var _e97=[];r.ba.forEach(function(n,r){var i=r.view.j_(t);i.snapshot&&_e97.push(i.snapshot);}),function __PRIVATE_eventManagerOnOnlineStateChange(e,t){var n=__PRIVATE_debugCast(e);n.onlineState=t;var r=!1;n.queries.forEach(function(e,n){var _iterator71=_createForOfIteratorHelper(n.U_),_step71;try{for(_iterator71.s();!(_step71=_iterator71.n()).done;){var _e98=_step71.value;// Run global snapshot listeners if a consistent snapshot has been emitted.
_e98.j_(t)&&(r=!0);}}catch(err){_iterator71.e(err);}finally{_iterator71.f();}}),r&&__PRIVATE_raiseSnapshotsInSyncEvent(n);}(r.eventManager,t),_e97.length&&r.Sa.h_(_e97),r.onlineState=t,r.isPrimaryClient&&r.sharedClientState.setOnlineState(t);}}/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */function __PRIVATE_syncEngineRejectListen(_x77,_x78,_x79){return _PRIVATE_syncEngineRejectListen.apply(this,arguments);}function _PRIVATE_syncEngineRejectListen(){_PRIVATE_syncEngineRejectListen=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee111(e,t,n){var r,i,s,_e126,_n40,_i19;return regenerator.wrap(function _callee111$(_context111){while(1){switch(_context111.prev=_context111.next){case 0:r=__PRIVATE_debugCast(e);// PORTING NOTE: Multi-tab only.
r.sharedClientState.updateQueryState(t,"rejected",n);i=r.Fa.get(t),s=i&&i.key;if(!s){_context111.next=14;break;}// TODO(klimt): We really only should do the following on permission
// denied errors, but we don't have the cause code here.
// It's a limbo doc. Create a synthetic event saying it was deleted.
// This is kind of a hack. Ideally, we would have a method in the local
// store to purge a document. However, it would be tricky to keep all of
// the local store's invariants with another method.
_e126=new SortedMap(DocumentKey.comparator);// TODO(b/217189216): This limbo document should ideally have a read time,
// so that it is picked up by any read-time based scans. The backend,
// however, does not send a read time for target removals.
_e126=_e126.insert(s,MutableDocument.newNoDocument(s,SnapshotVersion.min()));_n40=__PRIVATE_documentKeySet().add(s),_i19=new RemoteEvent(SnapshotVersion.min(),/* targetChanges= */new Map(),/* targetMismatches= */new SortedMap(__PRIVATE_primitiveComparator),_e126,_n40);_context111.next=9;return __PRIVATE_syncEngineApplyRemoteEvent(r,_i19);case 9:// Since this query failed, we won't want to manually unlisten to it.
// We only remove it from bookkeeping after we successfully applied the
// RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
// this query when the RemoteStore restarts the Watch stream, which should
// re-trigger the target failure.
r.va=r.va.remove(s);r.Fa["delete"](t);__PRIVATE_pumpEnqueuedLimboResolutions(r);_context111.next=16;break;case 14:_context111.next=16;return __PRIVATE_localStoreReleaseTarget(r.localStore,t,/* keepPersistedTargetData */!1).then(function(){return __PRIVATE_removeAndCleanupTarget(r,t,n);})["catch"](__PRIVATE_ignoreIfPrimaryLeaseLoss);case 16:case"end":return _context111.stop();}}},_callee111);}));return _PRIVATE_syncEngineRejectListen.apply(this,arguments);}function __PRIVATE_syncEngineApplySuccessfulWrite(_x80,_x81){return _PRIVATE_syncEngineApplySuccessfulWrite.apply(this,arguments);}function _PRIVATE_syncEngineApplySuccessfulWrite(){_PRIVATE_syncEngineApplySuccessfulWrite=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee112(e,t){var n,r,_e127;return regenerator.wrap(function _callee112$(_context112){while(1){switch(_context112.prev=_context112.next){case 0:n=__PRIVATE_debugCast(e),r=t.batch.batchId;_context112.prev=1;_context112.next=4;return __PRIVATE_localStoreAcknowledgeBatch(n.localStore,t);case 4:_e127=_context112.sent;__PRIVATE_processUserCallback(n,r,/*error=*/null);__PRIVATE_triggerPendingWritesCallbacks(n,r);n.sharedClientState.updateMutationState(r,"acknowledged");_context112.next=10;return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n,_e127);case 10:_context112.next=16;break;case 12:_context112.prev=12;_context112.t0=_context112["catch"](1);_context112.next=16;return __PRIVATE_ignoreIfPrimaryLeaseLoss(_context112.t0);case 16:case"end":return _context112.stop();}}},_callee112,null,[[1,12]]);}));return _PRIVATE_syncEngineApplySuccessfulWrite.apply(this,arguments);}function __PRIVATE_syncEngineRejectFailedWrite(_x82,_x83,_x84){return _PRIVATE_syncEngineRejectFailedWrite.apply(this,arguments);}/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */function _PRIVATE_syncEngineRejectFailedWrite(){_PRIVATE_syncEngineRejectFailedWrite=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee113(e,t,n){var r,_e128;return regenerator.wrap(function _callee113$(_context113){while(1){switch(_context113.prev=_context113.next){case 0:r=__PRIVATE_debugCast(e);_context113.prev=1;_context113.next=4;return function __PRIVATE_localStoreRejectBatch(e,t){var n=__PRIVATE_debugCast(e);return n.persistence.runTransaction("Reject batch","readwrite-primary",function(e){var r;return n.mutationQueue.lookupMutationBatch(e,t).next(function(t){return __PRIVATE_hardAssert(null!==t),r=t.keys(),n.mutationQueue.removeMutationBatch(e,t);}).next(function(){return n.mutationQueue.performConsistencyCheck(e);}).next(function(){return n.documentOverlayCache.removeOverlaysForBatchId(e,r,t);}).next(function(){return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e,r);}).next(function(){return n.localDocuments.getDocuments(e,r);});});}/**
 * Returns the largest (latest) batch id in mutation queue that is pending
 * server response.
 *
 * Returns `BATCHID_UNKNOWN` if the queue is empty.
 */(r.localStore,t);case 4:_e128=_context113.sent;__PRIVATE_processUserCallback(r,t,n);__PRIVATE_triggerPendingWritesCallbacks(r,t);r.sharedClientState.updateMutationState(t,"rejected",n);_context113.next=10;return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r,_e128);case 10:_context113.next=16;break;case 12:_context113.prev=12;_context113.t0=_context113["catch"](1);_context113.next=16;return __PRIVATE_ignoreIfPrimaryLeaseLoss(_context113.t0);case 16:case"end":return _context113.stop();}}},_callee113,null,[[1,12]]);}));return _PRIVATE_syncEngineRejectFailedWrite.apply(this,arguments);}function __PRIVATE_triggerPendingWritesCallbacks(e,t){(e.Oa.get(t)||[]).forEach(function(e){e.resolve();}),e.Oa["delete"](t);}/** Reject all outstanding callbacks waiting for pending writes to complete. */function __PRIVATE_processUserCallback(e,t,n){var r=__PRIVATE_debugCast(e);var i=r.xa[r.currentUser.toKey()];// NOTE: Mutations restored from persistence won't have callbacks, so it's
// okay for there to be no callback for this ID.
if(i){var _e99=i.get(t);_e99&&(n?_e99.reject(n):_e99.resolve(),i=i.remove(t)),r.xa[r.currentUser.toKey()]=i;}}function __PRIVATE_removeAndCleanupTarget(e,t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;e.sharedClientState.removeLocalQueryTarget(t);var _iterator72=_createForOfIteratorHelper(e.Da.get(t)),_step72;try{for(_iterator72.s();!(_step72=_iterator72.n()).done;){var r=_step72.value;e.ba["delete"](r),n&&e.Sa.ka(r,n);}}catch(err){_iterator72.e(err);}finally{_iterator72.f();}if(e.Da["delete"](t),e.isPrimaryClient){e.Ma.Vr(t).forEach(function(t){e.Ma.containsKey(t)||// We removed the last reference for this key
__PRIVATE_removeLimboTarget(e,t);});}}function __PRIVATE_removeLimboTarget(e,t){e.Ca["delete"](t.path.canonicalString());// It's possible that the target already got removed because the query failed. In that case,
// the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
var n=e.va.get(t);null!==n&&(__PRIVATE_remoteStoreUnlisten(e.remoteStore,n),e.va=e.va.remove(t),e.Fa["delete"](n),__PRIVATE_pumpEnqueuedLimboResolutions(e));}function __PRIVATE_updateTrackedLimbos(e,t,n){var _iterator73=_createForOfIteratorHelper(n),_step73;try{for(_iterator73.s();!(_step73=_iterator73.n()).done;){var r=_step73.value;if(r instanceof __PRIVATE_AddedLimboDocument)e.Ma.addReference(r.key,t),__PRIVATE_trackLimboChange(e,r);else if(r instanceof __PRIVATE_RemovedLimboDocument){__PRIVATE_logDebug("SyncEngine","Document no longer in limbo: "+r.key),e.Ma.removeReference(r.key,t);e.Ma.containsKey(r.key)||// We removed the last reference for this key
__PRIVATE_removeLimboTarget(e,r.key);}else fail();}}catch(err){_iterator73.e(err);}finally{_iterator73.f();}}function __PRIVATE_trackLimboChange(e,t){var n=t.key,r=n.path.canonicalString();e.va.get(n)||e.Ca.has(r)||(__PRIVATE_logDebug("SyncEngine","New document in limbo: "+n),e.Ca.add(r),__PRIVATE_pumpEnqueuedLimboResolutions(e));}/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */function __PRIVATE_pumpEnqueuedLimboResolutions(e){for(;e.Ca.size>0&&e.va.size<e.maxConcurrentLimboResolutions;){var t=e.Ca.values().next().value;e.Ca["delete"](t);var n=new DocumentKey(ResourcePath.fromString(t)),r=e.Na.next();e.Fa.set(r,new LimboResolution(n)),e.va=e.va.insert(n,r),__PRIVATE_remoteStoreListen(e.remoteStore,new TargetData(__PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)),r,"TargetPurposeLimboResolution"/* TargetPurpose.LimboResolution */,__PRIVATE_ListenSequence.oe));}}function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(_x87,_x88,_x89){return _PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this,arguments);}function _PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(){_PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee116(e,t,n){var r,i,s,o;return regenerator.wrap(function _callee116$(_context116){while(1){switch(_context116.prev=_context116.next){case 0:r=__PRIVATE_debugCast(e),i=[],s=[],o=[];_context116.t0=r.ba.isEmpty();if(_context116.t0){_context116.next=9;break;}r.ba.forEach(function(e,_){o.push(r.Ba(_,t,n).then(function(e){// If there are changes, or we are handling a global snapshot, notify
// secondary clients to update query state.
if((e||n)&&r.isPrimaryClient){var _t62=e&&!e.fromCache;r.sharedClientState.updateQueryState(_.targetId,_t62?"current":"not-current");}// Update views if there are actual changes.
if(e){i.push(e);var _t63=__PRIVATE_LocalViewChanges.Ki(_.targetId,e);s.push(_t63);}}));});_context116.next=6;return Promise.all(o);case 6:r.Sa.h_(i);_context116.next=9;return function(){var _PRIVATE_localStoreNotifyLocalViewChanges=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee115(e,t){var n,_iterator98,_step98,_e130,_t64,_e131,_r44,_i20;return regenerator.wrap(function _callee115$(_context115){while(1){switch(_context115.prev=_context115.next){case 0:n=__PRIVATE_debugCast(e);_context115.prev=1;_context115.next=4;return n.persistence.runTransaction("notifyLocalViewChanges","readwrite",function(e){return PersistencePromise.forEach(t,function(t){return PersistencePromise.forEach(t.qi,function(r){return n.persistence.referenceDelegate.addReference(e,t.targetId,r);}).next(function(){return PersistencePromise.forEach(t.Qi,function(r){return n.persistence.referenceDelegate.removeReference(e,t.targetId,r);});});});});case 4:_context115.next=11;break;case 6:_context115.prev=6;_context115.t0=_context115["catch"](1);if(__PRIVATE_isIndexedDbTransactionError(_context115.t0)){_context115.next=10;break;}throw _context115.t0;case 10:// If `notifyLocalViewChanges` fails, we did not advance the sequence
// number for the documents that were included in this transaction.
// This might trigger them to be deleted earlier than they otherwise
// would have, but it should not invalidate the integrity of the data.
__PRIVATE_logDebug("LocalStore","Failed to update sequence numbers: "+_context115.t0);case 11:_iterator98=_createForOfIteratorHelper(t);try{for(_iterator98.s();!(_step98=_iterator98.n()).done;){_e130=_step98.value;_t64=_e130.targetId;if(!_e130.fromCache){_e131=n.ns.get(_t64),_r44=_e131.snapshotVersion,_i20=_e131.withLastLimboFreeSnapshotVersion(_r44);// Advance the last limbo free snapshot version
n.ns=n.ns.insert(_t64,_i20);}}}catch(err){_iterator98.e(err);}finally{_iterator98.f();}case 13:case"end":return _context115.stop();}}},_callee115,null,[[1,6]]);}));function __PRIVATE_localStoreNotifyLocalViewChanges(_x157,_x158){return _PRIVATE_localStoreNotifyLocalViewChanges.apply(this,arguments);}return __PRIVATE_localStoreNotifyLocalViewChanges;}()(r.localStore,s);case 9:case"end":return _context116.stop();}}},_callee116);}));return _PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this,arguments);}function __PRIVATE_syncEngineHandleCredentialChange(_x90,_x91){return _PRIVATE_syncEngineHandleCredentialChange.apply(this,arguments);}function _PRIVATE_syncEngineHandleCredentialChange(){_PRIVATE_syncEngineHandleCredentialChange=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee117(e,t){var n,_e132;return regenerator.wrap(function _callee117$(_context117){while(1){switch(_context117.prev=_context117.next){case 0:n=__PRIVATE_debugCast(e);if(n.currentUser.isEqual(t)){_context117.next=11;break;}__PRIVATE_logDebug("SyncEngine","User change. New user:",t.toKey());_context117.next=5;return __PRIVATE_localStoreHandleUserChange(n.localStore,t);case 5:_e132=_context117.sent;n.currentUser=t;// Fails tasks waiting for pending writes requested by previous user.
(function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e,t){e.Oa.forEach(function(e){e.forEach(function(e){e.reject(new FirestoreError(C.CANCELLED,t));});}),e.Oa.clear();})(n,"'waitForPendingWrites' promise is rejected due to a user change.");// TODO(b/114226417): Consider calling this only in the primary tab.
n.sharedClientState.handleUserChange(t,_e132.removedBatchIds,_e132.addedBatchIds);_context117.next=11;return __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n,_e132.us);case 11:case"end":return _context117.stop();}}},_callee117);}));return _PRIVATE_syncEngineHandleCredentialChange.apply(this,arguments);}function __PRIVATE_syncEngineGetRemoteKeysForTarget(e,t){var n=__PRIVATE_debugCast(e),r=n.Fa.get(t);if(r&&r.wa)return __PRIVATE_documentKeySet().add(r.key);{var _e100=__PRIVATE_documentKeySet();var _r25=n.Da.get(t);if(!_r25)return _e100;var _iterator74=_createForOfIteratorHelper(_r25),_step74;try{for(_iterator74.s();!(_step74=_iterator74.n()).done;){var _t48=_step74.value;var _r26=n.ba.get(_t48);_e100=_e100.unionWith(_r26.view.Ea);}}catch(err){_iterator74.e(err);}finally{_iterator74.f();}return _e100;}}function __PRIVATE_ensureWatchCallbacks(e){var t=__PRIVATE_debugCast(e);return t.remoteStore.remoteSyncer.applyRemoteEvent=__PRIVATE_syncEngineApplyRemoteEvent.bind(null,t),t.remoteStore.remoteSyncer.getRemoteKeysForTarget=__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null,t),t.remoteStore.remoteSyncer.rejectListen=__PRIVATE_syncEngineRejectListen.bind(null,t),t.Sa.h_=__PRIVATE_eventManagerOnWatchChange.bind(null,t.eventManager),t.Sa.ka=__PRIVATE_eventManagerOnWatchError.bind(null,t.eventManager),t;}function __PRIVATE_syncEngineEnsureWriteCallbacks(e){var t=__PRIVATE_debugCast(e);return t.remoteStore.remoteSyncer.applySuccessfulWrite=__PRIVATE_syncEngineApplySuccessfulWrite.bind(null,t),t.remoteStore.remoteSyncer.rejectFailedWrite=__PRIVATE_syncEngineRejectFailedWrite.bind(null,t),t;}var MemoryOfflineComponentProvider=/*#__PURE__*/function(){function MemoryOfflineComponentProvider(){_classCallCheck(this,MemoryOfflineComponentProvider);this.synchronizeTabs=!1;}_createClass(MemoryOfflineComponentProvider,[{key:"initialize",value:function(){var _initialize=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee26(e){return regenerator.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:this.serializer=__PRIVATE_newSerializer(e.databaseInfo.databaseId);this.sharedClientState=this.createSharedClientState(e);this.persistence=this.createPersistence(e);_context26.next=5;return this.persistence.start();case 5:this.localStore=this.createLocalStore(e);this.gcScheduler=this.createGarbageCollectionScheduler(e,this.localStore);this.indexBackfillerScheduler=this.createIndexBackfillerScheduler(e,this.localStore);case 8:case"end":return _context26.stop();}}},_callee26,this);}));function initialize(_x115){return _initialize.apply(this,arguments);}return initialize;}()},{key:"createGarbageCollectionScheduler",value:function createGarbageCollectionScheduler(e,t){return null;}},{key:"createIndexBackfillerScheduler",value:function createIndexBackfillerScheduler(e,t){return null;}},{key:"createLocalStore",value:function createLocalStore(e){return __PRIVATE_newLocalStore(this.persistence,new __PRIVATE_QueryEngine(),e.initialUser,this.serializer);}},{key:"createPersistence",value:function createPersistence(e){return new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.Hr,this.serializer);}},{key:"createSharedClientState",value:function createSharedClientState(e){return new __PRIVATE_MemorySharedClientState();}},{key:"terminate",value:function(){var _terminate=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee27(){var e,t;return regenerator.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:null===(e=this.gcScheduler)||void 0===e||e.stop();null===(t=this.indexBackfillerScheduler)||void 0===t||t.stop();this.sharedClientState.shutdown();_context27.next=5;return this.persistence.shutdown();case 5:case"end":return _context27.stop();}}},_callee27,this);}));function terminate(){return _terminate.apply(this,arguments);}return terminate;}()}]);return MemoryOfflineComponentProvider;}();/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */var OnlineComponentProvider=/*#__PURE__*/function(){function OnlineComponentProvider(){_classCallCheck(this,OnlineComponentProvider);}_createClass(OnlineComponentProvider,[{key:"initialize",value:function(){var _initialize4=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee31(e,t){var _this188=this;return regenerator.wrap(function _callee31$(_context31){while(1){switch(_context31.prev=_context31.next){case 0:_context31.t0=this.localStore;if(_context31.t0){_context31.next=12;break;}this.localStore=e.localStore;this.sharedClientState=e.sharedClientState;this.datastore=this.createDatastore(t);this.remoteStore=this.createRemoteStore(t);this.eventManager=this.createEventManager(t);this.syncEngine=this.createSyncEngine(t,/* startAsPrimary=*/!e.synchronizeTabs);this.sharedClientState.onlineStateHandler=function(e){return __PRIVATE_syncEngineApplyOnlineStateChange(_this188.syncEngine,e,1/* OnlineStateSource.SharedClientState */);};this.remoteStore.remoteSyncer.handleCredentialChange=__PRIVATE_syncEngineHandleCredentialChange.bind(null,this.syncEngine);_context31.next=12;return __PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore,this.syncEngine.isPrimaryClient);case 12:case"end":return _context31.stop();}}},_callee31,this);}));function initialize(_x119,_x120){return _initialize4.apply(this,arguments);}return initialize;}()},{key:"createEventManager",value:function createEventManager(e){return function __PRIVATE_newEventManager(){return new __PRIVATE_EventManagerImpl();}();}},{key:"createDatastore",value:function createDatastore(e){var t=__PRIVATE_newSerializer(e.databaseInfo.databaseId),n=function __PRIVATE_newConnection(e){return new __PRIVATE_WebChannelConnection(e);}/** Return the Platform-specific connectivity monitor. */(e.databaseInfo);return function __PRIVATE_newDatastore(e,t,n,r){return new __PRIVATE_DatastoreImpl(e,t,n,r);}(e.authCredentials,e.appCheckCredentials,n,t);}},{key:"createRemoteStore",value:function createRemoteStore(e){var _this189=this;return function __PRIVATE_newRemoteStore(e,t,n,r,i){return new __PRIVATE_RemoteStoreImpl(e,t,n,r,i);}/** Re-enables the network. Idempotent. */(this.localStore,this.datastore,e.asyncQueue,function(e){return __PRIVATE_syncEngineApplyOnlineStateChange(_this189.syncEngine,e,0/* OnlineStateSource.RemoteStore */);},function __PRIVATE_newConnectivityMonitor(){return __PRIVATE_BrowserConnectivityMonitor.D()?new __PRIVATE_BrowserConnectivityMonitor():new __PRIVATE_NoopConnectivityMonitor();}());}},{key:"createSyncEngine",value:function createSyncEngine(e,t){return function __PRIVATE_newSyncEngine(e,t,n,// PORTING NOTE: Manages state synchronization in multi-tab environments.
r,i,s,o){var _=new __PRIVATE_SyncEngineImpl(e,t,n,r,i,s);return o&&(_.La=!0),_;}(this.localStore,this.remoteStore,this.eventManager,this.sharedClientState,e.initialUser,e.maxConcurrentLimboResolutions,t);}},{key:"terminate",value:function(){var _terminate2=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee33(){var e;return regenerator.wrap(function _callee33$(_context33){while(1){switch(_context33.prev=_context33.next){case 0:_context33.next=2;return function(){var _PRIVATE_remoteStoreShutdown=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee32(e){var t;return regenerator.wrap(function _callee32$(_context32){while(1){switch(_context32.prev=_context32.next){case 0:t=__PRIVATE_debugCast(e);__PRIVATE_logDebug("RemoteStore","RemoteStore shutting down.");t.M_.add(5/* OfflineCause.Shutdown */);_context32.next=5;return __PRIVATE_disableNetworkInternal(t);case 5:t.O_.shutdown();// Set the OnlineState to Unknown (rather than Offline) to avoid potentially
// triggering spurious listener events with cached data, etc.
t.N_.set("Unknown"/* OnlineState.Unknown */);case 7:case"end":return _context32.stop();}}},_callee32);}));function __PRIVATE_remoteStoreShutdown(_x121){return _PRIVATE_remoteStoreShutdown.apply(this,arguments);}return __PRIVATE_remoteStoreShutdown;}()(this.remoteStore);case 2:null===(e=this.datastore)||void 0===e||e.terminate();case 3:case"end":return _context33.stop();}}},_callee33,this);}));function terminate(){return _terminate2.apply(this,arguments);}return terminate;}()}]);return OnlineComponentProvider;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */var __PRIVATE_AsyncObserver=/*#__PURE__*/function(){function __PRIVATE_AsyncObserver(e){_classCallCheck(this,__PRIVATE_AsyncObserver);this.observer=e,/**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */this.muted=!1;}_createClass(__PRIVATE_AsyncObserver,[{key:"next",value:function next(e){this.observer.next&&this.Ka(this.observer.next,e);}},{key:"error",value:function error(e){this.observer.error?this.Ka(this.observer.error,e):__PRIVATE_logError("Uncaught Error in snapshot listener:",e.toString());}},{key:"$a",value:function $a(){this.muted=!0;}},{key:"Ka",value:function Ka(e,t){var _this190=this;this.muted||setTimeout(function(){_this190.muted||e(t);},0);}}]);return __PRIVATE_AsyncObserver;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */var FirestoreClient=/*#__PURE__*/function(){function FirestoreClient(e,t,/**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */n,r){var _this196=this;_classCallCheck(this,FirestoreClient);this.authCredentials=e,this.appCheckCredentials=t,this.asyncQueue=n,this.databaseInfo=r,this.user=User.UNAUTHENTICATED,this.clientId=__PRIVATE_AutoId.newId(),this.authCredentialListener=function(){return Promise.resolve();},this.appCheckCredentialListener=function(){return Promise.resolve();},this.authCredentials.start(n,/*#__PURE__*/function(){var _ref34=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee47(e){return regenerator.wrap(function _callee47$(_context47){while(1){switch(_context47.prev=_context47.next){case 0:__PRIVATE_logDebug("FirestoreClient","Received user=",e.uid);_context47.next=3;return _this196.authCredentialListener(e);case 3:_this196.user=e;case 4:case"end":return _context47.stop();}}},_callee47);}));return function(_x128){return _ref34.apply(this,arguments);};}()),this.appCheckCredentials.start(n,function(e){return __PRIVATE_logDebug("FirestoreClient","Received new app check token=",e),_this196.appCheckCredentialListener(e,_this196.user);});}_createClass(FirestoreClient,[{key:"configuration",get:function get(){return {asyncQueue:this.asyncQueue,databaseInfo:this.databaseInfo,clientId:this.clientId,authCredentials:this.authCredentials,appCheckCredentials:this.appCheckCredentials,initialUser:this.user,maxConcurrentLimboResolutions:100};}},{key:"setCredentialChangeListener",value:function setCredentialChangeListener(e){this.authCredentialListener=e;}},{key:"setAppCheckTokenChangeListener",value:function setAppCheckTokenChangeListener(e){this.appCheckCredentialListener=e;}/**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */},{key:"verifyNotTerminated",value:function verifyNotTerminated(){if(this.asyncQueue.isShuttingDown)throw new FirestoreError(C.FAILED_PRECONDITION,"The client has already been terminated.");}},{key:"terminate",value:function terminate(){var _this197=this;this.asyncQueue.enterRestrictedMode();var e=new __PRIVATE_Deferred();return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee48(){var n;return regenerator.wrap(function _callee48$(_context48){while(1){switch(_context48.prev=_context48.next){case 0:_context48.prev=0;_context48.t0=_this197._onlineComponents;if(!_context48.t0){_context48.next=5;break;}_context48.next=5;return _this197._onlineComponents.terminate();case 5:_context48.t1=_this197._offlineComponents;if(!_context48.t1){_context48.next=9;break;}_context48.next=9;return _this197._offlineComponents.terminate();case 9:// The credentials provider must be terminated after shutting down the
// RemoteStore as it will prevent the RemoteStore from retrieving auth
// tokens.
_this197.authCredentials.shutdown();_this197.appCheckCredentials.shutdown();e.resolve();_context48.next=18;break;case 14:_context48.prev=14;_context48.t2=_context48["catch"](0);n=__PRIVATE_wrapInUserErrorIfRecoverable(_context48.t2,"Failed to shutdown persistence");e.reject(n);case 18:case"end":return _context48.stop();}}},_callee48,null,[[0,14]]);}))),e.promise;}}]);return FirestoreClient;}();function __PRIVATE_setOfflineComponentProvider(_x129,_x130){return _PRIVATE_setOfflineComponentProvider.apply(this,arguments);}function _PRIVATE_setOfflineComponentProvider(){_PRIVATE_setOfflineComponentProvider=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee126(e,t){var n,r;return regenerator.wrap(function _callee126$(_context127){while(1){switch(_context127.prev=_context127.next){case 0:e.asyncQueue.verifyOperationInProgress(),__PRIVATE_logDebug("FirestoreClient","Initializing OfflineComponentProvider");n=e.configuration;_context127.next=4;return t.initialize(n);case 4:r=n.initialUser;e.setCredentialChangeListener(/*#__PURE__*/function(){var _ref60=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee125(e){return regenerator.wrap(function _callee125$(_context126){while(1){switch(_context126.prev=_context126.next){case 0:_context126.t0=r.isEqual(e);if(_context126.t0){_context126.next=5;break;}_context126.next=4;return __PRIVATE_localStoreHandleUserChange(t.localStore,e);case 4:r=e;case 5:case"end":return _context126.stop();}}},_callee125);}));return function(_x159){return _ref60.apply(this,arguments);};}()),// When a user calls clearPersistence() in one client, all other clients
// need to be terminated to allow the delete to succeed.
t.persistence.setDatabaseDeletedListener(function(){return e.terminate();}),e._offlineComponents=t;case 6:case"end":return _context127.stop();}}},_callee126);}));return _PRIVATE_setOfflineComponentProvider.apply(this,arguments);}function __PRIVATE_setOnlineComponentProvider(_x131,_x132){return _PRIVATE_setOnlineComponentProvider.apply(this,arguments);}/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */function _PRIVATE_setOnlineComponentProvider(){_PRIVATE_setOnlineComponentProvider=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee127(e,t){var n;return regenerator.wrap(function _callee127$(_context128){while(1){switch(_context128.prev=_context128.next){case 0:e.asyncQueue.verifyOperationInProgress();_context128.next=3;return __PRIVATE_ensureOfflineComponents(e);case 3:n=_context128.sent;__PRIVATE_logDebug("FirestoreClient","Initializing OnlineComponentProvider");_context128.next=7;return t.initialize(n,e.configuration);case 7:// The CredentialChangeListener of the online component provider takes
// precedence over the offline component provider.
e.setCredentialChangeListener(function(e){return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore,e);});e.setAppCheckTokenChangeListener(function(e,n){return __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore,n);});e._onlineComponents=t;case 10:case"end":return _context128.stop();}}},_callee127);}));return _PRIVATE_setOnlineComponentProvider.apply(this,arguments);}function __PRIVATE_canFallbackFromIndexedDbError(e){return "FirebaseError"===e.name?e.code===C.FAILED_PRECONDITION||e.code===C.UNIMPLEMENTED:!("undefined"!=typeof DOMException&&e instanceof DOMException)||// When the browser is out of quota we could get either quota exceeded
// or an aborted error depending on whether the error happened during
// schema migration.
22===e.code||20===e.code||// Firefox Private Browsing mode disables IndexedDb and returns
// INVALID_STATE for any usage.
11===e.code;}function __PRIVATE_ensureOfflineComponents(_x133){return _PRIVATE_ensureOfflineComponents.apply(this,arguments);}function _PRIVATE_ensureOfflineComponents(){_PRIVATE_ensureOfflineComponents=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee128(e){var n;return regenerator.wrap(function _callee128$(_context129){while(1){switch(_context129.prev=_context129.next){case 0:if(e._offlineComponents){_context129.next=21;break;}if(!e._uninitializedComponentsProvider){_context129.next=18;break;}__PRIVATE_logDebug("FirestoreClient","Using user provided OfflineComponentProvider");_context129.prev=3;_context129.next=6;return __PRIVATE_setOfflineComponentProvider(e,e._uninitializedComponentsProvider._offline);case 6:_context129.next=16;break;case 8:_context129.prev=8;_context129.t0=_context129["catch"](3);n=_context129.t0;if(__PRIVATE_canFallbackFromIndexedDbError(n)){_context129.next=13;break;}throw n;case 13:__PRIVATE_logWarn("Error using user provided cache. Falling back to memory cache: "+n);_context129.next=16;return __PRIVATE_setOfflineComponentProvider(e,new MemoryOfflineComponentProvider());case 16:_context129.next=21;break;case 18:__PRIVATE_logDebug("FirestoreClient","Using default OfflineComponentProvider");_context129.next=21;return __PRIVATE_setOfflineComponentProvider(e,new MemoryOfflineComponentProvider());case 21:return _context129.abrupt("return",e._offlineComponents);case 22:case"end":return _context129.stop();}}},_callee128,null,[[3,8]]);}));return _PRIVATE_ensureOfflineComponents.apply(this,arguments);}function __PRIVATE_ensureOnlineComponents(_x134){return _PRIVATE_ensureOnlineComponents.apply(this,arguments);}function _PRIVATE_ensureOnlineComponents(){_PRIVATE_ensureOnlineComponents=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee129(e){return regenerator.wrap(function _callee129$(_context130){while(1){switch(_context130.prev=_context130.next){case 0:_context130.t0=e._onlineComponents;if(_context130.t0){_context130.next=11;break;}if(!e._uninitializedComponentsProvider){_context130.next=8;break;}__PRIVATE_logDebug("FirestoreClient","Using user provided OnlineComponentProvider");_context130.next=6;return __PRIVATE_setOnlineComponentProvider(e,e._uninitializedComponentsProvider._online);case 6:_context130.next=11;break;case 8:__PRIVATE_logDebug("FirestoreClient","Using default OnlineComponentProvider");_context130.next=11;return __PRIVATE_setOnlineComponentProvider(e,new OnlineComponentProvider());case 11:return _context130.abrupt("return",e._onlineComponents);case 12:case"end":return _context130.stop();}}},_callee129);}));return _PRIVATE_ensureOnlineComponents.apply(this,arguments);}function __PRIVATE_getSyncEngine(e){return __PRIVATE_ensureOnlineComponents(e).then(function(e){return e.syncEngine;});}function __PRIVATE_getEventManager(_x135){return _PRIVATE_getEventManager.apply(this,arguments);}/** Enables the network connection and re-enqueues all pending operations. */function _PRIVATE_getEventManager(){_PRIVATE_getEventManager=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee130(e){var t,n;return regenerator.wrap(function _callee130$(_context131){while(1){switch(_context131.prev=_context131.next){case 0:_context131.next=2;return __PRIVATE_ensureOnlineComponents(e);case 2:t=_context131.sent;n=t.eventManager;return _context131.abrupt("return",(n.onListen=__PRIVATE_syncEngineListen.bind(null,t.syncEngine),n.onUnlisten=__PRIVATE_syncEngineUnlisten.bind(null,t.syncEngine),n.onFirstRemoteStoreListen=__PRIVATE_triggerRemoteStoreListen.bind(null,t.syncEngine),n.onLastRemoteStoreUnlisten=__PRIVATE_triggerRemoteStoreUnlisten.bind(null,t.syncEngine),n));case 5:case"end":return _context131.stop();}}},_callee130);}));return _PRIVATE_getEventManager.apply(this,arguments);}function __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e,t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var r=new __PRIVATE_Deferred();return e.asyncQueue.enqueueAndForget(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee54(){return regenerator.wrap(function _callee54$(_context54){while(1){switch(_context54.prev=_context54.next){case 0:_context54.t0=function __PRIVATE_readDocumentViaSnapshotListener(e,t,n,r,i){var s=new __PRIVATE_AsyncObserver({next:function next(s){// Remove query first before passing event to user to avoid
// user actions affecting the now stale query.
t.enqueueAndForget(function(){return __PRIVATE_eventManagerUnlisten(e,o);});var _=s.docs.has(n);!_&&s.fromCache?// TODO(dimond): If we're online and the document doesn't
// exist then we resolve with a doc.exists set to false. If
// we're offline however, we reject the Promise in this
// case. Two options: 1) Cache the negative response from
// the server so we can deliver that even when you're
// offline 2) Actually reject the Promise in the online case
// if the document doesn't exist.
i.reject(new FirestoreError(C.UNAVAILABLE,"Failed to get document because the client is offline.")):_&&s.fromCache&&r&&"server"===r.source?i.reject(new FirestoreError(C.UNAVAILABLE,'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')):i.resolve(s);},error:function error(e){return i.reject(e);}}),o=new __PRIVATE_QueryListener(__PRIVATE_newQueryForPath(n.path),s,{includeMetadataChanges:!0,ra:!0});return __PRIVATE_eventManagerListen(e,o);};_context54.next=3;return __PRIVATE_getEventManager(e);case 3:_context54.t1=_context54.sent;_context54.t2=e.asyncQueue;_context54.t3=t;_context54.t4=n;_context54.t5=r;return _context54.abrupt("return",(0, _context54.t0)(_context54.t1,_context54.t2,_context54.t3,_context54.t4,_context54.t5));case 9:case"end":return _context54.stop();}}},_callee54);}))),r.promise;}/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */function __PRIVATE_cloneLongPollingOptions(e){var t={};return void 0!==e.timeoutSeconds&&(t.timeoutSeconds=e.timeoutSeconds),t;}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var ye=new Map();/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function __PRIVATE_validateNonEmptyArgument(e,t,n){if(!n)throw new FirestoreError(C.INVALID_ARGUMENT,"Function ".concat(e,"() cannot be called with an empty ").concat(t,"."));}/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */function __PRIVATE_validateIsNotUsedTogether(e,t,n,r){if(!0===t&&!0===r)throw new FirestoreError(C.INVALID_ARGUMENT,"".concat(e," and ").concat(n," cannot be used together."));}/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */function __PRIVATE_validateDocumentPath(e){if(!DocumentKey.isDocumentKey(e))throw new FirestoreError(C.INVALID_ARGUMENT,"Invalid document reference. Document references must have an even number of segments, but ".concat(e," has ").concat(e.length,"."));}/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */function __PRIVATE_valueDescription(e){if(void 0===e)return "undefined";if(null===e)return "null";if("string"==typeof e)return e.length>20&&(e="".concat(e.substring(0,20),"...")),JSON.stringify(e);if("number"==typeof e||"boolean"==typeof e)return ""+e;if("object"==_typeof(e)){if(e instanceof Array)return "an array";{var t=/** try to get the constructor name for an object. */function __PRIVATE_tryGetCustomObjectType(e){if(e.constructor)return e.constructor.name;return null;}/**
 * Casts `obj` to `T`, optionally unwrapping Compat types to expose the
 * underlying instance. Throws if  `obj` is not an instance of `T`.
 *
 * This cast is used in the Lite and Full SDK to verify instance types for
 * arguments passed to the public API.
 * @internal
 */(e);return t?"a custom ".concat(t," object"):"an object";}}return "function"==typeof e?"a function":fail();}function __PRIVATE_cast(e,// eslint-disable-next-line @typescript-eslint/no-explicit-any
t){if("_delegate"in e&&(// Unwrap Compat types
// eslint-disable-next-line @typescript-eslint/no-explicit-any
e=e._delegate),!(e instanceof t)){if(t.name===e.constructor.name)throw new FirestoreError(C.INVALID_ARGUMENT,"Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");{var n=__PRIVATE_valueDescription(e);throw new FirestoreError(C.INVALID_ARGUMENT,"Expected type '".concat(t.name,"', but it was: ").concat(n));}}return e;}/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */var FirestoreSettingsImpl=/*#__PURE__*/function(){function FirestoreSettingsImpl(e){_classCallCheck(this,FirestoreSettingsImpl);var t,n;if(void 0===e.host){if(void 0!==e.ssl)throw new FirestoreError(C.INVALID_ARGUMENT,"Can't provide ssl option if host option is not set");this.host="firestore.googleapis.com",this.ssl=true;}else this.host=e.host,this.ssl=null===(t=e.ssl)||void 0===t||t;if(this.credentials=e.credentials,this.ignoreUndefinedProperties=!!e.ignoreUndefinedProperties,this.localCache=e.localCache,void 0===e.cacheSizeBytes)this.cacheSizeBytes=41943040;else {if(-1!==e.cacheSizeBytes&&e.cacheSizeBytes<1048576)throw new FirestoreError(C.INVALID_ARGUMENT,"cacheSizeBytes must be at least 1048576");this.cacheSizeBytes=e.cacheSizeBytes;}__PRIVATE_validateIsNotUsedTogether("experimentalForceLongPolling",e.experimentalForceLongPolling,"experimentalAutoDetectLongPolling",e.experimentalAutoDetectLongPolling),this.experimentalForceLongPolling=!!e.experimentalForceLongPolling,this.experimentalForceLongPolling?this.experimentalAutoDetectLongPolling=!1:void 0===e.experimentalAutoDetectLongPolling?this.experimentalAutoDetectLongPolling=true:// For backwards compatibility, coerce the value to boolean even though
// the TypeScript compiler has narrowed the type to boolean already.
// noinspection PointlessBooleanExpressionJS
this.experimentalAutoDetectLongPolling=!!e.experimentalAutoDetectLongPolling,this.experimentalLongPollingOptions=__PRIVATE_cloneLongPollingOptions(null!==(n=e.experimentalLongPollingOptions)&&void 0!==n?n:{}),function __PRIVATE_validateLongPollingOptions(e){if(void 0!==e.timeoutSeconds){if(isNaN(e.timeoutSeconds))throw new FirestoreError(C.INVALID_ARGUMENT,"invalid long polling timeout: ".concat(e.timeoutSeconds," (must not be NaN)"));if(e.timeoutSeconds<5)throw new FirestoreError(C.INVALID_ARGUMENT,"invalid long polling timeout: ".concat(e.timeoutSeconds," (minimum allowed value is 5)"));if(e.timeoutSeconds>30)throw new FirestoreError(C.INVALID_ARGUMENT,"invalid long polling timeout: ".concat(e.timeoutSeconds," (maximum allowed value is 30)"));}}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */(this.experimentalLongPollingOptions),this.useFetchStreams=!!e.useFetchStreams;}_createClass(FirestoreSettingsImpl,[{key:"isEqual",value:function isEqual(e){return this.host===e.host&&this.ssl===e.ssl&&this.credentials===e.credentials&&this.cacheSizeBytes===e.cacheSizeBytes&&this.experimentalForceLongPolling===e.experimentalForceLongPolling&&this.experimentalAutoDetectLongPolling===e.experimentalAutoDetectLongPolling&&function __PRIVATE_longPollingOptionsEqual(e,t){return e.timeoutSeconds===t.timeoutSeconds;}(this.experimentalLongPollingOptions,e.experimentalLongPollingOptions)&&this.ignoreUndefinedProperties===e.ignoreUndefinedProperties&&this.useFetchStreams===e.useFetchStreams;}}]);return FirestoreSettingsImpl;}();var Firestore$1=/*#__PURE__*/function(){/** @hideconstructor */function Firestore$1(e,t,n,r){_classCallCheck(this,Firestore$1);this._authCredentials=e,this._appCheckCredentials=t,this._databaseId=n,this._app=r,/**
         * Whether it's a Firestore or Firestore Lite instance.
         */this.type="firestore-lite",this._persistenceKey="(lite)",this._settings=new FirestoreSettingsImpl({}),this._settingsFrozen=!1;}/**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */_createClass(Firestore$1,[{key:"app",get:function get(){if(!this._app)throw new FirestoreError(C.FAILED_PRECONDITION,"Firestore was not initialized using the Firebase SDK. 'app' is not available");return this._app;}},{key:"_initialized",get:function get(){return this._settingsFrozen;}},{key:"_terminated",get:function get(){return void 0!==this._terminateTask;}},{key:"_setSettings",value:function _setSettings(e){if(this._settingsFrozen)throw new FirestoreError(C.FAILED_PRECONDITION,"Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");this._settings=new FirestoreSettingsImpl(e),void 0!==e.credentials&&(this._authCredentials=function __PRIVATE_makeAuthCredentialsProvider(e){if(!e)return new __PRIVATE_EmptyAuthCredentialsProvider();switch(e.type){case"firstParty":return new __PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex||"0",e.iamToken||null,e.authTokenFactory||null);case"provider":return e.client;default:throw new FirestoreError(C.INVALID_ARGUMENT,"makeAuthCredentialsProvider failed due to invalid credential type");}}(e.credentials));}},{key:"_getSettings",value:function _getSettings(){return this._settings;}},{key:"_freezeSettings",value:function _freezeSettings(){return this._settingsFrozen=!0,this._settings;}},{key:"_delete",value:function _delete(){return this._terminateTask||(this._terminateTask=this._terminate()),this._terminateTask;}/** Returns a JSON-serializable representation of this `Firestore` instance. */},{key:"toJSON",value:function toJSON(){return {app:this._app,databaseId:this._databaseId,settings:this._settings};}/**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */},{key:"_terminate",value:function _terminate(){/**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */return function __PRIVATE_removeComponents(e){var t=ye.get(e);t&&(__PRIVATE_logDebug("ComponentProvider","Removing Datastore"),ye["delete"](e),t.terminate());}(this),Promise.resolve();}}]);return Firestore$1;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */var Query=/*#__PURE__*/function(){// This is the lite version of the Query class in the main SDK.
/** @hideconstructor protected */function Query(e,/**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */t,n){_classCallCheck(this,Query);this.converter=t,this._query=n,/** The type of this Firestore reference. */this.type="query",this.firestore=e;}_createClass(Query,[{key:"withConverter",value:function withConverter(e){return new Query(this.firestore,e,this._query);}}]);return Query;}();/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */var DocumentReference=/*#__PURE__*/function(){/** @hideconstructor */function DocumentReference(e,/**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */t,n){_classCallCheck(this,DocumentReference);this.converter=t,this._key=n,/** The type of this Firestore reference. */this.type="document",this.firestore=e;}_createClass(DocumentReference,[{key:"_path",get:function get(){return this._key.path;}/**
     * The document's identifier within its collection.
     */},{key:"id",get:function get(){return this._key.path.lastSegment();}/**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */},{key:"path",get:function get(){return this._key.path.canonicalString();}/**
     * The collection this `DocumentReference` belongs to.
     */},{key:"parent",get:function get(){return new CollectionReference(this.firestore,this.converter,this._key.path.popLast());}},{key:"withConverter",value:function withConverter(e){return new DocumentReference(this.firestore,e,this._key);}}]);return DocumentReference;}();/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */var CollectionReference=/*#__PURE__*/function(_Query){_inherits(CollectionReference,_Query);var _super35=_createSuper(CollectionReference);/** @hideconstructor */function CollectionReference(e,t,n){var _this198;_classCallCheck(this,CollectionReference);_this198=_super35.call(this,e,t,__PRIVATE_newQueryForPath(n)),_this198._path=n,/** The type of this Firestore reference. */_this198.type="collection";return _this198;}/** The collection's identifier. */_createClass(CollectionReference,[{key:"id",get:function get(){return this._query.path.lastSegment();}/**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */},{key:"path",get:function get(){return this._query.path.canonicalString();}/**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */},{key:"parent",get:function get(){var e=this._path.popLast();return e.isEmpty()?null:new DocumentReference(this.firestore,/* converter= */null,new DocumentKey(e));}},{key:"withConverter",value:function withConverter(e){return new CollectionReference(this.firestore,e,this._path);}}]);return CollectionReference;}(Query);function doc(e,t){for(var _len8=arguments.length,n=new Array(_len8>2?_len8-2:0),_key8=2;_key8<_len8;_key8++){n[_key8-2]=arguments[_key8];}if(e=getModularInstance(e),// We allow omission of 'pathString' but explicitly prohibit passing in both
// 'undefined' and 'null'.
1===arguments.length&&(t=__PRIVATE_AutoId.newId()),__PRIVATE_validateNonEmptyArgument("doc","path",t),e instanceof Firestore$1){var _r32=ResourcePath.fromString.apply(ResourcePath,[t].concat(n));return __PRIVATE_validateDocumentPath(_r32),new DocumentReference(e,/* converter= */null,new DocumentKey(_r32));}{if(!(e instanceof DocumentReference||e instanceof CollectionReference))throw new FirestoreError(C.INVALID_ARGUMENT,"Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");var _r33=e._path.child(ResourcePath.fromString.apply(ResourcePath,[t].concat(n)));return __PRIVATE_validateDocumentPath(_r33),new DocumentReference(e.firestore,e instanceof CollectionReference?e.converter:null,new DocumentKey(_r33));}}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var __PRIVATE_AsyncQueueImpl=/*#__PURE__*/function(){function __PRIVATE_AsyncQueueImpl(){var _this199=this;_classCallCheck(this,__PRIVATE_AsyncQueueImpl);// The last promise in the queue.
this.iu=Promise.resolve(),// A list of retryable operations. Retryable operations are run in order and
// retried with backoff.
this.su=[],// Is this AsyncQueue being shut down? Once it is set to true, it will not
// be changed again.
this.ou=!1,// Operations scheduled to be queued in the future. Operations are
// automatically removed after they are run or canceled.
this._u=[],// visible for testing
this.au=null,// Flag set while there's an outstanding AsyncQueue operation, used for
// assertion sanity-checks.
this.uu=!1,// Enabled during shutdown on Safari to prevent future access to IndexedDB.
this.cu=!1,// List of TimerIds to fast-forward delays for.
this.lu=[],// Backoff timer used to schedule retries for retryable operations
this.Yo=new __PRIVATE_ExponentialBackoff(this,"async_queue_retry"/* TimerId.AsyncQueueRetry */),// Visibility handler that triggers an immediate retry of all retryable
// operations. Meant to speed up recovery when we regain file system access
// after page comes into foreground.
this.hu=function(){var e=getDocument();e&&__PRIVATE_logDebug("AsyncQueue","Visibility state changed to "+e.visibilityState),_this199.Yo.Wo();};var e=getDocument();e&&"function"==typeof e.addEventListener&&e.addEventListener("visibilitychange",this.hu);}_createClass(__PRIVATE_AsyncQueueImpl,[{key:"isShuttingDown",get:function get(){return this.ou;}/**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */},{key:"enqueueAndForget",value:function enqueueAndForget(e){// eslint-disable-next-line @typescript-eslint/no-floating-promises
this.enqueue(e);}},{key:"enqueueAndForgetEvenWhileRestricted",value:function enqueueAndForgetEvenWhileRestricted(e){this.Pu(),// eslint-disable-next-line @typescript-eslint/no-floating-promises
this.Iu(e);}},{key:"enterRestrictedMode",value:function enterRestrictedMode(e){if(!this.ou){this.ou=!0,this.cu=e||!1;var t=getDocument();t&&"function"==typeof t.removeEventListener&&t.removeEventListener("visibilitychange",this.hu);}}},{key:"enqueue",value:function enqueue(e){var _this200=this;if(this.Pu(),this.ou)// Return a Promise which never resolves.
return new Promise(function(){});// Create a deferred Promise that we can return to the callee. This
// allows us to return a "hanging Promise" only to the callee and still
// advance the queue even when the operation is not run.
var t=new __PRIVATE_Deferred();return this.Iu(function(){return _this200.ou&&_this200.cu?Promise.resolve():(e().then(t.resolve,t.reject),t.promise);}).then(function(){return t.promise;});}},{key:"enqueueRetryable",value:function enqueueRetryable(e){var _this201=this;this.enqueueAndForget(function(){return _this201.su.push(e),_this201.Tu();});}/**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */},{key:"Tu",value:function(){var _Tu=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee68(){var _this202=this;return regenerator.wrap(function _callee68$(_context68){while(1){switch(_context68.prev=_context68.next){case 0:if(!(0!==this.su.length)){_context68.next=14;break;}_context68.prev=1;_context68.next=4;return this.su[0]();case 4:this.su.shift();this.Yo.reset();_context68.next=13;break;case 8:_context68.prev=8;_context68.t0=_context68["catch"](1);if(__PRIVATE_isIndexedDbTransactionError(_context68.t0)){_context68.next=12;break;}throw _context68.t0;case 12:// Failure will be handled by AsyncQueue
__PRIVATE_logDebug("AsyncQueue","Operation failed with retryable error: "+_context68.t0);case 13:this.su.length>0&&// If there are additional operations, we re-schedule `retryNextOp()`.
// This is necessary to run retryable operations that failed during
// their initial attempt since we don't know whether they are already
// enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
// needs to  be re-run, we will run `op1`, `op1`, `op2` using the
// already enqueued calls to `retryNextOp()`. `op3()` will then run in the
// call scheduled here.
// Since `backoffAndRun()` cancels an existing backoff and schedules a
// new backoff on every call, there is only ever a single additional
// operation in the queue.
this.Yo.$o(function(){return _this202.Tu();});case 14:case"end":return _context68.stop();}}},_callee68,this,[[1,8]]);}));function Tu(){return _Tu.apply(this,arguments);}return Tu;}()},{key:"Iu",value:function Iu(e){var _this203=this;var t=this.iu.then(function(){return _this203.uu=!0,e()["catch"](function(e){_this203.au=e,_this203.uu=!1;var t=/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */function __PRIVATE_getMessageOrStack(e){var t=e.message||"";e.stack&&(t=e.stack.includes(e.message)?e.stack:e.message+"\n"+e.stack);return t;}/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */(e);// Re-throw the error so that this.tail becomes a rejected Promise and
// all further attempts to chain (via .then) will just short-circuit
// and return the rejected Promise.
throw __PRIVATE_logError("INTERNAL UNHANDLED ERROR: ",t),e;}).then(function(e){return _this203.uu=!1,e;});});return this.iu=t,t;}},{key:"enqueueAfterDelay",value:function enqueueAfterDelay(e,t,n){var _this204=this;this.Pu(),// Fast-forward delays for timerIds that have been overriden.
this.lu.indexOf(e)>-1&&(t=0);var r=DelayedOperation.createAndSchedule(this,e,t,n,function(e){return _this204.Eu(e);});return this._u.push(r),r;}},{key:"Pu",value:function Pu(){this.au&&fail();}},{key:"verifyOperationInProgress",value:function verifyOperationInProgress(){}/**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */},{key:"du",value:function(){var _du=_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee69(){var e;return regenerator.wrap(function _callee69$(_context69){while(1){switch(_context69.prev=_context69.next){case 0:e=this.iu;_context69.next=3;return e;case 3:if(e!==this.iu){_context69.next=0;break;}case 4:case"end":return _context69.stop();}}},_callee69,this);}));function du(){return _du.apply(this,arguments);}return du;}()/**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */},{key:"Au",value:function Au(e){var _iterator75=_createForOfIteratorHelper(this._u),_step75;try{for(_iterator75.s();!(_step75=_iterator75.n()).done;){var t=_step75.value;if(t.timerId===e)return !0;}}catch(err){_iterator75.e(err);}finally{_iterator75.f();}return !1;}/**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */},{key:"Ru",value:function Ru(e){var _this205=this;// Note that draining may generate more delayed ops, so we do that first.
return this.du().then(function(){// Run ops in the same order they'd run if they ran naturally.
_this205._u.sort(function(e,t){return e.targetTimeMs-t.targetTimeMs;});var _iterator76=_createForOfIteratorHelper(_this205._u),_step76;try{for(_iterator76.s();!(_step76=_iterator76.n()).done;){var t=_step76.value;if(t.skipDelay(),"all"/* TimerId.All */!==e&&t.timerId===e)break;}}catch(err){_iterator76.e(err);}finally{_iterator76.f();}return _this205.du();});}/**
     * For Tests: Skip all subsequent delays for a timer id.
     */},{key:"Vu",value:function Vu(e){this.lu.push(e);}/** Called once a DelayedOperation is run or canceled. */},{key:"Eu",value:function Eu(e){// NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
var t=this._u.indexOf(e);this._u.splice(t,1);}}]);return __PRIVATE_AsyncQueueImpl;}();/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */var Firestore=/*#__PURE__*/function(_Firestore$){_inherits(Firestore,_Firestore$);var _super36=_createSuper(Firestore);/** @hideconstructor */function Firestore(e,t,n,r){var _this206;_classCallCheck(this,Firestore);_this206=_super36.call(this,e,t,n,r),/**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */_this206.type="firestore",_this206._queue=function __PRIVATE_newAsyncQueue(){return new __PRIVATE_AsyncQueueImpl();}(),_this206._persistenceKey=(null==r?void 0:r.name)||"[DEFAULT]";return _this206;}_createClass(Firestore,[{key:"_terminate",value:function _terminate(){return this._firestoreClient||// The client must be initialized to ensure that all subsequent API
// usage throws an exception.
__PRIVATE_configureFirestore(this),this._firestoreClient.terminate();}}]);return Firestore;}(Firestore$1);/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */function initializeFirestore(e,t,n){n||(n="(default)");var r=_getProvider(e,"firestore");if(r.isInitialized(n)){var _e103=r.getImmediate({identifier:n}),i=r.getOptions(n);if(deepEqual(i,t))return _e103;throw new FirestoreError(C.FAILED_PRECONDITION,"initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");}if(void 0!==t.cacheSizeBytes&&void 0!==t.localCache)throw new FirestoreError(C.INVALID_ARGUMENT,"cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");if(void 0!==t.cacheSizeBytes&&-1!==t.cacheSizeBytes&&t.cacheSizeBytes<1048576)throw new FirestoreError(C.INVALID_ARGUMENT,"cacheSizeBytes must be at least 1048576");return r.initialize({options:t,instanceIdentifier:n});}/**
 * @internal
 */function ensureFirestoreConfigured(e){return e._firestoreClient||__PRIVATE_configureFirestore(e),e._firestoreClient.verifyNotTerminated(),e._firestoreClient;}function __PRIVATE_configureFirestore(e){var t,n,r;var i=e._freezeSettings(),s=function __PRIVATE_makeDatabaseInfo(e,t,n,r){return new DatabaseInfo(e,t,n,r.host,r.ssl,r.experimentalForceLongPolling,r.experimentalAutoDetectLongPolling,__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions),r.useFetchStreams);}(e._databaseId,(null===(t=e._app)||void 0===t?void 0:t.options.appId)||"",e._persistenceKey,i);e._firestoreClient=new FirestoreClient(e._authCredentials,e._appCheckCredentials,e._queue,s),(null===(n=i.localCache)||void 0===n?void 0:n._offlineComponentProvider)&&(null===(r=i.localCache)||void 0===r?void 0:r._onlineComponentProvider)&&(e._firestoreClient._uninitializedComponentsProvider={_offlineKind:i.localCache.kind,_offline:i.localCache._offlineComponentProvider,_online:i.localCache._onlineComponentProvider});}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */var Bytes=/*#__PURE__*/function(){/** @hideconstructor */function Bytes(e){_classCallCheck(this,Bytes);this._byteString=e;}/**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */_createClass(Bytes,[{key:"toBase64",value:/**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */function toBase64(){return this._byteString.toBase64();}/**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */},{key:"toUint8Array",value:function toUint8Array(){return this._byteString.toUint8Array();}/**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */},{key:"toString",value:function toString(){return "Bytes(base64: "+this.toBase64()+")";}/**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */},{key:"isEqual",value:function isEqual(e){return this._byteString.isEqual(e._byteString);}}],[{key:"fromBase64String",value:function fromBase64String(e){try{return new Bytes(ByteString.fromBase64String(e));}catch(e){throw new FirestoreError(C.INVALID_ARGUMENT,"Failed to construct data from Base64 string: "+e);}}/**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */},{key:"fromUint8Array",value:function fromUint8Array(e){return new Bytes(ByteString.fromUint8Array(e));}}]);return Bytes;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */var FieldPath=/*#__PURE__*/function(){/**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */function FieldPath(){_classCallCheck(this,FieldPath);for(var _len9=arguments.length,e=new Array(_len9),_key9=0;_key9<_len9;_key9++){e[_key9]=arguments[_key9];}for(var t=0;t<e.length;++t){if(0===e[t].length)throw new FirestoreError(C.INVALID_ARGUMENT,"Invalid field name at argument $(i + 1). Field names must not be empty.");}this._internalPath=new FieldPath$1(e);}/**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */_createClass(FieldPath,[{key:"isEqual",value:function isEqual(e){return this._internalPath.isEqual(e._internalPath);}}]);return FieldPath;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */var FieldValue=/*#__PURE__*/_createClass(/**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */function FieldValue(e){_classCallCheck(this,FieldValue);this._methodName=e;});/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */var GeoPoint=/*#__PURE__*/function(){/**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */function GeoPoint(e,t){_classCallCheck(this,GeoPoint);if(!isFinite(e)||e<-90||e>90)throw new FirestoreError(C.INVALID_ARGUMENT,"Latitude must be a number between -90 and 90, but was: "+e);if(!isFinite(t)||t<-180||t>180)throw new FirestoreError(C.INVALID_ARGUMENT,"Longitude must be a number between -180 and 180, but was: "+t);this._lat=e,this._long=t;}/**
     * The latitude of this `GeoPoint` instance.
     */_createClass(GeoPoint,[{key:"latitude",get:function get(){return this._lat;}/**
     * The longitude of this `GeoPoint` instance.
     */},{key:"longitude",get:function get(){return this._long;}/**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */},{key:"isEqual",value:function isEqual(e){return this._lat===e._lat&&this._long===e._long;}/** Returns a JSON-serializable representation of this GeoPoint. */},{key:"toJSON",value:function toJSON(){return {latitude:this._lat,longitude:this._long};}/**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */},{key:"_compareTo",value:function _compareTo(e){return __PRIVATE_primitiveComparator(this._lat,e._lat)||__PRIVATE_primitiveComparator(this._long,e._long);}}]);return GeoPoint;}();/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Se=/^__.*__$/;/** The result of parsing document data (e.g. for a setData call). */var ParsedSetData=/*#__PURE__*/function(){function ParsedSetData(e,t,n){_classCallCheck(this,ParsedSetData);this.data=e,this.fieldMask=t,this.fieldTransforms=n;}_createClass(ParsedSetData,[{key:"toMutation",value:function toMutation(e,t){return null!==this.fieldMask?new __PRIVATE_PatchMutation(e,this.data,this.fieldMask,t,this.fieldTransforms):new __PRIVATE_SetMutation(e,this.data,t,this.fieldTransforms);}}]);return ParsedSetData;}();/** The result of parsing "update" data (i.e. for an updateData call). */var ParsedUpdateData=/*#__PURE__*/function(){function ParsedUpdateData(e,// The fieldMask does not include document transforms.
t,n){_classCallCheck(this,ParsedUpdateData);this.data=e,this.fieldMask=t,this.fieldTransforms=n;}_createClass(ParsedUpdateData,[{key:"toMutation",value:function toMutation(e,t){return new __PRIVATE_PatchMutation(e,this.data,this.fieldMask,t,this.fieldTransforms);}}]);return ParsedUpdateData;}();function __PRIVATE_isWrite(e){switch(e){case 0/* UserDataSource.Set */:// fall through
case 2/* UserDataSource.MergeSet */:// fall through
case 1/* UserDataSource.Update */:return !0;case 3/* UserDataSource.Argument */:case 4/* UserDataSource.ArrayArgument */:return !1;default:throw fail();}}/** A "context" object passed around while parsing user data. */var __PRIVATE_ParseContextImpl=/*#__PURE__*/function(){/**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */function __PRIVATE_ParseContextImpl(e,t,n,r,i,s){_classCallCheck(this,__PRIVATE_ParseContextImpl);this.settings=e,this.databaseId=t,this.serializer=n,this.ignoreUndefinedProperties=r,// Minor hack: If fieldTransforms is undefined, we assume this is an
// external call and we need to validate the entire path.
void 0===i&&this.mu(),this.fieldTransforms=i||[],this.fieldMask=s||[];}_createClass(__PRIVATE_ParseContextImpl,[{key:"path",get:function get(){return this.settings.path;}},{key:"fu",get:function get(){return this.settings.fu;}/** Returns a new context with the specified settings overwritten. */},{key:"gu",value:function gu(e){return new __PRIVATE_ParseContextImpl(Object.assign(Object.assign({},this.settings),e),this.databaseId,this.serializer,this.ignoreUndefinedProperties,this.fieldTransforms,this.fieldMask);}},{key:"pu",value:function pu(e){var t;var n=null===(t=this.path)||void 0===t?void 0:t.child(e),r=this.gu({path:n,yu:!1});return r.wu(e),r;}},{key:"Su",value:function Su(e){var t;var n=null===(t=this.path)||void 0===t?void 0:t.child(e),r=this.gu({path:n,yu:!1});return r.mu(),r;}},{key:"bu",value:function bu(e){// TODO(b/34871131): We don't support array paths right now; so make path
// undefined.
return this.gu({path:void 0,yu:!0});}},{key:"Du",value:function Du(e){return __PRIVATE_createError(e,this.settings.methodName,this.settings.Cu||!1,this.path,this.settings.vu);}/** Returns 'true' if 'fieldPath' was traversed when creating this context. */},{key:"contains",value:function contains(e){return void 0!==this.fieldMask.find(function(t){return e.isPrefixOf(t);})||void 0!==this.fieldTransforms.find(function(t){return e.isPrefixOf(t.field);});}},{key:"mu",value:function mu(){// TODO(b/34871131): Remove null check once we have proper paths for fields
// within arrays.
if(this.path)for(var e=0;e<this.path.length;e++){this.wu(this.path.get(e));}}},{key:"wu",value:function wu(e){if(0===e.length)throw this.Du("Document fields must not be empty");if(__PRIVATE_isWrite(this.fu)&&Se.test(e))throw this.Du('Document fields cannot begin and end with "__"');}}]);return __PRIVATE_ParseContextImpl;}();/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */var __PRIVATE_UserDataReader=/*#__PURE__*/function(){function __PRIVATE_UserDataReader(e,t,n){_classCallCheck(this,__PRIVATE_UserDataReader);this.databaseId=e,this.ignoreUndefinedProperties=t,this.serializer=n||__PRIVATE_newSerializer(e);}/** Creates a new top-level parse context. */_createClass(__PRIVATE_UserDataReader,[{key:"Fu",value:function Fu(e,t,n){var r=arguments.length>3&&arguments[3]!==undefined?arguments[3]:!1;return new __PRIVATE_ParseContextImpl({fu:e,methodName:t,vu:n,path:FieldPath$1.emptyPath(),yu:!1,Cu:r},this.databaseId,this.serializer,this.ignoreUndefinedProperties);}}]);return __PRIVATE_UserDataReader;}();function __PRIVATE_newUserDataReader(e){var t=e._freezeSettings(),n=__PRIVATE_newSerializer(e._databaseId);return new __PRIVATE_UserDataReader(e._databaseId,!!t.ignoreUndefinedProperties,n);}/** Parse document data from a set() call. */function __PRIVATE_parseSetData(e,t,n,r,i){var s=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};var o=e.Fu(s.merge||s.mergeFields?2/* UserDataSource.MergeSet */:0/* UserDataSource.Set */,t,n,i);__PRIVATE_validatePlainObject("Data must be an object, but it was:",o,r);var _=__PRIVATE_parseObject(r,o);var a,u;if(s.merge)a=new FieldMask(o.fieldMask),u=o.fieldTransforms;else if(s.mergeFields){var _e104=[];var _iterator78=_createForOfIteratorHelper(s.mergeFields),_step78;try{for(_iterator78.s();!(_step78=_iterator78.n()).done;){var _r34=_step78.value;var _i17=__PRIVATE_fieldPathFromArgument$1(t,_r34,n);if(!o.contains(_i17))throw new FirestoreError(C.INVALID_ARGUMENT,"Field '".concat(_i17,"' is specified in your field mask but missing from your input data."));__PRIVATE_fieldMaskContains(_e104,_i17)||_e104.push(_i17);}}catch(err){_iterator78.e(err);}finally{_iterator78.f();}a=new FieldMask(_e104),u=o.fieldTransforms.filter(function(e){return a.covers(e.field);});}else a=null,u=o.fieldTransforms;return new ParsedSetData(new ObjectValue(_),a,u);}var __PRIVATE_DeleteFieldValueImpl=/*#__PURE__*/function(_FieldValue){_inherits(__PRIVATE_DeleteFieldValueImpl,_FieldValue);var _super37=_createSuper(__PRIVATE_DeleteFieldValueImpl);function __PRIVATE_DeleteFieldValueImpl(){_classCallCheck(this,__PRIVATE_DeleteFieldValueImpl);return _super37.apply(this,arguments);}_createClass(__PRIVATE_DeleteFieldValueImpl,[{key:"_toFieldTransform",value:function _toFieldTransform(e){if(2/* UserDataSource.MergeSet */!==e.fu)throw 1/* UserDataSource.Update */===e.fu?e.Du("".concat(this._methodName,"() can only appear at the top level of your update data")):e.Du("".concat(this._methodName,"() cannot be used with set() unless you pass {merge:true}"));// No transform to add for a delete, but we need to add it to our
// fieldMask so it gets deleted.
return e.fieldMask.push(e.path),null;}},{key:"isEqual",value:function isEqual(e){return e instanceof __PRIVATE_DeleteFieldValueImpl;}}]);return __PRIVATE_DeleteFieldValueImpl;}(FieldValue);/** Parse update data from an update() call. */function __PRIVATE_parseUpdateData(e,t,n,r){var i=e.Fu(1/* UserDataSource.Update */,t,n);__PRIVATE_validatePlainObject("Data must be an object, but it was:",i,r);var s=[],o=ObjectValue.empty();_forEach(r,function(e,r){var _=__PRIVATE_fieldPathFromDotSeparatedString(t,e,n);// For Compat types, we have to "extract" the underlying types before
// performing validation.
r=getModularInstance(r);var a=i.Su(_);if(r instanceof __PRIVATE_DeleteFieldValueImpl)// Add it to the field mask, but don't add anything to updateData.
s.push(_);else {var _e105=__PRIVATE_parseData(r,a);null!=_e105&&(s.push(_),o.set(_,_e105));}});var _=new FieldMask(s);return new ParsedUpdateData(o,_,i.fieldTransforms);}/** Parse update data from a list of field/value arguments. */function __PRIVATE_parseUpdateVarargs(e,t,n,r,i,s){var o=e.Fu(1/* UserDataSource.Update */,t,n),_=[__PRIVATE_fieldPathFromArgument$1(t,r,n)],a=[i];if(s.length%2!=0)throw new FirestoreError(C.INVALID_ARGUMENT,"Function ".concat(t,"() needs to be called with an even number of arguments that alternate between field names and values."));for(var _e106=0;_e106<s.length;_e106+=2){_.push(__PRIVATE_fieldPathFromArgument$1(t,s[_e106])),a.push(s[_e106+1]);}var u=[],c=ObjectValue.empty();// We iterate in reverse order to pick the last value for a field if the
// user specified the field multiple times.
for(var _e107=_.length-1;_e107>=0;--_e107){if(!__PRIVATE_fieldMaskContains(u,_[_e107])){var _t51=_[_e107];var _n30=a[_e107];// For Compat types, we have to "extract" the underlying types before
// performing validation.
_n30=getModularInstance(_n30);var _r35=o.Su(_t51);if(_n30 instanceof __PRIVATE_DeleteFieldValueImpl)// Add it to the field mask, but don't add anything to updateData.
u.push(_t51);else {var _e108=__PRIVATE_parseData(_n30,_r35);null!=_e108&&(u.push(_t51),c.set(_t51,_e108));}}}var l=new FieldMask(u);return new ParsedUpdateData(c,l,o.fieldTransforms);}/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */function __PRIVATE_parseData(e,t){if(__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
// from firestore-exp.
e=getModularInstance(e)))return __PRIVATE_validatePlainObject("Unsupported field value:",t,e),__PRIVATE_parseObject(e,t);if(e instanceof FieldValue)// FieldValues usually parse into transforms (except deleteField())
// in which case we do not want to include this field in our parsed data
// (as doing so will overwrite the field directly prior to the transform
// trying to transform it). So we don't add this location to
// context.fieldMask and we return null as our parsing result.
/**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */return function __PRIVATE_parseSentinelFieldValue(e,t){// Sentinels are only supported with writes, and not within arrays.
if(!__PRIVATE_isWrite(t.fu))throw t.Du("".concat(e._methodName,"() can only be used with update() and set()"));if(!t.path)throw t.Du("".concat(e._methodName,"() is not currently supported inside arrays"));var n=e._toFieldTransform(t);n&&t.fieldTransforms.push(n);}/**
 * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
 *
 * @returns The parsed value
 */(e,t),null;if(void 0===e&&t.ignoreUndefinedProperties)// If the input is undefined it can never participate in the fieldMask, so
// don't handle this below. If `ignoreUndefinedProperties` is false,
// `parseScalarValue` will reject an undefined value.
return null;if(// If context.path is null we are inside an array and we don't support
// field mask paths more granular than the top-level array.
t.path&&t.fieldMask.push(t.path),e instanceof Array){// TODO(b/34871131): Include the path containing the array in the error
// message.
// In the case of IN queries, the parsed data is an array (representing
// the set of values to be included for the IN query) that may directly
// contain additional arrays (each representing an individual field
// value), so we disable this validation.
if(t.settings.yu&&4/* UserDataSource.ArrayArgument */!==t.fu)throw t.Du("Nested arrays are not supported");return function __PRIVATE_parseArray(e,t){var n=[];var r=0;var _iterator79=_createForOfIteratorHelper(e),_step79;try{for(_iterator79.s();!(_step79=_iterator79.n()).done;){var i=_step79.value;var _e109=__PRIVATE_parseData(i,t.bu(r));null==_e109&&(// Just include nulls in the array for fields being replaced with a
// sentinel.
_e109={nullValue:"NULL_VALUE"}),n.push(_e109),r++;}}catch(err){_iterator79.e(err);}finally{_iterator79.f();}return {arrayValue:{values:n}};}(e,t);}return function __PRIVATE_parseScalarValue(e,t){if(null===(e=getModularInstance(e)))return {nullValue:"NULL_VALUE"};if("number"==typeof e)return toNumber(t.serializer,e);if("boolean"==typeof e)return {booleanValue:e};if("string"==typeof e)return {stringValue:e};if(e instanceof Date){var n=Timestamp.fromDate(e);return {timestampValue:toTimestamp(t.serializer,n)};}if(e instanceof Timestamp){// Firestore backend truncates precision down to microseconds. To ensure
// offline mode works the same with regards to truncation, perform the
// truncation immediately without waiting for the backend to do that.
var _n31=new Timestamp(e.seconds,1e3*Math.floor(e.nanoseconds/1e3));return {timestampValue:toTimestamp(t.serializer,_n31)};}if(e instanceof GeoPoint)return {geoPointValue:{latitude:e.latitude,longitude:e.longitude}};if(e instanceof Bytes)return {bytesValue:__PRIVATE_toBytes(t.serializer,e._byteString)};if(e instanceof DocumentReference){var _n32=t.databaseId,_r36=e.firestore._databaseId;if(!_r36.isEqual(_n32))throw t.Du("Document reference is for database ".concat(_r36.projectId,"/").concat(_r36.database," but should be for database ").concat(_n32.projectId,"/").concat(_n32.database));return {referenceValue:__PRIVATE_toResourceName(e.firestore._databaseId||t.databaseId,e._key.path)};}throw t.Du("Unsupported field value: ".concat(__PRIVATE_valueDescription(e)));}/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */(e,t);}function __PRIVATE_parseObject(e,t){var n={};return _isEmpty(e)?// If we encounter an empty object, we explicitly add it to the update
// mask to ensure that the server creates a map entry.
t.path&&t.path.length>0&&t.fieldMask.push(t.path):_forEach(e,function(e,r){var i=__PRIVATE_parseData(r,t.pu(e));null!=i&&(n[e]=i);}),{mapValue:{fields:n}};}function __PRIVATE_looksLikeJsonObject(e){return !("object"!=_typeof(e)||null===e||e instanceof Array||e instanceof Date||e instanceof Timestamp||e instanceof GeoPoint||e instanceof Bytes||e instanceof DocumentReference||e instanceof FieldValue);}function __PRIVATE_validatePlainObject(e,t,n){if(!__PRIVATE_looksLikeJsonObject(n)||!function __PRIVATE_isPlainObject(e){return "object"==_typeof(e)&&null!==e&&(Object.getPrototypeOf(e)===Object.prototype||null===Object.getPrototypeOf(e));}(n)){var _r37=__PRIVATE_valueDescription(n);throw "an object"===_r37?t.Du(e+" a custom object"):t.Du(e+" "+_r37);}}/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */function __PRIVATE_fieldPathFromArgument$1(e,t,n){if((// If required, replace the FieldPath Compat class with with the firestore-exp
// FieldPath.
t=getModularInstance(t))instanceof FieldPath)return t._internalPath;if("string"==typeof t)return __PRIVATE_fieldPathFromDotSeparatedString(e,t);throw __PRIVATE_createError("Field path arguments must be of type string or ",e,/* hasConverter= */!1,/* path= */void 0,n);}/**
 * Matches any characters in a field path string that are reserved.
 */var be=new RegExp("[~\\*/\\[\\]]");/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */function __PRIVATE_fieldPathFromDotSeparatedString(e,t,n){if(t.search(be)>=0)throw __PRIVATE_createError("Invalid field path (".concat(t,"). Paths must not contain '~', '*', '/', '[', or ']'"),e,/* hasConverter= */!1,/* path= */void 0,n);try{return _construct(FieldPath,_toConsumableArray(t.split(".")))._internalPath;}catch(r){throw __PRIVATE_createError("Invalid field path (".concat(t,"). Paths must not be empty, begin with '.', end with '.', or contain '..'"),e,/* hasConverter= */!1,/* path= */void 0,n);}}function __PRIVATE_createError(e,t,n,r,i){var s=r&&!r.isEmpty(),o=void 0!==i;var _="Function ".concat(t,"() called with invalid data");n&&(_+=" (via `toFirestore()`)"),_+=". ";var a="";return (s||o)&&(a+=" (found",s&&(a+=" in field ".concat(r)),o&&(a+=" in document ".concat(i)),a+=")"),new FirestoreError(C.INVALID_ARGUMENT,_+e+a);}/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */function __PRIVATE_fieldMaskContains(e,t){return e.some(function(e){return e.isEqual(t);});}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */var DocumentSnapshot$1=/*#__PURE__*/function(){// Note: This class is stripped down version of the DocumentSnapshot in
// the legacy SDK. The changes are:
// - No support for SnapshotMetadata.
// - No support for SnapshotOptions.
/** @hideconstructor protected */function DocumentSnapshot$1(e,t,n,r,i){_classCallCheck(this,DocumentSnapshot$1);this._firestore=e,this._userDataWriter=t,this._key=n,this._document=r,this._converter=i;}/** Property of the `DocumentSnapshot` that provides the document's ID. */_createClass(DocumentSnapshot$1,[{key:"id",get:function get(){return this._key.path.lastSegment();}/**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */},{key:"ref",get:function get(){return new DocumentReference(this._firestore,this._converter,this._key);}/**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */},{key:"exists",value:function exists(){return null!==this._document;}/**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */},{key:"data",value:function data(){if(this._document){if(this._converter){// We only want to use the converter and create a new DocumentSnapshot
// if a converter has been provided.
var e=new QueryDocumentSnapshot$1(this._firestore,this._userDataWriter,this._key,this._document,/* converter= */null);return this._converter.fromFirestore(e);}return this._userDataWriter.convertValue(this._document.data.value);}}/**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
},{key:"get",value:function get(e){if(this._document){var t=this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get",e));if(null!==t)return this._userDataWriter.convertValue(t);}}}]);return DocumentSnapshot$1;}();/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */var QueryDocumentSnapshot$1=/*#__PURE__*/function(_DocumentSnapshot$){_inherits(QueryDocumentSnapshot$1,_DocumentSnapshot$);var _super42=_createSuper(QueryDocumentSnapshot$1);function QueryDocumentSnapshot$1(){_classCallCheck(this,QueryDocumentSnapshot$1);return _super42.apply(this,arguments);}_createClass(QueryDocumentSnapshot$1,[{key:"data",value:/**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */function data(){return _get(_getPrototypeOf(QueryDocumentSnapshot$1.prototype),"data",this).call(this);}}]);return QueryDocumentSnapshot$1;}(DocumentSnapshot$1);/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */function __PRIVATE_fieldPathFromArgument(e,t){return "string"==typeof t?__PRIVATE_fieldPathFromDotSeparatedString(e,t):t instanceof FieldPath?t._internalPath:t._delegate._internalPath;}var AbstractUserDataWriter=/*#__PURE__*/function(){function AbstractUserDataWriter(){_classCallCheck(this,AbstractUserDataWriter);}_createClass(AbstractUserDataWriter,[{key:"convertValue",value:function convertValue(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"none";switch(__PRIVATE_typeOrder(e)){case 0/* TypeOrder.NullValue */:return null;case 1/* TypeOrder.BooleanValue */:return e.booleanValue;case 2/* TypeOrder.NumberValue */:return __PRIVATE_normalizeNumber(e.integerValue||e.doubleValue);case 3/* TypeOrder.TimestampValue */:return this.convertTimestamp(e.timestampValue);case 4/* TypeOrder.ServerTimestampValue */:return this.convertServerTimestamp(e,t);case 5/* TypeOrder.StringValue */:return e.stringValue;case 6/* TypeOrder.BlobValue */:return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));case 7/* TypeOrder.RefValue */:return this.convertReference(e.referenceValue);case 8/* TypeOrder.GeoPointValue */:return this.convertGeoPoint(e.geoPointValue);case 9/* TypeOrder.ArrayValue */:return this.convertArray(e.arrayValue,t);case 10/* TypeOrder.ObjectValue */:return this.convertObject(e.mapValue,t);default:throw fail();}}},{key:"convertObject",value:function convertObject(e,t){return this.convertObjectMap(e.fields,t);}/**
     * @internal
     */},{key:"convertObjectMap",value:function convertObjectMap(e){var _this216=this;var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"none";var n={};return _forEach(e,function(e,r){n[e]=_this216.convertValue(r,t);}),n;}},{key:"convertGeoPoint",value:function convertGeoPoint(e){return new GeoPoint(__PRIVATE_normalizeNumber(e.latitude),__PRIVATE_normalizeNumber(e.longitude));}},{key:"convertArray",value:function convertArray(e,t){var _this217=this;return (e.values||[]).map(function(e){return _this217.convertValue(e,t);});}},{key:"convertServerTimestamp",value:function convertServerTimestamp(e,t){switch(t){case"previous":var n=__PRIVATE_getPreviousValue(e);return null==n?null:this.convertValue(n,t);case"estimate":return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));default:return null;}}},{key:"convertTimestamp",value:function convertTimestamp(e){var t=__PRIVATE_normalizeTimestamp(e);return new Timestamp(t.seconds,t.nanos);}},{key:"convertDocumentKey",value:function convertDocumentKey(e,t){var n=ResourcePath.fromString(e);__PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n));var r=new DatabaseId(n.get(1),n.get(3)),i=new DocumentKey(n.popFirst(5));return r.isEqual(t)||// TODO(b/64130202): Somehow support foreign references.
__PRIVATE_logError("Document ".concat(i," contains a document reference within a different database (").concat(r.projectId,"/").concat(r.database,") which is not supported. It will be treated as a reference in the current database (").concat(t.projectId,"/").concat(t.database,") instead.")),i;}}]);return AbstractUserDataWriter;}();/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */function __PRIVATE_applyFirestoreDataConverter(e,t,n){var r;// Cast to `any` in order to satisfy the union type constraint on
// toFirestore().
// eslint-disable-next-line @typescript-eslint/no-explicit-any
return r=e?n&&(n.merge||n.mergeFields)?e.toFirestore(t,n):e.toFirestore(t):t,r;}/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */var SnapshotMetadata=/*#__PURE__*/function(){/** @hideconstructor */function SnapshotMetadata(e,t){_classCallCheck(this,SnapshotMetadata);this.hasPendingWrites=e,this.fromCache=t;}/**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */_createClass(SnapshotMetadata,[{key:"isEqual",value:function isEqual(e){return this.hasPendingWrites===e.hasPendingWrites&&this.fromCache===e.fromCache;}}]);return SnapshotMetadata;}();/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */var DocumentSnapshot=/*#__PURE__*/function(_DocumentSnapshot$2){_inherits(DocumentSnapshot,_DocumentSnapshot$2);var _super51=_createSuper(DocumentSnapshot);/** @hideconstructor protected */function DocumentSnapshot(e,t,n,r,i,s){var _this219;_classCallCheck(this,DocumentSnapshot);_this219=_super51.call(this,e,t,n,r,s),_this219._firestore=e,_this219._firestoreImpl=e,_this219.metadata=i;return _this219;}/**
     * Returns whether or not the data exists. True if the document exists.
     */_createClass(DocumentSnapshot,[{key:"exists",value:function exists(){return _get(_getPrototypeOf(DocumentSnapshot.prototype),"exists",this).call(this);}/**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */},{key:"data",value:function data(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this._document){if(this._converter){// We only want to use the converter and create a new DocumentSnapshot
// if a converter has been provided.
var t=new QueryDocumentSnapshot(this._firestore,this._userDataWriter,this._key,this._document,this.metadata,/* converter= */null);return this._converter.fromFirestore(t,e);}return this._userDataWriter.convertValue(this._document.data.value,e.serverTimestamps);}}/**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
},{key:"get",value:function get(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(this._document){var n=this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get",e));if(null!==n)return this._userDataWriter.convertValue(n,t.serverTimestamps);}}}]);return DocumentSnapshot;}(DocumentSnapshot$1);/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */var QueryDocumentSnapshot=/*#__PURE__*/function(_DocumentSnapshot){_inherits(QueryDocumentSnapshot,_DocumentSnapshot);var _super52=_createSuper(QueryDocumentSnapshot);function QueryDocumentSnapshot(){_classCallCheck(this,QueryDocumentSnapshot);return _super52.apply(this,arguments);}_createClass(QueryDocumentSnapshot,[{key:"data",value:/**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */function data(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _get(_getPrototypeOf(QueryDocumentSnapshot.prototype),"data",this).call(this,e);}}]);return QueryDocumentSnapshot;}(DocumentSnapshot);/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */function getDoc(e){e=__PRIVATE_cast(e,DocumentReference);var t=__PRIVATE_cast(e.firestore,Firestore);return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(ensureFirestoreConfigured(t),e._key).then(function(n){return __PRIVATE_convertToDocSnapshot(t,e,n);});}var __PRIVATE_ExpUserDataWriter=/*#__PURE__*/function(_AbstractUserDataWrit2){_inherits(__PRIVATE_ExpUserDataWriter,_AbstractUserDataWrit2);var _super53=_createSuper(__PRIVATE_ExpUserDataWriter);function __PRIVATE_ExpUserDataWriter(e){var _this221;_classCallCheck(this,__PRIVATE_ExpUserDataWriter);_this221=_super53.call(this),_this221.firestore=e;return _this221;}_createClass(__PRIVATE_ExpUserDataWriter,[{key:"convertBytes",value:function convertBytes(e){return new Bytes(e);}},{key:"convertReference",value:function convertReference(e){var t=this.convertDocumentKey(e,this.firestore._databaseId);return new DocumentReference(this.firestore,/* converter= */null,t);}}]);return __PRIVATE_ExpUserDataWriter;}(AbstractUserDataWriter);function setDoc(e,t,n){e=__PRIVATE_cast(e,DocumentReference);var r=__PRIVATE_cast(e.firestore,Firestore),i=__PRIVATE_applyFirestoreDataConverter(e.converter,t,n);return executeWrite(r,[__PRIVATE_parseSetData(__PRIVATE_newUserDataReader(r),"setDoc",e._key,i,null!==e.converter,n).toMutation(e._key,Precondition.none())]);}function updateDoc(e,t,n){e=__PRIVATE_cast(e,DocumentReference);var i=__PRIVATE_cast(e.firestore,Firestore),s=__PRIVATE_newUserDataReader(i);var o;for(var _len17=arguments.length,r=new Array(_len17>3?_len17-3:0),_key17=3;_key17<_len17;_key17++){r[_key17-3]=arguments[_key17];}o="string"==typeof(// For Compat types, we have to "extract" the underlying types before
// performing validation.
t=getModularInstance(t))||t instanceof FieldPath?__PRIVATE_parseUpdateVarargs(s,"updateDoc",e._key,t,n,r):__PRIVATE_parseUpdateData(s,"updateDoc",e._key,t);return executeWrite(i,[o.toMutation(e._key,Precondition.exists(!0))]);}/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */function deleteDoc(e){return executeWrite(__PRIVATE_cast(e.firestore,Firestore),[new __PRIVATE_DeleteMutation(e._key,Precondition.none())]);}/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */function executeWrite(e,t){return function __PRIVATE_firestoreClientWrite(e,t){var n=new __PRIVATE_Deferred();return e.asyncQueue.enqueueAndForget(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee76(){return regenerator.wrap(function _callee76$(_context76){while(1){switch(_context76.prev=_context76.next){case 0:_context76.t0=__PRIVATE_syncEngineWrite;_context76.next=3;return __PRIVATE_getSyncEngine(e);case 3:_context76.t1=_context76.sent;_context76.t2=t;_context76.t3=n;return _context76.abrupt("return",(0, _context76.t0)(_context76.t1,_context76.t2,_context76.t3));case 7:case"end":return _context76.stop();}}},_callee76);}))),n.promise;}(ensureFirestoreConfigured(e),t);}/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */function __PRIVATE_convertToDocSnapshot(e,t,n){var r=n.docs.get(t._key),i=new __PRIVATE_ExpUserDataWriter(e);return new DocumentSnapshot(e,i,t._key,r,new SnapshotMetadata(n.hasPendingWrites,n.fromCache),t.converter);}/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */!function __PRIVATE_registerFirestore(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:!0;!function __PRIVATE_setSDKVersion(e){b=e;}(SDK_VERSION),_registerComponent(new Component("firestore",function(e,_ref57){var n=_ref57.instanceIdentifier,r=_ref57.options;var i=e.getProvider("app").getImmediate(),s=new Firestore(new __PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")),new __PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")),function __PRIVATE_databaseIdFromApp(e,t){if(!Object.prototype.hasOwnProperty.apply(e.options,["projectId"]))throw new FirestoreError(C.INVALID_ARGUMENT,'"projectId" not provided in firebase.initializeApp.');return new DatabaseId(e.options.projectId,t);}(i,n),i);return r=Object.assign({useFetchStreams:t},r),s._setSettings(r),s;},"PUBLIC").setMultipleInstances(!0)),registerVersion(S,"4.6.3",e),// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
registerVersion(S,"4.6.3","esm2017");}();

class FirebaseUserAuthService {
    constructor(config) {
        this.config = config;
        this.authObjectInitialized = false;
        this.isUserDeletionInProgress = false;
        this.updateUserDisplayName = (user, displayName) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                if (user.displayName !== displayName) {
                    return updateProfile(user, {
                        displayName,
                    });
                }
                return {};
            }));
        });
        this.signUp = ({ email = '', password, attributes, }) => __awaiter(this, void 0, void 0, function* () {
            let userCredential = null;
            try {
                userCredential = yield createUserWithEmailAndPassword(this.auth, email, password);
                yield setDoc(doc(this.userDataStore, this.config.userAttrCollectionName, userCredential.user.uid), Object.assign({}, attributes));
                yield sendEmailVerification(userCredential.user);
                yield this.updateUserDisplayName(userCredential.user, (attributes === null || attributes === void 0 ? void 0 : attributes.given_name) || '');
                return Object.assign({ success: true }, userCredential);
            }
            catch (error) {
                if (userCredential) {
                    yield this.deleteUser(userCredential.user);
                }
                return {
                    success: false,
                    message: error.message,
                    code: error.code,
                };
            }
        });
        this.signIn = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () { return signInWithEmailAndPassword(this.auth, params.email, params.password); }));
        });
        this.federatedSignIn = ({ provider, userAttributes, }) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const authProvider = this.getAuthProvider(provider);
                const result = yield signInWithPopup(this.auth, authProvider);
                const providerSpecificData = getAdditionalUserInfo(result);
                if (providerSpecificData === null || providerSpecificData === void 0 ? void 0 : providerSpecificData.isNewUser) {
                    yield setDoc(doc(this.userDataStore, this.config.userAttrCollectionName, result.user.uid), userAttributes !== null && userAttributes !== void 0 ? userAttributes : {});
                }
                return result;
            }));
        });
        this.signOut = () => __awaiter(this, void 0, void 0, function* () { return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () { return signOut(this.auth); })); });
        this.getUserProvidersId = (user) => user.providerData.map((provider) => provider.providerId);
        this.reauthenticateCurrentUser = (params) => __awaiter(this, void 0, void 0, function* () {
            const user = this.getCurrentUser();
            if (user) {
                return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                    const provider = this.getUserProvider(user);
                    if (provider === ProviderId.PASSWORD) {
                        if (params.password) {
                            return this.reauthenticateWithPassword(user, params.password || '');
                        }
                        throw new Error('Missing password parameter');
                    }
                    else {
                        return this.reauthenticateExternalProvider(user, provider);
                    }
                }));
            }
            return { success: false, code: 'auth-custom/reauthentication-impossible' };
        });
        this.getCurrentUser = () => this.authObjectInitialized ? this.auth.currentUser : undefined;
        this.deleteUser = (user) => __awaiter(this, void 0, void 0, function* () {
            const deleteUserCallback = () => {
                this.isUserDeletionInProgress = false;
            };
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                this.isUserDeletionInProgress = true;
                yield deleteDoc(doc(this.userDataStore, this.config.userAttrCollectionName, user.uid));
                yield user.delete();
            }), deleteUserCallback, deleteUserCallback);
        });
        this.reloadUser = () => __awaiter(this, void 0, void 0, function* () {
            const user = this.getCurrentUser();
            yield (user === null || user === void 0 ? void 0 : user.reload());
        });
        this.confirmSignUp = ({ verificationCode, }) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                yield applyActionCode(this.auth, verificationCode);
                yield this.reloadUser();
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent(Events.onAuthStateChange, {
                        detail: { user: this.getCurrentUser() },
                    }));
                }
            }));
        });
        this.authStateChangedObserver = (params) => {
            const { customSignInEvent } = params || {};
            const authStateChangedCallback = (user) => {
                this.authObjectInitialized = true;
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent(Events.onAuthStateChange, {
                        detail: {
                            user,
                            suppressUserAccessValidation: this.isUserDeletionInProgress,
                        },
                    }));
                }
                if ((user === null || user === void 0 ? void 0 : user.emailVerified) && typeof customSignInEvent === 'function') {
                    customSignInEvent();
                }
            };
            onAuthStateChanged(this.auth, authStateChangedCallback);
        };
        this.forgotPassword = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                if (params.userIdentifier.type === UserIdentifierType.Email) {
                    return sendPasswordResetEmail(this.auth, params.userIdentifier.value);
                }
                throw new Error('Invalid user identifier type');
            }));
        });
        this.resetPassword = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () { return confirmPasswordReset(this.auth, params.oobCode, params.newPassword); }));
        });
        this.getUserAttributes = () => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const currentUser = this.getCurrentUser();
                const userAttributes = yield getDoc(doc(this.userDataStore, this.config.userAttrCollectionName, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid) || ''));
                return { attributes: userAttributes.data() };
            }));
        });
        this.setUserAttributes = (attributes) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const currentUser = this.getCurrentUser();
                yield updateDoc(doc(this.userDataStore, this.config.userAttrCollectionName, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid) || ''), attributes);
            }));
        });
        this.changePassword = (params) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const { user, password, currentPassword } = params;
                yield this.reauthenticateWithPassword(user, currentPassword);
                yield updatePassword(user, password);
            }));
        });
        this.resendSignUp = () => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const user = this.getCurrentUser();
                if (!user) {
                    throw new Error('Missing user data');
                }
                return sendEmailVerification(user);
            }));
        });
        this.getAvailableSocialSignIn = () => ({
            [ThirdPartyProvider.Facebook]: Boolean(this.config.hasFacebookSignIn),
            [ThirdPartyProvider.Google]: Boolean(this.config.hasGoogleSignIn),
        });
        this.getRememberMeConfig = () => this.config.rememberMeConfig || {
            show: false,
            defaultValue: false,
        };
        this.setAuthStatePersistence = (rememberMe) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                const type = rememberMe
                    ? indexedDBLocalPersistence
                    : browserSessionPersistence;
                yield setPersistence(this.auth, type);
            }));
        });
        this.changeEmail = (user, newEmail) => this.handleResponse(() => __awaiter(this, void 0, void 0, function* () { return verifyBeforeUpdateEmail(user, newEmail); }));
        this.verifyCodeForEmailChange = ({ verificationCode, }) => __awaiter(this, void 0, void 0, function* () {
            return this.handleResponse(() => __awaiter(this, void 0, void 0, function* () {
                yield applyActionCode(this.auth, verificationCode);
                yield this.signOut();
            }));
        });
        this.getUserProvider = (user) => {
            const userProviderIds = new Set(this.getUserProvidersId(user));
            if (userProviderIds.has(ProviderId.PASSWORD)) {
                return ProviderId.PASSWORD;
            }
            if (userProviderIds.has(ProviderId.FACEBOOK)) {
                return ThirdPartyProvider.Facebook;
            }
            if (userProviderIds.has(ProviderId.GOOGLE)) {
                return ThirdPartyProvider.Google;
            }
            throw Error(`Unknown user provider: ${JSON.stringify(userProviderIds)}`);
        };
        this.reauthenticateWithPassword = (user, password) => {
            const credential = EmailAuthProvider.credential(user.email || '', password);
            return reauthenticateWithCredential(user, credential);
        };
        this.reauthenticateExternalProvider = (user, provider) => {
            const authProvider = this.getAuthProvider(provider);
            return reauthenticateWithPopup(user, authProvider);
        };
        this.handleResponse = (fn, onErrorCallback, onCompletedCallback) => __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield fn();
                onCompletedCallback === null || onCompletedCallback === void 0 ? void 0 : onCompletedCallback();
                return Object.assign(Object.assign({}, result), { success: true });
            }
            catch (error) {
                onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback();
                return Object.assign(Object.assign({}, error), { success: false });
            }
        });
        this.getAuthProvider = (provider) => {
            switch (provider) {
                case ThirdPartyProvider.Google:
                    return new GoogleAuthProvider();
                case ThirdPartyProvider.Facebook:
                    return new FacebookAuthProvider();
                default:
                    throw Error(`No provider with name: ${provider}`);
            }
        };
        this.app = initializeApp(this.config.firebaseOptions);
        this.auth = getAuth(this.app);
        this.userDataStore = initializeFirestore(this.app, {
            ignoreUndefinedProperties: true,
        });
        if (typeof window !== 'undefined') {
            const recaptchaKey = process.env.GATSBY_FIREBASE_RECAPTCHA_PUBLIC_KEY;
            const useDebugToken = process.env.FIREBASE_RECAPTCHA_USE_DEBUG_TOKEN === 'true';
            const ciDebugToken = process.env.APP_CHECK_DEBUG_TOKEN_FROM_CI;
            if (recaptchaKey) {
                if (ciDebugToken) {
                    window.FIREBASE_APPCHECK_DEBUG_TOKEN = ciDebugToken;
                }
                else if (useDebugToken) {
                    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
                }
                initializeAppCheck(this.app, {
                    provider: new ReCaptchaV3Provider(recaptchaKey),
                    isTokenAutoRefreshEnabled: true,
                });
            }
        }
    }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq$3;

var eq$2 = eq_1;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf$4(array, key) {
  var length = array.length;

  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var getNative$1 = _getNative;
/* Built-in method references that are verified to be native. */

var nativeCreate$4 = getNative$1(Object, 'create');
var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet$1(key) {
  var data = this.__data__;

  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }

  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache$2)(),
    'string': new Hash()
  };
}

var _mapCacheClear = mapCacheClear$1;

function isKeyable$1(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$2 = _MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet$1(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache$1) {
    var pairs = data.__data__;

    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache$2(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach$1;

var getNative = _getNative;

var defineProperty$1 = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$1 = eq_1;
/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue$2(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$6.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject$4;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes$1;

var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex$2(value, length) {
  var type = _typeof(value);

  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex$2;

var baseTimes = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$7 = isArray_1,
    isBuffer$2 = isBuffer$4.exports,
    isIndex$1 = _isIndex,
    isTypedArray$1 = isTypedArray_1;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$7(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$2(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$1 = isArrayLike_1;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$3;

var copyObject$3 = _copyObject,
    keys$2 = keys_1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$2 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn$1(object) {
  if (!isObject$2(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
  var root = _root;
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
})(_cloneBuffer, _cloneBuffer.exports);

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$4.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$3;

var copyObject$1 = _copyObject,
    getSymbols$2 = _getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush$2;

var overArg = _overArg;
/** Built-in value references. */

var getPrototype$2 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;

var arrayPush$1 = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush = _arrayPush,
    isArray$6 = isArray_1;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$6(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols);
}

var _getAllKeys = getAllKeys$2;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$3.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray$1;

var root = _root;
/** Built-in value references. */

var Uint8Array$3 = root.Uint8Array;
var _Uint8Array = Uint8Array$3;

var Uint8Array$2 = _Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var _Symbol$2 = _Symbol$5;
/** Used to convert symbols to primitives and strings. */

var symbolProto$2 = _Symbol$2 ? _Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;
/** `Object#toString` result references. */

var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$3 = '[object Symbol]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$2:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor();

    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);

    case regexpTag$2:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor();

    case symbolTag$3:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$1 = isObject_1;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate$1 = function () {
  function object() {}

  return function (proto) {
    if (!isObject$1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject$1(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$3 = _getTag,
    isObjectLike$3 = isObjectLike_1;
/** `Object#toString` result references. */

var mapTag$2 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap$1(value) {
  return isObjectLike$3(value) && getTag$3(value) == mapTag$2;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;

var getTag$2 = _getTag,
    isObjectLike$2 = isObjectLike_1;
/** `Object#toString` result references. */

var setTag$2 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet$1(value) {
  return isObjectLike$2(value) && getTag$2(value) == setTag$2;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;
/* Node.js helper references. */

var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;

var Stack$1 = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$5 = isArray_1,
    isBuffer$1 = isBuffer$4.exports,
    isMap = isMap_1,
    isObject = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject(value)) {
    return value;
  }

  var isArr = isArray$5(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack$1());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var baseGetTag = _baseGetTag,
    isObjectLike$1 = isObjectLike_1;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$3(value) {
  return _typeof(value) == 'symbol' || isObjectLike$1(value) && baseGetTag(value) == symbolTag$1;
}

var isSymbol_1 = isSymbol$3;

var isArray$4 = isArray_1,
    isSymbol$2 = isSymbol_1;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey$1(value, object) {
  if (isArray$4(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$2(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey$1;

var MapCache$1 = _MapCache;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize$1.Cache || MapCache$1)();
  return memoized;
} // Expose `MapCache`.


memoize$1.Cache = MapCache$1;
var memoize_1 = memoize$1;

var memoize = memoize_1;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap$1;

var _Symbol$1 = _Symbol$5,
    arrayMap = _arrayMap,
    isArray$3 = isArray_1,
    isSymbol$1 = isSymbol_1;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol$1 ? _Symbol$1.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$3(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }

  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray$2 = isArray_1,
    isKey = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath$2(value, object) {
  if (isArray$2(value)) {
    return value;
  }

  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$2;

var isSymbol = isSymbol_1;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey$2(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _toKey = toKey$2;

var castPath$1 = _castPath,
    toKey$1 = _toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet$1(object, path) {
  path = castPath$1(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet$1;

var baseGet = _baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHas$1(object, key) {
  return object != null && hasOwnProperty$2.call(object, key);
}

var _baseHas = baseHas$1;

var castPath = _castPath,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isIndex = _isIndex,
    isLength = isLength_1,
    toKey = _toKey;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */

function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments(object));
}

var _hasPath = hasPath$1;

var baseHas = _baseHas,
    hasPath = _hasPath;
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */

function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

var has_1 = has;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$3 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var _Symbol = _Symbol$5,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$2 = 1,
    COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */

var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }

      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag$1;

var getAllKeys = _getAllKeys;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$1 = 1;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var Stack = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray = isArray_1,
    isBuffer = isBuffer$4.exports,
    isTypedArray = isTypedArray_1;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */

function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}

var _baseIsEqual = baseIsEqual$1;

var baseIsEqual = _baseIsEqual;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */

function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

const phoneNumberValidator = (params, _isEdit, translationService) => {
    var _a, _b;
    const valid = ((_a = params.value) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? isValidPhoneNumber(((_b = params.value) === null || _b === void 0 ? void 0 : _b.toString()) || '')
        : true;
    return {
        valid,
        message: valid
            ? null
            : translationService.translate('phone_numberRegexErrorMessage'),
    };
};

const defaultFields = {
    email: {
        id: 'email',
        type: InputType.textbox,
        showInSignUp: true,
        showInProfile: true,
        showInSignIn: true,
        isRequired: true,
        regex: /^[a-z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)+$/,
        category: FieldCategory.UserDetails,
        showInEdit: true,
        showInPreview: true,
        isRequiredInEdit: true,
        order: {
            signUp: 1,
            signIn: 1,
            profile: 3,
        },
    },
    currentPassword: {
        id: 'currentPassword',
        type: InputType.password,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.Security,
        showInEdit: true,
        showInPreview: false,
        isRequiredInEdit: true,
        requiredIf: ['password'],
    },
    loginPassword: {
        id: 'loginPassword',
        type: InputType.password,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: true,
        isRequired: true,
        category: FieldCategory.Security,
        showInEdit: true,
        showInPreview: false,
        isRequiredInEdit: true,
        order: {
            signIn: 2,
        },
    },
    password: {
        id: 'password',
        type: InputType.password,
        showInSignUp: true,
        showInProfile: true,
        isRequired: true,
        showInSignIn: false,
        regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[+=^$*.[\]{}()?\-“!@#%&/,><':;|_~`])\S{8,99}$/,
        category: FieldCategory.Security,
        showInEdit: true,
        showInPreview: true,
        isRequiredInEdit: true,
        requiredIf: ['currentPassword'],
        order: {
            signUp: 2,
        },
    },
    confirmPassword: {
        id: 'confirmPassword',
        type: InputType.password,
        showInSignUp: true,
        showInProfile: false,
        isRequired: true,
        showInSignIn: false,
        category: FieldCategory.Security,
        sameAs: 'password',
        showInEdit: true,
        showInPreview: false,
        isRequiredInEdit: true,
        requiredIf: ['password', 'currentPassword'],
        order: {
            signUp: 3,
        },
    },
    legals: {
        id: 'legals',
        type: InputType.checkbox,
        options: [],
        requiredOptions: [],
        defaultValue: [],
        category: FieldCategory.Security,
        showInSignUp: true,
        showInSignIn: false,
        showInProfile: true,
        showInEdit: true,
        showInPreview: false,
        isLegal: true,
        order: {
            signUp: 10,
        },
    },
    'address.street_address': {
        id: 'streetAddress',
        type: InputType.textbox,
        showInSignUp: false,
        showInSignIn: false,
        showInProfile: true,
        isRequired: false,
        category: FieldCategory.DeliveryAddresses,
        showInEdit: true,
        showInPreview: true,
        regex: /^.{1,85}$/,
        requiredIf: [
            'address.locality',
            'address.region',
            'address.postal_code',
            'address.country',
        ],
    },
    'address.locality': {
        id: 'locality',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: false,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.DeliveryAddresses,
        showInEdit: false,
        showInPreview: false,
        requiredIf: [
            'address.street_address',
            'address.region',
            'address.postal_code',
            'address.country',
        ],
    },
    'address.region': {
        id: 'region',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.DeliveryAddresses,
        showInEdit: true,
        showInPreview: true,
        regex: /^.{1,65}$/,
        requiredIf: [
            'address.street_address',
            'address.locality',
            'address.postal_code',
            'address.country',
        ],
    },
    'address.postal_code': {
        id: 'postalCode',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: false,
        regex: /^.{1,12}$/,
        category: FieldCategory.DeliveryAddresses,
        showInEdit: true,
        showInPreview: true,
        requiredIf: [
            'address.street_address',
            'address.locality',
            'address.region',
            'address.country',
        ],
    },
    'address.country': {
        id: 'country',
        type: InputType.textbox,
        showInSignUp: false,
        showInSignIn: false,
        showInProfile: true,
        isRequired: false,
        category: FieldCategory.DeliveryAddresses,
        showInEdit: true,
        showInPreview: true,
        regex: /^.{1,65}$/,
        requiredIf: [
            'address.street_address',
            'address.locality',
            'address.region',
            'address.postal_code',
        ],
    },
    name: {
        id: 'name',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: false,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.UserDetails,
        showInEdit: false,
        showInPreview: false,
    },
    given_name: {
        id: 'givenName',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.UserDetails,
        showInEdit: true,
        showInPreview: true,
        regex: /^.{1,60}$/,
        order: {
            profile: 1,
        },
    },
    family_name: {
        id: 'familyName',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.UserDetails,
        showInEdit: true,
        showInPreview: true,
        regex: /^.{1,60}$/,
        order: {
            profile: 2,
        },
    },
    birthdate: {
        id: 'birthdate',
        type: InputType.date,
        showInSignUp: false,
        showInSignIn: false,
        showInProfile: false,
        isRequired: false,
        regex: /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/,
        category: FieldCategory.UserDetails,
        showInEdit: false,
        showInPreview: true,
        maxValue: new Date(),
    },
    gender: {
        id: 'gender',
        type: InputType.radio,
        options: [
            { key: 'male', translationKey: 'male' },
            { key: 'female', translationKey: 'female' },
            { key: 'other', translationKey: 'other' },
        ],
        showInSignUp: false,
        showInProfile: false,
        showInSignIn: false,
        isRequired: false,
        category: FieldCategory.UserDetails,
        showInEdit: true,
        showInPreview: true,
    },
    middle_name: {
        id: 'middleName',
        type: InputType.textbox,
        category: FieldCategory.UserDetails,
        showInSignUp: false,
        showInProfile: false,
        isRequired: false,
        showInSignIn: false,
    },
    nickname: {
        id: 'nickname',
        type: InputType.textbox,
        category: FieldCategory.UserDetails,
        showInSignUp: false,
        showInProfile: false,
        isRequired: false,
        showInSignIn: false,
    },
    phone_number: {
        id: 'phoneNumber',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: true,
        isRequired: false,
        category: FieldCategory.UserDetails,
        showInEdit: true,
        showInSignIn: false,
        showInPreview: true,
        customValidator: phoneNumberValidator,
        order: {
            profile: 4,
        },
    },
    preferred_username: {
        id: 'preferredUsername',
        type: InputType.textbox,
        category: FieldCategory.UserDetails,
        showInSignUp: false,
        showInProfile: false,
        showInSignIn: false,
        isRequired: false,
    },
    website: {
        id: 'website',
        type: InputType.textbox,
        showInSignUp: false,
        showInProfile: false,
        isRequired: false,
        showInSignIn: false,
        category: FieldCategory.UserDetails,
        showInEdit: false,
        showInPreview: false,
    },
    deleteAccountStatement: {
        id: 'deleteAccountStatement',
        type: InputType.checkbox,
        showInSignUp: false,
        showInProfile: true,
        showInSignIn: false,
        isRequired: true,
        category: FieldCategory.Security,
        showInEdit: true,
        showInPreview: false,
        isRequiredInEdit: true,
        defaultValue: [],
        requiredOptions: ['agreement'],
        options: [
            {
                key: 'agreement',
                translationKey: 'confirmAccountDelete',
                hideCheckbox: false,
            },
        ],
    },
};

const defaultTranslations = {
    validationNotConfigured: 'No validation method configured for {1} field ',
    sameAsNeedsReferrer: 'When using sameAs parameter you must pass also referenced field for validation',
    defaultErrorMessage: 'An error occurred. Please try again.',
    requiredErrorMessage: '{1} is required.',
    notSameErrorMessage: '{2} and {1} do not match.',
    regexErrorMessage: 'Please enter a valid {1}.',
    emailRequiredErrorMessage: 'Email is required.',
    emailRegexErrorMessage: 'Please enter a valid email address.',
    passwordRequiredErrorMessage: 'Password is required.',
    passwordRegexErrorMessage: 'Password must have at least 8 characters and contain uppercase letters, lowercase letters, numbers and special characters.',
    deleteAccountStatementRequiredErrorMessage: 'Please fill out all required fields.',
    currentPasswordRequiredErrorMessage: 'Password is required.',
    confirmPasswordRequiredErrorMessage: 'Confirm password is required.',
    confirmPasswordNotSameErrorMessage: 'Password and Confirm password do not match.',
    phone_numberRegexErrorMessage: 'Phone number must start with a plus sign, followed by a number. Do not use spaces or any other characters.',
    legalsRequiredErrorMessage: 'All required legal fields must be accepted.',
    maxDateErrorMessage: 'The selected date is after the allowed date.',
    birthdateMaxDateErrorMessage: 'Please be sure to use your real birthday.',
    minDateErrorMessage: 'The selected date is before the allowed date.',
    birthdateMinDateErrorMessage: 'Please be sure to use your real birthday.',
    email: 'Email',
    emailProfile: 'Email',
    password: 'Password',
    passwordProfile: 'New password',
    currentPasswordProfile: 'Old password',
    loginPasswordProfile: 'Password',
    confirmPassword: 'Confirm password',
    gender: 'Gender',
    genderProfile: 'Gender',
    male: 'Male',
    maleProfile: 'Male',
    female: 'Female',
    femaleProfile: 'Female',
    other: 'Other',
    otherProfile: 'Other',
    family_name: 'Last name',
    family_nameProfile: 'Last name',
    given_name: 'First name',
    given_nameProfile: 'First name',
    website: 'Website',
    websiteProfile: 'Website',
    name: 'Full name',
    nameProfile: 'Full name',
    birthdate: 'Birthday',
    birthdateProfile: 'Birthday',
    phone_number: 'Phone',
    nicknameProfile: 'Nickname',
    preferred_usernameProfile: 'Preferred username',
    phone_numberProfile: 'Phone',
    'address.region': 'City',
    'address.regionProfile': 'City',
    'address.postal_code': 'Postal code',
    'address.postal_codeProfile': 'Postal code',
    'address.country': 'Country',
    'address.countryProfile': 'Country',
    'address.birthdate': 'Birthdate',
    'address.birthdateProfile': 'Birthdate',
    'address.phone_number': 'Phone number',
    'address.phone_numberProfile': 'Phone number',
    'address.locality': 'Locality',
    'address.localityProfile': 'Locality',
    'address.street_address': 'Street and Number',
    'address.street_addressProfile': 'Street and Number',
    legals: 'Legal',
    termsTextDefault: 'By creating an account you agree to {1}.',
    termsTextDefault_1: 'Terms & Conditions',
    termsTextDefaultSocialSignIn: 'You must agree with the {1} to continue. Please read them carefully.',
    termsTextDefaultSocialSignIn_1: 'Terms & Conditions',
    termsTextDefaultHasChanged: "We're updating our {1}. Please read them carefully.",
    termsTextDefaultHasChanged_1: 'Terms & Conditions',
    privacyPolicyLegal: 'You also need to accept {1}.',
    privacyPolicyLegal_1: 'Privacy Policy',
    privacyPolicyLegalSocialSignIn: 'You must agree with the {1} to continue. Please read them carefully.',
    privacyPolicyLegalSocialSignIn_1: 'Privacy Policy',
    privacyPolicyLegalHasChanged: "We're updating our {1}. Please read them carefully.",
    privacyPolicyLegalHasChanged_1: 'Privacy Policy',
    confirmLdsTitle: 'Privacy & Data',
    confirmLdsDescription: 'To add or modify data please accept our:',
    confirmLdsCloseButton: 'Not now',
    confirmLdsCloseSubmit: 'Accept',
    continueUsing: 'Or continue using',
    missingLdsError: 'Before changing user data you need to agree with Terms & Conditions',
    linkResendPossibleIn: 'Resend confirmation link possible in {1} seconds.',
    loginTitle: 'Log in to {brandname} shop',
    loginDescription: 'To log-in in to our {brandname} shop please enter email and password.',
    loginPassword: 'Password',
    loginRememberMe: 'Remember me',
    loginSignUpInformationSubtitle: "Don't have account yet?",
    loginSignUpInformationButton: '👉 Sign up',
    loginForgotPasswordButton: 'Forgot your password?',
    loginSubmitButton: 'Log in',
    registerTitle: 'Please register',
    registerSignInInformationButton: '👉 Log in',
    registerSignInInformationSubtitle: 'Already have account?',
    registerDescription: 'To register to our {brandname} shop please enter all obligatory data.',
    registerSubmitButton: 'Continue',
    registerConfirmTitle: 'Confirm registration',
    registerConfirmButton: 'Confirm registration',
    registerConfirmationCheckInfoEmail: 'Please click on confirmation link in a message that was sent to you by email on:',
    registerConfirmationCheckInfoSMS: 'Please provide a confirmation code that was sent to you by SMS on:',
    resendButton: 'Resend link',
    registerCongratulationTitle: 'Congratulations',
    registerCongratulationText: 'The account has been successfully created and verified 🎉. Please log in 🙏.',
    registerCongratulationButton: 'Log in',
    forgotPasswordTitle: 'Forgot the password?',
    forgotPasswordFormSuccessInfoTitle: 'Check your email inbox',
    forgotPasswordFormSuccessInfoMessage: "If an account associated with the provided email address exists, you will receive an email with further instructions on resetting your password. If you do not receive an email, please ensure you've entered the correct email address or register for a new account if you haven't already.",
    forgotPasswordProvideEmail: 'No worries, please enter the associated email address and we will send you a confirmation code for the password change.',
    forgotPasswordProvidePassword: 'Please provide a new password:',
    forgotPassword: 'Password',
    forgotPasswordConfirmPassword: 'Confirm password',
    forgotPasswordSignInInformationSubtitle: '👈 Go back to',
    forgotPasswordSignInInformationButton: 'Log in',
    forgotPasswordSendResetLinkButton: 'Send reset password link',
    forgotPasswordConfirmButton: 'Submit changes',
    forgotPasswordCongratulationText: 'Your password has been successfully changed 🎉. Please log in 🙏.',
    forgotPasswordCongratulationTitle: 'Congratulations',
    forgotPasswordCongratulationButton: 'Log in',
    changeAttributeTitleEMAIL: 'Confirm email',
    changeAttributeTitleSMS: 'Confirm phone number',
    changeAttributeCheckInfoEMAIL: 'Email has been changed. Please provide a confirmation code that was sent to you by email on: ',
    changeAttributeCheckInfoSMS: 'Phone number has been changed. Please provide a confirmation code that was sent to you by SMS on: ',
    userAttributesSubmitTitle: 'Account confirmation',
    userAttributesSubmitConfirmButton: 'Confirm account',
    accountConfirmationTitle: 'Account confirmation',
    accountConfirmationCheckInfoEmail: 'Account was not confirmed. Please provide a confirmation code that was sent to you by email on:',
    accountConfirmationCheckInfoSMS: 'Account was not confirmed. Please provide a confirmation code that was sent to you by SMS on:',
    accountConfirmationConfirmButton: 'Confirm account',
    accountConfirmationCongratulationText: 'The account has been successfully confirmed and verified 🎉. Please log in 🙏.',
    accountConfirmationCongratulationTitle: 'Congratulations',
    accountConfirmationCongratulationCloseButton: 'Log in',
    updatedLdsTitle: 'Legals have been changed',
    updatedLdsDescription: 'To add or modify data please accept our:',
    updatedLdsSubmitButton: 'Accept',
    security: 'Security',
    securityDeleteAccountSubmitButton: 'Delete account',
    securityDeleteAccountCancelButton: 'Cancel',
    confirmAccountDeleteProfile: "Yes, I'm sure. Please delete my account.",
    securityDeleteDescription: 'Permanently delete your account and all of your content',
    securityDeleteTitle: 'Delete your account',
    securityDeleteSuccessModalMessage: 'Your account was successfully deleted',
    securityDeleteSuccessModalTitle: 'Success',
    securityDeleteSuccessModalButton: 'Close',
    securityPasswordSectionTitle: 'Password',
    securityLegalsSectionTitle: 'Consents',
    securityPasswordEditSuccessModalTitle: 'Success',
    securityPasswordEditSuccessModalButton: 'Accept',
    securityPasswordChangeSuccessModalMessage: 'You password has been successfuly changed.',
    securityPasswordEditTitle: 'Edit password',
    securityPasswordEditCancelButton: 'Cancel',
    securityPasswordEditSubmitButton: 'Change password',
    securityLegalsEditSubmitButton: 'Save changes',
    securityPasswordCurrentPasswordTooltipLabel: 'Label describing old password field',
    securityPasswordPasswordTooltipLabel: 'Label describing new password field',
    securityPasswordCurrentPasswordTooltipText: '{"blocks":[{"text":"Your current password","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    securityPasswordPasswordTooltipText: '{"blocks":[{"text":"Your new password","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    userDetails: 'User details',
    userDetailsChangeEmailSubmitButton: 'Change email',
    userDetailsChangeEmailCancelButton: 'Cancel',
    userDetailsChangeEmailDescription: 'Change your email address',
    userDetailsChangeEmailTitle: 'Change email address',
    userDetailsChangeEmailSuccessModalTitle: 'Success',
    userDetailsChangeEmailSuccessModalMessage: 'Verification mail has been sent to your new e-mail. Please check your inbox.',
    userDetailsChangeEmailSuccessModalButton: 'Accept',
    userDetailsEditTitle: 'Edit personal information',
    userDetailsEditSubmitButton: 'Save changes',
    userDetailsEditButton: 'Edit details',
    userDetailsEditCancelButton: 'Cancel',
    userDetailsGiven_nameTooltipLabel: 'Label describing first name field',
    userDetailsGiven_nameTooltipText: '{"blocks":[{"text":"Your first name","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    userDetailsFamily_nameTooltipLabel: 'Label describing last name field',
    userDetailsFamily_nameTooltipText: '{"blocks":[{"text":"Your last name","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    userDetailsPhone_numberTooltipLabel: 'Label describing phone number field',
    userDetailsPhone_numberTooltipText: '{"blocks":[{"text":"Your phone number","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    contactInformation: 'Contact information',
    contactInformationEditTitle: 'Edit contact information',
    contactInformationEditSubmitButton: 'Save changes',
    deliveryAddresses: 'Delivery addresses',
    deliveryAddressesEditTitle: 'Edit contact information',
    deliveryAddressesEditSubmitButton: 'Save',
    deliveryAddressesEditCancelButton: 'Cancel',
    profileSecurityButton: 'Change password',
    phoneNumberChangeSubmitCongratulationText: 'Phone number has been changed successfully',
    federatedSignInFailure: 'Social media login failed',
    editPasswordEqualErrorMessage: 'Your new password cannot be the same as the current one.',
    multipassAPIConfigurationError: 'Env is missing: ',
    multipassAuthReturnToMissing: 'MultipassAuthReturnTo parameter in config is missing ',
    orderHistory: 'Order history',
    additionalDeliveryAddresses: 'Shipping addresses',
    addAdditionalDeliveryAddresses: 'Add new address',
    addNewAddressEditTitle: 'New address',
    addNewAddressEditSubmitButton: 'Save New Address',
    addNewAddressEditCancelButton: 'Cancel',
    additionalDeliveryAddressesEditTitle: 'Address editing',
    additionalDeliveryAddressesEditCancelButton: 'Cancel',
    additionalDeliveryAddressesEditSubmitButton: 'Save',
    editAddress: 'Edit',
    deleteAddress: 'Delete',
    setDefaultAddress: 'Set as Default',
    profileHeadingPrefix: 'Hello',
    profileHeadingSuffix: '!',
    profileHeadingDescription: 'Here you may review and edit all your details, addresses, security settings and orders.',
    verificationTimeout: 'Verification timeout!',
    missingUserDataWhileEmailVerification: 'Missing user data for verification, try to login to your account to resolve this issue',
    errorInformationBoxTitle: 'Something went wrong!',
    userAlreadyVerified: 'User already verified',
    canNotChangePasswordOfExternalProviderError: "Can't change password when user signed in with external provider",
    validationError: 'Invalid params',
    deleteAddressTitle: 'Delete address',
    deleteAddressText: 'Are you sure you want to delete address? It will be deleted permanently.',
    deleteAddressConfirm: 'Confirm',
    deleteAddressCancel: 'Cancel',
    confirmLdsInfo: 'Please accept to allow editing of your personal data; click "Not Now" to decline.',
    changeEmailEqualErrorMessage: 'Your new email cannot be the same as the current one.',
    changeEmailMissingErrorMessage: "Can't change email",
    verifyAndChangeEmailCongratulationTitle: 'Congratulations',
    verifyAndChangeEmailCongratulationText: 'The new e-mail address has been verified 🎉. Please log in with your new mail 🙏.',
    verifyAndChangeEmailCongratulationButton: 'Log in',
    recoverEmailCongratulationTitle: 'Congratulations',
    recoverEmailCongratulationText: 'Your e-mail address has been recovered 🎉. Please log in 🙏.',
    recoverEmailCongratulationButton: 'Log in',
};

const firebaseErrorCodeTranslations = {
    'auth/email-already-in-use': 'An account with the given email already exists.',
    'auth/expired-action-code': 'This confirmation link is already expired',
    'auth/invalid-action-code': 'This confirmation link is invalid or already used',
    'auth/invalid-credential': 'Invalid credentials',
    'invalid-argument': 'Internal error, please try again later',
    'auth/firebase-app-check-token-is-invalid.': 'There was an error processing the form, please try again',
    'auth-custom/reauthentication-impossible': 'Reauthentication impossible due to missing data',
    'auth/requires-recent-login': 'User reuthentication required',
    'auth/too-many-requests': 'Attempt limit exceeded, please try again later',
    'auth/weak-password': 'Password must have at least 6 characters',
    'auth/wrong-password': 'Your current password is incorrect.',
    'auth/user-mismatch': 'Invalid credentials',
    'auth/user-token-expired': 'You session has expired, please sign in and try again',
    'auth/api-key-not-valid.-please-pass-a-valid-api-key.': 'The login and register are currently unavailable, please try again later',
};

function isErrorResult(result) {
    return !result.success;
}

class Fields {
    constructor(translationService, ldsService, fieldsSetup) {
        this.translationService = translationService;
        this.ldsService = ldsService;
        this.fieldsSetup = fieldsSetup;
        this.fields = {};
        this.resetupLegalFields = (externalProviderUser) => __awaiter(this, void 0, void 0, function* () {
            yield this.setupFields(externalProviderUser, this.fieldsSetup);
        });
        this.setupFields = (externalProviderUser, fieldsSetup) => __awaiter(this, void 0, void 0, function* () {
            const fields = cloneDeep_1(defaultFields);
            const fieldsWithAdditional = this.setupAdditionalSignUpFields(fields, fieldsSetup === null || fieldsSetup === void 0 ? void 0 : fieldsSetup.slice());
            this.fieldsReady = new Promise((resolve) => {
                (() => __awaiter(this, void 0, void 0, function* () {
                    this.fields = yield this.setupLegalFields(fieldsWithAdditional, externalProviderUser);
                    resolve();
                }))();
            });
            yield this.fieldsReady;
        });
        this.filterChangedAttributes = (newAttributes, previousAttributes) => Object.entries(newAttributes).reduce((result, [key, value]) => {
            const keepValue = !previousAttributes ||
                (!isEqual_1(previousAttributes[key], value) &&
                    !(isEmpty_1(previousAttributes[key]) && isEmpty_1(value)));
            if (keepValue) {
                result[key] = value;
            }
            return result;
        }, {});
        this.createFormattedAddressAttributes = (fields) => {
            const { 'address.street_address': street, 'address.locality': locality, 'address.region': region, 'address.postal_code': postalCode, 'address.country': country } = fields, _fields = __rest(fields, ['address.street_address', 'address.locality', 'address.region', 'address.postal_code', 'address.country']);
            const address = {
                street_address: street,
                locality: locality,
                region: region,
                postal_code: postalCode,
                country: country,
            };
            const addressExists = this.areAnyFieldsExisting(...Object.values(address));
            return Object.assign(Object.assign({}, _fields), (addressExists && {
                address,
            }));
        };
        this.groupByCategory = (filledProfileFields) => Object.entries(filledProfileFields).reduce((prevCategory, [key, value]) => {
            const { category } = value;
            return Object.assign(Object.assign({}, prevCategory), (category
                ? {
                    [category]: Object.assign(Object.assign({}, (prevCategory[category] || {})), { [key]: value }),
                }
                : {}));
        }, {});
        this.fillLegalsField = (userLds, legalsField) => {
            var _a;
            const defaultValue = ((_a = legalsField === null || legalsField === void 0 ? void 0 : legalsField.options) === null || _a === void 0 ? void 0 : _a.filter((item) => item.isRequired).map((item) => item.key)) || [];
            userLds === null || userLds === void 0 ? void 0 : userLds.forEach((item) => {
                if (!defaultValue.includes(item.businessId)) {
                    defaultValue.push(item.businessId);
                }
            });
            const options = legalsField.options
                ? legalsField.options.map((option) => (Object.assign(Object.assign({}, option), { isDisabled: option.isRequired })))
                : [];
            return { legals: Object.assign(Object.assign({}, legalsField), { defaultValue, options }) };
        };
        this.fillFieldsWithUserData = ({ profileFields, userFields, filterExistingFields, }) => Object.entries(profileFields).reduce((result, [key, value]) => {
            if (filterExistingFields && userFields && !has_1(userFields, key)) {
                return Object.assign({}, result);
            }
            return Object.assign(Object.assign({}, result), { [key]: Object.assign(Object.assign({}, value), { defaultValue: get_1(userFields, key) }) });
        }, {});
        this.fillAdditionalDeliveryAddressesFields = (profileFields, deliveryAddresses = []) => deliveryAddresses
            .map((item) => this.fillFieldsWithUserData({
            profileFields,
            userFields: item,
            filterExistingFields: true,
        }))
            .map((item) => (Object.assign(Object.assign({}, item), { id: Math.random().toString(36).substring(2, 8) })));
        this.setFieldValidation = (key, validation) => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            this.fields[key] = Object.assign(Object.assign({}, this.fields[key]), validation);
        });
        this.getFields = () => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            return this.fields;
        });
        this.sortFieldsAscending = (orderA, orderB) => {
            const newOrderA = orderA === undefined ? Number.MAX_SAFE_INTEGER : orderA;
            const newOrderB = orderB === undefined ? Number.MAX_SAFE_INTEGER : orderB;
            return newOrderA - newOrderB;
        };
        this.getSignUpFields = () => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            return Object.entries(this.fields)
                .filter(([, { showInSignUp }]) => showInSignUp)
                .sort(([, { order: orderA }], [, { order: orderB }]) => this.sortFieldsAscending(orderA === null || orderA === void 0 ? void 0 : orderA.signUp, orderB === null || orderB === void 0 ? void 0 : orderB.signUp))
                .reduce(this.mapFieldsToShow(false), Promise.resolve({}));
        });
        this.getSignInFields = () => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            return Object.entries(this.fields)
                .filter(([, { showInSignIn }]) => showInSignIn)
                .sort(([, { order: orderA }], [, { order: orderB }]) => this.sortFieldsAscending(orderA === null || orderA === void 0 ? void 0 : orderA.signIn, orderB === null || orderB === void 0 ? void 0 : orderB.signIn))
                .reduce(this.mapFieldsToShow(false), Promise.resolve({}));
        });
        this.getLegalsFields = (isExternalProviderUser, translationPostfix, onlyRequired) => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            return Object.entries(this.fields)
                .filter(([, { isLegal }]) => isLegal)
                .reduce(this.mapFieldsToShow(isExternalProviderUser, translationPostfix, onlyRequired), Promise.resolve({}));
        });
        this.getProfileFields = () => __awaiter(this, void 0, void 0, function* () {
            yield this.fieldsReady;
            const translatePostfix = 'Profile';
            return Object.entries(this.fields)
                .filter(([, { showInProfile }]) => showInProfile)
                .sort(([, { order: orderA }], [, { order: orderB }]) => this.sortFieldsAscending(orderA === null || orderA === void 0 ? void 0 : orderA.profile, orderB === null || orderB === void 0 ? void 0 : orderB.profile))
                .reduce(this.mapFieldsToShow(false, translatePostfix), Promise.resolve({}));
        });
        this.areAllFieldsFilled = (...fields) => fields.every((field) => (field === null || field === void 0 ? void 0 : field.length) > 0);
        this.areAllFieldsExisting = (...fields) => fields.every((field) => field !== undefined);
        this.areAnyFieldsFilled = (...fields) => fields.some((field) => (field === null || field === void 0 ? void 0 : field.length) > 0);
        this.areAnyFieldsExisting = (...fields) => fields.some((field) => field !== undefined);
        this.mapFieldsToShow = (isExternalProviderUser, translationPostfix, onlyRequired) => (resultPromise, [key, value]) => __awaiter(this, void 0, void 0, function* () {
            const { translate } = this.translationService;
            const result = yield resultPromise;
            const mappedOptions = yield this.handleOptions(Object.assign(Object.assign({}, value), { translationPostfix,
                isExternalProviderUser }));
            result[key] = Object.assign(Object.assign({}, value), { label: translate(`${key}${translationPostfix || ''}`), options: mappedOptions === null || mappedOptions === void 0 ? void 0 : mappedOptions.filter((x) => onlyRequired ? x.isRequired : true) });
            return result;
        });
        this.setupAdditionalSignUpFields = (fields, fieldsSetup) => Object.entries(fields).reduce((result, [key, value]) => {
            const additionalField = fieldsSetup === null || fieldsSetup === void 0 ? void 0 : fieldsSetup.find((field) => field.name === key);
            return Object.assign(Object.assign({}, result), { [key]: Object.assign(Object.assign({}, value), (additionalField || {})) });
        }, {});
        this.setupLegalFields = (fields, externalProviderUser) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const lds = yield this.ldsService.getLds();
            const options = ((_a = fields.legals.options) === null || _a === void 0 ? void 0 : _a.slice()) || [];
            const requiredOptions = ((_b = fields.legals.requiredOptions) === null || _b === void 0 ? void 0 : _b.slice()) || [];
            lds.forEach(({ businessId, isRequired, hideCheckbox, translationKey, customLabel, socialTerm, }) => {
                var _a;
                const option = options.find(({ key }) => key === businessId);
                if (!option) {
                    options.push({
                        key: businessId,
                        customLabel,
                        translationKey: translationKey || 'termsTextDefault',
                        hideCheckbox,
                        socialTerm,
                    });
                }
                else {
                    option.hideCheckbox = hideCheckbox;
                    option.socialTerm = socialTerm;
                }
                if (hideCheckbox && !((_a = fields.legals.defaultValue) === null || _a === void 0 ? void 0 : _a.includes(businessId))) {
                    fields.legals.defaultValue.push(businessId);
                }
                const isLegalRequired = (isRequired || hideCheckbox) && !requiredOptions.includes(businessId);
                if (isLegalRequired && (externalProviderUser || !socialTerm)) {
                    requiredOptions.push(businessId);
                }
            });
            return Object.assign(Object.assign({}, fields), { legals: Object.assign(Object.assign({}, fields.legals), { options, requiredOptions }) });
        });
        this.handleOptions = ({ options, requiredOptions, type, translationPostfix, isExternalProviderUser, }) => __awaiter(this, void 0, void 0, function* () {
            if (!(options === null || options === void 0 ? void 0 : options.length)) {
                return Promise.resolve(null);
            }
            const filteredOptions = options.filter(({ socialTerm }) => isExternalProviderUser || !socialTerm);
            const map = {
                checkbox: this.handleCheckbox(filteredOptions, requiredOptions, translationPostfix),
                radio: this.handleRadio(filteredOptions, translationPostfix),
            };
            return Promise.all(map[type]());
        });
        this.handleRadio = (options, translationPostfix) => () => {
            const { translate } = this.translationService;
            return options.map(({ key, translationKey }) => __awaiter(this, void 0, void 0, function* () {
                return ({
                    key,
                    label: translate(`${translationKey}${translationPostfix || ''}`),
                });
            }));
        };
        this.handleCheckbox = (options, requiredOptions, translationPostfix) => () => options.map(({ key, translationKey, hideCheckbox, customLabel }) => __awaiter(this, void 0, void 0, function* () {
            const translationKeyModiefied = `${translationKey}${translationPostfix || ''}`;
            const labels = yield this.prepareActionArray({
                translationKey: translationKeyModiefied,
                businessId: key,
                customLabel,
            });
            return {
                key,
                labels,
                hideCheckbox: hideCheckbox,
                isRequired: requiredOptions !== undefined && requiredOptions.includes(key),
            };
        }));
        this.splitLabelForLinks = (str) => {
            const regex = /(\[.*?\]|\.)\s*/g;
            return str.split(regex).filter(Boolean);
        };
        this.prepareActionArray = ({ businessId, translationKey, customLabel, }) => __awaiter(this, void 0, void 0, function* () {
            const { translate, getTranslationArray } = this.translationService;
            const mode = customLabel ? 'custom' : 'default';
            const converters = {
                custom: { splitter: this.splitLabelForLinks, regex: /\[.*?\]/ },
                default: { splitter: getTranslationArray, regex: /\{([0-9]+)\}/ },
            };
            const { splitter, regex } = converters[mode];
            const translations = splitter(customLabel || translationKey);
            const lds = yield this.ldsService.getLdsByBusinessId(businessId);
            const onClick = lds
                ? () => {
                    if (lds.onLegalLinkClickAction) {
                        lds.onLegalLinkClickAction();
                    }
                }
                : null;
            return translations.map((translation) => {
                const match = translation.match(regex);
                if (match === null || match === void 0 ? void 0 : match.length) {
                    return {
                        value: customLabel
                            ? match[0].slice(1, match[0].length - 1)
                            : translate(`${translationKey}_${match[1]}`),
                        onClick,
                    };
                }
                return {
                    value: translation,
                    onClick: null,
                };
            });
        });
        this.setupFields(false, this.fieldsSetup);
    }
}

class Logger {
    log(message, ...args) {
        console.log(message, args);
    }
    warn(message, ...args) {
        console.warn(message, args);
    }
    error(message, ...args) {
        console.error(message, args);
    }
}

class Translation {
    constructor(loggerService, customTranslations) {
        this.loggerService = loggerService;
        this.translate = (key, fallback, ...args) => {
            let result = this.translations[key];
            if (!result) {
                return fallback || key;
            }
            args === null || args === void 0 ? void 0 : args.forEach((value, index) => {
                result = result.replace(`{${index + 1}}`, value || '');
            });
            return result;
        };
        this.getTranslationArray = (key) => {
            const result = this.translations[key];
            if (!result) {
                this.loggerService.warn('Translation key not provided', key);
                return [];
            }
            return result
                .split(/(\{[0-9]+\})([a-zA-Z0-9 .,-_&()]+)/g)
                .filter((s) => s.length);
        };
        this.translations = Object.assign(Object.assign(Object.assign({}, defaultTranslations), firebaseErrorCodeTranslations), (customTranslations || {}));
    }
}

class Validation {
    constructor(translationService, fieldsService, loggerService, fieldsSetup) {
        this.translationService = translationService;
        this.fieldsService = fieldsService;
        this.loggerService = loggerService;
        this.fieldsSetup = fieldsSetup;
        this.defaultValidators = {};
        this.resetupValidation = () => this.setup();
        this.setup = () => __awaiter(this, void 0, void 0, function* () {
            this.validatorsReady = new Promise((resolve) => {
                (() => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    this.defaultValidators = yield this.createDefaultValidation();
                    yield this.createValidation((_a = this.fieldsSetup) === null || _a === void 0 ? void 0 : _a.slice());
                    resolve();
                }))();
            });
            yield this.validatorsReady;
        });
        this.validate = (fields, isEdit) => __awaiter(this, void 0, void 0, function* () {
            yield this.validatorsReady;
            const { translate } = this.translationService;
            const result = {};
            Object.entries(fields).forEach(([name, value]) => {
                const validationMethod = this.defaultValidators[name];
                if (!validationMethod) {
                    this.loggerService.warn(translate('validationNotConfigured', name));
                    return;
                }
                result[name] = validationMethod({ name, value, fields }, isEdit, this.translationService);
            });
            return {
                valid: Object.values(result).every(({ valid }) => valid),
                validation: result,
            };
        });
        this.requiredValidator = ({ isRequired, isRequiredInEdit, requiredIf, type, requiredOptions, }, { name, value, fields }, isEdit) => {
            const { translate } = this.translationService;
            const requiredValidators = {
                textbox: this.stringRequiredValidator,
                date: this.stringRequiredValidator,
                textarea: this.stringRequiredValidator,
                password: this.stringRequiredValidator,
                checkbox: this.checkboxRequiredValidator,
                radio: this.radioRequiredValidator,
                phone: this.stringRequiredValidator,
            };
            const isFieldRequired = (isRequired && !isEdit) ||
                (isRequiredInEdit && isEdit) ||
                (requiredIf === null || requiredIf === void 0 ? void 0 : requiredIf.some((requiredField) => { var _a; return ((_a = fields[requiredField]) === null || _a === void 0 ? void 0 : _a.length) > 0; }));
            if (type === InputType.checkbox &&
                !requiredValidators[type.toString()](value, requiredOptions)) {
                return {
                    valid: false,
                    message: translate(`${name}RequiredErrorMessage`, translate('requiredErrorMessage', undefined, translate(name))),
                };
            }
            if (isFieldRequired && !requiredValidators[type.toString()](value)) {
                return {
                    valid: false,
                    message: translate(`${name}RequiredErrorMessage`, translate('requiredErrorMessage', undefined, translate(name))),
                };
            }
            return {
                valid: true,
                message: null,
            };
        };
        this.validator = (customValidationItem, { name, value, fields }, isEdit) => {
            var _a, _b;
            const { regex, sameAs, type, maxValue, minValue } = customValidationItem;
            const { translate } = this.translationService;
            const isValidRequired = this.requiredValidator(customValidationItem, { name, value, fields }, isEdit);
            if (!isValidRequired.valid) {
                return isValidRequired;
            }
            const additionalValidators = {
                date: this.rangeValidator,
            };
            const additionalValidationResult = (_a = additionalValidators[type.toString()]) === null || _a === void 0 ? void 0 : _a.call(additionalValidators, {
                min: minValue,
                max: maxValue,
                name,
                val: value,
            });
            if (additionalValidationResult === null || additionalValidationResult === void 0 ? void 0 : additionalValidationResult.error) {
                return {
                    valid: false,
                    message: additionalValidationResult.message,
                };
            }
            if (typeof value === 'string' &&
                regex &&
                (value === null || value === void 0 ? void 0 : value.length) &&
                !((_b = value.match(regex)) === null || _b === void 0 ? void 0 : _b.length)) {
                return {
                    valid: false,
                    message: translate(`${name}RegexErrorMessage`, translate('regexErrorMessage', undefined, translate(name))),
                };
            }
            if (sameAs) {
                const sameAsField = fields[sameAs];
                if (sameAsField === undefined) {
                    this.loggerService.error(translate('sameAsNeedsReferrer'));
                    return { valid: true, message: null };
                }
                const isValid = sameAsField === value;
                return {
                    valid: isValid,
                    message: !isValid
                        ? translate(`${name}${sameAs}NotSameErrorMessage`, translate('notSameErrorMessage', undefined, translate(name), translate(sameAs)))
                        : null,
                };
            }
            return { valid: true, message: null };
        };
        this.customValidator = (customValidator, field, { name, value, fields }, isEdit) => {
            const isValidRequired = this.requiredValidator(field, { name, value, fields }, isEdit);
            if (!isValidRequired.valid) {
                return isValidRequired;
            }
            return customValidator.bind(field, { name, value, fields }, isEdit, this.translationService)();
        };
        this.createDefaultValidation = () => __awaiter(this, void 0, void 0, function* () {
            const fields = yield this.fieldsService.getFields();
            return Object.keys(fields).reduce((result, key) => {
                const { customValidator } = fields[key];
                return Object.assign(Object.assign({}, result), { [key]: typeof customValidator === 'function'
                        ? this.customValidator.bind(this, customValidator, fields[key])
                        : this.validator.bind(this, fields[key]) });
            }, {});
        });
        this.stringRequiredValidator = (val) => (val === null || val === void 0 ? void 0 : val.length) > 0;
        this.radioRequiredValidator = (val) => (val === null || val === void 0 ? void 0 : val.length) > 0;
        this.rangeValidator = ({ val, max, min, name }) => {
            const { translate } = this.translationService;
            if (max && isAfter(new Date(val), max)) {
                return {
                    error: true,
                    message: translate(`${name}MaxDateErrorMessage`, translate('maxDateErrorMessage', undefined, translate(name))),
                };
            }
            if (min && isBefore(new Date(val), min)) {
                return {
                    error: true,
                    message: translate(`${name}MinDateErrorMessage`, translate('minDateErrorMessage', undefined, translate(name))),
                };
            }
            return {
                error: false,
                message: null,
            };
        };
        this.checkboxRequiredValidator = (val, requiredOptions) => {
            if (!(requiredOptions === null || requiredOptions === void 0 ? void 0 : requiredOptions.length)) {
                return (val === null || val === void 0 ? void 0 : val.length) > 0;
            }
            return requiredOptions === null || requiredOptions === void 0 ? void 0 : requiredOptions.every((required) => val === null || val === void 0 ? void 0 : val.includes(required));
        };
        this.createValidation = (fieldsSetup) => __awaiter(this, void 0, void 0, function* () {
            if (!(fieldsSetup === null || fieldsSetup === void 0 ? void 0 : fieldsSetup.length)) {
                return;
            }
            yield Promise.all(fieldsSetup === null || fieldsSetup === void 0 ? void 0 : fieldsSetup.map((value) => __awaiter(this, void 0, void 0, function* () {
                if (value) {
                    const { name: key } = value;
                    const { customValidator } = value, rest = __rest(value, ["customValidator"]);
                    this.fieldsService.setFieldValidation(key, rest);
                    const fields = yield this.fieldsService.getFields();
                    if (typeof customValidator === 'function') {
                        this.defaultValidators[key] = customValidator.bind(fields[key]);
                    }
                    else {
                        this.defaultValidators[key].bind(fields[key]);
                    }
                }
                return true;
            })));
        });
        this.setup();
    }
}

class AuthService {
    constructor({ userAuthService, ldsService, ecommerceService }, config) {
        this.signUp = (params) => __awaiter(this, void 0, void 0, function* () {
            const { email, password } = params, attributes = __rest(params, ["email", "password"]);
            const validation = yield this.validate(Object.assign(Object.assign({}, attributes), { email: email, password: password }));
            if (!validation.valid) {
                this.loggerService.error(validation);
                return {
                    success: false,
                    message: this.translationService.translate('validationError'),
                    lastModified: new Date().toISOString(),
                };
            }
            const ldsFields = Array.isArray(attributes.legals)
                ? yield this.ldsService.createLdsFields(attributes.legals)
                : [];
            const clearedAttr = this.cleanAttributes(attributes, true, [
                'confirmPassword',
                'legals',
            ]);
            const formattedAttr = this.fieldsService.createFormattedAddressAttributes(clearedAttr);
            const result = yield this.userAuthService.signUp({
                email: email,
                password: password,
                attributes: Object.assign(Object.assign({}, formattedAttr), { lds: ldsFields }),
            });
            window.localStorage.setItem(Events.onConfirmSignUp, 'false');
            return this.formatServiceResult(result);
        });
        this.signIn = (_a) => __awaiter(this, void 0, void 0, function* () {
            var { email } = _a, params = __rest(_a, ["email"]);
            let storeResult;
            if (this.ecommerceService && this.ecommerceService.isMultipassEnabled()) {
                storeResult = yield this.ecommerceService.generateMultipassLink(email);
                if (isErrorResult(storeResult)) {
                    const translatedMessage = storeResult.code
                        ? this.translate(`${storeResult.code}`) + storeResult.message
                        : this.translate('defaultErrorMessage');
                    return Object.assign(Object.assign({}, storeResult), { message: translatedMessage });
                }
            }
            const result = yield this.userAuthService.signIn(Object.assign(Object.assign({}, params), { email }));
            if (!result.success) {
                return this.formatServiceResult(result);
            }
            if (this.ecommerceService && storeResult && storeResult.url) {
                this.ecommerceService.signIn(storeResult.url);
            }
            return result;
        });
        this.federatedSignIn = (params) => __awaiter(this, void 0, void 0, function* () {
            const socialLds = yield this.ldsService.getSocialLds();
            return this.userAuthService.federatedSignIn(Object.assign(Object.assign({}, params), { userAttributes: { lds: socialLds } }));
        });
        this.dispatchEventIfLegalsUpdated = () => __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const userAttributes = yield this.userAuthService.getUserAttributes();
            if (!isErrorResult(userAttributes)) {
                yield this.ldsService.dispatchEventIfLegalsUpdated((_c = (_b = userAttributes.attributes) === null || _b === void 0 ? void 0 : _b.lds) !== null && _c !== void 0 ? _c : [], this.isExternalProviderUser());
            }
        });
        this.getAcceptedLegals = () => __awaiter(this, void 0, void 0, function* () {
            const userAttributes = yield this.userAuthService.getUserAttributes();
            if (!userAttributes.success || !userAttributes.attributes) {
                return {};
            }
            return this.ldsService.getAcceptedLegals(userAttributes.attributes);
        });
        this.translate = (key, fallback, ...args) => this.translationService.translate(key, fallback, ...args);
        this.signOut = () => this.userAuthService.signOut();
        this.getAvailableSocialSignIn = () => this.userAuthService.getAvailableSocialSignIn();
        this.getCurrentUser = () => this.userAuthService.getCurrentUser();
        this.deleteCurrentUser = (params) => __awaiter(this, void 0, void 0, function* () {
            const reauthenticationResult = yield this.userAuthService.reauthenticateCurrentUser(params);
            if (reauthenticationResult.success && reauthenticationResult.user) {
                const deleteResult = yield this.userAuthService.deleteUser(reauthenticationResult.user);
                if (deleteResult.success) {
                    return deleteResult;
                }
                return this.formatServiceResult(deleteResult);
            }
            return this.formatServiceResult(reauthenticationResult);
        });
        this.getRememberMeConfig = () => this.userAuthService.getRememberMeConfig();
        this.confirmSignUp = (params) => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.userAuthService.confirmSignUp(params);
            const errorResult = isErrorResult(result);
            const allowForAnotherResend = errorResult &&
                isNonBlank(result.message) &&
                [
                    AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY.EXPIRED_OOB_CODE,
                    AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY.INVALID_OOB_CODE,
                ].includes(result.message);
            if (!errorResult) {
                window.localStorage.setItem(Events.onConfirmSignUp, 'true');
            }
            return this.formatServiceResult(Object.assign(Object.assign({}, result), { allowForAnotherResend }));
        });
        this.verifyCodeForEmailChange = (params) => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.userAuthService.verifyCodeForEmailChange(params);
            return this.formatServiceResult(result);
        });
        this.validate = (params, isEdit = false) => this.validationService.validate(params, isEdit);
        this.getSignUpFields = () => this.fieldsService.getSignUpFields();
        this.getSignInFields = () => this.fieldsService.getSignInFields();
        this.getProfileFields = () => __awaiter(this, void 0, void 0, function* () {
            var _d, _e;
            const [profileFields, userAttributesResult] = yield Promise.all([
                this.fieldsService.getProfileFields(),
                this.userAuthService.getUserAttributes(),
            ]);
            if (!userAttributesResult.success) {
                return this.fieldsService.groupByCategory(profileFields);
            }
            const additionalDeliveryAddresses = this.fieldsService.fillAdditionalDeliveryAddressesFields(profileFields, (_d = userAttributesResult.attributes) === null || _d === void 0 ? void 0 : _d.deliveryAddresses);
            const currentUser = this.getCurrentUser();
            const filledProfileFields = this.fieldsService.fillFieldsWithUserData({
                profileFields,
                userFields: Object.assign(Object.assign({}, userAttributesResult.attributes), { email: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) || '' }),
            });
            const filledLegalsField = this.fieldsService.fillLegalsField(((_e = userAttributesResult.attributes) === null || _e === void 0 ? void 0 : _e.lds) || [], profileFields.legals);
            return Object.assign(Object.assign({}, this.fieldsService.groupByCategory(Object.assign(Object.assign({}, filledProfileFields), filledLegalsField))), (additionalDeliveryAddresses && {
                [FieldCategory.AdditionalDeliveryAddresses]: additionalDeliveryAddresses,
            }));
        });
        this.changePassword = (params) => __awaiter(this, void 0, void 0, function* () {
            const user = this.getCurrentUser();
            if (user && this.isPasswordProviderUser()) {
                const { password, currentPassword } = params;
                if (password === currentPassword) {
                    return {
                        success: false,
                        message: this.translationService.translate('editPasswordEqualErrorMessage'),
                    };
                }
                const result = yield this.userAuthService.changePassword({
                    user,
                    password: password,
                    currentPassword: currentPassword,
                });
                if (isErrorResult(result)) {
                    return this.formatServiceResult(result);
                }
                return result;
            }
            return {
                success: false,
                message: this.translationService.translate('canNotChangePasswordOfExternalProviderError'),
            };
        });
        this.updateUserLegals = ({ legals }, shouldUpdateMatching) => __awaiter(this, void 0, void 0, function* () {
            var _f, _g, _h;
            if (!Array.isArray(legals)) {
                return {
                    success: false,
                    message: this.translationService.translate('validationError'),
                };
            }
            const lds = yield this.ldsService.createLdsFields(legals);
            if (shouldUpdateMatching) {
                const getUserAttributesResult = yield this.userAuthService.getUserAttributes();
                if (isErrorResult(getUserAttributesResult)) {
                    return this.formatServiceResult(getUserAttributesResult);
                }
                const acceptedLds = (_h = (_g = (_f = getUserAttributesResult.attributes) === null || _f === void 0 ? void 0 : _f.lds) === null || _g === void 0 ? void 0 : _g.filter((legal) => !legals.includes(legal.businessId))) !== null && _h !== void 0 ? _h : [];
                lds.push(...acceptedLds);
            }
            const setUserAttributesResult = yield this.userAuthService.setUserAttributes({
                lds,
                lastModified: new Date().toISOString(),
            });
            return this.formatServiceResult(setUserAttributesResult);
        });
        this.setUserAttributes = (params) => __awaiter(this, void 0, void 0, function* () {
            var _j;
            const profileEditRightsResult = yield this.getUserProfileEditRights();
            if (!profileEditRightsResult.success) {
                return profileEditRightsResult;
            }
            if (profileEditRightsResult.success &&
                !profileEditRightsResult.canEditProfile) {
                return {
                    success: false,
                    message: this.translationService.translate('missingLdsError'),
                };
            }
            const validation = yield this.validationService.validate(params, true);
            if (!validation.valid) {
                this.loggerService.error(validation);
                return {
                    success: false,
                    message: this.translationService.translate('validationError'),
                };
            }
            const attributes = this.cleanAttributes(params, false, [
                'confirmPassword',
                'password',
                'currentPassword',
                'email',
                'legals',
            ]);
            const formattedAttr = this.fieldsService.createFormattedAddressAttributes(attributes);
            const userFields = yield this.userAuthService.getUserAttributes();
            const changedFields = this.fieldsService.filterChangedAttributes(formattedAttr, userFields.attributes);
            if (isEmptyObject(changedFields)) {
                return { success: true };
            }
            const result = yield this.userAuthService.setUserAttributes(Object.assign(Object.assign({}, changedFields), { deliveryAddresses: (_j = changedFields === null || changedFields === void 0 ? void 0 : changedFields.deliveryAddresses) === null || _j === void 0 ? void 0 : _j.filter((address) => [...(address.address ? Object.values(address.address) : [])].some((value) => !isEmpty_1(value))), lastModified: new Date().toISOString() }));
            if (result.success) {
                if (this.shouldUpdateUserDisplayName(changedFields)) {
                    return this.updateUserDisplayName({
                        preferredUsername: formattedAttr.preferred_username,
                        nickname: formattedAttr.nickname,
                        givenName: formattedAttr.given_name,
                    });
                }
                return { success: true };
            }
            return this.formatServiceResult(result);
        });
        this.getUserProfileEditRights = () => __awaiter(this, void 0, void 0, function* () {
            const getUserAttributesResult = yield this.userAuthService.getUserAttributes();
            if (getUserAttributesResult.success) {
                const missingLegals = yield this.ldsService.getMissingLegalsForProfileEdit(getUserAttributesResult.attributes);
                if (missingLegals === null || missingLegals === void 0 ? void 0 : missingLegals.length) {
                    return {
                        success: true,
                        canEditProfile: false,
                    };
                }
                return {
                    success: true,
                    canEditProfile: true,
                };
            }
            return this.formatServiceResult(getUserAttributesResult);
        });
        this.getLegalsFields = (translationPostfix, onlyRequired) => __awaiter(this, void 0, void 0, function* () {
            return this.fieldsService.getLegalsFields(this.isExternalProviderUser(), translationPostfix, onlyRequired);
        });
        this.resendSignUp = () => this.userAuthService.resendSignUp();
        this.forgotPassword = (params) => __awaiter(this, void 0, void 0, function* () {
            const forgotPasswordResult = yield this.userAuthService.forgotPassword(params);
            return this.formatServiceResult(forgotPasswordResult);
        });
        this.resetPassword = (params) => __awaiter(this, void 0, void 0, function* () {
            const serviceResult = yield this.userAuthService.resetPassword(params);
            return this.formatServiceResult(serviceResult);
        });
        this.getLds = () => this.ldsService.getLds();
        this.getUserName = () => {
            const user = this.userAuthService.getCurrentUser();
            const userName = user ? (user === null || user === void 0 ? void 0 : user.displayName) || '' : undefined;
            return { success: Boolean(user), userName };
        };
        this.isPasswordProviderUser = () => {
            try {
                return this.isPasswordProviderLoggedUser();
            }
            catch (_a) {
                return false;
            }
        };
        this.isExternalProviderUser = () => {
            try {
                return !this.isPasswordProviderLoggedUser();
            }
            catch (_a) {
                return false;
            }
        };
        this.getUserOrders = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ecommerceService)
                return undefined;
            const fields = yield this.getProfileFields();
            const clientIdResponse = yield this.ecommerceService.getUserIdByEmail({
                clientEmail: fields.security.email.defaultValue,
            });
            if (!clientIdResponse.success || !clientIdResponse.id)
                return clientIdResponse;
            return this.ecommerceService.getUserData({
                clientId: clientIdResponse.id,
                scope: 'orders',
            });
        });
        this.setRememberMe = (rememberMe) => __awaiter(this, void 0, void 0, function* () { return this.userAuthService.setAuthStatePersistence(rememberMe); });
        this.createFormattedAddressAttributes = (fields) => this.fieldsService.createFormattedAddressAttributes(fields);
        this.changeEmail = (_k) => __awaiter(this, void 0, void 0, function* () {
            var { newEmail } = _k, params = __rest(_k, ["newEmail"]);
            const { email } = this.getCurrentUser() || {};
            if (isBlank(email) || newEmail === email) {
                return {
                    success: false,
                    message: this.translationService.translate(isBlank(email)
                        ? 'changeEmailMissingErrorMessage'
                        : 'changeEmailEqualErrorMessage'),
                };
            }
            const reauthenticationResult = yield this.userAuthService.reauthenticateCurrentUser(params);
            if (reauthenticationResult.success && reauthenticationResult.user) {
                const result = yield this.userAuthService.changeEmail(reauthenticationResult.user, newEmail);
                if (result.success) {
                    return result;
                }
                return this.formatServiceResult(result);
            }
            return this.formatServiceResult(reauthenticationResult);
        });
        this.customSignInEvent = () => __awaiter(this, void 0, void 0, function* () {
            this.checkUserStatus();
            this.dispatchEventIfLegalsUpdated();
        });
        this.checkUserStatus = () => {
            this.fieldsService.resetupLegalFields(this.isExternalProviderUser());
            this.validationService.resetupValidation();
        };
        this.cleanAttributes = (atttributes, removeEmpty, toRemoveKeys) => Object.entries(atttributes).reduce((obj, [key, value]) => {
            const keepKey = value !== null &&
                value !== undefined &&
                (removeEmpty ? value === null || value === void 0 ? void 0 : value.length : true) &&
                !(toRemoveKeys === null || toRemoveKeys === void 0 ? void 0 : toRemoveKeys.includes(key));
            return Object.assign(Object.assign({}, obj), (keepKey ? { [key]: value } : {}));
        }, {});
        this.shouldUpdateUserDisplayName = (changedFields) => {
            const userDisplayNameFields = [
                'preferred_username',
                'nickname',
                'given_name',
            ];
            return Object.keys(changedFields).some((key) => userDisplayNameFields.includes(key));
        };
        this.updateUserDisplayName = (params) => __awaiter(this, void 0, void 0, function* () {
            let result;
            const user = this.getCurrentUser();
            if (user) {
                const { preferredUsername, nickname, givenName } = params;
                const userDisplayName = preferredUsername || nickname || givenName || '';
                result = yield this.userAuthService.updateUserDisplayName(user, userDisplayName);
                if (result.success) {
                    return result;
                }
            }
            return {
                success: false,
                message: this.getErrorMessage(result),
            };
        });
        this.isPasswordProviderLoggedUser = () => {
            const currentUser = this.userAuthService.getCurrentUser();
            if (currentUser) {
                const providersId = this.userAuthService.getUserProvidersId(currentUser);
                return providersId.includes(ProviderId.PASSWORD);
            }
            throw new Error('not logged');
        };
        this.getErrorMessage = (error) => {
            const { code, message } = error;
            return code ? this.translationService.translate(code, message) : message;
        };
        const { translations, fieldsSetup } = config || {};
        this.loggerService = new Logger();
        this.translationService = new Translation(this.loggerService, translations);
        this.ldsService = new ldsService.Class(ldsService.params);
        if (ecommerceService)
            this.ecommerceService = new ecommerceService.Class(ecommerceService.params);
        this.fieldsService = new Fields(this.translationService, this.ldsService, fieldsSetup);
        this.userAuthService = new userAuthService.Class(userAuthService.params);
        this.validationService = new Validation(this.translationService, this.fieldsService, this.loggerService, fieldsSetup);
        this.checkUserStatus();
        this.userAuthService.authStateChangedObserver({
            customSignInEvent: this.customSignInEvent,
        });
    }
    formatServiceResult(result) {
        return Object.assign(Object.assign({}, result), { message: this.getErrorMessage(result) });
    }
}
AuthService.getInstance = (services, config) => {
    if (!AuthService.instance) {
        AuthService.instance = new AuthService(services, config);
    }
    return AuthService.instance;
};

export { DefaultLdsService, Events, FieldCategory, FirebaseUserAuthService, InputType, LdsSystem, OobMode, ShopifyService, ThirdPartyProvider, UserIdentifierType, AuthService as default, isErrorResult };
